import { emptySplitApi as api } from './emptyApi';
export const addTagTypes = [
  'attendants',
  'billing',
  'Authentication',
  'brokers',
  'trips',
  'credentials',
  'daily-digest',
  'die',
  'dispatch',
  'tags',
  'drivers',
  'filters',
  'flags',
  'invoices',
  'locations',
  'members',
  'messages',
  'user',
  'organization-billing-status',
  'organizations',
  'Organizations',
  'Payers',
  'Trips',
  'passengers',
  'payers',
  'pricing',
  'reports',
  'run-bambi-run',
  'signatures',
  'tilled',
  'trip-import',
  'trip-request-embed',
  'vehicles',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      attendantsList: build.query<
        AttendantsListApiResponse,
        AttendantsListApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            can_be_scheduled: queryArg.canBeScheduled,
            id: queryArg.id,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['attendants'],
      }),
      attendantsCreate: build.mutation<
        AttendantsCreateApiResponse,
        AttendantsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/`,
          method: 'POST',
          body: queryArg.attendant,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsRetrieve: build.query<
        AttendantsRetrieveApiResponse,
        AttendantsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['attendants'],
      }),
      attendantsPartialUpdate: build.mutation<
        AttendantsPartialUpdateApiResponse,
        AttendantsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedAttendant,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsDestroy: build.mutation<
        AttendantsDestroyApiResponse,
        AttendantsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsSkillsCreate: build.mutation<
        AttendantsSkillsCreateApiResponse,
        AttendantsSkillsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/skills/`,
          method: 'POST',
          body: queryArg.attendantSkills,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsSkillsRetrieve: build.query<
        AttendantsSkillsRetrieveApiResponse,
        AttendantsSkillsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/skills/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['attendants'],
      }),
      attendantsSkillsUpdate: build.mutation<
        AttendantsSkillsUpdateApiResponse,
        AttendantsSkillsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/skills/${queryArg.id}/`,
          method: 'PUT',
          body: queryArg.attendantSkills,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsSkillsPartialUpdate: build.mutation<
        AttendantsSkillsPartialUpdateApiResponse,
        AttendantsSkillsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/skills/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedAttendantSkills,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsSkillsDestroy: build.mutation<
        AttendantsSkillsDestroyApiResponse,
        AttendantsSkillsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/skills/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['attendants'],
      }),
      billingBillingSettingsRetrieve: build.query<
        BillingBillingSettingsRetrieveApiResponse,
        BillingBillingSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/billing/billing-settings/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['billing'],
      }),
      billingBillingSettingsPartialUpdate: build.mutation<
        BillingBillingSettingsPartialUpdateApiResponse,
        BillingBillingSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/billing/billing-settings/`,
          method: 'PATCH',
          body: queryArg.patchedBillingSettings,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['billing'],
      }),
      billingBillingSettingsNextInvoiceNumberRetrieve: build.query<
        BillingBillingSettingsNextInvoiceNumberRetrieveApiResponse,
        BillingBillingSettingsNextInvoiceNumberRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/billing/billing-settings/next-invoice-number/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['billing'],
      }),
      billingTripsBillingList: build.query<
        BillingTripsBillingListApiResponse,
        BillingTripsBillingListApiArg
      >({
        query: (queryArg) => ({
          url: `/billing/trips-billing/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['billing'],
      }),
      brokersAliviOauth2TokenCreate: build.mutation<
        BrokersAliviOauth2TokenCreateApiResponse,
        BrokersAliviOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/oauth2/token/`,
          method: 'POST',
          body: queryArg.aliviOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersAliviRideActivateWillcallCreate: build.mutation<
        BrokersAliviRideActivateWillcallCreateApiResponse,
        BrokersAliviRideActivateWillcallCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/activateWillcall/`,
          method: 'POST',
          body: queryArg.aliviRideActivateWillCall,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviRideCancelCreate: build.mutation<
        BrokersAliviRideCancelCreateApiResponse,
        BrokersAliviRideCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/cancel/`,
          method: 'POST',
          body: queryArg.aliviRideCancel,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviRideCancelWillcallActivationCreate: build.mutation<
        BrokersAliviRideCancelWillcallActivationCreateApiResponse,
        BrokersAliviRideCancelWillcallActivationCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/cancelWillcallActivation/`,
          method: 'POST',
          body: queryArg.aliviRideCancelWillCallActivation,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviRideGetStatusCreate: build.mutation<
        BrokersAliviRideGetStatusCreateApiResponse,
        BrokersAliviRideGetStatusCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/getStatus/`,
          method: 'POST',
          body: queryArg.aliviRideStatus,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviRideOfferCreate: build.mutation<
        BrokersAliviRideOfferCreateApiResponse,
        BrokersAliviRideOfferCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/offer/`,
          method: 'POST',
          body: queryArg.aliviRideOffer,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviRideUpdateCreate: build.mutation<
        BrokersAliviRideUpdateCreateApiResponse,
        BrokersAliviRideUpdateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/update/`,
          method: 'POST',
          body: queryArg.aliviRideUpdate,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersClearviewOauth2TokenCreate: build.mutation<
        BrokersClearviewOauth2TokenCreateApiResponse,
        BrokersClearviewOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/oauth2/token/`,
          method: 'POST',
          body: queryArg.clearviewOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersClearviewTripsList: build.query<
        BrokersClearviewTripsListApiResponse,
        BrokersClearviewTripsListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/trips/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      brokersClearviewTripsCreate: build.mutation<
        BrokersClearviewTripsCreateApiResponse,
        BrokersClearviewTripsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/trips/`,
          method: 'POST',
          body: queryArg.clearviewTrip,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      brokersClearviewTripsRetrieve: build.query<
        BrokersClearviewTripsRetrieveApiResponse,
        BrokersClearviewTripsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/trips/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['trips'],
      }),
      brokersClearviewTripsPartialUpdate: build.mutation<
        BrokersClearviewTripsPartialUpdateApiResponse,
        BrokersClearviewTripsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/trips/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedClearviewTrip,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      brokersClearviewTripsCancelCreate: build.mutation<
        BrokersClearviewTripsCancelCreateApiResponse,
        BrokersClearviewTripsCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/trips/${queryArg.id}/cancel/`,
          method: 'POST',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      brokersCtcOauth2TokenCreate: build.mutation<
        BrokersCtcOauth2TokenCreateApiResponse,
        BrokersCtcOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/ctc/oauth2/token/`,
          method: 'POST',
          body: queryArg.ctcoAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersCtcTripCreate: build.mutation<
        BrokersCtcTripCreateApiResponse,
        BrokersCtcTripCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/ctc/trip/`,
          method: 'POST',
          body: queryArg.ctcTrip,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersCtcTripActivationCreate: build.mutation<
        BrokersCtcTripActivationCreateApiResponse,
        BrokersCtcTripActivationCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/ctc/trip/activation/`,
          method: 'POST',
          body: queryArg.ctcTripActivateWillCall,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersCtcTripCancelCreate: build.mutation<
        BrokersCtcTripCancelCreateApiResponse,
        BrokersCtcTripCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/ctc/trip/cancel/`,
          method: 'POST',
          body: queryArg.ctcTripCancel,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersExampleHelloWorldRetrieve: build.query<
        BrokersExampleHelloWorldRetrieveApiResponse,
        BrokersExampleHelloWorldRetrieveApiArg
      >({
        query: () => ({ url: `/brokers/example/hello_world/` }),
        providesTags: ['brokers'],
      }),
      brokersKinetikOauth2TokenCreate: build.mutation<
        BrokersKinetikOauth2TokenCreateApiResponse,
        BrokersKinetikOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/oauth2/token/`,
          method: 'POST',
          body: queryArg.kinetikOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersKinetikV1CancelRideCreate: build.mutation<
        BrokersKinetikV1CancelRideCreateApiResponse,
        BrokersKinetikV1CancelRideCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/cancelRide`,
          method: 'POST',
          body: queryArg.kinetikRideReadOnly,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikV1CreateRidesCreate: build.mutation<
        BrokersKinetikV1CreateRidesCreateApiResponse,
        BrokersKinetikV1CreateRidesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/createRides`,
          method: 'POST',
          body: queryArg.kinetikRide,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikV1GetDriverCreate: build.mutation<
        BrokersKinetikV1GetDriverCreateApiResponse,
        BrokersKinetikV1GetDriverCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/getDriver`,
          method: 'POST',
          body: queryArg.kinetikDriver,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikV1GetRideCreate: build.mutation<
        BrokersKinetikV1GetRideCreateApiResponse,
        BrokersKinetikV1GetRideCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/getRide`,
          method: 'POST',
          body: queryArg.kinetikRideReadOnly,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikV1GetVehicleCreate: build.mutation<
        BrokersKinetikV1GetVehicleCreateApiResponse,
        BrokersKinetikV1GetVehicleCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/getVehicle/`,
          method: 'POST',
          body: queryArg.kinetikVehicle,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikV1UpdateRidesUpdate: build.mutation<
        BrokersKinetikV1UpdateRidesUpdateApiResponse,
        BrokersKinetikV1UpdateRidesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/updateRides`,
          method: 'PUT',
          body: queryArg.kinetikRide,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMedidriveOauth2TokenCreate: build.mutation<
        BrokersMedidriveOauth2TokenCreateApiResponse,
        BrokersMedidriveOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/medidrive/oauth2/token/`,
          method: 'POST',
          body: queryArg.mediDriveOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersMomentmBrokerAuthList: build.query<
        BrokersMomentmBrokerAuthListApiResponse,
        BrokersMomentmBrokerAuthListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthCreate: build.mutation<
        BrokersMomentmBrokerAuthCreateApiResponse,
        BrokersMomentmBrokerAuthCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/`,
          method: 'POST',
          body: queryArg.momentmBrokerAuth,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthRetrieve: build.query<
        BrokersMomentmBrokerAuthRetrieveApiResponse,
        BrokersMomentmBrokerAuthRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/${queryArg.id}/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthUpdate: build.mutation<
        BrokersMomentmBrokerAuthUpdateApiResponse,
        BrokersMomentmBrokerAuthUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/${queryArg.id}/`,
          method: 'PUT',
          body: queryArg.momentmBrokerAuth,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthPartialUpdate: build.mutation<
        BrokersMomentmBrokerAuthPartialUpdateApiResponse,
        BrokersMomentmBrokerAuthPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedMomentmBrokerAuth,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthDestroy: build.mutation<
        BrokersMomentmBrokerAuthDestroyApiResponse,
        BrokersMomentmBrokerAuthDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/${queryArg.id}/`,
          method: 'DELETE',
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthSetSecretCreate: build.mutation<
        BrokersMomentmBrokerAuthSetSecretCreateApiResponse,
        BrokersMomentmBrokerAuthSetSecretCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/set_secret/`,
          method: 'POST',
          body: queryArg.momentmBrokerAuth,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMomentmSetSecretCreate: build.mutation<
        BrokersMomentmSetSecretCreateApiResponse,
        BrokersMomentmSetSecretCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/set-secret/`,
          method: 'POST',
          body: queryArg.momentmBrokerAuth,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmInitCreate: build.mutation<
        BrokersMtmInitCreateApiResponse,
        BrokersMtmInitCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/init/`,
          method: 'POST',
          body: queryArg.mtmTransportationProvider,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmOauth2TokenCreate: build.mutation<
        BrokersMtmOauth2TokenCreateApiResponse,
        BrokersMtmOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/oauth2/token/`,
          method: 'POST',
          body: queryArg.mtmoAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersMtmSetSecretCreate: build.mutation<
        BrokersMtmSetSecretCreateApiResponse,
        BrokersMtmSetSecretCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/set-secret/`,
          method: 'POST',
          body: queryArg.mtmSecret,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersList: build.query<
        BrokersMtmTransportationProvidersListApiResponse,
        BrokersMtmTransportationProvidersListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersCreate: build.mutation<
        BrokersMtmTransportationProvidersCreateApiResponse,
        BrokersMtmTransportationProvidersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/`,
          method: 'POST',
          body: queryArg.mtmTransportationProvider,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersRetrieve: build.query<
        BrokersMtmTransportationProvidersRetrieveApiResponse,
        BrokersMtmTransportationProvidersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersUpdate: build.mutation<
        BrokersMtmTransportationProvidersUpdateApiResponse,
        BrokersMtmTransportationProvidersUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/`,
          method: 'PUT',
          body: queryArg.mtmTransportationProvider,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersPartialUpdate: build.mutation<
        BrokersMtmTransportationProvidersPartialUpdateApiResponse,
        BrokersMtmTransportationProvidersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedMtmTransportationProvider,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersDestroy: build.mutation<
        BrokersMtmTransportationProvidersDestroyApiResponse,
        BrokersMtmTransportationProvidersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/`,
          method: 'DELETE',
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersBackfillTripsCreate: build.mutation<
        BrokersMtmTransportationProvidersBackfillTripsCreateApiResponse,
        BrokersMtmTransportationProvidersBackfillTripsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/backfill-trips/`,
          method: 'POST',
          body: queryArg.mtmBackfillTripsRequest,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersGetEmailRetrieve: build.query<
        BrokersMtmTransportationProvidersGetEmailRetrieveApiResponse,
        BrokersMtmTransportationProvidersGetEmailRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/get-email/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersTurnbackReasonsRetrieve: build.query<
        BrokersMtmTransportationProvidersTurnbackReasonsRetrieveApiResponse,
        BrokersMtmTransportationProvidersTurnbackReasonsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/turnback-reasons/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersGetEmailTextRetrieve: build.query<
        BrokersMtmTransportationProvidersGetEmailTextRetrieveApiResponse,
        BrokersMtmTransportationProvidersGetEmailTextRetrieveApiArg
      >({
        query: () => ({
          url: `/brokers/mtm/transportation-providers/get_email_text/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersInitCreate: build.mutation<
        BrokersMtmTransportationProvidersInitCreateApiResponse,
        BrokersMtmTransportationProvidersInitCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/init/`,
          method: 'POST',
          body: queryArg.mtmTransportationProvider,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersSetSecretCreate: build.mutation<
        BrokersMtmTransportationProvidersSetSecretCreateApiResponse,
        BrokersMtmTransportationProvidersSetSecretCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/set_secret/`,
          method: 'POST',
          body: queryArg.mtmSecret,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmWebhookCreate: build.mutation<
        BrokersMtmWebhookCreateApiResponse,
        BrokersMtmWebhookCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/webhook/${queryArg.webhookId}/`,
          method: 'POST',
          body: queryArg.mtmWebhook,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersProvideARideOauth2TokenCreate: build.mutation<
        BrokersProvideARideOauth2TokenCreateApiResponse,
        BrokersProvideARideOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/provide-a-ride/oauth2/token/`,
          method: 'POST',
          body: queryArg.provideARideOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersProvideARideTripsCreate: build.mutation<
        BrokersProvideARideTripsCreateApiResponse,
        BrokersProvideARideTripsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/provide-a-ride/trips/`,
          method: 'POST',
          body: queryArg.provideARideTripCreate,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersProvideARideTripsRetrieve: build.query<
        BrokersProvideARideTripsRetrieveApiResponse,
        BrokersProvideARideTripsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/provide-a-ride/trips/${queryArg.id}/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersProvideARideTripsCancelCreate: build.mutation<
        BrokersProvideARideTripsCancelCreateApiResponse,
        BrokersProvideARideTripsCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/provide-a-ride/trips/${queryArg.id}/cancel/`,
          method: 'POST',
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersVectorcareWebhookCreate: build.mutation<
        BrokersVectorcareWebhookCreateApiResponse,
        BrokersVectorcareWebhookCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/vectorcare/webhook/${queryArg.vectorcareOrganizationId}/`,
          method: 'POST',
          body: queryArg.vectorCareTrip,
        }),
        invalidatesTags: ['brokers'],
      }),
      credentialsList: build.query<
        CredentialsListApiResponse,
        CredentialsListApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/`,
          params: {
            credential_type_category: queryArg.credentialTypeCategory,
            credential_types: queryArg.credentialTypes,
            members: queryArg.members,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['credentials'],
      }),
      credentialsCreate: build.mutation<
        CredentialsCreateApiResponse,
        CredentialsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/`,
          method: 'POST',
          body: queryArg.credential,
        }),
        invalidatesTags: ['credentials'],
      }),
      credentialsRetrieve: build.query<
        CredentialsRetrieveApiResponse,
        CredentialsRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/credentials/${queryArg.id}/` }),
        providesTags: ['credentials'],
      }),
      credentialsPartialUpdate: build.mutation<
        CredentialsPartialUpdateApiResponse,
        CredentialsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedCredential,
        }),
        invalidatesTags: ['credentials'],
      }),
      credentialsDestroy: build.mutation<
        CredentialsDestroyApiResponse,
        CredentialsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/${queryArg.id}/`,
          method: 'DELETE',
        }),
        invalidatesTags: ['credentials'],
      }),
      credentialsExpiringSoonCountRetrieve: build.query<
        CredentialsExpiringSoonCountRetrieveApiResponse,
        CredentialsExpiringSoonCountRetrieveApiArg
      >({
        query: () => ({ url: `/credentials/expiring-soon-count/` }),
        providesTags: ['credentials'],
      }),
      credentialsTypesList: build.query<
        CredentialsTypesListApiResponse,
        CredentialsTypesListApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/types/`,
          params: {
            category: queryArg.category,
            description: queryArg.description,
            id: queryArg.id,
            name: queryArg.name,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['credentials'],
      }),
      credentialsTypesCreate: build.mutation<
        CredentialsTypesCreateApiResponse,
        CredentialsTypesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/types/`,
          method: 'POST',
          body: queryArg.credentialType,
        }),
        invalidatesTags: ['credentials'],
      }),
      credentialsTypesRetrieve: build.query<
        CredentialsTypesRetrieveApiResponse,
        CredentialsTypesRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/credentials/types/${queryArg.id}/` }),
        providesTags: ['credentials'],
      }),
      credentialsTypesPartialUpdate: build.mutation<
        CredentialsTypesPartialUpdateApiResponse,
        CredentialsTypesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/types/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedCredentialType,
        }),
        invalidatesTags: ['credentials'],
      }),
      credentialsTypesDestroy: build.mutation<
        CredentialsTypesDestroyApiResponse,
        CredentialsTypesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/types/${queryArg.id}/`,
          method: 'DELETE',
        }),
        invalidatesTags: ['credentials'],
      }),
      dailyDigestCreate: build.mutation<
        DailyDigestCreateApiResponse,
        DailyDigestCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/daily-digest/`,
          method: 'POST',
          body: queryArg.dailyDigest,
        }),
        invalidatesTags: ['daily-digest'],
      }),
      dieCreate: build.mutation<DieCreateApiResponse, DieCreateApiArg>({
        query: (queryArg) => ({
          url: `/die/${queryArg.code}/`,
          method: 'POST',
        }),
        invalidatesTags: ['die'],
      }),
      dispatchRetrieve: build.query<
        DispatchRetrieveApiResponse,
        DispatchRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/dispatch/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            county_search: queryArg.countySearch,
            driver_tag_search: queryArg.driverTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            state_search: queryArg.stateSearch,
            trip_tag_search: queryArg.tripTagSearch,
            unassigned_ordering: queryArg.unassignedOrdering,
            unassigned_payers: queryArg.unassignedPayers,
            unassigned_price_max: queryArg.unassignedPriceMax,
            unassigned_price_min: queryArg.unassignedPriceMin,
            unassigned_range_end: queryArg.unassignedRangeEnd,
            unassigned_range_start: queryArg.unassignedRangeStart,
            unassigned_search: queryArg.unassignedSearch,
            unassigned_service_types: queryArg.unassignedServiceTypes,
            unassigned_space_types: queryArg.unassignedSpaceTypes,
            vehicle_tag_search: queryArg.vehicleTagSearch,
            zipcode_search: queryArg.zipcodeSearch,
          },
        }),
        providesTags: ['dispatch'],
      }),
      dispatchSummaryRetrieve: build.query<
        DispatchSummaryRetrieveApiResponse,
        DispatchSummaryRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/dispatch/summary/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            driver_tag_search: queryArg.driverTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            vehicle_tag_search: queryArg.vehicleTagSearch,
          },
        }),
        providesTags: ['dispatch'],
      }),
      driverTagsList: build.query<
        DriverTagsListApiResponse,
        DriverTagsListApiArg
      >({
        query: (queryArg) => ({
          url: `/driver-tags/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['tags'],
      }),
      driverTagsCreate: build.mutation<
        DriverTagsCreateApiResponse,
        DriverTagsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/driver-tags/`,
          method: 'POST',
          body: queryArg.driverTagBulkCreate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      driverTagsRetrieve: build.query<
        DriverTagsRetrieveApiResponse,
        DriverTagsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/driver-tags/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['tags'],
      }),
      driverTagsDestroy: build.mutation<
        DriverTagsDestroyApiResponse,
        DriverTagsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/driver-tags/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      driversList: build.query<DriversListApiResponse, DriversListApiArg>({
        query: (queryArg) => ({
          url: `/drivers/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            can_be_scheduled: queryArg.canBeScheduled,
            deleted_objects: queryArg.deletedObjects,
            id: queryArg.id,
            id__in: queryArg.idIn,
            membership_id__in: queryArg.membershipIdIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            tags: queryArg.tags,
          },
        }),
        providesTags: ['drivers'],
      }),
      driversCreate: build.mutation<
        DriversCreateApiResponse,
        DriversCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/`,
          method: 'POST',
          body: queryArg.driver,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['drivers'],
      }),
      driversPayersList: build.query<
        DriversPayersListApiResponse,
        DriversPayersListApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.driverId}/payers/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['drivers'],
      }),
      driversPayersCreate: build.mutation<
        DriversPayersCreateApiResponse,
        DriversPayersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.driverId}/payers/`,
          method: 'POST',
          body: queryArg.driverPayerOrganization,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['drivers'],
      }),
      driversRetrieve: build.query<
        DriversRetrieveApiResponse,
        DriversRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['drivers'],
      }),
      driversPartialUpdate: build.mutation<
        DriversPartialUpdateApiResponse,
        DriversPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedDriver,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['drivers'],
      }),
      driversDestroy: build.mutation<
        DriversDestroyApiResponse,
        DriversDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['drivers'],
      }),
      driversUndeleteCreate: build.mutation<
        DriversUndeleteCreateApiResponse,
        DriversUndeleteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.id}/undelete/`,
          method: 'POST',
          body: queryArg.driver,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['drivers'],
      }),
      driversListSelected: build.query<
        DriversListSelectedApiResponse,
        DriversListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/list-selected/`,
          method: 'POST',
          body: queryArg.driverFilters,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            can_be_scheduled: queryArg.canBeScheduled,
            deleted_objects: queryArg.deletedObjects,
            id: queryArg.id,
            id__in: queryArg.idIn,
            membership_id__in: queryArg.membershipIdIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            tags: queryArg.tags,
          },
        }),
        providesTags: ['drivers'],
      }),
      filterGroupsList: build.query<
        FilterGroupsListApiResponse,
        FilterGroupsListApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['filters'],
      }),
      filterGroupsCreate: build.mutation<
        FilterGroupsCreateApiResponse,
        FilterGroupsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/`,
          method: 'POST',
          body: queryArg.filterGroup,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['filters'],
      }),
      filterGroupsRetrieve: build.query<
        FilterGroupsRetrieveApiResponse,
        FilterGroupsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['filters'],
      }),
      filterGroupsPartialUpdate: build.mutation<
        FilterGroupsPartialUpdateApiResponse,
        FilterGroupsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedFilterGroup,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['filters'],
      }),
      filterGroupsDestroy: build.mutation<
        FilterGroupsDestroyApiResponse,
        FilterGroupsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['filters'],
      }),
      filterGroupsCreateExamplesCreate: build.mutation<
        FilterGroupsCreateExamplesCreateApiResponse,
        FilterGroupsCreateExamplesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/create_examples/`,
          method: 'POST',
          body: queryArg.filterGroup,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['filters'],
      }),
      flagsFeatureValuesList: build.query<
        FlagsFeatureValuesListApiResponse,
        FlagsFeatureValuesListApiArg
      >({
        query: (queryArg) => ({
          url: `/flags/feature-values/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['flags'],
      }),
      flagsFeatureValuesMobileList: build.query<
        FlagsFeatureValuesMobileListApiResponse,
        FlagsFeatureValuesMobileListApiArg
      >({
        query: (queryArg) => ({
          url: `/flags/feature-values-mobile/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['flags'],
      }),
      flagsFeatureValuesWebList: build.query<
        FlagsFeatureValuesWebListApiResponse,
        FlagsFeatureValuesWebListApiArg
      >({
        query: (queryArg) => ({
          url: `/flags/feature-values-web/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['flags'],
      }),
      flagsFeaturesList: build.query<
        FlagsFeaturesListApiResponse,
        FlagsFeaturesListApiArg
      >({
        query: (queryArg) => ({
          url: `/flags/features/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['flags'],
      }),
      invoicesPayersList: build.query<
        InvoicesPayersListApiResponse,
        InvoicesPayersListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/${queryArg.id}/payers/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoicesTripsList: build.query<
        InvoicesTripsListApiResponse,
        InvoicesTripsListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/${queryArg.id}/trips/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoicesExportRetrieve: build.query<
        InvoicesExportRetrieveApiResponse,
        InvoicesExportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            created_at: queryArg.createdAt,
            invoice: queryArg.invoice,
            invoice__in: queryArg.invoiceIn,
            ordering: queryArg.ordering,
            output_type: queryArg.outputType,
            overall_payment_status__in: queryArg.overallPaymentStatusIn,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            trip__in: queryArg.tripIn,
            trip__payer: queryArg.tripPayer,
            trip__payer__in: queryArg.tripPayerIn,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesExportPaymentsRetrieve: build.query<
        InvoicesExportPaymentsRetrieveApiResponse,
        InvoicesExportPaymentsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export-payments/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoicePaymentsListSelected: build.query<
        InvoicePaymentsListSelectedApiResponse,
        InvoicePaymentsListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export-payments/list-selected/`,
          method: 'POST',
          body: queryArg.invoicePaymentExportFilter,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoicesExportRefundsRetrieve: build.query<
        InvoicesExportRefundsRetrieveApiResponse,
        InvoicesExportRefundsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export-refunds/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoiceRefundsListSelected: build.query<
        InvoiceRefundsListSelectedApiResponse,
        InvoiceRefundsListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export-refunds/list-selected/`,
          method: 'POST',
          body: queryArg.invoicesListFilter,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoiceLineItemsListSelected: build.query<
        InvoiceLineItemsListSelectedApiResponse,
        InvoiceLineItemsListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export/list-selected/`,
          method: 'POST',
          body: queryArg.invoicesListFilter,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            created_at: queryArg.createdAt,
            invoice: queryArg.invoice,
            invoice__in: queryArg.invoiceIn,
            overall_payment_status__in: queryArg.overallPaymentStatusIn,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            trip__in: queryArg.tripIn,
            trip__payer: queryArg.tripPayer,
            trip__payer__in: queryArg.tripPayerIn,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesInvoiceEmailCreate: build.mutation<
        InvoicesInvoiceEmailCreateApiResponse,
        InvoicesInvoiceEmailCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoice-email/`,
          method: 'POST',
          body: queryArg.invoiceEmail,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesInvoicesList: build.query<
        InvoicesInvoicesListApiResponse,
        InvoicesInvoicesListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoices/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            created_at: queryArg.createdAt,
            date_issued: queryArg.dateIssued,
            date_issued_end: queryArg.dateIssuedEnd,
            date_issued_start: queryArg.dateIssuedStart,
            due_max: queryArg.dueMax,
            due_min: queryArg.dueMin,
            has_emailed_payment_link: queryArg.hasEmailedPaymentLink,
            has_payment_link: queryArg.hasPaymentLink,
            min_payments: queryArg.minPayments,
            ordering: queryArg.ordering,
            overall_payment_status__in: queryArg.overallPaymentStatusIn,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            total_amount_max: queryArg.totalAmountMax,
            total_amount_min: queryArg.totalAmountMin,
            trip_payer__in: queryArg.tripPayerIn,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesInvoicesCreate: build.mutation<
        InvoicesInvoicesCreateApiResponse,
        InvoicesInvoicesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoices/`,
          method: 'POST',
          body: queryArg.invoice,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesInvoicesRetrieve: build.query<
        InvoicesInvoicesRetrieveApiResponse,
        InvoicesInvoicesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoices/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoicesInvoicesPartialUpdate: build.mutation<
        InvoicesInvoicesPartialUpdateApiResponse,
        InvoicesInvoicesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoices/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedInvoice,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesInvoicesDestroy: build.mutation<
        InvoicesInvoicesDestroyApiResponse,
        InvoicesInvoicesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoices/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesLineItemsList: build.query<
        InvoicesLineItemsListApiResponse,
        InvoicesLineItemsListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/line-items/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['invoices'],
      }),
      invoicesLineItemsCreate: build.mutation<
        InvoicesLineItemsCreateApiResponse,
        InvoicesLineItemsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/line-items/`,
          method: 'POST',
          body: queryArg.invoiceLineItem,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesLineItemsRetrieve: build.query<
        InvoicesLineItemsRetrieveApiResponse,
        InvoicesLineItemsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/line-items/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoicesLineItemsPartialUpdate: build.mutation<
        InvoicesLineItemsPartialUpdateApiResponse,
        InvoicesLineItemsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/line-items/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedInvoiceLineItem,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesLineItemsDestroy: build.mutation<
        InvoicesLineItemsDestroyApiResponse,
        InvoicesLineItemsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/line-items/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesPaymentLinkList: build.query<
        InvoicesPaymentLinkListApiResponse,
        InvoicesPaymentLinkListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payment-link/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            invoice: queryArg.invoice,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            payment: queryArg.payment,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesPaymentLinkCreate: build.mutation<
        InvoicesPaymentLinkCreateApiResponse,
        InvoicesPaymentLinkCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payment-link/`,
          method: 'POST',
          body: queryArg.invoicePaymentLink,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesPaymentLinkEmailCreate: build.mutation<
        InvoicesPaymentLinkEmailCreateApiResponse,
        InvoicesPaymentLinkEmailCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payment-link-email/`,
          method: 'POST',
          body: queryArg.invoicePaymentLinkEmail,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesPaymentLinkRetrieve: build.query<
        InvoicesPaymentLinkRetrieveApiResponse,
        InvoicesPaymentLinkRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payment-link/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoicesPaymentLinkPartialUpdate: build.mutation<
        InvoicesPaymentLinkPartialUpdateApiResponse,
        InvoicesPaymentLinkPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payment-link/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedInvoicePaymentLink,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesPaymentsList: build.query<
        InvoicesPaymentsListApiResponse,
        InvoicesPaymentsListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payments/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            created_at_after: queryArg.createdAtAfter,
            created_at_before: queryArg.createdAtBefore,
            has_refunds: queryArg.hasRefunds,
            invoice_number: queryArg.invoiceNumber,
            is_manual: queryArg.isManual,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            status: queryArg.status,
            total_amount_cents_max: queryArg.totalAmountCentsMax,
            total_amount_cents_min: queryArg.totalAmountCentsMin,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesPaymentsCreate: build.mutation<
        InvoicesPaymentsCreateApiResponse,
        InvoicesPaymentsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payments/`,
          method: 'POST',
          body: queryArg.invoicePayment,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesPaymentsRetrieve: build.query<
        InvoicesPaymentsRetrieveApiResponse,
        InvoicesPaymentsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payments/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoicesRefundsList: build.query<
        InvoicesRefundsListApiResponse,
        InvoicesRefundsListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/refunds/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['invoices'],
      }),
      invoicesRefundsCreate: build.mutation<
        InvoicesRefundsCreateApiResponse,
        InvoicesRefundsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/refunds/`,
          method: 'POST',
          body: queryArg.invoiceRefund,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesRefundsRetrieve: build.query<
        InvoicesRefundsRetrieveApiResponse,
        InvoicesRefundsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/refunds/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['invoices'],
      }),
      invoicesTripFinderList: build.query<
        InvoicesTripFinderListApiResponse,
        InvoicesTripFinderListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/trip-finder/`,
          params: {
            canceled_reason__in: queryArg.canceledReasonIn,
            created_at_range_end: queryArg.createdAtRangeEnd,
            created_at_range_start: queryArg.createdAtRangeStart,
            driver__in: queryArg.driverIn,
            dropoff_municipality__in: queryArg.dropoffMunicipalityIn,
            external_trip_id__in: queryArg.externalTripIdIn,
            has_driver_entered_notes: queryArg.hasDriverEnteredNotes,
            has_invoice: queryArg.hasInvoice,
            has_paid_invoice: queryArg.hasPaidInvoice,
            id__in: queryArg.idIn,
            intermediary__in: queryArg.intermediaryIn,
            is_from_csv: queryArg.isFromCsv,
            not_tag__in: queryArg.notTagIn,
            one_schema_template_id__in: queryArg.oneSchemaTemplateIdIn,
            one_schema_template_multi_id__in:
              queryArg.oneSchemaTemplateMultiIdIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            passenger__in: queryArg.passengerIn,
            passengers: queryArg.passengers,
            payer__in: queryArg.payerIn,
            payers: queryArg.payers,
            pickup_municipality__in: queryArg.pickupMunicipalityIn,
            price_max: queryArg.priceMax,
            price_min: queryArg.priceMin,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            space_type: queryArg.spaceType,
            space_type__in: queryArg.spaceTypeIn,
            status: queryArg.status,
            status__in: queryArg.statusIn,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
            vehicle_id__in: queryArg.vehicleIdIn,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesTripFinderRetrieve: build.query<
        InvoicesTripFinderRetrieveApiResponse,
        InvoicesTripFinderRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/invoices/trip-finder/${queryArg.id}/` }),
        providesTags: ['invoices'],
      }),
      locationsAddressesList: build.query<
        LocationsAddressesListApiResponse,
        LocationsAddressesListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/addresses/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['locations'],
      }),
      locationsAddressesRetrieve: build.query<
        LocationsAddressesRetrieveApiResponse,
        LocationsAddressesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/addresses/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['locations'],
      }),
      locationsCountiesList: build.query<
        LocationsCountiesListApiResponse,
        LocationsCountiesListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/counties/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            county: queryArg.county,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['locations'],
      }),
      locationsGeolocationsList: build.query<
        LocationsGeolocationsListApiResponse,
        LocationsGeolocationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            deleted_objects: queryArg.deletedObjects,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            source: queryArg.source,
            source__in: queryArg.sourceIn,
          },
        }),
        providesTags: ['locations'],
      }),
      locationsGeolocationsCreate: build.mutation<
        LocationsGeolocationsCreateApiResponse,
        LocationsGeolocationsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/`,
          method: 'POST',
          body: queryArg.geoLocation,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsGeolocationsRetrieve: build.query<
        LocationsGeolocationsRetrieveApiResponse,
        LocationsGeolocationsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['locations'],
      }),
      locationsGeolocationsPartialUpdate: build.mutation<
        LocationsGeolocationsPartialUpdateApiResponse,
        LocationsGeolocationsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedGeoLocation,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsGeolocationsDestroy: build.mutation<
        LocationsGeolocationsDestroyApiResponse,
        LocationsGeolocationsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsGeolocationsUndeleteCreate: build.mutation<
        LocationsGeolocationsUndeleteCreateApiResponse,
        LocationsGeolocationsUndeleteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/${queryArg.id}/undelete/`,
          method: 'POST',
          body: queryArg.geoLocation,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsLocationLogEntryTripsList: build.query<
        LocationsLocationLogEntryTripsListApiResponse,
        LocationsLocationLogEntryTripsListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/location-log-entry-trips/${queryArg.tripId}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['locations'],
      }),
      locationsLogCreate: build.mutation<
        LocationsLogCreateApiResponse,
        LocationsLogCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/log/`,
          method: 'POST',
          body: queryArg.locationLogEntry,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsMunicipalitiesRetrieve: build.query<
        LocationsMunicipalitiesRetrieveApiResponse,
        LocationsMunicipalitiesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/municipalities/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['locations'],
      }),
      locationsPassengerAddressesList: build.query<
        LocationsPassengerAddressesListApiResponse,
        LocationsPassengerAddressesListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['locations'],
      }),
      locationsPassengerAddressesCreate: build.mutation<
        LocationsPassengerAddressesCreateApiResponse,
        LocationsPassengerAddressesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/`,
          method: 'POST',
          body: queryArg.passengerAddress,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsPassengerAddressesRetrieve: build.query<
        LocationsPassengerAddressesRetrieveApiResponse,
        LocationsPassengerAddressesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['locations'],
      }),
      locationsPassengerAddressesUpdate: build.mutation<
        LocationsPassengerAddressesUpdateApiResponse,
        LocationsPassengerAddressesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/${queryArg.id}/`,
          method: 'PUT',
          body: queryArg.passengerAddress,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsPassengerAddressesPartialUpdate: build.mutation<
        LocationsPassengerAddressesPartialUpdateApiResponse,
        LocationsPassengerAddressesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPassengerAddressRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsPassengerAddressesDestroy: build.mutation<
        LocationsPassengerAddressesDestroyApiResponse,
        LocationsPassengerAddressesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsZipcodesList: build.query<
        LocationsZipcodesListApiResponse,
        LocationsZipcodesListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/zipcodes/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            zipcode: queryArg.zipcode,
          },
        }),
        providesTags: ['locations'],
      }),
      membersList: build.query<MembersListApiResponse, MembersListApiArg>({
        query: (queryArg) => ({
          url: `/members/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            deleted_objects: queryArg.deletedObjects,
            is_attendant: queryArg.isAttendant,
            is_bambi_staff: queryArg.isBambiStaff,
            is_driver: queryArg.isDriver,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            role: queryArg.role,
            search: queryArg.search,
          },
        }),
        providesTags: ['members'],
      }),
      membersCreate: build.mutation<
        MembersCreateApiResponse,
        MembersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/members/`,
          method: 'POST',
          body: queryArg.membership,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['members'],
      }),
      membersRetrieve: build.query<
        MembersRetrieveApiResponse,
        MembersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/members/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['members'],
      }),
      membersPartialUpdate: build.mutation<
        MembersPartialUpdateApiResponse,
        MembersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/members/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedMembership,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['members'],
      }),
      membersDestroy: build.mutation<
        MembersDestroyApiResponse,
        MembersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/members/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['members'],
      }),
      membersUndeleteCreate: build.mutation<
        MembersUndeleteCreateApiResponse,
        MembersUndeleteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/members/${queryArg.id}/undelete/`,
          method: 'POST',
          body: queryArg.membership,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['members'],
      }),
      membersUpdateEmailCreate: build.mutation<
        MembersUpdateEmailCreateApiResponse,
        MembersUpdateEmailCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/members/${queryArg.id}/update_email/`,
          method: 'POST',
          body: queryArg.updateEmail,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['members'],
      }),
      messagesList: build.query<MessagesListApiResponse, MessagesListApiArg>({
        query: (queryArg) => ({
          url: `/messages/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['messages'],
      }),
      messagesCreate: build.mutation<
        MessagesCreateApiResponse,
        MessagesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/`,
          method: 'POST',
          body: queryArg.message,
        }),
        invalidatesTags: ['messages'],
      }),
      messagesRetrieve: build.query<
        MessagesRetrieveApiResponse,
        MessagesRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/messages/${queryArg.id}/` }),
        providesTags: ['messages'],
      }),
      messagesTripMessagesList: build.query<
        MessagesTripMessagesListApiResponse,
        MessagesTripMessagesListApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/trip-messages/`,
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            trip_id: queryArg.tripId,
          },
        }),
        providesTags: ['messages'],
      }),
      messagesTripMessagesCreate: build.mutation<
        MessagesTripMessagesCreateApiResponse,
        MessagesTripMessagesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/trip-messages/`,
          method: 'POST',
          body: queryArg.tripMessage,
        }),
        invalidatesTags: ['messages'],
      }),
      messagesTripMessagesRetrieve: build.query<
        MessagesTripMessagesRetrieveApiResponse,
        MessagesTripMessagesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/trip-messages/${queryArg.tripId}/`,
        }),
        providesTags: ['messages'],
      }),
      messagesWebHookMessageUpdateCreate: build.mutation<
        MessagesWebHookMessageUpdateCreateApiResponse,
        MessagesWebHookMessageUpdateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/web-hook/message-update/`,
          method: 'POST',
          body: queryArg.message,
        }),
        invalidatesTags: ['messages'],
      }),
      mobileAppSettingsRetrieve: build.query<
        MobileAppSettingsRetrieveApiResponse,
        MobileAppSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/mobile-app-settings/`,
          headers: { 'User-Agent': queryArg['User-Agent'] },
        }),
        providesTags: ['user'],
      }),
      mobileAppSettingsPartialUpdate: build.mutation<
        MobileAppSettingsPartialUpdateApiResponse,
        MobileAppSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/mobile-app-settings/`,
          method: 'PATCH',
          body: queryArg.patchedMobileAppSettings,
          headers: { 'User-Agent': queryArg['User-Agent'] },
        }),
        invalidatesTags: ['user'],
      }),
      organizationBillingStatusRetrieve: build.query<
        OrganizationBillingStatusRetrieveApiResponse,
        OrganizationBillingStatusRetrieveApiArg
      >({
        query: () => ({ url: `/organization-billing-status/` }),
        providesTags: ['organization-billing-status'],
      }),
      organizationSettingsRetrieve: build.query<
        OrganizationSettingsRetrieveApiResponse,
        OrganizationSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/organization-settings/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['organizations'],
      }),
      organizationSettingsPartialUpdate: build.mutation<
        OrganizationSettingsPartialUpdateApiResponse,
        OrganizationSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/organization-settings/`,
          method: 'PATCH',
          body: queryArg.patchedOrganizationSettings,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['organizations'],
      }),
      organizationSettingsConnectMerchantAccountCreate: build.mutation<
        OrganizationSettingsConnectMerchantAccountCreateApiResponse,
        OrganizationSettingsConnectMerchantAccountCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/organization-settings/connect-merchant-account/`,
          method: 'POST',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['organizations'],
      }),
      organizationSettingsLogoRetrieve: build.query<
        OrganizationSettingsLogoRetrieveApiResponse,
        OrganizationSettingsLogoRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/organization-settings/logo/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['organizations'],
      }),
      partnersOauth2TokenCreate: build.mutation<
        PartnersOauth2TokenCreateApiResponse,
        PartnersOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/partners/oauth2/token/`,
          method: 'POST',
          body: queryArg.partnersOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      partnersOrganizationsList: build.query<
        PartnersOrganizationsListApiResponse,
        PartnersOrganizationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/partners/organizations/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['Organizations'],
      }),
      partnersOrganizationsPayersList: build.query<
        PartnersOrganizationsPayersListApiResponse,
        PartnersOrganizationsPayersListApiArg
      >({
        query: (queryArg) => ({
          url: `/partners/organizations/${queryArg.organizationId}/payers/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['Payers'],
      }),
      partnersOrganizationsTripsList: build.query<
        PartnersOrganizationsTripsListApiResponse,
        PartnersOrganizationsTripsListApiArg
      >({
        query: (queryArg) => ({
          url: `/partners/organizations/${queryArg.organizationId}/trips/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['Trips'],
      }),
      partnersOrganizationsTripsCreate: build.mutation<
        PartnersOrganizationsTripsCreateApiResponse,
        PartnersOrganizationsTripsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/partners/organizations/${queryArg.organizationId}/trips/`,
          method: 'POST',
          body: queryArg.partnerTripCreate,
        }),
        invalidatesTags: ['Trips'],
      }),
      partnersOrganizationsTripsRetrieve: build.query<
        PartnersOrganizationsTripsRetrieveApiResponse,
        PartnersOrganizationsTripsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/partners/organizations/${queryArg.organizationId}/trips/${queryArg.id}/`,
        }),
        providesTags: ['Trips'],
      }),
      partnersOrganizationsTripsActivateWillCallCreate: build.mutation<
        PartnersOrganizationsTripsActivateWillCallCreateApiResponse,
        PartnersOrganizationsTripsActivateWillCallCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/partners/organizations/${queryArg.organizationId}/trips/${queryArg.id}/activate_will_call/`,
          method: 'POST',
          body: queryArg.partnerTripActivateWillCall,
        }),
        invalidatesTags: ['Trips'],
      }),
      partnersOrganizationsTripsCancelCreate: build.mutation<
        PartnersOrganizationsTripsCancelCreateApiResponse,
        PartnersOrganizationsTripsCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/partners/organizations/${queryArg.organizationId}/trips/${queryArg.id}/cancel/`,
          method: 'POST',
          body: queryArg.partnerTripCancel,
        }),
        invalidatesTags: ['Trips'],
      }),
      passengerTagsList: build.query<
        PassengerTagsListApiResponse,
        PassengerTagsListApiArg
      >({
        query: (queryArg) => ({
          url: `/passenger-tags/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['tags'],
      }),
      passengerTagsCreate: build.mutation<
        PassengerTagsCreateApiResponse,
        PassengerTagsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passenger-tags/`,
          method: 'POST',
          body: queryArg.passengerTagBulkCreate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      passengerTagsRetrieve: build.query<
        PassengerTagsRetrieveApiResponse,
        PassengerTagsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passenger-tags/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['tags'],
      }),
      passengerTagsDestroy: build.mutation<
        PassengerTagsDestroyApiResponse,
        PassengerTagsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/passenger-tags/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      passengersList: build.query<
        PassengersListApiResponse,
        PassengersListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            allow_sms_message: queryArg.allowSmsMessage,
            deleted_objects: queryArg.deletedObjects,
            gender: queryArg.gender,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['passengers'],
      }),
      passengersCreate: build.mutation<
        PassengersCreateApiResponse,
        PassengersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/`,
          method: 'POST',
          body: queryArg.passenger,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersAlternateIdentifiersList: build.query<
        PassengersAlternateIdentifiersListApiResponse,
        PassengersAlternateIdentifiersListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/alternate-identifiers/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['passengers'],
      }),
      passengersAlternateIdentifiersCreate: build.mutation<
        PassengersAlternateIdentifiersCreateApiResponse,
        PassengersAlternateIdentifiersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/alternate-identifiers/`,
          method: 'POST',
          body: queryArg.passengerAlternateIdentifier,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersAlternateIdentifiersRetrieve: build.query<
        PassengersAlternateIdentifiersRetrieveApiResponse,
        PassengersAlternateIdentifiersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/alternate-identifiers/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['passengers'],
      }),
      passengersAlternateIdentifiersPartialUpdate: build.mutation<
        PassengersAlternateIdentifiersPartialUpdateApiResponse,
        PassengersAlternateIdentifiersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/alternate-identifiers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPassengerAlternateIdentifier,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersAlternateIdentifiersDestroy: build.mutation<
        PassengersAlternateIdentifiersDestroyApiResponse,
        PassengersAlternateIdentifiersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/alternate-identifiers/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersPreferredDriversList: build.query<
        PassengersPreferredDriversListApiResponse,
        PassengersPreferredDriversListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/preferred-drivers/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['passengers'],
      }),
      passengersPreferredDriversCreate: build.mutation<
        PassengersPreferredDriversCreateApiResponse,
        PassengersPreferredDriversCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/preferred-drivers/`,
          method: 'POST',
          body: queryArg.preferredDriver,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersPreferredDriversRetrieve: build.query<
        PassengersPreferredDriversRetrieveApiResponse,
        PassengersPreferredDriversRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/preferred-drivers/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['passengers'],
      }),
      passengersPreferredDriversPartialUpdate: build.mutation<
        PassengersPreferredDriversPartialUpdateApiResponse,
        PassengersPreferredDriversPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/preferred-drivers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPreferredDriver,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersPreferredDriversDestroy: build.mutation<
        PassengersPreferredDriversDestroyApiResponse,
        PassengersPreferredDriversDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/preferred-drivers/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersRetrieve: build.query<
        PassengersRetrieveApiResponse,
        PassengersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['passengers'],
      }),
      passengersPartialUpdate: build.mutation<
        PassengersPartialUpdateApiResponse,
        PassengersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPassenger,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersDestroy: build.mutation<
        PassengersDestroyApiResponse,
        PassengersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersRecentAddressesList: build.query<
        PassengersRecentAddressesListApiResponse,
        PassengersRecentAddressesListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/recent-addresses/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            max_results: queryArg.maxResults,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['passengers'],
      }),
      passengersRecentPayersList: build.query<
        PassengersRecentPayersListApiResponse,
        PassengersRecentPayersListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/recent-payers/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            max_results: queryArg.maxResults,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['passengers'],
      }),
      passengersUndeleteCreate: build.mutation<
        PassengersUndeleteCreateApiResponse,
        PassengersUndeleteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/undelete/`,
          method: 'POST',
          body: queryArg.passenger,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersDuplicatesList: build.query<
        PassengersDuplicatesListApiResponse,
        PassengersDuplicatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/duplicates/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            created_at_end: queryArg.createdAtEnd,
            created_at_start: queryArg.createdAtStart,
            first_name_starts_with: queryArg.firstNameStartsWith,
            last_name_starts_with: queryArg.lastNameStartsWith,
            match_fields: queryArg.matchFields,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            passenger__in: queryArg.passengerIn,
          },
        }),
        providesTags: ['passengers'],
      }),
      passengersExportRetrieve: build.query<
        PassengersExportRetrieveApiResponse,
        PassengersExportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/export/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['passengers'],
      }),
      passengersMergeCreate: build.mutation<
        PassengersMergeCreateApiResponse,
        PassengersMergeCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/merge/`,
          method: 'POST',
          body: queryArg.passengerMergeRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['passengers'],
      }),
      payerSettingsList: build.query<
        PayerSettingsListApiResponse,
        PayerSettingsListApiArg
      >({
        query: (queryArg) => ({
          url: `/payer-settings/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['payers'],
      }),
      payerSettingsRetrieve: build.query<
        PayerSettingsRetrieveApiResponse,
        PayerSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payer-settings/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['payers'],
      }),
      payerSettingsPartialUpdate: build.mutation<
        PayerSettingsPartialUpdateApiResponse,
        PayerSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/payer-settings/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPayerOrganizationSettings,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['payers'],
      }),
      payerinfoList: build.query<PayerinfoListApiResponse, PayerinfoListApiArg>(
        {
          query: (queryArg) => ({
            url: `/payerinfo/`,
            headers: { 'Organization-ID': queryArg['Organization-ID'] },
            params: {
              ordering: queryArg.ordering,
              page: queryArg.page,
              page_size: queryArg.pageSize,
              search: queryArg.search,
            },
          }),
          providesTags: ['payers'],
        }
      ),
      payerinfoRetrieve: build.query<
        PayerinfoRetrieveApiResponse,
        PayerinfoRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payerinfo/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['payers'],
      }),
      payerinfooneschematemplateList: build.query<
        PayerinfooneschematemplateListApiResponse,
        PayerinfooneschematemplateListApiArg
      >({
        query: (queryArg) => ({
          url: `/payerinfooneschematemplate/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['payers'],
      }),
      payersList: build.query<PayersListApiResponse, PayersListApiArg>({
        query: (queryArg) => ({
          url: `/payers/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            can_multiload: queryArg.canMultiload,
            id: queryArg.id,
            is_active: queryArg.isActive,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            payer_settings__allow_only_specific_drivers:
              queryArg.payerSettingsAllowOnlySpecificDrivers,
            payer_settings__allow_only_specific_vehicles:
              queryArg.payerSettingsAllowOnlySpecificVehicles,
            search: queryArg.search,
          },
        }),
        providesTags: ['payers'],
      }),
      payersCreate: build.mutation<PayersCreateApiResponse, PayersCreateApiArg>(
        {
          query: (queryArg) => ({
            url: `/payers/`,
            method: 'POST',
            body: queryArg.payerOrganization,
            headers: { 'Organization-ID': queryArg['Organization-ID'] },
          }),
          invalidatesTags: ['payers'],
        }
      ),
      payersDriversList: build.query<
        PayersDriversListApiResponse,
        PayersDriversListApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/drivers/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['payers'],
      }),
      payersDriversCreate: build.mutation<
        PayersDriversCreateApiResponse,
        PayersDriversCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/drivers/`,
          method: 'POST',
          body: queryArg.payerOrganizationDriver,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['payers'],
      }),
      payersPassengersRetrieve: build.query<
        PayersPassengersRetrieveApiResponse,
        PayersPassengersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/passengers/${queryArg.passengerId}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['payers'],
      }),
      payersPassengersCreate: build.mutation<
        PayersPassengersCreateApiResponse,
        PayersPassengersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/passengers/${queryArg.passengerId}/`,
          method: 'POST',
          body: queryArg.payerPassenger,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['payers'],
      }),
      payersPassengersPartialUpdate: build.mutation<
        PayersPassengersPartialUpdateApiResponse,
        PayersPassengersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/passengers/${queryArg.passengerId}/`,
          method: 'PATCH',
          body: queryArg.patchedPayerPassenger,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['payers'],
      }),
      payersPassengersDestroy: build.mutation<
        PayersPassengersDestroyApiResponse,
        PayersPassengersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/passengers/${queryArg.passengerId}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['payers'],
      }),
      payersSettingsRetrieve: build.query<
        PayersSettingsRetrieveApiResponse,
        PayersSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/settings/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['payers'],
      }),
      payersSettingsPartialUpdate: build.mutation<
        PayersSettingsPartialUpdateApiResponse,
        PayersSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/settings/`,
          method: 'PATCH',
          body: queryArg.patchedPayerOrganizationSettings,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['payers'],
      }),
      payersVehiclesList: build.query<
        PayersVehiclesListApiResponse,
        PayersVehiclesListApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/vehicles/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['payers'],
      }),
      payersVehiclesCreate: build.mutation<
        PayersVehiclesCreateApiResponse,
        PayersVehiclesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/vehicles/`,
          method: 'POST',
          body: queryArg.payerOrganizationVehicle,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['payers'],
      }),
      payersRetrieve: build.query<
        PayersRetrieveApiResponse,
        PayersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['payers'],
      }),
      payersPartialUpdate: build.mutation<
        PayersPartialUpdateApiResponse,
        PayersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPayerOrganization,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['payers'],
      }),
      payersDestroy: build.mutation<
        PayersDestroyApiResponse,
        PayersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['payers'],
      }),
      payersMultiloadingPartnersRetrieve: build.query<
        PayersMultiloadingPartnersRetrieveApiResponse,
        PayersMultiloadingPartnersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.id}/multiloading-partners/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['payers'],
      }),
      payersListSelected: build.query<
        PayersListSelectedApiResponse,
        PayersListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/list-selected/`,
          method: 'POST',
          body: queryArg.payerFilters,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            can_multiload: queryArg.canMultiload,
            id: queryArg.id,
            is_active: queryArg.isActive,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            payer_settings__allow_only_specific_drivers:
              queryArg.payerSettingsAllowOnlySpecificDrivers,
            payer_settings__allow_only_specific_vehicles:
              queryArg.payerSettingsAllowOnlySpecificVehicles,
            search: queryArg.search,
          },
        }),
        providesTags: ['payers'],
      }),
      payersandtemplatesRetrieve: build.query<
        PayersandtemplatesRetrieveApiResponse,
        PayersandtemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payersandtemplates/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['payers'],
      }),
      payerstemplatesList: build.query<
        PayerstemplatesListApiResponse,
        PayerstemplatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/payerstemplates/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['payers'],
      }),
      payerstemplatesRetrieve: build.query<
        PayerstemplatesRetrieveApiResponse,
        PayerstemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payerstemplates/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['payers'],
      }),
      pricingPriceQuoteCreate: build.mutation<
        PricingPriceQuoteCreateApiResponse,
        PricingPriceQuoteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/price-quote/`,
          method: 'POST',
          body: queryArg.priceQuote,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['pricing'],
      }),
      pricingPricingSchemeConflictsCreate: build.mutation<
        PricingPricingSchemeConflictsCreateApiResponse,
        PricingPricingSchemeConflictsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-scheme-conflicts/`,
          method: 'POST',
          body: queryArg.priceSchemeConflict,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['pricing'],
      }),
      pricingPricingSchemesList: build.query<
        PricingPricingSchemesListApiResponse,
        PricingPricingSchemesListApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-schemes/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            payer__in: queryArg.payerIn,
            pricing_scheme_payers__payer_id:
              queryArg.pricingSchemePayersPayerId,
            search: queryArg.search,
            service_type__in: queryArg.serviceTypeIn,
            space_type__in: queryArg.spaceTypeIn,
          },
        }),
        providesTags: ['pricing'],
      }),
      pricingPricingSchemesCreate: build.mutation<
        PricingPricingSchemesCreateApiResponse,
        PricingPricingSchemesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-schemes/`,
          method: 'POST',
          body: queryArg.pricingScheme,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['pricing'],
      }),
      pricingPricingSchemesRetrieve: build.query<
        PricingPricingSchemesRetrieveApiResponse,
        PricingPricingSchemesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-schemes/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['pricing'],
      }),
      pricingPricingSchemesPartialUpdate: build.mutation<
        PricingPricingSchemesPartialUpdateApiResponse,
        PricingPricingSchemesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-schemes/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPricingScheme,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['pricing'],
      }),
      pricingPricingSchemesDestroy: build.mutation<
        PricingPricingSchemesDestroyApiResponse,
        PricingPricingSchemesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-schemes/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['pricing'],
      }),
      profileRetrieve: build.query<
        ProfileRetrieveApiResponse,
        ProfileRetrieveApiArg
      >({
        query: () => ({ url: `/profile/` }),
        providesTags: ['user'],
      }),
      reportsCustomReportsList: build.query<
        ReportsCustomReportsListApiResponse,
        ReportsCustomReportsListApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/custom-reports`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['reports'],
      }),
      reportsCustomReportsCreate: build.mutation<
        ReportsCustomReportsCreateApiResponse,
        ReportsCustomReportsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/custom-reports`,
          method: 'POST',
          body: queryArg.customReport,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['reports'],
      }),
      reportsCustomReportsRetrieve: build.query<
        ReportsCustomReportsRetrieveApiResponse,
        ReportsCustomReportsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/custom-reports/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['reports'],
      }),
      reportsCustomReportsPartialUpdate: build.mutation<
        ReportsCustomReportsPartialUpdateApiResponse,
        ReportsCustomReportsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/custom-reports/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedCustomReport,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['reports'],
      }),
      reportsCustomReportsDestroy: build.mutation<
        ReportsCustomReportsDestroyApiResponse,
        ReportsCustomReportsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/custom-reports/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['reports'],
      }),
      reportsTripsLoadedMileageCountCreate: build.query<
        ReportsTripsLoadedMileageCountCreateApiResponse,
        ReportsTripsLoadedMileageCountCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/trips/loaded-mileage-count/`,
          method: 'POST',
          body: queryArg.tripLoadedMileageRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['reports'],
      }),
      reportsTripsOnTimeCountCreate: build.query<
        ReportsTripsOnTimeCountCreateApiResponse,
        ReportsTripsOnTimeCountCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/trips/on-time-count/`,
          method: 'POST',
          body: queryArg.tripOnTimeRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['reports'],
      }),
      reportsTripsRevenueCountCreate: build.query<
        ReportsTripsRevenueCountCreateApiResponse,
        ReportsTripsRevenueCountCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/trips/revenue-count/`,
          method: 'POST',
          body: queryArg.tripRevenueRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['reports'],
      }),
      reportsTripsStatusCountCreate: build.query<
        ReportsTripsStatusCountCreateApiResponse,
        ReportsTripsStatusCountCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/trips/status-count/`,
          method: 'POST',
          body: queryArg.tripStatusCountRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['reports'],
      }),
      runBambiRunCreate: build.mutation<
        RunBambiRunCreateApiResponse,
        RunBambiRunCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/run-bambi-run/`,
          method: 'POST',
          body: queryArg.runBambiRun,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      runBambiRunRetrieve: build.query<
        RunBambiRunRetrieveApiResponse,
        RunBambiRunRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/run-bambi-run/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['run-bambi-run'],
      }),
      runBambiRunApplyCreate: build.mutation<
        RunBambiRunApplyCreateApiResponse,
        RunBambiRunApplyCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/run-bambi-run/${queryArg.id}/apply/`,
          method: 'POST',
          body: queryArg.runBambiRunApply,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      signaturesList: build.query<
        SignaturesListApiResponse,
        SignaturesListApiArg
      >({
        query: (queryArg) => ({
          url: `/signatures/`,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['signatures'],
      }),
      signaturesCreate: build.mutation<
        SignaturesCreateApiResponse,
        SignaturesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/signatures/`,
          method: 'POST',
          body: queryArg.signature,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        invalidatesTags: ['signatures'],
      }),
      signaturesRetrieve: build.query<
        SignaturesRetrieveApiResponse,
        SignaturesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/signatures/${queryArg.id}/`,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        providesTags: ['signatures'],
      }),
      signaturesDestroy: build.mutation<
        SignaturesDestroyApiResponse,
        SignaturesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/signatures/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        invalidatesTags: ['signatures'],
      }),
      tagsList: build.query<TagsListApiResponse, TagsListApiArg>({
        query: (queryArg) => ({
          url: `/tags/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['tags'],
      }),
      tagsCreate: build.mutation<TagsCreateApiResponse, TagsCreateApiArg>({
        query: (queryArg) => ({
          url: `/tags/`,
          method: 'POST',
          body: queryArg.tag,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      tagsRetrieve: build.query<TagsRetrieveApiResponse, TagsRetrieveApiArg>({
        query: (queryArg) => ({
          url: `/tags/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['tags'],
      }),
      tagsPartialUpdate: build.mutation<
        TagsPartialUpdateApiResponse,
        TagsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/tags/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedTag,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      tagsDestroy: build.mutation<TagsDestroyApiResponse, TagsDestroyApiArg>({
        query: (queryArg) => ({
          url: `/tags/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      tilledPaymentMethodRetrieve: build.query<
        TilledPaymentMethodRetrieveApiResponse,
        TilledPaymentMethodRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            payer_id: queryArg.payerId,
            payer_type: queryArg.payerType,
          },
        }),
        providesTags: ['tilled'],
      }),
      tilledPaymentMethodCreate: build.mutation<
        TilledPaymentMethodCreateApiResponse,
        TilledPaymentMethodCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/`,
          method: 'POST',
          body: queryArg.tilledPaymentMethodInput,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledPaymentMethodDestroy: build.mutation<
        TilledPaymentMethodDestroyApiResponse,
        TilledPaymentMethodDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { payment_method_id: queryArg.paymentMethodId },
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledPaymentMethodPartialUpdate: build.mutation<
        TilledPaymentMethodPartialUpdateApiResponse,
        TilledPaymentMethodPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/${queryArg.paymentMethodId}/`,
          method: 'PATCH',
          body: queryArg.patchedTilledPaymentMethodBillingDetails,
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledPaymentMethodVerifyRetrieve: build.query<
        TilledPaymentMethodVerifyRetrieveApiResponse,
        TilledPaymentMethodVerifyRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/${queryArg.paymentMethodId}/verify/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['tilled'],
      }),
      tilledPaymentMethodVerifyCreate: build.mutation<
        TilledPaymentMethodVerifyCreateApiResponse,
        TilledPaymentMethodVerifyCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/${queryArg.paymentMethodId}/verify/`,
          method: 'POST',
          body: queryArg.tilledPaymentMethodVerifyRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledPayoutsList: build.query<
        TilledPayoutsListApiResponse,
        TilledPayoutsListApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payouts/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            invoice_number: queryArg.invoiceNumber,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            paid_at_after: queryArg.paidAtAfter,
            paid_at_before: queryArg.paidAtBefore,
            selected_invoices: queryArg.selectedInvoices,
          },
        }),
        providesTags: ['tilled'],
      }),
      tilledPayoutsExportCreate: build.mutation<
        TilledPayoutsExportCreateApiResponse,
        TilledPayoutsExportCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payouts/export/`,
          method: 'POST',
          body: queryArg.tilledPayoutExport,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            invoice_number: queryArg.invoiceNumber,
            paid_at_after: queryArg.paidAtAfter,
            paid_at_before: queryArg.paidAtBefore,
            selected_invoices: queryArg.selectedInvoices,
          },
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledResourceLinkCreate: build.mutation<
        TilledResourceLinkCreateApiResponse,
        TilledResourceLinkCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/resource-link/`,
          method: 'POST',
          body: queryArg.tilledResourceLink,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledWebhookCreate: build.mutation<
        TilledWebhookCreateApiResponse,
        TilledWebhookCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/webhook/`,
          method: 'POST',
          body: queryArg.tilledWebHookEnvelope,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tilled'],
      }),
      tokensChatIssueRetrieve: build.query<
        TokensChatIssueRetrieveApiResponse,
        TokensChatIssueRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/tokens/chat/issue/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['members'],
      }),
      tokensPushRegisterCreate: build.mutation<
        TokensPushRegisterCreateApiResponse,
        TokensPushRegisterCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tokens/push/register/`,
          method: 'POST',
          body: queryArg.pushTokens,
          headers: {
            'Organization-ID': queryArg['Organization-ID'],
            'User-Agent': queryArg['User-Agent'],
          },
        }),
        invalidatesTags: ['members'],
      }),
      tokensPushRevokeCreate: build.mutation<
        TokensPushRevokeCreateApiResponse,
        TokensPushRevokeCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tokens/push/revoke/`,
          method: 'POST',
          body: queryArg.pushTokens,
          headers: {
            'Organization-ID': queryArg['Organization-ID'],
            'User-Agent': queryArg['User-Agent'],
          },
        }),
        invalidatesTags: ['members'],
      }),
      tripImportCreate: build.mutation<
        TripImportCreateApiResponse,
        TripImportCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-import/`,
          method: 'POST',
          body: queryArg.tripImportAsyncRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trip-import'],
      }),
      tripImportRetrieve: build.query<
        TripImportRetrieveApiResponse,
        TripImportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-import/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['trip-import'],
      }),
      tripRequestEmbedList: build.query<
        TripRequestEmbedListApiResponse,
        TripRequestEmbedListApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-request-embed/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            is_active: queryArg.isActive,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['trip-request-embed'],
      }),
      tripRequestEmbedCreate: build.mutation<
        TripRequestEmbedCreateApiResponse,
        TripRequestEmbedCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-request-embed/`,
          method: 'POST',
          body: queryArg.tripRequestEmbed,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trip-request-embed'],
      }),
      tripRequestEmbedRetrieve: build.query<
        TripRequestEmbedRetrieveApiResponse,
        TripRequestEmbedRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-request-embed/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['trip-request-embed'],
      }),
      tripRequestEmbedPartialUpdate: build.mutation<
        TripRequestEmbedPartialUpdateApiResponse,
        TripRequestEmbedPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-request-embed/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedTripRequestEmbed,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trip-request-embed'],
      }),
      tripRequestEmbedDestroy: build.mutation<
        TripRequestEmbedDestroyApiResponse,
        TripRequestEmbedDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-request-embed/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trip-request-embed'],
      }),
      tripTagsList: build.query<TripTagsListApiResponse, TripTagsListApiArg>({
        query: (queryArg) => ({
          url: `/trip-tags/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['tags'],
      }),
      tripTagsCreate: build.mutation<
        TripTagsCreateApiResponse,
        TripTagsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-tags/`,
          method: 'POST',
          body: queryArg.tripTagBulkCreate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      tripTagsRetrieve: build.query<
        TripTagsRetrieveApiResponse,
        TripTagsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-tags/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['tags'],
      }),
      tripTagsDestroy: build.mutation<
        TripTagsDestroyApiResponse,
        TripTagsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-tags/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      vehicleTagsList: build.query<
        VehicleTagsListApiResponse,
        VehicleTagsListApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicle-tags/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['tags'],
      }),
      vehicleTagsCreate: build.mutation<
        VehicleTagsCreateApiResponse,
        VehicleTagsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicle-tags/`,
          method: 'POST',
          body: queryArg.vehicleTagBulkCreate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      vehicleTagsRetrieve: build.query<
        VehicleTagsRetrieveApiResponse,
        VehicleTagsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicle-tags/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['tags'],
      }),
      vehicleTagsDestroy: build.mutation<
        VehicleTagsDestroyApiResponse,
        VehicleTagsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicle-tags/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['tags'],
      }),
      vehiclesList: build.query<VehiclesListApiResponse, VehiclesListApiArg>({
        query: (queryArg) => ({
          url: `/vehicles/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            can_be_scheduled: queryArg.canBeScheduled,
            deleted_objects: queryArg.deletedObjects,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
          },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesCreate: build.mutation<
        VehiclesCreateApiResponse,
        VehiclesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/`,
          method: 'POST',
          body: queryArg.vehicle,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['vehicles'],
      }),
      vehiclesRetrieve: build.query<
        VehiclesRetrieveApiResponse,
        VehiclesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesPartialUpdate: build.mutation<
        VehiclesPartialUpdateApiResponse,
        VehiclesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedVehicle,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['vehicles'],
      }),
      vehiclesDestroy: build.mutation<
        VehiclesDestroyApiResponse,
        VehiclesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['vehicles'],
      }),
      vehiclesPayersList: build.query<
        VehiclesPayersListApiResponse,
        VehiclesPayersListApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.vehicleId}/payers/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesPayersCreate: build.mutation<
        VehiclesPayersCreateApiResponse,
        VehiclesPayersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.vehicleId}/payers/`,
          method: 'POST',
          body: queryArg.vehiclePayerOrganization,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['vehicles'],
      }),
      vehiclesInspectionCreate: build.mutation<
        VehiclesInspectionCreateApiResponse,
        VehiclesInspectionCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/inspection/`,
          method: 'POST',
          body: queryArg.vehicleInspectionReport,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['vehicles'],
      }),
      vehiclesInspectionFieldsList: build.query<
        VehiclesInspectionFieldsListApiResponse,
        VehiclesInspectionFieldsListApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/inspection-fields/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesInspectionsList: build.query<
        VehiclesInspectionsListApiResponse,
        VehiclesInspectionsListApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/inspections/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            assignment: queryArg.assignment,
            created_at: queryArg.createdAt,
            has_fail: queryArg.hasFail,
            membership: queryArg.membership,
            membership__in: queryArg.membershipIn,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            vehicle: queryArg.vehicle,
            vehicle__in: queryArg.vehicleIn,
          },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesInspectionsRetrieve: build.query<
        VehiclesInspectionsRetrieveApiResponse,
        VehiclesInspectionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/inspections/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesInspectionsExportRetrieve: build.query<
        VehiclesInspectionsExportRetrieveApiResponse,
        VehiclesInspectionsExportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/inspections/export/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            assignment: queryArg.assignment,
            created_at: queryArg.createdAt,
            has_fail: queryArg.hasFail,
            membership: queryArg.membership,
            membership__in: queryArg.membershipIn,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            vehicle: queryArg.vehicle,
            vehicle__in: queryArg.vehicleIn,
          },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesListSelected: build.query<
        VehiclesListSelectedApiResponse,
        VehiclesListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/list-selected/`,
          method: 'POST',
          body: queryArg.vehicleFilters,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            can_be_scheduled: queryArg.canBeScheduled,
            deleted_objects: queryArg.deletedObjects,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
          },
        }),
        providesTags: ['vehicles'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as bambiApi };
export type AttendantsListApiResponse =
  /** status 200  */ PaginatedAttendantListRead;
export type AttendantsListApiArg = {
  'Organization-ID'?: string;
  canBeScheduled?: boolean;
  id?: string;
  /** Sort attendants by an attribute */
  ordering?: 'can_be_scheduled' | 'first_name';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type AttendantsCreateApiResponse = /** status 201  */ AttendantRead;
export type AttendantsCreateApiArg = {
  'Organization-ID'?: string;
  attendant: AttendantWrite;
};
export type AttendantsRetrieveApiResponse = /** status 200  */ AttendantRead;
export type AttendantsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this attendant. */
  id: string;
};
export type AttendantsPartialUpdateApiResponse =
  /** status 200  */ AttendantRead;
export type AttendantsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this attendant. */
  id: string;
  patchedAttendant: PatchedAttendantWrite;
};
export type AttendantsDestroyApiResponse =
  /** status 204 No response body */ void;
export type AttendantsDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this attendant. */
  id: string;
};
export type AttendantsSkillsCreateApiResponse =
  /** status 201  */ AttendantSkills;
export type AttendantsSkillsCreateApiArg = {
  'Organization-ID'?: string;
  attendantSkills: AttendantSkillsWrite;
};
export type AttendantsSkillsRetrieveApiResponse =
  /** status 200  */ AttendantSkills;
export type AttendantsSkillsRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type AttendantsSkillsUpdateApiResponse =
  /** status 200  */ AttendantSkills;
export type AttendantsSkillsUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  attendantSkills: AttendantSkillsWrite;
};
export type AttendantsSkillsPartialUpdateApiResponse =
  /** status 200  */ AttendantSkills;
export type AttendantsSkillsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedAttendantSkills: PatchedAttendantSkillsWrite;
};
export type AttendantsSkillsDestroyApiResponse =
  /** status 204 No response body */ void;
export type AttendantsSkillsDestroyApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type BillingBillingSettingsRetrieveApiResponse =
  /** status 200  */ BillingSettingsRead;
export type BillingBillingSettingsRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type BillingBillingSettingsPartialUpdateApiResponse =
  /** status 200  */ BillingSettingsRead;
export type BillingBillingSettingsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  patchedBillingSettings: PatchedBillingSettings;
};
export type BillingBillingSettingsNextInvoiceNumberRetrieveApiResponse =
  /** status 200  */ InvoiceNumberGeneratorRead;
export type BillingBillingSettingsNextInvoiceNumberRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type BillingTripsBillingListApiResponse =
  /** status 200  */ PaginatedTripBillingListRead;
export type BillingTripsBillingListApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type BrokersAliviOauth2TokenCreateApiResponse =
  /** status 200  */ AliviOAuthTokenRead;
export type BrokersAliviOauth2TokenCreateApiArg = {
  aliviOAuthToken: AliviOAuthTokenWrite;
};
export type BrokersAliviRideActivateWillcallCreateApiResponse =
  /** status 200  */ AliviRideActivateWillCall;
export type BrokersAliviRideActivateWillcallCreateApiArg = {
  aliviRideActivateWillCall: AliviRideActivateWillCallWrite;
};
export type BrokersAliviRideCancelCreateApiResponse =
  /** status 200  */ AliviRideCancel;
export type BrokersAliviRideCancelCreateApiArg = {
  aliviRideCancel: AliviRideCancelWrite;
};
export type BrokersAliviRideCancelWillcallActivationCreateApiResponse =
  /** status 200  */ AliviRideCancelWillCallActivation;
export type BrokersAliviRideCancelWillcallActivationCreateApiArg = {
  aliviRideCancelWillCallActivation: AliviRideCancelWillCallActivationWrite;
};
export type BrokersAliviRideGetStatusCreateApiResponse =
  /** status 200  */ AliviRideStatusRead;
export type BrokersAliviRideGetStatusCreateApiArg = {
  aliviRideStatus: AliviRideStatus;
};
export type BrokersAliviRideOfferCreateApiResponse =
  /** status 200  */ AliviRideOfferRead;
export type BrokersAliviRideOfferCreateApiArg = {
  aliviRideOffer: AliviRideOfferWrite;
};
export type BrokersAliviRideUpdateCreateApiResponse =
  /** status 200  */ AliviRideUpdate;
export type BrokersAliviRideUpdateCreateApiArg = {
  aliviRideUpdate: AliviRideUpdateWrite;
};
export type BrokersClearviewOauth2TokenCreateApiResponse =
  /** status 200  */ ClearviewOAuthTokenRead;
export type BrokersClearviewOauth2TokenCreateApiArg = {
  clearviewOAuthToken: ClearviewOAuthTokenWrite;
};
export type BrokersClearviewTripsListApiResponse =
  /** status 200  */ PaginatedClearviewTripListRead;
export type BrokersClearviewTripsListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type BrokersClearviewTripsCreateApiResponse =
  /** status 201  */ ClearviewTripRead;
export type BrokersClearviewTripsCreateApiArg = {
  'Organization-ID'?: string;
  clearviewTrip: ClearviewTrip;
};
export type BrokersClearviewTripsRetrieveApiResponse =
  /** status 200  */ ClearviewTripRead;
export type BrokersClearviewTripsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this trip. */
  id: string;
};
export type BrokersClearviewTripsPartialUpdateApiResponse =
  /** status 200  */ ClearviewTripRead;
export type BrokersClearviewTripsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this trip. */
  id: string;
  patchedClearviewTrip: PatchedClearviewTrip;
};
export type BrokersClearviewTripsCancelCreateApiResponse =
  /** status 200  */ ClearviewTripRead;
export type BrokersClearviewTripsCancelCreateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this trip. */
  id: string;
};
export type BrokersCtcOauth2TokenCreateApiResponse =
  /** status 200  */ CtcoAuthTokenRead;
export type BrokersCtcOauth2TokenCreateApiArg = {
  ctcoAuthToken: CtcoAuthTokenWrite;
};
export type BrokersCtcTripCreateApiResponse = /** status 200  */ CtcTripRead;
export type BrokersCtcTripCreateApiArg = {
  ctcTrip: CtcTripWrite;
};
export type BrokersCtcTripActivationCreateApiResponse =
  /** status 200  */ CtcTripActivateWillCallRead;
export type BrokersCtcTripActivationCreateApiArg = {
  ctcTripActivateWillCall: CtcTripActivateWillCallWrite;
};
export type BrokersCtcTripCancelCreateApiResponse =
  /** status 200  */ CtcTripCancelRead;
export type BrokersCtcTripCancelCreateApiArg = {
  ctcTripCancel: CtcTripCancelWrite;
};
export type BrokersExampleHelloWorldRetrieveApiResponse =
  /** status 200 No response body */ void;
export type BrokersExampleHelloWorldRetrieveApiArg = void;
export type BrokersKinetikOauth2TokenCreateApiResponse =
  /** status 200  */ KinetikOAuthTokenRead;
export type BrokersKinetikOauth2TokenCreateApiArg = {
  kinetikOAuthToken: KinetikOAuthToken;
};
export type BrokersKinetikV1CancelRideCreateApiResponse =
  /** status 200  */ KinetikRideReadOnly;
export type BrokersKinetikV1CancelRideCreateApiArg = {
  kinetikRideReadOnly: KinetikRideReadOnly;
};
export type BrokersKinetikV1CreateRidesCreateApiResponse =
  /** status 200  */ KinetikRide;
export type BrokersKinetikV1CreateRidesCreateApiArg = {
  kinetikRide: KinetikRide;
};
export type BrokersKinetikV1GetDriverCreateApiResponse =
  /** status 200  */ KinetikDriverRead;
export type BrokersKinetikV1GetDriverCreateApiArg = {
  kinetikDriver: KinetikDriver;
};
export type BrokersKinetikV1GetRideCreateApiResponse =
  /** status 200  */ KinetikRideReadOnly;
export type BrokersKinetikV1GetRideCreateApiArg = {
  kinetikRideReadOnly: KinetikRideReadOnly;
};
export type BrokersKinetikV1GetVehicleCreateApiResponse =
  /** status 200  */ KinetikVehicleRead;
export type BrokersKinetikV1GetVehicleCreateApiArg = {
  kinetikVehicle: KinetikVehicle;
};
export type BrokersKinetikV1UpdateRidesUpdateApiResponse =
  /** status 200  */ KinetikRide;
export type BrokersKinetikV1UpdateRidesUpdateApiArg = {
  kinetikRide: KinetikRide;
};
export type BrokersMedidriveOauth2TokenCreateApiResponse =
  /** status 200  */ MediDriveOAuthTokenRead;
export type BrokersMedidriveOauth2TokenCreateApiArg = {
  mediDriveOAuthToken: MediDriveOAuthTokenWrite;
};
export type BrokersMomentmBrokerAuthListApiResponse =
  /** status 200  */ PaginatedMomentmBrokerAuthListRead;
export type BrokersMomentmBrokerAuthListApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type BrokersMomentmBrokerAuthCreateApiResponse =
  /** status 201  */ MomentmBrokerAuthRead;
export type BrokersMomentmBrokerAuthCreateApiArg = {
  momentmBrokerAuth: MomentmBrokerAuth;
};
export type BrokersMomentmBrokerAuthRetrieveApiResponse =
  /** status 200  */ MomentmBrokerAuthRead;
export type BrokersMomentmBrokerAuthRetrieveApiArg = {
  /** A UUID string identifying this momentm broker auth. */
  id: string;
};
export type BrokersMomentmBrokerAuthUpdateApiResponse =
  /** status 200  */ MomentmBrokerAuthRead;
export type BrokersMomentmBrokerAuthUpdateApiArg = {
  /** A UUID string identifying this momentm broker auth. */
  id: string;
  momentmBrokerAuth: MomentmBrokerAuth;
};
export type BrokersMomentmBrokerAuthPartialUpdateApiResponse =
  /** status 200  */ MomentmBrokerAuthRead;
export type BrokersMomentmBrokerAuthPartialUpdateApiArg = {
  /** A UUID string identifying this momentm broker auth. */
  id: string;
  patchedMomentmBrokerAuth: PatchedMomentmBrokerAuth;
};
export type BrokersMomentmBrokerAuthDestroyApiResponse =
  /** status 204 No response body */ void;
export type BrokersMomentmBrokerAuthDestroyApiArg = {
  /** A UUID string identifying this momentm broker auth. */
  id: string;
};
export type BrokersMomentmBrokerAuthSetSecretCreateApiResponse =
  /** status 200  */ MomentmBrokerAuthRead;
export type BrokersMomentmBrokerAuthSetSecretCreateApiArg = {
  momentmBrokerAuth: MomentmBrokerAuth;
};
export type BrokersMomentmSetSecretCreateApiResponse =
  /** status 200  */ MomentmBrokerAuthRead;
export type BrokersMomentmSetSecretCreateApiArg = {
  momentmBrokerAuth: MomentmBrokerAuth;
};
export type BrokersMtmInitCreateApiResponse =
  /** status 200  */ MtmEmailTextResponse;
export type BrokersMtmInitCreateApiArg = {
  mtmTransportationProvider: MtmTransportationProvider;
};
export type BrokersMtmOauth2TokenCreateApiResponse =
  /** status 200  */ MtmoAuthTokenRead;
export type BrokersMtmOauth2TokenCreateApiArg = {
  mtmoAuthToken: MtmoAuthTokenWrite;
};
export type BrokersMtmSetSecretCreateApiResponse =
  /** status 200  */ MtmSetSecretResponse;
export type BrokersMtmSetSecretCreateApiArg = {
  mtmSecret: MtmSecret;
};
export type BrokersMtmTransportationProvidersListApiResponse =
  /** status 200  */ PaginatedMtmTransportationProviderListRead;
export type BrokersMtmTransportationProvidersListApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type BrokersMtmTransportationProvidersCreateApiResponse =
  /** status 201  */ MtmTransportationProviderRead;
export type BrokersMtmTransportationProvidersCreateApiArg = {
  mtmTransportationProvider: MtmTransportationProvider;
};
export type BrokersMtmTransportationProvidersRetrieveApiResponse =
  /** status 200  */ MtmTransportationProviderRead;
export type BrokersMtmTransportationProvidersRetrieveApiArg = {
  /** A UUID string identifying this mtm transportation provider. */
  id: string;
};
export type BrokersMtmTransportationProvidersUpdateApiResponse =
  /** status 200  */ MtmTransportationProviderRead;
export type BrokersMtmTransportationProvidersUpdateApiArg = {
  /** A UUID string identifying this mtm transportation provider. */
  id: string;
  mtmTransportationProvider: MtmTransportationProvider;
};
export type BrokersMtmTransportationProvidersPartialUpdateApiResponse =
  /** status 200  */ MtmTransportationProviderRead;
export type BrokersMtmTransportationProvidersPartialUpdateApiArg = {
  /** A UUID string identifying this mtm transportation provider. */
  id: string;
  patchedMtmTransportationProvider: PatchedMtmTransportationProvider;
};
export type BrokersMtmTransportationProvidersDestroyApiResponse =
  /** status 204 No response body */ void;
export type BrokersMtmTransportationProvidersDestroyApiArg = {
  /** A UUID string identifying this mtm transportation provider. */
  id: string;
};
export type BrokersMtmTransportationProvidersBackfillTripsCreateApiResponse =
  /** status 200  */ MtmBackfillTripsResponse;
export type BrokersMtmTransportationProvidersBackfillTripsCreateApiArg = {
  /** A UUID string identifying this mtm transportation provider. */
  id: string;
  mtmBackfillTripsRequest: MtmBackfillTripsRequest;
};
export type BrokersMtmTransportationProvidersGetEmailRetrieveApiResponse =
  /** status 200  */ MtmEmailTextResponse;
export type BrokersMtmTransportationProvidersGetEmailRetrieveApiArg = {
  id: string;
};
export type BrokersMtmTransportationProvidersTurnbackReasonsRetrieveApiResponse =
  /** status 200  */ MtmTurnbackReason[];
export type BrokersMtmTransportationProvidersTurnbackReasonsRetrieveApiArg = {
  /** A UUID string identifying this mtm transportation provider. */
  id: string;
};
export type BrokersMtmTransportationProvidersGetEmailTextRetrieveApiResponse =
  /** status 200  */ MtmEmailTextResponse;
export type BrokersMtmTransportationProvidersGetEmailTextRetrieveApiArg = void;
export type BrokersMtmTransportationProvidersInitCreateApiResponse =
  /** status 200  */ MtmEmailTextResponse;
export type BrokersMtmTransportationProvidersInitCreateApiArg = {
  mtmTransportationProvider: MtmTransportationProvider;
};
export type BrokersMtmTransportationProvidersSetSecretCreateApiResponse =
  /** status 200  */ MtmSetSecretResponse;
export type BrokersMtmTransportationProvidersSetSecretCreateApiArg = {
  mtmSecret: MtmSecret;
};
export type BrokersMtmWebhookCreateApiResponse = /** status 200  */ MtmWebhook;
export type BrokersMtmWebhookCreateApiArg = {
  webhookId: string;
  mtmWebhook: MtmWebhook;
};
export type BrokersProvideARideOauth2TokenCreateApiResponse =
  /** status 200  */ ProvideARideOAuthTokenRead;
export type BrokersProvideARideOauth2TokenCreateApiArg = {
  provideARideOAuthToken: ProvideARideOAuthTokenWrite;
};
export type BrokersProvideARideTripsCreateApiResponse =
  /** status 201  */ ProvideARideTripCreateRead;
export type BrokersProvideARideTripsCreateApiArg = {
  provideARideTripCreate: ProvideARideTripCreateWrite;
};
export type BrokersProvideARideTripsRetrieveApiResponse =
  /** status 200  */ ProvideARideTripReadRead;
export type BrokersProvideARideTripsRetrieveApiArg = {
  /** A UUID string identifying this trip. */
  id: string;
};
export type BrokersProvideARideTripsCancelCreateApiResponse =
  /** status 200 No response body */ void;
export type BrokersProvideARideTripsCancelCreateApiArg = {
  /** A UUID string identifying this trip. */
  id: string;
};
export type BrokersVectorcareWebhookCreateApiResponse =
  /** status 200  */ VectorCareTrip;
export type BrokersVectorcareWebhookCreateApiArg = {
  vectorcareOrganizationId: string;
  vectorCareTrip: VectorCareTrip;
};
export type CredentialsListApiResponse =
  /** status 200  */ PaginatedCredentialListRead;
export type CredentialsListApiArg = {
  credentialTypeCategory?: string;
  credentialTypes?: string;
  members?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  vehicles?: string;
};
export type CredentialsCreateApiResponse = /** status 201  */ CredentialRead;
export type CredentialsCreateApiArg = {
  credential: CredentialWrite;
};
export type CredentialsRetrieveApiResponse = /** status 200  */ CredentialRead;
export type CredentialsRetrieveApiArg = {
  /** A UUID string identifying this credential. */
  id: string;
};
export type CredentialsPartialUpdateApiResponse =
  /** status 200  */ CredentialRead;
export type CredentialsPartialUpdateApiArg = {
  /** A UUID string identifying this credential. */
  id: string;
  patchedCredential: PatchedCredentialWrite;
};
export type CredentialsDestroyApiResponse =
  /** status 204 No response body */ void;
export type CredentialsDestroyApiArg = {
  /** A UUID string identifying this credential. */
  id: string;
};
export type CredentialsExpiringSoonCountRetrieveApiResponse =
  /** status 200  */ CredentialExpiringSoonCount;
export type CredentialsExpiringSoonCountRetrieveApiArg = void;
export type CredentialsTypesListApiResponse =
  /** status 200  */ PaginatedCredentialTypeListRead;
export type CredentialsTypesListApiArg = {
  /** The category of the credential type. */
  category?: 'Misc' | 'Team' | 'Vehicle';
  description?: string;
  id?: string;
  name?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type CredentialsTypesCreateApiResponse =
  /** status 201  */ CredentialTypeRead;
export type CredentialsTypesCreateApiArg = {
  credentialType: CredentialType;
};
export type CredentialsTypesRetrieveApiResponse =
  /** status 200  */ CredentialTypeRead;
export type CredentialsTypesRetrieveApiArg = {
  /** A UUID string identifying this credential type. */
  id: string;
};
export type CredentialsTypesPartialUpdateApiResponse =
  /** status 200  */ CredentialTypeRead;
export type CredentialsTypesPartialUpdateApiArg = {
  /** A UUID string identifying this credential type. */
  id: string;
  patchedCredentialType: PatchedCredentialType;
};
export type CredentialsTypesDestroyApiResponse =
  /** status 204 No response body */ void;
export type CredentialsTypesDestroyApiArg = {
  /** A UUID string identifying this credential type. */
  id: string;
};
export type DailyDigestCreateApiResponse = /** status 201  */ DailyDigestRead;
export type DailyDigestCreateApiArg = {
  dailyDigest: DailyDigest;
};
export type DieCreateApiResponse = unknown;
export type DieCreateApiArg = {
  code: number;
};
export type DispatchRetrieveApiResponse = /** status 200  */ DispatchRead;
export type DispatchRetrieveApiArg = {
  'Organization-ID'?: string;
  assignedTripStatus?: string;
  countySearch?: string;
  driverTagSearch?: string;
  rangeEnd?: string;
  rangeStart?: string;
  stateSearch?: string;
  tripTagSearch?: string;
  unassignedOrdering?: string;
  unassignedPayers?: string;
  unassignedPriceMax?: number;
  unassignedPriceMin?: number;
  unassignedRangeEnd?: string;
  unassignedRangeStart?: string;
  unassignedSearch?: string;
  unassignedServiceTypes?: string;
  unassignedSpaceTypes?: string;
  vehicleTagSearch?: string;
  zipcodeSearch?: string;
};
export type DispatchSummaryRetrieveApiResponse =
  /** status 200  */ DispatchTripSummaryRead;
export type DispatchSummaryRetrieveApiArg = {
  'Organization-ID'?: string;
  assignedTripStatus?: string;
  driverTagSearch?: string;
  rangeEnd?: string;
  rangeStart?: string;
  vehicleTagSearch?: string;
};
export type DriverTagsListApiResponse =
  /** status 200  */ PaginatedDriverTagListRead;
export type DriverTagsListApiArg = {
  'Organization-ID'?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type DriverTagsCreateApiResponse =
  /** status 201  */ DriverTagBulkCreateRead;
export type DriverTagsCreateApiArg = {
  'Organization-ID'?: string;
  driverTagBulkCreate: DriverTagBulkCreate;
};
export type DriverTagsRetrieveApiResponse = /** status 200  */ DriverTagRead;
export type DriverTagsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this driver tag. */
  id: string;
};
export type DriverTagsDestroyApiResponse =
  /** status 204 No response body */ void;
export type DriverTagsDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this driver tag. */
  id: string;
};
export type DriversListApiResponse = /** status 200  */ PaginatedDriverListRead;
export type DriversListApiArg = {
  'Organization-ID'?: string;
  canBeScheduled?: boolean;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  id?: string;
  /** Multiple values may be separated by commas. */
  idIn?: string[];
  /** Multiple values may be separated by commas. */
  membershipIdIn?: string[];
  /** Sort drivers by an attribute */
  ordering?:
    | 'can_be_scheduled'
    | 'first_name'
    | 'license_expiration_date'
    | 'license_number'
    | 'license_state';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  /** Multiple values may be separated by commas. */
  tags?: string[];
};
export type DriversCreateApiResponse = /** status 201  */ DriverRead;
export type DriversCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  driver: DriverWrite;
};
export type DriversPayersListApiResponse =
  /** status 200  */ PaginatedDriverPayerOrganizationListRead;
export type DriversPayersListApiArg = {
  'Organization-ID'?: string;
  driverId: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type DriversPayersCreateApiResponse =
  /** status 201  */ DriverPayerOrganizationRead;
export type DriversPayersCreateApiArg = {
  'Organization-ID'?: string;
  driverId: string;
  driverPayerOrganization: DriverPayerOrganizationWrite;
};
export type DriversRetrieveApiResponse = /** status 200  */ DriverRead;
export type DriversRetrieveApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this driver. */
  id: string;
};
export type DriversPartialUpdateApiResponse = /** status 200  */ DriverRead;
export type DriversPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this driver. */
  id: string;
  patchedDriver: PatchedDriverWrite;
};
export type DriversDestroyApiResponse = /** status 204 No response body */ void;
export type DriversDestroyApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this driver. */
  id: string;
};
export type DriversUndeleteCreateApiResponse = /** status 200  */ DriverRead;
export type DriversUndeleteCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this driver. */
  id: string;
  driver: DriverWrite;
};
export type DriversListSelectedApiResponse =
  /** status 200  */ PaginatedDriverListRead;
export type DriversListSelectedApiArg = {
  'Organization-ID'?: string;
  canBeScheduled?: boolean;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  id?: string;
  /** Multiple values may be separated by commas. */
  idIn?: string[];
  /** Multiple values may be separated by commas. */
  membershipIdIn?: string[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  /** Multiple values may be separated by commas. */
  tags?: string[];
  driverFilters: DriverFilters;
};
export type FilterGroupsListApiResponse =
  /** status 200  */ PaginatedFilterGroupListRead;
export type FilterGroupsListApiArg = {
  'Organization-ID'?: string;
  /** Sort tags by an attribute */
  ordering?: 'created_at' | 'group_name' | 'updated_at';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type FilterGroupsCreateApiResponse = /** status 201  */ FilterGroupRead;
export type FilterGroupsCreateApiArg = {
  'Organization-ID'?: string;
  filterGroup: FilterGroup;
};
export type FilterGroupsRetrieveApiResponse =
  /** status 200  */ FilterGroupRead;
export type FilterGroupsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this filter group. */
  id: string;
};
export type FilterGroupsPartialUpdateApiResponse =
  /** status 200  */ FilterGroupRead;
export type FilterGroupsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this filter group. */
  id: string;
  patchedFilterGroup: PatchedFilterGroup;
};
export type FilterGroupsDestroyApiResponse =
  /** status 204 No response body */ void;
export type FilterGroupsDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this filter group. */
  id: string;
};
export type FilterGroupsCreateExamplesCreateApiResponse =
  /** status 200  */ FilterGroupRead;
export type FilterGroupsCreateExamplesCreateApiArg = {
  'Organization-ID'?: string;
  filterGroup: FilterGroup;
};
export type FlagsFeatureValuesListApiResponse =
  /** status 200  */ PaginatedFeatureFlagListRead;
export type FlagsFeatureValuesListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type FlagsFeatureValuesMobileListApiResponse =
  /** status 200  */ PaginatedFeatureFlagListRead;
export type FlagsFeatureValuesMobileListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type FlagsFeatureValuesWebListApiResponse =
  /** status 200  */ PaginatedFeatureFlagListRead;
export type FlagsFeatureValuesWebListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type FlagsFeaturesListApiResponse =
  /** status 200  */ PaginatedFeatureListRead;
export type FlagsFeaturesListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type InvoicesPayersListApiResponse =
  /** status 200  */ InvoicePayerRead[];
export type InvoicesPayersListApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type InvoicesTripsListApiResponse =
  /** status 200  */ InvoiceTripsRead[];
export type InvoicesTripsListApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type InvoicesExportRetrieveApiResponse = /** status 200  */ Blob;
export type InvoicesExportRetrieveApiArg = {
  'Organization-ID'?: string;
  createdAt?: string;
  invoice?: string;
  /** Multiple values may be separated by commas. */
  invoiceIn?: string[];
  /** Sort invoices by an attribute */
  ordering?:
    | 'trip__passenger__full_name'
    | 'trip__payer__display_name'
    | 'trip__time_range__startswith';
  /** Determines which serializer to use. */
  outputType?: 'condensed' | 'quickbooks' | 'quickbooks-self-pay';
  overallPaymentStatusIn?: string;
  rangeEnd?: string;
  rangeStart?: string;
  /** Multiple values may be separated by commas. */
  tripIn?: string[];
  tripPayer?: string;
  /** Multiple values may be separated by commas. */
  tripPayerIn?: string[];
};
export type InvoicesExportPaymentsRetrieveApiResponse = /** status 200  */ Blob;
export type InvoicesExportPaymentsRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type InvoicePaymentsListSelectedApiResponse =
  /** status 200 CSV file containing the invoice payments. */ Blob;
export type InvoicePaymentsListSelectedApiArg = {
  'Organization-ID'?: string;
  invoicePaymentExportFilter: InvoicePaymentExportFilter;
};
export type InvoicesExportRefundsRetrieveApiResponse = /** status 200  */ Blob;
export type InvoicesExportRefundsRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type InvoiceRefundsListSelectedApiResponse =
  /** status 200 CSV file containing the invoice refunds. */ Blob;
export type InvoiceRefundsListSelectedApiArg = {
  'Organization-ID'?: string;
  invoicesListFilter: InvoicesListFilter;
};
export type InvoiceLineItemsListSelectedApiResponse =
  /** status 200 CSV file containing the invoice line items. */ Blob;
export type InvoiceLineItemsListSelectedApiArg = {
  'Organization-ID'?: string;
  createdAt?: string;
  invoice?: string;
  /** Multiple values may be separated by commas. */
  invoiceIn?: string[];
  overallPaymentStatusIn?: string;
  rangeEnd?: string;
  rangeStart?: string;
  /** Multiple values may be separated by commas. */
  tripIn?: string[];
  tripPayer?: string;
  /** Multiple values may be separated by commas. */
  tripPayerIn?: string[];
  invoicesListFilter: InvoicesListFilter;
};
export type InvoicesInvoiceEmailCreateApiResponse =
  /** status 201 Invoice email sent successfully. */ void;
export type InvoicesInvoiceEmailCreateApiArg = {
  'Organization-ID'?: string;
  invoiceEmail: InvoiceEmail;
};
export type InvoicesInvoicesListApiResponse =
  /** status 200  */ PaginatedInvoiceListRead;
export type InvoicesInvoicesListApiArg = {
  'Organization-ID'?: string;
  createdAt?: string;
  dateIssued?: string;
  dateIssuedEnd?: string;
  dateIssuedStart?: string;
  dueMax?: number;
  dueMin?: number;
  hasEmailedPaymentLink?: boolean;
  hasPaymentLink?: boolean;
  minPayments?: number;
  /** Sort invoices by an attribute */
  ordering?: 'created_at' | 'date_issued' | 'number';
  /** Filter by overall payment status */
  overallPaymentStatusIn?: (
    | 'overpaid'
    | 'paid'
    | 'partially_paid'
    | 'unknown'
    | 'unpaid'
  )[];
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  rangeEnd?: string;
  rangeStart?: string;
  /** A search term. */
  search?: string;
  totalAmountMax?: number;
  totalAmountMin?: number;
  /** Filter by the payers on the trips for the invoices */
  tripPayerIn?: string[];
};
export type InvoicesInvoicesCreateApiResponse = /** status 201  */ InvoiceRead;
export type InvoicesInvoicesCreateApiArg = {
  'Organization-ID'?: string;
  invoice: Invoice;
};
export type InvoicesInvoicesRetrieveApiResponse =
  /** status 200  */ InvoiceRead;
export type InvoicesInvoicesRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this invoice. */
  id: string;
};
export type InvoicesInvoicesPartialUpdateApiResponse =
  /** status 200  */ InvoiceRead;
export type InvoicesInvoicesPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this invoice. */
  id: string;
  patchedInvoice: PatchedInvoice;
};
export type InvoicesInvoicesDestroyApiResponse =
  /** status 204 No response body */ void;
export type InvoicesInvoicesDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this invoice. */
  id: string;
};
export type InvoicesLineItemsListApiResponse =
  /** status 200  */ PaginatedInvoiceLineItemListRead;
export type InvoicesLineItemsListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type InvoicesLineItemsCreateApiResponse =
  /** status 201  */ InvoiceLineItemRead;
export type InvoicesLineItemsCreateApiArg = {
  'Organization-ID'?: string;
  invoiceLineItem: InvoiceLineItem;
};
export type InvoicesLineItemsRetrieveApiResponse =
  /** status 200  */ InvoiceLineItemRead;
export type InvoicesLineItemsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this invoice line item. */
  id: string;
};
export type InvoicesLineItemsPartialUpdateApiResponse =
  /** status 200  */ InvoiceLineItemRead;
export type InvoicesLineItemsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this invoice line item. */
  id: string;
  patchedInvoiceLineItem: PatchedInvoiceLineItem;
};
export type InvoicesLineItemsDestroyApiResponse =
  /** status 204 No response body */ void;
export type InvoicesLineItemsDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this invoice line item. */
  id: string;
};
export type InvoicesPaymentLinkListApiResponse =
  /** status 200  */ PaginatedInvoicePaymentLinkListRead;
export type InvoicesPaymentLinkListApiArg = {
  'Organization-ID'?: string;
  invoice?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  payment?: string;
};
export type InvoicesPaymentLinkCreateApiResponse =
  /** status 201  */ InvoicePaymentLinkRead;
export type InvoicesPaymentLinkCreateApiArg = {
  'Organization-ID'?: string;
  invoicePaymentLink: InvoicePaymentLink;
};
export type InvoicesPaymentLinkEmailCreateApiResponse =
  /** status 201 Email payment link sent successfully. */ void;
export type InvoicesPaymentLinkEmailCreateApiArg = {
  'Organization-ID'?: string;
  invoicePaymentLinkEmail: InvoicePaymentLinkEmail;
};
export type InvoicesPaymentLinkRetrieveApiResponse =
  /** status 200  */ InvoicePaymentLinkRead;
export type InvoicesPaymentLinkRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this invoice payment link. */
  id: string;
};
export type InvoicesPaymentLinkPartialUpdateApiResponse =
  /** status 200  */ InvoicePaymentLinkRead;
export type InvoicesPaymentLinkPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this invoice payment link. */
  id: string;
  patchedInvoicePaymentLink: PatchedInvoicePaymentLink;
};
export type InvoicesPaymentsListApiResponse =
  /** status 200  */ PaginatedInvoicePaymentListRead;
export type InvoicesPaymentsListApiArg = {
  'Organization-ID'?: string;
  createdAtAfter?: string;
  createdAtBefore?: string;
  hasRefunds?: boolean;
  invoiceNumber?: string;
  isManual?: boolean;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  status?: string;
  totalAmountCentsMax?: number;
  totalAmountCentsMin?: number;
};
export type InvoicesPaymentsCreateApiResponse =
  /** status 201  */ InvoicePaymentRead;
export type InvoicesPaymentsCreateApiArg = {
  'Organization-ID'?: string;
  invoicePayment: InvoicePayment;
};
export type InvoicesPaymentsRetrieveApiResponse =
  /** status 200  */ InvoicePaymentRead;
export type InvoicesPaymentsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this invoice payment. */
  id: string;
};
export type InvoicesRefundsListApiResponse =
  /** status 200  */ PaginatedInvoiceRefundListRead;
export type InvoicesRefundsListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type InvoicesRefundsCreateApiResponse =
  /** status 201  */ InvoiceRefundRead;
export type InvoicesRefundsCreateApiArg = {
  'Organization-ID'?: string;
  invoiceRefund: InvoiceRefund;
};
export type InvoicesRefundsRetrieveApiResponse =
  /** status 200  */ InvoiceRefundRead;
export type InvoicesRefundsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this invoice refund. */
  id: string;
};
export type InvoicesTripFinderListApiResponse =
  /** status 200  */ PaginatedInvoiceTripFinderListRead;
export type InvoicesTripFinderListApiArg = {
  /** Multiple values may be separated by commas. */
  canceledReasonIn?: (
    | ''
    | 'appointment canceled'
    | 'no show'
    | 'other'
    | 'passenger not ready'
    | 'passenger refused'
    | 'passenger unable'
    | 'payer canceled'
    | 'scheduling conflict'
    | 'user requested'
  )[];
  createdAtRangeEnd?: string;
  createdAtRangeStart?: string;
  /** Multiple values may be separated by commas. */
  driverIn?: (string | null)[];
  /** Multiple values may be separated by commas. */
  dropoffMunicipalityIn?: string[];
  /** Multiple values may be separated by commas. */
  externalTripIdIn?: string[];
  hasDriverEnteredNotes?: boolean;
  hasInvoice?: boolean;
  hasPaidInvoice?: boolean;
  /** Multiple values may be separated by commas. */
  idIn?: string[];
  /** Multiple values may be separated by commas. */
  intermediaryIn?: (
    | ''
    | 'alivi'
    | 'call_the_car'
    | 'clearview'
    | 'cts'
    | 'kinetik'
    | 'momentm'
    | 'mtm'
    | 'provide_a_ride'
    | 'tennessee_carriers'
    | 'vectorcare'
    | 'verida'
    | 'welltrans'
  )[];
  isFromCsv?: boolean;
  /** Multiple values may be separated by commas. */
  notTagIn?: string[];
  /** Multiple values may be separated by commas. */
  oneSchemaTemplateIdIn?: (string | null)[];
  /** Multiple values may be separated by commas. */
  oneSchemaTemplateMultiIdIn?: (string | null)[];
  /** Sort trips by an attribute */
  ordering?:
    | 'created_at'
    | 'dropoff_address'
    | 'input_price_cents'
    | 'name'
    | 'payer_name'
    | 'pickup_address'
    | 'scheduled_pickup_at'
    | 'status';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Multiple values may be separated by commas. */
  passengerIn?: string[];
  passengers?: string;
  /** Multiple values may be separated by commas. */
  payerIn?: string[];
  payers?: string;
  /** Multiple values may be separated by commas. */
  pickupMunicipalityIn?: string[];
  /** The manually inputted price of the trip */
  priceMax?: number | null;
  /** The manually inputted price of the trip */
  priceMin?: number | null;
  rangeEnd?: string;
  rangeStart?: string;
  /** A search term. */
  search?: string;
  spaceType?: string;
  /** Multiple values may be separated by commas. */
  spaceTypeIn?: (
    | 'ambulatory'
    | 'broda chair'
    | 'delivery'
    | 'geri chair'
    | 'stretcher'
    | 'stretcher xl'
    | 'wheelchair'
    | 'wheelchair xl'
  )[];
  status?: string;
  /** Multiple values may be separated by commas. */
  statusIn?: (
    | 'assigned'
    | 'at dropoff'
    | 'at pickup'
    | 'canceled'
    | 'completed'
    | 'en route'
    | 'pending'
    | 'rejected'
    | 'requested'
    | 'transporting'
  )[];
  /** Multiple values may be separated by commas. */
  tagIn?: string[];
  tags?: string;
  /** Multiple values may be separated by commas. */
  vehicleIdIn?: string[];
  vehicles?: string;
};
export type InvoicesTripFinderRetrieveApiResponse =
  /** status 200  */ InvoiceTripFinderRead;
export type InvoicesTripFinderRetrieveApiArg = {
  /** A UUID string identifying this trip. */
  id: string;
};
export type LocationsAddressesListApiResponse =
  /** status 200  */ PaginatedAddressListRead;
export type LocationsAddressesListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type LocationsAddressesRetrieveApiResponse =
  /** status 200  */ AddressRead;
export type LocationsAddressesRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this address. */
  id: string;
};
export type LocationsCountiesListApiResponse =
  /** status 200  */ PaginatedCountyList;
export type LocationsCountiesListApiArg = {
  'Organization-ID'?: string;
  county?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type LocationsGeolocationsListApiResponse =
  /** status 200  */ PaginatedGeoLocationListRead;
export type LocationsGeolocationsListApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  source?: string;
  /** Multiple values may be separated by commas. */
  sourceIn?: ('broker' | 'other' | 'pin')[];
};
export type LocationsGeolocationsCreateApiResponse =
  /** status 201  */ GeoLocationRead;
export type LocationsGeolocationsCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  geoLocation: GeoLocation;
};
export type LocationsGeolocationsRetrieveApiResponse =
  /** status 200  */ GeoLocationRead;
export type LocationsGeolocationsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  id: string;
};
export type LocationsGeolocationsPartialUpdateApiResponse =
  /** status 200  */ GeoLocationRead;
export type LocationsGeolocationsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  id: string;
  patchedGeoLocation: PatchedGeoLocation;
};
export type LocationsGeolocationsDestroyApiResponse =
  /** status 204 No response body */ void;
export type LocationsGeolocationsDestroyApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  id: string;
};
export type LocationsGeolocationsUndeleteCreateApiResponse =
  /** status 200  */ GeoLocationRead;
export type LocationsGeolocationsUndeleteCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  id: string;
  geoLocation: GeoLocation;
};
export type LocationsLocationLogEntryTripsListApiResponse =
  /** status 200  */ PaginatedLocationLogEntryTripMinimalReadOnlyListRead;
export type LocationsLocationLogEntryTripsListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  tripId: string;
};
export type LocationsLogCreateApiResponse = /** status 201  */ LocationLogEntry;
export type LocationsLogCreateApiArg = {
  'Organization-ID'?: string;
  locationLogEntry: LocationLogEntryWrite;
};
export type LocationsMunicipalitiesRetrieveApiResponse =
  /** status 200  */ MunicipalityList;
export type LocationsMunicipalitiesRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type LocationsPassengerAddressesListApiResponse =
  /** status 200  */ PaginatedPassengerAddressListRead;
export type LocationsPassengerAddressesListApiArg = {
  'Organization-ID'?: string;
  /** Sort passenger addresses by an attribute */
  ordering?: '-id' | '-last_used_at' | 'id' | 'last_used_at';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type LocationsPassengerAddressesCreateApiResponse =
  /** status 201  */ PassengerAddressRead;
export type LocationsPassengerAddressesCreateApiArg = {
  'Organization-ID'?: string;
  passengerAddress: PassengerAddress;
};
export type LocationsPassengerAddressesRetrieveApiResponse =
  /** status 200  */ PassengerAddressRead;
export type LocationsPassengerAddressesRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this passenger address. */
  id: string;
};
export type LocationsPassengerAddressesUpdateApiResponse =
  /** status 200  */ PassengerAddressRead;
export type LocationsPassengerAddressesUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this passenger address. */
  id: string;
  passengerAddress: PassengerAddress;
};
export type LocationsPassengerAddressesPartialUpdateApiResponse =
  /** status 200  */ PassengerAddressRead;
export type LocationsPassengerAddressesPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this passenger address. */
  id: string;
  patchedPassengerAddressRequest: PatchedPassengerAddressRequest;
};
export type LocationsPassengerAddressesDestroyApiResponse =
  /** status 204 No response body */ void;
export type LocationsPassengerAddressesDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this passenger address. */
  id: string;
};
export type LocationsZipcodesListApiResponse =
  /** status 200  */ PaginatedZipCodeList;
export type LocationsZipcodesListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  zipcode?: string;
};
export type MembersListApiResponse =
  /** status 200  */ PaginatedMembershipListRead;
export type MembersListApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  isAttendant?: boolean;
  isBambiStaff?: boolean;
  isDriver?: boolean;
  /** Sort members by an attribute */
  ordering?: 'email' | 'first_name' | 'phone_number' | 'role';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  role?:
    | 'admin'
    | 'associate'
    | 'bambi'
    | 'dispatcher'
    | 'facility admin'
    | 'facility user'
    | 'integration'
    | 'owner'
    | 'restricted support';
  /** A search term. */
  search?: string;
};
export type MembersCreateApiResponse = /** status 201  */ MembershipRead;
export type MembersCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  membership: MembershipWrite;
};
export type MembersRetrieveApiResponse = /** status 200  */ MembershipRead;
export type MembersRetrieveApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this membership. */
  id: string;
};
export type MembersPartialUpdateApiResponse = /** status 200  */ MembershipRead;
export type MembersPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this membership. */
  id: string;
  patchedMembership: PatchedMembershipWrite;
};
export type MembersDestroyApiResponse = /** status 204 No response body */ void;
export type MembersDestroyApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this membership. */
  id: string;
};
export type MembersUndeleteCreateApiResponse =
  /** status 200  */ MembershipRead;
export type MembersUndeleteCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this membership. */
  id: string;
  membership: MembershipWrite;
};
export type MembersUpdateEmailCreateApiResponse =
  /** status 200  */ MembershipRead;
export type MembersUpdateEmailCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this membership. */
  id: string;
  updateEmail: UpdateEmail;
};
export type MessagesListApiResponse =
  /** status 200  */ PaginatedMessageListRead;
export type MessagesListApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type MessagesCreateApiResponse = /** status 201  */ MessageRead;
export type MessagesCreateApiArg = {
  message: Message;
};
export type MessagesRetrieveApiResponse = /** status 200  */ MessageRead;
export type MessagesRetrieveApiArg = {
  /** A UUID string identifying this message. */
  id: string;
};
export type MessagesTripMessagesListApiResponse =
  /** status 200  */ PaginatedTripMessageListRead;
export type MessagesTripMessagesListApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  tripId?: string;
};
export type MessagesTripMessagesCreateApiResponse =
  /** status 201  */ TripMessageRead;
export type MessagesTripMessagesCreateApiArg = {
  tripMessage: TripMessageWrite;
};
export type MessagesTripMessagesRetrieveApiResponse =
  /** status 200  */ TripMessageRead;
export type MessagesTripMessagesRetrieveApiArg = {
  tripId: string;
};
export type MessagesWebHookMessageUpdateCreateApiResponse =
  /** status 200  */ MessageRead;
export type MessagesWebHookMessageUpdateCreateApiArg = {
  message: Message;
};
export type MobileAppSettingsRetrieveApiResponse =
  /** status 200  */ MobileAppSettings;
export type MobileAppSettingsRetrieveApiArg = {
  'User-Agent': string;
};
export type MobileAppSettingsPartialUpdateApiResponse =
  /** status 200  */ MobileAppSettings;
export type MobileAppSettingsPartialUpdateApiArg = {
  'User-Agent': string;
  patchedMobileAppSettings: PatchedMobileAppSettings;
};
export type OrganizationBillingStatusRetrieveApiResponse =
  /** status 200  */ OrganizationBillingStatusRead;
export type OrganizationBillingStatusRetrieveApiArg = void;
export type OrganizationSettingsRetrieveApiResponse =
  /** status 200  */ OrganizationSettingsRead;
export type OrganizationSettingsRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type OrganizationSettingsPartialUpdateApiResponse =
  /** status 200  */ OrganizationSettingsRead;
export type OrganizationSettingsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  patchedOrganizationSettings: PatchedOrganizationSettings;
};
export type OrganizationSettingsConnectMerchantAccountCreateApiResponse =
  /** status 200  */ OrganizationMerchantAccountOnboarding;
export type OrganizationSettingsConnectMerchantAccountCreateApiArg = {
  'Organization-ID'?: string;
};
export type OrganizationSettingsLogoRetrieveApiResponse =
  /** status 200  */ OrganizationSettingsLogo;
export type OrganizationSettingsLogoRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type PartnersOauth2TokenCreateApiResponse =
  /** status 200  */ PartnersOAuthTokenRead;
export type PartnersOauth2TokenCreateApiArg = {
  partnersOAuthToken: PartnersOAuthTokenWrite;
};
export type PartnersOrganizationsListApiResponse =
  /** status 200  */ PaginatedPartnerOrganizationListRead;
export type PartnersOrganizationsListApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type PartnersOrganizationsPayersListApiResponse =
  /** status 200  */ PaginatedPartnerPayerOrganizationListRead;
export type PartnersOrganizationsPayersListApiArg = {
  organizationId: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type PartnersOrganizationsTripsListApiResponse =
  /** status 200  */ PaginatedPartnerTripReadListRead;
export type PartnersOrganizationsTripsListApiArg = {
  /** ID of the organization. */
  organizationId: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type PartnersOrganizationsTripsCreateApiResponse =
  /** status 201  */ PartnerTripCreateRead;
export type PartnersOrganizationsTripsCreateApiArg = {
  /** ID of the organization. */
  organizationId: string;
  partnerTripCreate: PartnerTripCreateWrite;
};
export type PartnersOrganizationsTripsRetrieveApiResponse =
  /** status 200  */ PartnerTripReadRead;
export type PartnersOrganizationsTripsRetrieveApiArg = {
  /** ID of the trip. */
  id: string;
  /** ID of the organization. */
  organizationId: string;
};
export type PartnersOrganizationsTripsActivateWillCallCreateApiResponse =
  /** status 200  */ PartnerTripActivateWillCall;
export type PartnersOrganizationsTripsActivateWillCallCreateApiArg = {
  /** ID of the trip. */
  id: string;
  /** ID of the organization. */
  organizationId: string;
  partnerTripActivateWillCall: PartnerTripActivateWillCallWrite;
};
export type PartnersOrganizationsTripsCancelCreateApiResponse =
  /** status 200  */ PartnerTripCancel;
export type PartnersOrganizationsTripsCancelCreateApiArg = {
  /** ID of the trip. */
  id: string;
  /** ID of the organization. */
  organizationId: string;
  partnerTripCancel: PartnerTripCancelWrite;
};
export type PassengerTagsListApiResponse =
  /** status 200  */ PaginatedPassengerTagListRead;
export type PassengerTagsListApiArg = {
  'Organization-ID'?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type PassengerTagsCreateApiResponse =
  /** status 201  */ PassengerTagBulkCreateRead;
export type PassengerTagsCreateApiArg = {
  'Organization-ID'?: string;
  passengerTagBulkCreate: PassengerTagBulkCreate;
};
export type PassengerTagsRetrieveApiResponse =
  /** status 200  */ PassengerTagRead;
export type PassengerTagsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this passenger tag. */
  id: string;
};
export type PassengerTagsDestroyApiResponse =
  /** status 204 No response body */ void;
export type PassengerTagsDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this passenger tag. */
  id: string;
};
export type PassengersListApiResponse =
  /** status 200  */ PaginatedPassengerListRead;
export type PassengersListApiArg = {
  'Organization-ID'?: string;
  allowSmsMessage?: boolean;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  gender?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type PassengersCreateApiResponse = /** status 201  */ PassengerRead;
export type PassengersCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  passenger: Passenger;
};
export type PassengersAlternateIdentifiersListApiResponse =
  /** status 200  */ PaginatedPassengerAlternateIdentifierListRead;
export type PassengersAlternateIdentifiersListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  passengerId: string;
};
export type PassengersAlternateIdentifiersCreateApiResponse =
  /** status 201  */ PassengerAlternateIdentifierRead;
export type PassengersAlternateIdentifiersCreateApiArg = {
  'Organization-ID'?: string;
  passengerId: string;
  passengerAlternateIdentifier: PassengerAlternateIdentifier;
};
export type PassengersAlternateIdentifiersRetrieveApiResponse =
  /** status 200  */ PassengerAlternateIdentifierRead;
export type PassengersAlternateIdentifiersRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
  passengerId: string;
};
export type PassengersAlternateIdentifiersPartialUpdateApiResponse =
  /** status 200  */ PassengerAlternateIdentifierRead;
export type PassengersAlternateIdentifiersPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  passengerId: string;
  patchedPassengerAlternateIdentifier: PatchedPassengerAlternateIdentifier;
};
export type PassengersAlternateIdentifiersDestroyApiResponse =
  /** status 204 No response body */ void;
export type PassengersAlternateIdentifiersDestroyApiArg = {
  'Organization-ID'?: string;
  id: string;
  passengerId: string;
};
export type PassengersPreferredDriversListApiResponse =
  /** status 200  */ PaginatedPreferredDriverListRead;
export type PassengersPreferredDriversListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  passengerId: string;
};
export type PassengersPreferredDriversCreateApiResponse =
  /** status 201  */ PreferredDriverRead;
export type PassengersPreferredDriversCreateApiArg = {
  'Organization-ID'?: string;
  passengerId: string;
  preferredDriver: PreferredDriver;
};
export type PassengersPreferredDriversRetrieveApiResponse =
  /** status 200  */ PreferredDriverRead;
export type PassengersPreferredDriversRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
  passengerId: string;
};
export type PassengersPreferredDriversPartialUpdateApiResponse =
  /** status 200  */ PreferredDriverRead;
export type PassengersPreferredDriversPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  passengerId: string;
  patchedPreferredDriver: PatchedPreferredDriver;
};
export type PassengersPreferredDriversDestroyApiResponse =
  /** status 204 No response body */ void;
export type PassengersPreferredDriversDestroyApiArg = {
  'Organization-ID'?: string;
  id: string;
  passengerId: string;
};
export type PassengersRetrieveApiResponse = /** status 200  */ PassengerRead;
export type PassengersRetrieveApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this passenger. */
  id: string;
};
export type PassengersPartialUpdateApiResponse =
  /** status 200  */ PassengerRead;
export type PassengersPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this passenger. */
  id: string;
  patchedPassenger: PatchedPassenger;
};
export type PassengersDestroyApiResponse =
  /** status 204 No response body */ void;
export type PassengersDestroyApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this passenger. */
  id: string;
};
export type PassengersRecentAddressesListApiResponse =
  /** status 200  */ PaginatedPassengerAddressListRead;
export type PassengersRecentAddressesListApiArg = {
  'Organization-ID'?: string;
  id: string;
  maxResults?: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type PassengersRecentPayersListApiResponse =
  /** status 200  */ PaginatedPayerPassengerListRead;
export type PassengersRecentPayersListApiArg = {
  'Organization-ID'?: string;
  id: string;
  maxResults?: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type PassengersUndeleteCreateApiResponse =
  /** status 204 Passenger undeleted */ void;
export type PassengersUndeleteCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this passenger. */
  id: string;
  passenger: Passenger;
};
export type PassengersDuplicatesListApiResponse =
  /** status 200  */ PaginatedPassengerDuplicateListRead;
export type PassengersDuplicatesListApiArg = {
  'Organization-ID'?: string;
  createdAtEnd?: string;
  createdAtStart?: string;
  firstNameStartsWith?: string;
  lastNameStartsWith?: string;
  /** fields to exactly match on when looking for duplicates */
  matchFields?: (
    | 'dob'
    | 'email'
    | 'first_name'
    | 'gender'
    | 'last_name'
    | 'phone_number'
    | 'weight'
  )[];
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Multiple values may be separated by commas. */
  passengerIn?: string[];
};
export type PassengersExportRetrieveApiResponse = /** status 200  */ Blob;
export type PassengersExportRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type PassengersMergeCreateApiResponse =
  /** status 200  */ PassengerMergeResultRead;
export type PassengersMergeCreateApiArg = {
  'Organization-ID'?: string;
  passengerMergeRequest: PassengerMergeRequest;
};
export type PayerSettingsListApiResponse =
  /** status 200  */ PaginatedPayerOrganizationSettingsListRead;
export type PayerSettingsListApiArg = {
  'Organization-ID'?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type PayerSettingsRetrieveApiResponse =
  /** status 200  */ PayerOrganizationSettingsRead;
export type PayerSettingsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this Payer Organization Settings. */
  id: string;
};
export type PayerSettingsPartialUpdateApiResponse =
  /** status 200  */ PayerOrganizationSettingsRead;
export type PayerSettingsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this Payer Organization Settings. */
  id: string;
  patchedPayerOrganizationSettings: PatchedPayerOrganizationSettings;
};
export type PayerinfoListApiResponse =
  /** status 200  */ PaginatedPayerInfoListRead;
export type PayerinfoListApiArg = {
  'Organization-ID'?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type PayerinfoRetrieveApiResponse = /** status 200  */ PayerInfoRead;
export type PayerinfoRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this payer info. */
  id: string;
};
export type PayerinfooneschematemplateListApiResponse =
  /** status 200  */ PaginatedPayerInfoOneSchemaTemplateListRead;
export type PayerinfooneschematemplateListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type PayersListApiResponse =
  /** status 200  */ PaginatedPayerOrganizationListRead;
export type PayersListApiArg = {
  'Organization-ID'?: string;
  canMultiload?: boolean;
  id?: string;
  isActive?: boolean;
  /** Sort payers by an attribute */
  ordering?:
    | 'billing_email'
    | 'billing_phone_number'
    | 'display_name'
    | 'email'
    | 'phone_number'
    | 'website';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  payerSettingsAllowOnlySpecificDrivers?: boolean;
  payerSettingsAllowOnlySpecificVehicles?: boolean;
  /** A search term. */
  search?: string;
};
export type PayersCreateApiResponse = /** status 201  */ PayerOrganizationRead;
export type PayersCreateApiArg = {
  'Organization-ID'?: string;
  payerOrganization: PayerOrganization;
};
export type PayersDriversListApiResponse =
  /** status 200  */ PaginatedPayerOrganizationDriverListRead;
export type PayersDriversListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  payerOrganizationId: string;
};
export type PayersDriversCreateApiResponse =
  /** status 201  */ PayerOrganizationDriverRead;
export type PayersDriversCreateApiArg = {
  'Organization-ID'?: string;
  payerOrganizationId: string;
  payerOrganizationDriver: PayerOrganizationDriverWrite;
};
export type PayersPassengersRetrieveApiResponse =
  /** status 200  */ PayerPassengerRead;
export type PayersPassengersRetrieveApiArg = {
  'Organization-ID'?: string;
  passengerId: string;
  payerOrganizationId: string;
};
export type PayersPassengersCreateApiResponse =
  /** status 201  */ PayerPassengerRead;
export type PayersPassengersCreateApiArg = {
  'Organization-ID'?: string;
  passengerId: string;
  payerOrganizationId: string;
  payerPassenger: PayerPassenger;
};
export type PayersPassengersPartialUpdateApiResponse =
  /** status 200  */ PayerPassengerRead;
export type PayersPassengersPartialUpdateApiArg = {
  'Organization-ID'?: string;
  passengerId: string;
  payerOrganizationId: string;
  patchedPayerPassenger: PatchedPayerPassenger;
};
export type PayersPassengersDestroyApiResponse =
  /** status 204 No response body */ void;
export type PayersPassengersDestroyApiArg = {
  'Organization-ID'?: string;
  passengerId: string;
  payerOrganizationId: string;
};
export type PayersSettingsRetrieveApiResponse =
  /** status 200  */ PayerOrganizationSettingsRead;
export type PayersSettingsRetrieveApiArg = {
  'Organization-ID'?: string;
  payerOrganizationId: string;
};
export type PayersSettingsPartialUpdateApiResponse =
  /** status 200  */ PayerOrganizationSettingsRead;
export type PayersSettingsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  payerOrganizationId: string;
  patchedPayerOrganizationSettings: PatchedPayerOrganizationSettings;
};
export type PayersVehiclesListApiResponse =
  /** status 200  */ PaginatedPayerOrganizationVehicleListRead;
export type PayersVehiclesListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  payerOrganizationId: string;
};
export type PayersVehiclesCreateApiResponse =
  /** status 201  */ PayerOrganizationVehicleRead;
export type PayersVehiclesCreateApiArg = {
  'Organization-ID'?: string;
  payerOrganizationId: string;
  payerOrganizationVehicle: PayerOrganizationVehicleWrite;
};
export type PayersRetrieveApiResponse =
  /** status 200  */ PayerOrganizationRead;
export type PayersRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this payer organization. */
  id: string;
};
export type PayersPartialUpdateApiResponse =
  /** status 200  */ PayerOrganizationRead;
export type PayersPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this payer organization. */
  id: string;
  patchedPayerOrganization: PatchedPayerOrganization;
};
export type PayersDestroyApiResponse = /** status 204 No response body */ void;
export type PayersDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this payer organization. */
  id: string;
};
export type PayersMultiloadingPartnersRetrieveApiResponse =
  /** status 200  */ OnlyMultiloadingPartners;
export type PayersMultiloadingPartnersRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this payer organization. */
  id: string;
};
export type PayersListSelectedApiResponse =
  /** status 200  */ PaginatedPayerOrganizationListRead;
export type PayersListSelectedApiArg = {
  'Organization-ID'?: string;
  canMultiload?: boolean;
  id?: string;
  isActive?: boolean;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  payerSettingsAllowOnlySpecificDrivers?: boolean;
  payerSettingsAllowOnlySpecificVehicles?: boolean;
  /** A search term. */
  search?: string;
  payerFilters: PayerFilters;
};
export type PayersandtemplatesRetrieveApiResponse =
  /** status 200  */ PayerWithTemplatesResponseRead;
export type PayersandtemplatesRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type PayerstemplatesListApiResponse =
  /** status 200  */ PaginatedPayerWithTemplatesListRead;
export type PayerstemplatesListApiArg = {
  'Organization-ID'?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type PayerstemplatesRetrieveApiResponse =
  /** status 200  */ PayerWithTemplatesRead;
export type PayerstemplatesRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this payer organization. */
  id: string;
};
export type PricingPriceQuoteCreateApiResponse =
  /** status 201  */ PriceQuoteRead;
export type PricingPriceQuoteCreateApiArg = {
  'Organization-ID'?: string;
  priceQuote: PriceQuote;
};
export type PricingPricingSchemeConflictsCreateApiResponse =
  /** status 200  */ PriceSchemeConflictResults;
export type PricingPricingSchemeConflictsCreateApiArg = {
  'Organization-ID'?: string;
  priceSchemeConflict: PriceSchemeConflictWrite;
};
export type PricingPricingSchemesListApiResponse =
  /** status 200  */ PaginatedPricingSchemeListRead;
export type PricingPricingSchemesListApiArg = {
  'Organization-ID'?: string;
  /** Sort pricing schemes by an attribute */
  ordering?:
    | 'base_fee_cents'
    | 'created_at'
    | 'description'
    | 'end_date'
    | 'loaded_mileage_rate_cents'
    | 'name'
    | 'start_date'
    | 'updated_at';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Multiple values may be separated by commas. */
  payerIn?: string[];
  pricingSchemePayersPayerId?: string;
  /** A search term. */
  search?: string;
  /** Filter by service types (comma-separated) */
  serviceTypeIn?: (
    | 'curb-to-curb'
    | 'door-to-door'
    | 'door-through-door'
    | 'person-to-person'
  )[];
  /** Filter by space types (comma-separated) */
  spaceTypeIn?: (
    | 'wheelchair'
    | 'wheelchair xl'
    | 'broda chair'
    | 'geri chair'
    | 'stretcher'
    | 'stretcher xl'
    | 'ambulatory'
    | 'delivery'
  )[];
};
export type PricingPricingSchemesCreateApiResponse =
  /** status 201  */ PricingSchemeRead;
export type PricingPricingSchemesCreateApiArg = {
  'Organization-ID'?: string;
  pricingScheme: PricingSchemeWrite;
};
export type PricingPricingSchemesRetrieveApiResponse =
  /** status 200  */ PricingSchemeRead;
export type PricingPricingSchemesRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type PricingPricingSchemesPartialUpdateApiResponse =
  /** status 200  */ PricingSchemeRead;
export type PricingPricingSchemesPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedPricingScheme: PatchedPricingSchemeWrite;
};
export type PricingPricingSchemesDestroyApiResponse =
  /** status 204 No response body */ void;
export type PricingPricingSchemesDestroyApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type ProfileRetrieveApiResponse = /** status 200  */ UserProfileRead;
export type ProfileRetrieveApiArg = void;
export type ReportsCustomReportsListApiResponse =
  /** status 200  */ PaginatedCustomReportListRead;
export type ReportsCustomReportsListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type ReportsCustomReportsCreateApiResponse =
  /** status 201  */ CustomReportRead;
export type ReportsCustomReportsCreateApiArg = {
  'Organization-ID'?: string;
  customReport: CustomReport;
};
export type ReportsCustomReportsRetrieveApiResponse =
  /** status 200  */ CustomReportRead;
export type ReportsCustomReportsRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type ReportsCustomReportsPartialUpdateApiResponse =
  /** status 200  */ CustomReportRead;
export type ReportsCustomReportsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedCustomReport: PatchedCustomReport;
};
export type ReportsCustomReportsDestroyApiResponse =
  /** status 204 No response body */ void;
export type ReportsCustomReportsDestroyApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type ReportsTripsLoadedMileageCountCreateApiResponse =
  /** status 200  */ TripLoadedMileageResultsRead[];
export type ReportsTripsLoadedMileageCountCreateApiArg = {
  'Organization-ID'?: string;
  tripLoadedMileageRequest: TripLoadedMileageRequest;
};
export type ReportsTripsOnTimeCountCreateApiResponse =
  /** status 200  */ TripOnTimeResultsRead[];
export type ReportsTripsOnTimeCountCreateApiArg = {
  'Organization-ID'?: string;
  tripOnTimeRequest: TripOnTimeRequest;
};
export type ReportsTripsRevenueCountCreateApiResponse =
  /** status 200  */ TripRevenueResultsRead[];
export type ReportsTripsRevenueCountCreateApiArg = {
  'Organization-ID'?: string;
  tripRevenueRequest: TripRevenueRequest;
};
export type ReportsTripsStatusCountCreateApiResponse =
  /** status 200  */ TripStatusCountResultsRead[];
export type ReportsTripsStatusCountCreateApiArg = {
  'Organization-ID'?: string;
  tripStatusCountRequest: TripStatusCountRequest;
};
export type RunBambiRunCreateApiResponse = /** status 201  */ RunBambiRunRead;
export type RunBambiRunCreateApiArg = {
  'Organization-ID'?: string;
  runBambiRun: RunBambiRunWrite;
};
export type RunBambiRunRetrieveApiResponse =
  /** status 200  */ RunBambiRunTaskRead;
export type RunBambiRunRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type RunBambiRunApplyCreateApiResponse =
  /** status 200  */ RunBambiRunApply;
export type RunBambiRunApplyCreateApiArg = {
  'Organization-ID'?: string;
  id: string;
  runBambiRunApply: RunBambiRunApplyWrite;
};
export type SignaturesListApiResponse =
  /** status 200  */ PaginatedSignatureListRead;
export type SignaturesListApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type SignaturesCreateApiResponse = /** status 201  */ SignatureRead;
export type SignaturesCreateApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  signature: Signature;
};
export type SignaturesRetrieveApiResponse = /** status 200  */ SignatureRead;
export type SignaturesRetrieveApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  /** A UUID string identifying this signature. */
  id: string;
};
export type SignaturesDestroyApiResponse =
  /** status 204 No response body */ void;
export type SignaturesDestroyApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  /** A UUID string identifying this signature. */
  id: string;
};
export type TagsListApiResponse = /** status 200  */ PaginatedTagListRead;
export type TagsListApiArg = {
  'Organization-ID'?: string;
  /** Sort tags by an attribute */
  ordering?: 'created_at' | 'tag_name' | 'updated_at';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type TagsCreateApiResponse = /** status 201  */ TagRead;
export type TagsCreateApiArg = {
  'Organization-ID'?: string;
  tag: Tag;
};
export type TagsRetrieveApiResponse = /** status 200  */ TagRead;
export type TagsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this tag. */
  id: string;
};
export type TagsPartialUpdateApiResponse = /** status 200  */ TagRead;
export type TagsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this tag. */
  id: string;
  patchedTag: PatchedTag;
};
export type TagsDestroyApiResponse = /** status 204 No response body */ void;
export type TagsDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this tag. */
  id: string;
};
export type TilledPaymentMethodRetrieveApiResponse =
  /** status 200  */ TilledListPaymentMethodsTilledResponse;
export type TilledPaymentMethodRetrieveApiArg = {
  'Organization-ID'?: string;
  payerId: string;
  payerType: 'passenger' | 'payer_organization';
};
export type TilledPaymentMethodCreateApiResponse =
  /** status 200  */ TilledCustomer;
export type TilledPaymentMethodCreateApiArg = {
  'Organization-ID'?: string;
  tilledPaymentMethodInput: TilledPaymentMethodInput;
};
export type TilledPaymentMethodDestroyApiResponse =
  /** status 204 No response body */ void;
export type TilledPaymentMethodDestroyApiArg = {
  'Organization-ID'?: string;
  paymentMethodId: string;
};
export type TilledPaymentMethodPartialUpdateApiResponse =
  /** status 200  */ TilledCustomer;
export type TilledPaymentMethodPartialUpdateApiArg = {
  paymentMethodId: string;
  patchedTilledPaymentMethodBillingDetails: PatchedTilledPaymentMethodBillingDetails;
};
export type TilledPaymentMethodVerifyRetrieveApiResponse =
  /** status 200  */ TilledPaymentMethodVerifyResponseRead;
export type TilledPaymentMethodVerifyRetrieveApiArg = {
  'Organization-ID'?: string;
  paymentMethodId: string;
};
export type TilledPaymentMethodVerifyCreateApiResponse =
  /** status 200  */ TilledPaymentMethodVerifyRequest;
export type TilledPaymentMethodVerifyCreateApiArg = {
  'Organization-ID'?: string;
  paymentMethodId: string;
  tilledPaymentMethodVerifyRequest: TilledPaymentMethodVerifyRequest;
};
export type TilledPayoutsListApiResponse =
  /** status 200  */ PaginatedTilledPayoutReadOnlyListRead;
export type TilledPayoutsListApiArg = {
  'Organization-ID'?: string;
  invoiceNumber?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  paidAtAfter?: string;
  paidAtBefore?: string;
  selectedInvoices?: string;
};
export type TilledPayoutsExportCreateApiResponse = /** status 200  */ Blob;
export type TilledPayoutsExportCreateApiArg = {
  'Organization-ID'?: string;
  invoiceNumber?: string;
  paidAtAfter?: string;
  paidAtBefore?: string;
  selectedInvoices?: string;
  tilledPayoutExport: TilledPayoutExport;
};
export type TilledResourceLinkCreateApiResponse =
  /** status 200  */ TilledAuthLink;
export type TilledResourceLinkCreateApiArg = {
  'Organization-ID'?: string;
  tilledResourceLink: TilledResourceLink;
};
export type TilledWebhookCreateApiResponse =
  /** status 200  */ TilledWebHookEnvelope;
export type TilledWebhookCreateApiArg = {
  'Organization-ID'?: string;
  tilledWebHookEnvelope: TilledWebHookEnvelope;
};
export type TokensChatIssueRetrieveApiResponse = /** status 200  */ ChatTokens;
export type TokensChatIssueRetrieveApiArg = {
  'Organization-ID'?: string;
};
export type TokensPushRegisterCreateApiResponse =
  /** status 200  */ PushTokensRead;
export type TokensPushRegisterCreateApiArg = {
  'Organization-ID'?: string;
  'User-Agent': string;
  pushTokens: PushTokens;
};
export type TokensPushRevokeCreateApiResponse =
  /** status 200  */ PushTokensRead;
export type TokensPushRevokeCreateApiArg = {
  'Organization-ID'?: string;
  'User-Agent': string;
  pushTokens: PushTokens;
};
export type TripImportCreateApiResponse =
  /** status 201  */ TripImportAsyncRead;
export type TripImportCreateApiArg = {
  'Organization-ID'?: string;
  tripImportAsyncRequest: TripImportAsyncRequestWrite;
};
export type TripImportRetrieveApiResponse =
  /** status 200  */ TripImportTaskRead;
export type TripImportRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripRequestEmbedListApiResponse =
  /** status 200  */ PaginatedTripRequestEmbedListRead;
export type TripRequestEmbedListApiArg = {
  'Organization-ID'?: string;
  isActive?: boolean;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type TripRequestEmbedCreateApiResponse =
  /** status 201  */ TripRequestEmbedRead;
export type TripRequestEmbedCreateApiArg = {
  'Organization-ID'?: string;
  tripRequestEmbed: TripRequestEmbed;
};
export type TripRequestEmbedRetrieveApiResponse =
  /** status 200  */ TripRequestEmbedRead;
export type TripRequestEmbedRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripRequestEmbedPartialUpdateApiResponse =
  /** status 200  */ TripRequestEmbedRead;
export type TripRequestEmbedPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripRequestEmbed: PatchedTripRequestEmbed;
};
export type TripRequestEmbedDestroyApiResponse =
  /** status 204 No response body */ void;
export type TripRequestEmbedDestroyApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripTagsListApiResponse =
  /** status 200  */ PaginatedTripTagListRead;
export type TripTagsListApiArg = {
  'Organization-ID'?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type TripTagsCreateApiResponse =
  /** status 201  */ TripTagBulkCreateRead;
export type TripTagsCreateApiArg = {
  'Organization-ID'?: string;
  tripTagBulkCreate: TripTagBulkCreate;
};
export type TripTagsRetrieveApiResponse = /** status 200  */ TripTagRead;
export type TripTagsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this trip tag. */
  id: string;
};
export type TripTagsDestroyApiResponse =
  /** status 204 No response body */ void;
export type TripTagsDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this trip tag. */
  id: string;
};
export type VehicleTagsListApiResponse =
  /** status 200  */ PaginatedVehicleTagListRead;
export type VehicleTagsListApiArg = {
  'Organization-ID'?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type VehicleTagsCreateApiResponse =
  /** status 201  */ VehicleTagBulkCreateRead;
export type VehicleTagsCreateApiArg = {
  'Organization-ID'?: string;
  vehicleTagBulkCreate: VehicleTagBulkCreate;
};
export type VehicleTagsRetrieveApiResponse = /** status 200  */ VehicleTagRead;
export type VehicleTagsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this vehicle tag. */
  id: string;
};
export type VehicleTagsDestroyApiResponse =
  /** status 204 No response body */ void;
export type VehicleTagsDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this vehicle tag. */
  id: string;
};
export type VehiclesListApiResponse =
  /** status 200  */ PaginatedVehicleListRead;
export type VehiclesListApiArg = {
  'Organization-ID'?: string;
  canBeScheduled?: boolean;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  /** Multiple values may be separated by commas. */
  tagIn?: string[];
  tags?: string;
};
export type VehiclesCreateApiResponse = /** status 201  */ VehicleRead;
export type VehiclesCreateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  vehicle: VehicleWrite;
};
export type VehiclesRetrieveApiResponse = /** status 200  */ VehicleRead;
export type VehiclesRetrieveApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this vehicle. */
  id: string;
};
export type VehiclesPartialUpdateApiResponse = /** status 200  */ VehicleRead;
export type VehiclesPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this vehicle. */
  id: string;
  patchedVehicle: PatchedVehicleWrite;
};
export type VehiclesDestroyApiResponse =
  /** status 204 No response body */ void;
export type VehiclesDestroyApiArg = {
  'Organization-ID'?: string;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** A UUID string identifying this vehicle. */
  id: string;
};
export type VehiclesPayersListApiResponse =
  /** status 200  */ PaginatedVehiclePayerOrganizationListRead;
export type VehiclesPayersListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  vehicleId: string;
};
export type VehiclesPayersCreateApiResponse =
  /** status 201  */ VehiclePayerOrganizationRead;
export type VehiclesPayersCreateApiArg = {
  'Organization-ID'?: string;
  vehicleId: string;
  vehiclePayerOrganization: VehiclePayerOrganizationWrite;
};
export type VehiclesInspectionCreateApiResponse =
  /** status 201  */ VehicleInspectionReportRead;
export type VehiclesInspectionCreateApiArg = {
  'Organization-ID'?: string;
  vehicleInspectionReport: VehicleInspectionReportWrite;
};
export type VehiclesInspectionFieldsListApiResponse =
  /** status 200  */ PaginatedVehicleInspectionFieldList;
export type VehiclesInspectionFieldsListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type VehiclesInspectionsListApiResponse =
  /** status 200  */ PaginatedVehicleInspectionReportDetailsListRead;
export type VehiclesInspectionsListApiArg = {
  'Organization-ID'?: string;
  assignment?: string;
  createdAt?: string;
  hasFail?: boolean;
  membership?: string;
  /** Multiple values may be separated by commas. */
  membershipIn?: string[];
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  rangeEnd?: string;
  rangeStart?: string;
  vehicle?: string;
  /** Multiple values may be separated by commas. */
  vehicleIn?: string[];
};
export type VehiclesInspectionsRetrieveApiResponse =
  /** status 200  */ VehicleInspectionReportExtraDetailsRead;
export type VehiclesInspectionsRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type VehiclesInspectionsExportRetrieveApiResponse =
  /** status 200  */ Blob;
export type VehiclesInspectionsExportRetrieveApiArg = {
  'Organization-ID'?: string;
  assignment?: string;
  createdAt?: string;
  hasFail?: boolean;
  membership?: string;
  /** Multiple values may be separated by commas. */
  membershipIn?: string[];
  rangeEnd?: string;
  rangeStart?: string;
  vehicle?: string;
  /** Multiple values may be separated by commas. */
  vehicleIn?: string[];
};
export type VehiclesListSelectedApiResponse =
  /** status 200  */ PaginatedVehicleListRead;
export type VehiclesListSelectedApiArg = {
  'Organization-ID'?: string;
  canBeScheduled?: boolean;
  /** Include deleted objects in the response, or only deleted objects in the response. */
  deletedObjects?: 'include' | 'only';
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  /** Multiple values may be separated by commas. */
  tagIn?: string[];
  tags?: string;
  vehicleFilters: VehicleFilters;
};
export type Attendant = {
  can_be_scheduled?: boolean;
  membership: string;
};
export type AttendantSkills = {
  id?: string;
  can_do_wheelchair_service?: boolean;
  can_do_wheelchair_xl_service?: boolean;
  can_do_broda_chair_service?: boolean;
  can_do_geri_chair_service?: boolean;
  can_do_stretcher_service?: boolean;
  can_do_stretcher_xl_service?: boolean;
  can_do_delivery_service?: boolean;
  can_do_ambulatory_service?: boolean;
  can_do_curb_to_curb?: boolean;
  can_do_door_to_door?: boolean;
  can_do_door_through_door?: boolean;
  can_do_person_to_person?: boolean;
  can_do_bariatric?: boolean;
  can_do_stairs?: boolean;
  can_do_student_transport?: boolean;
};
export type AttendantSkillsWrite = {
  id?: string;
  attendant: string;
  can_do_wheelchair_service?: boolean;
  can_do_wheelchair_xl_service?: boolean;
  can_do_broda_chair_service?: boolean;
  can_do_geri_chair_service?: boolean;
  can_do_stretcher_service?: boolean;
  can_do_stretcher_xl_service?: boolean;
  can_do_delivery_service?: boolean;
  can_do_ambulatory_service?: boolean;
  can_do_curb_to_curb?: boolean;
  can_do_door_to_door?: boolean;
  can_do_door_through_door?: boolean;
  can_do_person_to_person?: boolean;
  can_do_bariatric?: boolean;
  can_do_stairs?: boolean;
  can_do_student_transport?: boolean;
};
export type AttendantRead = {
  id: string;
  can_be_scheduled?: boolean;
  membership: string;
  organization_id: string;
  first_name: string;
  last_name: string;
  role: string;
  skills: AttendantSkills | null;
  deleted_at: string | null;
};
export type AttendantWrite = {
  can_be_scheduled?: boolean;
  membership: string;
};
export type PaginatedAttendantList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Attendant[];
};
export type PaginatedAttendantListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AttendantRead[];
};
export type PaginatedAttendantListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AttendantWrite[];
};
export type ValidationErrorEnum = 'validation_error';
export type AttendantsListIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null_characters_not_allowed';
  detail: string;
};
export type AttendantsListError = {
  attr: 'id';
} & AttendantsListIdErrorComponent;
export type AttendantsListValidationError = {
  type: ValidationErrorEnum;
  errors: AttendantsListError[];
};
export type ClientErrorEnum = 'client_error';
export type ParseErrorCodeEnum = 'parse_error';
export type ParseError = {
  code: ParseErrorCodeEnum;
  detail: string;
  attr: string | null;
};
export type ParseErrorResponse = {
  type: ClientErrorEnum;
  errors: ParseError[];
};
export type AttendantsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AttendantsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type ErrorCode403Enum = 'permission_denied';
export type Error403 = {
  code: ErrorCode403Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse403 = {
  type: ClientErrorEnum;
  errors: Error403[];
};
export type ErrorCode404Enum = 'not_found';
export type Error404 = {
  code: ErrorCode404Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse404 = {
  type: ClientErrorEnum;
  errors: Error404[];
};
export type AttendantsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type AttendantsCreateCanBeScheduledErrorComponent = {
  attr: 'can_be_scheduled';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateMembershipErrorComponent = {
  attr: 'membership';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required' | 'unique';
  detail: string;
};
export type AttendantsCreateSkillsIdErrorComponent = {
  attr: 'skills.id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type AttendantsCreateSkillsAttendantErrorComponent = {
  attr: 'skills.attendant';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AttendantsCreateSkillsCanDoWheelchairServiceErrorComponent = {
  attr: 'skills.can_do_wheelchair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoWheelchairXlServiceErrorComponent = {
  attr: 'skills.can_do_wheelchair_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoBrodaChairServiceErrorComponent = {
  attr: 'skills.can_do_broda_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoGeriChairServiceErrorComponent = {
  attr: 'skills.can_do_geri_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoStretcherServiceErrorComponent = {
  attr: 'skills.can_do_stretcher_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoStretcherXlServiceErrorComponent = {
  attr: 'skills.can_do_stretcher_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoDeliveryServiceErrorComponent = {
  attr: 'skills.can_do_delivery_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoAmbulatoryServiceErrorComponent = {
  attr: 'skills.can_do_ambulatory_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoCurbToCurbErrorComponent = {
  attr: 'skills.can_do_curb_to_curb';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoDoorToDoorErrorComponent = {
  attr: 'skills.can_do_door_to_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoDoorThroughDoorErrorComponent = {
  attr: 'skills.can_do_door_through_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoPersonToPersonErrorComponent = {
  attr: 'skills.can_do_person_to_person';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoBariatricErrorComponent = {
  attr: 'skills.can_do_bariatric';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoStairsErrorComponent = {
  attr: 'skills.can_do_stairs';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateSkillsCanDoStudentTransportErrorComponent = {
  attr: 'skills.can_do_student_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsCreateError =
  | ({
      attr: 'non_field_errors';
    } & AttendantsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'can_be_scheduled';
    } & AttendantsCreateCanBeScheduledErrorComponent)
  | ({
      attr: 'membership';
    } & AttendantsCreateMembershipErrorComponent)
  | ({
      attr: 'skills.id';
    } & AttendantsCreateSkillsIdErrorComponent)
  | ({
      attr: 'skills.attendant';
    } & AttendantsCreateSkillsAttendantErrorComponent)
  | ({
      attr: 'skills.can_do_wheelchair_service';
    } & AttendantsCreateSkillsCanDoWheelchairServiceErrorComponent)
  | ({
      attr: 'skills.can_do_wheelchair_xl_service';
    } & AttendantsCreateSkillsCanDoWheelchairXlServiceErrorComponent)
  | ({
      attr: 'skills.can_do_broda_chair_service';
    } & AttendantsCreateSkillsCanDoBrodaChairServiceErrorComponent)
  | ({
      attr: 'skills.can_do_geri_chair_service';
    } & AttendantsCreateSkillsCanDoGeriChairServiceErrorComponent)
  | ({
      attr: 'skills.can_do_stretcher_service';
    } & AttendantsCreateSkillsCanDoStretcherServiceErrorComponent)
  | ({
      attr: 'skills.can_do_stretcher_xl_service';
    } & AttendantsCreateSkillsCanDoStretcherXlServiceErrorComponent)
  | ({
      attr: 'skills.can_do_delivery_service';
    } & AttendantsCreateSkillsCanDoDeliveryServiceErrorComponent)
  | ({
      attr: 'skills.can_do_ambulatory_service';
    } & AttendantsCreateSkillsCanDoAmbulatoryServiceErrorComponent)
  | ({
      attr: 'skills.can_do_curb_to_curb';
    } & AttendantsCreateSkillsCanDoCurbToCurbErrorComponent)
  | ({
      attr: 'skills.can_do_door_to_door';
    } & AttendantsCreateSkillsCanDoDoorToDoorErrorComponent)
  | ({
      attr: 'skills.can_do_door_through_door';
    } & AttendantsCreateSkillsCanDoDoorThroughDoorErrorComponent)
  | ({
      attr: 'skills.can_do_person_to_person';
    } & AttendantsCreateSkillsCanDoPersonToPersonErrorComponent)
  | ({
      attr: 'skills.can_do_bariatric';
    } & AttendantsCreateSkillsCanDoBariatricErrorComponent)
  | ({
      attr: 'skills.can_do_stairs';
    } & AttendantsCreateSkillsCanDoStairsErrorComponent)
  | ({
      attr: 'skills.can_do_student_transport';
    } & AttendantsCreateSkillsCanDoStudentTransportErrorComponent);
export type AttendantsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: AttendantsCreateError[];
};
export type AttendantsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AttendantsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AttendantsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AttendantsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type AttendantsPartialUpdateCanBeScheduledErrorComponent = {
  attr: 'can_be_scheduled';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateMembershipErrorComponent = {
  attr: 'membership';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required' | 'unique';
  detail: string;
};
export type AttendantsPartialUpdateSkillsIdErrorComponent = {
  attr: 'skills.id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type AttendantsPartialUpdateSkillsAttendantErrorComponent = {
  attr: 'skills.attendant';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AttendantsPartialUpdateSkillsCanDoWheelchairServiceErrorComponent =
  {
    attr: 'skills.can_do_wheelchair_service';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AttendantsPartialUpdateSkillsCanDoWheelchairXlServiceErrorComponent =
  {
    attr: 'skills.can_do_wheelchair_xl_service';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AttendantsPartialUpdateSkillsCanDoBrodaChairServiceErrorComponent =
  {
    attr: 'skills.can_do_broda_chair_service';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AttendantsPartialUpdateSkillsCanDoGeriChairServiceErrorComponent = {
  attr: 'skills.can_do_geri_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateSkillsCanDoStretcherServiceErrorComponent = {
  attr: 'skills.can_do_stretcher_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateSkillsCanDoStretcherXlServiceErrorComponent =
  {
    attr: 'skills.can_do_stretcher_xl_service';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AttendantsPartialUpdateSkillsCanDoDeliveryServiceErrorComponent = {
  attr: 'skills.can_do_delivery_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateSkillsCanDoAmbulatoryServiceErrorComponent =
  {
    attr: 'skills.can_do_ambulatory_service';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AttendantsPartialUpdateSkillsCanDoCurbToCurbErrorComponent = {
  attr: 'skills.can_do_curb_to_curb';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateSkillsCanDoDoorToDoorErrorComponent = {
  attr: 'skills.can_do_door_to_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateSkillsCanDoDoorThroughDoorErrorComponent = {
  attr: 'skills.can_do_door_through_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateSkillsCanDoPersonToPersonErrorComponent = {
  attr: 'skills.can_do_person_to_person';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateSkillsCanDoBariatricErrorComponent = {
  attr: 'skills.can_do_bariatric';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateSkillsCanDoStairsErrorComponent = {
  attr: 'skills.can_do_stairs';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateSkillsCanDoStudentTransportErrorComponent = {
  attr: 'skills.can_do_student_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & AttendantsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'can_be_scheduled';
    } & AttendantsPartialUpdateCanBeScheduledErrorComponent)
  | ({
      attr: 'membership';
    } & AttendantsPartialUpdateMembershipErrorComponent)
  | ({
      attr: 'skills.id';
    } & AttendantsPartialUpdateSkillsIdErrorComponent)
  | ({
      attr: 'skills.attendant';
    } & AttendantsPartialUpdateSkillsAttendantErrorComponent)
  | ({
      attr: 'skills.can_do_wheelchair_service';
    } & AttendantsPartialUpdateSkillsCanDoWheelchairServiceErrorComponent)
  | ({
      attr: 'skills.can_do_wheelchair_xl_service';
    } & AttendantsPartialUpdateSkillsCanDoWheelchairXlServiceErrorComponent)
  | ({
      attr: 'skills.can_do_broda_chair_service';
    } & AttendantsPartialUpdateSkillsCanDoBrodaChairServiceErrorComponent)
  | ({
      attr: 'skills.can_do_geri_chair_service';
    } & AttendantsPartialUpdateSkillsCanDoGeriChairServiceErrorComponent)
  | ({
      attr: 'skills.can_do_stretcher_service';
    } & AttendantsPartialUpdateSkillsCanDoStretcherServiceErrorComponent)
  | ({
      attr: 'skills.can_do_stretcher_xl_service';
    } & AttendantsPartialUpdateSkillsCanDoStretcherXlServiceErrorComponent)
  | ({
      attr: 'skills.can_do_delivery_service';
    } & AttendantsPartialUpdateSkillsCanDoDeliveryServiceErrorComponent)
  | ({
      attr: 'skills.can_do_ambulatory_service';
    } & AttendantsPartialUpdateSkillsCanDoAmbulatoryServiceErrorComponent)
  | ({
      attr: 'skills.can_do_curb_to_curb';
    } & AttendantsPartialUpdateSkillsCanDoCurbToCurbErrorComponent)
  | ({
      attr: 'skills.can_do_door_to_door';
    } & AttendantsPartialUpdateSkillsCanDoDoorToDoorErrorComponent)
  | ({
      attr: 'skills.can_do_door_through_door';
    } & AttendantsPartialUpdateSkillsCanDoDoorThroughDoorErrorComponent)
  | ({
      attr: 'skills.can_do_person_to_person';
    } & AttendantsPartialUpdateSkillsCanDoPersonToPersonErrorComponent)
  | ({
      attr: 'skills.can_do_bariatric';
    } & AttendantsPartialUpdateSkillsCanDoBariatricErrorComponent)
  | ({
      attr: 'skills.can_do_stairs';
    } & AttendantsPartialUpdateSkillsCanDoStairsErrorComponent)
  | ({
      attr: 'skills.can_do_student_transport';
    } & AttendantsPartialUpdateSkillsCanDoStudentTransportErrorComponent);
export type AttendantsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: AttendantsPartialUpdateError[];
};
export type AttendantsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AttendantsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedAttendant = {
  can_be_scheduled?: boolean;
  membership?: string;
};
export type PatchedAttendantRead = {
  id?: string;
  can_be_scheduled?: boolean;
  membership?: string;
  organization_id?: string;
  first_name?: string;
  last_name?: string;
  role?: string;
  skills?: AttendantSkills | null;
  deleted_at?: string | null;
};
export type PatchedAttendantWrite = {
  can_be_scheduled?: boolean;
  membership?: string;
};
export type AttendantsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AttendantsSkillsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type AttendantsSkillsCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type AttendantsSkillsCreateAttendantErrorComponent = {
  attr: 'attendant';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AttendantsSkillsCreateCanDoWheelchairServiceErrorComponent = {
  attr: 'can_do_wheelchair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoWheelchairXlServiceErrorComponent = {
  attr: 'can_do_wheelchair_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoBrodaChairServiceErrorComponent = {
  attr: 'can_do_broda_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoGeriChairServiceErrorComponent = {
  attr: 'can_do_geri_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoStretcherServiceErrorComponent = {
  attr: 'can_do_stretcher_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoStretcherXlServiceErrorComponent = {
  attr: 'can_do_stretcher_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoDeliveryServiceErrorComponent = {
  attr: 'can_do_delivery_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoAmbulatoryServiceErrorComponent = {
  attr: 'can_do_ambulatory_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoCurbToCurbErrorComponent = {
  attr: 'can_do_curb_to_curb';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoDoorToDoorErrorComponent = {
  attr: 'can_do_door_to_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoDoorThroughDoorErrorComponent = {
  attr: 'can_do_door_through_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoPersonToPersonErrorComponent = {
  attr: 'can_do_person_to_person';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoBariatricErrorComponent = {
  attr: 'can_do_bariatric';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoStairsErrorComponent = {
  attr: 'can_do_stairs';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateCanDoStudentTransportErrorComponent = {
  attr: 'can_do_student_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsCreateError =
  | ({
      attr: 'non_field_errors';
    } & AttendantsSkillsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & AttendantsSkillsCreateIdErrorComponent)
  | ({
      attr: 'attendant';
    } & AttendantsSkillsCreateAttendantErrorComponent)
  | ({
      attr: 'can_do_wheelchair_service';
    } & AttendantsSkillsCreateCanDoWheelchairServiceErrorComponent)
  | ({
      attr: 'can_do_wheelchair_xl_service';
    } & AttendantsSkillsCreateCanDoWheelchairXlServiceErrorComponent)
  | ({
      attr: 'can_do_broda_chair_service';
    } & AttendantsSkillsCreateCanDoBrodaChairServiceErrorComponent)
  | ({
      attr: 'can_do_geri_chair_service';
    } & AttendantsSkillsCreateCanDoGeriChairServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_service';
    } & AttendantsSkillsCreateCanDoStretcherServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_xl_service';
    } & AttendantsSkillsCreateCanDoStretcherXlServiceErrorComponent)
  | ({
      attr: 'can_do_delivery_service';
    } & AttendantsSkillsCreateCanDoDeliveryServiceErrorComponent)
  | ({
      attr: 'can_do_ambulatory_service';
    } & AttendantsSkillsCreateCanDoAmbulatoryServiceErrorComponent)
  | ({
      attr: 'can_do_curb_to_curb';
    } & AttendantsSkillsCreateCanDoCurbToCurbErrorComponent)
  | ({
      attr: 'can_do_door_to_door';
    } & AttendantsSkillsCreateCanDoDoorToDoorErrorComponent)
  | ({
      attr: 'can_do_door_through_door';
    } & AttendantsSkillsCreateCanDoDoorThroughDoorErrorComponent)
  | ({
      attr: 'can_do_person_to_person';
    } & AttendantsSkillsCreateCanDoPersonToPersonErrorComponent)
  | ({
      attr: 'can_do_bariatric';
    } & AttendantsSkillsCreateCanDoBariatricErrorComponent)
  | ({
      attr: 'can_do_stairs';
    } & AttendantsSkillsCreateCanDoStairsErrorComponent)
  | ({
      attr: 'can_do_student_transport';
    } & AttendantsSkillsCreateCanDoStudentTransportErrorComponent);
export type AttendantsSkillsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: AttendantsSkillsCreateError[];
};
export type AttendantsSkillsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AttendantsSkillsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AttendantsSkillsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AttendantsSkillsUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type AttendantsSkillsUpdateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type AttendantsSkillsUpdateAttendantErrorComponent = {
  attr: 'attendant';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoWheelchairServiceErrorComponent = {
  attr: 'can_do_wheelchair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoWheelchairXlServiceErrorComponent = {
  attr: 'can_do_wheelchair_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoBrodaChairServiceErrorComponent = {
  attr: 'can_do_broda_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoGeriChairServiceErrorComponent = {
  attr: 'can_do_geri_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoStretcherServiceErrorComponent = {
  attr: 'can_do_stretcher_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoStretcherXlServiceErrorComponent = {
  attr: 'can_do_stretcher_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoDeliveryServiceErrorComponent = {
  attr: 'can_do_delivery_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoAmbulatoryServiceErrorComponent = {
  attr: 'can_do_ambulatory_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoCurbToCurbErrorComponent = {
  attr: 'can_do_curb_to_curb';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoDoorToDoorErrorComponent = {
  attr: 'can_do_door_to_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoDoorThroughDoorErrorComponent = {
  attr: 'can_do_door_through_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoPersonToPersonErrorComponent = {
  attr: 'can_do_person_to_person';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoBariatricErrorComponent = {
  attr: 'can_do_bariatric';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoStairsErrorComponent = {
  attr: 'can_do_stairs';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateCanDoStudentTransportErrorComponent = {
  attr: 'can_do_student_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsUpdateError =
  | ({
      attr: 'non_field_errors';
    } & AttendantsSkillsUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & AttendantsSkillsUpdateIdErrorComponent)
  | ({
      attr: 'attendant';
    } & AttendantsSkillsUpdateAttendantErrorComponent)
  | ({
      attr: 'can_do_wheelchair_service';
    } & AttendantsSkillsUpdateCanDoWheelchairServiceErrorComponent)
  | ({
      attr: 'can_do_wheelchair_xl_service';
    } & AttendantsSkillsUpdateCanDoWheelchairXlServiceErrorComponent)
  | ({
      attr: 'can_do_broda_chair_service';
    } & AttendantsSkillsUpdateCanDoBrodaChairServiceErrorComponent)
  | ({
      attr: 'can_do_geri_chair_service';
    } & AttendantsSkillsUpdateCanDoGeriChairServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_service';
    } & AttendantsSkillsUpdateCanDoStretcherServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_xl_service';
    } & AttendantsSkillsUpdateCanDoStretcherXlServiceErrorComponent)
  | ({
      attr: 'can_do_delivery_service';
    } & AttendantsSkillsUpdateCanDoDeliveryServiceErrorComponent)
  | ({
      attr: 'can_do_ambulatory_service';
    } & AttendantsSkillsUpdateCanDoAmbulatoryServiceErrorComponent)
  | ({
      attr: 'can_do_curb_to_curb';
    } & AttendantsSkillsUpdateCanDoCurbToCurbErrorComponent)
  | ({
      attr: 'can_do_door_to_door';
    } & AttendantsSkillsUpdateCanDoDoorToDoorErrorComponent)
  | ({
      attr: 'can_do_door_through_door';
    } & AttendantsSkillsUpdateCanDoDoorThroughDoorErrorComponent)
  | ({
      attr: 'can_do_person_to_person';
    } & AttendantsSkillsUpdateCanDoPersonToPersonErrorComponent)
  | ({
      attr: 'can_do_bariatric';
    } & AttendantsSkillsUpdateCanDoBariatricErrorComponent)
  | ({
      attr: 'can_do_stairs';
    } & AttendantsSkillsUpdateCanDoStairsErrorComponent)
  | ({
      attr: 'can_do_student_transport';
    } & AttendantsSkillsUpdateCanDoStudentTransportErrorComponent);
export type AttendantsSkillsUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: AttendantsSkillsUpdateError[];
};
export type AttendantsSkillsUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AttendantsSkillsUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AttendantsSkillsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type AttendantsSkillsPartialUpdateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type AttendantsSkillsPartialUpdateAttendantErrorComponent = {
  attr: 'attendant';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type AttendantsSkillsPartialUpdateCanDoWheelchairServiceErrorComponent =
  {
    attr: 'can_do_wheelchair_service';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AttendantsSkillsPartialUpdateCanDoWheelchairXlServiceErrorComponent =
  {
    attr: 'can_do_wheelchair_xl_service';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AttendantsSkillsPartialUpdateCanDoBrodaChairServiceErrorComponent =
  {
    attr: 'can_do_broda_chair_service';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AttendantsSkillsPartialUpdateCanDoGeriChairServiceErrorComponent = {
  attr: 'can_do_geri_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsPartialUpdateCanDoStretcherServiceErrorComponent = {
  attr: 'can_do_stretcher_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsPartialUpdateCanDoStretcherXlServiceErrorComponent =
  {
    attr: 'can_do_stretcher_xl_service';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AttendantsSkillsPartialUpdateCanDoDeliveryServiceErrorComponent = {
  attr: 'can_do_delivery_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsPartialUpdateCanDoAmbulatoryServiceErrorComponent =
  {
    attr: 'can_do_ambulatory_service';
    code: 'invalid' | 'null';
    detail: string;
  };
export type AttendantsSkillsPartialUpdateCanDoCurbToCurbErrorComponent = {
  attr: 'can_do_curb_to_curb';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsPartialUpdateCanDoDoorToDoorErrorComponent = {
  attr: 'can_do_door_to_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsPartialUpdateCanDoDoorThroughDoorErrorComponent = {
  attr: 'can_do_door_through_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsPartialUpdateCanDoPersonToPersonErrorComponent = {
  attr: 'can_do_person_to_person';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsPartialUpdateCanDoBariatricErrorComponent = {
  attr: 'can_do_bariatric';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsPartialUpdateCanDoStairsErrorComponent = {
  attr: 'can_do_stairs';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsPartialUpdateCanDoStudentTransportErrorComponent = {
  attr: 'can_do_student_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type AttendantsSkillsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & AttendantsSkillsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & AttendantsSkillsPartialUpdateIdErrorComponent)
  | ({
      attr: 'attendant';
    } & AttendantsSkillsPartialUpdateAttendantErrorComponent)
  | ({
      attr: 'can_do_wheelchair_service';
    } & AttendantsSkillsPartialUpdateCanDoWheelchairServiceErrorComponent)
  | ({
      attr: 'can_do_wheelchair_xl_service';
    } & AttendantsSkillsPartialUpdateCanDoWheelchairXlServiceErrorComponent)
  | ({
      attr: 'can_do_broda_chair_service';
    } & AttendantsSkillsPartialUpdateCanDoBrodaChairServiceErrorComponent)
  | ({
      attr: 'can_do_geri_chair_service';
    } & AttendantsSkillsPartialUpdateCanDoGeriChairServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_service';
    } & AttendantsSkillsPartialUpdateCanDoStretcherServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_xl_service';
    } & AttendantsSkillsPartialUpdateCanDoStretcherXlServiceErrorComponent)
  | ({
      attr: 'can_do_delivery_service';
    } & AttendantsSkillsPartialUpdateCanDoDeliveryServiceErrorComponent)
  | ({
      attr: 'can_do_ambulatory_service';
    } & AttendantsSkillsPartialUpdateCanDoAmbulatoryServiceErrorComponent)
  | ({
      attr: 'can_do_curb_to_curb';
    } & AttendantsSkillsPartialUpdateCanDoCurbToCurbErrorComponent)
  | ({
      attr: 'can_do_door_to_door';
    } & AttendantsSkillsPartialUpdateCanDoDoorToDoorErrorComponent)
  | ({
      attr: 'can_do_door_through_door';
    } & AttendantsSkillsPartialUpdateCanDoDoorThroughDoorErrorComponent)
  | ({
      attr: 'can_do_person_to_person';
    } & AttendantsSkillsPartialUpdateCanDoPersonToPersonErrorComponent)
  | ({
      attr: 'can_do_bariatric';
    } & AttendantsSkillsPartialUpdateCanDoBariatricErrorComponent)
  | ({
      attr: 'can_do_stairs';
    } & AttendantsSkillsPartialUpdateCanDoStairsErrorComponent)
  | ({
      attr: 'can_do_student_transport';
    } & AttendantsSkillsPartialUpdateCanDoStudentTransportErrorComponent);
export type AttendantsSkillsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: AttendantsSkillsPartialUpdateError[];
};
export type AttendantsSkillsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & AttendantsSkillsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedAttendantSkills = {
  id?: string;
  can_do_wheelchair_service?: boolean;
  can_do_wheelchair_xl_service?: boolean;
  can_do_broda_chair_service?: boolean;
  can_do_geri_chair_service?: boolean;
  can_do_stretcher_service?: boolean;
  can_do_stretcher_xl_service?: boolean;
  can_do_delivery_service?: boolean;
  can_do_ambulatory_service?: boolean;
  can_do_curb_to_curb?: boolean;
  can_do_door_to_door?: boolean;
  can_do_door_through_door?: boolean;
  can_do_person_to_person?: boolean;
  can_do_bariatric?: boolean;
  can_do_stairs?: boolean;
  can_do_student_transport?: boolean;
};
export type PatchedAttendantSkillsWrite = {
  id?: string;
  attendant?: string;
  can_do_wheelchair_service?: boolean;
  can_do_wheelchair_xl_service?: boolean;
  can_do_broda_chair_service?: boolean;
  can_do_geri_chair_service?: boolean;
  can_do_stretcher_service?: boolean;
  can_do_stretcher_xl_service?: boolean;
  can_do_delivery_service?: boolean;
  can_do_ambulatory_service?: boolean;
  can_do_curb_to_curb?: boolean;
  can_do_door_to_door?: boolean;
  can_do_door_through_door?: boolean;
  can_do_person_to_person?: boolean;
  can_do_bariatric?: boolean;
  can_do_stairs?: boolean;
  can_do_student_transport?: boolean;
};
export type AttendantsSkillsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BillingSettings = {
  invoice_seed_number?: number;
  invoice_prefix?: string;
  phone_number?: string;
  email?: string;
  invoice_note?: string;
  /** The email template that will be used to send a payment link to the passenger. */
  payment_link_email_template?: string;
  invoice_generation_columns?: string;
};
export type BillingSettingsRead = {
  id: string;
  invoice_seed_number?: number;
  invoice_prefix?: string;
  phone_number?: string;
  email?: string;
  invoice_note?: string;
  /** The email template that will be used to send a payment link to the passenger. */
  payment_link_email_template?: string;
  invoice_generation_columns?: string;
};
export type BillingBillingSettingsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BillingBillingSettingsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BillingBillingSettingsPartialUpdateInvoiceSeedNumberErrorComponent =
  {
    attr: 'invoice_seed_number';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type BillingBillingSettingsPartialUpdateInvoicePrefixErrorComponent = {
  attr: 'invoice_prefix';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BillingBillingSettingsPartialUpdatePhoneNumberErrorComponent = {
  attr: 'phone_number';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BillingBillingSettingsPartialUpdateEmailErrorComponent = {
  attr: 'email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BillingBillingSettingsPartialUpdateInvoiceNoteErrorComponent = {
  attr: 'invoice_note';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BillingBillingSettingsPartialUpdatePaymentLinkEmailTemplateErrorComponent =
  {
    attr: 'payment_link_email_template';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BillingBillingSettingsPartialUpdateInvoiceGenerationColumnsErrorComponent =
  {
    attr: 'invoice_generation_columns';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BillingBillingSettingsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & BillingBillingSettingsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'invoice_seed_number';
    } & BillingBillingSettingsPartialUpdateInvoiceSeedNumberErrorComponent)
  | ({
      attr: 'invoice_prefix';
    } & BillingBillingSettingsPartialUpdateInvoicePrefixErrorComponent)
  | ({
      attr: 'phone_number';
    } & BillingBillingSettingsPartialUpdatePhoneNumberErrorComponent)
  | ({
      attr: 'email';
    } & BillingBillingSettingsPartialUpdateEmailErrorComponent)
  | ({
      attr: 'invoice_note';
    } & BillingBillingSettingsPartialUpdateInvoiceNoteErrorComponent)
  | ({
      attr: 'payment_link_email_template';
    } & BillingBillingSettingsPartialUpdatePaymentLinkEmailTemplateErrorComponent)
  | ({
      attr: 'invoice_generation_columns';
    } & BillingBillingSettingsPartialUpdateInvoiceGenerationColumnsErrorComponent);
export type BillingBillingSettingsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: BillingBillingSettingsPartialUpdateError[];
};
export type BillingBillingSettingsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BillingBillingSettingsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedBillingSettings = {
  invoice_seed_number?: number;
  invoice_prefix?: string;
  phone_number?: string;
  email?: string;
  invoice_note?: string;
  /** The email template that will be used to send a payment link to the passenger. */
  payment_link_email_template?: string;
  invoice_generation_columns?: string;
};
export type PatchedBillingSettingsRead = {
  id?: string;
  invoice_seed_number?: number;
  invoice_prefix?: string;
  phone_number?: string;
  email?: string;
  invoice_note?: string;
  /** The email template that will be used to send a payment link to the passenger. */
  payment_link_email_template?: string;
  invoice_generation_columns?: string;
};
export type InvoiceNumberGenerator = {};
export type InvoiceNumberGeneratorRead = {
  invoice_prefix: string;
  next_invoice_number: number;
};
export type BillingBillingSettingsNextInvoiceNumberRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PatchedTripBillingPassenger = {
  id?: string;
  first_name?: string;
  last_name?: string;
  preferred_name?: string;
  pronoun?: string;
  gender?: string;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
};
export type PatchedTripBillingPassengerRead = {
  id?: string;
  organization_id?: string;
  first_name?: string;
  last_name?: string;
  full_name?: string;
  preferred_name?: string;
  pronoun?: string;
  gender?: string;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
};
export type TripBilling = {
  passenger: PatchedTripBillingPassenger;
  scheduled_pickup_at: string;
  oxygen_liters_per_min?: string;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  confirmation_code?: string;
};
export type OverrideStatusEnum =
  | 'requested'
  | 'pending'
  | 'assigned'
  | 'en route'
  | 'at pickup'
  | 'transporting'
  | 'at dropoff'
  | 'completed'
  | 'canceled'
  | 'rejected';
export type PayerTypeEnum = 'insurance' | 'broker' | 'private';
export type AddressLocation = {
  place_id: string;
};
export type AddressLocationRead = {
  /** The full address or geolocation label */
  label: string;
  place_id: string;
};
export type AddressTypeEnum = 'medical' | 'organization' | 'residential';
export type Address = {
  location?: AddressLocation;
  /** Address as sent to aws to get location */
  label: string;
  label2?: string;
  address_notes?: string;
  address_type?: AddressTypeEnum;
};
export type AddressRead = {
  id: string;
  organization_id: string;
  location?: AddressLocationRead;
  /** Address as sent to aws to get location */
  label: string;
  label2?: string;
  address_notes?: string;
  address_type?: AddressTypeEnum;
  created_at: string;
  updated_at: string;
};
export type PayerOrganization = {
  payer?: string | null;
  /** Name the organization uses to refer to this payer across the app */
  display_name: string;
  /** Any alternate name the organization uses (ex., full legal name) */
  alternate_name?: string;
  type?: PayerTypeEnum;
  /** if this payer could be used for current or future trips */
  is_active?: boolean;
  /** if this payer is a self-pay payer */
  is_self_pay?: boolean | null;
  /** Whether a payer organization allows any kind of multiloading */
  can_multiload?: boolean;
  /** ID of the organization in the payer's system */
  external_id?: string;
  website?: string;
  /** Employer Identification Number */
  ein?: string;
  /** Default contact email, ex. help@bambi.health */
  email?: string;
  /** Default contact phone number */
  phone_number?: string | null;
  /** Name of person to contact for billing/invoicing help or questions */
  billing_name?: string;
  /** Phone number for billing-specific purposes */
  billing_phone_number?: string | null;
  /** Email for billing/invoicing, ex. nirav@bambi.healh */
  billing_email?: string;
  /** Any additional information to display to dispatchers */
  dispatcher_notes?: string;
  /** Any additional information to display to admins */
  admin_notes?: string;
  deleted_at?: string | null;
  billing_address?: Address | null;
  default_trip_address?: Address | null;
  multiloading_partners?: string[] | null;
};
export type PayerOrganizationTripRequiredFields = {};
export type PayerOrganizationTripRequiredFieldsRead = {
  passenger_phone_number: boolean;
  passenger_weight: boolean;
  authorization_id: boolean;
  insurance_policy_id: boolean;
  payer_passenger_external_id: boolean;
  external_trip_id: boolean;
  booked_by_name: boolean;
  booked_by_phone_number: boolean;
};
export type PayerOrganizationRead = {
  id: string;
  organization_id: string;
  payer?: string | null;
  /** Name the organization uses to refer to this payer across the app */
  display_name: string;
  /** Any alternate name the organization uses (ex., full legal name) */
  alternate_name?: string;
  type?: PayerTypeEnum;
  /** if this payer could be used for current or future trips */
  is_active?: boolean;
  /** if this payer is a self-pay payer */
  is_self_pay?: boolean | null;
  /** Whether a payer organization allows any kind of multiloading */
  can_multiload?: boolean;
  /** ID of the organization in the payer's system */
  external_id?: string;
  website?: string;
  /** Employer Identification Number */
  ein?: string;
  /** Default contact email, ex. help@bambi.health */
  email?: string;
  /** Default contact phone number */
  phone_number?: string | null;
  /** Name of person to contact for billing/invoicing help or questions */
  billing_name?: string;
  /** Phone number for billing-specific purposes */
  billing_phone_number?: string | null;
  /** Email for billing/invoicing, ex. nirav@bambi.healh */
  billing_email?: string;
  /** Any additional information to display to dispatchers */
  dispatcher_notes?: string;
  /** Any additional information to display to admins */
  admin_notes?: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
  billing_address?: AddressRead | null;
  default_trip_address?: AddressRead | null;
  pickup_default_early_seconds: number;
  pickup_default_late_seconds: number;
  pickup_appointment_early_seconds: number;
  pickup_appointment_late_seconds: number;
  pickup_will_call_early_seconds: number;
  pickup_will_call_late_seconds: number;
  extra_scheduled_pickup_at_seconds: number;
  invoice_due_after_days: number | null;
  requires_signature_pickup_passenger: boolean;
  requires_signature_dropoff_passenger: boolean;
  requires_signature_pickup_driver: boolean;
  requires_signature_dropoff_driver: boolean;
  payer_info_id: string | null;
  payer_info_name: string | null;
  payer_name: string | null;
  payer_website: string | null;
  payer_type: PayerTypeEnum;
  multiloading_partners?: string[] | null;
  has_kinetik_account: boolean;
  trip_required_fields: PayerOrganizationTripRequiredFieldsRead | null;
};
export type PaymentMethodEnum = 'cash' | 'credit-card' | 'invoice';
export type SpaceTypeEnum =
  | 'wheelchair'
  | 'wheelchair xl'
  | 'broda chair'
  | 'geri chair'
  | 'stretcher'
  | 'stretcher xl'
  | 'ambulatory'
  | 'delivery';
export type ServiceTypeEnum =
  | 'curb-to-curb'
  | 'door-to-door'
  | 'door-through-door'
  | 'person-to-person';
export type CanceledReasonEnum =
  | 'no show'
  | 'passenger not ready'
  | 'passenger refused'
  | 'passenger unable'
  | 'scheduling conflict'
  | 'appointment canceled'
  | 'user requested'
  | 'payer canceled'
  | 'other';
export type TripBillingRead = {
  id: string;
  /** Current status of this trip */
  status: OverrideStatusEnum;
  /** Locked assignment cannot be changed */
  is_locked: boolean | null;
  passenger: PatchedTripBillingPassengerRead;
  payer: PayerOrganizationRead;
  early_pickup_at: string;
  late_pickup_at: string;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id: string;
  /** The initial price of the trip calculated using a pricing model */
  initial_calculated_price_cents: number | null;
  /** The final price of the trip calculated using a pricing model */
  final_calculated_price_cents: number | null;
  /** The manually inputted price of the trip */
  input_price_cents: number | null;
  payment_method: PaymentMethodEnum;
  scheduled_pickup_at: string;
  current_task: string | null;
  current_task_at: string | null;
  /** The time of the passenger's appointment */
  appointment_at: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call: boolean;
  /** Whether the passenger has called in that they are ready to be picked up */
  is_will_call_activated: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair: boolean;
  service_type: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes: string;
  /** Notes entered by the driver */
  driver_entered_notes: string;
  is_oxygen_required: boolean;
  oxygen_liters_per_min?: string;
  num_attendants_needed: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers: number;
  estimated_distance_miles: number | null;
  /** The time the trip was canceled */
  canceled_at: string | null;
  /** The main reason a trip was canceled */
  canceled_reason: CanceledReasonEnum;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  /** Who booked this trip, if not passenger */
  booked_by_name: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension: string;
  timing: string;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  tags: string[];
  /** The suggested pickup time based off of run_bambi_run results */
  suggested_pickup_time: string | null;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound: boolean;
  /** The authorization ID for this trip */
  authorization_id: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id: string;
  /** Whether this trips pricing is locked (non-editable) */
  is_price_locked: boolean;
  confirmation_code?: string;
  invoice_numbers: string | null;
  invoice_id: string | null;
};
export type TripBillingWrite = {
  passenger: PatchedTripBillingPassenger;
  payer_id: string;
  scheduled_pickup_at: string;
  oxygen_liters_per_min?: string;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  tag_ids?: string[] | null;
  confirmation_code?: string;
};
export type PaginatedTripBillingList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripBilling[];
};
export type PaginatedTripBillingListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripBillingRead[];
};
export type PaginatedTripBillingListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripBillingWrite[];
};
export type BillingTripsBillingListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type AliviOAuthToken = {};
export type TokenTypeEnum = 'Bearer';
export type AliviOAuthTokenRead = {
  access_token: string;
  expires_in: number;
  token_type: TokenTypeEnum;
};
export type GrantTypeEnum = 'client_credentials';
export type AliviOAuthTokenWrite = {
  client_id: string;
  client_secret: string;
  grant_type: GrantTypeEnum;
};
export type BrokersAliviOauth2TokenCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersAliviOauth2TokenCreateClientIdErrorComponent = {
  attr: 'client_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviOauth2TokenCreateClientSecretErrorComponent = {
  attr: 'client_secret';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviOauth2TokenCreateGrantTypeErrorComponent = {
  attr: 'grant_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviOauth2TokenCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersAliviOauth2TokenCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersAliviOauth2TokenCreateClientIdErrorComponent)
  | ({
      attr: 'client_secret';
    } & BrokersAliviOauth2TokenCreateClientSecretErrorComponent)
  | ({
      attr: 'grant_type';
    } & BrokersAliviOauth2TokenCreateGrantTypeErrorComponent);
export type BrokersAliviOauth2TokenCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersAliviOauth2TokenCreateError[];
};
export type BrokersAliviOauth2TokenCreateErrorResponse400 = {
  type: 'validation_error';
} & BrokersAliviOauth2TokenCreateValidationError;
export type AliviRideActivateWillCall = {};
export type AliviRideActivateWillCallWrite = {
  id: string;
};
export type BrokersAliviRideActivateWillcallCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersAliviRideActivateWillcallCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideActivateWillcallCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersAliviRideActivateWillcallCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & BrokersAliviRideActivateWillcallCreateIdErrorComponent);
export type BrokersAliviRideActivateWillcallCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersAliviRideActivateWillcallCreateError[];
};
export type BrokersAliviRideActivateWillcallCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersAliviRideActivateWillcallCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AliviRideCancel = {};
export type AliviRideCancelWrite = {
  id: string;
};
export type BrokersAliviRideCancelCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersAliviRideCancelCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideCancelCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersAliviRideCancelCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & BrokersAliviRideCancelCreateIdErrorComponent);
export type BrokersAliviRideCancelCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersAliviRideCancelCreateError[];
};
export type BrokersAliviRideCancelCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersAliviRideCancelCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AliviRideCancelWillCallActivation = {};
export type AliviRideCancelWillCallActivationWrite = {
  id: string;
};
export type BrokersAliviRideCancelWillcallActivationCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersAliviRideCancelWillcallActivationCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideCancelWillcallActivationCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersAliviRideCancelWillcallActivationCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & BrokersAliviRideCancelWillcallActivationCreateIdErrorComponent);
export type BrokersAliviRideCancelWillcallActivationCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersAliviRideCancelWillcallActivationCreateError[];
};
export type BrokersAliviRideCancelWillcallActivationCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersAliviRideCancelWillcallActivationCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AliviRideStatus = {
  id: string;
};
export type AliviRideStatusStatusEnum =
  | 'accept'
  | 'reject'
  | 'pending'
  | 'scheduled'
  | 'unscheduled'
  | 'pickupEnRoute'
  | 'pickupArrived'
  | 'dropoffEnroute'
  | 'dropoffArrived'
  | 'dropoffCompleted'
  | 'canceled';
export type AliviLevelOfServiceEnum =
  | 'C2C'
  | 'D2D'
  | 'WCH'
  | 'BWCH'
  | 'STR'
  | 'BSTR'
  | 'PPEC-AMB'
  | 'PPEC-WCH'
  | 'PPEC-STR'
  | 'BLS'
  | 'ALS';
export type AliviPassengerReadOnly = {};
export type AliviPassengerReadOnlyRead = {
  id: string;
  firstname: string;
  lastname: string;
  gender: string;
  weight: number;
  phone: string;
};
export type AliviAddressReadOnly = {};
export type AliviAddressReadOnlyRead = {
  name: string;
  phone: string;
  addressLine: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  latitude: number;
  longitude: number;
};
export type AliviCompanionsReadOnly = {};
export type AliviCompanionsReadOnlyRead = {
  adults: number;
  childrens: number;
  carSeats: number;
};
export type AliviRideStatusRead = {
  id: string;
  status: AliviRideStatusStatusEnum;
  transportationProviderId: string;
  levelOfService: AliviLevelOfServiceEnum;
  passenger: AliviPassengerReadOnlyRead;
  pickupAddress: AliviAddressReadOnlyRead;
  dropoffAddress: AliviAddressReadOnlyRead;
  appointmentTime: string;
  pickupTime: string;
  specialRequest: any[];
  driverNotes: string;
  alternateRideId: string;
  willcall: boolean;
  mileage: number;
  companions: AliviCompanionsReadOnlyRead;
};
export type BrokersAliviRideGetStatusCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersAliviRideGetStatusCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideGetStatusCreateSpecialRequestIndexErrorComponent = {
  attr: 'specialRequest.INDEX';
  code: 'required';
  detail: string;
};
export type BrokersAliviRideGetStatusCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersAliviRideGetStatusCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & BrokersAliviRideGetStatusCreateIdErrorComponent)
  | ({
      attr: 'specialRequest.INDEX';
    } & BrokersAliviRideGetStatusCreateSpecialRequestIndexErrorComponent);
export type BrokersAliviRideGetStatusCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersAliviRideGetStatusCreateError[];
};
export type BrokersAliviRideGetStatusCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersAliviRideGetStatusCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AliviRideOffer = {};
export type AliviRideOfferRead = {
  rideId: string;
};
export type AliviPassenger = {};
export type AliviPassengerWrite = {
  id: string;
  firstname: string;
  lastname: string;
  gender: string;
  weight?: number;
  phone: string | null;
};
export type AliviAddress = {};
export type AliviAddressWrite = {
  name?: string | null;
  phone: string | null;
  addressLine: string;
  addressLine2?: string;
  city: string;
  state: string;
  zipCode: string;
  latitude: number;
  longitude: number;
};
export type AliviCompanions = {};
export type AliviCompanionsWrite = {
  adults?: number;
  childrens?: number;
  carSeats?: number;
};
export type AliviRideOfferWrite = {
  transportationProviderId: string;
  levelOfService: AliviLevelOfServiceEnum;
  passenger: AliviPassengerWrite;
  pickupAddress: AliviAddressWrite;
  dropoffAddress: AliviAddressWrite;
  appointmentTime?: string;
  pickupTime: string;
  specialRequest?: any[];
  driverNotes?: string;
  alternateRideId?: string;
  willcall?: boolean;
  mileage?: number;
  webhookUrl?: string;
  companions?: AliviCompanionsWrite;
};
export type BrokersAliviRideOfferCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersAliviRideOfferCreateTransportationProviderIdErrorComponent =
  {
    attr: 'transportationProviderId';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersAliviRideOfferCreateLevelOfServiceErrorComponent = {
  attr: 'levelOfService';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideOfferCreatePassengerNonFieldErrorsErrorComponent = {
  attr: 'passenger.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideOfferCreatePassengerIdErrorComponent = {
  attr: 'passenger.id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideOfferCreatePassengerFirstnameErrorComponent = {
  attr: 'passenger.firstname';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreatePassengerLastnameErrorComponent = {
  attr: 'passenger.lastname';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreatePassengerGenderErrorComponent = {
  attr: 'passenger.gender';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreatePassengerWeightErrorComponent = {
  attr: 'passenger.weight';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type BrokersAliviRideOfferCreatePassengerPhoneErrorComponent = {
  attr: 'passenger.phone';
  code:
    | 'blank'
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreatePickupAddressNonFieldErrorsErrorComponent =
  {
    attr: 'pickupAddress.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersAliviRideOfferCreatePickupAddressNameErrorComponent = {
  attr: 'pickupAddress.name';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreatePickupAddressPhoneErrorComponent = {
  attr: 'pickupAddress.phone';
  code:
    | 'blank'
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreatePickupAddressAddressLineErrorComponent =
  {
    attr: 'pickupAddress.addressLine';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersAliviRideOfferCreatePickupAddressAddressLine2ErrorComponent =
  {
    attr: 'pickupAddress.addressLine2';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersAliviRideOfferCreatePickupAddressCityErrorComponent = {
  attr: 'pickupAddress.city';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreatePickupAddressStateErrorComponent = {
  attr: 'pickupAddress.state';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreatePickupAddressZipCodeErrorComponent = {
  attr: 'pickupAddress.zipCode';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreatePickupAddressLatitudeErrorComponent = {
  attr: 'pickupAddress.latitude';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideOfferCreatePickupAddressLongitudeErrorComponent = {
  attr: 'pickupAddress.longitude';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideOfferCreateDropoffAddressNonFieldErrorsErrorComponent =
  {
    attr: 'dropoffAddress.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersAliviRideOfferCreateDropoffAddressNameErrorComponent = {
  attr: 'dropoffAddress.name';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreateDropoffAddressPhoneErrorComponent = {
  attr: 'dropoffAddress.phone';
  code:
    | 'blank'
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreateDropoffAddressAddressLineErrorComponent =
  {
    attr: 'dropoffAddress.addressLine';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersAliviRideOfferCreateDropoffAddressAddressLine2ErrorComponent =
  {
    attr: 'dropoffAddress.addressLine2';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersAliviRideOfferCreateDropoffAddressCityErrorComponent = {
  attr: 'dropoffAddress.city';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreateDropoffAddressStateErrorComponent = {
  attr: 'dropoffAddress.state';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreateDropoffAddressZipCodeErrorComponent = {
  attr: 'dropoffAddress.zipCode';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreateDropoffAddressLatitudeErrorComponent = {
  attr: 'dropoffAddress.latitude';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideOfferCreateDropoffAddressLongitudeErrorComponent = {
  attr: 'dropoffAddress.longitude';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideOfferCreateAppointmentTimeErrorComponent = {
  attr: 'appointmentTime';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type BrokersAliviRideOfferCreatePickupTimeErrorComponent = {
  attr: 'pickupTime';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type BrokersAliviRideOfferCreateSpecialRequestErrorComponent = {
  attr: 'specialRequest';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type BrokersAliviRideOfferCreateSpecialRequestIndexErrorComponent = {
  attr: 'specialRequest.INDEX';
  code: 'required';
  detail: string;
};
export type BrokersAliviRideOfferCreateDriverNotesErrorComponent = {
  attr: 'driverNotes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreateAlternateRideIdErrorComponent = {
  attr: 'alternateRideId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreateWillcallErrorComponent = {
  attr: 'willcall';
  code: 'invalid' | 'null';
  detail: string;
};
export type BrokersAliviRideOfferCreateMileageErrorComponent = {
  attr: 'mileage';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type BrokersAliviRideOfferCreateWebhookUrlErrorComponent = {
  attr: 'webhookUrl';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideOfferCreateCompanionsNonFieldErrorsErrorComponent =
  {
    attr: 'companions.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type BrokersAliviRideOfferCreateCompanionsAdultsErrorComponent = {
  attr: 'companions.adults';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type BrokersAliviRideOfferCreateCompanionsChildrensErrorComponent = {
  attr: 'companions.childrens';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type BrokersAliviRideOfferCreateCompanionsCarSeatsErrorComponent = {
  attr: 'companions.carSeats';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type BrokersAliviRideOfferCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersAliviRideOfferCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'transportationProviderId';
    } & BrokersAliviRideOfferCreateTransportationProviderIdErrorComponent)
  | ({
      attr: 'levelOfService';
    } & BrokersAliviRideOfferCreateLevelOfServiceErrorComponent)
  | ({
      attr: 'passenger.non_field_errors';
    } & BrokersAliviRideOfferCreatePassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'passenger.id';
    } & BrokersAliviRideOfferCreatePassengerIdErrorComponent)
  | ({
      attr: 'passenger.firstname';
    } & BrokersAliviRideOfferCreatePassengerFirstnameErrorComponent)
  | ({
      attr: 'passenger.lastname';
    } & BrokersAliviRideOfferCreatePassengerLastnameErrorComponent)
  | ({
      attr: 'passenger.gender';
    } & BrokersAliviRideOfferCreatePassengerGenderErrorComponent)
  | ({
      attr: 'passenger.weight';
    } & BrokersAliviRideOfferCreatePassengerWeightErrorComponent)
  | ({
      attr: 'passenger.phone';
    } & BrokersAliviRideOfferCreatePassengerPhoneErrorComponent)
  | ({
      attr: 'pickupAddress.non_field_errors';
    } & BrokersAliviRideOfferCreatePickupAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickupAddress.name';
    } & BrokersAliviRideOfferCreatePickupAddressNameErrorComponent)
  | ({
      attr: 'pickupAddress.phone';
    } & BrokersAliviRideOfferCreatePickupAddressPhoneErrorComponent)
  | ({
      attr: 'pickupAddress.addressLine';
    } & BrokersAliviRideOfferCreatePickupAddressAddressLineErrorComponent)
  | ({
      attr: 'pickupAddress.addressLine2';
    } & BrokersAliviRideOfferCreatePickupAddressAddressLine2ErrorComponent)
  | ({
      attr: 'pickupAddress.city';
    } & BrokersAliviRideOfferCreatePickupAddressCityErrorComponent)
  | ({
      attr: 'pickupAddress.state';
    } & BrokersAliviRideOfferCreatePickupAddressStateErrorComponent)
  | ({
      attr: 'pickupAddress.zipCode';
    } & BrokersAliviRideOfferCreatePickupAddressZipCodeErrorComponent)
  | ({
      attr: 'pickupAddress.latitude';
    } & BrokersAliviRideOfferCreatePickupAddressLatitudeErrorComponent)
  | ({
      attr: 'pickupAddress.longitude';
    } & BrokersAliviRideOfferCreatePickupAddressLongitudeErrorComponent)
  | ({
      attr: 'dropoffAddress.non_field_errors';
    } & BrokersAliviRideOfferCreateDropoffAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'dropoffAddress.name';
    } & BrokersAliviRideOfferCreateDropoffAddressNameErrorComponent)
  | ({
      attr: 'dropoffAddress.phone';
    } & BrokersAliviRideOfferCreateDropoffAddressPhoneErrorComponent)
  | ({
      attr: 'dropoffAddress.addressLine';
    } & BrokersAliviRideOfferCreateDropoffAddressAddressLineErrorComponent)
  | ({
      attr: 'dropoffAddress.addressLine2';
    } & BrokersAliviRideOfferCreateDropoffAddressAddressLine2ErrorComponent)
  | ({
      attr: 'dropoffAddress.city';
    } & BrokersAliviRideOfferCreateDropoffAddressCityErrorComponent)
  | ({
      attr: 'dropoffAddress.state';
    } & BrokersAliviRideOfferCreateDropoffAddressStateErrorComponent)
  | ({
      attr: 'dropoffAddress.zipCode';
    } & BrokersAliviRideOfferCreateDropoffAddressZipCodeErrorComponent)
  | ({
      attr: 'dropoffAddress.latitude';
    } & BrokersAliviRideOfferCreateDropoffAddressLatitudeErrorComponent)
  | ({
      attr: 'dropoffAddress.longitude';
    } & BrokersAliviRideOfferCreateDropoffAddressLongitudeErrorComponent)
  | ({
      attr: 'appointmentTime';
    } & BrokersAliviRideOfferCreateAppointmentTimeErrorComponent)
  | ({
      attr: 'pickupTime';
    } & BrokersAliviRideOfferCreatePickupTimeErrorComponent)
  | ({
      attr: 'specialRequest';
    } & BrokersAliviRideOfferCreateSpecialRequestErrorComponent)
  | ({
      attr: 'specialRequest.INDEX';
    } & BrokersAliviRideOfferCreateSpecialRequestIndexErrorComponent)
  | ({
      attr: 'driverNotes';
    } & BrokersAliviRideOfferCreateDriverNotesErrorComponent)
  | ({
      attr: 'alternateRideId';
    } & BrokersAliviRideOfferCreateAlternateRideIdErrorComponent)
  | ({
      attr: 'willcall';
    } & BrokersAliviRideOfferCreateWillcallErrorComponent)
  | ({
      attr: 'mileage';
    } & BrokersAliviRideOfferCreateMileageErrorComponent)
  | ({
      attr: 'webhookUrl';
    } & BrokersAliviRideOfferCreateWebhookUrlErrorComponent)
  | ({
      attr: 'companions.non_field_errors';
    } & BrokersAliviRideOfferCreateCompanionsNonFieldErrorsErrorComponent)
  | ({
      attr: 'companions.adults';
    } & BrokersAliviRideOfferCreateCompanionsAdultsErrorComponent)
  | ({
      attr: 'companions.childrens';
    } & BrokersAliviRideOfferCreateCompanionsChildrensErrorComponent)
  | ({
      attr: 'companions.carSeats';
    } & BrokersAliviRideOfferCreateCompanionsCarSeatsErrorComponent);
export type BrokersAliviRideOfferCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersAliviRideOfferCreateError[];
};
export type BrokersAliviRideOfferCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersAliviRideOfferCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type AliviRideUpdate = {};
export type AliviRideUpdateWrite = {
  id: string;
  transportationProviderId: string;
  levelOfService: AliviLevelOfServiceEnum;
  appointmentTime?: string;
  pickupTime?: string;
  specialRequest?: any[];
  driverNotes?: string;
  alternateRideId?: string;
  willcall?: boolean;
  mileage?: number;
  companions?: AliviCompanionsWrite;
  passenger?: AliviPassengerWrite;
  pickupAddress?: AliviAddressWrite;
  dropoffAddress?: AliviAddressWrite;
};
export type BrokersAliviRideUpdateCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersAliviRideUpdateCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideUpdateCreateTransportationProviderIdErrorComponent =
  {
    attr: 'transportationProviderId';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersAliviRideUpdateCreateLevelOfServiceErrorComponent = {
  attr: 'levelOfService';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideUpdateCreateAppointmentTimeErrorComponent = {
  attr: 'appointmentTime';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePickupTimeErrorComponent = {
  attr: 'pickupTime';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type BrokersAliviRideUpdateCreateSpecialRequestErrorComponent = {
  attr: 'specialRequest';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type BrokersAliviRideUpdateCreateSpecialRequestIndexErrorComponent = {
  attr: 'specialRequest.INDEX';
  code: 'required';
  detail: string;
};
export type BrokersAliviRideUpdateCreateDriverNotesErrorComponent = {
  attr: 'driverNotes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreateAlternateRideIdErrorComponent = {
  attr: 'alternateRideId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreateWillcallErrorComponent = {
  attr: 'willcall';
  code: 'invalid' | 'null';
  detail: string;
};
export type BrokersAliviRideUpdateCreateMileageErrorComponent = {
  attr: 'mileage';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type BrokersAliviRideUpdateCreateCompanionsNonFieldErrorsErrorComponent =
  {
    attr: 'companions.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type BrokersAliviRideUpdateCreateCompanionsAdultsErrorComponent = {
  attr: 'companions.adults';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type BrokersAliviRideUpdateCreateCompanionsChildrensErrorComponent = {
  attr: 'companions.childrens';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type BrokersAliviRideUpdateCreateCompanionsCarSeatsErrorComponent = {
  attr: 'companions.carSeats';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePassengerNonFieldErrorsErrorComponent =
  {
    attr: 'passenger.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type BrokersAliviRideUpdateCreatePassengerIdErrorComponent = {
  attr: 'passenger.id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePassengerFirstnameErrorComponent = {
  attr: 'passenger.firstname';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePassengerLastnameErrorComponent = {
  attr: 'passenger.lastname';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePassengerGenderErrorComponent = {
  attr: 'passenger.gender';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePassengerWeightErrorComponent = {
  attr: 'passenger.weight';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePassengerPhoneErrorComponent = {
  attr: 'passenger.phone';
  code:
    | 'blank'
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePickupAddressNonFieldErrorsErrorComponent =
  {
    attr: 'pickupAddress.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type BrokersAliviRideUpdateCreatePickupAddressNameErrorComponent = {
  attr: 'pickupAddress.name';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePickupAddressPhoneErrorComponent = {
  attr: 'pickupAddress.phone';
  code:
    | 'blank'
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePickupAddressAddressLineErrorComponent =
  {
    attr: 'pickupAddress.addressLine';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersAliviRideUpdateCreatePickupAddressAddressLine2ErrorComponent =
  {
    attr: 'pickupAddress.addressLine2';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersAliviRideUpdateCreatePickupAddressCityErrorComponent = {
  attr: 'pickupAddress.city';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePickupAddressStateErrorComponent = {
  attr: 'pickupAddress.state';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePickupAddressZipCodeErrorComponent = {
  attr: 'pickupAddress.zipCode';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePickupAddressLatitudeErrorComponent = {
  attr: 'pickupAddress.latitude';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideUpdateCreatePickupAddressLongitudeErrorComponent = {
  attr: 'pickupAddress.longitude';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideUpdateCreateDropoffAddressNonFieldErrorsErrorComponent =
  {
    attr: 'dropoffAddress.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type BrokersAliviRideUpdateCreateDropoffAddressNameErrorComponent = {
  attr: 'dropoffAddress.name';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreateDropoffAddressPhoneErrorComponent = {
  attr: 'dropoffAddress.phone';
  code:
    | 'blank'
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreateDropoffAddressAddressLineErrorComponent =
  {
    attr: 'dropoffAddress.addressLine';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersAliviRideUpdateCreateDropoffAddressAddressLine2ErrorComponent =
  {
    attr: 'dropoffAddress.addressLine2';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersAliviRideUpdateCreateDropoffAddressCityErrorComponent = {
  attr: 'dropoffAddress.city';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreateDropoffAddressStateErrorComponent = {
  attr: 'dropoffAddress.state';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreateDropoffAddressZipCodeErrorComponent = {
  attr: 'dropoffAddress.zipCode';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersAliviRideUpdateCreateDropoffAddressLatitudeErrorComponent = {
  attr: 'dropoffAddress.latitude';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersAliviRideUpdateCreateDropoffAddressLongitudeErrorComponent =
  {
    attr: 'dropoffAddress.longitude';
    code: 'invalid' | 'max_string_length' | 'null' | 'required';
    detail: string;
  };
export type BrokersAliviRideUpdateCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersAliviRideUpdateCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & BrokersAliviRideUpdateCreateIdErrorComponent)
  | ({
      attr: 'transportationProviderId';
    } & BrokersAliviRideUpdateCreateTransportationProviderIdErrorComponent)
  | ({
      attr: 'levelOfService';
    } & BrokersAliviRideUpdateCreateLevelOfServiceErrorComponent)
  | ({
      attr: 'appointmentTime';
    } & BrokersAliviRideUpdateCreateAppointmentTimeErrorComponent)
  | ({
      attr: 'pickupTime';
    } & BrokersAliviRideUpdateCreatePickupTimeErrorComponent)
  | ({
      attr: 'specialRequest';
    } & BrokersAliviRideUpdateCreateSpecialRequestErrorComponent)
  | ({
      attr: 'specialRequest.INDEX';
    } & BrokersAliviRideUpdateCreateSpecialRequestIndexErrorComponent)
  | ({
      attr: 'driverNotes';
    } & BrokersAliviRideUpdateCreateDriverNotesErrorComponent)
  | ({
      attr: 'alternateRideId';
    } & BrokersAliviRideUpdateCreateAlternateRideIdErrorComponent)
  | ({
      attr: 'willcall';
    } & BrokersAliviRideUpdateCreateWillcallErrorComponent)
  | ({
      attr: 'mileage';
    } & BrokersAliviRideUpdateCreateMileageErrorComponent)
  | ({
      attr: 'companions.non_field_errors';
    } & BrokersAliviRideUpdateCreateCompanionsNonFieldErrorsErrorComponent)
  | ({
      attr: 'companions.adults';
    } & BrokersAliviRideUpdateCreateCompanionsAdultsErrorComponent)
  | ({
      attr: 'companions.childrens';
    } & BrokersAliviRideUpdateCreateCompanionsChildrensErrorComponent)
  | ({
      attr: 'companions.carSeats';
    } & BrokersAliviRideUpdateCreateCompanionsCarSeatsErrorComponent)
  | ({
      attr: 'passenger.non_field_errors';
    } & BrokersAliviRideUpdateCreatePassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'passenger.id';
    } & BrokersAliviRideUpdateCreatePassengerIdErrorComponent)
  | ({
      attr: 'passenger.firstname';
    } & BrokersAliviRideUpdateCreatePassengerFirstnameErrorComponent)
  | ({
      attr: 'passenger.lastname';
    } & BrokersAliviRideUpdateCreatePassengerLastnameErrorComponent)
  | ({
      attr: 'passenger.gender';
    } & BrokersAliviRideUpdateCreatePassengerGenderErrorComponent)
  | ({
      attr: 'passenger.weight';
    } & BrokersAliviRideUpdateCreatePassengerWeightErrorComponent)
  | ({
      attr: 'passenger.phone';
    } & BrokersAliviRideUpdateCreatePassengerPhoneErrorComponent)
  | ({
      attr: 'pickupAddress.non_field_errors';
    } & BrokersAliviRideUpdateCreatePickupAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickupAddress.name';
    } & BrokersAliviRideUpdateCreatePickupAddressNameErrorComponent)
  | ({
      attr: 'pickupAddress.phone';
    } & BrokersAliviRideUpdateCreatePickupAddressPhoneErrorComponent)
  | ({
      attr: 'pickupAddress.addressLine';
    } & BrokersAliviRideUpdateCreatePickupAddressAddressLineErrorComponent)
  | ({
      attr: 'pickupAddress.addressLine2';
    } & BrokersAliviRideUpdateCreatePickupAddressAddressLine2ErrorComponent)
  | ({
      attr: 'pickupAddress.city';
    } & BrokersAliviRideUpdateCreatePickupAddressCityErrorComponent)
  | ({
      attr: 'pickupAddress.state';
    } & BrokersAliviRideUpdateCreatePickupAddressStateErrorComponent)
  | ({
      attr: 'pickupAddress.zipCode';
    } & BrokersAliviRideUpdateCreatePickupAddressZipCodeErrorComponent)
  | ({
      attr: 'pickupAddress.latitude';
    } & BrokersAliviRideUpdateCreatePickupAddressLatitudeErrorComponent)
  | ({
      attr: 'pickupAddress.longitude';
    } & BrokersAliviRideUpdateCreatePickupAddressLongitudeErrorComponent)
  | ({
      attr: 'dropoffAddress.non_field_errors';
    } & BrokersAliviRideUpdateCreateDropoffAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'dropoffAddress.name';
    } & BrokersAliviRideUpdateCreateDropoffAddressNameErrorComponent)
  | ({
      attr: 'dropoffAddress.phone';
    } & BrokersAliviRideUpdateCreateDropoffAddressPhoneErrorComponent)
  | ({
      attr: 'dropoffAddress.addressLine';
    } & BrokersAliviRideUpdateCreateDropoffAddressAddressLineErrorComponent)
  | ({
      attr: 'dropoffAddress.addressLine2';
    } & BrokersAliviRideUpdateCreateDropoffAddressAddressLine2ErrorComponent)
  | ({
      attr: 'dropoffAddress.city';
    } & BrokersAliviRideUpdateCreateDropoffAddressCityErrorComponent)
  | ({
      attr: 'dropoffAddress.state';
    } & BrokersAliviRideUpdateCreateDropoffAddressStateErrorComponent)
  | ({
      attr: 'dropoffAddress.zipCode';
    } & BrokersAliviRideUpdateCreateDropoffAddressZipCodeErrorComponent)
  | ({
      attr: 'dropoffAddress.latitude';
    } & BrokersAliviRideUpdateCreateDropoffAddressLatitudeErrorComponent)
  | ({
      attr: 'dropoffAddress.longitude';
    } & BrokersAliviRideUpdateCreateDropoffAddressLongitudeErrorComponent);
export type BrokersAliviRideUpdateCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersAliviRideUpdateCreateError[];
};
export type BrokersAliviRideUpdateCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersAliviRideUpdateCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type ClearviewOAuthToken = {};
export type ClearviewOAuthTokenRead = {
  access_token: string;
  expires_in: number;
  token_type: TokenTypeEnum;
};
export type ClearviewOAuthTokenWrite = {
  client_id: string;
  client_secret: string;
  grant_type: GrantTypeEnum;
};
export type BrokersClearviewOauth2TokenCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersClearviewOauth2TokenCreateClientIdErrorComponent = {
  attr: 'client_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewOauth2TokenCreateClientSecretErrorComponent = {
  attr: 'client_secret';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewOauth2TokenCreateGrantTypeErrorComponent = {
  attr: 'grant_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewOauth2TokenCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersClearviewOauth2TokenCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersClearviewOauth2TokenCreateClientIdErrorComponent)
  | ({
      attr: 'client_secret';
    } & BrokersClearviewOauth2TokenCreateClientSecretErrorComponent)
  | ({
      attr: 'grant_type';
    } & BrokersClearviewOauth2TokenCreateGrantTypeErrorComponent);
export type BrokersClearviewOauth2TokenCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersClearviewOauth2TokenCreateError[];
};
export type BrokersClearviewOauth2TokenCreateErrorResponse400 = {
  type: 'validation_error';
} & BrokersClearviewOauth2TokenCreateValidationError;
export type ClearviewPassenger = {
  memberId?: string;
  firstName: string;
  lastName: string;
  phone: string;
};
export type ClearviewLocation = {
  address: string;
  lat: number;
  lng: number;
};
export type ClearviewTrip = {
  externalId?: string;
  account: string;
  pickupTime: string;
  appointmentTime?: string | null;
  willCall: boolean;
  passenger: ClearviewPassenger;
  origin: ClearviewLocation;
  destination: ClearviewLocation;
  comments?: string | null;
  levelOfService: SpaceTypeEnum;
  price?: number | null;
  miles?: number | null;
};
export type ClearviewTripRead = {
  id: string;
  organizationId: string;
  externalId?: string;
  account: string;
  pickupTime: string;
  appointmentTime?: string | null;
  willCall: boolean;
  passenger: ClearviewPassenger;
  origin: ClearviewLocation;
  destination: ClearviewLocation;
  comments?: string | null;
  levelOfService: SpaceTypeEnum;
  price?: number | null;
  miles?: number | null;
  customData: {
    [key: string]: any;
  };
};
export type PaginatedClearviewTripList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ClearviewTrip[];
};
export type PaginatedClearviewTripListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ClearviewTripRead[];
};
export type BrokersClearviewTripsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BrokersClearviewTripsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersClearviewTripsCreateExternalIdErrorComponent = {
  attr: 'externalId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsCreateAccountErrorComponent = {
  attr: 'account';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsCreatePickupTimeErrorComponent = {
  attr: 'pickupTime';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type BrokersClearviewTripsCreateAppointmentTimeErrorComponent = {
  attr: 'appointmentTime';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type BrokersClearviewTripsCreateWillCallErrorComponent = {
  attr: 'willCall';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsCreatePassengerNonFieldErrorsErrorComponent = {
  attr: 'passenger.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsCreatePassengerMemberIdErrorComponent = {
  attr: 'passenger.memberId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsCreatePassengerFirstNameErrorComponent = {
  attr: 'passenger.firstName';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsCreatePassengerLastNameErrorComponent = {
  attr: 'passenger.lastName';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsCreatePassengerPhoneErrorComponent = {
  attr: 'passenger.phone';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsCreateOriginNonFieldErrorsErrorComponent = {
  attr: 'origin.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsCreateOriginAddressErrorComponent = {
  attr: 'origin.address';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsCreateOriginLatErrorComponent = {
  attr: 'origin.lat';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsCreateOriginLngErrorComponent = {
  attr: 'origin.lng';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsCreateDestinationNonFieldErrorsErrorComponent =
  {
    attr: 'destination.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersClearviewTripsCreateDestinationAddressErrorComponent = {
  attr: 'destination.address';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsCreateDestinationLatErrorComponent = {
  attr: 'destination.lat';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsCreateDestinationLngErrorComponent = {
  attr: 'destination.lng';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsCreateCommentsErrorComponent = {
  attr: 'comments';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsCreateLevelOfServiceErrorComponent = {
  attr: 'levelOfService';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsCreatePriceErrorComponent = {
  attr: 'price';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersClearviewTripsCreateMilesErrorComponent = {
  attr: 'miles';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersClearviewTripsCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersClearviewTripsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'externalId';
    } & BrokersClearviewTripsCreateExternalIdErrorComponent)
  | ({
      attr: 'account';
    } & BrokersClearviewTripsCreateAccountErrorComponent)
  | ({
      attr: 'pickupTime';
    } & BrokersClearviewTripsCreatePickupTimeErrorComponent)
  | ({
      attr: 'appointmentTime';
    } & BrokersClearviewTripsCreateAppointmentTimeErrorComponent)
  | ({
      attr: 'willCall';
    } & BrokersClearviewTripsCreateWillCallErrorComponent)
  | ({
      attr: 'passenger.non_field_errors';
    } & BrokersClearviewTripsCreatePassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'passenger.memberId';
    } & BrokersClearviewTripsCreatePassengerMemberIdErrorComponent)
  | ({
      attr: 'passenger.firstName';
    } & BrokersClearviewTripsCreatePassengerFirstNameErrorComponent)
  | ({
      attr: 'passenger.lastName';
    } & BrokersClearviewTripsCreatePassengerLastNameErrorComponent)
  | ({
      attr: 'passenger.phone';
    } & BrokersClearviewTripsCreatePassengerPhoneErrorComponent)
  | ({
      attr: 'origin.non_field_errors';
    } & BrokersClearviewTripsCreateOriginNonFieldErrorsErrorComponent)
  | ({
      attr: 'origin.address';
    } & BrokersClearviewTripsCreateOriginAddressErrorComponent)
  | ({
      attr: 'origin.lat';
    } & BrokersClearviewTripsCreateOriginLatErrorComponent)
  | ({
      attr: 'origin.lng';
    } & BrokersClearviewTripsCreateOriginLngErrorComponent)
  | ({
      attr: 'destination.non_field_errors';
    } & BrokersClearviewTripsCreateDestinationNonFieldErrorsErrorComponent)
  | ({
      attr: 'destination.address';
    } & BrokersClearviewTripsCreateDestinationAddressErrorComponent)
  | ({
      attr: 'destination.lat';
    } & BrokersClearviewTripsCreateDestinationLatErrorComponent)
  | ({
      attr: 'destination.lng';
    } & BrokersClearviewTripsCreateDestinationLngErrorComponent)
  | ({
      attr: 'comments';
    } & BrokersClearviewTripsCreateCommentsErrorComponent)
  | ({
      attr: 'levelOfService';
    } & BrokersClearviewTripsCreateLevelOfServiceErrorComponent)
  | ({
      attr: 'price';
    } & BrokersClearviewTripsCreatePriceErrorComponent)
  | ({
      attr: 'miles';
    } & BrokersClearviewTripsCreateMilesErrorComponent);
export type BrokersClearviewTripsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersClearviewTripsCreateError[];
};
export type BrokersClearviewTripsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersClearviewTripsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BrokersClearviewTripsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BrokersClearviewTripsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateExternalIdErrorComponent = {
  attr: 'externalId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateAccountErrorComponent = {
  attr: 'account';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdatePickupTimeErrorComponent = {
  attr: 'pickupTime';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateAppointmentTimeErrorComponent = {
  attr: 'appointmentTime';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateWillCallErrorComponent = {
  attr: 'willCall';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdatePassengerNonFieldErrorsErrorComponent =
  {
    attr: 'passenger.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersClearviewTripsPartialUpdatePassengerMemberIdErrorComponent =
  {
    attr: 'passenger.memberId';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersClearviewTripsPartialUpdatePassengerFirstNameErrorComponent =
  {
    attr: 'passenger.firstName';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersClearviewTripsPartialUpdatePassengerLastNameErrorComponent =
  {
    attr: 'passenger.lastName';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersClearviewTripsPartialUpdatePassengerPhoneErrorComponent = {
  attr: 'passenger.phone';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateOriginNonFieldErrorsErrorComponent =
  {
    attr: 'origin.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersClearviewTripsPartialUpdateOriginAddressErrorComponent = {
  attr: 'origin.address';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateOriginLatErrorComponent = {
  attr: 'origin.lat';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateOriginLngErrorComponent = {
  attr: 'origin.lng';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateDestinationNonFieldErrorsErrorComponent =
  {
    attr: 'destination.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersClearviewTripsPartialUpdateDestinationAddressErrorComponent =
  {
    attr: 'destination.address';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersClearviewTripsPartialUpdateDestinationLatErrorComponent = {
  attr: 'destination.lat';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateDestinationLngErrorComponent = {
  attr: 'destination.lng';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateCommentsErrorComponent = {
  attr: 'comments';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateLevelOfServiceErrorComponent = {
  attr: 'levelOfService';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdatePriceErrorComponent = {
  attr: 'price';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateMilesErrorComponent = {
  attr: 'miles';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersClearviewTripsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersClearviewTripsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'externalId';
    } & BrokersClearviewTripsPartialUpdateExternalIdErrorComponent)
  | ({
      attr: 'account';
    } & BrokersClearviewTripsPartialUpdateAccountErrorComponent)
  | ({
      attr: 'pickupTime';
    } & BrokersClearviewTripsPartialUpdatePickupTimeErrorComponent)
  | ({
      attr: 'appointmentTime';
    } & BrokersClearviewTripsPartialUpdateAppointmentTimeErrorComponent)
  | ({
      attr: 'willCall';
    } & BrokersClearviewTripsPartialUpdateWillCallErrorComponent)
  | ({
      attr: 'passenger.non_field_errors';
    } & BrokersClearviewTripsPartialUpdatePassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'passenger.memberId';
    } & BrokersClearviewTripsPartialUpdatePassengerMemberIdErrorComponent)
  | ({
      attr: 'passenger.firstName';
    } & BrokersClearviewTripsPartialUpdatePassengerFirstNameErrorComponent)
  | ({
      attr: 'passenger.lastName';
    } & BrokersClearviewTripsPartialUpdatePassengerLastNameErrorComponent)
  | ({
      attr: 'passenger.phone';
    } & BrokersClearviewTripsPartialUpdatePassengerPhoneErrorComponent)
  | ({
      attr: 'origin.non_field_errors';
    } & BrokersClearviewTripsPartialUpdateOriginNonFieldErrorsErrorComponent)
  | ({
      attr: 'origin.address';
    } & BrokersClearviewTripsPartialUpdateOriginAddressErrorComponent)
  | ({
      attr: 'origin.lat';
    } & BrokersClearviewTripsPartialUpdateOriginLatErrorComponent)
  | ({
      attr: 'origin.lng';
    } & BrokersClearviewTripsPartialUpdateOriginLngErrorComponent)
  | ({
      attr: 'destination.non_field_errors';
    } & BrokersClearviewTripsPartialUpdateDestinationNonFieldErrorsErrorComponent)
  | ({
      attr: 'destination.address';
    } & BrokersClearviewTripsPartialUpdateDestinationAddressErrorComponent)
  | ({
      attr: 'destination.lat';
    } & BrokersClearviewTripsPartialUpdateDestinationLatErrorComponent)
  | ({
      attr: 'destination.lng';
    } & BrokersClearviewTripsPartialUpdateDestinationLngErrorComponent)
  | ({
      attr: 'comments';
    } & BrokersClearviewTripsPartialUpdateCommentsErrorComponent)
  | ({
      attr: 'levelOfService';
    } & BrokersClearviewTripsPartialUpdateLevelOfServiceErrorComponent)
  | ({
      attr: 'price';
    } & BrokersClearviewTripsPartialUpdatePriceErrorComponent)
  | ({
      attr: 'miles';
    } & BrokersClearviewTripsPartialUpdateMilesErrorComponent);
export type BrokersClearviewTripsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersClearviewTripsPartialUpdateError[];
};
export type BrokersClearviewTripsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersClearviewTripsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedClearviewTrip = {
  externalId?: string;
  account?: string;
  pickupTime?: string;
  appointmentTime?: string | null;
  willCall?: boolean;
  passenger?: ClearviewPassenger;
  origin?: ClearviewLocation;
  destination?: ClearviewLocation;
  comments?: string | null;
  levelOfService?: SpaceTypeEnum;
  price?: number | null;
  miles?: number | null;
};
export type PatchedClearviewTripRead = {
  id?: string;
  organizationId?: string;
  externalId?: string;
  account?: string;
  pickupTime?: string;
  appointmentTime?: string | null;
  willCall?: boolean;
  passenger?: ClearviewPassenger;
  origin?: ClearviewLocation;
  destination?: ClearviewLocation;
  comments?: string | null;
  levelOfService?: SpaceTypeEnum;
  price?: number | null;
  miles?: number | null;
  customData?: {
    [key: string]: any;
  };
};
export type BrokersClearviewTripsCancelCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersClearviewTripsCancelCreateError = {
  attr: 'non_field_errors';
} & BrokersClearviewTripsCancelCreateNonFieldErrorsErrorComponent;
export type BrokersClearviewTripsCancelCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersClearviewTripsCancelCreateError[];
};
export type BrokersClearviewTripsCancelCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersClearviewTripsCancelCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type CtcoAuthToken = {};
export type CtcoAuthTokenRead = {
  access_token: string;
  expires_in: number;
  token_type: TokenTypeEnum;
};
export type CtcoAuthTokenWrite = {
  client_id: string;
  client_secret: string;
  grant_type: GrantTypeEnum;
};
export type BrokersCtcOauth2TokenCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersCtcOauth2TokenCreateClientIdErrorComponent = {
  attr: 'client_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcOauth2TokenCreateClientSecretErrorComponent = {
  attr: 'client_secret';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcOauth2TokenCreateGrantTypeErrorComponent = {
  attr: 'grant_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersCtcOauth2TokenCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersCtcOauth2TokenCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersCtcOauth2TokenCreateClientIdErrorComponent)
  | ({
      attr: 'client_secret';
    } & BrokersCtcOauth2TokenCreateClientSecretErrorComponent)
  | ({
      attr: 'grant_type';
    } & BrokersCtcOauth2TokenCreateGrantTypeErrorComponent);
export type BrokersCtcOauth2TokenCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersCtcOauth2TokenCreateError[];
};
export type BrokersCtcOauth2TokenCreateErrorResponse400 = {
  type: 'validation_error';
} & BrokersCtcOauth2TokenCreateValidationError;
export type CtcTrip = {};
export type CtcTripRead = {
  message: string;
  id: string;
  intermediary_id: string;
};
export type CtcTripWrite = {
  /** CTC's internal ID for the trip */
  TripID: string;
  /** Name and identifier of the TP */
  SubContractor: string;
  RequestType: string;
  /** Used by CTC */
  ManifestType: string;
  DateOfService: string;
  AppointmentTime: string | null;
  PickupTime: string;
  LOS: string;
  Status: string;
  EstMiles: string;
  Escorts: number | null;
  StandingOrderDays: string | null;
  Dialysis: string | null;
  DialysisDays: string | null;
  Tags: string;
  /** Unique ID for the passenger */
  UniqueId: string;
  FirstName: string;
  LastName: string;
  Gender: string;
  DateOfBirth: string;
  Heightfeet: string | null;
  HomeNumber: string;
  OriginName: string;
  OriginLat: string;
  OriginLng: string;
  OriginStreet: string;
  OriginSuite: string | null;
  OriginCity: string;
  OriginState: string;
  OriginPostal: string;
  OriginCounty: string | null;
  OriginPhone: string;
  OriginComments: string | null;
  DestinationName: string;
  DestinationLat: string;
  DestinationLng: string;
  DestinationStreet: string;
  DestinationSuite: string | null;
  DestinationCity: string;
  DestinationState: string;
  DestinationPostal: string;
  DestinationCounty: string | null;
  DestinationPhone: string;
  DestinationComments: string | null;
};
export type BrokersCtcTripCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersCtcTripCreateTripIdErrorComponent = {
  attr: 'TripID';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateSubContractorErrorComponent = {
  attr: 'SubContractor';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateRequestTypeErrorComponent = {
  attr: 'RequestType';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateManifestTypeErrorComponent = {
  attr: 'ManifestType';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDateOfServiceErrorComponent = {
  attr: 'DateOfService';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type BrokersCtcTripCreateAppointmentTimeErrorComponent = {
  attr: 'AppointmentTime';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreatePickupTimeErrorComponent = {
  attr: 'PickupTime';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateLosErrorComponent = {
  attr: 'LOS';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateStatusErrorComponent = {
  attr: 'Status';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateEstMilesErrorComponent = {
  attr: 'EstMiles';
  code:
    | 'invalid'
    | 'max_decimal_places'
    | 'max_digits'
    | 'max_string_length'
    | 'max_whole_digits'
    | 'null'
    | 'required';
  detail: string;
};
export type BrokersCtcTripCreateEscortsErrorComponent = {
  attr: 'Escorts';
  code: 'invalid' | 'max_string_length' | 'required';
  detail: string;
};
export type BrokersCtcTripCreateStandingOrderDaysErrorComponent = {
  attr: 'StandingOrderDays';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDialysisErrorComponent = {
  attr: 'Dialysis';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDialysisDaysErrorComponent = {
  attr: 'DialysisDays';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateTagsErrorComponent = {
  attr: 'Tags';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateUniqueIdErrorComponent = {
  attr: 'UniqueId';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateFirstNameErrorComponent = {
  attr: 'FirstName';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateLastNameErrorComponent = {
  attr: 'LastName';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateGenderErrorComponent = {
  attr: 'Gender';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDateOfBirthErrorComponent = {
  attr: 'DateOfBirth';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type BrokersCtcTripCreateHeightfeetErrorComponent = {
  attr: 'Heightfeet';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateHomeNumberErrorComponent = {
  attr: 'HomeNumber';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginNameErrorComponent = {
  attr: 'OriginName';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginLatErrorComponent = {
  attr: 'OriginLat';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginLngErrorComponent = {
  attr: 'OriginLng';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginStreetErrorComponent = {
  attr: 'OriginStreet';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginSuiteErrorComponent = {
  attr: 'OriginSuite';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginCityErrorComponent = {
  attr: 'OriginCity';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginStateErrorComponent = {
  attr: 'OriginState';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginPostalErrorComponent = {
  attr: 'OriginPostal';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginCountyErrorComponent = {
  attr: 'OriginCounty';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginPhoneErrorComponent = {
  attr: 'OriginPhone';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateOriginCommentsErrorComponent = {
  attr: 'OriginComments';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationNameErrorComponent = {
  attr: 'DestinationName';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationLatErrorComponent = {
  attr: 'DestinationLat';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationLngErrorComponent = {
  attr: 'DestinationLng';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationStreetErrorComponent = {
  attr: 'DestinationStreet';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationSuiteErrorComponent = {
  attr: 'DestinationSuite';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationCityErrorComponent = {
  attr: 'DestinationCity';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationStateErrorComponent = {
  attr: 'DestinationState';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationPostalErrorComponent = {
  attr: 'DestinationPostal';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationCountyErrorComponent = {
  attr: 'DestinationCounty';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationPhoneErrorComponent = {
  attr: 'DestinationPhone';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateDestinationCommentsErrorComponent = {
  attr: 'DestinationComments';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersCtcTripCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'TripID';
    } & BrokersCtcTripCreateTripIdErrorComponent)
  | ({
      attr: 'SubContractor';
    } & BrokersCtcTripCreateSubContractorErrorComponent)
  | ({
      attr: 'RequestType';
    } & BrokersCtcTripCreateRequestTypeErrorComponent)
  | ({
      attr: 'ManifestType';
    } & BrokersCtcTripCreateManifestTypeErrorComponent)
  | ({
      attr: 'DateOfService';
    } & BrokersCtcTripCreateDateOfServiceErrorComponent)
  | ({
      attr: 'AppointmentTime';
    } & BrokersCtcTripCreateAppointmentTimeErrorComponent)
  | ({
      attr: 'PickupTime';
    } & BrokersCtcTripCreatePickupTimeErrorComponent)
  | ({
      attr: 'LOS';
    } & BrokersCtcTripCreateLosErrorComponent)
  | ({
      attr: 'Status';
    } & BrokersCtcTripCreateStatusErrorComponent)
  | ({
      attr: 'EstMiles';
    } & BrokersCtcTripCreateEstMilesErrorComponent)
  | ({
      attr: 'Escorts';
    } & BrokersCtcTripCreateEscortsErrorComponent)
  | ({
      attr: 'StandingOrderDays';
    } & BrokersCtcTripCreateStandingOrderDaysErrorComponent)
  | ({
      attr: 'Dialysis';
    } & BrokersCtcTripCreateDialysisErrorComponent)
  | ({
      attr: 'DialysisDays';
    } & BrokersCtcTripCreateDialysisDaysErrorComponent)
  | ({
      attr: 'Tags';
    } & BrokersCtcTripCreateTagsErrorComponent)
  | ({
      attr: 'UniqueId';
    } & BrokersCtcTripCreateUniqueIdErrorComponent)
  | ({
      attr: 'FirstName';
    } & BrokersCtcTripCreateFirstNameErrorComponent)
  | ({
      attr: 'LastName';
    } & BrokersCtcTripCreateLastNameErrorComponent)
  | ({
      attr: 'Gender';
    } & BrokersCtcTripCreateGenderErrorComponent)
  | ({
      attr: 'DateOfBirth';
    } & BrokersCtcTripCreateDateOfBirthErrorComponent)
  | ({
      attr: 'Heightfeet';
    } & BrokersCtcTripCreateHeightfeetErrorComponent)
  | ({
      attr: 'HomeNumber';
    } & BrokersCtcTripCreateHomeNumberErrorComponent)
  | ({
      attr: 'OriginName';
    } & BrokersCtcTripCreateOriginNameErrorComponent)
  | ({
      attr: 'OriginLat';
    } & BrokersCtcTripCreateOriginLatErrorComponent)
  | ({
      attr: 'OriginLng';
    } & BrokersCtcTripCreateOriginLngErrorComponent)
  | ({
      attr: 'OriginStreet';
    } & BrokersCtcTripCreateOriginStreetErrorComponent)
  | ({
      attr: 'OriginSuite';
    } & BrokersCtcTripCreateOriginSuiteErrorComponent)
  | ({
      attr: 'OriginCity';
    } & BrokersCtcTripCreateOriginCityErrorComponent)
  | ({
      attr: 'OriginState';
    } & BrokersCtcTripCreateOriginStateErrorComponent)
  | ({
      attr: 'OriginPostal';
    } & BrokersCtcTripCreateOriginPostalErrorComponent)
  | ({
      attr: 'OriginCounty';
    } & BrokersCtcTripCreateOriginCountyErrorComponent)
  | ({
      attr: 'OriginPhone';
    } & BrokersCtcTripCreateOriginPhoneErrorComponent)
  | ({
      attr: 'OriginComments';
    } & BrokersCtcTripCreateOriginCommentsErrorComponent)
  | ({
      attr: 'DestinationName';
    } & BrokersCtcTripCreateDestinationNameErrorComponent)
  | ({
      attr: 'DestinationLat';
    } & BrokersCtcTripCreateDestinationLatErrorComponent)
  | ({
      attr: 'DestinationLng';
    } & BrokersCtcTripCreateDestinationLngErrorComponent)
  | ({
      attr: 'DestinationStreet';
    } & BrokersCtcTripCreateDestinationStreetErrorComponent)
  | ({
      attr: 'DestinationSuite';
    } & BrokersCtcTripCreateDestinationSuiteErrorComponent)
  | ({
      attr: 'DestinationCity';
    } & BrokersCtcTripCreateDestinationCityErrorComponent)
  | ({
      attr: 'DestinationState';
    } & BrokersCtcTripCreateDestinationStateErrorComponent)
  | ({
      attr: 'DestinationPostal';
    } & BrokersCtcTripCreateDestinationPostalErrorComponent)
  | ({
      attr: 'DestinationCounty';
    } & BrokersCtcTripCreateDestinationCountyErrorComponent)
  | ({
      attr: 'DestinationPhone';
    } & BrokersCtcTripCreateDestinationPhoneErrorComponent)
  | ({
      attr: 'DestinationComments';
    } & BrokersCtcTripCreateDestinationCommentsErrorComponent);
export type BrokersCtcTripCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersCtcTripCreateError[];
};
export type BrokersCtcTripCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersCtcTripCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type CtcTripActivateWillCall = {};
export type CtcTripActivateWillCallRead = {
  message: string;
  id: string;
  intermediary_id: string;
};
export type CtcTripActivateWillCallWrite = {
  /** CTC's internal ID for the trip */
  TripID: string;
};
export type BrokersCtcTripActivationCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersCtcTripActivationCreateTripIdErrorComponent = {
  attr: 'TripID';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripActivationCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersCtcTripActivationCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'TripID';
    } & BrokersCtcTripActivationCreateTripIdErrorComponent);
export type BrokersCtcTripActivationCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersCtcTripActivationCreateError[];
};
export type BrokersCtcTripActivationCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersCtcTripActivationCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type CtcTripCancel = {};
export type CtcTripCancelRead = {
  message: string;
  id: string;
  intermediary_id: string;
};
export type CtcTripCancelWrite = {
  /** CTC's internal ID for the trip */
  TripID: string;
};
export type BrokersCtcTripCancelCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersCtcTripCancelCreateTripIdErrorComponent = {
  attr: 'TripID';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersCtcTripCancelCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersCtcTripCancelCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'TripID';
    } & BrokersCtcTripCancelCreateTripIdErrorComponent);
export type BrokersCtcTripCancelCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersCtcTripCancelCreateError[];
};
export type BrokersCtcTripCancelCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersCtcTripCancelCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BrokersExampleHelloWorldRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type KinetikOAuthToken = {};
export type KinetikOAuthTokenRead = {
  apiKey: string;
  apiSecret: string;
};
export type BrokersKinetikOauth2TokenCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersKinetikOauth2TokenCreateError = {
  attr: 'non_field_errors';
} & BrokersKinetikOauth2TokenCreateNonFieldErrorsErrorComponent;
export type BrokersKinetikOauth2TokenCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersKinetikOauth2TokenCreateError[];
};
export type BrokersKinetikOauth2TokenCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersKinetikOauth2TokenCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type KinetikRideReadOnly = {
  /** Unique ID for the trip from Kinetik */
  id: string;
  /** Unique ID for the transport provider from Kinetik */
  transportationProviderId: string;
};
export type BrokersKinetikV1CancelRideCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersKinetikV1CancelRideCreateIdErrorComponent = {
  attr: 'id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CancelRideCreateTransportationProviderIdErrorComponent =
  {
    attr: 'transportationProviderId';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CancelRideCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersKinetikV1CancelRideCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & BrokersKinetikV1CancelRideCreateIdErrorComponent)
  | ({
      attr: 'transportationProviderId';
    } & BrokersKinetikV1CancelRideCreateTransportationProviderIdErrorComponent);
export type BrokersKinetikV1CancelRideCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersKinetikV1CancelRideCreateError[];
};
export type BrokersKinetikV1CancelRideCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersKinetikV1CancelRideCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripTypeEnum = 'WillCall' | 'Appointment';
export type KinetikAddress = {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
  plusCode?: string | null;
  longitude?: number | null;
  latitude?: number | null;
};
export type KinetikAdditionalPassengers = {
  adultCount?: number | null;
  childCount?: number | null;
};
export type VehicleTypeEnum =
  | 'Ambulance'
  | 'Wheelchair'
  | 'Sedan'
  | 'Bus'
  | 'Minivan'
  | 'Stretcher'
  | 'Taxi'
  | 'Other';
export type KinetikProcedureCode = {
  procedureCode?: string | null;
  mod?: string | null;
};
export type DesignationEnum = 'facility' | 'patient' | 'pickup' | 'dropoff';
export type KinetikPhoneNumber = {
  number: string;
  extension?: string | null;
  designation: DesignationEnum;
  phonetype?: string | null;
};
export type KinetikRide = {
  patientName: string;
  patientPhone?: string | null;
  /** Kinetik's passenger ID */
  patientId: string;
  /** Kinetik's payer ID */
  accountId: string;
  /** Unique ID for the trip from Kinetik */
  id: string;
  /** Unique ID for the trip from the broker */
  referenceId: string;
  /** Unique ID for the transport provider from Kinetik */
  transportationProviderId: string;
  tripType: TripTypeEnum;
  pickupDateTime: string;
  dropoffDateTime?: string | null;
  pickupAddress: KinetikAddress;
  dropoffAddress: KinetikAddress;
  mileage: number;
  additionalPassengers?: KinetikAdditionalPassengers | null;
  chargeAmount?: number | null;
  vehicleType: VehicleTypeEnum;
  /** Trip instructions if any */
  instructions?: string | null;
  preferredDriverId?: string | null;
  procedureCodes?: KinetikProcedureCode[] | null;
  phoneNumbers: KinetikPhoneNumber[];
};
export type BrokersKinetikV1CreateRidesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreatePatientNameErrorComponent = {
  attr: 'patientName';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreatePatientPhoneErrorComponent = {
  attr: 'patientPhone';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreatePatientIdErrorComponent = {
  attr: 'patientId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreateAccountIdErrorComponent = {
  attr: 'accountId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreateIdErrorComponent = {
  attr: 'id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreateReferenceIdErrorComponent = {
  attr: 'referenceId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreateTransportationProviderIdErrorComponent =
  {
    attr: 'transportationProviderId';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateTripTypeErrorComponent = {
  attr: 'tripType';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreatePickupDateTimeErrorComponent = {
  attr: 'pickupDateTime';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreateDropoffDateTimeErrorComponent = {
  attr: 'dropoffDateTime';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreatePickupAddressNonFieldErrorsErrorComponent =
  {
    attr: 'pickupAddress.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePickupAddressAddress1ErrorComponent =
  {
    attr: 'pickupAddress.address1';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePickupAddressAddress2ErrorComponent =
  {
    attr: 'pickupAddress.address2';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePickupAddressCityErrorComponent = {
  attr: 'pickupAddress.city';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreatePickupAddressStateErrorComponent =
  {
    attr: 'pickupAddress.state';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePickupAddressZipErrorComponent = {
  attr: 'pickupAddress.zip';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreatePickupAddressCountryErrorComponent =
  {
    attr: 'pickupAddress.country';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePickupAddressPlusCodeErrorComponent =
  {
    attr: 'pickupAddress.plusCode';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePickupAddressLongitudeErrorComponent =
  {
    attr: 'pickupAddress.longitude';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePickupAddressLatitudeErrorComponent =
  {
    attr: 'pickupAddress.latitude';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateDropoffAddressNonFieldErrorsErrorComponent =
  {
    attr: 'dropoffAddress.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateDropoffAddressAddress1ErrorComponent =
  {
    attr: 'dropoffAddress.address1';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateDropoffAddressAddress2ErrorComponent =
  {
    attr: 'dropoffAddress.address2';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateDropoffAddressCityErrorComponent =
  {
    attr: 'dropoffAddress.city';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateDropoffAddressStateErrorComponent =
  {
    attr: 'dropoffAddress.state';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateDropoffAddressZipErrorComponent = {
  attr: 'dropoffAddress.zip';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreateDropoffAddressCountryErrorComponent =
  {
    attr: 'dropoffAddress.country';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateDropoffAddressPlusCodeErrorComponent =
  {
    attr: 'dropoffAddress.plusCode';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateDropoffAddressLongitudeErrorComponent =
  {
    attr: 'dropoffAddress.longitude';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateDropoffAddressLatitudeErrorComponent =
  {
    attr: 'dropoffAddress.latitude';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateMileageErrorComponent = {
  attr: 'mileage';
  code: 'invalid' | 'max_string_length' | 'min_value' | 'null' | 'required';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreateAdditionalPassengersNonFieldErrorsErrorComponent =
  {
    attr: 'additionalPassengers.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateAdditionalPassengersAdultCountErrorComponent =
  {
    attr: 'additionalPassengers.adultCount';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateAdditionalPassengersChildCountErrorComponent =
  {
    attr: 'additionalPassengers.childCount';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateChargeAmountErrorComponent = {
  attr: 'chargeAmount';
  code: 'invalid' | 'max_string_length' | 'min_value';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreateVehicleTypeErrorComponent = {
  attr: 'vehicleType';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreateInstructionsErrorComponent = {
  attr: 'instructions';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreatePreferredDriverIdErrorComponent = {
  attr: 'preferredDriverId';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1CreateRidesCreateProcedureCodesNonFieldErrorsErrorComponent =
  {
    attr: 'procedureCodes.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateProcedureCodesIndexNonFieldErrorsErrorComponent =
  {
    attr: 'procedureCodes.INDEX.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateProcedureCodesIndexProcedureCodeErrorComponent =
  {
    attr: 'procedureCodes.INDEX.procedureCode';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateProcedureCodesIndexModErrorComponent =
  {
    attr: 'procedureCodes.INDEX.mod';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePhoneNumbersNonFieldErrorsErrorComponent =
  {
    attr: 'phoneNumbers.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePhoneNumbersIndexNonFieldErrorsErrorComponent =
  {
    attr: 'phoneNumbers.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePhoneNumbersIndexNumberErrorComponent =
  {
    attr: 'phoneNumbers.INDEX.number';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePhoneNumbersIndexExtensionErrorComponent =
  {
    attr: 'phoneNumbers.INDEX.extension';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePhoneNumbersIndexDesignationErrorComponent =
  {
    attr: 'phoneNumbers.INDEX.designation';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreatePhoneNumbersIndexPhonetypeErrorComponent =
  {
    attr: 'phoneNumbers.INDEX.phonetype';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1CreateRidesCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersKinetikV1CreateRidesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'patientName';
    } & BrokersKinetikV1CreateRidesCreatePatientNameErrorComponent)
  | ({
      attr: 'patientPhone';
    } & BrokersKinetikV1CreateRidesCreatePatientPhoneErrorComponent)
  | ({
      attr: 'patientId';
    } & BrokersKinetikV1CreateRidesCreatePatientIdErrorComponent)
  | ({
      attr: 'accountId';
    } & BrokersKinetikV1CreateRidesCreateAccountIdErrorComponent)
  | ({
      attr: 'id';
    } & BrokersKinetikV1CreateRidesCreateIdErrorComponent)
  | ({
      attr: 'referenceId';
    } & BrokersKinetikV1CreateRidesCreateReferenceIdErrorComponent)
  | ({
      attr: 'transportationProviderId';
    } & BrokersKinetikV1CreateRidesCreateTransportationProviderIdErrorComponent)
  | ({
      attr: 'tripType';
    } & BrokersKinetikV1CreateRidesCreateTripTypeErrorComponent)
  | ({
      attr: 'pickupDateTime';
    } & BrokersKinetikV1CreateRidesCreatePickupDateTimeErrorComponent)
  | ({
      attr: 'dropoffDateTime';
    } & BrokersKinetikV1CreateRidesCreateDropoffDateTimeErrorComponent)
  | ({
      attr: 'pickupAddress.non_field_errors';
    } & BrokersKinetikV1CreateRidesCreatePickupAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickupAddress.address1';
    } & BrokersKinetikV1CreateRidesCreatePickupAddressAddress1ErrorComponent)
  | ({
      attr: 'pickupAddress.address2';
    } & BrokersKinetikV1CreateRidesCreatePickupAddressAddress2ErrorComponent)
  | ({
      attr: 'pickupAddress.city';
    } & BrokersKinetikV1CreateRidesCreatePickupAddressCityErrorComponent)
  | ({
      attr: 'pickupAddress.state';
    } & BrokersKinetikV1CreateRidesCreatePickupAddressStateErrorComponent)
  | ({
      attr: 'pickupAddress.zip';
    } & BrokersKinetikV1CreateRidesCreatePickupAddressZipErrorComponent)
  | ({
      attr: 'pickupAddress.country';
    } & BrokersKinetikV1CreateRidesCreatePickupAddressCountryErrorComponent)
  | ({
      attr: 'pickupAddress.plusCode';
    } & BrokersKinetikV1CreateRidesCreatePickupAddressPlusCodeErrorComponent)
  | ({
      attr: 'pickupAddress.longitude';
    } & BrokersKinetikV1CreateRidesCreatePickupAddressLongitudeErrorComponent)
  | ({
      attr: 'pickupAddress.latitude';
    } & BrokersKinetikV1CreateRidesCreatePickupAddressLatitudeErrorComponent)
  | ({
      attr: 'dropoffAddress.non_field_errors';
    } & BrokersKinetikV1CreateRidesCreateDropoffAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'dropoffAddress.address1';
    } & BrokersKinetikV1CreateRidesCreateDropoffAddressAddress1ErrorComponent)
  | ({
      attr: 'dropoffAddress.address2';
    } & BrokersKinetikV1CreateRidesCreateDropoffAddressAddress2ErrorComponent)
  | ({
      attr: 'dropoffAddress.city';
    } & BrokersKinetikV1CreateRidesCreateDropoffAddressCityErrorComponent)
  | ({
      attr: 'dropoffAddress.state';
    } & BrokersKinetikV1CreateRidesCreateDropoffAddressStateErrorComponent)
  | ({
      attr: 'dropoffAddress.zip';
    } & BrokersKinetikV1CreateRidesCreateDropoffAddressZipErrorComponent)
  | ({
      attr: 'dropoffAddress.country';
    } & BrokersKinetikV1CreateRidesCreateDropoffAddressCountryErrorComponent)
  | ({
      attr: 'dropoffAddress.plusCode';
    } & BrokersKinetikV1CreateRidesCreateDropoffAddressPlusCodeErrorComponent)
  | ({
      attr: 'dropoffAddress.longitude';
    } & BrokersKinetikV1CreateRidesCreateDropoffAddressLongitudeErrorComponent)
  | ({
      attr: 'dropoffAddress.latitude';
    } & BrokersKinetikV1CreateRidesCreateDropoffAddressLatitudeErrorComponent)
  | ({
      attr: 'mileage';
    } & BrokersKinetikV1CreateRidesCreateMileageErrorComponent)
  | ({
      attr: 'additionalPassengers.non_field_errors';
    } & BrokersKinetikV1CreateRidesCreateAdditionalPassengersNonFieldErrorsErrorComponent)
  | ({
      attr: 'additionalPassengers.adultCount';
    } & BrokersKinetikV1CreateRidesCreateAdditionalPassengersAdultCountErrorComponent)
  | ({
      attr: 'additionalPassengers.childCount';
    } & BrokersKinetikV1CreateRidesCreateAdditionalPassengersChildCountErrorComponent)
  | ({
      attr: 'chargeAmount';
    } & BrokersKinetikV1CreateRidesCreateChargeAmountErrorComponent)
  | ({
      attr: 'vehicleType';
    } & BrokersKinetikV1CreateRidesCreateVehicleTypeErrorComponent)
  | ({
      attr: 'instructions';
    } & BrokersKinetikV1CreateRidesCreateInstructionsErrorComponent)
  | ({
      attr: 'preferredDriverId';
    } & BrokersKinetikV1CreateRidesCreatePreferredDriverIdErrorComponent)
  | ({
      attr: 'procedureCodes.non_field_errors';
    } & BrokersKinetikV1CreateRidesCreateProcedureCodesNonFieldErrorsErrorComponent)
  | ({
      attr: 'procedureCodes.INDEX.non_field_errors';
    } & BrokersKinetikV1CreateRidesCreateProcedureCodesIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'procedureCodes.INDEX.procedureCode';
    } & BrokersKinetikV1CreateRidesCreateProcedureCodesIndexProcedureCodeErrorComponent)
  | ({
      attr: 'procedureCodes.INDEX.mod';
    } & BrokersKinetikV1CreateRidesCreateProcedureCodesIndexModErrorComponent)
  | ({
      attr: 'phoneNumbers.non_field_errors';
    } & BrokersKinetikV1CreateRidesCreatePhoneNumbersNonFieldErrorsErrorComponent)
  | ({
      attr: 'phoneNumbers.INDEX.non_field_errors';
    } & BrokersKinetikV1CreateRidesCreatePhoneNumbersIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'phoneNumbers.INDEX.number';
    } & BrokersKinetikV1CreateRidesCreatePhoneNumbersIndexNumberErrorComponent)
  | ({
      attr: 'phoneNumbers.INDEX.extension';
    } & BrokersKinetikV1CreateRidesCreatePhoneNumbersIndexExtensionErrorComponent)
  | ({
      attr: 'phoneNumbers.INDEX.designation';
    } & BrokersKinetikV1CreateRidesCreatePhoneNumbersIndexDesignationErrorComponent)
  | ({
      attr: 'phoneNumbers.INDEX.phonetype';
    } & BrokersKinetikV1CreateRidesCreatePhoneNumbersIndexPhonetypeErrorComponent);
export type BrokersKinetikV1CreateRidesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersKinetikV1CreateRidesCreateError[];
};
export type BrokersKinetikV1CreateRidesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersKinetikV1CreateRidesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type KinetikDriver = {
  /** Our unique identifier for the driver */
  id: string;
};
export type KinetikDriverRead = {
  /** Our unique identifier for the driver */
  id: string;
  firstName: string;
  lastName: string;
  licenseNumber: string | null;
  licenseState: string | null;
  phoneNumber: string;
};
export type BrokersKinetikV1GetDriverCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersKinetikV1GetDriverCreateIdErrorComponent = {
  attr: 'id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1GetDriverCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersKinetikV1GetDriverCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & BrokersKinetikV1GetDriverCreateIdErrorComponent);
export type BrokersKinetikV1GetDriverCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersKinetikV1GetDriverCreateError[];
};
export type BrokersKinetikV1GetDriverCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersKinetikV1GetDriverCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BrokersKinetikV1GetRideCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersKinetikV1GetRideCreateIdErrorComponent = {
  attr: 'id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1GetRideCreateTransportationProviderIdErrorComponent =
  {
    attr: 'transportationProviderId';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1GetRideCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersKinetikV1GetRideCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & BrokersKinetikV1GetRideCreateIdErrorComponent)
  | ({
      attr: 'transportationProviderId';
    } & BrokersKinetikV1GetRideCreateTransportationProviderIdErrorComponent);
export type BrokersKinetikV1GetRideCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersKinetikV1GetRideCreateError[];
};
export type BrokersKinetikV1GetRideCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersKinetikV1GetRideCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type KinetikVehicle = {
  /** Our unique identifier for the vehicle */
  id: string;
};
export type KinetikVehicleRead = {
  /** Our unique identifier for the vehicle */
  id: string;
  vin: string;
  licensePlate: string;
  licenseState: string;
};
export type BrokersKinetikV1GetVehicleCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersKinetikV1GetVehicleCreateIdErrorComponent = {
  attr: 'id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1GetVehicleCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersKinetikV1GetVehicleCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & BrokersKinetikV1GetVehicleCreateIdErrorComponent);
export type BrokersKinetikV1GetVehicleCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersKinetikV1GetVehicleCreateError[];
};
export type BrokersKinetikV1GetVehicleCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersKinetikV1GetVehicleCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BrokersKinetikV1UpdateRidesUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdatePatientNameErrorComponent = {
  attr: 'patientName';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdatePatientPhoneErrorComponent = {
  attr: 'patientPhone';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdatePatientIdErrorComponent = {
  attr: 'patientId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdateAccountIdErrorComponent = {
  attr: 'accountId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdateIdErrorComponent = {
  attr: 'id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdateReferenceIdErrorComponent = {
  attr: 'referenceId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdateTransportationProviderIdErrorComponent =
  {
    attr: 'transportationProviderId';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateTripTypeErrorComponent = {
  attr: 'tripType';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdatePickupDateTimeErrorComponent = {
  attr: 'pickupDateTime';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdateDropoffDateTimeErrorComponent = {
  attr: 'dropoffDateTime';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdatePickupAddressNonFieldErrorsErrorComponent =
  {
    attr: 'pickupAddress.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePickupAddressAddress1ErrorComponent =
  {
    attr: 'pickupAddress.address1';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePickupAddressAddress2ErrorComponent =
  {
    attr: 'pickupAddress.address2';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePickupAddressCityErrorComponent = {
  attr: 'pickupAddress.city';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdatePickupAddressStateErrorComponent =
  {
    attr: 'pickupAddress.state';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePickupAddressZipErrorComponent = {
  attr: 'pickupAddress.zip';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdatePickupAddressCountryErrorComponent =
  {
    attr: 'pickupAddress.country';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePickupAddressPlusCodeErrorComponent =
  {
    attr: 'pickupAddress.plusCode';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePickupAddressLongitudeErrorComponent =
  {
    attr: 'pickupAddress.longitude';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePickupAddressLatitudeErrorComponent =
  {
    attr: 'pickupAddress.latitude';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateDropoffAddressNonFieldErrorsErrorComponent =
  {
    attr: 'dropoffAddress.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateDropoffAddressAddress1ErrorComponent =
  {
    attr: 'dropoffAddress.address1';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateDropoffAddressAddress2ErrorComponent =
  {
    attr: 'dropoffAddress.address2';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateDropoffAddressCityErrorComponent =
  {
    attr: 'dropoffAddress.city';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateDropoffAddressStateErrorComponent =
  {
    attr: 'dropoffAddress.state';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateDropoffAddressZipErrorComponent = {
  attr: 'dropoffAddress.zip';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdateDropoffAddressCountryErrorComponent =
  {
    attr: 'dropoffAddress.country';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateDropoffAddressPlusCodeErrorComponent =
  {
    attr: 'dropoffAddress.plusCode';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateDropoffAddressLongitudeErrorComponent =
  {
    attr: 'dropoffAddress.longitude';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateDropoffAddressLatitudeErrorComponent =
  {
    attr: 'dropoffAddress.latitude';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateMileageErrorComponent = {
  attr: 'mileage';
  code: 'invalid' | 'max_string_length' | 'min_value' | 'null' | 'required';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdateAdditionalPassengersNonFieldErrorsErrorComponent =
  {
    attr: 'additionalPassengers.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateAdditionalPassengersAdultCountErrorComponent =
  {
    attr: 'additionalPassengers.adultCount';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateAdditionalPassengersChildCountErrorComponent =
  {
    attr: 'additionalPassengers.childCount';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateChargeAmountErrorComponent = {
  attr: 'chargeAmount';
  code: 'invalid' | 'max_string_length' | 'min_value';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdateVehicleTypeErrorComponent = {
  attr: 'vehicleType';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdateInstructionsErrorComponent = {
  attr: 'instructions';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdatePreferredDriverIdErrorComponent = {
  attr: 'preferredDriverId';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersKinetikV1UpdateRidesUpdateProcedureCodesNonFieldErrorsErrorComponent =
  {
    attr: 'procedureCodes.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateProcedureCodesIndexNonFieldErrorsErrorComponent =
  {
    attr: 'procedureCodes.INDEX.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateProcedureCodesIndexProcedureCodeErrorComponent =
  {
    attr: 'procedureCodes.INDEX.procedureCode';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateProcedureCodesIndexModErrorComponent =
  {
    attr: 'procedureCodes.INDEX.mod';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePhoneNumbersNonFieldErrorsErrorComponent =
  {
    attr: 'phoneNumbers.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePhoneNumbersIndexNonFieldErrorsErrorComponent =
  {
    attr: 'phoneNumbers.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePhoneNumbersIndexNumberErrorComponent =
  {
    attr: 'phoneNumbers.INDEX.number';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePhoneNumbersIndexExtensionErrorComponent =
  {
    attr: 'phoneNumbers.INDEX.extension';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePhoneNumbersIndexDesignationErrorComponent =
  {
    attr: 'phoneNumbers.INDEX.designation';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdatePhoneNumbersIndexPhonetypeErrorComponent =
  {
    attr: 'phoneNumbers.INDEX.phonetype';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersKinetikV1UpdateRidesUpdateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersKinetikV1UpdateRidesUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'patientName';
    } & BrokersKinetikV1UpdateRidesUpdatePatientNameErrorComponent)
  | ({
      attr: 'patientPhone';
    } & BrokersKinetikV1UpdateRidesUpdatePatientPhoneErrorComponent)
  | ({
      attr: 'patientId';
    } & BrokersKinetikV1UpdateRidesUpdatePatientIdErrorComponent)
  | ({
      attr: 'accountId';
    } & BrokersKinetikV1UpdateRidesUpdateAccountIdErrorComponent)
  | ({
      attr: 'id';
    } & BrokersKinetikV1UpdateRidesUpdateIdErrorComponent)
  | ({
      attr: 'referenceId';
    } & BrokersKinetikV1UpdateRidesUpdateReferenceIdErrorComponent)
  | ({
      attr: 'transportationProviderId';
    } & BrokersKinetikV1UpdateRidesUpdateTransportationProviderIdErrorComponent)
  | ({
      attr: 'tripType';
    } & BrokersKinetikV1UpdateRidesUpdateTripTypeErrorComponent)
  | ({
      attr: 'pickupDateTime';
    } & BrokersKinetikV1UpdateRidesUpdatePickupDateTimeErrorComponent)
  | ({
      attr: 'dropoffDateTime';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffDateTimeErrorComponent)
  | ({
      attr: 'pickupAddress.non_field_errors';
    } & BrokersKinetikV1UpdateRidesUpdatePickupAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickupAddress.address1';
    } & BrokersKinetikV1UpdateRidesUpdatePickupAddressAddress1ErrorComponent)
  | ({
      attr: 'pickupAddress.address2';
    } & BrokersKinetikV1UpdateRidesUpdatePickupAddressAddress2ErrorComponent)
  | ({
      attr: 'pickupAddress.city';
    } & BrokersKinetikV1UpdateRidesUpdatePickupAddressCityErrorComponent)
  | ({
      attr: 'pickupAddress.state';
    } & BrokersKinetikV1UpdateRidesUpdatePickupAddressStateErrorComponent)
  | ({
      attr: 'pickupAddress.zip';
    } & BrokersKinetikV1UpdateRidesUpdatePickupAddressZipErrorComponent)
  | ({
      attr: 'pickupAddress.country';
    } & BrokersKinetikV1UpdateRidesUpdatePickupAddressCountryErrorComponent)
  | ({
      attr: 'pickupAddress.plusCode';
    } & BrokersKinetikV1UpdateRidesUpdatePickupAddressPlusCodeErrorComponent)
  | ({
      attr: 'pickupAddress.longitude';
    } & BrokersKinetikV1UpdateRidesUpdatePickupAddressLongitudeErrorComponent)
  | ({
      attr: 'pickupAddress.latitude';
    } & BrokersKinetikV1UpdateRidesUpdatePickupAddressLatitudeErrorComponent)
  | ({
      attr: 'dropoffAddress.non_field_errors';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'dropoffAddress.address1';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffAddressAddress1ErrorComponent)
  | ({
      attr: 'dropoffAddress.address2';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffAddressAddress2ErrorComponent)
  | ({
      attr: 'dropoffAddress.city';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffAddressCityErrorComponent)
  | ({
      attr: 'dropoffAddress.state';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffAddressStateErrorComponent)
  | ({
      attr: 'dropoffAddress.zip';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffAddressZipErrorComponent)
  | ({
      attr: 'dropoffAddress.country';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffAddressCountryErrorComponent)
  | ({
      attr: 'dropoffAddress.plusCode';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffAddressPlusCodeErrorComponent)
  | ({
      attr: 'dropoffAddress.longitude';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffAddressLongitudeErrorComponent)
  | ({
      attr: 'dropoffAddress.latitude';
    } & BrokersKinetikV1UpdateRidesUpdateDropoffAddressLatitudeErrorComponent)
  | ({
      attr: 'mileage';
    } & BrokersKinetikV1UpdateRidesUpdateMileageErrorComponent)
  | ({
      attr: 'additionalPassengers.non_field_errors';
    } & BrokersKinetikV1UpdateRidesUpdateAdditionalPassengersNonFieldErrorsErrorComponent)
  | ({
      attr: 'additionalPassengers.adultCount';
    } & BrokersKinetikV1UpdateRidesUpdateAdditionalPassengersAdultCountErrorComponent)
  | ({
      attr: 'additionalPassengers.childCount';
    } & BrokersKinetikV1UpdateRidesUpdateAdditionalPassengersChildCountErrorComponent)
  | ({
      attr: 'chargeAmount';
    } & BrokersKinetikV1UpdateRidesUpdateChargeAmountErrorComponent)
  | ({
      attr: 'vehicleType';
    } & BrokersKinetikV1UpdateRidesUpdateVehicleTypeErrorComponent)
  | ({
      attr: 'instructions';
    } & BrokersKinetikV1UpdateRidesUpdateInstructionsErrorComponent)
  | ({
      attr: 'preferredDriverId';
    } & BrokersKinetikV1UpdateRidesUpdatePreferredDriverIdErrorComponent)
  | ({
      attr: 'procedureCodes.non_field_errors';
    } & BrokersKinetikV1UpdateRidesUpdateProcedureCodesNonFieldErrorsErrorComponent)
  | ({
      attr: 'procedureCodes.INDEX.non_field_errors';
    } & BrokersKinetikV1UpdateRidesUpdateProcedureCodesIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'procedureCodes.INDEX.procedureCode';
    } & BrokersKinetikV1UpdateRidesUpdateProcedureCodesIndexProcedureCodeErrorComponent)
  | ({
      attr: 'procedureCodes.INDEX.mod';
    } & BrokersKinetikV1UpdateRidesUpdateProcedureCodesIndexModErrorComponent)
  | ({
      attr: 'phoneNumbers.non_field_errors';
    } & BrokersKinetikV1UpdateRidesUpdatePhoneNumbersNonFieldErrorsErrorComponent)
  | ({
      attr: 'phoneNumbers.INDEX.non_field_errors';
    } & BrokersKinetikV1UpdateRidesUpdatePhoneNumbersIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'phoneNumbers.INDEX.number';
    } & BrokersKinetikV1UpdateRidesUpdatePhoneNumbersIndexNumberErrorComponent)
  | ({
      attr: 'phoneNumbers.INDEX.extension';
    } & BrokersKinetikV1UpdateRidesUpdatePhoneNumbersIndexExtensionErrorComponent)
  | ({
      attr: 'phoneNumbers.INDEX.designation';
    } & BrokersKinetikV1UpdateRidesUpdatePhoneNumbersIndexDesignationErrorComponent)
  | ({
      attr: 'phoneNumbers.INDEX.phonetype';
    } & BrokersKinetikV1UpdateRidesUpdatePhoneNumbersIndexPhonetypeErrorComponent);
export type BrokersKinetikV1UpdateRidesUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersKinetikV1UpdateRidesUpdateError[];
};
export type BrokersKinetikV1UpdateRidesUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersKinetikV1UpdateRidesUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MediDriveOAuthToken = {};
export type MediDriveOAuthTokenRead = {
  access_token: string;
  expires_in: number;
  token_type: TokenTypeEnum;
};
export type MediDriveOAuthTokenWrite = {
  client_id: string;
  client_secret: string;
  grant_type: GrantTypeEnum;
};
export type BrokersMedidriveOauth2TokenCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersMedidriveOauth2TokenCreateClientIdErrorComponent = {
  attr: 'client_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMedidriveOauth2TokenCreateClientSecretErrorComponent = {
  attr: 'client_secret';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMedidriveOauth2TokenCreateGrantTypeErrorComponent = {
  attr: 'grant_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersMedidriveOauth2TokenCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMedidriveOauth2TokenCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersMedidriveOauth2TokenCreateClientIdErrorComponent)
  | ({
      attr: 'client_secret';
    } & BrokersMedidriveOauth2TokenCreateClientSecretErrorComponent)
  | ({
      attr: 'grant_type';
    } & BrokersMedidriveOauth2TokenCreateGrantTypeErrorComponent);
export type BrokersMedidriveOauth2TokenCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMedidriveOauth2TokenCreateError[];
};
export type BrokersMedidriveOauth2TokenCreateErrorResponse400 = {
  type: 'validation_error';
} & BrokersMedidriveOauth2TokenCreateValidationError;
export type BrokerNameEnum = 'cts' | 'welltrans' | 'tennessee_carriers';
export type MomentmBrokerAuth = {
  /** Momentm username for organization+broker pair */
  username: string;
  /** Name for broker, used for auth and maps to the trip intermediary */
  broker_name: BrokerNameEnum;
  /** IANA time zone standard, (ex. America/Los_Angeles, America/New_York) that broker is in, all times from momentm are relative to this tz */
  broker_time_zone_name?: string;
  payer: string;
  /** Momentm api_url for organization+broker pair */
  api_url?: string;
};
export type MomentmBrokerAuthRead = {
  id: string;
  organization: string;
  /** Momentm username for organization+broker pair */
  username: string;
  /** Name for broker, used for auth and maps to the trip intermediary */
  broker_name: BrokerNameEnum;
  /** IANA time zone standard, (ex. America/Los_Angeles, America/New_York) that broker is in, all times from momentm are relative to this tz */
  broker_time_zone_name?: string;
  payer: string;
  /** Momentm api_url for organization+broker pair */
  api_url?: string;
};
export type PaginatedMomentmBrokerAuthList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MomentmBrokerAuth[];
};
export type PaginatedMomentmBrokerAuthListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MomentmBrokerAuthRead[];
};
export type BrokersMomentmBrokerAuthListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BrokersMomentmBrokerAuthCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersMomentmBrokerAuthCreateUsernameErrorComponent = {
  attr: 'username';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmBrokerAuthCreateBrokerNameErrorComponent = {
  attr: 'broker_name';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersMomentmBrokerAuthCreateBrokerTimeZoneNameErrorComponent = {
  attr: 'broker_time_zone_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmBrokerAuthCreatePayerErrorComponent = {
  attr: 'payer';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required' | 'unique';
  detail: string;
};
export type BrokersMomentmBrokerAuthCreateApiUrlErrorComponent = {
  attr: 'api_url';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmBrokerAuthCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMomentmBrokerAuthCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'username';
    } & BrokersMomentmBrokerAuthCreateUsernameErrorComponent)
  | ({
      attr: 'broker_name';
    } & BrokersMomentmBrokerAuthCreateBrokerNameErrorComponent)
  | ({
      attr: 'broker_time_zone_name';
    } & BrokersMomentmBrokerAuthCreateBrokerTimeZoneNameErrorComponent)
  | ({
      attr: 'payer';
    } & BrokersMomentmBrokerAuthCreatePayerErrorComponent)
  | ({
      attr: 'api_url';
    } & BrokersMomentmBrokerAuthCreateApiUrlErrorComponent);
export type BrokersMomentmBrokerAuthCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMomentmBrokerAuthCreateError[];
};
export type BrokersMomentmBrokerAuthCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMomentmBrokerAuthCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BrokersMomentmBrokerAuthRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BrokersMomentmBrokerAuthUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersMomentmBrokerAuthUpdateUsernameErrorComponent = {
  attr: 'username';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmBrokerAuthUpdateBrokerNameErrorComponent = {
  attr: 'broker_name';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersMomentmBrokerAuthUpdateBrokerTimeZoneNameErrorComponent = {
  attr: 'broker_time_zone_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmBrokerAuthUpdatePayerErrorComponent = {
  attr: 'payer';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required' | 'unique';
  detail: string;
};
export type BrokersMomentmBrokerAuthUpdateApiUrlErrorComponent = {
  attr: 'api_url';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmBrokerAuthUpdateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMomentmBrokerAuthUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'username';
    } & BrokersMomentmBrokerAuthUpdateUsernameErrorComponent)
  | ({
      attr: 'broker_name';
    } & BrokersMomentmBrokerAuthUpdateBrokerNameErrorComponent)
  | ({
      attr: 'broker_time_zone_name';
    } & BrokersMomentmBrokerAuthUpdateBrokerTimeZoneNameErrorComponent)
  | ({
      attr: 'payer';
    } & BrokersMomentmBrokerAuthUpdatePayerErrorComponent)
  | ({
      attr: 'api_url';
    } & BrokersMomentmBrokerAuthUpdateApiUrlErrorComponent);
export type BrokersMomentmBrokerAuthUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMomentmBrokerAuthUpdateError[];
};
export type BrokersMomentmBrokerAuthUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMomentmBrokerAuthUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BrokersMomentmBrokerAuthPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersMomentmBrokerAuthPartialUpdateUsernameErrorComponent = {
  attr: 'username';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmBrokerAuthPartialUpdateBrokerNameErrorComponent = {
  attr: 'broker_name';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersMomentmBrokerAuthPartialUpdateBrokerTimeZoneNameErrorComponent =
  {
    attr: 'broker_time_zone_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersMomentmBrokerAuthPartialUpdatePayerErrorComponent = {
  attr: 'payer';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required' | 'unique';
  detail: string;
};
export type BrokersMomentmBrokerAuthPartialUpdateApiUrlErrorComponent = {
  attr: 'api_url';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmBrokerAuthPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMomentmBrokerAuthPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'username';
    } & BrokersMomentmBrokerAuthPartialUpdateUsernameErrorComponent)
  | ({
      attr: 'broker_name';
    } & BrokersMomentmBrokerAuthPartialUpdateBrokerNameErrorComponent)
  | ({
      attr: 'broker_time_zone_name';
    } & BrokersMomentmBrokerAuthPartialUpdateBrokerTimeZoneNameErrorComponent)
  | ({
      attr: 'payer';
    } & BrokersMomentmBrokerAuthPartialUpdatePayerErrorComponent)
  | ({
      attr: 'api_url';
    } & BrokersMomentmBrokerAuthPartialUpdateApiUrlErrorComponent);
export type BrokersMomentmBrokerAuthPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMomentmBrokerAuthPartialUpdateError[];
};
export type BrokersMomentmBrokerAuthPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMomentmBrokerAuthPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedMomentmBrokerAuth = {
  /** Momentm username for organization+broker pair */
  username?: string;
  /** Name for broker, used for auth and maps to the trip intermediary */
  broker_name?: BrokerNameEnum;
  /** IANA time zone standard, (ex. America/Los_Angeles, America/New_York) that broker is in, all times from momentm are relative to this tz */
  broker_time_zone_name?: string;
  payer?: string;
  /** Momentm api_url for organization+broker pair */
  api_url?: string;
};
export type PatchedMomentmBrokerAuthRead = {
  id?: string;
  organization?: string;
  /** Momentm username for organization+broker pair */
  username?: string;
  /** Name for broker, used for auth and maps to the trip intermediary */
  broker_name?: BrokerNameEnum;
  /** IANA time zone standard, (ex. America/Los_Angeles, America/New_York) that broker is in, all times from momentm are relative to this tz */
  broker_time_zone_name?: string;
  payer?: string;
  /** Momentm api_url for organization+broker pair */
  api_url?: string;
};
export type BrokersMomentmBrokerAuthDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BrokersMomentmBrokerAuthSetSecretCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersMomentmBrokerAuthSetSecretCreateUsernameErrorComponent = {
  attr: 'username';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmBrokerAuthSetSecretCreateBrokerNameErrorComponent = {
  attr: 'broker_name';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersMomentmBrokerAuthSetSecretCreateBrokerTimeZoneNameErrorComponent =
  {
    attr: 'broker_time_zone_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersMomentmBrokerAuthSetSecretCreatePayerErrorComponent = {
  attr: 'payer';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required' | 'unique';
  detail: string;
};
export type BrokersMomentmBrokerAuthSetSecretCreateApiUrlErrorComponent = {
  attr: 'api_url';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmBrokerAuthSetSecretCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMomentmBrokerAuthSetSecretCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'username';
    } & BrokersMomentmBrokerAuthSetSecretCreateUsernameErrorComponent)
  | ({
      attr: 'broker_name';
    } & BrokersMomentmBrokerAuthSetSecretCreateBrokerNameErrorComponent)
  | ({
      attr: 'broker_time_zone_name';
    } & BrokersMomentmBrokerAuthSetSecretCreateBrokerTimeZoneNameErrorComponent)
  | ({
      attr: 'payer';
    } & BrokersMomentmBrokerAuthSetSecretCreatePayerErrorComponent)
  | ({
      attr: 'api_url';
    } & BrokersMomentmBrokerAuthSetSecretCreateApiUrlErrorComponent);
export type BrokersMomentmBrokerAuthSetSecretCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMomentmBrokerAuthSetSecretCreateError[];
};
export type BrokersMomentmBrokerAuthSetSecretCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMomentmBrokerAuthSetSecretCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BrokersMomentmSetSecretCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersMomentmSetSecretCreateUsernameErrorComponent = {
  attr: 'username';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmSetSecretCreateBrokerNameErrorComponent = {
  attr: 'broker_name';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersMomentmSetSecretCreateBrokerTimeZoneNameErrorComponent = {
  attr: 'broker_time_zone_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmSetSecretCreatePayerErrorComponent = {
  attr: 'payer';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required' | 'unique';
  detail: string;
};
export type BrokersMomentmSetSecretCreateApiUrlErrorComponent = {
  attr: 'api_url';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMomentmSetSecretCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMomentmSetSecretCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'username';
    } & BrokersMomentmSetSecretCreateUsernameErrorComponent)
  | ({
      attr: 'broker_name';
    } & BrokersMomentmSetSecretCreateBrokerNameErrorComponent)
  | ({
      attr: 'broker_time_zone_name';
    } & BrokersMomentmSetSecretCreateBrokerTimeZoneNameErrorComponent)
  | ({
      attr: 'payer';
    } & BrokersMomentmSetSecretCreatePayerErrorComponent)
  | ({
      attr: 'api_url';
    } & BrokersMomentmSetSecretCreateApiUrlErrorComponent);
export type BrokersMomentmSetSecretCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMomentmSetSecretCreateError[];
};
export type BrokersMomentmSetSecretCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMomentmSetSecretCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MtmEmailTextResponse = {
  email_text: string;
  detail?: string;
};
export type BrokersMtmInitCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersMtmInitCreateProviderErrorComponent = {
  attr: 'provider';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmInitCreateOrgCodeErrorComponent = {
  attr: 'org_code';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmInitCreateClientIdErrorComponent = {
  attr: 'client_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmInitCreateLastBackfillErrorComponent = {
  attr: 'last_backfill';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type BrokersMtmInitCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMtmInitCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'provider';
    } & BrokersMtmInitCreateProviderErrorComponent)
  | ({
      attr: 'org_code';
    } & BrokersMtmInitCreateOrgCodeErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersMtmInitCreateClientIdErrorComponent)
  | ({
      attr: 'last_backfill';
    } & BrokersMtmInitCreateLastBackfillErrorComponent);
export type BrokersMtmInitCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMtmInitCreateError[];
};
export type BrokersMtmInitCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMtmInitCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MtmTransportationProvider = {
  /** MTM's name for an organization */
  provider?: string;
  /** MTM's 'code' for an organization */
  org_code?: string;
  /** MTM OAuth client ID for an organization */
  client_id?: string;
  last_backfill?: string | null;
};
export type MtmTransportationProviderRead = {
  id: string;
  organization: string;
  /** MTM's name for an organization */
  provider?: string;
  /** MTM's 'code' for an organization */
  org_code?: string;
  /** MTM OAuth client ID for an organization */
  client_id?: string;
  webhook_id: string | null;
  first_used: string | null;
  last_used: string | null;
  last_backfill?: string | null;
};
export type MtmoAuthToken = {};
export type MtmoAuthTokenRead = {
  access_token: string;
  expires_in: number;
  token_type: TokenTypeEnum;
};
export type MtmoAuthTokenWrite = {
  client_id: string;
  client_secret: string;
  grant_type?: string;
};
export type BrokersMtmOauth2TokenCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersMtmOauth2TokenCreateClientIdErrorComponent = {
  attr: 'client_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmOauth2TokenCreateClientSecretErrorComponent = {
  attr: 'client_secret';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmOauth2TokenCreateGrantTypeErrorComponent = {
  attr: 'grant_type';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmOauth2TokenCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMtmOauth2TokenCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersMtmOauth2TokenCreateClientIdErrorComponent)
  | ({
      attr: 'client_secret';
    } & BrokersMtmOauth2TokenCreateClientSecretErrorComponent)
  | ({
      attr: 'grant_type';
    } & BrokersMtmOauth2TokenCreateGrantTypeErrorComponent);
export type BrokersMtmOauth2TokenCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMtmOauth2TokenCreateError[];
};
export type BrokersMtmOauth2TokenCreateErrorResponse400 = {
  type: 'validation_error';
} & BrokersMtmOauth2TokenCreateValidationError;
export type MtmSetSecretResponse = {
  detail: string;
};
export type BrokersMtmSetSecretCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersMtmSetSecretCreateMtmTransportationProviderIdErrorComponent =
  {
    attr: 'mtm_transportation_provider_id';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersMtmSetSecretCreateClientSecretErrorComponent = {
  attr: 'client_secret';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmSetSecretCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMtmSetSecretCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'mtm_transportation_provider_id';
    } & BrokersMtmSetSecretCreateMtmTransportationProviderIdErrorComponent)
  | ({
      attr: 'client_secret';
    } & BrokersMtmSetSecretCreateClientSecretErrorComponent);
export type BrokersMtmSetSecretCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMtmSetSecretCreateError[];
};
export type BrokersMtmSetSecretCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMtmSetSecretCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MtmSecret = {
  mtm_transportation_provider_id: string;
  client_secret: string;
};
export type PaginatedMtmTransportationProviderList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MtmTransportationProvider[];
};
export type PaginatedMtmTransportationProviderListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MtmTransportationProviderRead[];
};
export type BrokersMtmTransportationProvidersListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BrokersMtmTransportationProvidersCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersMtmTransportationProvidersCreateProviderErrorComponent = {
  attr: 'provider';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmTransportationProvidersCreateOrgCodeErrorComponent = {
  attr: 'org_code';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmTransportationProvidersCreateClientIdErrorComponent = {
  attr: 'client_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmTransportationProvidersCreateLastBackfillErrorComponent =
  {
    attr: 'last_backfill';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type BrokersMtmTransportationProvidersCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMtmTransportationProvidersCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'provider';
    } & BrokersMtmTransportationProvidersCreateProviderErrorComponent)
  | ({
      attr: 'org_code';
    } & BrokersMtmTransportationProvidersCreateOrgCodeErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersMtmTransportationProvidersCreateClientIdErrorComponent)
  | ({
      attr: 'last_backfill';
    } & BrokersMtmTransportationProvidersCreateLastBackfillErrorComponent);
export type BrokersMtmTransportationProvidersCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMtmTransportationProvidersCreateError[];
};
export type BrokersMtmTransportationProvidersCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMtmTransportationProvidersCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BrokersMtmTransportationProvidersRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BrokersMtmTransportationProvidersUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersMtmTransportationProvidersUpdateProviderErrorComponent = {
  attr: 'provider';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmTransportationProvidersUpdateOrgCodeErrorComponent = {
  attr: 'org_code';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmTransportationProvidersUpdateClientIdErrorComponent = {
  attr: 'client_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmTransportationProvidersUpdateLastBackfillErrorComponent =
  {
    attr: 'last_backfill';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type BrokersMtmTransportationProvidersUpdateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMtmTransportationProvidersUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'provider';
    } & BrokersMtmTransportationProvidersUpdateProviderErrorComponent)
  | ({
      attr: 'org_code';
    } & BrokersMtmTransportationProvidersUpdateOrgCodeErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersMtmTransportationProvidersUpdateClientIdErrorComponent)
  | ({
      attr: 'last_backfill';
    } & BrokersMtmTransportationProvidersUpdateLastBackfillErrorComponent);
export type BrokersMtmTransportationProvidersUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMtmTransportationProvidersUpdateError[];
};
export type BrokersMtmTransportationProvidersUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMtmTransportationProvidersUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BrokersMtmTransportationProvidersPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersMtmTransportationProvidersPartialUpdateProviderErrorComponent =
  {
    attr: 'provider';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersMtmTransportationProvidersPartialUpdateOrgCodeErrorComponent =
  {
    attr: 'org_code';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersMtmTransportationProvidersPartialUpdateClientIdErrorComponent =
  {
    attr: 'client_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersMtmTransportationProvidersPartialUpdateLastBackfillErrorComponent =
  {
    attr: 'last_backfill';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type BrokersMtmTransportationProvidersPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMtmTransportationProvidersPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'provider';
    } & BrokersMtmTransportationProvidersPartialUpdateProviderErrorComponent)
  | ({
      attr: 'org_code';
    } & BrokersMtmTransportationProvidersPartialUpdateOrgCodeErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersMtmTransportationProvidersPartialUpdateClientIdErrorComponent)
  | ({
      attr: 'last_backfill';
    } & BrokersMtmTransportationProvidersPartialUpdateLastBackfillErrorComponent);
export type BrokersMtmTransportationProvidersPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMtmTransportationProvidersPartialUpdateError[];
};
export type BrokersMtmTransportationProvidersPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMtmTransportationProvidersPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedMtmTransportationProvider = {
  /** MTM's name for an organization */
  provider?: string;
  /** MTM's 'code' for an organization */
  org_code?: string;
  /** MTM OAuth client ID for an organization */
  client_id?: string;
  last_backfill?: string | null;
};
export type PatchedMtmTransportationProviderRead = {
  id?: string;
  organization?: string;
  /** MTM's name for an organization */
  provider?: string;
  /** MTM's 'code' for an organization */
  org_code?: string;
  /** MTM OAuth client ID for an organization */
  client_id?: string;
  webhook_id?: string | null;
  first_used?: string | null;
  last_used?: string | null;
  last_backfill?: string | null;
};
export type BrokersMtmTransportationProvidersDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type MtmBackfillTripsResponse = {
  total_found: number;
  total_created: number;
  total_already_existed: number;
  total_errors: number;
  total_duplicates_in_pages: number;
  created_trip_ids: string[];
  existing_trip_ids: string[];
  error_details: {
    [key: string]: any;
  }[];
  start_date: string | null;
  end_date: string | null;
  pages_fetched: number;
};
export type BrokersMtmTransportationProvidersBackfillTripsCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersMtmTransportationProvidersBackfillTripsCreateStartDateErrorComponent =
  {
    attr: 'start_date';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type BrokersMtmTransportationProvidersBackfillTripsCreateEndDateErrorComponent =
  {
    attr: 'end_date';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type BrokersMtmTransportationProvidersBackfillTripsCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMtmTransportationProvidersBackfillTripsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'start_date';
    } & BrokersMtmTransportationProvidersBackfillTripsCreateStartDateErrorComponent)
  | ({
      attr: 'end_date';
    } & BrokersMtmTransportationProvidersBackfillTripsCreateEndDateErrorComponent);
export type BrokersMtmTransportationProvidersBackfillTripsCreateValidationError =
  {
    type: ValidationErrorEnum;
    errors: BrokersMtmTransportationProvidersBackfillTripsCreateError[];
  };
export type BrokersMtmTransportationProvidersBackfillTripsCreateErrorResponse400 =

    | ({
        type: 'validation_error';
      } & BrokersMtmTransportationProvidersBackfillTripsCreateValidationError)
    | ({
        type: 'client_error';
      } & ParseErrorResponse);
export type MtmBackfillTripsRequest = {
  /** Start date for backfill (UTC). Default: midnight today. */
  start_date?: string | null;
  /** End date for backfill (UTC). Default: 4 weeks from start_date. */
  end_date?: string | null;
};
export type BrokersMtmTransportationProvidersGetEmailRetrieveErrorResponse400 =
  {
    type: 'client_error';
  } & ParseErrorResponse;
export type MtmTurnbackReason = {
  id: number;
  name: string;
  createdOn?: string | null;
  editedOn?: string | null;
};
export type BrokersMtmTransportationProvidersTurnbackReasonsRetrieveErrorResponse400 =
  {
    type: 'client_error';
  } & ParseErrorResponse;
export type BrokersMtmTransportationProvidersGetEmailTextRetrieveErrorResponse400 =
  {
    type: 'client_error';
  } & ParseErrorResponse;
export type BrokersMtmTransportationProvidersInitCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersMtmTransportationProvidersInitCreateProviderErrorComponent =
  {
    attr: 'provider';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersMtmTransportationProvidersInitCreateOrgCodeErrorComponent = {
  attr: 'org_code';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmTransportationProvidersInitCreateClientIdErrorComponent =
  {
    attr: 'client_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersMtmTransportationProvidersInitCreateLastBackfillErrorComponent =
  {
    attr: 'last_backfill';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type BrokersMtmTransportationProvidersInitCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMtmTransportationProvidersInitCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'provider';
    } & BrokersMtmTransportationProvidersInitCreateProviderErrorComponent)
  | ({
      attr: 'org_code';
    } & BrokersMtmTransportationProvidersInitCreateOrgCodeErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersMtmTransportationProvidersInitCreateClientIdErrorComponent)
  | ({
      attr: 'last_backfill';
    } & BrokersMtmTransportationProvidersInitCreateLastBackfillErrorComponent);
export type BrokersMtmTransportationProvidersInitCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMtmTransportationProvidersInitCreateError[];
};
export type BrokersMtmTransportationProvidersInitCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMtmTransportationProvidersInitCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BrokersMtmTransportationProvidersSetSecretCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersMtmTransportationProvidersSetSecretCreateMtmTransportationProviderIdErrorComponent =
  {
    attr: 'mtm_transportation_provider_id';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type BrokersMtmTransportationProvidersSetSecretCreateClientSecretErrorComponent =
  {
    attr: 'client_secret';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersMtmTransportationProvidersSetSecretCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMtmTransportationProvidersSetSecretCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'mtm_transportation_provider_id';
    } & BrokersMtmTransportationProvidersSetSecretCreateMtmTransportationProviderIdErrorComponent)
  | ({
      attr: 'client_secret';
    } & BrokersMtmTransportationProvidersSetSecretCreateClientSecretErrorComponent);
export type BrokersMtmTransportationProvidersSetSecretCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMtmTransportationProvidersSetSecretCreateError[];
};
export type BrokersMtmTransportationProvidersSetSecretCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMtmTransportationProvidersSetSecretCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type EventTypeIdEnum = 10 | 11 | 12 | 13;
export type MtmWebhook = {
  eventTypeId: EventTypeIdEnum;
  providerTripId: string;
  eventData?: {
    [key: string]: any;
  } | null;
  organizationCode?: string;
};
export type BrokersMtmWebhookCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersMtmWebhookCreateEventTypeIdErrorComponent = {
  attr: 'eventTypeId';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersMtmWebhookCreateProviderTripIdErrorComponent = {
  attr: 'providerTripId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmWebhookCreateEventDataErrorComponent = {
  attr: 'eventData';
  code: 'not_a_dict';
  detail: string;
};
export type BrokersMtmWebhookCreateEventDataKeyErrorComponent = {
  attr: 'eventData.KEY';
  code: 'required';
  detail: string;
};
export type BrokersMtmWebhookCreateOrganizationCodeErrorComponent = {
  attr: 'organizationCode';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersMtmWebhookCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersMtmWebhookCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'eventTypeId';
    } & BrokersMtmWebhookCreateEventTypeIdErrorComponent)
  | ({
      attr: 'providerTripId';
    } & BrokersMtmWebhookCreateProviderTripIdErrorComponent)
  | ({
      attr: 'eventData';
    } & BrokersMtmWebhookCreateEventDataErrorComponent)
  | ({
      attr: 'eventData.KEY';
    } & BrokersMtmWebhookCreateEventDataKeyErrorComponent)
  | ({
      attr: 'organizationCode';
    } & BrokersMtmWebhookCreateOrganizationCodeErrorComponent);
export type BrokersMtmWebhookCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersMtmWebhookCreateError[];
};
export type BrokersMtmWebhookCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersMtmWebhookCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type ProvideARideOAuthToken = {};
export type ProvideARideOAuthTokenRead = {
  access_token: string;
  expires_in: number;
  token_type: TokenTypeEnum;
};
export type ProvideARideOAuthTokenWrite = {
  client_id: string;
  client_secret: string;
  grant_type: GrantTypeEnum;
};
export type BrokersProvideARideOauth2TokenCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersProvideARideOauth2TokenCreateClientIdErrorComponent = {
  attr: 'client_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideOauth2TokenCreateClientSecretErrorComponent = {
  attr: 'client_secret';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideOauth2TokenCreateGrantTypeErrorComponent = {
  attr: 'grant_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersProvideARideOauth2TokenCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersProvideARideOauth2TokenCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'client_id';
    } & BrokersProvideARideOauth2TokenCreateClientIdErrorComponent)
  | ({
      attr: 'client_secret';
    } & BrokersProvideARideOauth2TokenCreateClientSecretErrorComponent)
  | ({
      attr: 'grant_type';
    } & BrokersProvideARideOauth2TokenCreateGrantTypeErrorComponent);
export type BrokersProvideARideOauth2TokenCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersProvideARideOauth2TokenCreateError[];
};
export type BrokersProvideARideOauth2TokenCreateErrorResponse400 = {
  type: 'validation_error';
} & BrokersProvideARideOauth2TokenCreateValidationError;
export type ProvideARideTripCreate = {};
export type ProvideARideTripCreateRead = {
  BambiTripID: string;
};
export type RiderSexEnum = 'M' | 'F' | 'A' | 'U';
export type BlankEnum = '';
export type NullEnum = null;
export type MobilityRequirementEnum =
  | 0
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16;
export type MobilityKindEnum = 1 | 2 | 3 | 4;
export type ProvideARideTripCreateWrite = {
  TripActualID: number;
  AppointmentTime?: string | null;
  RequestTime: string;
  WillCall?: boolean | null;
  DriverComments?: string | null;
  PickupLocationName?: string | null;
  PickupAddress1: string;
  PickupAddress2?: string | null;
  PickupCity: string;
  PickupState: string;
  PickupZip: string;
  PickupLongitude?: number | null;
  PickupLatitude?: number | null;
  PickupPhoneNumber?: string | null;
  DropoffLocationName?: string | null;
  DropoffAddress1: string;
  DropoffAddress2?: string | null;
  DropoffCity: string;
  DropoffState: string;
  DropoffZip: string;
  DropoffLongitude?: number | null;
  DropoffLatitude?: number | null;
  DropoffPhoneNumber?: string | null;
  RiderId: string;
  RiderFirstName: string;
  RiderLastName: string;
  RiderMiddleName?: string | null;
  RiderEmail?: string | null;
  RiderPhone?: string | null;
  RiderDateOfBirth?: string | null;
  RiderSex?: (RiderSexEnum | BlankEnum | NullEnum) | null;
  RiderComments?: string | null;
  GuestCount?: number | null;
  MobilityRequirement: MobilityRequirementEnum;
  MobilityKind: MobilityKindEnum;
  ServiceComments?: string | null;
  SubcontractorId: number;
};
export type BrokersProvideARideTripsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersProvideARideTripsCreateTripActualIdErrorComponent = {
  attr: 'TripActualID';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersProvideARideTripsCreateAppointmentTimeErrorComponent = {
  attr: 'AppointmentTime';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type BrokersProvideARideTripsCreateRequestTimeErrorComponent = {
  attr: 'RequestTime';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type BrokersProvideARideTripsCreateWillCallErrorComponent = {
  attr: 'WillCall';
  code: 'invalid';
  detail: string;
};
export type BrokersProvideARideTripsCreateDriverCommentsErrorComponent = {
  attr: 'DriverComments';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreatePickupLocationNameErrorComponent = {
  attr: 'PickupLocationName';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreatePickupAddress1ErrorComponent = {
  attr: 'PickupAddress1';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreatePickupAddress2ErrorComponent = {
  attr: 'PickupAddress2';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreatePickupCityErrorComponent = {
  attr: 'PickupCity';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreatePickupStateErrorComponent = {
  attr: 'PickupState';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreatePickupZipErrorComponent = {
  attr: 'PickupZip';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreatePickupLongitudeErrorComponent = {
  attr: 'PickupLongitude';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersProvideARideTripsCreatePickupLatitudeErrorComponent = {
  attr: 'PickupLatitude';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersProvideARideTripsCreatePickupPhoneNumberErrorComponent = {
  attr: 'PickupPhoneNumber';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateDropoffLocationNameErrorComponent = {
  attr: 'DropoffLocationName';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateDropoffAddress1ErrorComponent = {
  attr: 'DropoffAddress1';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateDropoffAddress2ErrorComponent = {
  attr: 'DropoffAddress2';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateDropoffCityErrorComponent = {
  attr: 'DropoffCity';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateDropoffStateErrorComponent = {
  attr: 'DropoffState';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateDropoffZipErrorComponent = {
  attr: 'DropoffZip';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateDropoffLongitudeErrorComponent = {
  attr: 'DropoffLongitude';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersProvideARideTripsCreateDropoffLatitudeErrorComponent = {
  attr: 'DropoffLatitude';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersProvideARideTripsCreateDropoffPhoneNumberErrorComponent = {
  attr: 'DropoffPhoneNumber';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateRiderIdErrorComponent = {
  attr: 'RiderId';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateRiderFirstNameErrorComponent = {
  attr: 'RiderFirstName';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateRiderLastNameErrorComponent = {
  attr: 'RiderLastName';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateRiderMiddleNameErrorComponent = {
  attr: 'RiderMiddleName';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateRiderEmailErrorComponent = {
  attr: 'RiderEmail';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateRiderPhoneErrorComponent = {
  attr: 'RiderPhone';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateRiderDateOfBirthErrorComponent = {
  attr: 'RiderDateOfBirth';
  code: 'datetime' | 'invalid';
  detail: string;
};
export type BrokersProvideARideTripsCreateRiderSexErrorComponent = {
  attr: 'RiderSex';
  code: 'invalid_choice';
  detail: string;
};
export type BrokersProvideARideTripsCreateRiderCommentsErrorComponent = {
  attr: 'RiderComments';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateGuestCountErrorComponent = {
  attr: 'GuestCount';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersProvideARideTripsCreateMobilityRequirementErrorComponent = {
  attr: 'MobilityRequirement';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersProvideARideTripsCreateMobilityKindErrorComponent = {
  attr: 'MobilityKind';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type BrokersProvideARideTripsCreateServiceCommentsErrorComponent = {
  attr: 'ServiceComments';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersProvideARideTripsCreateSubcontractorIdErrorComponent = {
  attr: 'SubcontractorId';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type BrokersProvideARideTripsCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersProvideARideTripsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'TripActualID';
    } & BrokersProvideARideTripsCreateTripActualIdErrorComponent)
  | ({
      attr: 'AppointmentTime';
    } & BrokersProvideARideTripsCreateAppointmentTimeErrorComponent)
  | ({
      attr: 'RequestTime';
    } & BrokersProvideARideTripsCreateRequestTimeErrorComponent)
  | ({
      attr: 'WillCall';
    } & BrokersProvideARideTripsCreateWillCallErrorComponent)
  | ({
      attr: 'DriverComments';
    } & BrokersProvideARideTripsCreateDriverCommentsErrorComponent)
  | ({
      attr: 'PickupLocationName';
    } & BrokersProvideARideTripsCreatePickupLocationNameErrorComponent)
  | ({
      attr: 'PickupAddress1';
    } & BrokersProvideARideTripsCreatePickupAddress1ErrorComponent)
  | ({
      attr: 'PickupAddress2';
    } & BrokersProvideARideTripsCreatePickupAddress2ErrorComponent)
  | ({
      attr: 'PickupCity';
    } & BrokersProvideARideTripsCreatePickupCityErrorComponent)
  | ({
      attr: 'PickupState';
    } & BrokersProvideARideTripsCreatePickupStateErrorComponent)
  | ({
      attr: 'PickupZip';
    } & BrokersProvideARideTripsCreatePickupZipErrorComponent)
  | ({
      attr: 'PickupLongitude';
    } & BrokersProvideARideTripsCreatePickupLongitudeErrorComponent)
  | ({
      attr: 'PickupLatitude';
    } & BrokersProvideARideTripsCreatePickupLatitudeErrorComponent)
  | ({
      attr: 'PickupPhoneNumber';
    } & BrokersProvideARideTripsCreatePickupPhoneNumberErrorComponent)
  | ({
      attr: 'DropoffLocationName';
    } & BrokersProvideARideTripsCreateDropoffLocationNameErrorComponent)
  | ({
      attr: 'DropoffAddress1';
    } & BrokersProvideARideTripsCreateDropoffAddress1ErrorComponent)
  | ({
      attr: 'DropoffAddress2';
    } & BrokersProvideARideTripsCreateDropoffAddress2ErrorComponent)
  | ({
      attr: 'DropoffCity';
    } & BrokersProvideARideTripsCreateDropoffCityErrorComponent)
  | ({
      attr: 'DropoffState';
    } & BrokersProvideARideTripsCreateDropoffStateErrorComponent)
  | ({
      attr: 'DropoffZip';
    } & BrokersProvideARideTripsCreateDropoffZipErrorComponent)
  | ({
      attr: 'DropoffLongitude';
    } & BrokersProvideARideTripsCreateDropoffLongitudeErrorComponent)
  | ({
      attr: 'DropoffLatitude';
    } & BrokersProvideARideTripsCreateDropoffLatitudeErrorComponent)
  | ({
      attr: 'DropoffPhoneNumber';
    } & BrokersProvideARideTripsCreateDropoffPhoneNumberErrorComponent)
  | ({
      attr: 'RiderId';
    } & BrokersProvideARideTripsCreateRiderIdErrorComponent)
  | ({
      attr: 'RiderFirstName';
    } & BrokersProvideARideTripsCreateRiderFirstNameErrorComponent)
  | ({
      attr: 'RiderLastName';
    } & BrokersProvideARideTripsCreateRiderLastNameErrorComponent)
  | ({
      attr: 'RiderMiddleName';
    } & BrokersProvideARideTripsCreateRiderMiddleNameErrorComponent)
  | ({
      attr: 'RiderEmail';
    } & BrokersProvideARideTripsCreateRiderEmailErrorComponent)
  | ({
      attr: 'RiderPhone';
    } & BrokersProvideARideTripsCreateRiderPhoneErrorComponent)
  | ({
      attr: 'RiderDateOfBirth';
    } & BrokersProvideARideTripsCreateRiderDateOfBirthErrorComponent)
  | ({
      attr: 'RiderSex';
    } & BrokersProvideARideTripsCreateRiderSexErrorComponent)
  | ({
      attr: 'RiderComments';
    } & BrokersProvideARideTripsCreateRiderCommentsErrorComponent)
  | ({
      attr: 'GuestCount';
    } & BrokersProvideARideTripsCreateGuestCountErrorComponent)
  | ({
      attr: 'MobilityRequirement';
    } & BrokersProvideARideTripsCreateMobilityRequirementErrorComponent)
  | ({
      attr: 'MobilityKind';
    } & BrokersProvideARideTripsCreateMobilityKindErrorComponent)
  | ({
      attr: 'ServiceComments';
    } & BrokersProvideARideTripsCreateServiceCommentsErrorComponent)
  | ({
      attr: 'SubcontractorId';
    } & BrokersProvideARideTripsCreateSubcontractorIdErrorComponent);
export type BrokersProvideARideTripsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersProvideARideTripsCreateError[];
};
export type BrokersProvideARideTripsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersProvideARideTripsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type ProvideARideTripRead = {};
export type ProvideARideTripReadRead = {
  TripActualID: number;
  AppointmentTime: string | null;
  RequestTime: string;
  WillCall: boolean | null;
  DriverComments: string | null;
  PickupLocationName: string | null;
  PickupAddress1: string;
  PickupAddress2: string | null;
  PickupCity: string;
  PickupState: string;
  PickupZip: string;
  PickupLongitude: number | null;
  PickupLatitude: number | null;
  PickupPhoneNumber: string | null;
  DropoffLocationName: string | null;
  DropoffAddress1: string;
  DropoffAddress2: string | null;
  DropoffCity: string;
  DropoffState: string;
  DropoffZip: string;
  DropoffLongitude: number | null;
  DropoffLatitude: number | null;
  DropoffPhoneNumber: string | null;
  RiderId: string;
  RiderFirstName: string;
  RiderLastName: string;
  RiderMiddleName: string | null;
  RiderEmail: string | null;
  RiderPhone: string | null;
  RiderDateOfBirth: string | null;
  RiderSex: (RiderSexEnum | BlankEnum | NullEnum) | null;
  RiderComments: string | null;
  GuestCount: number | null;
  MobilityRequirement: MobilityRequirementEnum;
  MobilityKind: MobilityKindEnum;
  ServiceComments: string | null;
  BambiTripID: string;
  PickupArrive: string | null;
  DropoffArrive: string | null;
};
export type BrokersProvideARideTripsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BrokersProvideARideTripsCancelCreateErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type VectorCareLocation = {
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  street: string | null;
  country: string | null;
  lat: number | null;
  lng: number | null;
};
export type VectorCareTripData = {
  account_name: string | null;
  collection_id?: string | null;
  destination_location?: VectorCareLocation | null;
  facility_name?: string | null;
  is_round_trip_first_trip?: boolean | null;
  is_round_trip_return_trip?: boolean | null;
  round_trip_other_service_request_id?: string | null;
  organization_id: string;
  patient_active_membership?: boolean | null;
  patient_age?: number | null;
  patient_coverages?: any[] | null;
  patient_date_of_birth: string | null;
  patient_first_name: string | null;
  patient_gender: string | null;
  patient_girth_inches?: number | null;
  patient_height_inches?: number | null;
  patient_id: string | null;
  patient_interpreter_required?: boolean | null;
  patient_language_spoken?: string | null;
  patient_language_written?: string | null;
  patient_last_name: string | null;
  patient_membership_primary_id?: string | null;
  patient_membership_primary_prefix?: string | null;
  patient_membership_secondary_id?: string | null;
  patient_membership_secondary_prefix?: string | null;
  patient_middle_name?: string | null;
  patient_over_300p?: boolean | null;
  patient_weight_kg?: number | null;
  patient_weight_lbs?: number | null;
  pickup_location: VectorCareLocation | null;
  responder_user_email?: string | null;
  responder_user_first_name?: string | null;
  responder_user_last_name?: string | null;
  requester_email: string;
  requester_first_name?: string | null;
  requester_last_name?: string | null;
  request_current_state?: string | null;
  scheduling_option?: string | null;
  scheduling_type?: string | null;
  service_level_type: string | null;
  service_request_id?: string | null;
  service_type: string | null;
  agreed_for_time?: string | null;
  appointment_datetime: string | null;
  arrival_airport: VectorCareLocation | null;
  authorizing_physician?: string | null;
  can_ambulate?: boolean | null;
  case_number?: string | null;
  cct_criteria?: any[] | null;
  contact_name?: string | null;
  contact_phone?: string | null;
  departure_airport: VectorCareLocation | null;
  destination_address_detail?: string | null;
  destination_facility_name?: string | null;
  destination_facility_type?: string | null;
  destination_is_home?: boolean | null;
  destination_phone_number?: string | null;
  destination_phone_number_extension?: string | null;
  destination_room_number?: string | null;
  destination_stair_steps?: string | null;
  diagnosis_notes?: string | null;
  escalated?: boolean | null;
  external_authorization?: string | null;
  gl_code?: string | null;
  has_own_wheelchair: boolean | null;
  hospice?: boolean | null;
  intravenous_therapy?: any[] | null;
  is_dialysis_trip?: boolean | null;
  is_inpatient?: boolean | null;
  is_recent_onset?: boolean | null;
  isolation_precaution?: boolean | null;
  medical_supervision: any[] | null;
  medications?: any[] | null;
  mental_health_hold?: any[] | null;
  note: string | null;
  number_of_drips?: number | null;
  o2?: string | null;
  other_requirements?: string | null;
  override_approver?: string | null;
  override_reason?: any[] | null;
  patient_bmi?: number | null;
  patient_is_ready?: boolean | null;
  payment_option_primary?: string | null;
  payment_option_primary_group_number?: string | null;
  payment_option_primary_subscriber_id?: string | null;
  payment_option_secondary?: string | null;
  payment_option_secondary_group_number: string | null;
  payment_option_secondary_subscriber_id: string | null;
  pickup_date_time?: string | null;
  pickup_facility_name?: string | null;
  pickup_facility_type?: string | null;
  pickup_is_home?: boolean | null;
  pickup_phone_number?: string | null;
  pickup_phone_number_extension?: string | null;
  pickup_room_number?: string | null;
  pickup_stair_steps?: string | null;
  pre_authorization_number?: string | null;
  receiving_practitioner?: string | null;
  requester_phone_number?: string | null;
  requester_phone_number_extension?: string | null;
  required_equipment?: any[] | null;
  return_date_time?: string | null;
  return_on_will_call?: boolean | null;
  revised_eta?: string | null;
  special_equipment?: any[] | null;
  spoken_language?: string | null;
  transport_reason?: any[] | null;
  travel_authorization_number?: string | null;
  trip_priority_level?: string | null;
  under_isolation?: any[] | null;
  wait_and_return?: boolean | null;
};
export type VectorCareTrip = {
  event_id: string;
  service_request_id: string;
  request_status: string;
  event_timestamp: string;
  action?: string | null;
  data?: VectorCareTripData | null;
};
export type BrokersVectorcareWebhookCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateEventIdErrorComponent = {
  attr: 'event_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateServiceRequestIdErrorComponent = {
  attr: 'service_request_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateRequestStatusErrorComponent = {
  attr: 'request_status';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateEventTimestampErrorComponent = {
  attr: 'event_timestamp';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateActionErrorComponent = {
  attr: 'action';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataNonFieldErrorsErrorComponent = {
  attr: 'data.non_field_errors';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataAccountNameErrorComponent = {
  attr: 'data.account_name';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataCollectionIdErrorComponent = {
  attr: 'data.collection_id';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataDestinationLocationNonFieldErrorsErrorComponent =
  {
    attr: 'data.destination_location.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationLocationAddressErrorComponent =
  {
    attr: 'data.destination_location.address';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationLocationCityErrorComponent =
  {
    attr: 'data.destination_location.city';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationLocationStateErrorComponent =
  {
    attr: 'data.destination_location.state';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationLocationZipErrorComponent =
  {
    attr: 'data.destination_location.zip';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationLocationStreetErrorComponent =
  {
    attr: 'data.destination_location.street';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationLocationCountryErrorComponent =
  {
    attr: 'data.destination_location.country';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationLocationLatErrorComponent =
  {
    attr: 'data.destination_location.lat';
    code: 'invalid' | 'max_string_length' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationLocationLngErrorComponent =
  {
    attr: 'data.destination_location.lng';
    code: 'invalid' | 'max_string_length' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataFacilityNameErrorComponent = {
  attr: 'data.facility_name';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataIsRoundTripFirstTripErrorComponent =
  {
    attr: 'data.is_round_trip_first_trip';
    code: 'invalid';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataIsRoundTripReturnTripErrorComponent =
  {
    attr: 'data.is_round_trip_return_trip';
    code: 'invalid';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataRoundTripOtherServiceRequestIdErrorComponent =
  {
    attr: 'data.round_trip_other_service_request_id';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataOrganizationIdErrorComponent = {
  attr: 'data.organization_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPatientActiveMembershipErrorComponent =
  {
    attr: 'data.patient_active_membership';
    code: 'invalid';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientAgeErrorComponent = {
  attr: 'data.patient_age';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPatientCoveragesErrorComponent = {
  attr: 'data.patient_coverages';
  code: 'not_a_list';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPatientCoveragesIndexErrorComponent =
  {
    attr: 'data.patient_coverages.INDEX';
    code: 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientDateOfBirthErrorComponent =
  {
    attr: 'data.patient_date_of_birth';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientFirstNameErrorComponent = {
  attr: 'data.patient_first_name';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPatientGenderErrorComponent = {
  attr: 'data.patient_gender';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPatientGirthInchesErrorComponent =
  {
    attr: 'data.patient_girth_inches';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientHeightInchesErrorComponent =
  {
    attr: 'data.patient_height_inches';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientIdErrorComponent = {
  attr: 'data.patient_id';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPatientInterpreterRequiredErrorComponent =
  {
    attr: 'data.patient_interpreter_required';
    code: 'invalid';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientLanguageSpokenErrorComponent =
  {
    attr: 'data.patient_language_spoken';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientLanguageWrittenErrorComponent =
  {
    attr: 'data.patient_language_written';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientLastNameErrorComponent = {
  attr: 'data.patient_last_name';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPatientMembershipPrimaryIdErrorComponent =
  {
    attr: 'data.patient_membership_primary_id';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientMembershipPrimaryPrefixErrorComponent =
  {
    attr: 'data.patient_membership_primary_prefix';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientMembershipSecondaryIdErrorComponent =
  {
    attr: 'data.patient_membership_secondary_id';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientMembershipSecondaryPrefixErrorComponent =
  {
    attr: 'data.patient_membership_secondary_prefix';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientMiddleNameErrorComponent =
  {
    attr: 'data.patient_middle_name';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientOver300PErrorComponent = {
  attr: 'data.patient_over_300p';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPatientWeightKgErrorComponent = {
  attr: 'data.patient_weight_kg';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPatientWeightLbsErrorComponent = {
  attr: 'data.patient_weight_lbs';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPickupLocationNonFieldErrorsErrorComponent =
  {
    attr: 'data.pickup_location.non_field_errors';
    code: 'invalid' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupLocationAddressErrorComponent =
  {
    attr: 'data.pickup_location.address';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupLocationCityErrorComponent =
  {
    attr: 'data.pickup_location.city';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupLocationStateErrorComponent =
  {
    attr: 'data.pickup_location.state';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupLocationZipErrorComponent =
  {
    attr: 'data.pickup_location.zip';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupLocationStreetErrorComponent =
  {
    attr: 'data.pickup_location.street';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupLocationCountryErrorComponent =
  {
    attr: 'data.pickup_location.country';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupLocationLatErrorComponent =
  {
    attr: 'data.pickup_location.lat';
    code: 'invalid' | 'max_string_length' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupLocationLngErrorComponent =
  {
    attr: 'data.pickup_location.lng';
    code: 'invalid' | 'max_string_length' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataResponderUserEmailErrorComponent =
  {
    attr: 'data.responder_user_email';
    code:
      | 'blank'
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataResponderUserFirstNameErrorComponent =
  {
    attr: 'data.responder_user_first_name';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataResponderUserLastNameErrorComponent =
  {
    attr: 'data.responder_user_last_name';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataRequesterEmailErrorComponent = {
  attr: 'data.requester_email';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataRequesterFirstNameErrorComponent =
  {
    attr: 'data.requester_first_name';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataRequesterLastNameErrorComponent =
  {
    attr: 'data.requester_last_name';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataRequestCurrentStateErrorComponent =
  {
    attr: 'data.request_current_state';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataSchedulingOptionErrorComponent = {
  attr: 'data.scheduling_option';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataSchedulingTypeErrorComponent = {
  attr: 'data.scheduling_type';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataServiceLevelTypeErrorComponent = {
  attr: 'data.service_level_type';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataServiceRequestIdErrorComponent = {
  attr: 'data.service_request_id';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataServiceTypeErrorComponent = {
  attr: 'data.service_type';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataAgreedForTimeErrorComponent = {
  attr: 'data.agreed_for_time';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataAppointmentDatetimeErrorComponent =
  {
    attr: 'data.appointment_datetime';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataArrivalAirportNonFieldErrorsErrorComponent =
  {
    attr: 'data.arrival_airport.non_field_errors';
    code: 'invalid' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataArrivalAirportAddressErrorComponent =
  {
    attr: 'data.arrival_airport.address';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataArrivalAirportCityErrorComponent =
  {
    attr: 'data.arrival_airport.city';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataArrivalAirportStateErrorComponent =
  {
    attr: 'data.arrival_airport.state';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataArrivalAirportZipErrorComponent =
  {
    attr: 'data.arrival_airport.zip';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataArrivalAirportStreetErrorComponent =
  {
    attr: 'data.arrival_airport.street';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataArrivalAirportCountryErrorComponent =
  {
    attr: 'data.arrival_airport.country';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataArrivalAirportLatErrorComponent =
  {
    attr: 'data.arrival_airport.lat';
    code: 'invalid' | 'max_string_length' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataArrivalAirportLngErrorComponent =
  {
    attr: 'data.arrival_airport.lng';
    code: 'invalid' | 'max_string_length' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataAuthorizingPhysicianErrorComponent =
  {
    attr: 'data.authorizing_physician';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataCanAmbulateErrorComponent = {
  attr: 'data.can_ambulate';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataCaseNumberErrorComponent = {
  attr: 'data.case_number';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataCctCriteriaErrorComponent = {
  attr: 'data.cct_criteria';
  code: 'not_a_list';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataCctCriteriaIndexErrorComponent = {
  attr: 'data.cct_criteria.INDEX';
  code: 'required';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataContactNameErrorComponent = {
  attr: 'data.contact_name';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataContactPhoneErrorComponent = {
  attr: 'data.contact_phone';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataDepartureAirportNonFieldErrorsErrorComponent =
  {
    attr: 'data.departure_airport.non_field_errors';
    code: 'invalid' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDepartureAirportAddressErrorComponent =
  {
    attr: 'data.departure_airport.address';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDepartureAirportCityErrorComponent =
  {
    attr: 'data.departure_airport.city';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDepartureAirportStateErrorComponent =
  {
    attr: 'data.departure_airport.state';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDepartureAirportZipErrorComponent =
  {
    attr: 'data.departure_airport.zip';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDepartureAirportStreetErrorComponent =
  {
    attr: 'data.departure_airport.street';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDepartureAirportCountryErrorComponent =
  {
    attr: 'data.departure_airport.country';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDepartureAirportLatErrorComponent =
  {
    attr: 'data.departure_airport.lat';
    code: 'invalid' | 'max_string_length' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDepartureAirportLngErrorComponent =
  {
    attr: 'data.departure_airport.lng';
    code: 'invalid' | 'max_string_length' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationAddressDetailErrorComponent =
  {
    attr: 'data.destination_address_detail';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationFacilityNameErrorComponent =
  {
    attr: 'data.destination_facility_name';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationFacilityTypeErrorComponent =
  {
    attr: 'data.destination_facility_type';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationIsHomeErrorComponent =
  {
    attr: 'data.destination_is_home';
    code: 'invalid';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationPhoneNumberErrorComponent =
  {
    attr: 'data.destination_phone_number';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationPhoneNumberExtensionErrorComponent =
  {
    attr: 'data.destination_phone_number_extension';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationRoomNumberErrorComponent =
  {
    attr: 'data.destination_room_number';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDestinationStairStepsErrorComponent =
  {
    attr: 'data.destination_stair_steps';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataDiagnosisNotesErrorComponent = {
  attr: 'data.diagnosis_notes';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataEscalatedErrorComponent = {
  attr: 'data.escalated';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataExternalAuthorizationErrorComponent =
  {
    attr: 'data.external_authorization';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataGlCodeErrorComponent = {
  attr: 'data.gl_code';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataHasOwnWheelchairErrorComponent = {
  attr: 'data.has_own_wheelchair';
  code: 'invalid' | 'required';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataHospiceErrorComponent = {
  attr: 'data.hospice';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataIntravenousTherapyErrorComponent =
  {
    attr: 'data.intravenous_therapy';
    code: 'not_a_list';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataIntravenousTherapyIndexErrorComponent =
  {
    attr: 'data.intravenous_therapy.INDEX';
    code: 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataIsDialysisTripErrorComponent = {
  attr: 'data.is_dialysis_trip';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataIsInpatientErrorComponent = {
  attr: 'data.is_inpatient';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataIsRecentOnsetErrorComponent = {
  attr: 'data.is_recent_onset';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataIsolationPrecautionErrorComponent =
  {
    attr: 'data.isolation_precaution';
    code: 'invalid';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataMedicalSupervisionErrorComponent =
  {
    attr: 'data.medical_supervision';
    code: 'not_a_list' | 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataMedicalSupervisionIndexErrorComponent =
  {
    attr: 'data.medical_supervision.INDEX';
    code: 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataMedicationsErrorComponent = {
  attr: 'data.medications';
  code: 'not_a_list';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataMedicationsIndexErrorComponent = {
  attr: 'data.medications.INDEX';
  code: 'required';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataMentalHealthHoldErrorComponent = {
  attr: 'data.mental_health_hold';
  code: 'not_a_list';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataMentalHealthHoldIndexErrorComponent =
  {
    attr: 'data.mental_health_hold.INDEX';
    code: 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataNoteErrorComponent = {
  attr: 'data.note';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataNumberOfDripsErrorComponent = {
  attr: 'data.number_of_drips';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataO2ErrorComponent = {
  attr: 'data.o2';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataOtherRequirementsErrorComponent =
  {
    attr: 'data.other_requirements';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataOverrideApproverErrorComponent = {
  attr: 'data.override_approver';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataOverrideReasonErrorComponent = {
  attr: 'data.override_reason';
  code: 'not_a_list';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataOverrideReasonIndexErrorComponent =
  {
    attr: 'data.override_reason.INDEX';
    code: 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPatientBmiErrorComponent = {
  attr: 'data.patient_bmi';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPatientIsReadyErrorComponent = {
  attr: 'data.patient_is_ready';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPaymentOptionPrimaryErrorComponent =
  {
    attr: 'data.payment_option_primary';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPaymentOptionPrimaryGroupNumberErrorComponent =
  {
    attr: 'data.payment_option_primary_group_number';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPaymentOptionPrimarySubscriberIdErrorComponent =
  {
    attr: 'data.payment_option_primary_subscriber_id';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPaymentOptionSecondaryErrorComponent =
  {
    attr: 'data.payment_option_secondary';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPaymentOptionSecondaryGroupNumberErrorComponent =
  {
    attr: 'data.payment_option_secondary_group_number';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPaymentOptionSecondarySubscriberIdErrorComponent =
  {
    attr: 'data.payment_option_secondary_subscriber_id';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupDateTimeErrorComponent = {
  attr: 'data.pickup_date_time';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPickupFacilityNameErrorComponent =
  {
    attr: 'data.pickup_facility_name';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupFacilityTypeErrorComponent =
  {
    attr: 'data.pickup_facility_type';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupIsHomeErrorComponent = {
  attr: 'data.pickup_is_home';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPickupPhoneNumberErrorComponent =
  {
    attr: 'data.pickup_phone_number';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupPhoneNumberExtensionErrorComponent =
  {
    attr: 'data.pickup_phone_number_extension';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataPickupRoomNumberErrorComponent = {
  attr: 'data.pickup_room_number';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPickupStairStepsErrorComponent = {
  attr: 'data.pickup_stair_steps';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataPreAuthorizationNumberErrorComponent =
  {
    attr: 'data.pre_authorization_number';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataReceivingPractitionerErrorComponent =
  {
    attr: 'data.receiving_practitioner';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataRequesterPhoneNumberErrorComponent =
  {
    attr: 'data.requester_phone_number';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataRequesterPhoneNumberExtensionErrorComponent =
  {
    attr: 'data.requester_phone_number_extension';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataRequiredEquipmentErrorComponent =
  {
    attr: 'data.required_equipment';
    code: 'not_a_list';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataRequiredEquipmentIndexErrorComponent =
  {
    attr: 'data.required_equipment.INDEX';
    code: 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataReturnDateTimeErrorComponent = {
  attr: 'data.return_date_time';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataReturnOnWillCallErrorComponent = {
  attr: 'data.return_on_will_call';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataRevisedEtaErrorComponent = {
  attr: 'data.revised_eta';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataSpecialEquipmentErrorComponent = {
  attr: 'data.special_equipment';
  code: 'not_a_list';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataSpecialEquipmentIndexErrorComponent =
  {
    attr: 'data.special_equipment.INDEX';
    code: 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataSpokenLanguageErrorComponent = {
  attr: 'data.spoken_language';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataTransportReasonErrorComponent = {
  attr: 'data.transport_reason';
  code: 'not_a_list';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataTransportReasonIndexErrorComponent =
  {
    attr: 'data.transport_reason.INDEX';
    code: 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataTravelAuthorizationNumberErrorComponent =
  {
    attr: 'data.travel_authorization_number';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataTripPriorityLevelErrorComponent =
  {
    attr: 'data.trip_priority_level';
    code:
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataUnderIsolationErrorComponent = {
  attr: 'data.under_isolation';
  code: 'not_a_list';
  detail: string;
};
export type BrokersVectorcareWebhookCreateDataUnderIsolationIndexErrorComponent =
  {
    attr: 'data.under_isolation.INDEX';
    code: 'required';
    detail: string;
  };
export type BrokersVectorcareWebhookCreateDataWaitAndReturnErrorComponent = {
  attr: 'data.wait_and_return';
  code: 'invalid';
  detail: string;
};
export type BrokersVectorcareWebhookCreateError =
  | ({
      attr: 'non_field_errors';
    } & BrokersVectorcareWebhookCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'event_id';
    } & BrokersVectorcareWebhookCreateEventIdErrorComponent)
  | ({
      attr: 'service_request_id';
    } & BrokersVectorcareWebhookCreateServiceRequestIdErrorComponent)
  | ({
      attr: 'request_status';
    } & BrokersVectorcareWebhookCreateRequestStatusErrorComponent)
  | ({
      attr: 'event_timestamp';
    } & BrokersVectorcareWebhookCreateEventTimestampErrorComponent)
  | ({
      attr: 'action';
    } & BrokersVectorcareWebhookCreateActionErrorComponent)
  | ({
      attr: 'data.non_field_errors';
    } & BrokersVectorcareWebhookCreateDataNonFieldErrorsErrorComponent)
  | ({
      attr: 'data.account_name';
    } & BrokersVectorcareWebhookCreateDataAccountNameErrorComponent)
  | ({
      attr: 'data.collection_id';
    } & BrokersVectorcareWebhookCreateDataCollectionIdErrorComponent)
  | ({
      attr: 'data.destination_location.non_field_errors';
    } & BrokersVectorcareWebhookCreateDataDestinationLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'data.destination_location.address';
    } & BrokersVectorcareWebhookCreateDataDestinationLocationAddressErrorComponent)
  | ({
      attr: 'data.destination_location.city';
    } & BrokersVectorcareWebhookCreateDataDestinationLocationCityErrorComponent)
  | ({
      attr: 'data.destination_location.state';
    } & BrokersVectorcareWebhookCreateDataDestinationLocationStateErrorComponent)
  | ({
      attr: 'data.destination_location.zip';
    } & BrokersVectorcareWebhookCreateDataDestinationLocationZipErrorComponent)
  | ({
      attr: 'data.destination_location.street';
    } & BrokersVectorcareWebhookCreateDataDestinationLocationStreetErrorComponent)
  | ({
      attr: 'data.destination_location.country';
    } & BrokersVectorcareWebhookCreateDataDestinationLocationCountryErrorComponent)
  | ({
      attr: 'data.destination_location.lat';
    } & BrokersVectorcareWebhookCreateDataDestinationLocationLatErrorComponent)
  | ({
      attr: 'data.destination_location.lng';
    } & BrokersVectorcareWebhookCreateDataDestinationLocationLngErrorComponent)
  | ({
      attr: 'data.facility_name';
    } & BrokersVectorcareWebhookCreateDataFacilityNameErrorComponent)
  | ({
      attr: 'data.is_round_trip_first_trip';
    } & BrokersVectorcareWebhookCreateDataIsRoundTripFirstTripErrorComponent)
  | ({
      attr: 'data.is_round_trip_return_trip';
    } & BrokersVectorcareWebhookCreateDataIsRoundTripReturnTripErrorComponent)
  | ({
      attr: 'data.round_trip_other_service_request_id';
    } & BrokersVectorcareWebhookCreateDataRoundTripOtherServiceRequestIdErrorComponent)
  | ({
      attr: 'data.organization_id';
    } & BrokersVectorcareWebhookCreateDataOrganizationIdErrorComponent)
  | ({
      attr: 'data.patient_active_membership';
    } & BrokersVectorcareWebhookCreateDataPatientActiveMembershipErrorComponent)
  | ({
      attr: 'data.patient_age';
    } & BrokersVectorcareWebhookCreateDataPatientAgeErrorComponent)
  | ({
      attr: 'data.patient_coverages';
    } & BrokersVectorcareWebhookCreateDataPatientCoveragesErrorComponent)
  | ({
      attr: 'data.patient_coverages.INDEX';
    } & BrokersVectorcareWebhookCreateDataPatientCoveragesIndexErrorComponent)
  | ({
      attr: 'data.patient_date_of_birth';
    } & BrokersVectorcareWebhookCreateDataPatientDateOfBirthErrorComponent)
  | ({
      attr: 'data.patient_first_name';
    } & BrokersVectorcareWebhookCreateDataPatientFirstNameErrorComponent)
  | ({
      attr: 'data.patient_gender';
    } & BrokersVectorcareWebhookCreateDataPatientGenderErrorComponent)
  | ({
      attr: 'data.patient_girth_inches';
    } & BrokersVectorcareWebhookCreateDataPatientGirthInchesErrorComponent)
  | ({
      attr: 'data.patient_height_inches';
    } & BrokersVectorcareWebhookCreateDataPatientHeightInchesErrorComponent)
  | ({
      attr: 'data.patient_id';
    } & BrokersVectorcareWebhookCreateDataPatientIdErrorComponent)
  | ({
      attr: 'data.patient_interpreter_required';
    } & BrokersVectorcareWebhookCreateDataPatientInterpreterRequiredErrorComponent)
  | ({
      attr: 'data.patient_language_spoken';
    } & BrokersVectorcareWebhookCreateDataPatientLanguageSpokenErrorComponent)
  | ({
      attr: 'data.patient_language_written';
    } & BrokersVectorcareWebhookCreateDataPatientLanguageWrittenErrorComponent)
  | ({
      attr: 'data.patient_last_name';
    } & BrokersVectorcareWebhookCreateDataPatientLastNameErrorComponent)
  | ({
      attr: 'data.patient_membership_primary_id';
    } & BrokersVectorcareWebhookCreateDataPatientMembershipPrimaryIdErrorComponent)
  | ({
      attr: 'data.patient_membership_primary_prefix';
    } & BrokersVectorcareWebhookCreateDataPatientMembershipPrimaryPrefixErrorComponent)
  | ({
      attr: 'data.patient_membership_secondary_id';
    } & BrokersVectorcareWebhookCreateDataPatientMembershipSecondaryIdErrorComponent)
  | ({
      attr: 'data.patient_membership_secondary_prefix';
    } & BrokersVectorcareWebhookCreateDataPatientMembershipSecondaryPrefixErrorComponent)
  | ({
      attr: 'data.patient_middle_name';
    } & BrokersVectorcareWebhookCreateDataPatientMiddleNameErrorComponent)
  | ({
      attr: 'data.patient_over_300p';
    } & BrokersVectorcareWebhookCreateDataPatientOver300PErrorComponent)
  | ({
      attr: 'data.patient_weight_kg';
    } & BrokersVectorcareWebhookCreateDataPatientWeightKgErrorComponent)
  | ({
      attr: 'data.patient_weight_lbs';
    } & BrokersVectorcareWebhookCreateDataPatientWeightLbsErrorComponent)
  | ({
      attr: 'data.pickup_location.non_field_errors';
    } & BrokersVectorcareWebhookCreateDataPickupLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'data.pickup_location.address';
    } & BrokersVectorcareWebhookCreateDataPickupLocationAddressErrorComponent)
  | ({
      attr: 'data.pickup_location.city';
    } & BrokersVectorcareWebhookCreateDataPickupLocationCityErrorComponent)
  | ({
      attr: 'data.pickup_location.state';
    } & BrokersVectorcareWebhookCreateDataPickupLocationStateErrorComponent)
  | ({
      attr: 'data.pickup_location.zip';
    } & BrokersVectorcareWebhookCreateDataPickupLocationZipErrorComponent)
  | ({
      attr: 'data.pickup_location.street';
    } & BrokersVectorcareWebhookCreateDataPickupLocationStreetErrorComponent)
  | ({
      attr: 'data.pickup_location.country';
    } & BrokersVectorcareWebhookCreateDataPickupLocationCountryErrorComponent)
  | ({
      attr: 'data.pickup_location.lat';
    } & BrokersVectorcareWebhookCreateDataPickupLocationLatErrorComponent)
  | ({
      attr: 'data.pickup_location.lng';
    } & BrokersVectorcareWebhookCreateDataPickupLocationLngErrorComponent)
  | ({
      attr: 'data.responder_user_email';
    } & BrokersVectorcareWebhookCreateDataResponderUserEmailErrorComponent)
  | ({
      attr: 'data.responder_user_first_name';
    } & BrokersVectorcareWebhookCreateDataResponderUserFirstNameErrorComponent)
  | ({
      attr: 'data.responder_user_last_name';
    } & BrokersVectorcareWebhookCreateDataResponderUserLastNameErrorComponent)
  | ({
      attr: 'data.requester_email';
    } & BrokersVectorcareWebhookCreateDataRequesterEmailErrorComponent)
  | ({
      attr: 'data.requester_first_name';
    } & BrokersVectorcareWebhookCreateDataRequesterFirstNameErrorComponent)
  | ({
      attr: 'data.requester_last_name';
    } & BrokersVectorcareWebhookCreateDataRequesterLastNameErrorComponent)
  | ({
      attr: 'data.request_current_state';
    } & BrokersVectorcareWebhookCreateDataRequestCurrentStateErrorComponent)
  | ({
      attr: 'data.scheduling_option';
    } & BrokersVectorcareWebhookCreateDataSchedulingOptionErrorComponent)
  | ({
      attr: 'data.scheduling_type';
    } & BrokersVectorcareWebhookCreateDataSchedulingTypeErrorComponent)
  | ({
      attr: 'data.service_level_type';
    } & BrokersVectorcareWebhookCreateDataServiceLevelTypeErrorComponent)
  | ({
      attr: 'data.service_request_id';
    } & BrokersVectorcareWebhookCreateDataServiceRequestIdErrorComponent)
  | ({
      attr: 'data.service_type';
    } & BrokersVectorcareWebhookCreateDataServiceTypeErrorComponent)
  | ({
      attr: 'data.agreed_for_time';
    } & BrokersVectorcareWebhookCreateDataAgreedForTimeErrorComponent)
  | ({
      attr: 'data.appointment_datetime';
    } & BrokersVectorcareWebhookCreateDataAppointmentDatetimeErrorComponent)
  | ({
      attr: 'data.arrival_airport.non_field_errors';
    } & BrokersVectorcareWebhookCreateDataArrivalAirportNonFieldErrorsErrorComponent)
  | ({
      attr: 'data.arrival_airport.address';
    } & BrokersVectorcareWebhookCreateDataArrivalAirportAddressErrorComponent)
  | ({
      attr: 'data.arrival_airport.city';
    } & BrokersVectorcareWebhookCreateDataArrivalAirportCityErrorComponent)
  | ({
      attr: 'data.arrival_airport.state';
    } & BrokersVectorcareWebhookCreateDataArrivalAirportStateErrorComponent)
  | ({
      attr: 'data.arrival_airport.zip';
    } & BrokersVectorcareWebhookCreateDataArrivalAirportZipErrorComponent)
  | ({
      attr: 'data.arrival_airport.street';
    } & BrokersVectorcareWebhookCreateDataArrivalAirportStreetErrorComponent)
  | ({
      attr: 'data.arrival_airport.country';
    } & BrokersVectorcareWebhookCreateDataArrivalAirportCountryErrorComponent)
  | ({
      attr: 'data.arrival_airport.lat';
    } & BrokersVectorcareWebhookCreateDataArrivalAirportLatErrorComponent)
  | ({
      attr: 'data.arrival_airport.lng';
    } & BrokersVectorcareWebhookCreateDataArrivalAirportLngErrorComponent)
  | ({
      attr: 'data.authorizing_physician';
    } & BrokersVectorcareWebhookCreateDataAuthorizingPhysicianErrorComponent)
  | ({
      attr: 'data.can_ambulate';
    } & BrokersVectorcareWebhookCreateDataCanAmbulateErrorComponent)
  | ({
      attr: 'data.case_number';
    } & BrokersVectorcareWebhookCreateDataCaseNumberErrorComponent)
  | ({
      attr: 'data.cct_criteria';
    } & BrokersVectorcareWebhookCreateDataCctCriteriaErrorComponent)
  | ({
      attr: 'data.cct_criteria.INDEX';
    } & BrokersVectorcareWebhookCreateDataCctCriteriaIndexErrorComponent)
  | ({
      attr: 'data.contact_name';
    } & BrokersVectorcareWebhookCreateDataContactNameErrorComponent)
  | ({
      attr: 'data.contact_phone';
    } & BrokersVectorcareWebhookCreateDataContactPhoneErrorComponent)
  | ({
      attr: 'data.departure_airport.non_field_errors';
    } & BrokersVectorcareWebhookCreateDataDepartureAirportNonFieldErrorsErrorComponent)
  | ({
      attr: 'data.departure_airport.address';
    } & BrokersVectorcareWebhookCreateDataDepartureAirportAddressErrorComponent)
  | ({
      attr: 'data.departure_airport.city';
    } & BrokersVectorcareWebhookCreateDataDepartureAirportCityErrorComponent)
  | ({
      attr: 'data.departure_airport.state';
    } & BrokersVectorcareWebhookCreateDataDepartureAirportStateErrorComponent)
  | ({
      attr: 'data.departure_airport.zip';
    } & BrokersVectorcareWebhookCreateDataDepartureAirportZipErrorComponent)
  | ({
      attr: 'data.departure_airport.street';
    } & BrokersVectorcareWebhookCreateDataDepartureAirportStreetErrorComponent)
  | ({
      attr: 'data.departure_airport.country';
    } & BrokersVectorcareWebhookCreateDataDepartureAirportCountryErrorComponent)
  | ({
      attr: 'data.departure_airport.lat';
    } & BrokersVectorcareWebhookCreateDataDepartureAirportLatErrorComponent)
  | ({
      attr: 'data.departure_airport.lng';
    } & BrokersVectorcareWebhookCreateDataDepartureAirportLngErrorComponent)
  | ({
      attr: 'data.destination_address_detail';
    } & BrokersVectorcareWebhookCreateDataDestinationAddressDetailErrorComponent)
  | ({
      attr: 'data.destination_facility_name';
    } & BrokersVectorcareWebhookCreateDataDestinationFacilityNameErrorComponent)
  | ({
      attr: 'data.destination_facility_type';
    } & BrokersVectorcareWebhookCreateDataDestinationFacilityTypeErrorComponent)
  | ({
      attr: 'data.destination_is_home';
    } & BrokersVectorcareWebhookCreateDataDestinationIsHomeErrorComponent)
  | ({
      attr: 'data.destination_phone_number';
    } & BrokersVectorcareWebhookCreateDataDestinationPhoneNumberErrorComponent)
  | ({
      attr: 'data.destination_phone_number_extension';
    } & BrokersVectorcareWebhookCreateDataDestinationPhoneNumberExtensionErrorComponent)
  | ({
      attr: 'data.destination_room_number';
    } & BrokersVectorcareWebhookCreateDataDestinationRoomNumberErrorComponent)
  | ({
      attr: 'data.destination_stair_steps';
    } & BrokersVectorcareWebhookCreateDataDestinationStairStepsErrorComponent)
  | ({
      attr: 'data.diagnosis_notes';
    } & BrokersVectorcareWebhookCreateDataDiagnosisNotesErrorComponent)
  | ({
      attr: 'data.escalated';
    } & BrokersVectorcareWebhookCreateDataEscalatedErrorComponent)
  | ({
      attr: 'data.external_authorization';
    } & BrokersVectorcareWebhookCreateDataExternalAuthorizationErrorComponent)
  | ({
      attr: 'data.gl_code';
    } & BrokersVectorcareWebhookCreateDataGlCodeErrorComponent)
  | ({
      attr: 'data.has_own_wheelchair';
    } & BrokersVectorcareWebhookCreateDataHasOwnWheelchairErrorComponent)
  | ({
      attr: 'data.hospice';
    } & BrokersVectorcareWebhookCreateDataHospiceErrorComponent)
  | ({
      attr: 'data.intravenous_therapy';
    } & BrokersVectorcareWebhookCreateDataIntravenousTherapyErrorComponent)
  | ({
      attr: 'data.intravenous_therapy.INDEX';
    } & BrokersVectorcareWebhookCreateDataIntravenousTherapyIndexErrorComponent)
  | ({
      attr: 'data.is_dialysis_trip';
    } & BrokersVectorcareWebhookCreateDataIsDialysisTripErrorComponent)
  | ({
      attr: 'data.is_inpatient';
    } & BrokersVectorcareWebhookCreateDataIsInpatientErrorComponent)
  | ({
      attr: 'data.is_recent_onset';
    } & BrokersVectorcareWebhookCreateDataIsRecentOnsetErrorComponent)
  | ({
      attr: 'data.isolation_precaution';
    } & BrokersVectorcareWebhookCreateDataIsolationPrecautionErrorComponent)
  | ({
      attr: 'data.medical_supervision';
    } & BrokersVectorcareWebhookCreateDataMedicalSupervisionErrorComponent)
  | ({
      attr: 'data.medical_supervision.INDEX';
    } & BrokersVectorcareWebhookCreateDataMedicalSupervisionIndexErrorComponent)
  | ({
      attr: 'data.medications';
    } & BrokersVectorcareWebhookCreateDataMedicationsErrorComponent)
  | ({
      attr: 'data.medications.INDEX';
    } & BrokersVectorcareWebhookCreateDataMedicationsIndexErrorComponent)
  | ({
      attr: 'data.mental_health_hold';
    } & BrokersVectorcareWebhookCreateDataMentalHealthHoldErrorComponent)
  | ({
      attr: 'data.mental_health_hold.INDEX';
    } & BrokersVectorcareWebhookCreateDataMentalHealthHoldIndexErrorComponent)
  | ({
      attr: 'data.note';
    } & BrokersVectorcareWebhookCreateDataNoteErrorComponent)
  | ({
      attr: 'data.number_of_drips';
    } & BrokersVectorcareWebhookCreateDataNumberOfDripsErrorComponent)
  | ({
      attr: 'data.o2';
    } & BrokersVectorcareWebhookCreateDataO2ErrorComponent)
  | ({
      attr: 'data.other_requirements';
    } & BrokersVectorcareWebhookCreateDataOtherRequirementsErrorComponent)
  | ({
      attr: 'data.override_approver';
    } & BrokersVectorcareWebhookCreateDataOverrideApproverErrorComponent)
  | ({
      attr: 'data.override_reason';
    } & BrokersVectorcareWebhookCreateDataOverrideReasonErrorComponent)
  | ({
      attr: 'data.override_reason.INDEX';
    } & BrokersVectorcareWebhookCreateDataOverrideReasonIndexErrorComponent)
  | ({
      attr: 'data.patient_bmi';
    } & BrokersVectorcareWebhookCreateDataPatientBmiErrorComponent)
  | ({
      attr: 'data.patient_is_ready';
    } & BrokersVectorcareWebhookCreateDataPatientIsReadyErrorComponent)
  | ({
      attr: 'data.payment_option_primary';
    } & BrokersVectorcareWebhookCreateDataPaymentOptionPrimaryErrorComponent)
  | ({
      attr: 'data.payment_option_primary_group_number';
    } & BrokersVectorcareWebhookCreateDataPaymentOptionPrimaryGroupNumberErrorComponent)
  | ({
      attr: 'data.payment_option_primary_subscriber_id';
    } & BrokersVectorcareWebhookCreateDataPaymentOptionPrimarySubscriberIdErrorComponent)
  | ({
      attr: 'data.payment_option_secondary';
    } & BrokersVectorcareWebhookCreateDataPaymentOptionSecondaryErrorComponent)
  | ({
      attr: 'data.payment_option_secondary_group_number';
    } & BrokersVectorcareWebhookCreateDataPaymentOptionSecondaryGroupNumberErrorComponent)
  | ({
      attr: 'data.payment_option_secondary_subscriber_id';
    } & BrokersVectorcareWebhookCreateDataPaymentOptionSecondarySubscriberIdErrorComponent)
  | ({
      attr: 'data.pickup_date_time';
    } & BrokersVectorcareWebhookCreateDataPickupDateTimeErrorComponent)
  | ({
      attr: 'data.pickup_facility_name';
    } & BrokersVectorcareWebhookCreateDataPickupFacilityNameErrorComponent)
  | ({
      attr: 'data.pickup_facility_type';
    } & BrokersVectorcareWebhookCreateDataPickupFacilityTypeErrorComponent)
  | ({
      attr: 'data.pickup_is_home';
    } & BrokersVectorcareWebhookCreateDataPickupIsHomeErrorComponent)
  | ({
      attr: 'data.pickup_phone_number';
    } & BrokersVectorcareWebhookCreateDataPickupPhoneNumberErrorComponent)
  | ({
      attr: 'data.pickup_phone_number_extension';
    } & BrokersVectorcareWebhookCreateDataPickupPhoneNumberExtensionErrorComponent)
  | ({
      attr: 'data.pickup_room_number';
    } & BrokersVectorcareWebhookCreateDataPickupRoomNumberErrorComponent)
  | ({
      attr: 'data.pickup_stair_steps';
    } & BrokersVectorcareWebhookCreateDataPickupStairStepsErrorComponent)
  | ({
      attr: 'data.pre_authorization_number';
    } & BrokersVectorcareWebhookCreateDataPreAuthorizationNumberErrorComponent)
  | ({
      attr: 'data.receiving_practitioner';
    } & BrokersVectorcareWebhookCreateDataReceivingPractitionerErrorComponent)
  | ({
      attr: 'data.requester_phone_number';
    } & BrokersVectorcareWebhookCreateDataRequesterPhoneNumberErrorComponent)
  | ({
      attr: 'data.requester_phone_number_extension';
    } & BrokersVectorcareWebhookCreateDataRequesterPhoneNumberExtensionErrorComponent)
  | ({
      attr: 'data.required_equipment';
    } & BrokersVectorcareWebhookCreateDataRequiredEquipmentErrorComponent)
  | ({
      attr: 'data.required_equipment.INDEX';
    } & BrokersVectorcareWebhookCreateDataRequiredEquipmentIndexErrorComponent)
  | ({
      attr: 'data.return_date_time';
    } & BrokersVectorcareWebhookCreateDataReturnDateTimeErrorComponent)
  | ({
      attr: 'data.return_on_will_call';
    } & BrokersVectorcareWebhookCreateDataReturnOnWillCallErrorComponent)
  | ({
      attr: 'data.revised_eta';
    } & BrokersVectorcareWebhookCreateDataRevisedEtaErrorComponent)
  | ({
      attr: 'data.special_equipment';
    } & BrokersVectorcareWebhookCreateDataSpecialEquipmentErrorComponent)
  | ({
      attr: 'data.special_equipment.INDEX';
    } & BrokersVectorcareWebhookCreateDataSpecialEquipmentIndexErrorComponent)
  | ({
      attr: 'data.spoken_language';
    } & BrokersVectorcareWebhookCreateDataSpokenLanguageErrorComponent)
  | ({
      attr: 'data.transport_reason';
    } & BrokersVectorcareWebhookCreateDataTransportReasonErrorComponent)
  | ({
      attr: 'data.transport_reason.INDEX';
    } & BrokersVectorcareWebhookCreateDataTransportReasonIndexErrorComponent)
  | ({
      attr: 'data.travel_authorization_number';
    } & BrokersVectorcareWebhookCreateDataTravelAuthorizationNumberErrorComponent)
  | ({
      attr: 'data.trip_priority_level';
    } & BrokersVectorcareWebhookCreateDataTripPriorityLevelErrorComponent)
  | ({
      attr: 'data.under_isolation';
    } & BrokersVectorcareWebhookCreateDataUnderIsolationErrorComponent)
  | ({
      attr: 'data.under_isolation.INDEX';
    } & BrokersVectorcareWebhookCreateDataUnderIsolationIndexErrorComponent)
  | ({
      attr: 'data.wait_and_return';
    } & BrokersVectorcareWebhookCreateDataWaitAndReturnErrorComponent);
export type BrokersVectorcareWebhookCreateValidationError = {
  type: ValidationErrorEnum;
  errors: BrokersVectorcareWebhookCreateError[];
};
export type BrokersVectorcareWebhookCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & BrokersVectorcareWebhookCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type Credential = {
  credential_type_id: string;
  expiration_date: string;
  notes?: string;
};
export type CredentialCategoryEnum = 'Team' | 'Vehicle' | 'Misc';
export type CredentialType = {
  name: string;
  description?: string;
  category: CredentialCategoryEnum;
};
export type CredentialTypeRead = {
  id: string;
  name: string;
  description?: string;
  category: CredentialCategoryEnum;
};
export type CredentialMembership = {
  first_name: string;
  last_name: string;
  deleted_at?: string | null;
};
export type CredentialMembershipRead = {
  id: string;
  first_name: string;
  last_name: string;
  deleted_at?: string | null;
};
export type CredentialVehicle = {
  nickname?: string;
};
export type CredentialVehicleRead = {
  id: string;
  nickname?: string;
};
export type CredentialRead = {
  id: string;
  credential_type: CredentialTypeRead;
  credential_type_id: string;
  membership: CredentialMembershipRead | null;
  vehicle: CredentialVehicleRead | null;
  expiration_date: string;
  notes?: string;
};
export type CredentialWrite = {
  credential_type_id: string;
  membership_id?: string;
  vehicle_id?: string;
  expiration_date: string;
  notes?: string;
};
export type PaginatedCredentialList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Credential[];
};
export type PaginatedCredentialListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: CredentialRead[];
};
export type PaginatedCredentialListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: CredentialWrite[];
};
export type CredentialsListCredentialTypeCategoryErrorComponent = {
  attr: 'credential_type_category';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type CredentialsListCredentialTypesErrorComponent = {
  attr: 'credential_types';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type CredentialsListMembersErrorComponent = {
  attr: 'members';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type CredentialsListVehiclesErrorComponent = {
  attr: 'vehicles';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type CredentialsListError =
  | ({
      attr: 'credential_type_category';
    } & CredentialsListCredentialTypeCategoryErrorComponent)
  | ({
      attr: 'credential_types';
    } & CredentialsListCredentialTypesErrorComponent)
  | ({
      attr: 'members';
    } & CredentialsListMembersErrorComponent)
  | ({
      attr: 'vehicles';
    } & CredentialsListVehiclesErrorComponent);
export type CredentialsListValidationError = {
  type: ValidationErrorEnum;
  errors: CredentialsListError[];
};
export type CredentialsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & CredentialsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type CredentialsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type CredentialsCreateCredentialTypeNameErrorComponent = {
  attr: 'credential_type.name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsCreateCredentialTypeDescriptionErrorComponent = {
  attr: 'credential_type.description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsCreateCredentialTypeCategoryErrorComponent = {
  attr: 'credential_type.category';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type CredentialsCreateCredentialTypeIdErrorComponent = {
  attr: 'credential_type_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type CredentialsCreateMembershipFirstNameErrorComponent = {
  attr: 'membership.first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsCreateMembershipLastNameErrorComponent = {
  attr: 'membership.last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsCreateMembershipDeletedAtErrorComponent = {
  attr: 'membership.deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type CredentialsCreateMembershipIdErrorComponent = {
  attr: 'membership_id';
  code: 'invalid' | 'null';
  detail: string;
};
export type CredentialsCreateVehicleNicknameErrorComponent = {
  attr: 'vehicle.nickname';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsCreateVehicleIdErrorComponent = {
  attr: 'vehicle_id';
  code: 'invalid' | 'null';
  detail: string;
};
export type CredentialsCreateExpirationDateErrorComponent = {
  attr: 'expiration_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type CredentialsCreateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsCreateError =
  | ({
      attr: 'non_field_errors';
    } & CredentialsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'credential_type.name';
    } & CredentialsCreateCredentialTypeNameErrorComponent)
  | ({
      attr: 'credential_type.description';
    } & CredentialsCreateCredentialTypeDescriptionErrorComponent)
  | ({
      attr: 'credential_type.category';
    } & CredentialsCreateCredentialTypeCategoryErrorComponent)
  | ({
      attr: 'credential_type_id';
    } & CredentialsCreateCredentialTypeIdErrorComponent)
  | ({
      attr: 'membership.first_name';
    } & CredentialsCreateMembershipFirstNameErrorComponent)
  | ({
      attr: 'membership.last_name';
    } & CredentialsCreateMembershipLastNameErrorComponent)
  | ({
      attr: 'membership.deleted_at';
    } & CredentialsCreateMembershipDeletedAtErrorComponent)
  | ({
      attr: 'membership_id';
    } & CredentialsCreateMembershipIdErrorComponent)
  | ({
      attr: 'vehicle.nickname';
    } & CredentialsCreateVehicleNicknameErrorComponent)
  | ({
      attr: 'vehicle_id';
    } & CredentialsCreateVehicleIdErrorComponent)
  | ({
      attr: 'expiration_date';
    } & CredentialsCreateExpirationDateErrorComponent)
  | ({
      attr: 'notes';
    } & CredentialsCreateNotesErrorComponent);
export type CredentialsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: CredentialsCreateError[];
};
export type CredentialsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & CredentialsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type CredentialsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type CredentialsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type CredentialsPartialUpdateCredentialTypeNameErrorComponent = {
  attr: 'credential_type.name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsPartialUpdateCredentialTypeDescriptionErrorComponent = {
  attr: 'credential_type.description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsPartialUpdateCredentialTypeCategoryErrorComponent = {
  attr: 'credential_type.category';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type CredentialsPartialUpdateCredentialTypeIdErrorComponent = {
  attr: 'credential_type_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type CredentialsPartialUpdateMembershipFirstNameErrorComponent = {
  attr: 'membership.first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsPartialUpdateMembershipLastNameErrorComponent = {
  attr: 'membership.last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsPartialUpdateMembershipDeletedAtErrorComponent = {
  attr: 'membership.deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type CredentialsPartialUpdateMembershipIdErrorComponent = {
  attr: 'membership_id';
  code: 'invalid' | 'null';
  detail: string;
};
export type CredentialsPartialUpdateVehicleNicknameErrorComponent = {
  attr: 'vehicle.nickname';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsPartialUpdateVehicleIdErrorComponent = {
  attr: 'vehicle_id';
  code: 'invalid' | 'null';
  detail: string;
};
export type CredentialsPartialUpdateExpirationDateErrorComponent = {
  attr: 'expiration_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type CredentialsPartialUpdateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & CredentialsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'credential_type.name';
    } & CredentialsPartialUpdateCredentialTypeNameErrorComponent)
  | ({
      attr: 'credential_type.description';
    } & CredentialsPartialUpdateCredentialTypeDescriptionErrorComponent)
  | ({
      attr: 'credential_type.category';
    } & CredentialsPartialUpdateCredentialTypeCategoryErrorComponent)
  | ({
      attr: 'credential_type_id';
    } & CredentialsPartialUpdateCredentialTypeIdErrorComponent)
  | ({
      attr: 'membership.first_name';
    } & CredentialsPartialUpdateMembershipFirstNameErrorComponent)
  | ({
      attr: 'membership.last_name';
    } & CredentialsPartialUpdateMembershipLastNameErrorComponent)
  | ({
      attr: 'membership.deleted_at';
    } & CredentialsPartialUpdateMembershipDeletedAtErrorComponent)
  | ({
      attr: 'membership_id';
    } & CredentialsPartialUpdateMembershipIdErrorComponent)
  | ({
      attr: 'vehicle.nickname';
    } & CredentialsPartialUpdateVehicleNicknameErrorComponent)
  | ({
      attr: 'vehicle_id';
    } & CredentialsPartialUpdateVehicleIdErrorComponent)
  | ({
      attr: 'expiration_date';
    } & CredentialsPartialUpdateExpirationDateErrorComponent)
  | ({
      attr: 'notes';
    } & CredentialsPartialUpdateNotesErrorComponent);
export type CredentialsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: CredentialsPartialUpdateError[];
};
export type CredentialsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & CredentialsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedCredential = {
  credential_type_id?: string;
  expiration_date?: string;
  notes?: string;
};
export type PatchedCredentialRead = {
  id?: string;
  credential_type?: CredentialTypeRead;
  credential_type_id?: string;
  membership?: CredentialMembershipRead | null;
  vehicle?: CredentialVehicleRead | null;
  expiration_date?: string;
  notes?: string;
};
export type PatchedCredentialWrite = {
  credential_type_id?: string;
  membership_id?: string;
  vehicle_id?: string;
  expiration_date?: string;
  notes?: string;
};
export type CredentialsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type CredentialExpiringSoonCount = {
  team?: number;
  vehicle?: number;
};
export type CredentialsExpiringSoonCountRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PaginatedCredentialTypeList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: CredentialType[];
};
export type PaginatedCredentialTypeListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: CredentialTypeRead[];
};
export type CredentialsTypesListIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null_characters_not_allowed';
  detail: string;
};
export type CredentialsTypesListNameErrorComponent = {
  attr: 'name';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type CredentialsTypesListDescriptionErrorComponent = {
  attr: 'description';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type CredentialsTypesListCategoryErrorComponent = {
  attr: 'category';
  code: 'invalid_choice';
  detail: string;
};
export type CredentialsTypesListError =
  | ({
      attr: 'id';
    } & CredentialsTypesListIdErrorComponent)
  | ({
      attr: 'name';
    } & CredentialsTypesListNameErrorComponent)
  | ({
      attr: 'description';
    } & CredentialsTypesListDescriptionErrorComponent)
  | ({
      attr: 'category';
    } & CredentialsTypesListCategoryErrorComponent);
export type CredentialsTypesListValidationError = {
  type: ValidationErrorEnum;
  errors: CredentialsTypesListError[];
};
export type CredentialsTypesListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & CredentialsTypesListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type CredentialsTypesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type CredentialsTypesCreateNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsTypesCreateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsTypesCreateCategoryErrorComponent = {
  attr: 'category';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type CredentialsTypesCreateError =
  | ({
      attr: 'non_field_errors';
    } & CredentialsTypesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & CredentialsTypesCreateNameErrorComponent)
  | ({
      attr: 'description';
    } & CredentialsTypesCreateDescriptionErrorComponent)
  | ({
      attr: 'category';
    } & CredentialsTypesCreateCategoryErrorComponent);
export type CredentialsTypesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: CredentialsTypesCreateError[];
};
export type CredentialsTypesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & CredentialsTypesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type CredentialsTypesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type CredentialsTypesPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type CredentialsTypesPartialUpdateNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsTypesPartialUpdateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type CredentialsTypesPartialUpdateCategoryErrorComponent = {
  attr: 'category';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type CredentialsTypesPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & CredentialsTypesPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & CredentialsTypesPartialUpdateNameErrorComponent)
  | ({
      attr: 'description';
    } & CredentialsTypesPartialUpdateDescriptionErrorComponent)
  | ({
      attr: 'category';
    } & CredentialsTypesPartialUpdateCategoryErrorComponent);
export type CredentialsTypesPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: CredentialsTypesPartialUpdateError[];
};
export type CredentialsTypesPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & CredentialsTypesPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedCredentialType = {
  name?: string;
  description?: string;
  category?: CredentialCategoryEnum;
};
export type PatchedCredentialTypeRead = {
  id?: string;
  name?: string;
  description?: string;
  category?: CredentialCategoryEnum;
};
export type CredentialsTypesDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type DailyDigest = {
  organization_id: string;
  day_offset: number;
};
export type DailyDigestRead = {
  organization_id: string;
  day_offset: number;
  digest: string;
};
export type DailyDigestCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type DailyDigestCreateOrganizationIdErrorComponent = {
  attr: 'organization_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type DailyDigestCreateDayOffsetErrorComponent = {
  attr: 'day_offset';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type DailyDigestCreateError =
  | ({
      attr: 'non_field_errors';
    } & DailyDigestCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'organization_id';
    } & DailyDigestCreateOrganizationIdErrorComponent)
  | ({
      attr: 'day_offset';
    } & DailyDigestCreateDayOffsetErrorComponent);
export type DailyDigestCreateValidationError = {
  type: ValidationErrorEnum;
  errors: DailyDigestCreateError[];
};
export type DailyDigestCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & DailyDigestCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type DispatchAssignment = {};
export type DispatchAssignedVehicle = {};
export type VehicleCategoryEnum = 'wheelchair' | 'stretcher' | 'ambulatory';
export type DispatchVehicleTag = {
  tag_name: string;
  color_hex: string;
};
export type DispatchVehicleTagRead = {
  id: string;
  tag: string;
  tag_name: string;
  color_hex: string;
};
export type DispatchAssignedVehicleRead = {
  id: string;
  nickname: string;
  category: VehicleCategoryEnum;
  tags: DispatchVehicleTagRead[];
  storage_location_label: string | null;
};
export type DispatchAssignedDriver = {};
export type DispatchDriverTag = {
  tag_name: string;
  color_hex: string;
};
export type DispatchDriverTagRead = {
  id: string;
  tag: string;
  tag_name: string;
  color_hex: string;
};
export type DispatchAssignedDriverRead = {
  id: string;
  assigned_membership: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  can_be_scheduled: boolean;
  tags: DispatchDriverTagRead[];
  deleted_at: string | null;
  driver_deleted_at: string | null;
  membership_deleted_at: string | null;
};
export type DriverCallRequest = {
  /** Comment from driver on reason for the call */
  comment?: string;
};
export type DriverCallRequestRead = {
  id: string;
  assignment: string;
  created_at: string;
  /** Membership of driver that created the call request */
  created_by: string;
  /** Membership of non-associate that resolved the call request */
  resolved_by: string | null;
  canceled_at: string | null;
  resolved_at: string | null;
  /** Comment from driver on reason for the call */
  comment?: string;
};
export type DispatchAssignmentStatusEnum = 'scheduled' | 'active' | 'complete';
export type DispatchAssignedAttendant = {};
export type DispatchAssignedAttendantRead = {
  id: string;
  first_name: string;
  last_name: string;
  can_be_scheduled: boolean;
};
export type DispatchAssignmentBreaks = {};
export type DispatchAssignmentBreaksRead = {
  id: string;
  start: string;
  end: string;
  break_notes: string;
  started_at: string | null;
  ended_at: string | null;
};
export type DispatchAssignmentRead = {
  id: string;
  start: string;
  end: string;
  vehicle: DispatchAssignedVehicleRead;
  driver: DispatchAssignedDriverRead;
  driver_call_requests: DriverCallRequestRead[];
  status: DispatchAssignmentStatusEnum;
  attendants: DispatchAssignedAttendantRead[];
  breaks: DispatchAssignmentBreaksRead[];
  clocked_in_at: string | null;
  clocked_out_at: string | null;
  estimated_revenue: number | null;
  show_pricing: boolean;
  loaded_miles: number | null;
  unloaded_miles: number | null;
  final_travel_time_minutes: number | null;
  final_travel_time_range_start: string | null;
  final_travel_time_range_end: string | null;
};
export type DispatchInboundTrip = {};
export type DispatchTripPassenger = {};
export type DispatchTripPassengerRead = {
  id: string;
  full_name: string;
  deleted_at: string | null;
};
export type DispatchInboundTripRead = {
  id: string;
  passenger: DispatchTripPassengerRead;
  scheduled_pickup_at: string;
  scheduled_dropoff_at: string;
  estimated_duration_sec: number;
  service_type: ServiceTypeEnum;
  /** Current status of this trip */
  status: OverrideStatusEnum;
  assignment_id: string;
  /** Locked assignment cannot be changed */
  is_locked: boolean | null;
  is_activated_will_call: boolean;
  is_non_activated_will_call: boolean;
  pickup_address: string;
  dropoff_address: string;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** The time of the passenger's appointment */
  appointment_at: string | null;
  travel_time_minutes: number | null;
  travel_distance_miles: number | null;
};
export type DispatchTrip = {
  inbound_trip: DispatchInboundTrip | null;
  /** Most recently calculated time of arrival to pickup destination */
  arrival_time: string;
  /** Most recently calculated time of trip completion */
  completion_time: string;
};
export type DispatchTripPayerOrganization = {};
export type DispatchTripPayerOrganizationRead = {
  id: string;
  /** Name the organization uses to refer to this payer across the app */
  display_name: string;
};
export type DispatchTripTiming = {};
export type DispatchTripTimingRead = {
  /** Estimated arrival at pickup location per vehicle's last location log */
  estimated_pickup_arrival_time: string | null;
  /** Estimated time this trip will be completed per vehicle's last location log */
  estimated_completion_time: string | null;
  is_on_time: boolean | null;
  delayed_by_seconds: number | null;
  /** Last time this timing was calculated */
  last_calculated_at: string | null;
};
export type DispatchTripTag = {
  tag_name: string;
  color_hex: string;
};
export type DispatchTripTagRead = {
  id: string;
  tag: string;
  tag_name: string;
  color_hex: string;
};
export type IntermediaryEnum =
  | 'call_the_car'
  | 'kinetik'
  | 'momentm'
  | 'mtm'
  | 'alivi'
  | 'provide_a_ride'
  | 'cts'
  | 'welltrans'
  | 'verida'
  | 'tennessee_carriers'
  | 'clearview'
  | 'vectorcare';
export type DispatchTripRead = {
  id: string;
  passenger: DispatchTripPassengerRead;
  payer: DispatchTripPayerOrganizationRead;
  scheduled_pickup_at: string;
  scheduled_dropoff_at: string;
  estimated_duration_sec: number;
  service_type: ServiceTypeEnum;
  /** Current status of this trip */
  status: OverrideStatusEnum;
  assignment_id: string;
  inbound_trip: DispatchInboundTripRead | null;
  /** Locked assignment cannot be changed */
  is_locked: boolean | null;
  is_activated_will_call: boolean;
  is_non_activated_will_call: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound: boolean;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound: boolean;
  multiload_id: string | null;
  pickup_address: string;
  pickup_latitude: number;
  pickup_longitude: number;
  pickup_driver_notes: string;
  pickup_trip_location_detail_id: string | null;
  pickup_order: number | null;
  pickup_place_id: string | null;
  dropoff_address: string;
  dropoff_latitude: number;
  dropoff_longitude: number;
  dropoff_driver_notes: string;
  dropoff_trip_location_detail_id: string | null;
  dropoff_order: number | null;
  dropoff_place_id: string | null;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** The time of the passenger's appointment */
  appointment_at: string | null;
  /** template used to create this trip, if uploaded via csv */
  one_schema_template_id: string | null;
  /** template used to create this trip, if backfilled via csv */
  one_schema_template_multi_id: string | null;
  timing: DispatchTripTimingRead | null;
  /** Optional extra time spent waiting for the pickup, provided by dispatcher */
  pickup_wait_time_seconds: number | null;
  tags: DispatchTripTagRead[] | null;
  /** Notes only visible to the dispatcher */
  dispatcher_notes: string;
  wait_time_start: string | null;
  wait_time_end: string | null;
  /** Most recently calculated time of arrival to pickup destination */
  arrival_time: string;
  /** Most recently calculated time of trip completion */
  completion_time: string;
  missing_any_required_signature: boolean | null;
  travel_time_minutes: number | null;
  travel_distance_miles: number | null;
  /** The trip ID used by an intermediary/broker, may or may not be the originator */
  intermediary_id: string;
  /** The intermediary/broker source of this trip */
  intermediary: IntermediaryEnum;
  /** An ID that relates all trips created in the same API request */
  correlation_id: string | null;
  is_cancellation_requested: boolean;
  num_accompanying_passengers: number | null;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload: boolean;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id: string;
};
export type DispatchTripSummary = {};
export type DispatchTripSummaryRead = {
  completed: number;
  will_call: number;
  canceled: number;
  on_time: number;
  delayed: number;
  assigned: number;
};
export type Dispatch = {
  assignments: DispatchAssignment[];
  unassigned_trips: DispatchTrip[];
  assigned_trips: DispatchTrip[];
  summary: DispatchTripSummary;
};
export type DispatchRead = {
  assignments: DispatchAssignmentRead[];
  unassigned_trips: DispatchTripRead[];
  assigned_trips: DispatchTripRead[];
  summary: DispatchTripSummaryRead;
  show_pricing: boolean;
};
export type DispatchRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type DispatchSummaryRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type DriverTag = {
  driver: string;
  tag: string;
};
export type DriverTagRead = {
  id: string;
  tag_name: string;
  color_hex: string;
  driver: string;
  tag: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedDriverTagList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: DriverTag[];
};
export type PaginatedDriverTagListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: DriverTagRead[];
};
export type DriverTagsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type DriverTagBulkCreate = {
  tags: DriverTag[];
};
export type DriverTagBulkCreateRead = {
  tags: DriverTagRead[];
};
export type DriverTagsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type DriverTagsCreateTagsNonFieldErrorsErrorComponent = {
  attr: 'tags.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type DriverTagsCreateTagsIndexNonFieldErrorsErrorComponent = {
  attr: 'tags.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required' | 'unique';
  detail: string;
};
export type DriverTagsCreateTagsIndexDriverErrorComponent = {
  attr: 'tags.INDEX.driver';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type DriverTagsCreateTagsIndexTagErrorComponent = {
  attr: 'tags.INDEX.tag';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type DriverTagsCreateError =
  | ({
      attr: 'non_field_errors';
    } & DriverTagsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.non_field_errors';
    } & DriverTagsCreateTagsNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.INDEX.non_field_errors';
    } & DriverTagsCreateTagsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.INDEX.driver';
    } & DriverTagsCreateTagsIndexDriverErrorComponent)
  | ({
      attr: 'tags.INDEX.tag';
    } & DriverTagsCreateTagsIndexTagErrorComponent);
export type DriverTagsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: DriverTagsCreateError[];
};
export type DriverTagsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & DriverTagsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type DriverTagsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type DriverTagsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type LicensePlateStateEnum =
  | 'AL'
  | 'AK'
  | 'AS'
  | 'AZ'
  | 'AR'
  | 'AA'
  | 'AE'
  | 'AP'
  | 'CA'
  | 'CO'
  | 'CT'
  | 'DE'
  | 'DC'
  | 'FL'
  | 'GA'
  | 'GU'
  | 'HI'
  | 'ID'
  | 'IL'
  | 'IN'
  | 'IA'
  | 'KS'
  | 'KY'
  | 'LA'
  | 'ME'
  | 'MD'
  | 'MA'
  | 'MI'
  | 'MN'
  | 'MS'
  | 'MO'
  | 'MT'
  | 'NE'
  | 'NV'
  | 'NH'
  | 'NJ'
  | 'NM'
  | 'NY'
  | 'NC'
  | 'ND'
  | 'MP'
  | 'OH'
  | 'OK'
  | 'OR'
  | 'PA'
  | 'PR'
  | 'RI'
  | 'SC'
  | 'SD'
  | 'TN'
  | 'TX'
  | 'UT'
  | 'VT'
  | 'VI'
  | 'VA'
  | 'WA'
  | 'WV'
  | 'WI'
  | 'WY'
  | 'AB'
  | 'BC'
  | 'MB'
  | 'NB'
  | 'NL'
  | 'NT'
  | 'NS'
  | 'NU'
  | 'ON'
  | 'PE'
  | 'QC'
  | 'SK'
  | 'YT';
export type Driver = {
  can_be_scheduled?: boolean;
  license_number: string;
  license_expiration_date: string;
  license_dob?: string;
  license_state: LicensePlateStateEnum;
  can_do_wheelchair_service?: boolean;
  can_do_wheelchair_xl_service?: boolean;
  can_do_broda_chair_service?: boolean;
  can_do_geri_chair_service?: boolean;
  can_do_stretcher_service?: boolean;
  can_do_stretcher_xl_service?: boolean;
  can_do_delivery_service?: boolean;
  can_do_ambulatory_service?: boolean;
  can_do_curb_to_curb?: boolean;
  can_do_door_to_door?: boolean;
  can_do_door_through_door?: boolean;
  can_do_person_to_person?: boolean;
  can_do_bariatric?: boolean;
  can_do_stairs?: boolean;
  can_do_student_transport?: boolean;
  membership: string;
  deleted_at?: string | null;
};
export type DriverDriverTag = {
  tag_name: string;
  color_hex: string;
};
export type DriverDriverTagRead = {
  id: string;
  tag: string;
  tag_name: string;
  color_hex: string;
  created_at: string;
  updated_at: string;
};
export type DriverRead = {
  id: string;
  first_name: string;
  last_name: string;
  app_version: string;
  can_be_scheduled?: boolean;
  license_number: string;
  license_expiration_date: string;
  license_dob?: string;
  license_state: LicensePlateStateEnum;
  can_do_wheelchair_service?: boolean;
  can_do_wheelchair_xl_service?: boolean;
  can_do_broda_chair_service?: boolean;
  can_do_geri_chair_service?: boolean;
  can_do_stretcher_service?: boolean;
  can_do_stretcher_xl_service?: boolean;
  can_do_delivery_service?: boolean;
  can_do_ambulatory_service?: boolean;
  can_do_curb_to_curb?: boolean;
  can_do_door_to_door?: boolean;
  can_do_door_through_door?: boolean;
  can_do_person_to_person?: boolean;
  can_do_bariatric?: boolean;
  can_do_stairs?: boolean;
  can_do_student_transport?: boolean;
  membership: string;
  organization_id: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
  tags: DriverDriverTagRead[] | null;
  allowed_payers: string[];
};
export type DriverWrite = {
  can_be_scheduled?: boolean;
  license_number: string;
  license_expiration_date: string;
  license_dob?: string;
  license_state: LicensePlateStateEnum;
  can_do_wheelchair_service?: boolean;
  can_do_wheelchair_xl_service?: boolean;
  can_do_broda_chair_service?: boolean;
  can_do_geri_chair_service?: boolean;
  can_do_stretcher_service?: boolean;
  can_do_stretcher_xl_service?: boolean;
  can_do_delivery_service?: boolean;
  can_do_ambulatory_service?: boolean;
  can_do_curb_to_curb?: boolean;
  can_do_door_to_door?: boolean;
  can_do_door_through_door?: boolean;
  can_do_person_to_person?: boolean;
  can_do_bariatric?: boolean;
  can_do_stairs?: boolean;
  can_do_student_transport?: boolean;
  membership: string;
  deleted_at?: string | null;
  tag_ids?: string[] | null;
  allowed_payer_ids?: string[] | null;
};
export type PaginatedDriverList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Driver[];
};
export type PaginatedDriverListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: DriverRead[];
};
export type PaginatedDriverListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: DriverWrite[];
};
export type DriversListIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null_characters_not_allowed';
  detail: string;
};
export type DriversListMembershipIdInErrorComponent = {
  attr: 'membership_id__in';
  code: 'invalid_choice';
  detail: string;
};
export type DriversListError =
  | ({
      attr: 'id';
    } & DriversListIdErrorComponent)
  | ({
      attr: 'membership_id__in';
    } & DriversListMembershipIdInErrorComponent);
export type DriversListValidationError = {
  type: ValidationErrorEnum;
  errors: DriversListError[];
};
export type DriversListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & DriversListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type DriversCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type DriversCreateCanBeScheduledErrorComponent = {
  attr: 'can_be_scheduled';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateLicenseNumberErrorComponent = {
  attr: 'license_number';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type DriversCreateLicenseExpirationDateErrorComponent = {
  attr: 'license_expiration_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversCreateLicenseDobErrorComponent = {
  attr: 'license_dob';
  code: 'datetime' | 'invalid' | 'null';
  detail: string;
};
export type DriversCreateLicenseStateErrorComponent = {
  attr: 'license_state';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type DriversCreateCanDoWheelchairServiceErrorComponent = {
  attr: 'can_do_wheelchair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoWheelchairXlServiceErrorComponent = {
  attr: 'can_do_wheelchair_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoBrodaChairServiceErrorComponent = {
  attr: 'can_do_broda_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoGeriChairServiceErrorComponent = {
  attr: 'can_do_geri_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoStretcherServiceErrorComponent = {
  attr: 'can_do_stretcher_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoStretcherXlServiceErrorComponent = {
  attr: 'can_do_stretcher_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoDeliveryServiceErrorComponent = {
  attr: 'can_do_delivery_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoAmbulatoryServiceErrorComponent = {
  attr: 'can_do_ambulatory_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoCurbToCurbErrorComponent = {
  attr: 'can_do_curb_to_curb';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoDoorToDoorErrorComponent = {
  attr: 'can_do_door_to_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoDoorThroughDoorErrorComponent = {
  attr: 'can_do_door_through_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoPersonToPersonErrorComponent = {
  attr: 'can_do_person_to_person';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoBariatricErrorComponent = {
  attr: 'can_do_bariatric';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoStairsErrorComponent = {
  attr: 'can_do_stairs';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateCanDoStudentTransportErrorComponent = {
  attr: 'can_do_student_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversCreateMembershipErrorComponent = {
  attr: 'membership';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required' | 'unique';
  detail: string;
};
export type DriversCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type DriversCreateTagIdsErrorComponent = {
  attr: 'tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type DriversCreateTagIdsIndexErrorComponent = {
  attr: 'tag_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversCreateTagsIndexTagNameErrorComponent = {
  attr: 'tags.INDEX.tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type DriversCreateTagsIndexColorHexErrorComponent = {
  attr: 'tags.INDEX.color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type DriversCreateAllowedPayerIdsErrorComponent = {
  attr: 'allowed_payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type DriversCreateAllowedPayerIdsIndexErrorComponent = {
  attr: 'allowed_payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversCreateError =
  | ({
      attr: 'non_field_errors';
    } & DriversCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'can_be_scheduled';
    } & DriversCreateCanBeScheduledErrorComponent)
  | ({
      attr: 'license_number';
    } & DriversCreateLicenseNumberErrorComponent)
  | ({
      attr: 'license_expiration_date';
    } & DriversCreateLicenseExpirationDateErrorComponent)
  | ({
      attr: 'license_dob';
    } & DriversCreateLicenseDobErrorComponent)
  | ({
      attr: 'license_state';
    } & DriversCreateLicenseStateErrorComponent)
  | ({
      attr: 'can_do_wheelchair_service';
    } & DriversCreateCanDoWheelchairServiceErrorComponent)
  | ({
      attr: 'can_do_wheelchair_xl_service';
    } & DriversCreateCanDoWheelchairXlServiceErrorComponent)
  | ({
      attr: 'can_do_broda_chair_service';
    } & DriversCreateCanDoBrodaChairServiceErrorComponent)
  | ({
      attr: 'can_do_geri_chair_service';
    } & DriversCreateCanDoGeriChairServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_service';
    } & DriversCreateCanDoStretcherServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_xl_service';
    } & DriversCreateCanDoStretcherXlServiceErrorComponent)
  | ({
      attr: 'can_do_delivery_service';
    } & DriversCreateCanDoDeliveryServiceErrorComponent)
  | ({
      attr: 'can_do_ambulatory_service';
    } & DriversCreateCanDoAmbulatoryServiceErrorComponent)
  | ({
      attr: 'can_do_curb_to_curb';
    } & DriversCreateCanDoCurbToCurbErrorComponent)
  | ({
      attr: 'can_do_door_to_door';
    } & DriversCreateCanDoDoorToDoorErrorComponent)
  | ({
      attr: 'can_do_door_through_door';
    } & DriversCreateCanDoDoorThroughDoorErrorComponent)
  | ({
      attr: 'can_do_person_to_person';
    } & DriversCreateCanDoPersonToPersonErrorComponent)
  | ({
      attr: 'can_do_bariatric';
    } & DriversCreateCanDoBariatricErrorComponent)
  | ({
      attr: 'can_do_stairs';
    } & DriversCreateCanDoStairsErrorComponent)
  | ({
      attr: 'can_do_student_transport';
    } & DriversCreateCanDoStudentTransportErrorComponent)
  | ({
      attr: 'membership';
    } & DriversCreateMembershipErrorComponent)
  | ({
      attr: 'deleted_at';
    } & DriversCreateDeletedAtErrorComponent)
  | ({
      attr: 'tag_ids';
    } & DriversCreateTagIdsErrorComponent)
  | ({
      attr: 'tag_ids.INDEX';
    } & DriversCreateTagIdsIndexErrorComponent)
  | ({
      attr: 'tags.INDEX.tag_name';
    } & DriversCreateTagsIndexTagNameErrorComponent)
  | ({
      attr: 'tags.INDEX.color_hex';
    } & DriversCreateTagsIndexColorHexErrorComponent)
  | ({
      attr: 'allowed_payer_ids';
    } & DriversCreateAllowedPayerIdsErrorComponent)
  | ({
      attr: 'allowed_payer_ids.INDEX';
    } & DriversCreateAllowedPayerIdsIndexErrorComponent);
export type DriversCreateValidationError = {
  type: ValidationErrorEnum;
  errors: DriversCreateError[];
};
export type DriversCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & DriversCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type DriverPayerOrganization = {};
export type DriverPayerOrganizationRead = {
  id: string;
  organization_id: string;
  driver_id: string;
  payer_organization_id: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
};
export type DriverPayerOrganizationWrite = {
  payer_organization_ids: string[];
};
export type PaginatedDriverPayerOrganizationList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: DriverPayerOrganization[];
};
export type PaginatedDriverPayerOrganizationListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: DriverPayerOrganizationRead[];
};
export type PaginatedDriverPayerOrganizationListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: DriverPayerOrganizationWrite[];
};
export type DriversPayersListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type DriversPayersCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type DriversPayersCreatePayerOrganizationIdsErrorComponent = {
  attr: 'payer_organization_ids';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type DriversPayersCreatePayerOrganizationIdsIndexErrorComponent = {
  attr: 'payer_organization_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversPayersCreateError =
  | ({
      attr: 'non_field_errors';
    } & DriversPayersCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization_ids';
    } & DriversPayersCreatePayerOrganizationIdsErrorComponent)
  | ({
      attr: 'payer_organization_ids.INDEX';
    } & DriversPayersCreatePayerOrganizationIdsIndexErrorComponent);
export type DriversPayersCreateValidationError = {
  type: ValidationErrorEnum;
  errors: DriversPayersCreateError[];
};
export type DriversPayersCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & DriversPayersCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type DriversRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type DriversPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type DriversPartialUpdateCanBeScheduledErrorComponent = {
  attr: 'can_be_scheduled';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateLicenseNumberErrorComponent = {
  attr: 'license_number';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type DriversPartialUpdateLicenseExpirationDateErrorComponent = {
  attr: 'license_expiration_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversPartialUpdateLicenseDobErrorComponent = {
  attr: 'license_dob';
  code: 'datetime' | 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateLicenseStateErrorComponent = {
  attr: 'license_state';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type DriversPartialUpdateCanDoWheelchairServiceErrorComponent = {
  attr: 'can_do_wheelchair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoWheelchairXlServiceErrorComponent = {
  attr: 'can_do_wheelchair_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoBrodaChairServiceErrorComponent = {
  attr: 'can_do_broda_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoGeriChairServiceErrorComponent = {
  attr: 'can_do_geri_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoStretcherServiceErrorComponent = {
  attr: 'can_do_stretcher_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoStretcherXlServiceErrorComponent = {
  attr: 'can_do_stretcher_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoDeliveryServiceErrorComponent = {
  attr: 'can_do_delivery_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoAmbulatoryServiceErrorComponent = {
  attr: 'can_do_ambulatory_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoCurbToCurbErrorComponent = {
  attr: 'can_do_curb_to_curb';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoDoorToDoorErrorComponent = {
  attr: 'can_do_door_to_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoDoorThroughDoorErrorComponent = {
  attr: 'can_do_door_through_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoPersonToPersonErrorComponent = {
  attr: 'can_do_person_to_person';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoBariatricErrorComponent = {
  attr: 'can_do_bariatric';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoStairsErrorComponent = {
  attr: 'can_do_stairs';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateCanDoStudentTransportErrorComponent = {
  attr: 'can_do_student_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversPartialUpdateMembershipErrorComponent = {
  attr: 'membership';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required' | 'unique';
  detail: string;
};
export type DriversPartialUpdateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type DriversPartialUpdateTagIdsErrorComponent = {
  attr: 'tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type DriversPartialUpdateTagIdsIndexErrorComponent = {
  attr: 'tag_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversPartialUpdateTagsIndexTagNameErrorComponent = {
  attr: 'tags.INDEX.tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type DriversPartialUpdateTagsIndexColorHexErrorComponent = {
  attr: 'tags.INDEX.color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type DriversPartialUpdateAllowedPayerIdsErrorComponent = {
  attr: 'allowed_payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type DriversPartialUpdateAllowedPayerIdsIndexErrorComponent = {
  attr: 'allowed_payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & DriversPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'can_be_scheduled';
    } & DriversPartialUpdateCanBeScheduledErrorComponent)
  | ({
      attr: 'license_number';
    } & DriversPartialUpdateLicenseNumberErrorComponent)
  | ({
      attr: 'license_expiration_date';
    } & DriversPartialUpdateLicenseExpirationDateErrorComponent)
  | ({
      attr: 'license_dob';
    } & DriversPartialUpdateLicenseDobErrorComponent)
  | ({
      attr: 'license_state';
    } & DriversPartialUpdateLicenseStateErrorComponent)
  | ({
      attr: 'can_do_wheelchair_service';
    } & DriversPartialUpdateCanDoWheelchairServiceErrorComponent)
  | ({
      attr: 'can_do_wheelchair_xl_service';
    } & DriversPartialUpdateCanDoWheelchairXlServiceErrorComponent)
  | ({
      attr: 'can_do_broda_chair_service';
    } & DriversPartialUpdateCanDoBrodaChairServiceErrorComponent)
  | ({
      attr: 'can_do_geri_chair_service';
    } & DriversPartialUpdateCanDoGeriChairServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_service';
    } & DriversPartialUpdateCanDoStretcherServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_xl_service';
    } & DriversPartialUpdateCanDoStretcherXlServiceErrorComponent)
  | ({
      attr: 'can_do_delivery_service';
    } & DriversPartialUpdateCanDoDeliveryServiceErrorComponent)
  | ({
      attr: 'can_do_ambulatory_service';
    } & DriversPartialUpdateCanDoAmbulatoryServiceErrorComponent)
  | ({
      attr: 'can_do_curb_to_curb';
    } & DriversPartialUpdateCanDoCurbToCurbErrorComponent)
  | ({
      attr: 'can_do_door_to_door';
    } & DriversPartialUpdateCanDoDoorToDoorErrorComponent)
  | ({
      attr: 'can_do_door_through_door';
    } & DriversPartialUpdateCanDoDoorThroughDoorErrorComponent)
  | ({
      attr: 'can_do_person_to_person';
    } & DriversPartialUpdateCanDoPersonToPersonErrorComponent)
  | ({
      attr: 'can_do_bariatric';
    } & DriversPartialUpdateCanDoBariatricErrorComponent)
  | ({
      attr: 'can_do_stairs';
    } & DriversPartialUpdateCanDoStairsErrorComponent)
  | ({
      attr: 'can_do_student_transport';
    } & DriversPartialUpdateCanDoStudentTransportErrorComponent)
  | ({
      attr: 'membership';
    } & DriversPartialUpdateMembershipErrorComponent)
  | ({
      attr: 'deleted_at';
    } & DriversPartialUpdateDeletedAtErrorComponent)
  | ({
      attr: 'tag_ids';
    } & DriversPartialUpdateTagIdsErrorComponent)
  | ({
      attr: 'tag_ids.INDEX';
    } & DriversPartialUpdateTagIdsIndexErrorComponent)
  | ({
      attr: 'tags.INDEX.tag_name';
    } & DriversPartialUpdateTagsIndexTagNameErrorComponent)
  | ({
      attr: 'tags.INDEX.color_hex';
    } & DriversPartialUpdateTagsIndexColorHexErrorComponent)
  | ({
      attr: 'allowed_payer_ids';
    } & DriversPartialUpdateAllowedPayerIdsErrorComponent)
  | ({
      attr: 'allowed_payer_ids.INDEX';
    } & DriversPartialUpdateAllowedPayerIdsIndexErrorComponent);
export type DriversPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: DriversPartialUpdateError[];
};
export type DriversPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & DriversPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedDriver = {
  can_be_scheduled?: boolean;
  license_number?: string;
  license_expiration_date?: string;
  license_dob?: string;
  license_state?: LicensePlateStateEnum;
  can_do_wheelchair_service?: boolean;
  can_do_wheelchair_xl_service?: boolean;
  can_do_broda_chair_service?: boolean;
  can_do_geri_chair_service?: boolean;
  can_do_stretcher_service?: boolean;
  can_do_stretcher_xl_service?: boolean;
  can_do_delivery_service?: boolean;
  can_do_ambulatory_service?: boolean;
  can_do_curb_to_curb?: boolean;
  can_do_door_to_door?: boolean;
  can_do_door_through_door?: boolean;
  can_do_person_to_person?: boolean;
  can_do_bariatric?: boolean;
  can_do_stairs?: boolean;
  can_do_student_transport?: boolean;
  membership?: string;
  deleted_at?: string | null;
};
export type PatchedDriverRead = {
  id?: string;
  first_name?: string;
  last_name?: string;
  app_version?: string;
  can_be_scheduled?: boolean;
  license_number?: string;
  license_expiration_date?: string;
  license_dob?: string;
  license_state?: LicensePlateStateEnum;
  can_do_wheelchair_service?: boolean;
  can_do_wheelchair_xl_service?: boolean;
  can_do_broda_chair_service?: boolean;
  can_do_geri_chair_service?: boolean;
  can_do_stretcher_service?: boolean;
  can_do_stretcher_xl_service?: boolean;
  can_do_delivery_service?: boolean;
  can_do_ambulatory_service?: boolean;
  can_do_curb_to_curb?: boolean;
  can_do_door_to_door?: boolean;
  can_do_door_through_door?: boolean;
  can_do_person_to_person?: boolean;
  can_do_bariatric?: boolean;
  can_do_stairs?: boolean;
  can_do_student_transport?: boolean;
  membership?: string;
  organization_id?: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  tags?: DriverDriverTagRead[] | null;
  allowed_payers?: string[];
};
export type PatchedDriverWrite = {
  can_be_scheduled?: boolean;
  license_number?: string;
  license_expiration_date?: string;
  license_dob?: string;
  license_state?: LicensePlateStateEnum;
  can_do_wheelchair_service?: boolean;
  can_do_wheelchair_xl_service?: boolean;
  can_do_broda_chair_service?: boolean;
  can_do_geri_chair_service?: boolean;
  can_do_stretcher_service?: boolean;
  can_do_stretcher_xl_service?: boolean;
  can_do_delivery_service?: boolean;
  can_do_ambulatory_service?: boolean;
  can_do_curb_to_curb?: boolean;
  can_do_door_to_door?: boolean;
  can_do_door_through_door?: boolean;
  can_do_person_to_person?: boolean;
  can_do_bariatric?: boolean;
  can_do_stairs?: boolean;
  can_do_student_transport?: boolean;
  membership?: string;
  deleted_at?: string | null;
  tag_ids?: string[] | null;
  allowed_payer_ids?: string[] | null;
};
export type DriversDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type DriversUndeleteCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type DriversUndeleteCreateCanBeScheduledErrorComponent = {
  attr: 'can_be_scheduled';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateLicenseNumberErrorComponent = {
  attr: 'license_number';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type DriversUndeleteCreateLicenseExpirationDateErrorComponent = {
  attr: 'license_expiration_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversUndeleteCreateLicenseDobErrorComponent = {
  attr: 'license_dob';
  code: 'datetime' | 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateLicenseStateErrorComponent = {
  attr: 'license_state';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type DriversUndeleteCreateCanDoWheelchairServiceErrorComponent = {
  attr: 'can_do_wheelchair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoWheelchairXlServiceErrorComponent = {
  attr: 'can_do_wheelchair_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoBrodaChairServiceErrorComponent = {
  attr: 'can_do_broda_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoGeriChairServiceErrorComponent = {
  attr: 'can_do_geri_chair_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoStretcherServiceErrorComponent = {
  attr: 'can_do_stretcher_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoStretcherXlServiceErrorComponent = {
  attr: 'can_do_stretcher_xl_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoDeliveryServiceErrorComponent = {
  attr: 'can_do_delivery_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoAmbulatoryServiceErrorComponent = {
  attr: 'can_do_ambulatory_service';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoCurbToCurbErrorComponent = {
  attr: 'can_do_curb_to_curb';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoDoorToDoorErrorComponent = {
  attr: 'can_do_door_to_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoDoorThroughDoorErrorComponent = {
  attr: 'can_do_door_through_door';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoPersonToPersonErrorComponent = {
  attr: 'can_do_person_to_person';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoBariatricErrorComponent = {
  attr: 'can_do_bariatric';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoStairsErrorComponent = {
  attr: 'can_do_stairs';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateCanDoStudentTransportErrorComponent = {
  attr: 'can_do_student_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type DriversUndeleteCreateMembershipErrorComponent = {
  attr: 'membership';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required' | 'unique';
  detail: string;
};
export type DriversUndeleteCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type DriversUndeleteCreateTagIdsErrorComponent = {
  attr: 'tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type DriversUndeleteCreateTagIdsIndexErrorComponent = {
  attr: 'tag_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversUndeleteCreateTagsIndexTagNameErrorComponent = {
  attr: 'tags.INDEX.tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type DriversUndeleteCreateTagsIndexColorHexErrorComponent = {
  attr: 'tags.INDEX.color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type DriversUndeleteCreateAllowedPayerIdsErrorComponent = {
  attr: 'allowed_payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type DriversUndeleteCreateAllowedPayerIdsIndexErrorComponent = {
  attr: 'allowed_payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversUndeleteCreateError =
  | ({
      attr: 'non_field_errors';
    } & DriversUndeleteCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'can_be_scheduled';
    } & DriversUndeleteCreateCanBeScheduledErrorComponent)
  | ({
      attr: 'license_number';
    } & DriversUndeleteCreateLicenseNumberErrorComponent)
  | ({
      attr: 'license_expiration_date';
    } & DriversUndeleteCreateLicenseExpirationDateErrorComponent)
  | ({
      attr: 'license_dob';
    } & DriversUndeleteCreateLicenseDobErrorComponent)
  | ({
      attr: 'license_state';
    } & DriversUndeleteCreateLicenseStateErrorComponent)
  | ({
      attr: 'can_do_wheelchair_service';
    } & DriversUndeleteCreateCanDoWheelchairServiceErrorComponent)
  | ({
      attr: 'can_do_wheelchair_xl_service';
    } & DriversUndeleteCreateCanDoWheelchairXlServiceErrorComponent)
  | ({
      attr: 'can_do_broda_chair_service';
    } & DriversUndeleteCreateCanDoBrodaChairServiceErrorComponent)
  | ({
      attr: 'can_do_geri_chair_service';
    } & DriversUndeleteCreateCanDoGeriChairServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_service';
    } & DriversUndeleteCreateCanDoStretcherServiceErrorComponent)
  | ({
      attr: 'can_do_stretcher_xl_service';
    } & DriversUndeleteCreateCanDoStretcherXlServiceErrorComponent)
  | ({
      attr: 'can_do_delivery_service';
    } & DriversUndeleteCreateCanDoDeliveryServiceErrorComponent)
  | ({
      attr: 'can_do_ambulatory_service';
    } & DriversUndeleteCreateCanDoAmbulatoryServiceErrorComponent)
  | ({
      attr: 'can_do_curb_to_curb';
    } & DriversUndeleteCreateCanDoCurbToCurbErrorComponent)
  | ({
      attr: 'can_do_door_to_door';
    } & DriversUndeleteCreateCanDoDoorToDoorErrorComponent)
  | ({
      attr: 'can_do_door_through_door';
    } & DriversUndeleteCreateCanDoDoorThroughDoorErrorComponent)
  | ({
      attr: 'can_do_person_to_person';
    } & DriversUndeleteCreateCanDoPersonToPersonErrorComponent)
  | ({
      attr: 'can_do_bariatric';
    } & DriversUndeleteCreateCanDoBariatricErrorComponent)
  | ({
      attr: 'can_do_stairs';
    } & DriversUndeleteCreateCanDoStairsErrorComponent)
  | ({
      attr: 'can_do_student_transport';
    } & DriversUndeleteCreateCanDoStudentTransportErrorComponent)
  | ({
      attr: 'membership';
    } & DriversUndeleteCreateMembershipErrorComponent)
  | ({
      attr: 'deleted_at';
    } & DriversUndeleteCreateDeletedAtErrorComponent)
  | ({
      attr: 'tag_ids';
    } & DriversUndeleteCreateTagIdsErrorComponent)
  | ({
      attr: 'tag_ids.INDEX';
    } & DriversUndeleteCreateTagIdsIndexErrorComponent)
  | ({
      attr: 'tags.INDEX.tag_name';
    } & DriversUndeleteCreateTagsIndexTagNameErrorComponent)
  | ({
      attr: 'tags.INDEX.color_hex';
    } & DriversUndeleteCreateTagsIndexColorHexErrorComponent)
  | ({
      attr: 'allowed_payer_ids';
    } & DriversUndeleteCreateAllowedPayerIdsErrorComponent)
  | ({
      attr: 'allowed_payer_ids.INDEX';
    } & DriversUndeleteCreateAllowedPayerIdsIndexErrorComponent);
export type DriversUndeleteCreateValidationError = {
  type: ValidationErrorEnum;
  errors: DriversUndeleteCreateError[];
};
export type DriversUndeleteCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & DriversUndeleteCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type DriversListSelectedNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type DriversListSelectedSelectedDriversErrorComponent = {
  attr: 'selected_drivers';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type DriversListSelectedSelectedDriversIndexErrorComponent = {
  attr: 'selected_drivers.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type DriversListSelectedError =
  | ({
      attr: 'non_field_errors';
    } & DriversListSelectedNonFieldErrorsErrorComponent)
  | ({
      attr: 'selected_drivers';
    } & DriversListSelectedSelectedDriversErrorComponent)
  | ({
      attr: 'selected_drivers.INDEX';
    } & DriversListSelectedSelectedDriversIndexErrorComponent);
export type DriversListSelectedValidationError = {
  type: ValidationErrorEnum;
  errors: DriversListSelectedError[];
};
export type DriversListSelectedErrorResponse400 =
  | ({
      type: 'validation_error';
    } & DriversListSelectedValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type DriverFilters = {
  /** List of IDs of the drivers to include in response. */
  selected_drivers?: string[];
};
export type FiltersetEnum = 'InvoiceFilter' | 'TripFilter';
export type FilterGroup = {
  /** The human/computer readable name. */
  group_name: string;
  /** The URL-friendly name. */
  slug: string;
  /** Additional information for ops or admin. */
  description?: string;
  /** The associated django filterset class. */
  filterset: FiltersetEnum;
  /** Filters and their values. For example, {"overall_payment_status__in":"unpaid","payer__in":"018e7719-d16a-96b0-dac7-6d1ff142f8ef"}. */
  filters: {
    [key: string]: any;
  };
};
export type FilterGroupRead = {
  id: string;
  /** The human/computer readable name. */
  group_name: string;
  /** The URL-friendly name. */
  slug: string;
  /** Additional information for ops or admin. */
  description?: string;
  /** The associated django filterset class. */
  filterset: FiltersetEnum;
  /** Filters and their values. For example, {"overall_payment_status__in":"unpaid","payer__in":"018e7719-d16a-96b0-dac7-6d1ff142f8ef"}. */
  filters: {
    [key: string]: any;
  };
  created_at: string;
  updated_at: string;
};
export type PaginatedFilterGroupList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: FilterGroup[];
};
export type PaginatedFilterGroupListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: FilterGroupRead[];
};
export type FilterGroupsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type FilterGroupsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type FilterGroupsCreateGroupNameErrorComponent = {
  attr: 'group_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type FilterGroupsCreateSlugErrorComponent = {
  attr: 'slug';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type FilterGroupsCreateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type FilterGroupsCreateFiltersetErrorComponent = {
  attr: 'filterset';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type FilterGroupsCreateFiltersErrorComponent = {
  attr: 'filters';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type FilterGroupsCreateError =
  | ({
      attr: 'non_field_errors';
    } & FilterGroupsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'group_name';
    } & FilterGroupsCreateGroupNameErrorComponent)
  | ({
      attr: 'slug';
    } & FilterGroupsCreateSlugErrorComponent)
  | ({
      attr: 'description';
    } & FilterGroupsCreateDescriptionErrorComponent)
  | ({
      attr: 'filterset';
    } & FilterGroupsCreateFiltersetErrorComponent)
  | ({
      attr: 'filters';
    } & FilterGroupsCreateFiltersErrorComponent);
export type FilterGroupsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: FilterGroupsCreateError[];
};
export type FilterGroupsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & FilterGroupsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type FilterGroupsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type FilterGroupsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type FilterGroupsPartialUpdateGroupNameErrorComponent = {
  attr: 'group_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type FilterGroupsPartialUpdateSlugErrorComponent = {
  attr: 'slug';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type FilterGroupsPartialUpdateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type FilterGroupsPartialUpdateFiltersetErrorComponent = {
  attr: 'filterset';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type FilterGroupsPartialUpdateFiltersErrorComponent = {
  attr: 'filters';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type FilterGroupsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & FilterGroupsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'group_name';
    } & FilterGroupsPartialUpdateGroupNameErrorComponent)
  | ({
      attr: 'slug';
    } & FilterGroupsPartialUpdateSlugErrorComponent)
  | ({
      attr: 'description';
    } & FilterGroupsPartialUpdateDescriptionErrorComponent)
  | ({
      attr: 'filterset';
    } & FilterGroupsPartialUpdateFiltersetErrorComponent)
  | ({
      attr: 'filters';
    } & FilterGroupsPartialUpdateFiltersErrorComponent);
export type FilterGroupsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: FilterGroupsPartialUpdateError[];
};
export type FilterGroupsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & FilterGroupsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedFilterGroup = {
  /** The human/computer readable name. */
  group_name?: string;
  /** The URL-friendly name. */
  slug?: string;
  /** Additional information for ops or admin. */
  description?: string;
  /** The associated django filterset class. */
  filterset?: FiltersetEnum;
  /** Filters and their values. For example, {"overall_payment_status__in":"unpaid","payer__in":"018e7719-d16a-96b0-dac7-6d1ff142f8ef"}. */
  filters?: {
    [key: string]: any;
  };
};
export type PatchedFilterGroupRead = {
  id?: string;
  /** The human/computer readable name. */
  group_name?: string;
  /** The URL-friendly name. */
  slug?: string;
  /** Additional information for ops or admin. */
  description?: string;
  /** The associated django filterset class. */
  filterset?: FiltersetEnum;
  /** Filters and their values. For example, {"overall_payment_status__in":"unpaid","payer__in":"018e7719-d16a-96b0-dac7-6d1ff142f8ef"}. */
  filters?: {
    [key: string]: any;
  };
  created_at?: string;
  updated_at?: string;
};
export type FilterGroupsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type FilterGroupsCreateExamplesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type FilterGroupsCreateExamplesCreateGroupNameErrorComponent = {
  attr: 'group_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type FilterGroupsCreateExamplesCreateSlugErrorComponent = {
  attr: 'slug';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type FilterGroupsCreateExamplesCreateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type FilterGroupsCreateExamplesCreateFiltersetErrorComponent = {
  attr: 'filterset';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type FilterGroupsCreateExamplesCreateFiltersErrorComponent = {
  attr: 'filters';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type FilterGroupsCreateExamplesCreateError =
  | ({
      attr: 'non_field_errors';
    } & FilterGroupsCreateExamplesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'group_name';
    } & FilterGroupsCreateExamplesCreateGroupNameErrorComponent)
  | ({
      attr: 'slug';
    } & FilterGroupsCreateExamplesCreateSlugErrorComponent)
  | ({
      attr: 'description';
    } & FilterGroupsCreateExamplesCreateDescriptionErrorComponent)
  | ({
      attr: 'filterset';
    } & FilterGroupsCreateExamplesCreateFiltersetErrorComponent)
  | ({
      attr: 'filters';
    } & FilterGroupsCreateExamplesCreateFiltersErrorComponent);
export type FilterGroupsCreateExamplesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: FilterGroupsCreateExamplesCreateError[];
};
export type FilterGroupsCreateExamplesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & FilterGroupsCreateExamplesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type FeatureNameEnum =
  | 'daily digest email'
  | 'demo'
  | 'driver call requests'
  | 'facility request cancel'
  | 'facility trip cancel'
  | 'geolocations'
  | 'inactive organization'
  | 'itinerary'
  | 'itinerary return to storage'
  | 'member credentials'
  | 'multi-loading'
  | 'multiload closest fit'
  | 'offline mobile'
  | 'onboarding via password reset'
  | 'passenger merge'
  | 'passenger messaging'
  | 'payer allowed vehicles and drivers'
  | 'payment link'
  | 'precise location check'
  | 'pricing version 1'
  | 'reporting'
  | 'ride ordering marketplace'
  | 'ride ordering portal'
  | 'route templates'
  | 'run bambi run multiloading'
  | 'tilled card verification'
  | 'tilled payment capture'
  | 'transfer assignment'
  | 'trip event history'
  | 'trip event updates'
  | 'trip request form'
  | 'trip required fields'
  | 'trip subscription update'
  | 'vehicle credentials';
export type FeatureFlag = {
  feature_name: FeatureNameEnum;
};
export type FeatureFlagRead = {
  feature_name: FeatureNameEnum;
  feature_is_on: boolean;
};
export type PaginatedFeatureFlagList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: FeatureFlag[];
};
export type PaginatedFeatureFlagListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: FeatureFlagRead[];
};
export type FlagsFeatureValuesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type FlagsFeatureValuesMobileListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type FlagsFeatureValuesWebListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type Feature = {
  feature_name: FeatureNameEnum;
};
export type FlagTypeEnum = 'feature flag' | 'rollout toggle';
export type FeatureRead = {
  id: string;
  feature_name: FeatureNameEnum;
  /** The default state of this feature. If the flag is not set on an org, this is the state it will be in. */
  default_value: boolean;
  /** If True, this feature will always be in the default state, regardless of the flag. */
  force_default: boolean;
  /** If True, this feature is relevant to the mobile app. */
  is_mobile: boolean;
  /** If True, this feature is relevant to the web app. */
  is_web: boolean;
  /** The type of flag this feature is expected to be controlled by. Used for reporting and cleanup. Used for ops, and code warnings. */
  flag_type: FlagTypeEnum;
  created_at: string;
  updated_at: string;
};
export type PaginatedFeatureList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Feature[];
};
export type PaginatedFeatureListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: FeatureRead[];
};
export type FlagsFeaturesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoicePayer = {};
export type InvoicePayerRead = {
  id: string;
  payer_display_name: string | null;
};
export type InvoicesPayersListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PatchedTripPassenger = {
  id?: string;
  first_name?: string;
  last_name?: string;
  preferred_name?: string;
  pronoun?: string;
  gender?: string;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
  dispatcher_notes?: string;
  allow_sms_message?: boolean;
};
export type PatchedTripPassengerRead = {
  id?: string;
  organization_id?: string;
  first_name?: string;
  last_name?: string;
  full_name?: string;
  preferred_name?: string;
  pronoun?: string;
  gender?: string;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
  dispatcher_notes?: string;
  allow_sms_message?: boolean;
  deleted_at?: string;
};
export type StairEquipmentEnum = 'ramp' | 'stair-chair';
export type TripLocationDetail = {
  address_details?: string;
  /** The number of stairs at this location */
  num_stairs?: number;
  /** Stair equipment required for this location */
  stair_equipment?: StairEquipmentEnum | BlankEnum;
  /** Name of contact for this location, if not passenger */
  contact_name?: string;
  /** Phone number of contact for this location, if not passenger */
  contact_phone_number?: string | null;
  /** Notes visible to the driver for this location */
  driver_notes?: string;
  place_id: string;
};
export type PurposeEnum = 'pickup' | 'dropoff';
export type TripLocationDetailRead = {
  id: string;
  /** Purpose of this location, pickup, dropoff, etc. */
  purpose: PurposeEnum;
  address: string;
  address_details?: string;
  latitude: number;
  longitude: number;
  /** The number of stairs at this location */
  num_stairs?: number;
  /** Stair equipment required for this location */
  stair_equipment?: StairEquipmentEnum | BlankEnum;
  /** Name of contact for this location, if not passenger */
  contact_name?: string;
  /** Phone number of contact for this location, if not passenger */
  contact_phone_number?: string | null;
  /** Notes visible to the driver for this location */
  driver_notes?: string;
  place_id: string;
};
export type InvoiceTrips = {
  id: string;
  /** The assignment that this trip belongs to (optional) */
  assignment?: string | null;
  /** Current status of this trip */
  status?: OverrideStatusEnum;
  passenger: PatchedTripPassenger;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  pickup: TripLocationDetail;
  dropoff: TripLocationDetail;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** Whether the passenger has called in that they are ready to be picked up */
  is_will_call_activated?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  is_oxygen_required?: boolean;
  estimated_distance_miles?: number | null;
  /** The time the trip was canceled */
  canceled_at?: string | null;
  /** The main reason a trip was canceled */
  canceled_reason?: CanceledReasonEnum | BlankEnum;
  /** An ID that relates all trips created in the same API request */
  correlation_id?: string | null;
  /** The expected load time for this specific trip, provided by the customer */
  load_time_seconds?: number | null;
  /** The expected unload time for this specific trip, provided by the customer */
  unload_time_seconds?: number | null;
  /** Optional extra time spent waiting for the pickup, provided by dispatcher */
  pickup_wait_time_seconds?: number | null;
  /** Searchable, sharable short code for this trip and/or subscription */
  confirmation_code?: string;
  /** The trip ID used by an intermediary/broker, may or may not be the originator */
  intermediary_id?: string;
  /** The intermediary/broker source of this trip */
  intermediary?: IntermediaryEnum | BlankEnum;
};
export type InvoiceTripPayerOrganization = {
  id?: string;
  /** Name the organization uses to refer to this payer across the app */
  display_name: string;
};
export type TripPayerPassenger = {};
export type TripPayerPassengerRead = {
  id: string;
  external_id: string;
  /** Authorization ID associated with the passenger for insurance payers */
  authorization_id: string | null;
};
export type TripTripTag = {
  tag_name: string;
  color_hex: string;
};
export type TripTripTagRead = {
  id: string;
  tag: string;
  tag_name: string;
  color_hex: string;
  created_at: string;
  updated_at: string;
};
export type InvoiceTripsRead = {
  id: string;
  /** The assignment that this trip belongs to (optional) */
  assignment?: string | null;
  /** Current status of this trip */
  status?: OverrideStatusEnum;
  passenger: PatchedTripPassengerRead;
  payer: InvoiceTripPayerOrganization;
  /** Who is paying for this trip */
  payer_id: string;
  payer_passenger: TripPayerPassengerRead | null;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  scheduled_pickup_at: string;
  pickup: TripLocationDetailRead;
  dropoff: TripLocationDetailRead;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** Whether the passenger has called in that they are ready to be picked up */
  is_will_call_activated?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min: number | null;
  estimated_distance_miles?: number | null;
  /** The time the trip was canceled */
  canceled_at?: string | null;
  /** The main reason a trip was canceled */
  canceled_reason?: CanceledReasonEnum | BlankEnum;
  /** An ID that relates all trips created in the same API request */
  correlation_id?: string | null;
  /** The expected load time for this specific trip, provided by the customer */
  load_time_seconds?: number | null;
  /** The expected unload time for this specific trip, provided by the customer */
  unload_time_seconds?: number | null;
  /** Optional extra time spent waiting for the pickup, provided by dispatcher */
  pickup_wait_time_seconds?: number | null;
  tags: TripTripTagRead[] | null;
  /** Searchable, sharable short code for this trip and/or subscription */
  confirmation_code?: string;
  /** The trip ID used by an intermediary/broker, may or may not be the originator */
  intermediary_id?: string;
  /** The intermediary/broker source of this trip */
  intermediary?: IntermediaryEnum | BlankEnum;
  completion_time: string | null;
  /** - This class represents the summary of all fees that are calculated
    and the associated subtotals.
    - The fields are all optional because they will only be calculated
    if the relevant fees are present on the PricingScheme model. */
  price_summary: {
    name: string;
    base_fee_summary: {
      sub_total: number;
    } | null;
    loaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    long_distance_loaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    unloaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    unloaded_return_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    wait_time_fee_summary: {
      minutes: number;
      free_minutes: number;
      period: number;
      rate: number;
      sub_total: number;
    } | null;
    no_show_fee_summary: {
      sub_total: number;
      cancellation_reason: string;
      canceled_at: string;
      scheduled_pickup_at: string;
      minutes_before_pickup: number;
      no_show_fee_type: string;
    } | null;
    late_cancellation_fee_summary: {
      sub_total: number;
      canceled_at: string;
      scheduled_pickup_at: string;
      minutes_before_pickup: number;
      late_cancellation_fee_type: string;
    } | null;
    pickup_stair_fee_summary: {
      sub_total: number;
      steps: number;
      minimum_steps: number;
      fee_type: string;
      rate: number;
    } | null;
    dropoff_stair_fee_summary: {
      sub_total: number;
      steps: number;
      minimum_steps: number;
      fee_type: string;
      rate: number;
    } | null;
    additional_attendants_fee_summary: {
      sub_total: number;
      additional_attendants: number;
      rate: number;
    } | null;
    additional_passengers_fee_summary: {
      sub_total: number;
      additional_passengers: number;
      rate: number;
    } | null;
    bariatric_fee_summary: {
      sub_total: number;
      is_bariatric: boolean;
    } | null;
    wheelchair_rental_fee_summary: {
      sub_total: number;
      is_wheelchair_provided: boolean;
    } | null;
    oxygen_fee_summary: {
      sub_total: number;
      is_oxygen_provided: boolean;
    } | null;
    after_hours_fee_summary: {
      sub_total: number;
      pickup_time: string;
      business_hours_start: string | null;
      business_hours_end: string | null;
    } | null;
    weekend_fee_summary: {
      sub_total: number;
      day_of_week: string;
    } | null;
    holiday_fee_summary: {
      sub_total: number;
      holiday: string | null;
      date: string;
    } | null;
    minimum_price_cents: number | null;
    infectious_disease_fee_summary: {
      sub_total: number;
      has_infectious_disease: boolean;
    } | null;
    same_day_booking_fee_summary: {
      sub_total: number;
    } | null;
    car_seat_fee_summary: {
      sub_total: number;
      is_car_seat_required: boolean;
    } | null;
    booster_seat_fee_summary: {
      sub_total: number;
      is_booster_seat_required: boolean;
    } | null;
    ride_alone_fee_summary: {
      sub_total: number;
      is_ride_alone: boolean;
    } | null;
    price_rounding: string;
    price_rounding_interval: number | null;
    total: number;
  } | null;
};
export type InvoicesTripsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoicesExportRetrieveInvoiceErrorComponent = {
  attr: 'invoice';
  code: 'invalid_choice';
  detail: string;
};
export type InvoicesExportRetrieveTripPayerErrorComponent = {
  attr: 'trip__payer';
  code: 'invalid_choice';
  detail: string;
};
export type InvoicesExportRetrieveCreatedAtErrorComponent = {
  attr: 'created_at';
  code: 'invalid';
  detail: string;
};
export type InvoicesExportRetrieveRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type InvoicesExportRetrieveRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type InvoicesExportRetrieveOverallPaymentStatusInErrorComponent = {
  attr: 'overall_payment_status__in';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesExportRetrieveError =
  | ({
      attr: 'invoice';
    } & InvoicesExportRetrieveInvoiceErrorComponent)
  | ({
      attr: 'trip__payer';
    } & InvoicesExportRetrieveTripPayerErrorComponent)
  | ({
      attr: 'created_at';
    } & InvoicesExportRetrieveCreatedAtErrorComponent)
  | ({
      attr: 'range_start';
    } & InvoicesExportRetrieveRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & InvoicesExportRetrieveRangeEndErrorComponent)
  | ({
      attr: 'overall_payment_status__in';
    } & InvoicesExportRetrieveOverallPaymentStatusInErrorComponent);
export type InvoicesExportRetrieveValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesExportRetrieveError[];
};
export type InvoicesExportRetrieveErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesExportRetrieveValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicePaymentsListSelectedNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicePaymentsListSelectedSelectedInvoicesErrorComponent = {
  attr: 'selected_invoices';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type InvoicePaymentsListSelectedSelectedInvoicesIndexErrorComponent = {
  attr: 'selected_invoices.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicePaymentsListSelectedStartDateErrorComponent = {
  attr: 'start_date';
  code: 'datetime' | 'invalid' | 'null';
  detail: string;
};
export type InvoicePaymentsListSelectedEndDateErrorComponent = {
  attr: 'end_date';
  code: 'datetime' | 'invalid' | 'null';
  detail: string;
};
export type InvoicePaymentsListSelectedError =
  | ({
      attr: 'non_field_errors';
    } & InvoicePaymentsListSelectedNonFieldErrorsErrorComponent)
  | ({
      attr: 'selected_invoices';
    } & InvoicePaymentsListSelectedSelectedInvoicesErrorComponent)
  | ({
      attr: 'selected_invoices.INDEX';
    } & InvoicePaymentsListSelectedSelectedInvoicesIndexErrorComponent)
  | ({
      attr: 'start_date';
    } & InvoicePaymentsListSelectedStartDateErrorComponent)
  | ({
      attr: 'end_date';
    } & InvoicePaymentsListSelectedEndDateErrorComponent);
export type InvoicePaymentsListSelectedValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicePaymentsListSelectedError[];
};
export type InvoicePaymentsListSelectedErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicePaymentsListSelectedValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicePaymentExportFilter = {
  /** List of IDs of the invoices to include in response. */
  selected_invoices?: string[];
  /** Filter payments on or after this date (YYYY-MM-DD). */
  start_date?: string;
  /** Filter payments on or before this date (YYYY-MM-DD). */
  end_date?: string;
};
export type InvoiceRefundsListSelectedNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoiceRefundsListSelectedSelectedInvoicesErrorComponent = {
  attr: 'selected_invoices';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type InvoiceRefundsListSelectedSelectedInvoicesIndexErrorComponent = {
  attr: 'selected_invoices.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoiceRefundsListSelectedError =
  | ({
      attr: 'non_field_errors';
    } & InvoiceRefundsListSelectedNonFieldErrorsErrorComponent)
  | ({
      attr: 'selected_invoices';
    } & InvoiceRefundsListSelectedSelectedInvoicesErrorComponent)
  | ({
      attr: 'selected_invoices.INDEX';
    } & InvoiceRefundsListSelectedSelectedInvoicesIndexErrorComponent);
export type InvoiceRefundsListSelectedValidationError = {
  type: ValidationErrorEnum;
  errors: InvoiceRefundsListSelectedError[];
};
export type InvoiceRefundsListSelectedErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoiceRefundsListSelectedValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesListFilter = {
  /** List of IDs of the invoices to include in response. */
  selected_invoices?: string[];
};
export type InvoiceLineItemsListSelectedNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoiceLineItemsListSelectedSelectedInvoicesErrorComponent = {
  attr: 'selected_invoices';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type InvoiceLineItemsListSelectedSelectedInvoicesIndexErrorComponent = {
  attr: 'selected_invoices.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoiceLineItemsListSelectedError =
  | ({
      attr: 'non_field_errors';
    } & InvoiceLineItemsListSelectedNonFieldErrorsErrorComponent)
  | ({
      attr: 'selected_invoices';
    } & InvoiceLineItemsListSelectedSelectedInvoicesErrorComponent)
  | ({
      attr: 'selected_invoices.INDEX';
    } & InvoiceLineItemsListSelectedSelectedInvoicesIndexErrorComponent);
export type InvoiceLineItemsListSelectedValidationError = {
  type: ValidationErrorEnum;
  errors: InvoiceLineItemsListSelectedError[];
};
export type InvoiceLineItemsListSelectedErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoiceLineItemsListSelectedValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesInvoiceEmailCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicesInvoiceEmailCreateInvoiceIdErrorComponent = {
  attr: 'invoice_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoiceEmailCreateInvoiceFileErrorComponent = {
  attr: 'invoice_file';
  code: 'empty' | 'invalid' | 'no_name';
  detail: string;
};
export type InvoicesInvoiceEmailCreateMessageNonFieldErrorsErrorComponent = {
  attr: 'message.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoiceEmailCreateMessageEmailToErrorComponent = {
  attr: 'message.email_to';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoiceEmailCreateMessageEmailSubjectErrorComponent = {
  attr: 'message.email_subject';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoiceEmailCreateMessageEmailBodyErrorComponent = {
  attr: 'message.email_body';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoiceEmailCreateError =
  | ({
      attr: 'non_field_errors';
    } & InvoicesInvoiceEmailCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'invoice_id';
    } & InvoicesInvoiceEmailCreateInvoiceIdErrorComponent)
  | ({
      attr: 'invoice_file';
    } & InvoicesInvoiceEmailCreateInvoiceFileErrorComponent)
  | ({
      attr: 'message.non_field_errors';
    } & InvoicesInvoiceEmailCreateMessageNonFieldErrorsErrorComponent)
  | ({
      attr: 'message.email_to';
    } & InvoicesInvoiceEmailCreateMessageEmailToErrorComponent)
  | ({
      attr: 'message.email_subject';
    } & InvoicesInvoiceEmailCreateMessageEmailSubjectErrorComponent)
  | ({
      attr: 'message.email_body';
    } & InvoicesInvoiceEmailCreateMessageEmailBodyErrorComponent);
export type InvoicesInvoiceEmailCreateValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesInvoiceEmailCreateError[];
};
export type InvoicesInvoiceEmailCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesInvoiceEmailCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoiceEmailMessage = {
  /** The email address(es) to send the email to. Multiple addresses can be separated by commas. */
  email_to: string;
  /** The subject of the email. */
  email_subject: string;
  /** The body of the email. */
  email_body: string;
};
export type InvoiceEmail = {
  /** The ID of the invoice to send. */
  invoice_id: string;
  /** The invoice PDF file to attach to the email. */
  invoice_file?: string | null;
  message: InvoiceEmailMessage;
};
export type LineItemTypeEnum = 'trip' | 'modifier';
export type InvoiceNestedLineItem = {
  id?: string;
  description: string;
  amount_cents: number;
  trip?: string | null;
  line_item_type?: LineItemTypeEnum;
};
export type InvoiceLineItemPayer = {
  id: string;
  display_name: string;
};
export type InvoiceNestedLineItemRead = {
  id?: string;
  description: string;
  amount_cents: number;
  trip?: string | null;
  line_item_type?: LineItemTypeEnum;
  invoice: string;
  created_at: string;
  updated_at: string;
  trip_payer: InvoiceLineItemPayer | null;
};
export type Invoice = {
  number: string;
  date_issued: string;
  notes?: string;
  line_items: InvoiceNestedLineItem[];
};
export type InvoicePaymentStatusEnum =
  | 'canceled'
  | 'processing'
  | 'requires_action'
  | 'requires_capture'
  | 'requires_confirmation'
  | 'requires_payment_method'
  | 'succeeded'
  | 'refunded';
export type InvoicePayment = {
  id?: string;
  amount_cents: number;
  date: string;
  invoice: string;
  /** Tilled payment method id */
  external_payment_method_id: string;
  /** The status of the payment intent */
  status?: InvoicePaymentStatusEnum;
  by_passenger?: string | null;
  by_payer?: string | null;
  /** Set to true to mark payment as manually collected */
  is_manual?: boolean;
  /** Note for the payment */
  note?: string;
  payment_link?: string | null;
};
export type ChargeStatusEnum = 'succeeded' | 'pending' | 'failed';
export type InvoicePaymentRead = {
  id?: string;
  amount_cents: number;
  date: string;
  invoice: string;
  invoice_number: string;
  /** Tilled payment method id */
  external_payment_method_id: string;
  /** Tilled payment id */
  external_payment_id: string;
  /** The status of the payment intent */
  status?: InvoicePaymentStatusEnum;
  tilled_type_of_payer: string;
  id_of_payer: string | null;
  by_passenger?: string | null;
  by_payer?: string | null;
  created_at: string;
  updated_at: string;
  amount_total_cents: number;
  /** The status of the payment */
  charge_status: ChargeStatusEnum;
  refunds: string[];
  /** Tilled failure message for the charge */
  failure_message: string;
  /** Tilled failure code for the charge */
  failure_code: string;
  /** The time the charge failed at */
  failed_at: string | null;
  /** Set to true to mark payment as manually collected */
  is_manual?: boolean;
  /** Note for the payment */
  note?: string;
  total_refunded: number;
  payment_link?: string | null;
};
export type OverallPaymentStatusEnum =
  | 'paid'
  | 'partially_paid'
  | 'unpaid'
  | 'overpaid'
  | 'unknown';
export type InvoiceRead = {
  id: string;
  number: string;
  date_issued: string;
  notes?: string;
  line_items: InvoiceNestedLineItemRead[];
  total_amount_cents: number;
  total_amount_due_cents: number;
  payments: InvoicePaymentRead[] | null;
  overall_payment_status: OverallPaymentStatusEnum;
  created_at: string;
  updated_at: string;
};
export type PaginatedInvoiceList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Invoice[];
};
export type PaginatedInvoiceListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoiceRead[];
};
export type InvoicesInvoicesListCreatedAtErrorComponent = {
  attr: 'created_at';
  code: 'invalid';
  detail: string;
};
export type InvoicesInvoicesListDateIssuedErrorComponent = {
  attr: 'date_issued';
  code: 'invalid';
  detail: string;
};
export type InvoicesInvoicesListTotalAmountMinErrorComponent = {
  attr: 'total_amount_min';
  code: 'invalid' | 'max_value';
  detail: string;
};
export type InvoicesInvoicesListTotalAmountMaxErrorComponent = {
  attr: 'total_amount_max';
  code: 'invalid' | 'max_value';
  detail: string;
};
export type InvoicesInvoicesListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type InvoicesInvoicesListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type InvoicesInvoicesListMinPaymentsErrorComponent = {
  attr: 'min_payments';
  code: 'invalid' | 'max_value';
  detail: string;
};
export type InvoicesInvoicesListDateIssuedStartErrorComponent = {
  attr: 'date_issued_start';
  code: 'invalid';
  detail: string;
};
export type InvoicesInvoicesListDateIssuedEndErrorComponent = {
  attr: 'date_issued_end';
  code: 'invalid';
  detail: string;
};
export type InvoicesInvoicesListOverallPaymentStatusInErrorComponent = {
  attr: 'overall_payment_status__in';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoicesListDueMinErrorComponent = {
  attr: 'due_min';
  code: 'invalid' | 'max_value';
  detail: string;
};
export type InvoicesInvoicesListDueMaxErrorComponent = {
  attr: 'due_max';
  code: 'invalid' | 'max_value';
  detail: string;
};
export type InvoicesInvoicesListTripPayerInErrorComponent = {
  attr: 'trip_payer__in';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoicesListError =
  | ({
      attr: 'created_at';
    } & InvoicesInvoicesListCreatedAtErrorComponent)
  | ({
      attr: 'date_issued';
    } & InvoicesInvoicesListDateIssuedErrorComponent)
  | ({
      attr: 'total_amount_min';
    } & InvoicesInvoicesListTotalAmountMinErrorComponent)
  | ({
      attr: 'total_amount_max';
    } & InvoicesInvoicesListTotalAmountMaxErrorComponent)
  | ({
      attr: 'range_start';
    } & InvoicesInvoicesListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & InvoicesInvoicesListRangeEndErrorComponent)
  | ({
      attr: 'min_payments';
    } & InvoicesInvoicesListMinPaymentsErrorComponent)
  | ({
      attr: 'date_issued_start';
    } & InvoicesInvoicesListDateIssuedStartErrorComponent)
  | ({
      attr: 'date_issued_end';
    } & InvoicesInvoicesListDateIssuedEndErrorComponent)
  | ({
      attr: 'overall_payment_status__in';
    } & InvoicesInvoicesListOverallPaymentStatusInErrorComponent)
  | ({
      attr: 'due_min';
    } & InvoicesInvoicesListDueMinErrorComponent)
  | ({
      attr: 'due_max';
    } & InvoicesInvoicesListDueMaxErrorComponent)
  | ({
      attr: 'trip_payer__in';
    } & InvoicesInvoicesListTripPayerInErrorComponent);
export type InvoicesInvoicesListValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesInvoicesListError[];
};
export type InvoicesInvoicesListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesInvoicesListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesInvoicesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicesInvoicesCreateNumberErrorComponent = {
  attr: 'number';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoicesCreateDateIssuedErrorComponent = {
  attr: 'date_issued';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoicesCreateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoicesCreateLineItemsNonFieldErrorsErrorComponent = {
  attr: 'line_items.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoicesCreateLineItemsIndexNonFieldErrorsErrorComponent = {
  attr: 'line_items.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoicesCreateLineItemsIndexIdErrorComponent = {
  attr: 'line_items.INDEX.id';
  code: 'invalid' | 'null';
  detail: string;
};
export type InvoicesInvoicesCreateLineItemsIndexDescriptionErrorComponent = {
  attr: 'line_items.INDEX.description';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoicesCreateLineItemsIndexAmountCentsErrorComponent = {
  attr: 'line_items.INDEX.amount_cents';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type InvoicesInvoicesCreateLineItemsIndexTripErrorComponent = {
  attr: 'line_items.INDEX.trip';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesInvoicesCreateLineItemsIndexLineItemTypeErrorComponent = {
  attr: 'line_items.INDEX.line_item_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type InvoicesInvoicesCreateLineItemsIndexTripPayerIdErrorComponent = {
  attr: 'line_items.INDEX.trip_payer.id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoicesCreateLineItemsIndexTripPayerDisplayNameErrorComponent =
  {
    attr: 'line_items.INDEX.trip_payer.display_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type InvoicesInvoicesCreatePaymentsIndexIdErrorComponent = {
  attr: 'payments.INDEX.id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type InvoicesInvoicesCreatePaymentsIndexAmountCentsErrorComponent = {
  attr: 'payments.INDEX.amount_cents';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type InvoicesInvoicesCreatePaymentsIndexDateErrorComponent = {
  attr: 'payments.INDEX.date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoicesCreatePaymentsIndexInvoiceErrorComponent = {
  attr: 'payments.INDEX.invoice';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoicesCreatePaymentsIndexExternalPaymentMethodIdErrorComponent =
  {
    attr: 'payments.INDEX.external_payment_method_id';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type InvoicesInvoicesCreatePaymentsIndexStatusErrorComponent = {
  attr: 'payments.INDEX.status';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type InvoicesInvoicesCreatePaymentsIndexByPassengerErrorComponent = {
  attr: 'payments.INDEX.by_passenger';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesInvoicesCreatePaymentsIndexByPayerErrorComponent = {
  attr: 'payments.INDEX.by_payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesInvoicesCreatePaymentsIndexIsManualErrorComponent = {
  attr: 'payments.INDEX.is_manual';
  code: 'invalid' | 'null';
  detail: string;
};
export type InvoicesInvoicesCreatePaymentsIndexNoteErrorComponent = {
  attr: 'payments.INDEX.note';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoicesCreatePaymentsIndexPaymentLinkErrorComponent = {
  attr: 'payments.INDEX.payment_link';
  code: 'invalid';
  detail: string;
};
export type InvoicesInvoicesCreateError =
  | ({
      attr: 'non_field_errors';
    } & InvoicesInvoicesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'number';
    } & InvoicesInvoicesCreateNumberErrorComponent)
  | ({
      attr: 'date_issued';
    } & InvoicesInvoicesCreateDateIssuedErrorComponent)
  | ({
      attr: 'notes';
    } & InvoicesInvoicesCreateNotesErrorComponent)
  | ({
      attr: 'line_items.non_field_errors';
    } & InvoicesInvoicesCreateLineItemsNonFieldErrorsErrorComponent)
  | ({
      attr: 'line_items.INDEX.non_field_errors';
    } & InvoicesInvoicesCreateLineItemsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'line_items.INDEX.id';
    } & InvoicesInvoicesCreateLineItemsIndexIdErrorComponent)
  | ({
      attr: 'line_items.INDEX.description';
    } & InvoicesInvoicesCreateLineItemsIndexDescriptionErrorComponent)
  | ({
      attr: 'line_items.INDEX.amount_cents';
    } & InvoicesInvoicesCreateLineItemsIndexAmountCentsErrorComponent)
  | ({
      attr: 'line_items.INDEX.trip';
    } & InvoicesInvoicesCreateLineItemsIndexTripErrorComponent)
  | ({
      attr: 'line_items.INDEX.line_item_type';
    } & InvoicesInvoicesCreateLineItemsIndexLineItemTypeErrorComponent)
  | ({
      attr: 'line_items.INDEX.trip_payer.id';
    } & InvoicesInvoicesCreateLineItemsIndexTripPayerIdErrorComponent)
  | ({
      attr: 'line_items.INDEX.trip_payer.display_name';
    } & InvoicesInvoicesCreateLineItemsIndexTripPayerDisplayNameErrorComponent)
  | ({
      attr: 'payments.INDEX.id';
    } & InvoicesInvoicesCreatePaymentsIndexIdErrorComponent)
  | ({
      attr: 'payments.INDEX.amount_cents';
    } & InvoicesInvoicesCreatePaymentsIndexAmountCentsErrorComponent)
  | ({
      attr: 'payments.INDEX.date';
    } & InvoicesInvoicesCreatePaymentsIndexDateErrorComponent)
  | ({
      attr: 'payments.INDEX.invoice';
    } & InvoicesInvoicesCreatePaymentsIndexInvoiceErrorComponent)
  | ({
      attr: 'payments.INDEX.external_payment_method_id';
    } & InvoicesInvoicesCreatePaymentsIndexExternalPaymentMethodIdErrorComponent)
  | ({
      attr: 'payments.INDEX.status';
    } & InvoicesInvoicesCreatePaymentsIndexStatusErrorComponent)
  | ({
      attr: 'payments.INDEX.by_passenger';
    } & InvoicesInvoicesCreatePaymentsIndexByPassengerErrorComponent)
  | ({
      attr: 'payments.INDEX.by_payer';
    } & InvoicesInvoicesCreatePaymentsIndexByPayerErrorComponent)
  | ({
      attr: 'payments.INDEX.is_manual';
    } & InvoicesInvoicesCreatePaymentsIndexIsManualErrorComponent)
  | ({
      attr: 'payments.INDEX.note';
    } & InvoicesInvoicesCreatePaymentsIndexNoteErrorComponent)
  | ({
      attr: 'payments.INDEX.payment_link';
    } & InvoicesInvoicesCreatePaymentsIndexPaymentLinkErrorComponent);
export type InvoicesInvoicesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesInvoicesCreateError[];
};
export type InvoicesInvoicesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesInvoicesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesInvoicesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoicesInvoicesPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicesInvoicesPartialUpdateNumberErrorComponent = {
  attr: 'number';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoicesPartialUpdateDateIssuedErrorComponent = {
  attr: 'date_issued';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoicesPartialUpdateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoicesPartialUpdateLineItemsNonFieldErrorsErrorComponent =
  {
    attr: 'line_items.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdateLineItemsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'line_items.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdateLineItemsIndexIdErrorComponent = {
  attr: 'line_items.INDEX.id';
  code: 'invalid' | 'null';
  detail: string;
};
export type InvoicesInvoicesPartialUpdateLineItemsIndexDescriptionErrorComponent =
  {
    attr: 'line_items.INDEX.description';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdateLineItemsIndexAmountCentsErrorComponent =
  {
    attr: 'line_items.INDEX.amount_cents';
    code:
      | 'invalid'
      | 'max_string_length'
      | 'max_value'
      | 'min_value'
      | 'null'
      | 'required';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdateLineItemsIndexTripErrorComponent = {
  attr: 'line_items.INDEX.trip';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesInvoicesPartialUpdateLineItemsIndexLineItemTypeErrorComponent =
  {
    attr: 'line_items.INDEX.line_item_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdateLineItemsIndexTripPayerIdErrorComponent =
  {
    attr: 'line_items.INDEX.trip_payer.id';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdateLineItemsIndexTripPayerDisplayNameErrorComponent =
  {
    attr: 'line_items.INDEX.trip_payer.display_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdatePaymentsIndexIdErrorComponent = {
  attr: 'payments.INDEX.id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type InvoicesInvoicesPartialUpdatePaymentsIndexAmountCentsErrorComponent =
  {
    attr: 'payments.INDEX.amount_cents';
    code:
      | 'invalid'
      | 'max_string_length'
      | 'max_value'
      | 'min_value'
      | 'null'
      | 'required';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdatePaymentsIndexDateErrorComponent = {
  attr: 'payments.INDEX.date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoicesPartialUpdatePaymentsIndexInvoiceErrorComponent = {
  attr: 'payments.INDEX.invoice';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type InvoicesInvoicesPartialUpdatePaymentsIndexExternalPaymentMethodIdErrorComponent =
  {
    attr: 'payments.INDEX.external_payment_method_id';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdatePaymentsIndexStatusErrorComponent = {
  attr: 'payments.INDEX.status';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type InvoicesInvoicesPartialUpdatePaymentsIndexByPassengerErrorComponent =
  {
    attr: 'payments.INDEX.by_passenger';
    code: 'does_not_exist' | 'incorrect_type';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdatePaymentsIndexByPayerErrorComponent = {
  attr: 'payments.INDEX.by_payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesInvoicesPartialUpdatePaymentsIndexIsManualErrorComponent = {
  attr: 'payments.INDEX.is_manual';
  code: 'invalid' | 'null';
  detail: string;
};
export type InvoicesInvoicesPartialUpdatePaymentsIndexNoteErrorComponent = {
  attr: 'payments.INDEX.note';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesInvoicesPartialUpdatePaymentsIndexPaymentLinkErrorComponent =
  {
    attr: 'payments.INDEX.payment_link';
    code: 'invalid';
    detail: string;
  };
export type InvoicesInvoicesPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & InvoicesInvoicesPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'number';
    } & InvoicesInvoicesPartialUpdateNumberErrorComponent)
  | ({
      attr: 'date_issued';
    } & InvoicesInvoicesPartialUpdateDateIssuedErrorComponent)
  | ({
      attr: 'notes';
    } & InvoicesInvoicesPartialUpdateNotesErrorComponent)
  | ({
      attr: 'line_items.non_field_errors';
    } & InvoicesInvoicesPartialUpdateLineItemsNonFieldErrorsErrorComponent)
  | ({
      attr: 'line_items.INDEX.non_field_errors';
    } & InvoicesInvoicesPartialUpdateLineItemsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'line_items.INDEX.id';
    } & InvoicesInvoicesPartialUpdateLineItemsIndexIdErrorComponent)
  | ({
      attr: 'line_items.INDEX.description';
    } & InvoicesInvoicesPartialUpdateLineItemsIndexDescriptionErrorComponent)
  | ({
      attr: 'line_items.INDEX.amount_cents';
    } & InvoicesInvoicesPartialUpdateLineItemsIndexAmountCentsErrorComponent)
  | ({
      attr: 'line_items.INDEX.trip';
    } & InvoicesInvoicesPartialUpdateLineItemsIndexTripErrorComponent)
  | ({
      attr: 'line_items.INDEX.line_item_type';
    } & InvoicesInvoicesPartialUpdateLineItemsIndexLineItemTypeErrorComponent)
  | ({
      attr: 'line_items.INDEX.trip_payer.id';
    } & InvoicesInvoicesPartialUpdateLineItemsIndexTripPayerIdErrorComponent)
  | ({
      attr: 'line_items.INDEX.trip_payer.display_name';
    } & InvoicesInvoicesPartialUpdateLineItemsIndexTripPayerDisplayNameErrorComponent)
  | ({
      attr: 'payments.INDEX.id';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexIdErrorComponent)
  | ({
      attr: 'payments.INDEX.amount_cents';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexAmountCentsErrorComponent)
  | ({
      attr: 'payments.INDEX.date';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexDateErrorComponent)
  | ({
      attr: 'payments.INDEX.invoice';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexInvoiceErrorComponent)
  | ({
      attr: 'payments.INDEX.external_payment_method_id';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexExternalPaymentMethodIdErrorComponent)
  | ({
      attr: 'payments.INDEX.status';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexStatusErrorComponent)
  | ({
      attr: 'payments.INDEX.by_passenger';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexByPassengerErrorComponent)
  | ({
      attr: 'payments.INDEX.by_payer';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexByPayerErrorComponent)
  | ({
      attr: 'payments.INDEX.is_manual';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexIsManualErrorComponent)
  | ({
      attr: 'payments.INDEX.note';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexNoteErrorComponent)
  | ({
      attr: 'payments.INDEX.payment_link';
    } & InvoicesInvoicesPartialUpdatePaymentsIndexPaymentLinkErrorComponent);
export type InvoicesInvoicesPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesInvoicesPartialUpdateError[];
};
export type InvoicesInvoicesPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesInvoicesPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedInvoice = {
  number?: string;
  date_issued?: string;
  notes?: string;
  line_items?: InvoiceNestedLineItem[];
};
export type PatchedInvoiceRead = {
  id?: string;
  number?: string;
  date_issued?: string;
  notes?: string;
  line_items?: InvoiceNestedLineItemRead[];
  total_amount_cents?: number;
  total_amount_due_cents?: number;
  payments?: InvoicePaymentRead[] | null;
  overall_payment_status?: OverallPaymentStatusEnum;
  created_at?: string;
  updated_at?: string;
};
export type InvoicesInvoicesDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoiceLineItem = {
  description: string;
  amount_cents: number;
  trip?: string | null;
  line_item_type?: LineItemTypeEnum;
  invoice: string;
};
export type InvoiceLineItemRead = {
  id: string;
  description: string;
  amount_cents: number;
  trip?: string | null;
  line_item_type?: LineItemTypeEnum;
  invoice: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedInvoiceLineItemList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoiceLineItem[];
};
export type PaginatedInvoiceLineItemListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoiceLineItemRead[];
};
export type InvoicesLineItemsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoicesLineItemsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicesLineItemsCreateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesLineItemsCreateAmountCentsErrorComponent = {
  attr: 'amount_cents';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type InvoicesLineItemsCreateTripErrorComponent = {
  attr: 'trip';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesLineItemsCreateLineItemTypeErrorComponent = {
  attr: 'line_item_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type InvoicesLineItemsCreateInvoiceErrorComponent = {
  attr: 'invoice';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type InvoicesLineItemsCreateError =
  | ({
      attr: 'non_field_errors';
    } & InvoicesLineItemsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'description';
    } & InvoicesLineItemsCreateDescriptionErrorComponent)
  | ({
      attr: 'amount_cents';
    } & InvoicesLineItemsCreateAmountCentsErrorComponent)
  | ({
      attr: 'trip';
    } & InvoicesLineItemsCreateTripErrorComponent)
  | ({
      attr: 'line_item_type';
    } & InvoicesLineItemsCreateLineItemTypeErrorComponent)
  | ({
      attr: 'invoice';
    } & InvoicesLineItemsCreateInvoiceErrorComponent);
export type InvoicesLineItemsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesLineItemsCreateError[];
};
export type InvoicesLineItemsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesLineItemsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesLineItemsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoicesLineItemsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicesLineItemsPartialUpdateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesLineItemsPartialUpdateAmountCentsErrorComponent = {
  attr: 'amount_cents';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type InvoicesLineItemsPartialUpdateTripErrorComponent = {
  attr: 'trip';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesLineItemsPartialUpdateLineItemTypeErrorComponent = {
  attr: 'line_item_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type InvoicesLineItemsPartialUpdateInvoiceErrorComponent = {
  attr: 'invoice';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type InvoicesLineItemsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & InvoicesLineItemsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'description';
    } & InvoicesLineItemsPartialUpdateDescriptionErrorComponent)
  | ({
      attr: 'amount_cents';
    } & InvoicesLineItemsPartialUpdateAmountCentsErrorComponent)
  | ({
      attr: 'trip';
    } & InvoicesLineItemsPartialUpdateTripErrorComponent)
  | ({
      attr: 'line_item_type';
    } & InvoicesLineItemsPartialUpdateLineItemTypeErrorComponent)
  | ({
      attr: 'invoice';
    } & InvoicesLineItemsPartialUpdateInvoiceErrorComponent);
export type InvoicesLineItemsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesLineItemsPartialUpdateError[];
};
export type InvoicesLineItemsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesLineItemsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedInvoiceLineItem = {
  description?: string;
  amount_cents?: number;
  trip?: string | null;
  line_item_type?: LineItemTypeEnum;
  invoice?: string;
};
export type PatchedInvoiceLineItemRead = {
  id?: string;
  description?: string;
  amount_cents?: number;
  trip?: string | null;
  line_item_type?: LineItemTypeEnum;
  invoice?: string;
  created_at?: string;
  updated_at?: string;
};
export type InvoicesLineItemsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoicePaymentLink = {
  /** The invoice file generated for this payment link */
  invoice_file?: string | null;
  invoice: string;
  by_passenger?: string | null;
  by_payer?: string | null;
  email_message?: string | null;
};
export type InvoicePaymentLinkStatusEnum = 'open' | 'complete' | 'expired';
export type InvoicePaymentLinkRead = {
  id: string;
  is_expired: boolean;
  invoice_number: string;
  email_to: string;
  deleted_at: string | null;
  created_at: string;
  updated_at: string;
  amount_cents: number;
  payment_portal_url: string;
  status: InvoicePaymentLinkStatusEnum;
  /** Tilled payment intent id */
  payment_intent_id: string;
  expires_at: string;
  /** The invoice file generated for this payment link */
  invoice_file?: string | null;
  organization: string;
  invoice: string;
  payment: string | null;
  by_passenger?: string | null;
  by_payer?: string | null;
  email_message?: string | null;
};
export type PaginatedInvoicePaymentLinkList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoicePaymentLink[];
};
export type PaginatedInvoicePaymentLinkListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoicePaymentLinkRead[];
};
export type InvoicesPaymentLinkListInvoiceErrorComponent = {
  attr: 'invoice';
  code: 'invalid_choice';
  detail: string;
};
export type InvoicesPaymentLinkListPaymentErrorComponent = {
  attr: 'payment';
  code: 'invalid_choice';
  detail: string;
};
export type InvoicesPaymentLinkListError =
  | ({
      attr: 'invoice';
    } & InvoicesPaymentLinkListInvoiceErrorComponent)
  | ({
      attr: 'payment';
    } & InvoicesPaymentLinkListPaymentErrorComponent);
export type InvoicesPaymentLinkListValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesPaymentLinkListError[];
};
export type InvoicesPaymentLinkListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesPaymentLinkListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesPaymentLinkCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicesPaymentLinkCreateInvoiceFileErrorComponent = {
  attr: 'invoice_file';
  code: 'empty' | 'invalid' | 'max_length' | 'no_name';
  detail: string;
};
export type InvoicesPaymentLinkCreateInvoiceErrorComponent = {
  attr: 'invoice';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type InvoicesPaymentLinkCreateByPassengerErrorComponent = {
  attr: 'by_passenger';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesPaymentLinkCreateByPayerErrorComponent = {
  attr: 'by_payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesPaymentLinkCreateEmailMessageErrorComponent = {
  attr: 'email_message';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesPaymentLinkCreateError =
  | ({
      attr: 'non_field_errors';
    } & InvoicesPaymentLinkCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'invoice_file';
    } & InvoicesPaymentLinkCreateInvoiceFileErrorComponent)
  | ({
      attr: 'invoice';
    } & InvoicesPaymentLinkCreateInvoiceErrorComponent)
  | ({
      attr: 'by_passenger';
    } & InvoicesPaymentLinkCreateByPassengerErrorComponent)
  | ({
      attr: 'by_payer';
    } & InvoicesPaymentLinkCreateByPayerErrorComponent)
  | ({
      attr: 'email_message';
    } & InvoicesPaymentLinkCreateEmailMessageErrorComponent);
export type InvoicesPaymentLinkCreateValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesPaymentLinkCreateError[];
};
export type InvoicesPaymentLinkCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesPaymentLinkCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesPaymentLinkEmailCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicesPaymentLinkEmailCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicesPaymentLinkEmailCreateEmailToErrorComponent = {
  attr: 'email_to';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesPaymentLinkEmailCreateEmailSubjectErrorComponent = {
  attr: 'email_subject';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesPaymentLinkEmailCreateEmailBodyErrorComponent = {
  attr: 'email_body';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesPaymentLinkEmailCreateEmailFromErrorComponent = {
  attr: 'email_from';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesPaymentLinkEmailCreateIncludeInvoiceAsAttachmentErrorComponent =
  {
    attr: 'include_invoice_as_attachment';
    code: 'invalid' | 'null';
    detail: string;
  };
export type InvoicesPaymentLinkEmailCreateError =
  | ({
      attr: 'non_field_errors';
    } & InvoicesPaymentLinkEmailCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & InvoicesPaymentLinkEmailCreateIdErrorComponent)
  | ({
      attr: 'email_to';
    } & InvoicesPaymentLinkEmailCreateEmailToErrorComponent)
  | ({
      attr: 'email_subject';
    } & InvoicesPaymentLinkEmailCreateEmailSubjectErrorComponent)
  | ({
      attr: 'email_body';
    } & InvoicesPaymentLinkEmailCreateEmailBodyErrorComponent)
  | ({
      attr: 'email_from';
    } & InvoicesPaymentLinkEmailCreateEmailFromErrorComponent)
  | ({
      attr: 'include_invoice_as_attachment';
    } & InvoicesPaymentLinkEmailCreateIncludeInvoiceAsAttachmentErrorComponent);
export type InvoicesPaymentLinkEmailCreateValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesPaymentLinkEmailCreateError[];
};
export type InvoicesPaymentLinkEmailCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesPaymentLinkEmailCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicePaymentLinkEmail = {
  /** The ID of the invoice payment link. */
  id: string;
  /** The email address(es) to send the email to. Multiple addresses can be separated by commas. */
  email_to: string;
  /** The subject of the email. */
  email_subject: string;
  /** The body of the email. */
  email_body: string;
  /** The display label of the sender. */
  email_from: string;
  /** Whether to include the invoice as an attachment. */
  include_invoice_as_attachment?: boolean;
};
export type InvoicesPaymentLinkRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoicesPaymentLinkPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicesPaymentLinkPartialUpdateInvoiceFileErrorComponent = {
  attr: 'invoice_file';
  code: 'empty' | 'invalid' | 'max_length' | 'no_name';
  detail: string;
};
export type InvoicesPaymentLinkPartialUpdateInvoiceErrorComponent = {
  attr: 'invoice';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type InvoicesPaymentLinkPartialUpdateByPassengerErrorComponent = {
  attr: 'by_passenger';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesPaymentLinkPartialUpdateByPayerErrorComponent = {
  attr: 'by_payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesPaymentLinkPartialUpdateEmailMessageErrorComponent = {
  attr: 'email_message';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesPaymentLinkPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & InvoicesPaymentLinkPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'invoice_file';
    } & InvoicesPaymentLinkPartialUpdateInvoiceFileErrorComponent)
  | ({
      attr: 'invoice';
    } & InvoicesPaymentLinkPartialUpdateInvoiceErrorComponent)
  | ({
      attr: 'by_passenger';
    } & InvoicesPaymentLinkPartialUpdateByPassengerErrorComponent)
  | ({
      attr: 'by_payer';
    } & InvoicesPaymentLinkPartialUpdateByPayerErrorComponent)
  | ({
      attr: 'email_message';
    } & InvoicesPaymentLinkPartialUpdateEmailMessageErrorComponent);
export type InvoicesPaymentLinkPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesPaymentLinkPartialUpdateError[];
};
export type InvoicesPaymentLinkPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesPaymentLinkPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedInvoicePaymentLink = {
  /** The invoice file generated for this payment link */
  invoice_file?: string | null;
  invoice?: string;
  by_passenger?: string | null;
  by_payer?: string | null;
  email_message?: string | null;
};
export type PatchedInvoicePaymentLinkRead = {
  id?: string;
  is_expired?: boolean;
  invoice_number?: string;
  email_to?: string;
  deleted_at?: string | null;
  created_at?: string;
  updated_at?: string;
  amount_cents?: number;
  payment_portal_url?: string;
  status?: InvoicePaymentLinkStatusEnum;
  /** Tilled payment intent id */
  payment_intent_id?: string;
  expires_at?: string;
  /** The invoice file generated for this payment link */
  invoice_file?: string | null;
  organization?: string;
  invoice?: string;
  payment?: string | null;
  by_passenger?: string | null;
  by_payer?: string | null;
  email_message?: string | null;
};
export type PaginatedInvoicePaymentList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoicePayment[];
};
export type PaginatedInvoicePaymentListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoicePaymentRead[];
};
export type InvoicesPaymentsListInvoiceNumberErrorComponent = {
  attr: 'invoice_number';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesPaymentsListTotalAmountCentsMinErrorComponent = {
  attr: 'total_amount_cents_min';
  code: 'invalid' | 'max_value';
  detail: string;
};
export type InvoicesPaymentsListTotalAmountCentsMaxErrorComponent = {
  attr: 'total_amount_cents_max';
  code: 'invalid' | 'max_value';
  detail: string;
};
export type InvoicesPaymentsListCreatedAtAfterErrorComponent = {
  attr: 'created_at_after';
  code: 'invalid';
  detail: string;
};
export type InvoicesPaymentsListCreatedAtBeforeErrorComponent = {
  attr: 'created_at_before';
  code: 'invalid';
  detail: string;
};
export type InvoicesPaymentsListStatusErrorComponent = {
  attr: 'status';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesPaymentsListError =
  | ({
      attr: 'invoice_number';
    } & InvoicesPaymentsListInvoiceNumberErrorComponent)
  | ({
      attr: 'total_amount_cents_min';
    } & InvoicesPaymentsListTotalAmountCentsMinErrorComponent)
  | ({
      attr: 'total_amount_cents_max';
    } & InvoicesPaymentsListTotalAmountCentsMaxErrorComponent)
  | ({
      attr: 'created_at_after';
    } & InvoicesPaymentsListCreatedAtAfterErrorComponent)
  | ({
      attr: 'created_at_before';
    } & InvoicesPaymentsListCreatedAtBeforeErrorComponent)
  | ({
      attr: 'status';
    } & InvoicesPaymentsListStatusErrorComponent);
export type InvoicesPaymentsListValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesPaymentsListError[];
};
export type InvoicesPaymentsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesPaymentsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesPaymentsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicesPaymentsCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type InvoicesPaymentsCreateAmountCentsErrorComponent = {
  attr: 'amount_cents';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type InvoicesPaymentsCreateDateErrorComponent = {
  attr: 'date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type InvoicesPaymentsCreateInvoiceErrorComponent = {
  attr: 'invoice';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type InvoicesPaymentsCreateExternalPaymentMethodIdErrorComponent = {
  attr: 'external_payment_method_id';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesPaymentsCreateStatusErrorComponent = {
  attr: 'status';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type InvoicesPaymentsCreateByPassengerErrorComponent = {
  attr: 'by_passenger';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesPaymentsCreateByPayerErrorComponent = {
  attr: 'by_payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type InvoicesPaymentsCreateIsManualErrorComponent = {
  attr: 'is_manual';
  code: 'invalid' | 'null';
  detail: string;
};
export type InvoicesPaymentsCreateNoteErrorComponent = {
  attr: 'note';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesPaymentsCreatePaymentLinkErrorComponent = {
  attr: 'payment_link';
  code: 'invalid';
  detail: string;
};
export type InvoicesPaymentsCreateError =
  | ({
      attr: 'non_field_errors';
    } & InvoicesPaymentsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & InvoicesPaymentsCreateIdErrorComponent)
  | ({
      attr: 'amount_cents';
    } & InvoicesPaymentsCreateAmountCentsErrorComponent)
  | ({
      attr: 'date';
    } & InvoicesPaymentsCreateDateErrorComponent)
  | ({
      attr: 'invoice';
    } & InvoicesPaymentsCreateInvoiceErrorComponent)
  | ({
      attr: 'external_payment_method_id';
    } & InvoicesPaymentsCreateExternalPaymentMethodIdErrorComponent)
  | ({
      attr: 'status';
    } & InvoicesPaymentsCreateStatusErrorComponent)
  | ({
      attr: 'by_passenger';
    } & InvoicesPaymentsCreateByPassengerErrorComponent)
  | ({
      attr: 'by_payer';
    } & InvoicesPaymentsCreateByPayerErrorComponent)
  | ({
      attr: 'is_manual';
    } & InvoicesPaymentsCreateIsManualErrorComponent)
  | ({
      attr: 'note';
    } & InvoicesPaymentsCreateNoteErrorComponent)
  | ({
      attr: 'payment_link';
    } & InvoicesPaymentsCreatePaymentLinkErrorComponent);
export type InvoicesPaymentsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesPaymentsCreateError[];
};
export type InvoicesPaymentsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesPaymentsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesPaymentsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoiceRefund = {
  payment: string;
  /** Tilled payment intent id */
  payment_intent_id: string;
  amount_cents: number;
};
export type InvoiceRefundStatusEnum =
  | 'canceled'
  | 'pending'
  | 'succeeded'
  | 'failed'
  | 'requires_action';
export type InvoiceRefundRead = {
  id: string;
  payment: string;
  /** Tilled payment intent id */
  payment_intent_id: string;
  amount_cents: number;
  /** Tilled refund id */
  external_refund_id: string;
  /** Tilled payment method id */
  external_payment_method_id: string;
  /** Tilled refund-charge id */
  charge_id: string;
  status: InvoiceRefundStatusEnum;
  reason: string;
  failure_code: string;
  failure_message: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedInvoiceRefundList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoiceRefund[];
};
export type PaginatedInvoiceRefundListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoiceRefundRead[];
};
export type InvoicesRefundsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoicesRefundsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type InvoicesRefundsCreatePaymentErrorComponent = {
  attr: 'payment';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type InvoicesRefundsCreatePaymentIntentIdErrorComponent = {
  attr: 'payment_intent_id';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type InvoicesRefundsCreateAmountCentsErrorComponent = {
  attr: 'amount_cents';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type InvoicesRefundsCreateError =
  | ({
      attr: 'non_field_errors';
    } & InvoicesRefundsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'payment';
    } & InvoicesRefundsCreatePaymentErrorComponent)
  | ({
      attr: 'payment_intent_id';
    } & InvoicesRefundsCreatePaymentIntentIdErrorComponent)
  | ({
      attr: 'amount_cents';
    } & InvoicesRefundsCreateAmountCentsErrorComponent);
export type InvoicesRefundsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesRefundsCreateError[];
};
export type InvoicesRefundsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesRefundsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesRefundsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type InvoiceTripFinder = {
  created_at: string;
  dropoff: TripLocationDetail;
  pickup: TripLocationDetail;
  scheduled_pickup_at: string;
};
export type InvoiceTripFinderPassenger = {};
export type InvoiceTripFinderPassengerRead = {
  id: string;
  first_name: string;
  last_name: string;
  full_name: string;
  dob: string | null;
};
export type InvoiceTripFinderRead = {
  id: string;
  /** Searchable, sharable short code for this trip and/or subscription */
  confirmation_code: string;
  created_at: string;
  driver_name: string;
  dropoff: TripLocationDetailRead;
  estimated_distance_miles: number | null;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id: string;
  /** The manually inputted price of the trip */
  input_price_cents: number | null;
  invoice_id: string | null;
  invoice_numbers: string | null;
  passenger: InvoiceTripFinderPassengerRead;
  payer: InvoicePayerRead;
  payer_id: string;
  pickup: TripLocationDetailRead;
  /** - This class represents the summary of all fees that are calculated
    and the associated subtotals.
    - The fields are all optional because they will only be calculated
    if the relevant fees are present on the PricingScheme model. */
  price_summary: {
    name: string;
    base_fee_summary: {
      sub_total: number;
    } | null;
    loaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    long_distance_loaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    unloaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    unloaded_return_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    wait_time_fee_summary: {
      minutes: number;
      free_minutes: number;
      period: number;
      rate: number;
      sub_total: number;
    } | null;
    no_show_fee_summary: {
      sub_total: number;
      cancellation_reason: string;
      canceled_at: string;
      scheduled_pickup_at: string;
      minutes_before_pickup: number;
      no_show_fee_type: string;
    } | null;
    late_cancellation_fee_summary: {
      sub_total: number;
      canceled_at: string;
      scheduled_pickup_at: string;
      minutes_before_pickup: number;
      late_cancellation_fee_type: string;
    } | null;
    pickup_stair_fee_summary: {
      sub_total: number;
      steps: number;
      minimum_steps: number;
      fee_type: string;
      rate: number;
    } | null;
    dropoff_stair_fee_summary: {
      sub_total: number;
      steps: number;
      minimum_steps: number;
      fee_type: string;
      rate: number;
    } | null;
    additional_attendants_fee_summary: {
      sub_total: number;
      additional_attendants: number;
      rate: number;
    } | null;
    additional_passengers_fee_summary: {
      sub_total: number;
      additional_passengers: number;
      rate: number;
    } | null;
    bariatric_fee_summary: {
      sub_total: number;
      is_bariatric: boolean;
    } | null;
    wheelchair_rental_fee_summary: {
      sub_total: number;
      is_wheelchair_provided: boolean;
    } | null;
    oxygen_fee_summary: {
      sub_total: number;
      is_oxygen_provided: boolean;
    } | null;
    after_hours_fee_summary: {
      sub_total: number;
      pickup_time: string;
      business_hours_start: string | null;
      business_hours_end: string | null;
    } | null;
    weekend_fee_summary: {
      sub_total: number;
      day_of_week: string;
    } | null;
    holiday_fee_summary: {
      sub_total: number;
      holiday: string | null;
      date: string;
    } | null;
    minimum_price_cents: number | null;
    infectious_disease_fee_summary: {
      sub_total: number;
      has_infectious_disease: boolean;
    } | null;
    same_day_booking_fee_summary: {
      sub_total: number;
    } | null;
    car_seat_fee_summary: {
      sub_total: number;
      is_car_seat_required: boolean;
    } | null;
    booster_seat_fee_summary: {
      sub_total: number;
      is_booster_seat_required: boolean;
    } | null;
    ride_alone_fee_summary: {
      sub_total: number;
      is_ride_alone: boolean;
    } | null;
    price_rounding: string;
    price_rounding_interval: number | null;
    total: number;
  } | null;
  scheduled_pickup_at: string;
  service_type: ServiceTypeEnum;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Current status of this trip */
  status: OverrideStatusEnum;
  tags: TripTripTagRead[] | null;
  vehicle_nickname: string | null;
};
export type PaginatedInvoiceTripFinderList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoiceTripFinder[];
};
export type PaginatedInvoiceTripFinderListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: InvoiceTripFinderRead[];
};
export type InvoicesTripFinderListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type InvoicesTripFinderListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type InvoicesTripFinderListPayersErrorComponent = {
  attr: 'payers';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesTripFinderListStatusErrorComponent = {
  attr: 'status';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesTripFinderListPassengersErrorComponent = {
  attr: 'passengers';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesTripFinderListTagsErrorComponent = {
  attr: 'tags';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesTripFinderListVehiclesErrorComponent = {
  attr: 'vehicles';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesTripFinderListSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type InvoicesTripFinderListPriceErrorComponent = {
  attr: 'price';
  code: 'invalid';
  detail: string;
};
export type InvoicesTripFinderListCreatedAtRangeStartErrorComponent = {
  attr: 'created_at_range_start';
  code: 'invalid';
  detail: string;
};
export type InvoicesTripFinderListCreatedAtRangeEndErrorComponent = {
  attr: 'created_at_range_end';
  code: 'invalid';
  detail: string;
};
export type InvoicesTripFinderListError =
  | ({
      attr: 'range_start';
    } & InvoicesTripFinderListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & InvoicesTripFinderListRangeEndErrorComponent)
  | ({
      attr: 'payers';
    } & InvoicesTripFinderListPayersErrorComponent)
  | ({
      attr: 'status';
    } & InvoicesTripFinderListStatusErrorComponent)
  | ({
      attr: 'passengers';
    } & InvoicesTripFinderListPassengersErrorComponent)
  | ({
      attr: 'tags';
    } & InvoicesTripFinderListTagsErrorComponent)
  | ({
      attr: 'vehicles';
    } & InvoicesTripFinderListVehiclesErrorComponent)
  | ({
      attr: 'space_type';
    } & InvoicesTripFinderListSpaceTypeErrorComponent)
  | ({
      attr: 'price';
    } & InvoicesTripFinderListPriceErrorComponent)
  | ({
      attr: 'created_at_range_start';
    } & InvoicesTripFinderListCreatedAtRangeStartErrorComponent)
  | ({
      attr: 'created_at_range_end';
    } & InvoicesTripFinderListCreatedAtRangeEndErrorComponent);
export type InvoicesTripFinderListValidationError = {
  type: ValidationErrorEnum;
  errors: InvoicesTripFinderListError[];
};
export type InvoicesTripFinderListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & InvoicesTripFinderListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type InvoicesTripFinderRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PaginatedAddressList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Address[];
};
export type PaginatedAddressListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AddressRead[];
};
export type LocationsAddressesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type LocationsAddressesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type County = {
  county: string;
  state: string;
};
export type PaginatedCountyList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: County[];
};
export type LocationsCountiesListCountyErrorComponent = {
  attr: 'county';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type LocationsCountiesListError = {
  attr: 'county';
} & LocationsCountiesListCountyErrorComponent;
export type LocationsCountiesListValidationError = {
  type: ValidationErrorEnum;
  errors: LocationsCountiesListError[];
};
export type LocationsCountiesListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & LocationsCountiesListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type GeoLocationLocation = {
  longitude: number;
  latitude: number;
};
export type GeoLocationLocationRead = {
  longitude: number;
  latitude: number;
  /** local area, ex. Toronto */
  municipality: string;
  region: string;
  /** letters/numbers in country-specific format */
  postal_code: string;
  place_id: string;
};
export type GeoLocation = {
  /** Label for the GeoLocation, provided by the creator. */
  label: string;
  location: GeoLocationLocation;
};
export type SourceEnum = 'pin' | 'broker' | 'other';
export type GeoLocationRead = {
  id: string;
  /** The location object corresponding to this GeoLocation. */
  location_id: string;
  /** Label for the GeoLocation, provided by the creator. */
  label: string;
  /** Source of the GeoLocation. */
  source: SourceEnum;
  location: GeoLocationLocationRead;
  trip_count: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
};
export type PaginatedGeoLocationList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: GeoLocation[];
};
export type PaginatedGeoLocationListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: GeoLocationRead[];
};
export type LocationsGeolocationsListSourceErrorComponent = {
  attr: 'source';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type LocationsGeolocationsListError = {
  attr: 'source';
} & LocationsGeolocationsListSourceErrorComponent;
export type LocationsGeolocationsListValidationError = {
  type: ValidationErrorEnum;
  errors: LocationsGeolocationsListError[];
};
export type LocationsGeolocationsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & LocationsGeolocationsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type LocationsGeolocationsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type LocationsGeolocationsCreateLabelErrorComponent = {
  attr: 'label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type LocationsGeolocationsCreateLocationNonFieldErrorsErrorComponent = {
  attr: 'location.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type LocationsGeolocationsCreateLocationLongitudeErrorComponent = {
  attr: 'location.longitude';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type LocationsGeolocationsCreateLocationLatitudeErrorComponent = {
  attr: 'location.latitude';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type LocationsGeolocationsCreateError =
  | ({
      attr: 'non_field_errors';
    } & LocationsGeolocationsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'label';
    } & LocationsGeolocationsCreateLabelErrorComponent)
  | ({
      attr: 'location.non_field_errors';
    } & LocationsGeolocationsCreateLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'location.longitude';
    } & LocationsGeolocationsCreateLocationLongitudeErrorComponent)
  | ({
      attr: 'location.latitude';
    } & LocationsGeolocationsCreateLocationLatitudeErrorComponent);
export type LocationsGeolocationsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: LocationsGeolocationsCreateError[];
};
export type LocationsGeolocationsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & LocationsGeolocationsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type LocationsGeolocationsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type LocationsGeolocationsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type LocationsGeolocationsPartialUpdateLabelErrorComponent = {
  attr: 'label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type LocationsGeolocationsPartialUpdateLocationNonFieldErrorsErrorComponent =
  {
    attr: 'location.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type LocationsGeolocationsPartialUpdateLocationLongitudeErrorComponent =
  {
    attr: 'location.longitude';
    code:
      | 'invalid'
      | 'max_string_length'
      | 'max_value'
      | 'min_value'
      | 'null'
      | 'required';
    detail: string;
  };
export type LocationsGeolocationsPartialUpdateLocationLatitudeErrorComponent = {
  attr: 'location.latitude';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type LocationsGeolocationsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & LocationsGeolocationsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'label';
    } & LocationsGeolocationsPartialUpdateLabelErrorComponent)
  | ({
      attr: 'location.non_field_errors';
    } & LocationsGeolocationsPartialUpdateLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'location.longitude';
    } & LocationsGeolocationsPartialUpdateLocationLongitudeErrorComponent)
  | ({
      attr: 'location.latitude';
    } & LocationsGeolocationsPartialUpdateLocationLatitudeErrorComponent);
export type LocationsGeolocationsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: LocationsGeolocationsPartialUpdateError[];
};
export type LocationsGeolocationsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & LocationsGeolocationsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedGeoLocation = {
  /** Label for the GeoLocation, provided by the creator. */
  label?: string;
  location?: GeoLocationLocation;
};
export type PatchedGeoLocationRead = {
  id?: string;
  /** The location object corresponding to this GeoLocation. */
  location_id?: string;
  /** Label for the GeoLocation, provided by the creator. */
  label?: string;
  /** Source of the GeoLocation. */
  source?: SourceEnum;
  location?: GeoLocationLocationRead;
  trip_count?: number;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
};
export type LocationsGeolocationsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type LocationsGeolocationsUndeleteCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type LocationsGeolocationsUndeleteCreateLabelErrorComponent = {
  attr: 'label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type LocationsGeolocationsUndeleteCreateLocationNonFieldErrorsErrorComponent =
  {
    attr: 'location.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type LocationsGeolocationsUndeleteCreateLocationLongitudeErrorComponent =
  {
    attr: 'location.longitude';
    code:
      | 'invalid'
      | 'max_string_length'
      | 'max_value'
      | 'min_value'
      | 'null'
      | 'required';
    detail: string;
  };
export type LocationsGeolocationsUndeleteCreateLocationLatitudeErrorComponent =
  {
    attr: 'location.latitude';
    code:
      | 'invalid'
      | 'max_string_length'
      | 'max_value'
      | 'min_value'
      | 'null'
      | 'required';
    detail: string;
  };
export type LocationsGeolocationsUndeleteCreateError =
  | ({
      attr: 'non_field_errors';
    } & LocationsGeolocationsUndeleteCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'label';
    } & LocationsGeolocationsUndeleteCreateLabelErrorComponent)
  | ({
      attr: 'location.non_field_errors';
    } & LocationsGeolocationsUndeleteCreateLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'location.longitude';
    } & LocationsGeolocationsUndeleteCreateLocationLongitudeErrorComponent)
  | ({
      attr: 'location.latitude';
    } & LocationsGeolocationsUndeleteCreateLocationLatitudeErrorComponent);
export type LocationsGeolocationsUndeleteCreateValidationError = {
  type: ValidationErrorEnum;
  errors: LocationsGeolocationsUndeleteCreateError[];
};
export type LocationsGeolocationsUndeleteCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & LocationsGeolocationsUndeleteCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type LocationLogEntryTripMinimalReadOnly = {
  trip: string;
};
export type LocationLogEntryMinimalReadOnly = {};
export type LocationLogEntryMinimalReadOnlyRead = {
  /** ISO-8601 UTC datetime provided by the native location API. */
  device_timestamp: string;
  longitude: number;
  latitude: number;
  /** Device battery level when the location was recorded. 0.0=empty; 1.0=full. */
  battery_level: number;
  /** True when device is plugged in to power. */
  battery_is_charging: boolean;
};
export type LocationLogEntryTripMinimalReadOnlyRead = {
  id: string;
  location_log_entry: LocationLogEntryMinimalReadOnlyRead;
  trip: string;
};
export type PaginatedLocationLogEntryTripMinimalReadOnlyList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: LocationLogEntryTripMinimalReadOnly[];
};
export type PaginatedLocationLogEntryTripMinimalReadOnlyListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: LocationLogEntryTripMinimalReadOnlyRead[];
};
export type LocationsLocationLogEntryTripsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type LocationLogEntry = {};
export type EventEnum =
  | 'motionchange'
  | 'providerchange'
  | 'geofence'
  | 'heartbeat';
export type LocationLogEntryLocationBattery = {
  is_charging?: boolean | null;
  level?: number | null;
};
export type LocationLogEntryLocationActivityTypeEnum =
  | 'still'
  | 'on_foot'
  | 'walking'
  | 'running'
  | 'in_vehicle'
  | 'on_bicycle'
  | 'unknown'
  | 'moving';
export type LocationLogEntryLocationActivity = {
  confidence: number;
  type: LocationLogEntryLocationActivityTypeEnum;
};
export type LocationLogEntryLocationCoords = {
  longitude: number;
  latitude: number;
  /** Location accuracy in meters. */
  accuracy: number;
  /** Speed in meters / second. Only present when location came from GPS. -1 otherwise. */
  speed: number;
  /** Speed accuracy in meters / second. Only present when location came from GPS. -1 otherwise. */
  speed_accuracy: number;
  /** Heading in degrees. Only present when location came from GPS. -1 otherwise. */
  heading: number;
  /** Heading accuracy in degrees. Only present when location came from GPS. -1 otherwise. */
  heading_accuracy: number;
  /** [iOS] Altitude above sea-level in meters. [Android] The altitude in meters above the WGS84 reference ellipsoid. */
  altitude: number;
  /** Altitude accuracy in meters, If this location does not have altitude_accuracy, then -1. */
  altitude_accuracy: number;
  /** The altitude of this location in meters above the WGS84 reference ellipsoid. */
  ellipsoidal_altitude: number;
  /** [iOS Only] When the env has indoor-tracking hardware, the current floor within a building. */
  floor?: number | null;
};
export type LocationLogEntryLocationExtras = {
  assignment?: string | null;
  vehicle?: string | null;
  driver?: string | null;
  trips?: string[];
};
export type LocationLogEntryLocation = {
  timestamp: string;
  uuid: string;
  /** If location was recorded while plugin is in the moving state. */
  is_moving: boolean;
  /** Distance traveled in meters. */
  odometer: number;
  /** Event responsible for generating this location. */
  event?: EventEnum | BlankEnum;
  battery: LocationLogEntryLocationBattery;
  activity: LocationLogEntryLocationActivity;
  coords: LocationLogEntryLocationCoords;
  extras: LocationLogEntryLocationExtras;
};
export type LocationLogEntryWrite = {
  location: LocationLogEntryLocation;
};
export type LocationsLogCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type LocationsLogCreateLocationNonFieldErrorsErrorComponent = {
  attr: 'location.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationTimestampErrorComponent = {
  attr: 'location.timestamp';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationUuidErrorComponent = {
  attr: 'location.uuid';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationIsMovingErrorComponent = {
  attr: 'location.is_moving';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationOdometerErrorComponent = {
  attr: 'location.odometer';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationEventErrorComponent = {
  attr: 'location.event';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type LocationsLogCreateLocationBatteryNonFieldErrorsErrorComponent = {
  attr: 'location.battery.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationBatteryIsChargingErrorComponent = {
  attr: 'location.battery.is_charging';
  code: 'invalid';
  detail: string;
};
export type LocationsLogCreateLocationBatteryLevelErrorComponent = {
  attr: 'location.battery.level';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type LocationsLogCreateLocationActivityNonFieldErrorsErrorComponent = {
  attr: 'location.activity.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationActivityConfidenceErrorComponent = {
  attr: 'location.activity.confidence';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type LocationsLogCreateLocationActivityTypeErrorComponent = {
  attr: 'location.activity.type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsNonFieldErrorsErrorComponent = {
  attr: 'location.coords.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsLongitudeErrorComponent = {
  attr: 'location.coords.longitude';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsLatitudeErrorComponent = {
  attr: 'location.coords.latitude';
  code:
    | 'invalid'
    | 'max_string_length'
    | 'max_value'
    | 'min_value'
    | 'null'
    | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsAccuracyErrorComponent = {
  attr: 'location.coords.accuracy';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsSpeedErrorComponent = {
  attr: 'location.coords.speed';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsSpeedAccuracyErrorComponent = {
  attr: 'location.coords.speed_accuracy';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsHeadingErrorComponent = {
  attr: 'location.coords.heading';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsHeadingAccuracyErrorComponent = {
  attr: 'location.coords.heading_accuracy';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsAltitudeErrorComponent = {
  attr: 'location.coords.altitude';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsAltitudeAccuracyErrorComponent = {
  attr: 'location.coords.altitude_accuracy';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationCoordsEllipsoidalAltitudeErrorComponent =
  {
    attr: 'location.coords.ellipsoidal_altitude';
    code: 'invalid' | 'max_string_length' | 'null' | 'required';
    detail: string;
  };
export type LocationsLogCreateLocationCoordsFloorErrorComponent = {
  attr: 'location.coords.floor';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type LocationsLogCreateLocationExtrasNonFieldErrorsErrorComponent = {
  attr: 'location.extras.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateLocationExtrasAssignmentErrorComponent = {
  attr: 'location.extras.assignment';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type LocationsLogCreateLocationExtrasVehicleErrorComponent = {
  attr: 'location.extras.vehicle';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type LocationsLogCreateLocationExtrasDriverErrorComponent = {
  attr: 'location.extras.driver';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type LocationsLogCreateLocationExtrasTripsErrorComponent = {
  attr: 'location.extras.trips';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type LocationsLogCreateLocationExtrasTripsIndexErrorComponent = {
  attr: 'location.extras.trips.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type LocationsLogCreateError =
  | ({
      attr: 'non_field_errors';
    } & LocationsLogCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'location.non_field_errors';
    } & LocationsLogCreateLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'location.timestamp';
    } & LocationsLogCreateLocationTimestampErrorComponent)
  | ({
      attr: 'location.uuid';
    } & LocationsLogCreateLocationUuidErrorComponent)
  | ({
      attr: 'location.is_moving';
    } & LocationsLogCreateLocationIsMovingErrorComponent)
  | ({
      attr: 'location.odometer';
    } & LocationsLogCreateLocationOdometerErrorComponent)
  | ({
      attr: 'location.event';
    } & LocationsLogCreateLocationEventErrorComponent)
  | ({
      attr: 'location.battery.non_field_errors';
    } & LocationsLogCreateLocationBatteryNonFieldErrorsErrorComponent)
  | ({
      attr: 'location.battery.is_charging';
    } & LocationsLogCreateLocationBatteryIsChargingErrorComponent)
  | ({
      attr: 'location.battery.level';
    } & LocationsLogCreateLocationBatteryLevelErrorComponent)
  | ({
      attr: 'location.activity.non_field_errors';
    } & LocationsLogCreateLocationActivityNonFieldErrorsErrorComponent)
  | ({
      attr: 'location.activity.confidence';
    } & LocationsLogCreateLocationActivityConfidenceErrorComponent)
  | ({
      attr: 'location.activity.type';
    } & LocationsLogCreateLocationActivityTypeErrorComponent)
  | ({
      attr: 'location.coords.non_field_errors';
    } & LocationsLogCreateLocationCoordsNonFieldErrorsErrorComponent)
  | ({
      attr: 'location.coords.longitude';
    } & LocationsLogCreateLocationCoordsLongitudeErrorComponent)
  | ({
      attr: 'location.coords.latitude';
    } & LocationsLogCreateLocationCoordsLatitudeErrorComponent)
  | ({
      attr: 'location.coords.accuracy';
    } & LocationsLogCreateLocationCoordsAccuracyErrorComponent)
  | ({
      attr: 'location.coords.speed';
    } & LocationsLogCreateLocationCoordsSpeedErrorComponent)
  | ({
      attr: 'location.coords.speed_accuracy';
    } & LocationsLogCreateLocationCoordsSpeedAccuracyErrorComponent)
  | ({
      attr: 'location.coords.heading';
    } & LocationsLogCreateLocationCoordsHeadingErrorComponent)
  | ({
      attr: 'location.coords.heading_accuracy';
    } & LocationsLogCreateLocationCoordsHeadingAccuracyErrorComponent)
  | ({
      attr: 'location.coords.altitude';
    } & LocationsLogCreateLocationCoordsAltitudeErrorComponent)
  | ({
      attr: 'location.coords.altitude_accuracy';
    } & LocationsLogCreateLocationCoordsAltitudeAccuracyErrorComponent)
  | ({
      attr: 'location.coords.ellipsoidal_altitude';
    } & LocationsLogCreateLocationCoordsEllipsoidalAltitudeErrorComponent)
  | ({
      attr: 'location.coords.floor';
    } & LocationsLogCreateLocationCoordsFloorErrorComponent)
  | ({
      attr: 'location.extras.non_field_errors';
    } & LocationsLogCreateLocationExtrasNonFieldErrorsErrorComponent)
  | ({
      attr: 'location.extras.assignment';
    } & LocationsLogCreateLocationExtrasAssignmentErrorComponent)
  | ({
      attr: 'location.extras.vehicle';
    } & LocationsLogCreateLocationExtrasVehicleErrorComponent)
  | ({
      attr: 'location.extras.driver';
    } & LocationsLogCreateLocationExtrasDriverErrorComponent)
  | ({
      attr: 'location.extras.trips';
    } & LocationsLogCreateLocationExtrasTripsErrorComponent)
  | ({
      attr: 'location.extras.trips.INDEX';
    } & LocationsLogCreateLocationExtrasTripsIndexErrorComponent);
export type LocationsLogCreateValidationError = {
  type: ValidationErrorEnum;
  errors: LocationsLogCreateError[];
};
export type LocationsLogCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & LocationsLogCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MunicipalityList = {
  municipality: string[];
};
export type LocationsMunicipalitiesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengerAddress = {};
export type PassengerAddressRead = {
  id: string;
  organization_id: string;
  passenger: string;
  /** The name of this address in relation to the passenger, ex. 'Work' or 'Home' */
  name: string;
  address: AddressRead;
  /** If this address should be used on insurance claims (or CC processing) */
  is_billing_address: boolean;
  /** If this address is the patient's primary (likely home) address */
  is_primary_address: boolean;
  /** Additional details about this mapping; ex., what loading zone the passenger prefers */
  address_notes: string;
  /** Address details provided from trip information */
  address_details: string;
  /** Last time this address was used in a trip */
  last_used_at: string | null;
  /** The expected load time for this specific trip, provided by the customer */
  load_time_seconds: number | null;
  /** The expected unload time for this specific trip, provided by the customer */
  unload_time_seconds: number | null;
  created_at: string;
  updated_at: string;
};
export type PaginatedPassengerAddressList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PassengerAddress[];
};
export type PaginatedPassengerAddressListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PassengerAddressRead[];
};
export type LocationsPassengerAddressesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type LocationsPassengerAddressesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type LocationsPassengerAddressesCreateAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type LocationsPassengerAddressesCreateAddressLocationPlaceIdErrorComponent =
  {
    attr: 'address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type LocationsPassengerAddressesCreateAddressLabelErrorComponent = {
  attr: 'address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type LocationsPassengerAddressesCreateAddressLabel2ErrorComponent = {
  attr: 'address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type LocationsPassengerAddressesCreateAddressAddressNotesErrorComponent =
  {
    attr: 'address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type LocationsPassengerAddressesCreateAddressAddressTypeErrorComponent =
  {
    attr: 'address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type LocationsPassengerAddressesCreateError =
  | ({
      attr: 'non_field_errors';
    } & LocationsPassengerAddressesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'address.location.non_field_errors';
    } & LocationsPassengerAddressesCreateAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'address.location.place_id';
    } & LocationsPassengerAddressesCreateAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'address.label';
    } & LocationsPassengerAddressesCreateAddressLabelErrorComponent)
  | ({
      attr: 'address.label2';
    } & LocationsPassengerAddressesCreateAddressLabel2ErrorComponent)
  | ({
      attr: 'address.address_notes';
    } & LocationsPassengerAddressesCreateAddressAddressNotesErrorComponent)
  | ({
      attr: 'address.address_type';
    } & LocationsPassengerAddressesCreateAddressAddressTypeErrorComponent);
export type LocationsPassengerAddressesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: LocationsPassengerAddressesCreateError[];
};
export type LocationsPassengerAddressesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & LocationsPassengerAddressesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type LocationsPassengerAddressesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type LocationsPassengerAddressesUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type LocationsPassengerAddressesUpdateAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type LocationsPassengerAddressesUpdateAddressLocationPlaceIdErrorComponent =
  {
    attr: 'address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type LocationsPassengerAddressesUpdateAddressLabelErrorComponent = {
  attr: 'address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type LocationsPassengerAddressesUpdateAddressLabel2ErrorComponent = {
  attr: 'address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type LocationsPassengerAddressesUpdateAddressAddressNotesErrorComponent =
  {
    attr: 'address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type LocationsPassengerAddressesUpdateAddressAddressTypeErrorComponent =
  {
    attr: 'address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type LocationsPassengerAddressesUpdateError =
  | ({
      attr: 'non_field_errors';
    } & LocationsPassengerAddressesUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'address.location.non_field_errors';
    } & LocationsPassengerAddressesUpdateAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'address.location.place_id';
    } & LocationsPassengerAddressesUpdateAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'address.label';
    } & LocationsPassengerAddressesUpdateAddressLabelErrorComponent)
  | ({
      attr: 'address.label2';
    } & LocationsPassengerAddressesUpdateAddressLabel2ErrorComponent)
  | ({
      attr: 'address.address_notes';
    } & LocationsPassengerAddressesUpdateAddressAddressNotesErrorComponent)
  | ({
      attr: 'address.address_type';
    } & LocationsPassengerAddressesUpdateAddressAddressTypeErrorComponent);
export type LocationsPassengerAddressesUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: LocationsPassengerAddressesUpdateError[];
};
export type LocationsPassengerAddressesUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & LocationsPassengerAddressesUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type LocationsPassengerAddressesPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateNameErrorComponent = {
  attr: 'name';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type LocationsPassengerAddressesPartialUpdateAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateAddressLocationPlaceIdErrorComponent =
  {
    attr: 'address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateAddressLabelErrorComponent =
  {
    attr: 'address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateAddressLabel2ErrorComponent =
  {
    attr: 'address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateAddressAddressNotesErrorComponent =
  {
    attr: 'address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateAddressAddressTypeErrorComponent =
  {
    attr: 'address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateIsBillingAddressErrorComponent =
  {
    attr: 'is_billing_address';
    code: 'invalid' | 'null';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateIsPrimaryAddressErrorComponent =
  {
    attr: 'is_primary_address';
    code: 'invalid' | 'null';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateAddressNotesErrorComponent =
  {
    attr: 'address_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateAddressDetailsErrorComponent =
  {
    attr: 'address_details';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateLoadTimeSecondsErrorComponent =
  {
    attr: 'load_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateUnloadTimeSecondsErrorComponent =
  {
    attr: 'unload_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type LocationsPassengerAddressesPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & LocationsPassengerAddressesPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & LocationsPassengerAddressesPartialUpdateNameErrorComponent)
  | ({
      attr: 'address.location.non_field_errors';
    } & LocationsPassengerAddressesPartialUpdateAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'address.location.place_id';
    } & LocationsPassengerAddressesPartialUpdateAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'address.label';
    } & LocationsPassengerAddressesPartialUpdateAddressLabelErrorComponent)
  | ({
      attr: 'address.label2';
    } & LocationsPassengerAddressesPartialUpdateAddressLabel2ErrorComponent)
  | ({
      attr: 'address.address_notes';
    } & LocationsPassengerAddressesPartialUpdateAddressAddressNotesErrorComponent)
  | ({
      attr: 'address.address_type';
    } & LocationsPassengerAddressesPartialUpdateAddressAddressTypeErrorComponent)
  | ({
      attr: 'is_billing_address';
    } & LocationsPassengerAddressesPartialUpdateIsBillingAddressErrorComponent)
  | ({
      attr: 'is_primary_address';
    } & LocationsPassengerAddressesPartialUpdateIsPrimaryAddressErrorComponent)
  | ({
      attr: 'address_notes';
    } & LocationsPassengerAddressesPartialUpdateAddressNotesErrorComponent)
  | ({
      attr: 'address_details';
    } & LocationsPassengerAddressesPartialUpdateAddressDetailsErrorComponent)
  | ({
      attr: 'load_time_seconds';
    } & LocationsPassengerAddressesPartialUpdateLoadTimeSecondsErrorComponent)
  | ({
      attr: 'unload_time_seconds';
    } & LocationsPassengerAddressesPartialUpdateUnloadTimeSecondsErrorComponent);
export type LocationsPassengerAddressesPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: LocationsPassengerAddressesPartialUpdateError[];
};
export type LocationsPassengerAddressesPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & LocationsPassengerAddressesPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedPassengerAddressRequest = {
  /** The name of this address in relation to the passenger, ex. 'Work' or 'Home' */
  name?: string;
  /** If this address should be used on insurance claims (or CC processing) */
  is_billing_address?: boolean;
  /** If this address is the patient's primary (likely home) address */
  is_primary_address?: boolean;
  /** Additional details about this mapping; ex., what loading zone the passenger prefers */
  address_notes?: string;
  /** Address details provided from trip information */
  address_details?: string;
  /** The expected load time for this specific trip, provided by the customer */
  load_time_seconds?: number | null;
  /** The expected unload time for this specific trip, provided by the customer */
  unload_time_seconds?: number | null;
};
export type PatchedPassengerAddressRequestRead = {
  id?: string;
  organization_id?: string;
  passenger?: string;
  /** The name of this address in relation to the passenger, ex. 'Work' or 'Home' */
  name?: string;
  address?: AddressRead;
  /** If this address should be used on insurance claims (or CC processing) */
  is_billing_address?: boolean;
  /** If this address is the patient's primary (likely home) address */
  is_primary_address?: boolean;
  /** Additional details about this mapping; ex., what loading zone the passenger prefers */
  address_notes?: string;
  /** Address details provided from trip information */
  address_details?: string;
  /** Last time this address was used in a trip */
  last_used_at?: string | null;
  /** The expected load time for this specific trip, provided by the customer */
  load_time_seconds?: number | null;
  /** The expected unload time for this specific trip, provided by the customer */
  unload_time_seconds?: number | null;
  created_at?: string;
  updated_at?: string;
};
export type LocationsPassengerAddressesDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type ZipCode = {
  zipcode: string;
};
export type PaginatedZipCodeList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ZipCode[];
};
export type LocationsZipcodesListZipcodeErrorComponent = {
  attr: 'zipcode';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type LocationsZipcodesListError = {
  attr: 'zipcode';
} & LocationsZipcodesListZipcodeErrorComponent;
export type LocationsZipcodesListValidationError = {
  type: ValidationErrorEnum;
  errors: LocationsZipcodesListError[];
};
export type LocationsZipcodesListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & LocationsZipcodesListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type RoleEnum =
  | 'owner'
  | 'admin'
  | 'dispatcher'
  | 'associate'
  | 'restricted support'
  | 'facility admin'
  | 'facility user'
  | 'bambi'
  | 'integration';
export type Membership = {
  role?: RoleEnum;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
};
export type MembershipRead = {
  id: string;
  organization_id: string;
  role?: RoleEnum;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  status: string;
  active_payers: any[] | null;
  shared_payer_count: number | null;
  has_driver_profile: boolean | null;
  has_attendant_profile: boolean | null;
  deleted_at: string | null;
};
export type MembershipWrite = {
  role?: RoleEnum;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  payer_ids?: string[] | null;
};
export type PaginatedMembershipList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Membership[];
};
export type PaginatedMembershipListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MembershipRead[];
};
export type PaginatedMembershipListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MembershipWrite[];
};
export type MembersListRoleErrorComponent = {
  attr: 'role';
  code: 'invalid_choice';
  detail: string;
};
export type MembersListError = {
  attr: 'role';
} & MembersListRoleErrorComponent;
export type MembersListValidationError = {
  type: ValidationErrorEnum;
  errors: MembersListError[];
};
export type MembersListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MembersListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MembersCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type MembersCreateRoleErrorComponent = {
  attr: 'role';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MembersCreateFirstNameErrorComponent = {
  attr: 'first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersCreateLastNameErrorComponent = {
  attr: 'last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersCreateEmailErrorComponent = {
  attr: 'email';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersCreatePhoneNumberErrorComponent = {
  attr: 'phone_number';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersCreatePayerIdsErrorComponent = {
  attr: 'payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type MembersCreatePayerIdsIndexErrorComponent = {
  attr: 'payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type MembersCreateError =
  | ({
      attr: 'non_field_errors';
    } & MembersCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'role';
    } & MembersCreateRoleErrorComponent)
  | ({
      attr: 'first_name';
    } & MembersCreateFirstNameErrorComponent)
  | ({
      attr: 'last_name';
    } & MembersCreateLastNameErrorComponent)
  | ({
      attr: 'email';
    } & MembersCreateEmailErrorComponent)
  | ({
      attr: 'phone_number';
    } & MembersCreatePhoneNumberErrorComponent)
  | ({
      attr: 'payer_ids';
    } & MembersCreatePayerIdsErrorComponent)
  | ({
      attr: 'payer_ids.INDEX';
    } & MembersCreatePayerIdsIndexErrorComponent);
export type MembersCreateValidationError = {
  type: ValidationErrorEnum;
  errors: MembersCreateError[];
};
export type MembersCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MembersCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MembersRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type MembersPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type MembersPartialUpdateRoleErrorComponent = {
  attr: 'role';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MembersPartialUpdateFirstNameErrorComponent = {
  attr: 'first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersPartialUpdateLastNameErrorComponent = {
  attr: 'last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersPartialUpdateEmailErrorComponent = {
  attr: 'email';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersPartialUpdatePhoneNumberErrorComponent = {
  attr: 'phone_number';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersPartialUpdatePayerIdsErrorComponent = {
  attr: 'payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type MembersPartialUpdatePayerIdsIndexErrorComponent = {
  attr: 'payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type MembersPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & MembersPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'role';
    } & MembersPartialUpdateRoleErrorComponent)
  | ({
      attr: 'first_name';
    } & MembersPartialUpdateFirstNameErrorComponent)
  | ({
      attr: 'last_name';
    } & MembersPartialUpdateLastNameErrorComponent)
  | ({
      attr: 'email';
    } & MembersPartialUpdateEmailErrorComponent)
  | ({
      attr: 'phone_number';
    } & MembersPartialUpdatePhoneNumberErrorComponent)
  | ({
      attr: 'payer_ids';
    } & MembersPartialUpdatePayerIdsErrorComponent)
  | ({
      attr: 'payer_ids.INDEX';
    } & MembersPartialUpdatePayerIdsIndexErrorComponent);
export type MembersPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: MembersPartialUpdateError[];
};
export type MembersPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MembersPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedMembership = {
  role?: RoleEnum;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
};
export type PatchedMembershipRead = {
  id?: string;
  organization_id?: string;
  role?: RoleEnum;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  status?: string;
  active_payers?: any[] | null;
  shared_payer_count?: number | null;
  has_driver_profile?: boolean | null;
  has_attendant_profile?: boolean | null;
  deleted_at?: string | null;
};
export type PatchedMembershipWrite = {
  role?: RoleEnum;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  payer_ids?: string[] | null;
};
export type MembersDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type MembersUndeleteCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type MembersUndeleteCreateRoleErrorComponent = {
  attr: 'role';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MembersUndeleteCreateFirstNameErrorComponent = {
  attr: 'first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersUndeleteCreateLastNameErrorComponent = {
  attr: 'last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersUndeleteCreateEmailErrorComponent = {
  attr: 'email';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersUndeleteCreatePhoneNumberErrorComponent = {
  attr: 'phone_number';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersUndeleteCreatePayerIdsErrorComponent = {
  attr: 'payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type MembersUndeleteCreatePayerIdsIndexErrorComponent = {
  attr: 'payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type MembersUndeleteCreateError =
  | ({
      attr: 'non_field_errors';
    } & MembersUndeleteCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'role';
    } & MembersUndeleteCreateRoleErrorComponent)
  | ({
      attr: 'first_name';
    } & MembersUndeleteCreateFirstNameErrorComponent)
  | ({
      attr: 'last_name';
    } & MembersUndeleteCreateLastNameErrorComponent)
  | ({
      attr: 'email';
    } & MembersUndeleteCreateEmailErrorComponent)
  | ({
      attr: 'phone_number';
    } & MembersUndeleteCreatePhoneNumberErrorComponent)
  | ({
      attr: 'payer_ids';
    } & MembersUndeleteCreatePayerIdsErrorComponent)
  | ({
      attr: 'payer_ids.INDEX';
    } & MembersUndeleteCreatePayerIdsIndexErrorComponent);
export type MembersUndeleteCreateValidationError = {
  type: ValidationErrorEnum;
  errors: MembersUndeleteCreateError[];
};
export type MembersUndeleteCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MembersUndeleteCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MembersUpdateEmailCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type MembersUpdateEmailCreateEmailErrorComponent = {
  attr: 'email';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MembersUpdateEmailCreateError =
  | ({
      attr: 'non_field_errors';
    } & MembersUpdateEmailCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'email';
    } & MembersUpdateEmailCreateEmailErrorComponent);
export type MembersUpdateEmailCreateValidationError = {
  type: ValidationErrorEnum;
  errors: MembersUpdateEmailCreateError[];
};
export type MembersUpdateEmailCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MembersUpdateEmailCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type UpdateEmail = {
  email: string;
};
export type DirectionEnum =
  | 'inbound'
  | 'outbound-api'
  | 'outbound-call'
  | 'outbound-reply';
export type MessageStatusEnum =
  | 'queued'
  | 'sending'
  | 'sent'
  | 'failed'
  | 'delivered'
  | 'undelivered'
  | 'receiving'
  | 'received'
  | 'accepted'
  | 'scheduled'
  | 'read'
  | 'partially_delivered'
  | 'canceled';
export type Message = {
  id?: string;
  deleted_at?: string | null;
  body: string;
  direction?: DirectionEnum;
  status?: MessageStatusEnum;
  from_number: string;
  to: string;
  uri?: string;
  account_sid: string;
  messaging_service_sid?: string;
  num_media?: number;
  num_segments?: number;
  price?: string;
  price_unit?: string;
  error_message?: string;
  error_code?: number | null;
  sid?: string;
  date_sent?: string | null;
  date_created?: string | null;
  date_updated?: string | null;
  api_version?: string;
  organization: string;
};
export type MessageRead = {
  id?: string;
  deleted_at?: string | null;
  created_at: string;
  updated_at: string;
  body: string;
  direction?: DirectionEnum;
  status?: MessageStatusEnum;
  from_number: string;
  to: string;
  uri?: string;
  account_sid: string;
  messaging_service_sid?: string;
  num_media?: number;
  num_segments?: number;
  price?: string;
  price_unit?: string;
  error_message?: string;
  error_code?: number | null;
  sid?: string;
  date_sent?: string | null;
  date_created?: string | null;
  date_updated?: string | null;
  api_version?: string;
  organization: string;
};
export type PaginatedMessageList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Message[];
};
export type PaginatedMessageListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MessageRead[];
};
export type MessagesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type MessagesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type MessagesCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type MessagesCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesCreateBodyErrorComponent = {
  attr: 'body';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreateDirectionErrorComponent = {
  attr: 'direction';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MessagesCreateStatusErrorComponent = {
  attr: 'status';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MessagesCreateFromNumberErrorComponent = {
  attr: 'from_number';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreateToErrorComponent = {
  attr: 'to';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreateUriErrorComponent = {
  attr: 'uri';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreateAccountSidErrorComponent = {
  attr: 'account_sid';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreateMessagingServiceSidErrorComponent = {
  attr: 'messaging_service_sid';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreateNumMediaErrorComponent = {
  attr: 'num_media';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type MessagesCreateNumSegmentsErrorComponent = {
  attr: 'num_segments';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type MessagesCreatePriceErrorComponent = {
  attr: 'price';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreatePriceUnitErrorComponent = {
  attr: 'price_unit';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreateErrorMessageErrorComponent = {
  attr: 'error_message';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreateErrorCodeErrorComponent = {
  attr: 'error_code';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type MessagesCreateSidErrorComponent = {
  attr: 'sid';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreateDateSentErrorComponent = {
  attr: 'date_sent';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesCreateDateCreatedErrorComponent = {
  attr: 'date_created';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesCreateDateUpdatedErrorComponent = {
  attr: 'date_updated';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesCreateApiVersionErrorComponent = {
  attr: 'api_version';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesCreateOrganizationErrorComponent = {
  attr: 'organization';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type MessagesCreateError =
  | ({
      attr: 'non_field_errors';
    } & MessagesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & MessagesCreateIdErrorComponent)
  | ({
      attr: 'deleted_at';
    } & MessagesCreateDeletedAtErrorComponent)
  | ({
      attr: 'body';
    } & MessagesCreateBodyErrorComponent)
  | ({
      attr: 'direction';
    } & MessagesCreateDirectionErrorComponent)
  | ({
      attr: 'status';
    } & MessagesCreateStatusErrorComponent)
  | ({
      attr: 'from_number';
    } & MessagesCreateFromNumberErrorComponent)
  | ({
      attr: 'to';
    } & MessagesCreateToErrorComponent)
  | ({
      attr: 'uri';
    } & MessagesCreateUriErrorComponent)
  | ({
      attr: 'account_sid';
    } & MessagesCreateAccountSidErrorComponent)
  | ({
      attr: 'messaging_service_sid';
    } & MessagesCreateMessagingServiceSidErrorComponent)
  | ({
      attr: 'num_media';
    } & MessagesCreateNumMediaErrorComponent)
  | ({
      attr: 'num_segments';
    } & MessagesCreateNumSegmentsErrorComponent)
  | ({
      attr: 'price';
    } & MessagesCreatePriceErrorComponent)
  | ({
      attr: 'price_unit';
    } & MessagesCreatePriceUnitErrorComponent)
  | ({
      attr: 'error_message';
    } & MessagesCreateErrorMessageErrorComponent)
  | ({
      attr: 'error_code';
    } & MessagesCreateErrorCodeErrorComponent)
  | ({
      attr: 'sid';
    } & MessagesCreateSidErrorComponent)
  | ({
      attr: 'date_sent';
    } & MessagesCreateDateSentErrorComponent)
  | ({
      attr: 'date_created';
    } & MessagesCreateDateCreatedErrorComponent)
  | ({
      attr: 'date_updated';
    } & MessagesCreateDateUpdatedErrorComponent)
  | ({
      attr: 'api_version';
    } & MessagesCreateApiVersionErrorComponent)
  | ({
      attr: 'organization';
    } & MessagesCreateOrganizationErrorComponent);
export type MessagesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: MessagesCreateError[];
};
export type MessagesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MessagesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MessagesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripMessage = {
  message: Message;
};
export type TripMessageTrip = {
  passenger_full_name: string;
  passenger_phone_number: string;
  pickup_time: string;
};
export type TripMessageTripRead = {
  id: string;
  organization: string;
  /** Current status of this trip */
  status: OverrideStatusEnum;
  passenger_full_name: string;
  passenger_phone_number: string;
  pickup_time: string;
};
export type MessageTypeEnum =
  | 'reminder-day-before'
  | 'reminder-near-pickup'
  | 'reminder-before-pickup-time'
  | 'post-trip'
  | 'trip-acknowledgement'
  | 'public-trip-portal'
  | 'canceled'
  | 'public-trip-acknowledgement'
  | 'public-trip-accepted'
  | 'public-trip-rejected';
export type TripMessageRead = {
  id: string;
  trip: TripMessageTripRead;
  message: MessageRead;
  message_type: MessageTypeEnum;
};
export type TripMessageWrite = {
  message: Message;
  trip_id: string;
};
export type PaginatedTripMessageList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripMessage[];
};
export type PaginatedTripMessageListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripMessageRead[];
};
export type PaginatedTripMessageListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripMessageWrite[];
};
export type MessagesTripMessagesListTripIdErrorComponent = {
  attr: 'trip_id';
  code: 'invalid' | 'null_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesListError = {
  attr: 'trip_id';
} & MessagesTripMessagesListTripIdErrorComponent;
export type MessagesTripMessagesListValidationError = {
  type: ValidationErrorEnum;
  errors: MessagesTripMessagesListError[];
};
export type MessagesTripMessagesListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MessagesTripMessagesListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MessagesTripMessagesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'unique';
  detail: string;
};
export type MessagesTripMessagesCreateTripPassengerFullNameErrorComponent = {
  attr: 'trip.passenger_full_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateTripPassengerPhoneNumberErrorComponent = {
  attr: 'trip.passenger_phone_number';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateTripPickupTimeErrorComponent = {
  attr: 'trip.pickup_time';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type MessagesTripMessagesCreateMessageNonFieldErrorsErrorComponent = {
  attr: 'message.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type MessagesTripMessagesCreateMessageIdErrorComponent = {
  attr: 'message.id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type MessagesTripMessagesCreateMessageDeletedAtErrorComponent = {
  attr: 'message.deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesTripMessagesCreateMessageBodyErrorComponent = {
  attr: 'message.body';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateMessageDirectionErrorComponent = {
  attr: 'message.direction';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MessagesTripMessagesCreateMessageStatusErrorComponent = {
  attr: 'message.status';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MessagesTripMessagesCreateMessageFromNumberErrorComponent = {
  attr: 'message.from_number';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateMessageToErrorComponent = {
  attr: 'message.to';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateMessageUriErrorComponent = {
  attr: 'message.uri';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateMessageAccountSidErrorComponent = {
  attr: 'message.account_sid';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateMessageMessagingServiceSidErrorComponent =
  {
    attr: 'message.messaging_service_sid';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type MessagesTripMessagesCreateMessageNumMediaErrorComponent = {
  attr: 'message.num_media';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type MessagesTripMessagesCreateMessageNumSegmentsErrorComponent = {
  attr: 'message.num_segments';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type MessagesTripMessagesCreateMessagePriceErrorComponent = {
  attr: 'message.price';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateMessagePriceUnitErrorComponent = {
  attr: 'message.price_unit';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateMessageErrorMessageErrorComponent = {
  attr: 'message.error_message';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateMessageErrorCodeErrorComponent = {
  attr: 'message.error_code';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type MessagesTripMessagesCreateMessageSidErrorComponent = {
  attr: 'message.sid';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateMessageDateSentErrorComponent = {
  attr: 'message.date_sent';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesTripMessagesCreateMessageDateCreatedErrorComponent = {
  attr: 'message.date_created';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesTripMessagesCreateMessageDateUpdatedErrorComponent = {
  attr: 'message.date_updated';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesTripMessagesCreateMessageApiVersionErrorComponent = {
  attr: 'message.api_version';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesTripMessagesCreateMessageOrganizationErrorComponent = {
  attr: 'message.organization';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type MessagesTripMessagesCreateTripIdErrorComponent = {
  attr: 'trip_id';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type MessagesTripMessagesCreateError =
  | ({
      attr: 'non_field_errors';
    } & MessagesTripMessagesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip.passenger_full_name';
    } & MessagesTripMessagesCreateTripPassengerFullNameErrorComponent)
  | ({
      attr: 'trip.passenger_phone_number';
    } & MessagesTripMessagesCreateTripPassengerPhoneNumberErrorComponent)
  | ({
      attr: 'trip.pickup_time';
    } & MessagesTripMessagesCreateTripPickupTimeErrorComponent)
  | ({
      attr: 'message.non_field_errors';
    } & MessagesTripMessagesCreateMessageNonFieldErrorsErrorComponent)
  | ({
      attr: 'message.id';
    } & MessagesTripMessagesCreateMessageIdErrorComponent)
  | ({
      attr: 'message.deleted_at';
    } & MessagesTripMessagesCreateMessageDeletedAtErrorComponent)
  | ({
      attr: 'message.body';
    } & MessagesTripMessagesCreateMessageBodyErrorComponent)
  | ({
      attr: 'message.direction';
    } & MessagesTripMessagesCreateMessageDirectionErrorComponent)
  | ({
      attr: 'message.status';
    } & MessagesTripMessagesCreateMessageStatusErrorComponent)
  | ({
      attr: 'message.from_number';
    } & MessagesTripMessagesCreateMessageFromNumberErrorComponent)
  | ({
      attr: 'message.to';
    } & MessagesTripMessagesCreateMessageToErrorComponent)
  | ({
      attr: 'message.uri';
    } & MessagesTripMessagesCreateMessageUriErrorComponent)
  | ({
      attr: 'message.account_sid';
    } & MessagesTripMessagesCreateMessageAccountSidErrorComponent)
  | ({
      attr: 'message.messaging_service_sid';
    } & MessagesTripMessagesCreateMessageMessagingServiceSidErrorComponent)
  | ({
      attr: 'message.num_media';
    } & MessagesTripMessagesCreateMessageNumMediaErrorComponent)
  | ({
      attr: 'message.num_segments';
    } & MessagesTripMessagesCreateMessageNumSegmentsErrorComponent)
  | ({
      attr: 'message.price';
    } & MessagesTripMessagesCreateMessagePriceErrorComponent)
  | ({
      attr: 'message.price_unit';
    } & MessagesTripMessagesCreateMessagePriceUnitErrorComponent)
  | ({
      attr: 'message.error_message';
    } & MessagesTripMessagesCreateMessageErrorMessageErrorComponent)
  | ({
      attr: 'message.error_code';
    } & MessagesTripMessagesCreateMessageErrorCodeErrorComponent)
  | ({
      attr: 'message.sid';
    } & MessagesTripMessagesCreateMessageSidErrorComponent)
  | ({
      attr: 'message.date_sent';
    } & MessagesTripMessagesCreateMessageDateSentErrorComponent)
  | ({
      attr: 'message.date_created';
    } & MessagesTripMessagesCreateMessageDateCreatedErrorComponent)
  | ({
      attr: 'message.date_updated';
    } & MessagesTripMessagesCreateMessageDateUpdatedErrorComponent)
  | ({
      attr: 'message.api_version';
    } & MessagesTripMessagesCreateMessageApiVersionErrorComponent)
  | ({
      attr: 'message.organization';
    } & MessagesTripMessagesCreateMessageOrganizationErrorComponent)
  | ({
      attr: 'trip_id';
    } & MessagesTripMessagesCreateTripIdErrorComponent);
export type MessagesTripMessagesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: MessagesTripMessagesCreateError[];
};
export type MessagesTripMessagesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MessagesTripMessagesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MessagesTripMessagesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type MessagesWebHookMessageUpdateCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null' | 'unique';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateBodyErrorComponent = {
  attr: 'body';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateDirectionErrorComponent = {
  attr: 'direction';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateStatusErrorComponent = {
  attr: 'status';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateFromNumberErrorComponent = {
  attr: 'from_number';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateToErrorComponent = {
  attr: 'to';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateUriErrorComponent = {
  attr: 'uri';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateAccountSidErrorComponent = {
  attr: 'account_sid';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateMessagingServiceSidErrorComponent =
  {
    attr: 'messaging_service_sid';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type MessagesWebHookMessageUpdateCreateNumMediaErrorComponent = {
  attr: 'num_media';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateNumSegmentsErrorComponent = {
  attr: 'num_segments';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreatePriceErrorComponent = {
  attr: 'price';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreatePriceUnitErrorComponent = {
  attr: 'price_unit';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateErrorMessageErrorComponent = {
  attr: 'error_message';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateErrorCodeErrorComponent = {
  attr: 'error_code';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateSidErrorComponent = {
  attr: 'sid';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateDateSentErrorComponent = {
  attr: 'date_sent';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateDateCreatedErrorComponent = {
  attr: 'date_created';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateDateUpdatedErrorComponent = {
  attr: 'date_updated';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateApiVersionErrorComponent = {
  attr: 'api_version';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateOrganizationErrorComponent = {
  attr: 'organization';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type MessagesWebHookMessageUpdateCreateError =
  | ({
      attr: 'non_field_errors';
    } & MessagesWebHookMessageUpdateCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & MessagesWebHookMessageUpdateCreateIdErrorComponent)
  | ({
      attr: 'deleted_at';
    } & MessagesWebHookMessageUpdateCreateDeletedAtErrorComponent)
  | ({
      attr: 'body';
    } & MessagesWebHookMessageUpdateCreateBodyErrorComponent)
  | ({
      attr: 'direction';
    } & MessagesWebHookMessageUpdateCreateDirectionErrorComponent)
  | ({
      attr: 'status';
    } & MessagesWebHookMessageUpdateCreateStatusErrorComponent)
  | ({
      attr: 'from_number';
    } & MessagesWebHookMessageUpdateCreateFromNumberErrorComponent)
  | ({
      attr: 'to';
    } & MessagesWebHookMessageUpdateCreateToErrorComponent)
  | ({
      attr: 'uri';
    } & MessagesWebHookMessageUpdateCreateUriErrorComponent)
  | ({
      attr: 'account_sid';
    } & MessagesWebHookMessageUpdateCreateAccountSidErrorComponent)
  | ({
      attr: 'messaging_service_sid';
    } & MessagesWebHookMessageUpdateCreateMessagingServiceSidErrorComponent)
  | ({
      attr: 'num_media';
    } & MessagesWebHookMessageUpdateCreateNumMediaErrorComponent)
  | ({
      attr: 'num_segments';
    } & MessagesWebHookMessageUpdateCreateNumSegmentsErrorComponent)
  | ({
      attr: 'price';
    } & MessagesWebHookMessageUpdateCreatePriceErrorComponent)
  | ({
      attr: 'price_unit';
    } & MessagesWebHookMessageUpdateCreatePriceUnitErrorComponent)
  | ({
      attr: 'error_message';
    } & MessagesWebHookMessageUpdateCreateErrorMessageErrorComponent)
  | ({
      attr: 'error_code';
    } & MessagesWebHookMessageUpdateCreateErrorCodeErrorComponent)
  | ({
      attr: 'sid';
    } & MessagesWebHookMessageUpdateCreateSidErrorComponent)
  | ({
      attr: 'date_sent';
    } & MessagesWebHookMessageUpdateCreateDateSentErrorComponent)
  | ({
      attr: 'date_created';
    } & MessagesWebHookMessageUpdateCreateDateCreatedErrorComponent)
  | ({
      attr: 'date_updated';
    } & MessagesWebHookMessageUpdateCreateDateUpdatedErrorComponent)
  | ({
      attr: 'api_version';
    } & MessagesWebHookMessageUpdateCreateApiVersionErrorComponent)
  | ({
      attr: 'organization';
    } & MessagesWebHookMessageUpdateCreateOrganizationErrorComponent);
export type MessagesWebHookMessageUpdateCreateValidationError = {
  type: ValidationErrorEnum;
  errors: MessagesWebHookMessageUpdateCreateError[];
};
export type MessagesWebHookMessageUpdateCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MessagesWebHookMessageUpdateCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type MapsAppEnum = 'waze' | 'google' | 'apple' | 'here';
export type MobileAppSettings = {
  maps_app?: MapsAppEnum | BlankEnum;
  /** The ID of the endpoint for a device and mobile app on one of the supported push notification services */
  push_notification_endpoint_id?: string;
};
export type MobileAppSettingsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type MobileAppSettingsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type MobileAppSettingsPartialUpdateMapsAppErrorComponent = {
  attr: 'maps_app';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type MobileAppSettingsPartialUpdatePushNotificationEndpointIdErrorComponent =
  {
    attr: 'push_notification_endpoint_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type MobileAppSettingsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & MobileAppSettingsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'maps_app';
    } & MobileAppSettingsPartialUpdateMapsAppErrorComponent)
  | ({
      attr: 'push_notification_endpoint_id';
    } & MobileAppSettingsPartialUpdatePushNotificationEndpointIdErrorComponent);
export type MobileAppSettingsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: MobileAppSettingsPartialUpdateError[];
};
export type MobileAppSettingsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & MobileAppSettingsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedMobileAppSettings = {
  maps_app?: MapsAppEnum | BlankEnum;
  /** The ID of the endpoint for a device and mobile app on one of the supported push notification services */
  push_notification_endpoint_id?: string;
};
export type OrganizationBillingStatus = {};
export type OrganizationBillingStatusRead = {
  id: string;
  name: string;
  is_delinquent: boolean;
  /** Whether this organization is for an active customer */
  is_active_customer: boolean | null;
  stripe_subscription_payment_link: string | null;
};
export type OrganizationBillingStatusRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type OrganizationHeadquarters = {
  place_id: string;
};
export type OrganizationHeadquartersRead = {
  address: string;
  place_id: string;
  latitude: number;
  longitude: number;
  time_zone_name: string;
};
export type OrganizationSettingsTripRequiredFields = {
  passenger_phone_number?: boolean;
  passenger_weight?: boolean;
  authorization_id?: boolean;
  insurance_policy_id?: boolean;
  payer_passenger_external_id?: boolean;
  external_trip_id?: boolean;
  booked_by_name?: boolean;
  booked_by_phone_number?: boolean;
};
export type OrganizationSettings = {
  headquarters_location?: OrganizationHeadquarters;
  logo?: string | null;
  /** Billing address for the business, appears on invoices */
  billing_address?: string;
  dispatch_phone_number?: string;
  dispatch_text_number?: string;
  /** Some payer exports require this */
  tax_id?: string;
  should_avoid_toll_roads?: boolean;
  should_avoid_ferries?: boolean;
  /** The default space type when creating trips */
  default_trip_space_type?: SpaceTypeEnum | BlankEnum;
  /** The default service type when creating trips */
  default_trip_service_type?: ServiceTypeEnum | BlankEnum;
  /** Expand location details automatically on load */
  expand_trip_location_details?: boolean;
  ambulatory_load_seconds?: number;
  ambulatory_unload_seconds?: number;
  wheelchair_load_seconds?: number;
  wheelchair_unload_seconds?: number;
  wheelchair_xl_load_seconds?: number;
  wheelchair_xl_unload_seconds?: number;
  broda_chair_load_seconds?: number;
  broda_chair_unload_seconds?: number;
  geri_chair_load_seconds?: number;
  geri_chair_unload_seconds?: number;
  stretcher_load_seconds?: number;
  stretcher_unload_seconds?: number;
  /** How early a driver can arrive before a pickup time */
  pickup_default_early_seconds?: number;
  /** How late a driver can arrive after a pickup time */
  pickup_default_late_seconds?: number;
  /** How early a driver can arrive before a pickup time headed to an appointment */
  pickup_appointment_early_seconds?: number;
  /** How late a driver can arrive after a pickup time headed to an appointment */
  pickup_appointment_late_seconds?: number;
  /** How early a driver can arrive before a pickup time for a will call trip */
  pickup_will_call_early_seconds?: number;
  /** How late a driver can arrive after a pickup time for a will call trip */
  pickup_will_call_late_seconds?: number;
  /** How early before an appointment the passenger should arrive */
  appointment_early_arrival_window_seconds?: number;
  /** Start time of standard transport time (in local time) */
  standard_transport_time_start?: string | null;
  /** End time of standard transport time (in local time) */
  standard_transport_time_end?: string | null;
  requires_inspection_after_assignment_start?: boolean;
  requires_inspection_before_assignment_end?: boolean;
  requires_signature_pickup_passenger?: boolean;
  requires_signature_dropoff_passenger?: boolean;
  requires_signature_pickup_driver?: boolean;
  requires_signature_dropoff_driver?: boolean;
  /** Whether an associate is allowed to cancel their own trips */
  can_associate_cancel_trips?: boolean;
  /** Whether an associate is allowed to activate their own will call trips */
  can_associate_activate_will_call_trips?: boolean;
  /** Whether an associate is allowed to view the passenger's phone number */
  can_associate_view_passenger_phone_number?: boolean;
  /** The number of days of future assignments to show associates, excluding today */
  days_of_future_assignments_to_show?: number;
  /** The number of days of future trips to show associates, excluding today */
  days_of_future_trips_to_show?: number;
  /** The reasons for canceling a trip that an associate can select */
  associate_cancel_reasons?: CanceledReasonEnum[];
  /** The Tilled onboarding user id */
  payment_account_onboarding_user_id?: string;
  /** The lead time required for facilities to request a trip before the pickup */
  facility_trip_request_lead_time_seconds?: number;
  /** The lead time required for facilities to cancel a trip before the pickup */
  facility_trip_cancel_lead_time_seconds?: number;
  /** The minimum advance notice required for trips submitted through the public trip request form. */
  public_trip_request_lead_time_seconds?: number;
  /** Window up to the pick up time for a customer to be charged a fee for canceling */
  cancellation_fee_window_hours?: number;
  /** Whether the organization is using pricing v1 */
  is_pricing_v1_enabled?: boolean;
  /** The minimum number of upcoming trips to return in the driver app */
  minimum_upcoming_trips_returned?: number;
  /** The hex color for the header background */
  header_background_color?: string;
  /** Whether to assign the same driver for a passenger during run bambi run if they have multiple trips */
  assign_same_driver_for_passenger?: boolean;
  /** Whether to restrict pricing display based on role */
  restrict_pricing_display?: boolean;
  trip_required_fields?: OrganizationSettingsTripRequiredFields | null;
  /** Whether to enable the public trip portal */
  public_trip_portal?: boolean;
  /** Whether to include canceled trips in revenue calculations */
  include_canceled_trips_in_revenue?: boolean;
};
export type TripCancelReason = {
  /** The reason for the cancellation to be shown to the user */
  label: string;
  /** The value of the reason for dropdowns, the cancel endpoint.  */
  value?: CanceledReasonEnum;
};
export type OrganizationSettingsRead = {
  headquarters_location?: OrganizationHeadquartersRead;
  logo?: string | null;
  /** Billing address for the business, appears on invoices */
  billing_address?: string;
  dispatch_phone_number?: string;
  dispatch_text_number?: string;
  /** Some payer exports require this */
  tax_id?: string;
  should_avoid_toll_roads?: boolean;
  should_avoid_ferries?: boolean;
  /** The default space type when creating trips */
  default_trip_space_type?: SpaceTypeEnum | BlankEnum;
  /** The default service type when creating trips */
  default_trip_service_type?: ServiceTypeEnum | BlankEnum;
  /** Expand location details automatically on load */
  expand_trip_location_details?: boolean;
  ambulatory_load_seconds?: number;
  ambulatory_unload_seconds?: number;
  wheelchair_load_seconds?: number;
  wheelchair_unload_seconds?: number;
  wheelchair_xl_load_seconds?: number;
  wheelchair_xl_unload_seconds?: number;
  broda_chair_load_seconds?: number;
  broda_chair_unload_seconds?: number;
  geri_chair_load_seconds?: number;
  geri_chair_unload_seconds?: number;
  stretcher_load_seconds?: number;
  stretcher_unload_seconds?: number;
  /** How early a driver can arrive before a pickup time */
  pickup_default_early_seconds?: number;
  /** How late a driver can arrive after a pickup time */
  pickup_default_late_seconds?: number;
  /** How early a driver can arrive before a pickup time headed to an appointment */
  pickup_appointment_early_seconds?: number;
  /** How late a driver can arrive after a pickup time headed to an appointment */
  pickup_appointment_late_seconds?: number;
  /** How early a driver can arrive before a pickup time for a will call trip */
  pickup_will_call_early_seconds?: number;
  /** How late a driver can arrive after a pickup time for a will call trip */
  pickup_will_call_late_seconds?: number;
  /** How early before an appointment the passenger should arrive */
  appointment_early_arrival_window_seconds?: number;
  /** Start time of standard transport time (in local time) */
  standard_transport_time_start?: string | null;
  /** End time of standard transport time (in local time) */
  standard_transport_time_end?: string | null;
  requires_inspection_after_assignment_start?: boolean;
  requires_inspection_before_assignment_end?: boolean;
  requires_signature_pickup_passenger?: boolean;
  requires_signature_dropoff_passenger?: boolean;
  requires_signature_pickup_driver?: boolean;
  requires_signature_dropoff_driver?: boolean;
  /** Whether an associate is allowed to cancel their own trips */
  can_associate_cancel_trips?: boolean;
  /** Whether an associate is allowed to activate their own will call trips */
  can_associate_activate_will_call_trips?: boolean;
  /** Whether an associate is allowed to view the passenger's phone number */
  can_associate_view_passenger_phone_number?: boolean;
  /** The number of days of future assignments to show associates, excluding today */
  days_of_future_assignments_to_show?: number;
  /** The number of days of future trips to show associates, excluding today */
  days_of_future_trips_to_show?: number;
  /** The reasons for canceling a trip that an associate can select */
  associate_cancel_reasons?: CanceledReasonEnum[];
  /** All possible reasons for canceling a trip */
  bambi_cancel_reasons: TripCancelReason[];
  payment_account_id: string | null;
  payment_account_status: string | null;
  /** The Tilled onboarding user id */
  payment_account_onboarding_user_id?: string;
  /** The lead time required for facilities to request a trip before the pickup */
  facility_trip_request_lead_time_seconds?: number;
  /** The lead time required for facilities to cancel a trip before the pickup */
  facility_trip_cancel_lead_time_seconds?: number;
  /** The minimum advance notice required for trips submitted through the public trip request form. */
  public_trip_request_lead_time_seconds?: number;
  /** Window up to the pick up time for a customer to be charged a fee for canceling */
  cancellation_fee_window_hours?: number;
  /** Whether the organization is using pricing v1 */
  is_pricing_v1_enabled?: boolean;
  /** The minimum number of upcoming trips to return in the driver app */
  minimum_upcoming_trips_returned?: number;
  /** The hex color for the header background */
  header_background_color?: string;
  /** Whether to assign the same driver for a passenger during run bambi run if they have multiple trips */
  assign_same_driver_for_passenger?: boolean;
  /** Whether to restrict pricing display based on role */
  restrict_pricing_display?: boolean;
  trip_required_fields?: OrganizationSettingsTripRequiredFields | null;
  /** Whether to enable the public trip portal */
  public_trip_portal?: boolean;
  /** Whether to include canceled trips in revenue calculations */
  include_canceled_trips_in_revenue?: boolean;
};
export type OrganizationSettingsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type OrganizationSettingsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type OrganizationSettingsPartialUpdateHeadquartersLocationNonFieldErrorsErrorComponent =
  {
    attr: 'headquarters_location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateHeadquartersLocationPlaceIdErrorComponent =
  {
    attr: 'headquarters_location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateLogoErrorComponent = {
  attr: 'logo';
  code: 'empty' | 'invalid' | 'invalid_image' | 'max_length' | 'no_name';
  detail: string;
};
export type OrganizationSettingsPartialUpdateBillingAddressErrorComponent = {
  attr: 'billing_address';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type OrganizationSettingsPartialUpdateDispatchPhoneNumberErrorComponent =
  {
    attr: 'dispatch_phone_number';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateDispatchTextNumberErrorComponent =
  {
    attr: 'dispatch_text_number';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateTaxIdErrorComponent = {
  attr: 'tax_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type OrganizationSettingsPartialUpdateShouldAvoidTollRoadsErrorComponent =
  {
    attr: 'should_avoid_toll_roads';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateShouldAvoidFerriesErrorComponent =
  {
    attr: 'should_avoid_ferries';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateDefaultTripSpaceTypeErrorComponent =
  {
    attr: 'default_trip_space_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateDefaultTripServiceTypeErrorComponent =
  {
    attr: 'default_trip_service_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateExpandTripLocationDetailsErrorComponent =
  {
    attr: 'expand_trip_location_details';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateAmbulatoryLoadSecondsErrorComponent =
  {
    attr: 'ambulatory_load_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateAmbulatoryUnloadSecondsErrorComponent =
  {
    attr: 'ambulatory_unload_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateWheelchairLoadSecondsErrorComponent =
  {
    attr: 'wheelchair_load_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateWheelchairUnloadSecondsErrorComponent =
  {
    attr: 'wheelchair_unload_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateWheelchairXlLoadSecondsErrorComponent =
  {
    attr: 'wheelchair_xl_load_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateWheelchairXlUnloadSecondsErrorComponent =
  {
    attr: 'wheelchair_xl_unload_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateBrodaChairLoadSecondsErrorComponent =
  {
    attr: 'broda_chair_load_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateBrodaChairUnloadSecondsErrorComponent =
  {
    attr: 'broda_chair_unload_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateGeriChairLoadSecondsErrorComponent =
  {
    attr: 'geri_chair_load_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateGeriChairUnloadSecondsErrorComponent =
  {
    attr: 'geri_chair_unload_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateStretcherLoadSecondsErrorComponent =
  {
    attr: 'stretcher_load_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateStretcherUnloadSecondsErrorComponent =
  {
    attr: 'stretcher_unload_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdatePickupDefaultEarlySecondsErrorComponent =
  {
    attr: 'pickup_default_early_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdatePickupDefaultLateSecondsErrorComponent =
  {
    attr: 'pickup_default_late_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdatePickupAppointmentEarlySecondsErrorComponent =
  {
    attr: 'pickup_appointment_early_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdatePickupAppointmentLateSecondsErrorComponent =
  {
    attr: 'pickup_appointment_late_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdatePickupWillCallEarlySecondsErrorComponent =
  {
    attr: 'pickup_will_call_early_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdatePickupWillCallLateSecondsErrorComponent =
  {
    attr: 'pickup_will_call_late_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateAppointmentEarlyArrivalWindowSecondsErrorComponent =
  {
    attr: 'appointment_early_arrival_window_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateStandardTransportTimeStartErrorComponent =
  {
    attr: 'standard_transport_time_start';
    code: 'invalid';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateStandardTransportTimeEndErrorComponent =
  {
    attr: 'standard_transport_time_end';
    code: 'invalid';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateRequiresInspectionAfterAssignmentStartErrorComponent =
  {
    attr: 'requires_inspection_after_assignment_start';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateRequiresInspectionBeforeAssignmentEndErrorComponent =
  {
    attr: 'requires_inspection_before_assignment_end';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateRequiresSignaturePickupPassengerErrorComponent =
  {
    attr: 'requires_signature_pickup_passenger';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateRequiresSignatureDropoffPassengerErrorComponent =
  {
    attr: 'requires_signature_dropoff_passenger';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateRequiresSignaturePickupDriverErrorComponent =
  {
    attr: 'requires_signature_pickup_driver';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateRequiresSignatureDropoffDriverErrorComponent =
  {
    attr: 'requires_signature_dropoff_driver';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateCanAssociateCancelTripsErrorComponent =
  {
    attr: 'can_associate_cancel_trips';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateCanAssociateActivateWillCallTripsErrorComponent =
  {
    attr: 'can_associate_activate_will_call_trips';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateCanAssociateViewPassengerPhoneNumberErrorComponent =
  {
    attr: 'can_associate_view_passenger_phone_number';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateDaysOfFutureAssignmentsToShowErrorComponent =
  {
    attr: 'days_of_future_assignments_to_show';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateDaysOfFutureTripsToShowErrorComponent =
  {
    attr: 'days_of_future_trips_to_show';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateAssociateCancelReasonsErrorComponent =
  {
    attr: 'associate_cancel_reasons';
    code: 'min_length' | 'not_a_list' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateAssociateCancelReasonsIndexErrorComponent =
  {
    attr: 'associate_cancel_reasons.INDEX';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type OrganizationSettingsPartialUpdatePaymentAccountOnboardingUserIdErrorComponent =
  {
    attr: 'payment_account_onboarding_user_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateFacilityTripRequestLeadTimeSecondsErrorComponent =
  {
    attr: 'facility_trip_request_lead_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateFacilityTripCancelLeadTimeSecondsErrorComponent =
  {
    attr: 'facility_trip_cancel_lead_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdatePublicTripRequestLeadTimeSecondsErrorComponent =
  {
    attr: 'public_trip_request_lead_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateCancellationFeeWindowHoursErrorComponent =
  {
    attr: 'cancellation_fee_window_hours';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateIsPricingV1EnabledErrorComponent =
  {
    attr: 'is_pricing_v1_enabled';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateMinimumUpcomingTripsReturnedErrorComponent =
  {
    attr: 'minimum_upcoming_trips_returned';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateHeaderBackgroundColorErrorComponent =
  {
    attr: 'header_background_color';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateAssignSameDriverForPassengerErrorComponent =
  {
    attr: 'assign_same_driver_for_passenger';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateRestrictPricingDisplayErrorComponent =
  {
    attr: 'restrict_pricing_display';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateTripRequiredFieldsNonFieldErrorsErrorComponent =
  {
    attr: 'trip_required_fields.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateTripRequiredFieldsPassengerPhoneNumberErrorComponent =
  {
    attr: 'trip_required_fields.passenger_phone_number';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateTripRequiredFieldsPassengerWeightErrorComponent =
  {
    attr: 'trip_required_fields.passenger_weight';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateTripRequiredFieldsAuthorizationIdErrorComponent =
  {
    attr: 'trip_required_fields.authorization_id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateTripRequiredFieldsInsurancePolicyIdErrorComponent =
  {
    attr: 'trip_required_fields.insurance_policy_id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateTripRequiredFieldsPayerPassengerExternalIdErrorComponent =
  {
    attr: 'trip_required_fields.payer_passenger_external_id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateTripRequiredFieldsExternalTripIdErrorComponent =
  {
    attr: 'trip_required_fields.external_trip_id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateTripRequiredFieldsBookedByNameErrorComponent =
  {
    attr: 'trip_required_fields.booked_by_name';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateTripRequiredFieldsBookedByPhoneNumberErrorComponent =
  {
    attr: 'trip_required_fields.booked_by_phone_number';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdatePublicTripPortalErrorComponent = {
  attr: 'public_trip_portal';
  code: 'invalid' | 'null';
  detail: string;
};
export type OrganizationSettingsPartialUpdateIncludeCanceledTripsInRevenueErrorComponent =
  {
    attr: 'include_canceled_trips_in_revenue';
    code: 'invalid' | 'null';
    detail: string;
  };
export type OrganizationSettingsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & OrganizationSettingsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'headquarters_location.non_field_errors';
    } & OrganizationSettingsPartialUpdateHeadquartersLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'headquarters_location.place_id';
    } & OrganizationSettingsPartialUpdateHeadquartersLocationPlaceIdErrorComponent)
  | ({
      attr: 'logo';
    } & OrganizationSettingsPartialUpdateLogoErrorComponent)
  | ({
      attr: 'billing_address';
    } & OrganizationSettingsPartialUpdateBillingAddressErrorComponent)
  | ({
      attr: 'dispatch_phone_number';
    } & OrganizationSettingsPartialUpdateDispatchPhoneNumberErrorComponent)
  | ({
      attr: 'dispatch_text_number';
    } & OrganizationSettingsPartialUpdateDispatchTextNumberErrorComponent)
  | ({
      attr: 'tax_id';
    } & OrganizationSettingsPartialUpdateTaxIdErrorComponent)
  | ({
      attr: 'should_avoid_toll_roads';
    } & OrganizationSettingsPartialUpdateShouldAvoidTollRoadsErrorComponent)
  | ({
      attr: 'should_avoid_ferries';
    } & OrganizationSettingsPartialUpdateShouldAvoidFerriesErrorComponent)
  | ({
      attr: 'default_trip_space_type';
    } & OrganizationSettingsPartialUpdateDefaultTripSpaceTypeErrorComponent)
  | ({
      attr: 'default_trip_service_type';
    } & OrganizationSettingsPartialUpdateDefaultTripServiceTypeErrorComponent)
  | ({
      attr: 'expand_trip_location_details';
    } & OrganizationSettingsPartialUpdateExpandTripLocationDetailsErrorComponent)
  | ({
      attr: 'ambulatory_load_seconds';
    } & OrganizationSettingsPartialUpdateAmbulatoryLoadSecondsErrorComponent)
  | ({
      attr: 'ambulatory_unload_seconds';
    } & OrganizationSettingsPartialUpdateAmbulatoryUnloadSecondsErrorComponent)
  | ({
      attr: 'wheelchair_load_seconds';
    } & OrganizationSettingsPartialUpdateWheelchairLoadSecondsErrorComponent)
  | ({
      attr: 'wheelchair_unload_seconds';
    } & OrganizationSettingsPartialUpdateWheelchairUnloadSecondsErrorComponent)
  | ({
      attr: 'wheelchair_xl_load_seconds';
    } & OrganizationSettingsPartialUpdateWheelchairXlLoadSecondsErrorComponent)
  | ({
      attr: 'wheelchair_xl_unload_seconds';
    } & OrganizationSettingsPartialUpdateWheelchairXlUnloadSecondsErrorComponent)
  | ({
      attr: 'broda_chair_load_seconds';
    } & OrganizationSettingsPartialUpdateBrodaChairLoadSecondsErrorComponent)
  | ({
      attr: 'broda_chair_unload_seconds';
    } & OrganizationSettingsPartialUpdateBrodaChairUnloadSecondsErrorComponent)
  | ({
      attr: 'geri_chair_load_seconds';
    } & OrganizationSettingsPartialUpdateGeriChairLoadSecondsErrorComponent)
  | ({
      attr: 'geri_chair_unload_seconds';
    } & OrganizationSettingsPartialUpdateGeriChairUnloadSecondsErrorComponent)
  | ({
      attr: 'stretcher_load_seconds';
    } & OrganizationSettingsPartialUpdateStretcherLoadSecondsErrorComponent)
  | ({
      attr: 'stretcher_unload_seconds';
    } & OrganizationSettingsPartialUpdateStretcherUnloadSecondsErrorComponent)
  | ({
      attr: 'pickup_default_early_seconds';
    } & OrganizationSettingsPartialUpdatePickupDefaultEarlySecondsErrorComponent)
  | ({
      attr: 'pickup_default_late_seconds';
    } & OrganizationSettingsPartialUpdatePickupDefaultLateSecondsErrorComponent)
  | ({
      attr: 'pickup_appointment_early_seconds';
    } & OrganizationSettingsPartialUpdatePickupAppointmentEarlySecondsErrorComponent)
  | ({
      attr: 'pickup_appointment_late_seconds';
    } & OrganizationSettingsPartialUpdatePickupAppointmentLateSecondsErrorComponent)
  | ({
      attr: 'pickup_will_call_early_seconds';
    } & OrganizationSettingsPartialUpdatePickupWillCallEarlySecondsErrorComponent)
  | ({
      attr: 'pickup_will_call_late_seconds';
    } & OrganizationSettingsPartialUpdatePickupWillCallLateSecondsErrorComponent)
  | ({
      attr: 'appointment_early_arrival_window_seconds';
    } & OrganizationSettingsPartialUpdateAppointmentEarlyArrivalWindowSecondsErrorComponent)
  | ({
      attr: 'standard_transport_time_start';
    } & OrganizationSettingsPartialUpdateStandardTransportTimeStartErrorComponent)
  | ({
      attr: 'standard_transport_time_end';
    } & OrganizationSettingsPartialUpdateStandardTransportTimeEndErrorComponent)
  | ({
      attr: 'requires_inspection_after_assignment_start';
    } & OrganizationSettingsPartialUpdateRequiresInspectionAfterAssignmentStartErrorComponent)
  | ({
      attr: 'requires_inspection_before_assignment_end';
    } & OrganizationSettingsPartialUpdateRequiresInspectionBeforeAssignmentEndErrorComponent)
  | ({
      attr: 'requires_signature_pickup_passenger';
    } & OrganizationSettingsPartialUpdateRequiresSignaturePickupPassengerErrorComponent)
  | ({
      attr: 'requires_signature_dropoff_passenger';
    } & OrganizationSettingsPartialUpdateRequiresSignatureDropoffPassengerErrorComponent)
  | ({
      attr: 'requires_signature_pickup_driver';
    } & OrganizationSettingsPartialUpdateRequiresSignaturePickupDriverErrorComponent)
  | ({
      attr: 'requires_signature_dropoff_driver';
    } & OrganizationSettingsPartialUpdateRequiresSignatureDropoffDriverErrorComponent)
  | ({
      attr: 'can_associate_cancel_trips';
    } & OrganizationSettingsPartialUpdateCanAssociateCancelTripsErrorComponent)
  | ({
      attr: 'can_associate_activate_will_call_trips';
    } & OrganizationSettingsPartialUpdateCanAssociateActivateWillCallTripsErrorComponent)
  | ({
      attr: 'can_associate_view_passenger_phone_number';
    } & OrganizationSettingsPartialUpdateCanAssociateViewPassengerPhoneNumberErrorComponent)
  | ({
      attr: 'days_of_future_assignments_to_show';
    } & OrganizationSettingsPartialUpdateDaysOfFutureAssignmentsToShowErrorComponent)
  | ({
      attr: 'days_of_future_trips_to_show';
    } & OrganizationSettingsPartialUpdateDaysOfFutureTripsToShowErrorComponent)
  | ({
      attr: 'associate_cancel_reasons';
    } & OrganizationSettingsPartialUpdateAssociateCancelReasonsErrorComponent)
  | ({
      attr: 'associate_cancel_reasons.INDEX';
    } & OrganizationSettingsPartialUpdateAssociateCancelReasonsIndexErrorComponent)
  | ({
      attr: 'payment_account_onboarding_user_id';
    } & OrganizationSettingsPartialUpdatePaymentAccountOnboardingUserIdErrorComponent)
  | ({
      attr: 'facility_trip_request_lead_time_seconds';
    } & OrganizationSettingsPartialUpdateFacilityTripRequestLeadTimeSecondsErrorComponent)
  | ({
      attr: 'facility_trip_cancel_lead_time_seconds';
    } & OrganizationSettingsPartialUpdateFacilityTripCancelLeadTimeSecondsErrorComponent)
  | ({
      attr: 'public_trip_request_lead_time_seconds';
    } & OrganizationSettingsPartialUpdatePublicTripRequestLeadTimeSecondsErrorComponent)
  | ({
      attr: 'cancellation_fee_window_hours';
    } & OrganizationSettingsPartialUpdateCancellationFeeWindowHoursErrorComponent)
  | ({
      attr: 'is_pricing_v1_enabled';
    } & OrganizationSettingsPartialUpdateIsPricingV1EnabledErrorComponent)
  | ({
      attr: 'minimum_upcoming_trips_returned';
    } & OrganizationSettingsPartialUpdateMinimumUpcomingTripsReturnedErrorComponent)
  | ({
      attr: 'header_background_color';
    } & OrganizationSettingsPartialUpdateHeaderBackgroundColorErrorComponent)
  | ({
      attr: 'assign_same_driver_for_passenger';
    } & OrganizationSettingsPartialUpdateAssignSameDriverForPassengerErrorComponent)
  | ({
      attr: 'restrict_pricing_display';
    } & OrganizationSettingsPartialUpdateRestrictPricingDisplayErrorComponent)
  | ({
      attr: 'trip_required_fields.non_field_errors';
    } & OrganizationSettingsPartialUpdateTripRequiredFieldsNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_required_fields.passenger_phone_number';
    } & OrganizationSettingsPartialUpdateTripRequiredFieldsPassengerPhoneNumberErrorComponent)
  | ({
      attr: 'trip_required_fields.passenger_weight';
    } & OrganizationSettingsPartialUpdateTripRequiredFieldsPassengerWeightErrorComponent)
  | ({
      attr: 'trip_required_fields.authorization_id';
    } & OrganizationSettingsPartialUpdateTripRequiredFieldsAuthorizationIdErrorComponent)
  | ({
      attr: 'trip_required_fields.insurance_policy_id';
    } & OrganizationSettingsPartialUpdateTripRequiredFieldsInsurancePolicyIdErrorComponent)
  | ({
      attr: 'trip_required_fields.payer_passenger_external_id';
    } & OrganizationSettingsPartialUpdateTripRequiredFieldsPayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'trip_required_fields.external_trip_id';
    } & OrganizationSettingsPartialUpdateTripRequiredFieldsExternalTripIdErrorComponent)
  | ({
      attr: 'trip_required_fields.booked_by_name';
    } & OrganizationSettingsPartialUpdateTripRequiredFieldsBookedByNameErrorComponent)
  | ({
      attr: 'trip_required_fields.booked_by_phone_number';
    } & OrganizationSettingsPartialUpdateTripRequiredFieldsBookedByPhoneNumberErrorComponent)
  | ({
      attr: 'public_trip_portal';
    } & OrganizationSettingsPartialUpdatePublicTripPortalErrorComponent)
  | ({
      attr: 'include_canceled_trips_in_revenue';
    } & OrganizationSettingsPartialUpdateIncludeCanceledTripsInRevenueErrorComponent);
export type OrganizationSettingsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: OrganizationSettingsPartialUpdateError[];
};
export type OrganizationSettingsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & OrganizationSettingsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedOrganizationSettings = {
  headquarters_location?: OrganizationHeadquarters;
  logo?: string | null;
  /** Billing address for the business, appears on invoices */
  billing_address?: string;
  dispatch_phone_number?: string;
  dispatch_text_number?: string;
  /** Some payer exports require this */
  tax_id?: string;
  should_avoid_toll_roads?: boolean;
  should_avoid_ferries?: boolean;
  /** The default space type when creating trips */
  default_trip_space_type?: SpaceTypeEnum | BlankEnum;
  /** The default service type when creating trips */
  default_trip_service_type?: ServiceTypeEnum | BlankEnum;
  /** Expand location details automatically on load */
  expand_trip_location_details?: boolean;
  ambulatory_load_seconds?: number;
  ambulatory_unload_seconds?: number;
  wheelchair_load_seconds?: number;
  wheelchair_unload_seconds?: number;
  wheelchair_xl_load_seconds?: number;
  wheelchair_xl_unload_seconds?: number;
  broda_chair_load_seconds?: number;
  broda_chair_unload_seconds?: number;
  geri_chair_load_seconds?: number;
  geri_chair_unload_seconds?: number;
  stretcher_load_seconds?: number;
  stretcher_unload_seconds?: number;
  /** How early a driver can arrive before a pickup time */
  pickup_default_early_seconds?: number;
  /** How late a driver can arrive after a pickup time */
  pickup_default_late_seconds?: number;
  /** How early a driver can arrive before a pickup time headed to an appointment */
  pickup_appointment_early_seconds?: number;
  /** How late a driver can arrive after a pickup time headed to an appointment */
  pickup_appointment_late_seconds?: number;
  /** How early a driver can arrive before a pickup time for a will call trip */
  pickup_will_call_early_seconds?: number;
  /** How late a driver can arrive after a pickup time for a will call trip */
  pickup_will_call_late_seconds?: number;
  /** How early before an appointment the passenger should arrive */
  appointment_early_arrival_window_seconds?: number;
  /** Start time of standard transport time (in local time) */
  standard_transport_time_start?: string | null;
  /** End time of standard transport time (in local time) */
  standard_transport_time_end?: string | null;
  requires_inspection_after_assignment_start?: boolean;
  requires_inspection_before_assignment_end?: boolean;
  requires_signature_pickup_passenger?: boolean;
  requires_signature_dropoff_passenger?: boolean;
  requires_signature_pickup_driver?: boolean;
  requires_signature_dropoff_driver?: boolean;
  /** Whether an associate is allowed to cancel their own trips */
  can_associate_cancel_trips?: boolean;
  /** Whether an associate is allowed to activate their own will call trips */
  can_associate_activate_will_call_trips?: boolean;
  /** Whether an associate is allowed to view the passenger's phone number */
  can_associate_view_passenger_phone_number?: boolean;
  /** The number of days of future assignments to show associates, excluding today */
  days_of_future_assignments_to_show?: number;
  /** The number of days of future trips to show associates, excluding today */
  days_of_future_trips_to_show?: number;
  /** The reasons for canceling a trip that an associate can select */
  associate_cancel_reasons?: CanceledReasonEnum[];
  /** The Tilled onboarding user id */
  payment_account_onboarding_user_id?: string;
  /** The lead time required for facilities to request a trip before the pickup */
  facility_trip_request_lead_time_seconds?: number;
  /** The lead time required for facilities to cancel a trip before the pickup */
  facility_trip_cancel_lead_time_seconds?: number;
  /** The minimum advance notice required for trips submitted through the public trip request form. */
  public_trip_request_lead_time_seconds?: number;
  /** Window up to the pick up time for a customer to be charged a fee for canceling */
  cancellation_fee_window_hours?: number;
  /** Whether the organization is using pricing v1 */
  is_pricing_v1_enabled?: boolean;
  /** The minimum number of upcoming trips to return in the driver app */
  minimum_upcoming_trips_returned?: number;
  /** The hex color for the header background */
  header_background_color?: string;
  /** Whether to assign the same driver for a passenger during run bambi run if they have multiple trips */
  assign_same_driver_for_passenger?: boolean;
  /** Whether to restrict pricing display based on role */
  restrict_pricing_display?: boolean;
  trip_required_fields?: OrganizationSettingsTripRequiredFields | null;
  /** Whether to enable the public trip portal */
  public_trip_portal?: boolean;
  /** Whether to include canceled trips in revenue calculations */
  include_canceled_trips_in_revenue?: boolean;
};
export type PatchedOrganizationSettingsRead = {
  headquarters_location?: OrganizationHeadquartersRead;
  logo?: string | null;
  /** Billing address for the business, appears on invoices */
  billing_address?: string;
  dispatch_phone_number?: string;
  dispatch_text_number?: string;
  /** Some payer exports require this */
  tax_id?: string;
  should_avoid_toll_roads?: boolean;
  should_avoid_ferries?: boolean;
  /** The default space type when creating trips */
  default_trip_space_type?: SpaceTypeEnum | BlankEnum;
  /** The default service type when creating trips */
  default_trip_service_type?: ServiceTypeEnum | BlankEnum;
  /** Expand location details automatically on load */
  expand_trip_location_details?: boolean;
  ambulatory_load_seconds?: number;
  ambulatory_unload_seconds?: number;
  wheelchair_load_seconds?: number;
  wheelchair_unload_seconds?: number;
  wheelchair_xl_load_seconds?: number;
  wheelchair_xl_unload_seconds?: number;
  broda_chair_load_seconds?: number;
  broda_chair_unload_seconds?: number;
  geri_chair_load_seconds?: number;
  geri_chair_unload_seconds?: number;
  stretcher_load_seconds?: number;
  stretcher_unload_seconds?: number;
  /** How early a driver can arrive before a pickup time */
  pickup_default_early_seconds?: number;
  /** How late a driver can arrive after a pickup time */
  pickup_default_late_seconds?: number;
  /** How early a driver can arrive before a pickup time headed to an appointment */
  pickup_appointment_early_seconds?: number;
  /** How late a driver can arrive after a pickup time headed to an appointment */
  pickup_appointment_late_seconds?: number;
  /** How early a driver can arrive before a pickup time for a will call trip */
  pickup_will_call_early_seconds?: number;
  /** How late a driver can arrive after a pickup time for a will call trip */
  pickup_will_call_late_seconds?: number;
  /** How early before an appointment the passenger should arrive */
  appointment_early_arrival_window_seconds?: number;
  /** Start time of standard transport time (in local time) */
  standard_transport_time_start?: string | null;
  /** End time of standard transport time (in local time) */
  standard_transport_time_end?: string | null;
  requires_inspection_after_assignment_start?: boolean;
  requires_inspection_before_assignment_end?: boolean;
  requires_signature_pickup_passenger?: boolean;
  requires_signature_dropoff_passenger?: boolean;
  requires_signature_pickup_driver?: boolean;
  requires_signature_dropoff_driver?: boolean;
  /** Whether an associate is allowed to cancel their own trips */
  can_associate_cancel_trips?: boolean;
  /** Whether an associate is allowed to activate their own will call trips */
  can_associate_activate_will_call_trips?: boolean;
  /** Whether an associate is allowed to view the passenger's phone number */
  can_associate_view_passenger_phone_number?: boolean;
  /** The number of days of future assignments to show associates, excluding today */
  days_of_future_assignments_to_show?: number;
  /** The number of days of future trips to show associates, excluding today */
  days_of_future_trips_to_show?: number;
  /** The reasons for canceling a trip that an associate can select */
  associate_cancel_reasons?: CanceledReasonEnum[];
  /** All possible reasons for canceling a trip */
  bambi_cancel_reasons?: TripCancelReason[];
  payment_account_id?: string | null;
  payment_account_status?: string | null;
  /** The Tilled onboarding user id */
  payment_account_onboarding_user_id?: string;
  /** The lead time required for facilities to request a trip before the pickup */
  facility_trip_request_lead_time_seconds?: number;
  /** The lead time required for facilities to cancel a trip before the pickup */
  facility_trip_cancel_lead_time_seconds?: number;
  /** The minimum advance notice required for trips submitted through the public trip request form. */
  public_trip_request_lead_time_seconds?: number;
  /** Window up to the pick up time for a customer to be charged a fee for canceling */
  cancellation_fee_window_hours?: number;
  /** Whether the organization is using pricing v1 */
  is_pricing_v1_enabled?: boolean;
  /** The minimum number of upcoming trips to return in the driver app */
  minimum_upcoming_trips_returned?: number;
  /** The hex color for the header background */
  header_background_color?: string;
  /** Whether to assign the same driver for a passenger during run bambi run if they have multiple trips */
  assign_same_driver_for_passenger?: boolean;
  /** Whether to restrict pricing display based on role */
  restrict_pricing_display?: boolean;
  trip_required_fields?: OrganizationSettingsTripRequiredFields | null;
  /** Whether to enable the public trip portal */
  public_trip_portal?: boolean;
  /** Whether to include canceled trips in revenue calculations */
  include_canceled_trips_in_revenue?: boolean;
};
export type OrganizationMerchantAccountOnboardingStatusEnum =
  | 'created'
  | 'started'
  | 'submitted'
  | 'disabled'
  | 'in_review'
  | 'rejected'
  | 'withdrawn'
  | 'active';
export type OrganizationMerchantAccountOnboarding = {
  account_id: string;
  onboarding_application_url?: string | null;
  status: OrganizationMerchantAccountOnboardingStatusEnum;
  merchant_email: string;
};
export type OrganizationSettingsConnectMerchantAccountCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type OrganizationSettingsConnectMerchantAccountCreateError = {
  attr: 'non_field_errors';
} & OrganizationSettingsConnectMerchantAccountCreateNonFieldErrorsErrorComponent;
export type OrganizationSettingsConnectMerchantAccountCreateValidationError = {
  type: ValidationErrorEnum;
  errors: OrganizationSettingsConnectMerchantAccountCreateError[];
};
export type OrganizationSettingsConnectMerchantAccountCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & OrganizationSettingsConnectMerchantAccountCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type OrganizationSettingsLogo = {
  logo?: string;
};
export type OrganizationSettingsLogoRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PartnersOAuthToken = {};
export type PartnersOAuthTokenRead = {
  access_token: string;
  expires_in: number;
  token_type: TokenTypeEnum;
};
export type PartnersOAuthTokenWrite = {
  client_id: string;
  client_secret: string;
  grant_type: GrantTypeEnum;
};
export type PartnersOauth2TokenCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PartnersOauth2TokenCreateClientIdErrorComponent = {
  attr: 'client_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOauth2TokenCreateClientSecretErrorComponent = {
  attr: 'client_secret';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOauth2TokenCreateGrantTypeErrorComponent = {
  attr: 'grant_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type PartnersOauth2TokenCreateError =
  | ({
      attr: 'non_field_errors';
    } & PartnersOauth2TokenCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'client_id';
    } & PartnersOauth2TokenCreateClientIdErrorComponent)
  | ({
      attr: 'client_secret';
    } & PartnersOauth2TokenCreateClientSecretErrorComponent)
  | ({
      attr: 'grant_type';
    } & PartnersOauth2TokenCreateGrantTypeErrorComponent);
export type PartnersOauth2TokenCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PartnersOauth2TokenCreateError[];
};
export type PartnersOauth2TokenCreateErrorResponse400 = {
  type: 'validation_error';
} & PartnersOauth2TokenCreateValidationError;
export type PartnerOrganization = {};
export type PartnerOrganizationRead = {
  /** The ID of the organization, Ex: `123e4567-e89b-12d3-a456-426614174000` */
  id: string;
  /** The name of the organization, Ex: `Safe Transport` */
  name: string;
};
export type PaginatedPartnerOrganizationList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PartnerOrganization[];
};
export type PaginatedPartnerOrganizationListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PartnerOrganizationRead[];
};
export type PartnersOrganizationsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PartnerPayerOrganization = {};
export type PartnerPayerOrganizationRead = {
  /** The ID of the payer, Ex: `123e4567-e89b-12d3-a456-426614174000` */
  id: string;
  /** The display name of the payer, Ex: `Facility A` */
  display_name: string;
};
export type PaginatedPartnerPayerOrganizationList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PartnerPayerOrganization[];
};
export type PaginatedPartnerPayerOrganizationListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PartnerPayerOrganizationRead[];
};
export type PartnersOrganizationsPayersListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PartnerTripRead = {};
export type PartnerTripAssignment = {};
export type PartnerTripAssignmentVehicle = {};
export type PartnerTripAssignmentVehicleRead = {
  /** The license plate of the vehicle, Ex: `ABC123` */
  license_plate: string;
  /** The VIN of the vehicle, Ex: `12345678901234567` */
  vin: string;
  /** The make of the vehicle, Ex: `Toyota` */
  make: string;
  /** The model of the vehicle, Ex: `Camry` */
  model: string;
  /** The year of the vehicle, Ex: `2020` */
  year: number;
  /** The color of the vehicle, Ex: `Red` */
  color: string;
};
export type PartnerTripAssignmentDriver = {};
export type PartnerTripAssignmentDriverRead = {
  /** The first name of the driver, Ex: `John` */
  first_name: string;
  /** The last name of the driver, Ex: `Doe` */
  last_name: string;
};
export type PartnerTripAssignmentAttendants = {};
export type PartnerTripAssignmentAttendantsRead = {
  /** The first name of the attendant, Ex: `Jane` */
  first_name: string;
  /** The last name of the attendant, Ex: `Smith` */
  last_name: string;
};
export type PartnerTripAssignmentRead = {
  /** The vehicle assigned to the trip */
  vehicle: PartnerTripAssignmentVehicleRead;
  /** The driver assigned to the trip */
  driver: PartnerTripAssignmentDriverRead;
  /** The attendants assigned to the trip */
  attendants: PartnerTripAssignmentAttendantsRead[];
};
export type PartnerTripPassenger = {};
export type PartnerTripPassengerRead = {
  /** The first name of the passenger, Ex: `John` */
  first_name: string;
  /** The last name of the passenger, Ex: `Doe` */
  last_name: string;
  /** The date of birth of the passenger, Ex: `1990-01-01` */
  dob: string;
  /** The email of the passenger, Ex: `john.doe@example.com` */
  email: string;
  /** The phone number of the passenger, Ex: `+1(123)456-7890` */
  phone_number: string;
};
export type PartnerTripPayer = {};
export type PartnerTripPayerRead = {
  /** The ID of the payer, Ex: `123e4567-e89b-12d3-a456-426614174000` */
  id: string;
  /** The display name of the payer, Ex: `Facility A` */
  display_name: string;
};
export type PartnerTripLocationDetail = {};
export type PartnerTripLocationDetailRead = {
  /** The full street address, Ex: `4500 Broadway, New York, NY 10001` */
  full_address: string;
  /** The number of the address, Ex: `4500` */
  number: string;
  /** The street of the address, Ex: `Broadway` */
  street: string;
  /** The detail of the address, Ex: `Apt 5B` */
  detail: string;
  /** The city of the address, Ex: `New York` */
  city: string;
  /** The state of the address, Ex: `New York` */
  state: string;
  /** The zip code of the address, Ex: `10001` */
  zip: string;
  /** The country of the address, Ex: `United States` */
  country: string;
  /** The latitude of the address, Ex: `40.712776` */
  latitude: number;
  /** The longitude of the address, Ex: `-74.005974` */
  longitude: number;
  /** The number of stairs at the address, Ex: `2` */
  num_stairs: number;
  /** The name of the contact at the address, Ex: `John Doe` */
  contact_name: string;
  /** The phone number of the contact at the address, Ex: `+1(123)456-7890` */
  contact_phone_number: string;
  /** The driver notes for the address, Ex: `Please ring the doorbell` */
  driver_notes: string;
};
export type SeatEquipmentEnum = 'booster-seat' | 'car-seat';
export type PartnerTripReadRead = {
  /** The ID of the trip, Ex: `123e4567-e89b-12d3-a456-426614174000` */
  id: string;
  /** The vehicle, driver, and attendants for the trip */
  assignment: PartnerTripAssignmentRead | null;
  /** The status of the trip, Ex: `completed` */
  status: OverrideStatusEnum;
  /** The passenger for the trip */
  passenger: PartnerTripPassengerRead;
  /** The payer for the trip */
  payer: PartnerTripPayerRead;
  /** The external trip ID, Ex: `ARHF-7890` */
  external_trip_id: string;
  /** The price of the trip in cents. Ex: `10000` */
  price_cents: number;
  /** The scheduled pickup datetime in UTC for the trip, Ex: `2025-01-01T00:00:00Z` */
  scheduled_pickup_at: string;
  /** The datetime of the passenger's appointment in UTC, Ex: `2025-01-01T00:00:00Z` */
  appointment_at: string;
  /** The pickup location for the trip */
  pickup: PartnerTripLocationDetailRead;
  /** The dropoff location for the trip */
  dropoff: PartnerTripLocationDetailRead;
  /** The dispatcher notes for the trip, Ex: `Please call the passenger to confirm the pickup` */
  dispatcher_notes: string;
  /** The estimated distance of the trip in miles, Ex: `10.5` */
  estimated_distance_miles: number;
  /** Whether the trip is a will call trip, Ex: `true` */
  is_will_call: boolean;
  /** The space type required for the trip, Ex: `wheelchair` */
  space_type: SpaceTypeEnum;
  /** The service type required for the trip, Ex: `ambulatory` */
  service_type: ServiceTypeEnum;
  /** Whether the trip must provide a wheelchair, Ex: `true` */
  must_provide_wheelchair: boolean;
  /** Whether the trip requires oxygen, Ex: `true` */
  is_oxygen_required: boolean;
  /** The amount of oxygen required for the trip in liters per minute, Ex: `2.5` */
  oxygen_liters_per_min: number;
  /** The number of attendants needed for the trip, Ex: `2` */
  num_attendants_needed: number;
  /** The number of accompanying passengers for the trip, Ex: `1` */
  num_accompanying_passengers: number;
  /** Whether the passenger has an infectious disease, Ex: `true` */
  has_infectious_disease: boolean;
  /** The seat equipment required for the trip, Ex: `booster-seat` */
  seat_equipment: SeatEquipmentEnum;
  /** The datetime the trip was created in UTC, Ex: `2025-01-01T00:00:00Z` */
  created_at: string;
};
export type PaginatedPartnerTripReadList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PartnerTripRead[];
};
export type PaginatedPartnerTripReadListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PartnerTripReadRead[];
};
export type PartnersOrganizationsTripsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PartnerTripCreate = {};
export type PartnerTripCreateRead = {
  /** The ID of the trip in Bambi, Ex: `123e4567-e89b-12d3-a456-426614174000` */
  id: string;
};
export type PartnerTripPassengerCreate = {};
export type PartnerTripPassengerCreateWrite = {
  /** The first name of the passenger, Ex: `John` */
  first_name: string;
  /** The last name of the passenger, Ex: `Doe` */
  last_name: string;
  /** The date of birth of the passenger, Ex: `1990-01-01` */
  dob: string;
  /** The email of the passenger, Ex: `john.doe@example.com` */
  email?: string;
  /** The phone number of the passenger, Ex: `+1(123)456-7890` */
  phone_number?: string;
};
export type PartnerTripLocationDetailCreate = {};
export type PartnerTripLocationDetailCreateWrite = {
  /** The number of the address, Ex: `4500` */
  number: string;
  /** The street of the address, Ex: `Main Street` */
  street: string;
  /** The detail of the address, Ex: `Apt 5B` */
  detail?: string;
  /** The city of the address, Ex: `New York` */
  city: string;
  /** The state of the address, Ex: `New York` */
  state: string;
  /** The zip code of the address, Ex: `10001` */
  zip: string;
  /** The country of the address, Ex: `United States` */
  country: string;
  /** The latitude of the address, Ex: `40.712776` */
  latitude?: number;
  /** The longitude of the address, Ex: `-74.005974` */
  longitude?: number;
  /** The driver notes for the address, Ex: `Please ring the doorbell` */
  driver_notes?: string;
  /** The number of stairs at the address, Ex: `2` */
  num_stairs?: number;
  /** The name of the contact at the address, Ex: `John Doe` */
  contact_name?: string;
  /** The phone number of the contact at the address, Ex: `+1(123)456-7890` */
  contact_phone_number?: string;
};
export type PartnerTripCreateWrite = {
  /** The passenger for the trip */
  passenger: PartnerTripPassengerCreateWrite;
  /** The ID of the payer, Ex: `123e4567-e89b-12d3-a456-426614174000` */
  payer_id: string;
  /** The ID of the trip in the partner's system, Ex: `ARHF-7890` */
  external_trip_id?: string;
  /** The price of the trip in cents, Ex: `10000` */
  price_cents?: number;
  /** The scheduled pickup datetime in UTC, Ex: `2025-01-01T00:00:00Z` */
  scheduled_pickup_at: string;
  /** The datetime of the passenger's appointment in UTC, Ex: `2025-01-01T00:00:00Z` */
  appointment_at?: string;
  /** The pickup location for the trip */
  pickup: PartnerTripLocationDetailCreateWrite;
  /** The dropoff location for the trip */
  dropoff: PartnerTripLocationDetailCreateWrite;
  /** The dispatcher notes for the trip, Ex: `Please call the passenger to confirm the pickup` */
  dispatcher_notes?: string;
  /** Whether the trip is a will call trip, Ex: `true` */
  is_will_call?: boolean;
  /** The space type required for the trip, Ex: `wheelchair` */
  space_type: SpaceTypeEnum;
  /** The service type required for the trip, Ex: `ambulatory` */
  service_type: ServiceTypeEnum;
  /** Whether a wheelchair must be provided to the passenger, Ex: `true` */
  must_provide_wheelchair?: boolean;
  /** Whether oxygen must be provided to the passenger, Ex: `true` */
  is_oxygen_required?: boolean;
  /** The amount of oxygen required for the trip in liters per minute, Ex: `2.5` */
  oxygen_liters_per_min?: number;
  /** The number of attendants needed for the trip, Ex: `2` */
  num_attendants_needed?: number;
  /** The number of accompanying passengers for the trip, Ex: `1` */
  num_accompanying_passengers?: number;
  /** Whether the passenger has an infectious disease, Ex: `true` */
  has_infectious_disease?: boolean;
  /** The seat equipment required for the trip, Ex: `booster-seat` */
  seat_equipment?: SeatEquipmentEnum;
};
export type PartnersOrganizationsTripsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePassengerNonFieldErrorsErrorComponent =
  {
    attr: 'passenger.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type PartnersOrganizationsTripsCreatePassengerFirstNameErrorComponent = {
  attr: 'passenger.first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePassengerLastNameErrorComponent = {
  attr: 'passenger.last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePassengerDobErrorComponent = {
  attr: 'passenger.dob';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePassengerEmailErrorComponent = {
  attr: 'passenger.email';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePassengerPhoneNumberErrorComponent =
  {
    attr: 'passenger.phone_number';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PartnersOrganizationsTripsCreatePayerIdErrorComponent = {
  attr: 'payer_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PartnersOrganizationsTripsCreateExternalTripIdErrorComponent = {
  attr: 'external_trip_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePriceCentsErrorComponent = {
  attr: 'price_cents';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreateScheduledPickupAtErrorComponent = {
  attr: 'scheduled_pickup_at';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type PartnersOrganizationsTripsCreateAppointmentAtErrorComponent = {
  attr: 'appointment_at';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupNonFieldErrorsErrorComponent =
  {
    attr: 'pickup.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type PartnersOrganizationsTripsCreatePickupNumberErrorComponent = {
  attr: 'pickup.number';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupStreetErrorComponent = {
  attr: 'pickup.street';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupDetailErrorComponent = {
  attr: 'pickup.detail';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupCityErrorComponent = {
  attr: 'pickup.city';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupStateErrorComponent = {
  attr: 'pickup.state';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupZipErrorComponent = {
  attr: 'pickup.zip';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupCountryErrorComponent = {
  attr: 'pickup.country';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupLatitudeErrorComponent = {
  attr: 'pickup.latitude';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupLongitudeErrorComponent = {
  attr: 'pickup.longitude';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupDriverNotesErrorComponent = {
  attr: 'pickup.driver_notes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupNumStairsErrorComponent = {
  attr: 'pickup.num_stairs';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupContactNameErrorComponent = {
  attr: 'pickup.contact_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreatePickupContactPhoneNumberErrorComponent =
  {
    attr: 'pickup.contact_phone_number';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PartnersOrganizationsTripsCreateDropoffNonFieldErrorsErrorComponent =
  {
    attr: 'dropoff.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type PartnersOrganizationsTripsCreateDropoffNumberErrorComponent = {
  attr: 'dropoff.number';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffStreetErrorComponent = {
  attr: 'dropoff.street';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffDetailErrorComponent = {
  attr: 'dropoff.detail';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffCityErrorComponent = {
  attr: 'dropoff.city';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffStateErrorComponent = {
  attr: 'dropoff.state';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffZipErrorComponent = {
  attr: 'dropoff.zip';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffCountryErrorComponent = {
  attr: 'dropoff.country';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffLatitudeErrorComponent = {
  attr: 'dropoff.latitude';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffLongitudeErrorComponent = {
  attr: 'dropoff.longitude';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffDriverNotesErrorComponent = {
  attr: 'dropoff.driver_notes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffNumStairsErrorComponent = {
  attr: 'dropoff.num_stairs';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffContactNameErrorComponent = {
  attr: 'dropoff.contact_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreateDropoffContactPhoneNumberErrorComponent =
  {
    attr: 'dropoff.contact_phone_number';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PartnersOrganizationsTripsCreateDispatcherNotesErrorComponent = {
  attr: 'dispatcher_notes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PartnersOrganizationsTripsCreateIsWillCallErrorComponent = {
  attr: 'is_will_call';
  code: 'invalid' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreateSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type PartnersOrganizationsTripsCreateServiceTypeErrorComponent = {
  attr: 'service_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type PartnersOrganizationsTripsCreateMustProvideWheelchairErrorComponent =
  {
    attr: 'must_provide_wheelchair';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PartnersOrganizationsTripsCreateIsOxygenRequiredErrorComponent = {
  attr: 'is_oxygen_required';
  code: 'invalid' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreateOxygenLitersPerMinErrorComponent = {
  attr: 'oxygen_liters_per_min';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreateNumAttendantsNeededErrorComponent =
  {
    attr: 'num_attendants_needed';
    code: 'invalid' | 'max_string_length' | 'null';
    detail: string;
  };
export type PartnersOrganizationsTripsCreateNumAccompanyingPassengersErrorComponent =
  {
    attr: 'num_accompanying_passengers';
    code: 'invalid' | 'max_string_length' | 'null';
    detail: string;
  };
export type PartnersOrganizationsTripsCreateHasInfectiousDiseaseErrorComponent =
  {
    attr: 'has_infectious_disease';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PartnersOrganizationsTripsCreateSeatEquipmentErrorComponent = {
  attr: 'seat_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PartnersOrganizationsTripsCreateError =
  | ({
      attr: 'non_field_errors';
    } & PartnersOrganizationsTripsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'passenger.non_field_errors';
    } & PartnersOrganizationsTripsCreatePassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'passenger.first_name';
    } & PartnersOrganizationsTripsCreatePassengerFirstNameErrorComponent)
  | ({
      attr: 'passenger.last_name';
    } & PartnersOrganizationsTripsCreatePassengerLastNameErrorComponent)
  | ({
      attr: 'passenger.dob';
    } & PartnersOrganizationsTripsCreatePassengerDobErrorComponent)
  | ({
      attr: 'passenger.email';
    } & PartnersOrganizationsTripsCreatePassengerEmailErrorComponent)
  | ({
      attr: 'passenger.phone_number';
    } & PartnersOrganizationsTripsCreatePassengerPhoneNumberErrorComponent)
  | ({
      attr: 'payer_id';
    } & PartnersOrganizationsTripsCreatePayerIdErrorComponent)
  | ({
      attr: 'external_trip_id';
    } & PartnersOrganizationsTripsCreateExternalTripIdErrorComponent)
  | ({
      attr: 'price_cents';
    } & PartnersOrganizationsTripsCreatePriceCentsErrorComponent)
  | ({
      attr: 'scheduled_pickup_at';
    } & PartnersOrganizationsTripsCreateScheduledPickupAtErrorComponent)
  | ({
      attr: 'appointment_at';
    } & PartnersOrganizationsTripsCreateAppointmentAtErrorComponent)
  | ({
      attr: 'pickup.non_field_errors';
    } & PartnersOrganizationsTripsCreatePickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickup.number';
    } & PartnersOrganizationsTripsCreatePickupNumberErrorComponent)
  | ({
      attr: 'pickup.street';
    } & PartnersOrganizationsTripsCreatePickupStreetErrorComponent)
  | ({
      attr: 'pickup.detail';
    } & PartnersOrganizationsTripsCreatePickupDetailErrorComponent)
  | ({
      attr: 'pickup.city';
    } & PartnersOrganizationsTripsCreatePickupCityErrorComponent)
  | ({
      attr: 'pickup.state';
    } & PartnersOrganizationsTripsCreatePickupStateErrorComponent)
  | ({
      attr: 'pickup.zip';
    } & PartnersOrganizationsTripsCreatePickupZipErrorComponent)
  | ({
      attr: 'pickup.country';
    } & PartnersOrganizationsTripsCreatePickupCountryErrorComponent)
  | ({
      attr: 'pickup.latitude';
    } & PartnersOrganizationsTripsCreatePickupLatitudeErrorComponent)
  | ({
      attr: 'pickup.longitude';
    } & PartnersOrganizationsTripsCreatePickupLongitudeErrorComponent)
  | ({
      attr: 'pickup.driver_notes';
    } & PartnersOrganizationsTripsCreatePickupDriverNotesErrorComponent)
  | ({
      attr: 'pickup.num_stairs';
    } & PartnersOrganizationsTripsCreatePickupNumStairsErrorComponent)
  | ({
      attr: 'pickup.contact_name';
    } & PartnersOrganizationsTripsCreatePickupContactNameErrorComponent)
  | ({
      attr: 'pickup.contact_phone_number';
    } & PartnersOrganizationsTripsCreatePickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'dropoff.non_field_errors';
    } & PartnersOrganizationsTripsCreateDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'dropoff.number';
    } & PartnersOrganizationsTripsCreateDropoffNumberErrorComponent)
  | ({
      attr: 'dropoff.street';
    } & PartnersOrganizationsTripsCreateDropoffStreetErrorComponent)
  | ({
      attr: 'dropoff.detail';
    } & PartnersOrganizationsTripsCreateDropoffDetailErrorComponent)
  | ({
      attr: 'dropoff.city';
    } & PartnersOrganizationsTripsCreateDropoffCityErrorComponent)
  | ({
      attr: 'dropoff.state';
    } & PartnersOrganizationsTripsCreateDropoffStateErrorComponent)
  | ({
      attr: 'dropoff.zip';
    } & PartnersOrganizationsTripsCreateDropoffZipErrorComponent)
  | ({
      attr: 'dropoff.country';
    } & PartnersOrganizationsTripsCreateDropoffCountryErrorComponent)
  | ({
      attr: 'dropoff.latitude';
    } & PartnersOrganizationsTripsCreateDropoffLatitudeErrorComponent)
  | ({
      attr: 'dropoff.longitude';
    } & PartnersOrganizationsTripsCreateDropoffLongitudeErrorComponent)
  | ({
      attr: 'dropoff.driver_notes';
    } & PartnersOrganizationsTripsCreateDropoffDriverNotesErrorComponent)
  | ({
      attr: 'dropoff.num_stairs';
    } & PartnersOrganizationsTripsCreateDropoffNumStairsErrorComponent)
  | ({
      attr: 'dropoff.contact_name';
    } & PartnersOrganizationsTripsCreateDropoffContactNameErrorComponent)
  | ({
      attr: 'dropoff.contact_phone_number';
    } & PartnersOrganizationsTripsCreateDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'dispatcher_notes';
    } & PartnersOrganizationsTripsCreateDispatcherNotesErrorComponent)
  | ({
      attr: 'is_will_call';
    } & PartnersOrganizationsTripsCreateIsWillCallErrorComponent)
  | ({
      attr: 'space_type';
    } & PartnersOrganizationsTripsCreateSpaceTypeErrorComponent)
  | ({
      attr: 'service_type';
    } & PartnersOrganizationsTripsCreateServiceTypeErrorComponent)
  | ({
      attr: 'must_provide_wheelchair';
    } & PartnersOrganizationsTripsCreateMustProvideWheelchairErrorComponent)
  | ({
      attr: 'is_oxygen_required';
    } & PartnersOrganizationsTripsCreateIsOxygenRequiredErrorComponent)
  | ({
      attr: 'oxygen_liters_per_min';
    } & PartnersOrganizationsTripsCreateOxygenLitersPerMinErrorComponent)
  | ({
      attr: 'num_attendants_needed';
    } & PartnersOrganizationsTripsCreateNumAttendantsNeededErrorComponent)
  | ({
      attr: 'num_accompanying_passengers';
    } & PartnersOrganizationsTripsCreateNumAccompanyingPassengersErrorComponent)
  | ({
      attr: 'has_infectious_disease';
    } & PartnersOrganizationsTripsCreateHasInfectiousDiseaseErrorComponent)
  | ({
      attr: 'seat_equipment';
    } & PartnersOrganizationsTripsCreateSeatEquipmentErrorComponent);
export type PartnersOrganizationsTripsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PartnersOrganizationsTripsCreateError[];
};
export type PartnersOrganizationsTripsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PartnersOrganizationsTripsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PartnersOrganizationsTripsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PartnerTripActivateWillCall = {};
export type PartnerTripActivateWillCallWrite = {
  /** The new requested pickup time for the trip, Ex: `2025-01-01T00:00:00Z`. If not provided, defaults to the current time */
  requested_pickup_at?: string;
};
export type PartnersOrganizationsTripsActivateWillCallCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PartnersOrganizationsTripsActivateWillCallCreateRequestedPickupAtErrorComponent =
  {
    attr: 'requested_pickup_at';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
    detail: string;
  };
export type PartnersOrganizationsTripsActivateWillCallCreateError =
  | ({
      attr: 'non_field_errors';
    } & PartnersOrganizationsTripsActivateWillCallCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'requested_pickup_at';
    } & PartnersOrganizationsTripsActivateWillCallCreateRequestedPickupAtErrorComponent);
export type PartnersOrganizationsTripsActivateWillCallCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PartnersOrganizationsTripsActivateWillCallCreateError[];
};
export type PartnersOrganizationsTripsActivateWillCallCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PartnersOrganizationsTripsActivateWillCallCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PartnerTripCancel = {};
export type PartnerTripCancelWrite = {
  /** The reason for canceling the trip, Ex: `appointment canceled` */
  reason: CanceledReasonEnum;
};
export type PartnersOrganizationsTripsCancelCreateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PartnersOrganizationsTripsCancelCreateReasonErrorComponent = {
  attr: 'reason';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type PartnersOrganizationsTripsCancelCreateError =
  | ({
      attr: 'non_field_errors';
    } & PartnersOrganizationsTripsCancelCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'reason';
    } & PartnersOrganizationsTripsCancelCreateReasonErrorComponent);
export type PartnersOrganizationsTripsCancelCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PartnersOrganizationsTripsCancelCreateError[];
};
export type PartnersOrganizationsTripsCancelCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PartnersOrganizationsTripsCancelCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PassengerTag = {
  passenger: string;
  tag: string;
};
export type PassengerTagRead = {
  id: string;
  tag_name: string;
  color_hex: string;
  passenger: string;
  tag: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedPassengerTagList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PassengerTag[];
};
export type PaginatedPassengerTagListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PassengerTagRead[];
};
export type PassengerTagsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengerTagBulkCreate = {
  tags: PassengerTag[];
};
export type PassengerTagBulkCreateRead = {
  tags: PassengerTagRead[];
};
export type PassengerTagsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PassengerTagsCreateTagsNonFieldErrorsErrorComponent = {
  attr: 'tags.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type PassengerTagsCreateTagsIndexNonFieldErrorsErrorComponent = {
  attr: 'tags.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required' | 'unique';
  detail: string;
};
export type PassengerTagsCreateTagsIndexPassengerErrorComponent = {
  attr: 'tags.INDEX.passenger';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type PassengerTagsCreateTagsIndexTagErrorComponent = {
  attr: 'tags.INDEX.tag';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type PassengerTagsCreateError =
  | ({
      attr: 'non_field_errors';
    } & PassengerTagsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.non_field_errors';
    } & PassengerTagsCreateTagsNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.INDEX.non_field_errors';
    } & PassengerTagsCreateTagsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.INDEX.passenger';
    } & PassengerTagsCreateTagsIndexPassengerErrorComponent)
  | ({
      attr: 'tags.INDEX.tag';
    } & PassengerTagsCreateTagsIndexTagErrorComponent);
export type PassengerTagsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PassengerTagsCreateError[];
};
export type PassengerTagsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengerTagsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PassengerTagsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengerTagsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PronounEnum = 'she' | 'he' | 'they';
export type GenderEnum = 'female' | 'male' | 'other';
export type Passenger = {
  first_name: string;
  last_name: string;
  preferred_name?: string;
  pronoun?: PronounEnum | BlankEnum;
  /** Patient gender according to their primary insurance */
  gender?: GenderEnum | BlankEnum;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  is_student?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
  /** Notes, but not exposed to drivers */
  dispatcher_notes?: string;
  billing_address?: PassengerAddress | null;
  payer_ids?: string[] | null;
  /** allow sms messages to be sent to passenger (opt-in) */
  allow_sms_message?: boolean;
  deleted_at?: string | null;
};
export type PassengerRead = {
  id: string;
  organization_id: string;
  first_name: string;
  last_name: string;
  full_name: string;
  preferred_name?: string;
  pronoun?: PronounEnum | BlankEnum;
  /** Patient gender according to their primary insurance */
  gender?: GenderEnum | BlankEnum;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  is_student?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
  /** Notes, but not exposed to drivers */
  dispatcher_notes?: string;
  created_at: string;
  updated_at: string;
  billing_address?: PassengerAddressRead | null;
  payer_ids?: string[] | null;
  has_tilled_account: boolean;
  /** allow sms messages to be sent to passenger (opt-in) */
  allow_sms_message?: boolean;
  deleted_at?: string | null;
};
export type PaginatedPassengerList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Passenger[];
};
export type PaginatedPassengerListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PassengerRead[];
};
export type PassengersListGenderErrorComponent = {
  attr: 'gender';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type PassengersListError = {
  attr: 'gender';
} & PassengersListGenderErrorComponent;
export type PassengersListValidationError = {
  type: ValidationErrorEnum;
  errors: PassengersListError[];
};
export type PassengersListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengersListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PassengersCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PassengersCreateFirstNameErrorComponent = {
  attr: 'first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersCreateLastNameErrorComponent = {
  attr: 'last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersCreatePreferredNameErrorComponent = {
  attr: 'preferred_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersCreatePronounErrorComponent = {
  attr: 'pronoun';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PassengersCreateGenderErrorComponent = {
  attr: 'gender';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PassengersCreateDobErrorComponent = {
  attr: 'dob';
  code: 'datetime' | 'invalid';
  detail: string;
};
export type PassengersCreateWeightErrorComponent = {
  attr: 'weight';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PassengersCreateNeedsBariatricTransportErrorComponent = {
  attr: 'needs_bariatric_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type PassengersCreateIsStudentErrorComponent = {
  attr: 'is_student';
  code: 'invalid' | 'null';
  detail: string;
};
export type PassengersCreatePhoneNumberErrorComponent = {
  attr: 'phone_number';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersCreateEmailErrorComponent = {
  attr: 'email';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersCreateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersCreateDispatcherNotesErrorComponent = {
  attr: 'dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersCreateBillingAddressNonFieldErrorsErrorComponent = {
  attr: 'billing_address.non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PassengersCreateBillingAddressAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'billing_address.address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PassengersCreateBillingAddressAddressLocationPlaceIdErrorComponent =
  {
    attr: 'billing_address.address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PassengersCreateBillingAddressAddressLabelErrorComponent = {
  attr: 'billing_address.address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersCreateBillingAddressAddressLabel2ErrorComponent = {
  attr: 'billing_address.address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersCreateBillingAddressAddressAddressNotesErrorComponent = {
  attr: 'billing_address.address.address_notes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersCreateBillingAddressAddressAddressTypeErrorComponent = {
  attr: 'billing_address.address.address_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PassengersCreatePayerIdsErrorComponent = {
  attr: 'payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type PassengersCreatePayerIdsIndexErrorComponent = {
  attr: 'payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PassengersCreateAllowSmsMessageErrorComponent = {
  attr: 'allow_sms_message';
  code: 'invalid' | 'null';
  detail: string;
};
export type PassengersCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type PassengersCreateError =
  | ({
      attr: 'non_field_errors';
    } & PassengersCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'first_name';
    } & PassengersCreateFirstNameErrorComponent)
  | ({
      attr: 'last_name';
    } & PassengersCreateLastNameErrorComponent)
  | ({
      attr: 'preferred_name';
    } & PassengersCreatePreferredNameErrorComponent)
  | ({
      attr: 'pronoun';
    } & PassengersCreatePronounErrorComponent)
  | ({
      attr: 'gender';
    } & PassengersCreateGenderErrorComponent)
  | ({
      attr: 'dob';
    } & PassengersCreateDobErrorComponent)
  | ({
      attr: 'weight';
    } & PassengersCreateWeightErrorComponent)
  | ({
      attr: 'needs_bariatric_transport';
    } & PassengersCreateNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'is_student';
    } & PassengersCreateIsStudentErrorComponent)
  | ({
      attr: 'phone_number';
    } & PassengersCreatePhoneNumberErrorComponent)
  | ({
      attr: 'email';
    } & PassengersCreateEmailErrorComponent)
  | ({
      attr: 'notes';
    } & PassengersCreateNotesErrorComponent)
  | ({
      attr: 'dispatcher_notes';
    } & PassengersCreateDispatcherNotesErrorComponent)
  | ({
      attr: 'billing_address.non_field_errors';
    } & PassengersCreateBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'billing_address.address.location.non_field_errors';
    } & PassengersCreateBillingAddressAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'billing_address.address.location.place_id';
    } & PassengersCreateBillingAddressAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'billing_address.address.label';
    } & PassengersCreateBillingAddressAddressLabelErrorComponent)
  | ({
      attr: 'billing_address.address.label2';
    } & PassengersCreateBillingAddressAddressLabel2ErrorComponent)
  | ({
      attr: 'billing_address.address.address_notes';
    } & PassengersCreateBillingAddressAddressAddressNotesErrorComponent)
  | ({
      attr: 'billing_address.address.address_type';
    } & PassengersCreateBillingAddressAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer_ids';
    } & PassengersCreatePayerIdsErrorComponent)
  | ({
      attr: 'payer_ids.INDEX';
    } & PassengersCreatePayerIdsIndexErrorComponent)
  | ({
      attr: 'allow_sms_message';
    } & PassengersCreateAllowSmsMessageErrorComponent)
  | ({
      attr: 'deleted_at';
    } & PassengersCreateDeletedAtErrorComponent);
export type PassengersCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PassengersCreateError[];
};
export type PassengersCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengersCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PassengerAlternateIdentifier = {
  identifier: string;
  identifier_source: string;
};
export type PassengerAlternateIdentifierRead = {
  id: string;
  passenger: string;
  identifier: string;
  identifier_source: string;
};
export type PaginatedPassengerAlternateIdentifierList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PassengerAlternateIdentifier[];
};
export type PaginatedPassengerAlternateIdentifierListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PassengerAlternateIdentifierRead[];
};
export type PassengersAlternateIdentifiersListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengersAlternateIdentifiersCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PassengersAlternateIdentifiersCreateIdentifierErrorComponent = {
  attr: 'identifier';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersAlternateIdentifiersCreateIdentifierSourceErrorComponent =
  {
    attr: 'identifier_source';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PassengersAlternateIdentifiersCreateError =
  | ({
      attr: 'non_field_errors';
    } & PassengersAlternateIdentifiersCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'identifier';
    } & PassengersAlternateIdentifiersCreateIdentifierErrorComponent)
  | ({
      attr: 'identifier_source';
    } & PassengersAlternateIdentifiersCreateIdentifierSourceErrorComponent);
export type PassengersAlternateIdentifiersCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PassengersAlternateIdentifiersCreateError[];
};
export type PassengersAlternateIdentifiersCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengersAlternateIdentifiersCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PassengersAlternateIdentifiersRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengersAlternateIdentifiersPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PassengersAlternateIdentifiersPartialUpdateIdentifierErrorComponent =
  {
    attr: 'identifier';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PassengersAlternateIdentifiersPartialUpdateIdentifierSourceErrorComponent =
  {
    attr: 'identifier_source';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PassengersAlternateIdentifiersPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & PassengersAlternateIdentifiersPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'identifier';
    } & PassengersAlternateIdentifiersPartialUpdateIdentifierErrorComponent)
  | ({
      attr: 'identifier_source';
    } & PassengersAlternateIdentifiersPartialUpdateIdentifierSourceErrorComponent);
export type PassengersAlternateIdentifiersPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: PassengersAlternateIdentifiersPartialUpdateError[];
};
export type PassengersAlternateIdentifiersPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengersAlternateIdentifiersPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedPassengerAlternateIdentifier = {
  identifier?: string;
  identifier_source?: string;
};
export type PatchedPassengerAlternateIdentifierRead = {
  id?: string;
  passenger?: string;
  identifier?: string;
  identifier_source?: string;
};
export type PassengersAlternateIdentifiersDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PreferenceTypeEnum = 'prefer' | 'avoid' | 'demand' | 'prohibit';
export type PreferredDriver = {
  driver: string;
  preference_type: PreferenceTypeEnum;
  notes?: string;
};
export type PreferredDriverRead = {
  id: string;
  driver: string;
  preference_type: PreferenceTypeEnum;
  notes?: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedPreferredDriverList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PreferredDriver[];
};
export type PaginatedPreferredDriverListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PreferredDriverRead[];
};
export type PassengersPreferredDriversListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengersPreferredDriversCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PassengersPreferredDriversCreateDriverErrorComponent = {
  attr: 'driver';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type PassengersPreferredDriversCreatePreferenceTypeErrorComponent = {
  attr: 'preference_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type PassengersPreferredDriversCreateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPreferredDriversCreateError =
  | ({
      attr: 'non_field_errors';
    } & PassengersPreferredDriversCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'driver';
    } & PassengersPreferredDriversCreateDriverErrorComponent)
  | ({
      attr: 'preference_type';
    } & PassengersPreferredDriversCreatePreferenceTypeErrorComponent)
  | ({
      attr: 'notes';
    } & PassengersPreferredDriversCreateNotesErrorComponent);
export type PassengersPreferredDriversCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PassengersPreferredDriversCreateError[];
};
export type PassengersPreferredDriversCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengersPreferredDriversCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PassengersPreferredDriversRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengersPreferredDriversPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PassengersPreferredDriversPartialUpdateDriverErrorComponent = {
  attr: 'driver';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type PassengersPreferredDriversPartialUpdatePreferenceTypeErrorComponent =
  {
    attr: 'preference_type';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type PassengersPreferredDriversPartialUpdateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPreferredDriversPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & PassengersPreferredDriversPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'driver';
    } & PassengersPreferredDriversPartialUpdateDriverErrorComponent)
  | ({
      attr: 'preference_type';
    } & PassengersPreferredDriversPartialUpdatePreferenceTypeErrorComponent)
  | ({
      attr: 'notes';
    } & PassengersPreferredDriversPartialUpdateNotesErrorComponent);
export type PassengersPreferredDriversPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: PassengersPreferredDriversPartialUpdateError[];
};
export type PassengersPreferredDriversPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengersPreferredDriversPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedPreferredDriver = {
  driver?: string;
  preference_type?: PreferenceTypeEnum;
  notes?: string;
};
export type PatchedPreferredDriverRead = {
  id?: string;
  driver?: string;
  preference_type?: PreferenceTypeEnum;
  notes?: string;
  created_at?: string;
  updated_at?: string;
};
export type PassengersPreferredDriversDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengersRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengersPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PassengersPartialUpdateFirstNameErrorComponent = {
  attr: 'first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPartialUpdateLastNameErrorComponent = {
  attr: 'last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPartialUpdatePreferredNameErrorComponent = {
  attr: 'preferred_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPartialUpdatePronounErrorComponent = {
  attr: 'pronoun';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PassengersPartialUpdateGenderErrorComponent = {
  attr: 'gender';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PassengersPartialUpdateDobErrorComponent = {
  attr: 'dob';
  code: 'datetime' | 'invalid';
  detail: string;
};
export type PassengersPartialUpdateWeightErrorComponent = {
  attr: 'weight';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PassengersPartialUpdateNeedsBariatricTransportErrorComponent = {
  attr: 'needs_bariatric_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type PassengersPartialUpdateIsStudentErrorComponent = {
  attr: 'is_student';
  code: 'invalid' | 'null';
  detail: string;
};
export type PassengersPartialUpdatePhoneNumberErrorComponent = {
  attr: 'phone_number';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPartialUpdateEmailErrorComponent = {
  attr: 'email';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPartialUpdateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPartialUpdateDispatcherNotesErrorComponent = {
  attr: 'dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPartialUpdateBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PassengersPartialUpdateBillingAddressAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'billing_address.address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PassengersPartialUpdateBillingAddressAddressLocationPlaceIdErrorComponent =
  {
    attr: 'billing_address.address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PassengersPartialUpdateBillingAddressAddressLabelErrorComponent = {
  attr: 'billing_address.address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPartialUpdateBillingAddressAddressLabel2ErrorComponent = {
  attr: 'billing_address.address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersPartialUpdateBillingAddressAddressAddressNotesErrorComponent =
  {
    attr: 'billing_address.address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PassengersPartialUpdateBillingAddressAddressAddressTypeErrorComponent =
  {
    attr: 'billing_address.address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type PassengersPartialUpdatePayerIdsErrorComponent = {
  attr: 'payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type PassengersPartialUpdatePayerIdsIndexErrorComponent = {
  attr: 'payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PassengersPartialUpdateAllowSmsMessageErrorComponent = {
  attr: 'allow_sms_message';
  code: 'invalid' | 'null';
  detail: string;
};
export type PassengersPartialUpdateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type PassengersPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & PassengersPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'first_name';
    } & PassengersPartialUpdateFirstNameErrorComponent)
  | ({
      attr: 'last_name';
    } & PassengersPartialUpdateLastNameErrorComponent)
  | ({
      attr: 'preferred_name';
    } & PassengersPartialUpdatePreferredNameErrorComponent)
  | ({
      attr: 'pronoun';
    } & PassengersPartialUpdatePronounErrorComponent)
  | ({
      attr: 'gender';
    } & PassengersPartialUpdateGenderErrorComponent)
  | ({
      attr: 'dob';
    } & PassengersPartialUpdateDobErrorComponent)
  | ({
      attr: 'weight';
    } & PassengersPartialUpdateWeightErrorComponent)
  | ({
      attr: 'needs_bariatric_transport';
    } & PassengersPartialUpdateNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'is_student';
    } & PassengersPartialUpdateIsStudentErrorComponent)
  | ({
      attr: 'phone_number';
    } & PassengersPartialUpdatePhoneNumberErrorComponent)
  | ({
      attr: 'email';
    } & PassengersPartialUpdateEmailErrorComponent)
  | ({
      attr: 'notes';
    } & PassengersPartialUpdateNotesErrorComponent)
  | ({
      attr: 'dispatcher_notes';
    } & PassengersPartialUpdateDispatcherNotesErrorComponent)
  | ({
      attr: 'billing_address.non_field_errors';
    } & PassengersPartialUpdateBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'billing_address.address.location.non_field_errors';
    } & PassengersPartialUpdateBillingAddressAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'billing_address.address.location.place_id';
    } & PassengersPartialUpdateBillingAddressAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'billing_address.address.label';
    } & PassengersPartialUpdateBillingAddressAddressLabelErrorComponent)
  | ({
      attr: 'billing_address.address.label2';
    } & PassengersPartialUpdateBillingAddressAddressLabel2ErrorComponent)
  | ({
      attr: 'billing_address.address.address_notes';
    } & PassengersPartialUpdateBillingAddressAddressAddressNotesErrorComponent)
  | ({
      attr: 'billing_address.address.address_type';
    } & PassengersPartialUpdateBillingAddressAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer_ids';
    } & PassengersPartialUpdatePayerIdsErrorComponent)
  | ({
      attr: 'payer_ids.INDEX';
    } & PassengersPartialUpdatePayerIdsIndexErrorComponent)
  | ({
      attr: 'allow_sms_message';
    } & PassengersPartialUpdateAllowSmsMessageErrorComponent)
  | ({
      attr: 'deleted_at';
    } & PassengersPartialUpdateDeletedAtErrorComponent);
export type PassengersPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: PassengersPartialUpdateError[];
};
export type PassengersPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengersPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedPassenger = {
  first_name?: string;
  last_name?: string;
  preferred_name?: string;
  pronoun?: PronounEnum | BlankEnum;
  /** Patient gender according to their primary insurance */
  gender?: GenderEnum | BlankEnum;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  is_student?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
  /** Notes, but not exposed to drivers */
  dispatcher_notes?: string;
  billing_address?: PassengerAddress | null;
  payer_ids?: string[] | null;
  /** allow sms messages to be sent to passenger (opt-in) */
  allow_sms_message?: boolean;
  deleted_at?: string | null;
};
export type PatchedPassengerRead = {
  id?: string;
  organization_id?: string;
  first_name?: string;
  last_name?: string;
  full_name?: string;
  preferred_name?: string;
  pronoun?: PronounEnum | BlankEnum;
  /** Patient gender according to their primary insurance */
  gender?: GenderEnum | BlankEnum;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  is_student?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
  /** Notes, but not exposed to drivers */
  dispatcher_notes?: string;
  created_at?: string;
  updated_at?: string;
  billing_address?: PassengerAddressRead | null;
  payer_ids?: string[] | null;
  has_tilled_account?: boolean;
  /** allow sms messages to be sent to passenger (opt-in) */
  allow_sms_message?: boolean;
  deleted_at?: string | null;
};
export type PassengersDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengersRecentAddressesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayerPassenger = {
  external_id?: string;
  /** Authorization ID associated with the passenger for insurance payers */
  authorization_id?: string | null;
};
export type PayerPassengerRead = {
  id: string;
  payer_organization_id: string;
  passenger_id: string;
  external_id?: string;
  /** Authorization ID associated with the passenger for insurance payers */
  authorization_id?: string | null;
  /** Last time this payer was used in a trip */
  last_used_at: string | null;
  passenger: string;
  payer_organization: PayerOrganizationRead;
  organization_id: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedPayerPassengerList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerPassenger[];
};
export type PaginatedPayerPassengerListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerPassengerRead[];
};
export type PassengersRecentPayersListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PassengersUndeleteCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PassengersUndeleteCreateFirstNameErrorComponent = {
  attr: 'first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersUndeleteCreateLastNameErrorComponent = {
  attr: 'last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersUndeleteCreatePreferredNameErrorComponent = {
  attr: 'preferred_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersUndeleteCreatePronounErrorComponent = {
  attr: 'pronoun';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PassengersUndeleteCreateGenderErrorComponent = {
  attr: 'gender';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PassengersUndeleteCreateDobErrorComponent = {
  attr: 'dob';
  code: 'datetime' | 'invalid';
  detail: string;
};
export type PassengersUndeleteCreateWeightErrorComponent = {
  attr: 'weight';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PassengersUndeleteCreateNeedsBariatricTransportErrorComponent = {
  attr: 'needs_bariatric_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type PassengersUndeleteCreateIsStudentErrorComponent = {
  attr: 'is_student';
  code: 'invalid' | 'null';
  detail: string;
};
export type PassengersUndeleteCreatePhoneNumberErrorComponent = {
  attr: 'phone_number';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersUndeleteCreateEmailErrorComponent = {
  attr: 'email';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersUndeleteCreateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersUndeleteCreateDispatcherNotesErrorComponent = {
  attr: 'dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersUndeleteCreateBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PassengersUndeleteCreateBillingAddressAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'billing_address.address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PassengersUndeleteCreateBillingAddressAddressLocationPlaceIdErrorComponent =
  {
    attr: 'billing_address.address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PassengersUndeleteCreateBillingAddressAddressLabelErrorComponent = {
  attr: 'billing_address.address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PassengersUndeleteCreateBillingAddressAddressLabel2ErrorComponent =
  {
    attr: 'billing_address.address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PassengersUndeleteCreateBillingAddressAddressAddressNotesErrorComponent =
  {
    attr: 'billing_address.address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PassengersUndeleteCreateBillingAddressAddressAddressTypeErrorComponent =
  {
    attr: 'billing_address.address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type PassengersUndeleteCreatePayerIdsErrorComponent = {
  attr: 'payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type PassengersUndeleteCreatePayerIdsIndexErrorComponent = {
  attr: 'payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PassengersUndeleteCreateAllowSmsMessageErrorComponent = {
  attr: 'allow_sms_message';
  code: 'invalid' | 'null';
  detail: string;
};
export type PassengersUndeleteCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type PassengersUndeleteCreateError =
  | ({
      attr: 'non_field_errors';
    } & PassengersUndeleteCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'first_name';
    } & PassengersUndeleteCreateFirstNameErrorComponent)
  | ({
      attr: 'last_name';
    } & PassengersUndeleteCreateLastNameErrorComponent)
  | ({
      attr: 'preferred_name';
    } & PassengersUndeleteCreatePreferredNameErrorComponent)
  | ({
      attr: 'pronoun';
    } & PassengersUndeleteCreatePronounErrorComponent)
  | ({
      attr: 'gender';
    } & PassengersUndeleteCreateGenderErrorComponent)
  | ({
      attr: 'dob';
    } & PassengersUndeleteCreateDobErrorComponent)
  | ({
      attr: 'weight';
    } & PassengersUndeleteCreateWeightErrorComponent)
  | ({
      attr: 'needs_bariatric_transport';
    } & PassengersUndeleteCreateNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'is_student';
    } & PassengersUndeleteCreateIsStudentErrorComponent)
  | ({
      attr: 'phone_number';
    } & PassengersUndeleteCreatePhoneNumberErrorComponent)
  | ({
      attr: 'email';
    } & PassengersUndeleteCreateEmailErrorComponent)
  | ({
      attr: 'notes';
    } & PassengersUndeleteCreateNotesErrorComponent)
  | ({
      attr: 'dispatcher_notes';
    } & PassengersUndeleteCreateDispatcherNotesErrorComponent)
  | ({
      attr: 'billing_address.non_field_errors';
    } & PassengersUndeleteCreateBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'billing_address.address.location.non_field_errors';
    } & PassengersUndeleteCreateBillingAddressAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'billing_address.address.location.place_id';
    } & PassengersUndeleteCreateBillingAddressAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'billing_address.address.label';
    } & PassengersUndeleteCreateBillingAddressAddressLabelErrorComponent)
  | ({
      attr: 'billing_address.address.label2';
    } & PassengersUndeleteCreateBillingAddressAddressLabel2ErrorComponent)
  | ({
      attr: 'billing_address.address.address_notes';
    } & PassengersUndeleteCreateBillingAddressAddressAddressNotesErrorComponent)
  | ({
      attr: 'billing_address.address.address_type';
    } & PassengersUndeleteCreateBillingAddressAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer_ids';
    } & PassengersUndeleteCreatePayerIdsErrorComponent)
  | ({
      attr: 'payer_ids.INDEX';
    } & PassengersUndeleteCreatePayerIdsIndexErrorComponent)
  | ({
      attr: 'allow_sms_message';
    } & PassengersUndeleteCreateAllowSmsMessageErrorComponent)
  | ({
      attr: 'deleted_at';
    } & PassengersUndeleteCreateDeletedAtErrorComponent);
export type PassengersUndeleteCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PassengersUndeleteCreateError[];
};
export type PassengersUndeleteCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengersUndeleteCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PassengerDuplicate = {};
export type PassengerAndAddress = {
  first_name: string;
  last_name: string;
  preferred_name?: string;
  pronoun?: PronounEnum | BlankEnum;
  /** Patient gender according to their primary insurance */
  gender?: GenderEnum | BlankEnum;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  is_student?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
  /** Notes, but not exposed to drivers */
  dispatcher_notes?: string;
  billing_address?: PassengerAddress | null;
  payer_ids?: string[] | null;
  /** allow sms messages to be sent to passenger (opt-in) */
  allow_sms_message?: boolean;
  deleted_at?: string | null;
  passenger_addresses: PassengerAddress[];
};
export type PassengerAndAddressRead = {
  id: string;
  organization_id: string;
  first_name: string;
  last_name: string;
  full_name: string;
  preferred_name?: string;
  pronoun?: PronounEnum | BlankEnum;
  /** Patient gender according to their primary insurance */
  gender?: GenderEnum | BlankEnum;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  is_student?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
  /** Notes, but not exposed to drivers */
  dispatcher_notes?: string;
  created_at: string;
  updated_at: string;
  billing_address?: PassengerAddressRead | null;
  payer_ids?: string[] | null;
  has_tilled_account: boolean;
  /** allow sms messages to be sent to passenger (opt-in) */
  allow_sms_message?: boolean;
  deleted_at?: string | null;
  passenger_addresses: PassengerAddressRead[];
};
export type PassengerDuplicateRead = {
  base_passenger: PassengerAndAddressRead;
  possible_duplicates: PassengerAndAddressRead[];
};
export type PaginatedPassengerDuplicateList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PassengerDuplicate[];
};
export type PaginatedPassengerDuplicateListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PassengerDuplicateRead[];
};
export type PassengersDuplicatesListFirstNameStartsWithErrorComponent = {
  attr: 'first_name_starts_with';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type PassengersDuplicatesListLastNameStartsWithErrorComponent = {
  attr: 'last_name_starts_with';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type PassengersDuplicatesListCreatedAtStartErrorComponent = {
  attr: 'created_at_start';
  code: 'invalid';
  detail: string;
};
export type PassengersDuplicatesListCreatedAtEndErrorComponent = {
  attr: 'created_at_end';
  code: 'invalid';
  detail: string;
};
export type PassengersDuplicatesListError =
  | ({
      attr: 'first_name_starts_with';
    } & PassengersDuplicatesListFirstNameStartsWithErrorComponent)
  | ({
      attr: 'last_name_starts_with';
    } & PassengersDuplicatesListLastNameStartsWithErrorComponent)
  | ({
      attr: 'created_at_start';
    } & PassengersDuplicatesListCreatedAtStartErrorComponent)
  | ({
      attr: 'created_at_end';
    } & PassengersDuplicatesListCreatedAtEndErrorComponent);
export type PassengersDuplicatesListValidationError = {
  type: ValidationErrorEnum;
  errors: PassengersDuplicatesListError[];
};
export type PassengersDuplicatesListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengersDuplicatesListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PassengerMergeError = {
  passenger_id: string;
  error: string;
};
export type PassengerMergeResult = {
  base_passenger: Passenger;
  merge_success: string[];
  merge_failure: string[];
  errors?: PassengerMergeError[] | null;
};
export type PassengerMergeResultRead = {
  base_passenger: PassengerRead;
  merge_success: string[];
  merge_failure: string[];
  errors?: PassengerMergeError[] | null;
};
export type PassengersMergeCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PassengersMergeCreatePassengerIdsErrorComponent = {
  attr: 'passenger_ids';
  code: 'min_length' | 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type PassengersMergeCreatePassengerIdsIndexErrorComponent = {
  attr: 'passenger_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PassengersMergeCreateError =
  | ({
      attr: 'non_field_errors';
    } & PassengersMergeCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'passenger_ids';
    } & PassengersMergeCreatePassengerIdsErrorComponent)
  | ({
      attr: 'passenger_ids.INDEX';
    } & PassengersMergeCreatePassengerIdsIndexErrorComponent);
export type PassengersMergeCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PassengersMergeCreateError[];
};
export type PassengersMergeCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PassengersMergeCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PassengerMergeRequest = {
  passenger_ids: string[];
};
export type PayerOrganizationSettingsTripRequiredFields = {
  _passenger_phone_number?: boolean | null;
  _passenger_weight?: boolean | null;
  _authorization_id?: boolean | null;
  _insurance_policy_id?: boolean | null;
  _payer_passenger_external_id?: boolean | null;
  _external_trip_id?: boolean | null;
  _booked_by_name?: boolean | null;
  _booked_by_phone_number?: boolean | null;
};
export type PayerOrganizationSettings = {
  /** How early a driver can arrive before a pickup time */
  _pickup_default_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time */
  _pickup_default_late_seconds?: number | null;
  /** How early a driver can arrive before a pickup time headed to an appointment */
  _pickup_appointment_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time headed to an appointment */
  _pickup_appointment_late_seconds?: number | null;
  /** How early a driver can arrive before a pickup time for a will call trip */
  _pickup_will_call_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time for a will call trip */
  _pickup_will_call_late_seconds?: number | null;
  /** How many seconds extra is padded to scheduled_pickup_at during a trip import */
  _extra_scheduled_pickup_at_seconds?: number | null;
  /** How many days after an invoice is issued before it's due */
  invoice_due_after_days?: number | null;
  _requires_signature_pickup_passenger?: boolean | null;
  _requires_signature_dropoff_passenger?: boolean | null;
  _requires_signature_pickup_driver?: boolean | null;
  _requires_signature_dropoff_driver?: boolean | null;
  /** Whether to only allow specific vehicles for this payer */
  allow_only_specific_vehicles?: boolean | null;
  allowed_vehicle_ids?: string[] | null;
  /** Whether to only allow specific drivers for this payer */
  allow_only_specific_drivers?: boolean | null;
  allowed_driver_ids?: string[] | null;
  trip_required_fields?: PayerOrganizationSettingsTripRequiredFields | null;
};
export type PayerOrganizationSettingsRead = {
  id: string;
  payer_organization: string;
  /** How early a driver can arrive before a pickup time */
  _pickup_default_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time */
  _pickup_default_late_seconds?: number | null;
  /** How early a driver can arrive before a pickup time headed to an appointment */
  _pickup_appointment_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time headed to an appointment */
  _pickup_appointment_late_seconds?: number | null;
  /** How early a driver can arrive before a pickup time for a will call trip */
  _pickup_will_call_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time for a will call trip */
  _pickup_will_call_late_seconds?: number | null;
  /** How many seconds extra is padded to scheduled_pickup_at during a trip import */
  _extra_scheduled_pickup_at_seconds?: number | null;
  /** How many days after an invoice is issued before it's due */
  invoice_due_after_days?: number | null;
  _requires_signature_pickup_passenger?: boolean | null;
  _requires_signature_dropoff_passenger?: boolean | null;
  _requires_signature_pickup_driver?: boolean | null;
  _requires_signature_dropoff_driver?: boolean | null;
  /** Whether to only allow specific vehicles for this payer */
  allow_only_specific_vehicles?: boolean | null;
  allowed_vehicle_ids?: string[] | null;
  /** Whether to only allow specific drivers for this payer */
  allow_only_specific_drivers?: boolean | null;
  allowed_driver_ids?: string[] | null;
  trip_required_fields?: PayerOrganizationSettingsTripRequiredFields | null;
};
export type PaginatedPayerOrganizationSettingsList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerOrganizationSettings[];
};
export type PaginatedPayerOrganizationSettingsListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerOrganizationSettingsRead[];
};
export type PayerSettingsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayerSettingsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayerSettingsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayerSettingsPartialUpdatePickupDefaultEarlySecondsErrorComponent =
  {
    attr: '_pickup_default_early_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayerSettingsPartialUpdatePickupDefaultLateSecondsErrorComponent = {
  attr: '_pickup_default_late_seconds';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PayerSettingsPartialUpdatePickupAppointmentEarlySecondsErrorComponent =
  {
    attr: '_pickup_appointment_early_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayerSettingsPartialUpdatePickupAppointmentLateSecondsErrorComponent =
  {
    attr: '_pickup_appointment_late_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayerSettingsPartialUpdatePickupWillCallEarlySecondsErrorComponent =
  {
    attr: '_pickup_will_call_early_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayerSettingsPartialUpdatePickupWillCallLateSecondsErrorComponent =
  {
    attr: '_pickup_will_call_late_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayerSettingsPartialUpdateExtraScheduledPickupAtSecondsErrorComponent =
  {
    attr: '_extra_scheduled_pickup_at_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayerSettingsPartialUpdateInvoiceDueAfterDaysErrorComponent = {
  attr: 'invoice_due_after_days';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PayerSettingsPartialUpdateRequiresSignaturePickupPassengerErrorComponent =
  {
    attr: '_requires_signature_pickup_passenger';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateRequiresSignatureDropoffPassengerErrorComponent =
  {
    attr: '_requires_signature_dropoff_passenger';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateRequiresSignaturePickupDriverErrorComponent =
  {
    attr: '_requires_signature_pickup_driver';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateRequiresSignatureDropoffDriverErrorComponent =
  {
    attr: '_requires_signature_dropoff_driver';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateAllowOnlySpecificVehiclesErrorComponent =
  {
    attr: 'allow_only_specific_vehicles';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateAllowedVehicleIdsErrorComponent = {
  attr: 'allowed_vehicle_ids';
  code: 'not_a_list';
  detail: string;
};
export type PayerSettingsPartialUpdateAllowedVehicleIdsIndexErrorComponent = {
  attr: 'allowed_vehicle_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PayerSettingsPartialUpdateAllowOnlySpecificDriversErrorComponent = {
  attr: 'allow_only_specific_drivers';
  code: 'invalid';
  detail: string;
};
export type PayerSettingsPartialUpdateAllowedDriverIdsErrorComponent = {
  attr: 'allowed_driver_ids';
  code: 'not_a_list';
  detail: string;
};
export type PayerSettingsPartialUpdateAllowedDriverIdsIndexErrorComponent = {
  attr: 'allowed_driver_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PayerSettingsPartialUpdateTripRequiredFieldsNonFieldErrorsErrorComponent =
  {
    attr: 'trip_required_fields.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateTripRequiredFieldsPassengerPhoneNumberErrorComponent =
  {
    attr: 'trip_required_fields._passenger_phone_number';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateTripRequiredFieldsPassengerWeightErrorComponent =
  {
    attr: 'trip_required_fields._passenger_weight';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateTripRequiredFieldsAuthorizationIdErrorComponent =
  {
    attr: 'trip_required_fields._authorization_id';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateTripRequiredFieldsInsurancePolicyIdErrorComponent =
  {
    attr: 'trip_required_fields._insurance_policy_id';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateTripRequiredFieldsPayerPassengerExternalIdErrorComponent =
  {
    attr: 'trip_required_fields._payer_passenger_external_id';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateTripRequiredFieldsExternalTripIdErrorComponent =
  {
    attr: 'trip_required_fields._external_trip_id';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateTripRequiredFieldsBookedByNameErrorComponent =
  {
    attr: 'trip_required_fields._booked_by_name';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateTripRequiredFieldsBookedByPhoneNumberErrorComponent =
  {
    attr: 'trip_required_fields._booked_by_phone_number';
    code: 'invalid';
    detail: string;
  };
export type PayerSettingsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & PayerSettingsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: '_pickup_default_early_seconds';
    } & PayerSettingsPartialUpdatePickupDefaultEarlySecondsErrorComponent)
  | ({
      attr: '_pickup_default_late_seconds';
    } & PayerSettingsPartialUpdatePickupDefaultLateSecondsErrorComponent)
  | ({
      attr: '_pickup_appointment_early_seconds';
    } & PayerSettingsPartialUpdatePickupAppointmentEarlySecondsErrorComponent)
  | ({
      attr: '_pickup_appointment_late_seconds';
    } & PayerSettingsPartialUpdatePickupAppointmentLateSecondsErrorComponent)
  | ({
      attr: '_pickup_will_call_early_seconds';
    } & PayerSettingsPartialUpdatePickupWillCallEarlySecondsErrorComponent)
  | ({
      attr: '_pickup_will_call_late_seconds';
    } & PayerSettingsPartialUpdatePickupWillCallLateSecondsErrorComponent)
  | ({
      attr: '_extra_scheduled_pickup_at_seconds';
    } & PayerSettingsPartialUpdateExtraScheduledPickupAtSecondsErrorComponent)
  | ({
      attr: 'invoice_due_after_days';
    } & PayerSettingsPartialUpdateInvoiceDueAfterDaysErrorComponent)
  | ({
      attr: '_requires_signature_pickup_passenger';
    } & PayerSettingsPartialUpdateRequiresSignaturePickupPassengerErrorComponent)
  | ({
      attr: '_requires_signature_dropoff_passenger';
    } & PayerSettingsPartialUpdateRequiresSignatureDropoffPassengerErrorComponent)
  | ({
      attr: '_requires_signature_pickup_driver';
    } & PayerSettingsPartialUpdateRequiresSignaturePickupDriverErrorComponent)
  | ({
      attr: '_requires_signature_dropoff_driver';
    } & PayerSettingsPartialUpdateRequiresSignatureDropoffDriverErrorComponent)
  | ({
      attr: 'allow_only_specific_vehicles';
    } & PayerSettingsPartialUpdateAllowOnlySpecificVehiclesErrorComponent)
  | ({
      attr: 'allowed_vehicle_ids';
    } & PayerSettingsPartialUpdateAllowedVehicleIdsErrorComponent)
  | ({
      attr: 'allowed_vehicle_ids.INDEX';
    } & PayerSettingsPartialUpdateAllowedVehicleIdsIndexErrorComponent)
  | ({
      attr: 'allow_only_specific_drivers';
    } & PayerSettingsPartialUpdateAllowOnlySpecificDriversErrorComponent)
  | ({
      attr: 'allowed_driver_ids';
    } & PayerSettingsPartialUpdateAllowedDriverIdsErrorComponent)
  | ({
      attr: 'allowed_driver_ids.INDEX';
    } & PayerSettingsPartialUpdateAllowedDriverIdsIndexErrorComponent)
  | ({
      attr: 'trip_required_fields.non_field_errors';
    } & PayerSettingsPartialUpdateTripRequiredFieldsNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_required_fields._passenger_phone_number';
    } & PayerSettingsPartialUpdateTripRequiredFieldsPassengerPhoneNumberErrorComponent)
  | ({
      attr: 'trip_required_fields._passenger_weight';
    } & PayerSettingsPartialUpdateTripRequiredFieldsPassengerWeightErrorComponent)
  | ({
      attr: 'trip_required_fields._authorization_id';
    } & PayerSettingsPartialUpdateTripRequiredFieldsAuthorizationIdErrorComponent)
  | ({
      attr: 'trip_required_fields._insurance_policy_id';
    } & PayerSettingsPartialUpdateTripRequiredFieldsInsurancePolicyIdErrorComponent)
  | ({
      attr: 'trip_required_fields._payer_passenger_external_id';
    } & PayerSettingsPartialUpdateTripRequiredFieldsPayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'trip_required_fields._external_trip_id';
    } & PayerSettingsPartialUpdateTripRequiredFieldsExternalTripIdErrorComponent)
  | ({
      attr: 'trip_required_fields._booked_by_name';
    } & PayerSettingsPartialUpdateTripRequiredFieldsBookedByNameErrorComponent)
  | ({
      attr: 'trip_required_fields._booked_by_phone_number';
    } & PayerSettingsPartialUpdateTripRequiredFieldsBookedByPhoneNumberErrorComponent);
export type PayerSettingsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: PayerSettingsPartialUpdateError[];
};
export type PayerSettingsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PayerSettingsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedPayerOrganizationSettings = {
  /** How early a driver can arrive before a pickup time */
  _pickup_default_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time */
  _pickup_default_late_seconds?: number | null;
  /** How early a driver can arrive before a pickup time headed to an appointment */
  _pickup_appointment_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time headed to an appointment */
  _pickup_appointment_late_seconds?: number | null;
  /** How early a driver can arrive before a pickup time for a will call trip */
  _pickup_will_call_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time for a will call trip */
  _pickup_will_call_late_seconds?: number | null;
  /** How many seconds extra is padded to scheduled_pickup_at during a trip import */
  _extra_scheduled_pickup_at_seconds?: number | null;
  /** How many days after an invoice is issued before it's due */
  invoice_due_after_days?: number | null;
  _requires_signature_pickup_passenger?: boolean | null;
  _requires_signature_dropoff_passenger?: boolean | null;
  _requires_signature_pickup_driver?: boolean | null;
  _requires_signature_dropoff_driver?: boolean | null;
  /** Whether to only allow specific vehicles for this payer */
  allow_only_specific_vehicles?: boolean | null;
  allowed_vehicle_ids?: string[] | null;
  /** Whether to only allow specific drivers for this payer */
  allow_only_specific_drivers?: boolean | null;
  allowed_driver_ids?: string[] | null;
  trip_required_fields?: PayerOrganizationSettingsTripRequiredFields | null;
};
export type PatchedPayerOrganizationSettingsRead = {
  id?: string;
  payer_organization?: string;
  /** How early a driver can arrive before a pickup time */
  _pickup_default_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time */
  _pickup_default_late_seconds?: number | null;
  /** How early a driver can arrive before a pickup time headed to an appointment */
  _pickup_appointment_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time headed to an appointment */
  _pickup_appointment_late_seconds?: number | null;
  /** How early a driver can arrive before a pickup time for a will call trip */
  _pickup_will_call_early_seconds?: number | null;
  /** How late a driver can arrive after a pickup time for a will call trip */
  _pickup_will_call_late_seconds?: number | null;
  /** How many seconds extra is padded to scheduled_pickup_at during a trip import */
  _extra_scheduled_pickup_at_seconds?: number | null;
  /** How many days after an invoice is issued before it's due */
  invoice_due_after_days?: number | null;
  _requires_signature_pickup_passenger?: boolean | null;
  _requires_signature_dropoff_passenger?: boolean | null;
  _requires_signature_pickup_driver?: boolean | null;
  _requires_signature_dropoff_driver?: boolean | null;
  /** Whether to only allow specific vehicles for this payer */
  allow_only_specific_vehicles?: boolean | null;
  allowed_vehicle_ids?: string[] | null;
  /** Whether to only allow specific drivers for this payer */
  allow_only_specific_drivers?: boolean | null;
  allowed_driver_ids?: string[] | null;
  trip_required_fields?: PayerOrganizationSettingsTripRequiredFields | null;
};
export type PayerInfo = {};
export type PayerInfoRead = {
  id: string;
  name: string;
  website: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedPayerInfoList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerInfo[];
};
export type PaginatedPayerInfoListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerInfoRead[];
};
export type PayerinfoListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayerinfoRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayerInfoOneSchemaTemplate = {};
export type OneSchemaTemplate = {
  id?: string;
  template_key: string;
  template_name: string;
};
export type PayerInfoOneSchemaTemplateRead = {
  payer_info: PayerInfoRead;
  one_schema_template: OneSchemaTemplate;
};
export type PaginatedPayerInfoOneSchemaTemplateList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerInfoOneSchemaTemplate[];
};
export type PaginatedPayerInfoOneSchemaTemplateListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerInfoOneSchemaTemplateRead[];
};
export type PayerinfooneschematemplateListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PaginatedPayerOrganizationList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerOrganization[];
};
export type PaginatedPayerOrganizationListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerOrganizationRead[];
};
export type PayersListIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null_characters_not_allowed';
  detail: string;
};
export type PayersListError = {
  attr: 'id';
} & PayersListIdErrorComponent;
export type PayersListValidationError = {
  type: ValidationErrorEnum;
  errors: PayersListError[];
};
export type PayersListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PayersListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PayersCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersCreatePayerErrorComponent = {
  attr: 'payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type PayersCreateDisplayNameErrorComponent = {
  attr: 'display_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateAlternateNameErrorComponent = {
  attr: 'alternate_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateTypeErrorComponent = {
  attr: 'type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PayersCreateIsActiveErrorComponent = {
  attr: 'is_active';
  code: 'invalid' | 'null';
  detail: string;
};
export type PayersCreateIsSelfPayErrorComponent = {
  attr: 'is_self_pay';
  code: 'invalid';
  detail: string;
};
export type PayersCreateCanMultiloadErrorComponent = {
  attr: 'can_multiload';
  code: 'invalid' | 'null';
  detail: string;
};
export type PayersCreateExternalIdErrorComponent = {
  attr: 'external_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateWebsiteErrorComponent = {
  attr: 'website';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateEinErrorComponent = {
  attr: 'ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateEmailErrorComponent = {
  attr: 'email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreatePhoneNumberErrorComponent = {
  attr: 'phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateBillingNameErrorComponent = {
  attr: 'billing_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateBillingPhoneNumberErrorComponent = {
  attr: 'billing_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateBillingEmailErrorComponent = {
  attr: 'billing_email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateDispatcherNotesErrorComponent = {
  attr: 'dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateAdminNotesErrorComponent = {
  attr: 'admin_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type PayersCreateBillingAddressNonFieldErrorsErrorComponent = {
  attr: 'billing_address.non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersCreateBillingAddressLocationNonFieldErrorsErrorComponent = {
  attr: 'billing_address.location.non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};
export type PayersCreateBillingAddressLocationPlaceIdErrorComponent = {
  attr: 'billing_address.location.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateBillingAddressLabelErrorComponent = {
  attr: 'billing_address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateBillingAddressLabel2ErrorComponent = {
  attr: 'billing_address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateBillingAddressAddressNotesErrorComponent = {
  attr: 'billing_address.address_notes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateBillingAddressAddressTypeErrorComponent = {
  attr: 'billing_address.address_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PayersCreateDefaultTripAddressNonFieldErrorsErrorComponent = {
  attr: 'default_trip_address.non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersCreateDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PayersCreateDefaultTripAddressLocationPlaceIdErrorComponent = {
  attr: 'default_trip_address.location.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateDefaultTripAddressLabelErrorComponent = {
  attr: 'default_trip_address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateDefaultTripAddressLabel2ErrorComponent = {
  attr: 'default_trip_address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateDefaultTripAddressAddressNotesErrorComponent = {
  attr: 'default_trip_address.address_notes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersCreateDefaultTripAddressAddressTypeErrorComponent = {
  attr: 'default_trip_address.address_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PayersCreateMultiloadingPartnersNonFieldErrorsErrorComponent = {
  attr: 'multiloading_partners.non_field_errors';
  code: 'not_a_list';
  detail: string;
};
export type PayersCreateMultiloadingPartnersIndexErrorComponent = {
  attr: 'multiloading_partners.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PayersCreateError =
  | ({
      attr: 'non_field_errors';
    } & PayersCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer';
    } & PayersCreatePayerErrorComponent)
  | ({
      attr: 'display_name';
    } & PayersCreateDisplayNameErrorComponent)
  | ({
      attr: 'alternate_name';
    } & PayersCreateAlternateNameErrorComponent)
  | ({
      attr: 'type';
    } & PayersCreateTypeErrorComponent)
  | ({
      attr: 'is_active';
    } & PayersCreateIsActiveErrorComponent)
  | ({
      attr: 'is_self_pay';
    } & PayersCreateIsSelfPayErrorComponent)
  | ({
      attr: 'can_multiload';
    } & PayersCreateCanMultiloadErrorComponent)
  | ({
      attr: 'external_id';
    } & PayersCreateExternalIdErrorComponent)
  | ({
      attr: 'website';
    } & PayersCreateWebsiteErrorComponent)
  | ({
      attr: 'ein';
    } & PayersCreateEinErrorComponent)
  | ({
      attr: 'email';
    } & PayersCreateEmailErrorComponent)
  | ({
      attr: 'phone_number';
    } & PayersCreatePhoneNumberErrorComponent)
  | ({
      attr: 'billing_name';
    } & PayersCreateBillingNameErrorComponent)
  | ({
      attr: 'billing_phone_number';
    } & PayersCreateBillingPhoneNumberErrorComponent)
  | ({
      attr: 'billing_email';
    } & PayersCreateBillingEmailErrorComponent)
  | ({
      attr: 'dispatcher_notes';
    } & PayersCreateDispatcherNotesErrorComponent)
  | ({
      attr: 'admin_notes';
    } & PayersCreateAdminNotesErrorComponent)
  | ({
      attr: 'deleted_at';
    } & PayersCreateDeletedAtErrorComponent)
  | ({
      attr: 'billing_address.non_field_errors';
    } & PayersCreateBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'billing_address.location.non_field_errors';
    } & PayersCreateBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'billing_address.location.place_id';
    } & PayersCreateBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'billing_address.label';
    } & PayersCreateBillingAddressLabelErrorComponent)
  | ({
      attr: 'billing_address.label2';
    } & PayersCreateBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'billing_address.address_notes';
    } & PayersCreateBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'billing_address.address_type';
    } & PayersCreateBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'default_trip_address.non_field_errors';
    } & PayersCreateDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'default_trip_address.location.non_field_errors';
    } & PayersCreateDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'default_trip_address.location.place_id';
    } & PayersCreateDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'default_trip_address.label';
    } & PayersCreateDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'default_trip_address.label2';
    } & PayersCreateDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'default_trip_address.address_notes';
    } & PayersCreateDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'default_trip_address.address_type';
    } & PayersCreateDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'multiloading_partners.non_field_errors';
    } & PayersCreateMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'multiloading_partners.INDEX';
    } & PayersCreateMultiloadingPartnersIndexErrorComponent);
export type PayersCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PayersCreateError[];
};
export type PayersCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PayersCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PayerOrganizationDriver = {};
export type PayerOrganizationDriverRead = {
  id: string;
  organization_id: string;
  payer_organization_id: string;
  driver_id: string;
  driver_first_name: string;
  driver_last_name: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
};
export type PayerOrganizationDriverWrite = {
  driver_ids: string[];
};
export type PaginatedPayerOrganizationDriverList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerOrganizationDriver[];
};
export type PaginatedPayerOrganizationDriverListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerOrganizationDriverRead[];
};
export type PaginatedPayerOrganizationDriverListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerOrganizationDriverWrite[];
};
export type PayersDriversListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayersDriversCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersDriversCreateDriverIdsErrorComponent = {
  attr: 'driver_ids';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type PayersDriversCreateDriverIdsIndexErrorComponent = {
  attr: 'driver_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PayersDriversCreateError =
  | ({
      attr: 'non_field_errors';
    } & PayersDriversCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'driver_ids';
    } & PayersDriversCreateDriverIdsErrorComponent)
  | ({
      attr: 'driver_ids.INDEX';
    } & PayersDriversCreateDriverIdsIndexErrorComponent);
export type PayersDriversCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PayersDriversCreateError[];
};
export type PayersDriversCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PayersDriversCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PayersPassengersRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayersPassengersCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersPassengersCreateExternalIdErrorComponent = {
  attr: 'external_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersCreateAuthorizationIdErrorComponent = {
  attr: 'authorization_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationPayerErrorComponent = {
  attr: 'payer_organization.payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationDisplayNameErrorComponent = {
  attr: 'payer_organization.display_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationAlternateNameErrorComponent =
  {
    attr: 'payer_organization.alternate_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationTypeErrorComponent = {
  attr: 'payer_organization.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationIsActiveErrorComponent = {
  attr: 'payer_organization.is_active';
  code: 'invalid' | 'null';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationIsSelfPayErrorComponent = {
  attr: 'payer_organization.is_self_pay';
  code: 'invalid';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationCanMultiloadErrorComponent =
  {
    attr: 'payer_organization.can_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationExternalIdErrorComponent = {
  attr: 'payer_organization.external_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationWebsiteErrorComponent = {
  attr: 'payer_organization.website';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationEinErrorComponent = {
  attr: 'payer_organization.ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationEmailErrorComponent = {
  attr: 'payer_organization.email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationPhoneNumberErrorComponent = {
  attr: 'payer_organization.phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationBillingNameErrorComponent = {
  attr: 'payer_organization.billing_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationBillingPhoneNumberErrorComponent =
  {
    attr: 'payer_organization.billing_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationBillingEmailErrorComponent =
  {
    attr: 'payer_organization.billing_email';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationDispatcherNotesErrorComponent =
  {
    attr: 'payer_organization.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationAdminNotesErrorComponent = {
  attr: 'payer_organization.admin_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationDeletedAtErrorComponent = {
  attr: 'payer_organization.deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type PayersPassengersCreatePayerOrganizationBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'payer_organization.billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'payer_organization.billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationBillingAddressLocationPlaceIdErrorComponent =
  {
    attr: 'payer_organization.billing_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationBillingAddressLabelErrorComponent =
  {
    attr: 'payer_organization.billing_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationBillingAddressLabel2ErrorComponent =
  {
    attr: 'payer_organization.billing_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationBillingAddressAddressNotesErrorComponent =
  {
    attr: 'payer_organization.billing_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationBillingAddressAddressTypeErrorComponent =
  {
    attr: 'payer_organization.billing_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationDefaultTripAddressLabelErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationDefaultTripAddressLabel2ErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationDefaultTripAddressAddressNotesErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationDefaultTripAddressAddressTypeErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'payer_organization.multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type PayersPassengersCreatePayerOrganizationMultiloadingPartnersIndexErrorComponent =
  {
    attr: 'payer_organization.multiloading_partners.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type PayersPassengersCreateError =
  | ({
      attr: 'non_field_errors';
    } & PayersPassengersCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'external_id';
    } & PayersPassengersCreateExternalIdErrorComponent)
  | ({
      attr: 'authorization_id';
    } & PayersPassengersCreateAuthorizationIdErrorComponent)
  | ({
      attr: 'payer_organization.payer';
    } & PayersPassengersCreatePayerOrganizationPayerErrorComponent)
  | ({
      attr: 'payer_organization.display_name';
    } & PayersPassengersCreatePayerOrganizationDisplayNameErrorComponent)
  | ({
      attr: 'payer_organization.alternate_name';
    } & PayersPassengersCreatePayerOrganizationAlternateNameErrorComponent)
  | ({
      attr: 'payer_organization.type';
    } & PayersPassengersCreatePayerOrganizationTypeErrorComponent)
  | ({
      attr: 'payer_organization.is_active';
    } & PayersPassengersCreatePayerOrganizationIsActiveErrorComponent)
  | ({
      attr: 'payer_organization.is_self_pay';
    } & PayersPassengersCreatePayerOrganizationIsSelfPayErrorComponent)
  | ({
      attr: 'payer_organization.can_multiload';
    } & PayersPassengersCreatePayerOrganizationCanMultiloadErrorComponent)
  | ({
      attr: 'payer_organization.external_id';
    } & PayersPassengersCreatePayerOrganizationExternalIdErrorComponent)
  | ({
      attr: 'payer_organization.website';
    } & PayersPassengersCreatePayerOrganizationWebsiteErrorComponent)
  | ({
      attr: 'payer_organization.ein';
    } & PayersPassengersCreatePayerOrganizationEinErrorComponent)
  | ({
      attr: 'payer_organization.email';
    } & PayersPassengersCreatePayerOrganizationEmailErrorComponent)
  | ({
      attr: 'payer_organization.phone_number';
    } & PayersPassengersCreatePayerOrganizationPhoneNumberErrorComponent)
  | ({
      attr: 'payer_organization.billing_name';
    } & PayersPassengersCreatePayerOrganizationBillingNameErrorComponent)
  | ({
      attr: 'payer_organization.billing_phone_number';
    } & PayersPassengersCreatePayerOrganizationBillingPhoneNumberErrorComponent)
  | ({
      attr: 'payer_organization.billing_email';
    } & PayersPassengersCreatePayerOrganizationBillingEmailErrorComponent)
  | ({
      attr: 'payer_organization.dispatcher_notes';
    } & PayersPassengersCreatePayerOrganizationDispatcherNotesErrorComponent)
  | ({
      attr: 'payer_organization.admin_notes';
    } & PayersPassengersCreatePayerOrganizationAdminNotesErrorComponent)
  | ({
      attr: 'payer_organization.deleted_at';
    } & PayersPassengersCreatePayerOrganizationDeletedAtErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.non_field_errors';
    } & PayersPassengersCreatePayerOrganizationBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.location.non_field_errors';
    } & PayersPassengersCreatePayerOrganizationBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.location.place_id';
    } & PayersPassengersCreatePayerOrganizationBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.label';
    } & PayersPassengersCreatePayerOrganizationBillingAddressLabelErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.label2';
    } & PayersPassengersCreatePayerOrganizationBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.address_notes';
    } & PayersPassengersCreatePayerOrganizationBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.address_type';
    } & PayersPassengersCreatePayerOrganizationBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.non_field_errors';
    } & PayersPassengersCreatePayerOrganizationDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.location.non_field_errors';
    } & PayersPassengersCreatePayerOrganizationDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.location.place_id';
    } & PayersPassengersCreatePayerOrganizationDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.label';
    } & PayersPassengersCreatePayerOrganizationDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.label2';
    } & PayersPassengersCreatePayerOrganizationDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.address_notes';
    } & PayersPassengersCreatePayerOrganizationDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.address_type';
    } & PayersPassengersCreatePayerOrganizationDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer_organization.multiloading_partners.non_field_errors';
    } & PayersPassengersCreatePayerOrganizationMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization.multiloading_partners.INDEX';
    } & PayersPassengersCreatePayerOrganizationMultiloadingPartnersIndexErrorComponent);
export type PayersPassengersCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PayersPassengersCreateError[];
};
export type PayersPassengersCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PayersPassengersCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PayersPassengersPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersPassengersPartialUpdateExternalIdErrorComponent = {
  attr: 'external_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersPartialUpdateAuthorizationIdErrorComponent = {
  attr: 'authorization_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersPartialUpdatePayerOrganizationPayerErrorComponent =
  {
    attr: 'payer_organization.payer';
    code: 'does_not_exist' | 'incorrect_type';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationDisplayNameErrorComponent =
  {
    attr: 'payer_organization.display_name';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationAlternateNameErrorComponent =
  {
    attr: 'payer_organization.alternate_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationTypeErrorComponent = {
  attr: 'payer_organization.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PayersPassengersPartialUpdatePayerOrganizationIsActiveErrorComponent =
  {
    attr: 'payer_organization.is_active';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationIsSelfPayErrorComponent =
  {
    attr: 'payer_organization.is_self_pay';
    code: 'invalid';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationCanMultiloadErrorComponent =
  {
    attr: 'payer_organization.can_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationExternalIdErrorComponent =
  {
    attr: 'payer_organization.external_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationWebsiteErrorComponent =
  {
    attr: 'payer_organization.website';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationEinErrorComponent = {
  attr: 'payer_organization.ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPassengersPartialUpdatePayerOrganizationEmailErrorComponent =
  {
    attr: 'payer_organization.email';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationPhoneNumberErrorComponent =
  {
    attr: 'payer_organization.phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationBillingNameErrorComponent =
  {
    attr: 'payer_organization.billing_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationBillingPhoneNumberErrorComponent =
  {
    attr: 'payer_organization.billing_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationBillingEmailErrorComponent =
  {
    attr: 'payer_organization.billing_email';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationDispatcherNotesErrorComponent =
  {
    attr: 'payer_organization.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationAdminNotesErrorComponent =
  {
    attr: 'payer_organization.admin_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationDeletedAtErrorComponent =
  {
    attr: 'payer_organization.deleted_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'payer_organization.billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'payer_organization.billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationBillingAddressLocationPlaceIdErrorComponent =
  {
    attr: 'payer_organization.billing_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationBillingAddressLabelErrorComponent =
  {
    attr: 'payer_organization.billing_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationBillingAddressLabel2ErrorComponent =
  {
    attr: 'payer_organization.billing_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationBillingAddressAddressNotesErrorComponent =
  {
    attr: 'payer_organization.billing_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationBillingAddressAddressTypeErrorComponent =
  {
    attr: 'payer_organization.billing_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressLabelErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressLabel2ErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressAddressNotesErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressAddressTypeErrorComponent =
  {
    attr: 'payer_organization.default_trip_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'payer_organization.multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type PayersPassengersPartialUpdatePayerOrganizationMultiloadingPartnersIndexErrorComponent =
  {
    attr: 'payer_organization.multiloading_partners.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type PayersPassengersPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & PayersPassengersPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'external_id';
    } & PayersPassengersPartialUpdateExternalIdErrorComponent)
  | ({
      attr: 'authorization_id';
    } & PayersPassengersPartialUpdateAuthorizationIdErrorComponent)
  | ({
      attr: 'payer_organization.payer';
    } & PayersPassengersPartialUpdatePayerOrganizationPayerErrorComponent)
  | ({
      attr: 'payer_organization.display_name';
    } & PayersPassengersPartialUpdatePayerOrganizationDisplayNameErrorComponent)
  | ({
      attr: 'payer_organization.alternate_name';
    } & PayersPassengersPartialUpdatePayerOrganizationAlternateNameErrorComponent)
  | ({
      attr: 'payer_organization.type';
    } & PayersPassengersPartialUpdatePayerOrganizationTypeErrorComponent)
  | ({
      attr: 'payer_organization.is_active';
    } & PayersPassengersPartialUpdatePayerOrganizationIsActiveErrorComponent)
  | ({
      attr: 'payer_organization.is_self_pay';
    } & PayersPassengersPartialUpdatePayerOrganizationIsSelfPayErrorComponent)
  | ({
      attr: 'payer_organization.can_multiload';
    } & PayersPassengersPartialUpdatePayerOrganizationCanMultiloadErrorComponent)
  | ({
      attr: 'payer_organization.external_id';
    } & PayersPassengersPartialUpdatePayerOrganizationExternalIdErrorComponent)
  | ({
      attr: 'payer_organization.website';
    } & PayersPassengersPartialUpdatePayerOrganizationWebsiteErrorComponent)
  | ({
      attr: 'payer_organization.ein';
    } & PayersPassengersPartialUpdatePayerOrganizationEinErrorComponent)
  | ({
      attr: 'payer_organization.email';
    } & PayersPassengersPartialUpdatePayerOrganizationEmailErrorComponent)
  | ({
      attr: 'payer_organization.phone_number';
    } & PayersPassengersPartialUpdatePayerOrganizationPhoneNumberErrorComponent)
  | ({
      attr: 'payer_organization.billing_name';
    } & PayersPassengersPartialUpdatePayerOrganizationBillingNameErrorComponent)
  | ({
      attr: 'payer_organization.billing_phone_number';
    } & PayersPassengersPartialUpdatePayerOrganizationBillingPhoneNumberErrorComponent)
  | ({
      attr: 'payer_organization.billing_email';
    } & PayersPassengersPartialUpdatePayerOrganizationBillingEmailErrorComponent)
  | ({
      attr: 'payer_organization.dispatcher_notes';
    } & PayersPassengersPartialUpdatePayerOrganizationDispatcherNotesErrorComponent)
  | ({
      attr: 'payer_organization.admin_notes';
    } & PayersPassengersPartialUpdatePayerOrganizationAdminNotesErrorComponent)
  | ({
      attr: 'payer_organization.deleted_at';
    } & PayersPassengersPartialUpdatePayerOrganizationDeletedAtErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.non_field_errors';
    } & PayersPassengersPartialUpdatePayerOrganizationBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.location.non_field_errors';
    } & PayersPassengersPartialUpdatePayerOrganizationBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.location.place_id';
    } & PayersPassengersPartialUpdatePayerOrganizationBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.label';
    } & PayersPassengersPartialUpdatePayerOrganizationBillingAddressLabelErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.label2';
    } & PayersPassengersPartialUpdatePayerOrganizationBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.address_notes';
    } & PayersPassengersPartialUpdatePayerOrganizationBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'payer_organization.billing_address.address_type';
    } & PayersPassengersPartialUpdatePayerOrganizationBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.non_field_errors';
    } & PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.location.non_field_errors';
    } & PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.location.place_id';
    } & PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.label';
    } & PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.label2';
    } & PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.address_notes';
    } & PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'payer_organization.default_trip_address.address_type';
    } & PayersPassengersPartialUpdatePayerOrganizationDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer_organization.multiloading_partners.non_field_errors';
    } & PayersPassengersPartialUpdatePayerOrganizationMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization.multiloading_partners.INDEX';
    } & PayersPassengersPartialUpdatePayerOrganizationMultiloadingPartnersIndexErrorComponent);
export type PayersPassengersPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: PayersPassengersPartialUpdateError[];
};
export type PayersPassengersPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PayersPassengersPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedPayerPassenger = {
  external_id?: string;
  /** Authorization ID associated with the passenger for insurance payers */
  authorization_id?: string | null;
};
export type PatchedPayerPassengerRead = {
  id?: string;
  payer_organization_id?: string;
  passenger_id?: string;
  external_id?: string;
  /** Authorization ID associated with the passenger for insurance payers */
  authorization_id?: string | null;
  /** Last time this payer was used in a trip */
  last_used_at?: string | null;
  passenger?: string;
  payer_organization?: PayerOrganizationRead;
  organization_id?: string;
  created_at?: string;
  updated_at?: string;
};
export type PayersPassengersDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayersSettingsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayersSettingsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersSettingsPartialUpdatePickupDefaultEarlySecondsErrorComponent =
  {
    attr: '_pickup_default_early_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayersSettingsPartialUpdatePickupDefaultLateSecondsErrorComponent =
  {
    attr: '_pickup_default_late_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayersSettingsPartialUpdatePickupAppointmentEarlySecondsErrorComponent =
  {
    attr: '_pickup_appointment_early_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayersSettingsPartialUpdatePickupAppointmentLateSecondsErrorComponent =
  {
    attr: '_pickup_appointment_late_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayersSettingsPartialUpdatePickupWillCallEarlySecondsErrorComponent =
  {
    attr: '_pickup_will_call_early_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayersSettingsPartialUpdatePickupWillCallLateSecondsErrorComponent =
  {
    attr: '_pickup_will_call_late_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayersSettingsPartialUpdateExtraScheduledPickupAtSecondsErrorComponent =
  {
    attr: '_extra_scheduled_pickup_at_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PayersSettingsPartialUpdateInvoiceDueAfterDaysErrorComponent = {
  attr: 'invoice_due_after_days';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PayersSettingsPartialUpdateRequiresSignaturePickupPassengerErrorComponent =
  {
    attr: '_requires_signature_pickup_passenger';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateRequiresSignatureDropoffPassengerErrorComponent =
  {
    attr: '_requires_signature_dropoff_passenger';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateRequiresSignaturePickupDriverErrorComponent =
  {
    attr: '_requires_signature_pickup_driver';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateRequiresSignatureDropoffDriverErrorComponent =
  {
    attr: '_requires_signature_dropoff_driver';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateAllowOnlySpecificVehiclesErrorComponent =
  {
    attr: 'allow_only_specific_vehicles';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateAllowedVehicleIdsErrorComponent = {
  attr: 'allowed_vehicle_ids';
  code: 'not_a_list';
  detail: string;
};
export type PayersSettingsPartialUpdateAllowedVehicleIdsIndexErrorComponent = {
  attr: 'allowed_vehicle_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PayersSettingsPartialUpdateAllowOnlySpecificDriversErrorComponent =
  {
    attr: 'allow_only_specific_drivers';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateAllowedDriverIdsErrorComponent = {
  attr: 'allowed_driver_ids';
  code: 'not_a_list';
  detail: string;
};
export type PayersSettingsPartialUpdateAllowedDriverIdsIndexErrorComponent = {
  attr: 'allowed_driver_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PayersSettingsPartialUpdateTripRequiredFieldsNonFieldErrorsErrorComponent =
  {
    attr: 'trip_required_fields.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateTripRequiredFieldsPassengerPhoneNumberErrorComponent =
  {
    attr: 'trip_required_fields._passenger_phone_number';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateTripRequiredFieldsPassengerWeightErrorComponent =
  {
    attr: 'trip_required_fields._passenger_weight';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateTripRequiredFieldsAuthorizationIdErrorComponent =
  {
    attr: 'trip_required_fields._authorization_id';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateTripRequiredFieldsInsurancePolicyIdErrorComponent =
  {
    attr: 'trip_required_fields._insurance_policy_id';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateTripRequiredFieldsPayerPassengerExternalIdErrorComponent =
  {
    attr: 'trip_required_fields._payer_passenger_external_id';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateTripRequiredFieldsExternalTripIdErrorComponent =
  {
    attr: 'trip_required_fields._external_trip_id';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateTripRequiredFieldsBookedByNameErrorComponent =
  {
    attr: 'trip_required_fields._booked_by_name';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateTripRequiredFieldsBookedByPhoneNumberErrorComponent =
  {
    attr: 'trip_required_fields._booked_by_phone_number';
    code: 'invalid';
    detail: string;
  };
export type PayersSettingsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & PayersSettingsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: '_pickup_default_early_seconds';
    } & PayersSettingsPartialUpdatePickupDefaultEarlySecondsErrorComponent)
  | ({
      attr: '_pickup_default_late_seconds';
    } & PayersSettingsPartialUpdatePickupDefaultLateSecondsErrorComponent)
  | ({
      attr: '_pickup_appointment_early_seconds';
    } & PayersSettingsPartialUpdatePickupAppointmentEarlySecondsErrorComponent)
  | ({
      attr: '_pickup_appointment_late_seconds';
    } & PayersSettingsPartialUpdatePickupAppointmentLateSecondsErrorComponent)
  | ({
      attr: '_pickup_will_call_early_seconds';
    } & PayersSettingsPartialUpdatePickupWillCallEarlySecondsErrorComponent)
  | ({
      attr: '_pickup_will_call_late_seconds';
    } & PayersSettingsPartialUpdatePickupWillCallLateSecondsErrorComponent)
  | ({
      attr: '_extra_scheduled_pickup_at_seconds';
    } & PayersSettingsPartialUpdateExtraScheduledPickupAtSecondsErrorComponent)
  | ({
      attr: 'invoice_due_after_days';
    } & PayersSettingsPartialUpdateInvoiceDueAfterDaysErrorComponent)
  | ({
      attr: '_requires_signature_pickup_passenger';
    } & PayersSettingsPartialUpdateRequiresSignaturePickupPassengerErrorComponent)
  | ({
      attr: '_requires_signature_dropoff_passenger';
    } & PayersSettingsPartialUpdateRequiresSignatureDropoffPassengerErrorComponent)
  | ({
      attr: '_requires_signature_pickup_driver';
    } & PayersSettingsPartialUpdateRequiresSignaturePickupDriverErrorComponent)
  | ({
      attr: '_requires_signature_dropoff_driver';
    } & PayersSettingsPartialUpdateRequiresSignatureDropoffDriverErrorComponent)
  | ({
      attr: 'allow_only_specific_vehicles';
    } & PayersSettingsPartialUpdateAllowOnlySpecificVehiclesErrorComponent)
  | ({
      attr: 'allowed_vehicle_ids';
    } & PayersSettingsPartialUpdateAllowedVehicleIdsErrorComponent)
  | ({
      attr: 'allowed_vehicle_ids.INDEX';
    } & PayersSettingsPartialUpdateAllowedVehicleIdsIndexErrorComponent)
  | ({
      attr: 'allow_only_specific_drivers';
    } & PayersSettingsPartialUpdateAllowOnlySpecificDriversErrorComponent)
  | ({
      attr: 'allowed_driver_ids';
    } & PayersSettingsPartialUpdateAllowedDriverIdsErrorComponent)
  | ({
      attr: 'allowed_driver_ids.INDEX';
    } & PayersSettingsPartialUpdateAllowedDriverIdsIndexErrorComponent)
  | ({
      attr: 'trip_required_fields.non_field_errors';
    } & PayersSettingsPartialUpdateTripRequiredFieldsNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_required_fields._passenger_phone_number';
    } & PayersSettingsPartialUpdateTripRequiredFieldsPassengerPhoneNumberErrorComponent)
  | ({
      attr: 'trip_required_fields._passenger_weight';
    } & PayersSettingsPartialUpdateTripRequiredFieldsPassengerWeightErrorComponent)
  | ({
      attr: 'trip_required_fields._authorization_id';
    } & PayersSettingsPartialUpdateTripRequiredFieldsAuthorizationIdErrorComponent)
  | ({
      attr: 'trip_required_fields._insurance_policy_id';
    } & PayersSettingsPartialUpdateTripRequiredFieldsInsurancePolicyIdErrorComponent)
  | ({
      attr: 'trip_required_fields._payer_passenger_external_id';
    } & PayersSettingsPartialUpdateTripRequiredFieldsPayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'trip_required_fields._external_trip_id';
    } & PayersSettingsPartialUpdateTripRequiredFieldsExternalTripIdErrorComponent)
  | ({
      attr: 'trip_required_fields._booked_by_name';
    } & PayersSettingsPartialUpdateTripRequiredFieldsBookedByNameErrorComponent)
  | ({
      attr: 'trip_required_fields._booked_by_phone_number';
    } & PayersSettingsPartialUpdateTripRequiredFieldsBookedByPhoneNumberErrorComponent);
export type PayersSettingsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: PayersSettingsPartialUpdateError[];
};
export type PayersSettingsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PayersSettingsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PayerOrganizationVehicle = {};
export type PayerOrganizationVehicleRead = {
  id: string;
  organization_id: string;
  payer_organization_id: string;
  vehicle_id: string;
  vehicle_nickname: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
};
export type PayerOrganizationVehicleWrite = {
  vehicle_ids: string[];
};
export type PaginatedPayerOrganizationVehicleList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerOrganizationVehicle[];
};
export type PaginatedPayerOrganizationVehicleListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerOrganizationVehicleRead[];
};
export type PaginatedPayerOrganizationVehicleListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerOrganizationVehicleWrite[];
};
export type PayersVehiclesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayersVehiclesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersVehiclesCreateVehicleIdsErrorComponent = {
  attr: 'vehicle_ids';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type PayersVehiclesCreateVehicleIdsIndexErrorComponent = {
  attr: 'vehicle_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PayersVehiclesCreateError =
  | ({
      attr: 'non_field_errors';
    } & PayersVehiclesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'vehicle_ids';
    } & PayersVehiclesCreateVehicleIdsErrorComponent)
  | ({
      attr: 'vehicle_ids.INDEX';
    } & PayersVehiclesCreateVehicleIdsIndexErrorComponent);
export type PayersVehiclesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PayersVehiclesCreateError[];
};
export type PayersVehiclesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PayersVehiclesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PayersRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayersPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersPartialUpdatePayerErrorComponent = {
  attr: 'payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type PayersPartialUpdateDisplayNameErrorComponent = {
  attr: 'display_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateAlternateNameErrorComponent = {
  attr: 'alternate_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateTypeErrorComponent = {
  attr: 'type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PayersPartialUpdateIsActiveErrorComponent = {
  attr: 'is_active';
  code: 'invalid' | 'null';
  detail: string;
};
export type PayersPartialUpdateIsSelfPayErrorComponent = {
  attr: 'is_self_pay';
  code: 'invalid';
  detail: string;
};
export type PayersPartialUpdateCanMultiloadErrorComponent = {
  attr: 'can_multiload';
  code: 'invalid' | 'null';
  detail: string;
};
export type PayersPartialUpdateExternalIdErrorComponent = {
  attr: 'external_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateWebsiteErrorComponent = {
  attr: 'website';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateEinErrorComponent = {
  attr: 'ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateEmailErrorComponent = {
  attr: 'email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdatePhoneNumberErrorComponent = {
  attr: 'phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateBillingNameErrorComponent = {
  attr: 'billing_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateBillingPhoneNumberErrorComponent = {
  attr: 'billing_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateBillingEmailErrorComponent = {
  attr: 'billing_email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateDispatcherNotesErrorComponent = {
  attr: 'dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateAdminNotesErrorComponent = {
  attr: 'admin_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type PayersPartialUpdateBillingAddressNonFieldErrorsErrorComponent = {
  attr: 'billing_address.non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersPartialUpdateBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PayersPartialUpdateBillingAddressLocationPlaceIdErrorComponent = {
  attr: 'billing_address.location.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateBillingAddressLabelErrorComponent = {
  attr: 'billing_address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateBillingAddressLabel2ErrorComponent = {
  attr: 'billing_address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateBillingAddressAddressNotesErrorComponent = {
  attr: 'billing_address.address_notes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateBillingAddressAddressTypeErrorComponent = {
  attr: 'billing_address.address_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PayersPartialUpdateDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type PayersPartialUpdateDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type PayersPartialUpdateDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PayersPartialUpdateDefaultTripAddressLabelErrorComponent = {
  attr: 'default_trip_address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateDefaultTripAddressLabel2ErrorComponent = {
  attr: 'default_trip_address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateDefaultTripAddressAddressNotesErrorComponent = {
  attr: 'default_trip_address.address_notes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PayersPartialUpdateDefaultTripAddressAddressTypeErrorComponent = {
  attr: 'default_trip_address.address_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PayersPartialUpdateMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type PayersPartialUpdateMultiloadingPartnersIndexErrorComponent = {
  attr: 'multiloading_partners.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PayersPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & PayersPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer';
    } & PayersPartialUpdatePayerErrorComponent)
  | ({
      attr: 'display_name';
    } & PayersPartialUpdateDisplayNameErrorComponent)
  | ({
      attr: 'alternate_name';
    } & PayersPartialUpdateAlternateNameErrorComponent)
  | ({
      attr: 'type';
    } & PayersPartialUpdateTypeErrorComponent)
  | ({
      attr: 'is_active';
    } & PayersPartialUpdateIsActiveErrorComponent)
  | ({
      attr: 'is_self_pay';
    } & PayersPartialUpdateIsSelfPayErrorComponent)
  | ({
      attr: 'can_multiload';
    } & PayersPartialUpdateCanMultiloadErrorComponent)
  | ({
      attr: 'external_id';
    } & PayersPartialUpdateExternalIdErrorComponent)
  | ({
      attr: 'website';
    } & PayersPartialUpdateWebsiteErrorComponent)
  | ({
      attr: 'ein';
    } & PayersPartialUpdateEinErrorComponent)
  | ({
      attr: 'email';
    } & PayersPartialUpdateEmailErrorComponent)
  | ({
      attr: 'phone_number';
    } & PayersPartialUpdatePhoneNumberErrorComponent)
  | ({
      attr: 'billing_name';
    } & PayersPartialUpdateBillingNameErrorComponent)
  | ({
      attr: 'billing_phone_number';
    } & PayersPartialUpdateBillingPhoneNumberErrorComponent)
  | ({
      attr: 'billing_email';
    } & PayersPartialUpdateBillingEmailErrorComponent)
  | ({
      attr: 'dispatcher_notes';
    } & PayersPartialUpdateDispatcherNotesErrorComponent)
  | ({
      attr: 'admin_notes';
    } & PayersPartialUpdateAdminNotesErrorComponent)
  | ({
      attr: 'deleted_at';
    } & PayersPartialUpdateDeletedAtErrorComponent)
  | ({
      attr: 'billing_address.non_field_errors';
    } & PayersPartialUpdateBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'billing_address.location.non_field_errors';
    } & PayersPartialUpdateBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'billing_address.location.place_id';
    } & PayersPartialUpdateBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'billing_address.label';
    } & PayersPartialUpdateBillingAddressLabelErrorComponent)
  | ({
      attr: 'billing_address.label2';
    } & PayersPartialUpdateBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'billing_address.address_notes';
    } & PayersPartialUpdateBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'billing_address.address_type';
    } & PayersPartialUpdateBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'default_trip_address.non_field_errors';
    } & PayersPartialUpdateDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'default_trip_address.location.non_field_errors';
    } & PayersPartialUpdateDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'default_trip_address.location.place_id';
    } & PayersPartialUpdateDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'default_trip_address.label';
    } & PayersPartialUpdateDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'default_trip_address.label2';
    } & PayersPartialUpdateDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'default_trip_address.address_notes';
    } & PayersPartialUpdateDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'default_trip_address.address_type';
    } & PayersPartialUpdateDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'multiloading_partners.non_field_errors';
    } & PayersPartialUpdateMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'multiloading_partners.INDEX';
    } & PayersPartialUpdateMultiloadingPartnersIndexErrorComponent);
export type PayersPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: PayersPartialUpdateError[];
};
export type PayersPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PayersPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedPayerOrganization = {
  payer?: string | null;
  /** Name the organization uses to refer to this payer across the app */
  display_name?: string;
  /** Any alternate name the organization uses (ex., full legal name) */
  alternate_name?: string;
  type?: PayerTypeEnum;
  /** if this payer could be used for current or future trips */
  is_active?: boolean;
  /** if this payer is a self-pay payer */
  is_self_pay?: boolean | null;
  /** Whether a payer organization allows any kind of multiloading */
  can_multiload?: boolean;
  /** ID of the organization in the payer's system */
  external_id?: string;
  website?: string;
  /** Employer Identification Number */
  ein?: string;
  /** Default contact email, ex. help@bambi.health */
  email?: string;
  /** Default contact phone number */
  phone_number?: string | null;
  /** Name of person to contact for billing/invoicing help or questions */
  billing_name?: string;
  /** Phone number for billing-specific purposes */
  billing_phone_number?: string | null;
  /** Email for billing/invoicing, ex. nirav@bambi.healh */
  billing_email?: string;
  /** Any additional information to display to dispatchers */
  dispatcher_notes?: string;
  /** Any additional information to display to admins */
  admin_notes?: string;
  deleted_at?: string | null;
  billing_address?: Address | null;
  default_trip_address?: Address | null;
  multiloading_partners?: string[] | null;
};
export type PatchedPayerOrganizationRead = {
  id?: string;
  organization_id?: string;
  payer?: string | null;
  /** Name the organization uses to refer to this payer across the app */
  display_name?: string;
  /** Any alternate name the organization uses (ex., full legal name) */
  alternate_name?: string;
  type?: PayerTypeEnum;
  /** if this payer could be used for current or future trips */
  is_active?: boolean;
  /** if this payer is a self-pay payer */
  is_self_pay?: boolean | null;
  /** Whether a payer organization allows any kind of multiloading */
  can_multiload?: boolean;
  /** ID of the organization in the payer's system */
  external_id?: string;
  website?: string;
  /** Employer Identification Number */
  ein?: string;
  /** Default contact email, ex. help@bambi.health */
  email?: string;
  /** Default contact phone number */
  phone_number?: string | null;
  /** Name of person to contact for billing/invoicing help or questions */
  billing_name?: string;
  /** Phone number for billing-specific purposes */
  billing_phone_number?: string | null;
  /** Email for billing/invoicing, ex. nirav@bambi.healh */
  billing_email?: string;
  /** Any additional information to display to dispatchers */
  dispatcher_notes?: string;
  /** Any additional information to display to admins */
  admin_notes?: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  billing_address?: AddressRead | null;
  default_trip_address?: AddressRead | null;
  pickup_default_early_seconds?: number;
  pickup_default_late_seconds?: number;
  pickup_appointment_early_seconds?: number;
  pickup_appointment_late_seconds?: number;
  pickup_will_call_early_seconds?: number;
  pickup_will_call_late_seconds?: number;
  extra_scheduled_pickup_at_seconds?: number;
  invoice_due_after_days?: number | null;
  requires_signature_pickup_passenger?: boolean;
  requires_signature_dropoff_passenger?: boolean;
  requires_signature_pickup_driver?: boolean;
  requires_signature_dropoff_driver?: boolean;
  payer_info_id?: string | null;
  payer_info_name?: string | null;
  payer_name?: string | null;
  payer_website?: string | null;
  payer_type?: PayerTypeEnum;
  multiloading_partners?: string[] | null;
  has_kinetik_account?: boolean;
  trip_required_fields?: PayerOrganizationTripRequiredFieldsRead | null;
};
export type PayersDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type OnlyMultiloadingPartners = {
  multiloading_partners?: string[] | null;
};
export type PayersMultiloadingPartnersRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayersListSelectedNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PayersListSelectedSelectedPayersErrorComponent = {
  attr: 'selected_payers';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type PayersListSelectedSelectedPayersIndexErrorComponent = {
  attr: 'selected_payers.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PayersListSelectedError =
  | ({
      attr: 'non_field_errors';
    } & PayersListSelectedNonFieldErrorsErrorComponent)
  | ({
      attr: 'selected_payers';
    } & PayersListSelectedSelectedPayersErrorComponent)
  | ({
      attr: 'selected_payers.INDEX';
    } & PayersListSelectedSelectedPayersIndexErrorComponent);
export type PayersListSelectedValidationError = {
  type: ValidationErrorEnum;
  errors: PayersListSelectedError[];
};
export type PayersListSelectedErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PayersListSelectedValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PayerFilters = {
  /** List of IDs of the payers to include in response. */
  selected_payers?: string[];
};
export type PayerWithTemplates = {};
export type PayerWithTemplatesRead = {
  id: string;
  organization_id: string;
  payer: string | null;
  payer_name: string;
  payer_display_name: string;
  payer_website: string;
  payer_type: PayerTypeEnum;
  /** ID of the organization in the payer's system */
  external_id: string;
  default_template: OneSchemaTemplate;
  active_templates: OneSchemaTemplate[];
  updated_at: string;
  created_at: string;
};
export type OneSchemaTemplateMulti = {};
export type OneSchemaTemplateMultiRead = {
  id: string;
  template_key: string;
  template_name: string;
};
export type PayerWithTemplatesResponse = {
  payer_templates: PayerWithTemplates[];
  multi_payer_templates: OneSchemaTemplateMulti[];
};
export type PayerWithTemplatesResponseRead = {
  payer_templates: PayerWithTemplatesRead[];
  multi_payer_templates: OneSchemaTemplateMultiRead[];
};
export type PayersandtemplatesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PaginatedPayerWithTemplatesList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerWithTemplates[];
};
export type PaginatedPayerWithTemplatesListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PayerWithTemplatesRead[];
};
export type PayerstemplatesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PayerstemplatesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PriceQuote = {
  is_canceled: boolean;
  cancellation_reason?: string | null;
  canceled_at?: string | null;
  pickup_at: string;
  pickup_place_id: string;
  dropoff_place_id: string;
  wait_time_minutes: number;
  steps_pickup: number;
  steps_dropoff: number;
  num_attendants: number;
  num_additional_passengers: number;
  is_bariatric: boolean;
  is_wheelchair_provided: boolean;
  is_oxygen_provided: boolean;
  space_type: SpaceTypeEnum;
  service_type?: (ServiceTypeEnum | NullEnum) | null;
  payer: string;
  is_will_call?: boolean;
  is_will_call_activated?: boolean;
  has_infectious_disease: boolean;
  is_trip_subscription?: boolean;
  is_car_seat_required?: boolean;
  is_booster_seat_required?: boolean;
  is_ride_alone?: boolean;
  is_wait_and_return_outbound?: boolean;
  is_wait_and_return_inbound?: boolean;
  wait_and_return_first_leg_scheduled_pickup_at?: string | null;
  wait_and_return_first_leg_pickup_place_id?: string | null;
  wait_and_return_first_leg_dropoff_place_id?: string | null;
  trip_id?: string | null;
};
export type BaseFeeSummary = {
  sub_total: number;
};
export type LoadedMileageFeeSummary = {
  miles: number;
  free_miles: number;
  rate: number;
  sub_total: number;
};
export type LongDistanceLoadedMileageFeeSummary = {
  miles: number;
  free_miles: number;
  rate: number;
  sub_total: number;
};
export type UnloadedMileageFeeSummary = {
  miles: number;
  free_miles: number;
  rate: number;
  sub_total: number;
};
export type UnloadedReturnMileageFeeSummary = {
  miles: number;
  free_miles: number;
  rate: number;
  sub_total: number;
};
export type WaitTimeFeeSummary = {
  minutes: number;
  free_minutes: number;
  period: number;
  rate: number;
  sub_total: number;
};
export type NoShowFeeTypeEnum = 'Flat' | 'Percentage';
export type NoShowFeeSummary = {
  sub_total: number;
  cancellation_reason: string;
  canceled_at: string;
  scheduled_pickup_at: string;
  minutes_before_pickup: number;
  no_show_fee_type: NoShowFeeTypeEnum;
};
export type LateCancellationFeeSummary = {
  sub_total: number;
  canceled_at: string;
  scheduled_pickup_at: string;
  minutes_before_pickup: number;
  late_cancellation_fee_type: NoShowFeeTypeEnum;
};
export type StairFeeSummary = {
  sub_total: number;
  steps: number;
  minimum_steps: number;
  fee_type: string;
  rate: number;
};
export type AdditionalAttendantsFeeSummary = {
  sub_total: number;
  additional_attendants: number;
  rate: number;
};
export type AdditionalPassengersFeeSummary = {
  sub_total: number;
  additional_passengers: number;
  rate: number;
};
export type BariatricFeeSummary = {
  sub_total: number;
  is_bariatric: boolean;
};
export type WheelchairRentalFeeSummary = {
  sub_total: number;
  is_wheelchair_provided: boolean;
};
export type OxygenFeeSummary = {
  sub_total: number;
  is_oxygen_provided: boolean;
};
export type AfterHoursFeeSummary = {
  sub_total: number;
  pickup_time: string;
  business_hours_start?: string | null;
  business_hours_end?: string | null;
};
export type WeekendFeeSummary = {
  sub_total: number;
  day_of_week: string;
};
export type HolidayFeeSummary = {
  sub_total?: number | null;
  holiday?: string | null;
  date: string;
};
export type InfectiousDiseaseFeeSummary = {
  sub_total: number;
  has_infectious_disease: boolean;
};
export type SameDayBookingFeeSummary = {
  sub_total: number;
};
export type CarSeatFeeSummary = {
  sub_total: number;
  is_car_seat_required: boolean;
};
export type BoosterSeatFeeSummary = {
  sub_total: number;
  is_booster_seat_required: boolean;
};
export type RideAloneFeeSummary = {
  sub_total: number;
  is_ride_alone: boolean;
};
export type PriceSummary = {
  name: string;
  base_fee_summary?: BaseFeeSummary | null;
  loaded_mileage_fee_summary?: LoadedMileageFeeSummary | null;
  long_distance_loaded_mileage_fee_summary?: LongDistanceLoadedMileageFeeSummary | null;
  unloaded_mileage_fee_summary?: UnloadedMileageFeeSummary | null;
  unloaded_return_mileage_fee_summary?: UnloadedReturnMileageFeeSummary | null;
  wait_time_fee_summary?: WaitTimeFeeSummary | null;
  no_show_fee_summary?: NoShowFeeSummary | null;
  late_cancellation_fee_summary?: LateCancellationFeeSummary | null;
  pickup_stair_fee_summary?: StairFeeSummary | null;
  dropoff_stair_fee_summary?: StairFeeSummary | null;
  additional_attendants_fee_summary?: AdditionalAttendantsFeeSummary | null;
  additional_passengers_fee_summary?: AdditionalPassengersFeeSummary | null;
  bariatric_fee_summary?: BariatricFeeSummary | null;
  wheelchair_rental_fee_summary?: WheelchairRentalFeeSummary | null;
  oxygen_fee_summary?: OxygenFeeSummary | null;
  after_hours_fee_summary?: AfterHoursFeeSummary | null;
  weekend_fee_summary?: WeekendFeeSummary | null;
  holiday_fee_summary?: HolidayFeeSummary | null;
  minimum_price_cents?: number | null;
  infectious_disease_fee_summary?: InfectiousDiseaseFeeSummary | null;
  same_day_booking_fee_summary?: SameDayBookingFeeSummary | null;
  car_seat_fee_summary?: CarSeatFeeSummary | null;
  booster_seat_fee_summary?: BoosterSeatFeeSummary | null;
  ride_alone_fee_summary?: RideAloneFeeSummary | null;
  total?: number | null;
};
export type PriceQuoteRead = {
  is_canceled: boolean;
  cancellation_reason?: string | null;
  canceled_at?: string | null;
  pickup_at: string;
  pickup_place_id: string;
  dropoff_place_id: string;
  wait_time_minutes: number;
  steps_pickup: number;
  steps_dropoff: number;
  num_attendants: number;
  num_additional_passengers: number;
  is_bariatric: boolean;
  is_wheelchair_provided: boolean;
  is_oxygen_provided: boolean;
  space_type: SpaceTypeEnum;
  service_type?: (ServiceTypeEnum | NullEnum) | null;
  payer: string;
  is_will_call?: boolean;
  is_will_call_activated?: boolean;
  has_infectious_disease: boolean;
  is_trip_subscription?: boolean;
  is_car_seat_required?: boolean;
  is_booster_seat_required?: boolean;
  is_ride_alone?: boolean;
  is_wait_and_return_outbound?: boolean;
  is_wait_and_return_inbound?: boolean;
  wait_and_return_first_leg_scheduled_pickup_at?: string | null;
  wait_and_return_first_leg_pickup_place_id?: string | null;
  wait_and_return_first_leg_dropoff_place_id?: string | null;
  trip_id?: string | null;
  price_summary: PriceSummary;
  loaded_miles: number;
};
export type PricingPriceQuoteCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PricingPriceQuoteCreateIsCanceledErrorComponent = {
  attr: 'is_canceled';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateCancellationReasonErrorComponent = {
  attr: 'cancellation_reason';
  code:
    | 'blank'
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PricingPriceQuoteCreateCanceledAtErrorComponent = {
  attr: 'canceled_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type PricingPriceQuoteCreatePickupAtErrorComponent = {
  attr: 'pickup_at';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreatePickupPlaceIdErrorComponent = {
  attr: 'pickup_place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PricingPriceQuoteCreateDropoffPlaceIdErrorComponent = {
  attr: 'dropoff_place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PricingPriceQuoteCreateWaitTimeMinutesErrorComponent = {
  attr: 'wait_time_minutes';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateStepsPickupErrorComponent = {
  attr: 'steps_pickup';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateStepsDropoffErrorComponent = {
  attr: 'steps_dropoff';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateNumAttendantsErrorComponent = {
  attr: 'num_attendants';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateNumAdditionalPassengersErrorComponent = {
  attr: 'num_additional_passengers';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateIsBariatricErrorComponent = {
  attr: 'is_bariatric';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateIsWheelchairProvidedErrorComponent = {
  attr: 'is_wheelchair_provided';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateIsOxygenProvidedErrorComponent = {
  attr: 'is_oxygen_provided';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateServiceTypeErrorComponent = {
  attr: 'service_type';
  code: 'invalid_choice';
  detail: string;
};
export type PricingPriceQuoteCreatePayerErrorComponent = {
  attr: 'payer';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateIsWillCallErrorComponent = {
  attr: 'is_will_call';
  code: 'invalid' | 'null';
  detail: string;
};
export type PricingPriceQuoteCreateIsWillCallActivatedErrorComponent = {
  attr: 'is_will_call_activated';
  code: 'invalid' | 'null';
  detail: string;
};
export type PricingPriceQuoteCreateHasInfectiousDiseaseErrorComponent = {
  attr: 'has_infectious_disease';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPriceQuoteCreateIsTripSubscriptionErrorComponent = {
  attr: 'is_trip_subscription';
  code: 'invalid' | 'null';
  detail: string;
};
export type PricingPriceQuoteCreateIsCarSeatRequiredErrorComponent = {
  attr: 'is_car_seat_required';
  code: 'invalid' | 'null';
  detail: string;
};
export type PricingPriceQuoteCreateIsBoosterSeatRequiredErrorComponent = {
  attr: 'is_booster_seat_required';
  code: 'invalid' | 'null';
  detail: string;
};
export type PricingPriceQuoteCreateIsRideAloneErrorComponent = {
  attr: 'is_ride_alone';
  code: 'invalid' | 'null';
  detail: string;
};
export type PricingPriceQuoteCreateIsWaitAndReturnOutboundErrorComponent = {
  attr: 'is_wait_and_return_outbound';
  code: 'invalid' | 'null';
  detail: string;
};
export type PricingPriceQuoteCreateIsWaitAndReturnInboundErrorComponent = {
  attr: 'is_wait_and_return_inbound';
  code: 'invalid' | 'null';
  detail: string;
};
export type PricingPriceQuoteCreateWaitAndReturnFirstLegScheduledPickupAtErrorComponent =
  {
    attr: 'wait_and_return_first_leg_scheduled_pickup_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type PricingPriceQuoteCreateWaitAndReturnFirstLegPickupPlaceIdErrorComponent =
  {
    attr: 'wait_and_return_first_leg_pickup_place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PricingPriceQuoteCreateWaitAndReturnFirstLegDropoffPlaceIdErrorComponent =
  {
    attr: 'wait_and_return_first_leg_dropoff_place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type PricingPriceQuoteCreateTripIdErrorComponent = {
  attr: 'trip_id';
  code: 'invalid';
  detail: string;
};
export type PricingPriceQuoteCreateError =
  | ({
      attr: 'non_field_errors';
    } & PricingPriceQuoteCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'is_canceled';
    } & PricingPriceQuoteCreateIsCanceledErrorComponent)
  | ({
      attr: 'cancellation_reason';
    } & PricingPriceQuoteCreateCancellationReasonErrorComponent)
  | ({
      attr: 'canceled_at';
    } & PricingPriceQuoteCreateCanceledAtErrorComponent)
  | ({
      attr: 'pickup_at';
    } & PricingPriceQuoteCreatePickupAtErrorComponent)
  | ({
      attr: 'pickup_place_id';
    } & PricingPriceQuoteCreatePickupPlaceIdErrorComponent)
  | ({
      attr: 'dropoff_place_id';
    } & PricingPriceQuoteCreateDropoffPlaceIdErrorComponent)
  | ({
      attr: 'wait_time_minutes';
    } & PricingPriceQuoteCreateWaitTimeMinutesErrorComponent)
  | ({
      attr: 'steps_pickup';
    } & PricingPriceQuoteCreateStepsPickupErrorComponent)
  | ({
      attr: 'steps_dropoff';
    } & PricingPriceQuoteCreateStepsDropoffErrorComponent)
  | ({
      attr: 'num_attendants';
    } & PricingPriceQuoteCreateNumAttendantsErrorComponent)
  | ({
      attr: 'num_additional_passengers';
    } & PricingPriceQuoteCreateNumAdditionalPassengersErrorComponent)
  | ({
      attr: 'is_bariatric';
    } & PricingPriceQuoteCreateIsBariatricErrorComponent)
  | ({
      attr: 'is_wheelchair_provided';
    } & PricingPriceQuoteCreateIsWheelchairProvidedErrorComponent)
  | ({
      attr: 'is_oxygen_provided';
    } & PricingPriceQuoteCreateIsOxygenProvidedErrorComponent)
  | ({
      attr: 'space_type';
    } & PricingPriceQuoteCreateSpaceTypeErrorComponent)
  | ({
      attr: 'service_type';
    } & PricingPriceQuoteCreateServiceTypeErrorComponent)
  | ({
      attr: 'payer';
    } & PricingPriceQuoteCreatePayerErrorComponent)
  | ({
      attr: 'is_will_call';
    } & PricingPriceQuoteCreateIsWillCallErrorComponent)
  | ({
      attr: 'is_will_call_activated';
    } & PricingPriceQuoteCreateIsWillCallActivatedErrorComponent)
  | ({
      attr: 'has_infectious_disease';
    } & PricingPriceQuoteCreateHasInfectiousDiseaseErrorComponent)
  | ({
      attr: 'is_trip_subscription';
    } & PricingPriceQuoteCreateIsTripSubscriptionErrorComponent)
  | ({
      attr: 'is_car_seat_required';
    } & PricingPriceQuoteCreateIsCarSeatRequiredErrorComponent)
  | ({
      attr: 'is_booster_seat_required';
    } & PricingPriceQuoteCreateIsBoosterSeatRequiredErrorComponent)
  | ({
      attr: 'is_ride_alone';
    } & PricingPriceQuoteCreateIsRideAloneErrorComponent)
  | ({
      attr: 'is_wait_and_return_outbound';
    } & PricingPriceQuoteCreateIsWaitAndReturnOutboundErrorComponent)
  | ({
      attr: 'is_wait_and_return_inbound';
    } & PricingPriceQuoteCreateIsWaitAndReturnInboundErrorComponent)
  | ({
      attr: 'wait_and_return_first_leg_scheduled_pickup_at';
    } & PricingPriceQuoteCreateWaitAndReturnFirstLegScheduledPickupAtErrorComponent)
  | ({
      attr: 'wait_and_return_first_leg_pickup_place_id';
    } & PricingPriceQuoteCreateWaitAndReturnFirstLegPickupPlaceIdErrorComponent)
  | ({
      attr: 'wait_and_return_first_leg_dropoff_place_id';
    } & PricingPriceQuoteCreateWaitAndReturnFirstLegDropoffPlaceIdErrorComponent)
  | ({
      attr: 'trip_id';
    } & PricingPriceQuoteCreateTripIdErrorComponent);
export type PricingPriceQuoteCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PricingPriceQuoteCreateError[];
};
export type PricingPriceQuoteCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PricingPriceQuoteCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PriceSchemeConflictResults = {
  conflicts: string[];
};
export type PricingPricingSchemeConflictsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PricingPricingSchemeConflictsCreateIdErrorComponent = {
  attr: 'id';
  code: 'invalid' | 'null';
  detail: string;
};
export type PricingPricingSchemeConflictsCreateNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PricingPricingSchemeConflictsCreateStartDateErrorComponent = {
  attr: 'start_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemeConflictsCreateEndDateErrorComponent = {
  attr: 'end_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemeConflictsCreateSpaceTypesErrorComponent = {
  attr: 'space_types';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemeConflictsCreateSpaceTypesIndexErrorComponent = {
  attr: 'space_types.INDEX';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PricingPricingSchemeConflictsCreateServiceTypesErrorComponent = {
  attr: 'service_types';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type PricingPricingSchemeConflictsCreateServiceTypesIndexErrorComponent =
  {
    attr: 'service_types.INDEX';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type PricingPricingSchemeConflictsCreatePayerIdsErrorComponent = {
  attr: 'payer_ids';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemeConflictsCreatePayerIdsIndexErrorComponent = {
  attr: 'payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemeConflictsCreateMileageRangeHundredthsLowerErrorComponent =
  {
    attr: 'mileage_range_hundredths_lower';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemeConflictsCreateMileageRangeHundredthsUpperErrorComponent =
  {
    attr: 'mileage_range_hundredths_upper';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemeConflictsCreateError =
  | ({
      attr: 'non_field_errors';
    } & PricingPricingSchemeConflictsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & PricingPricingSchemeConflictsCreateIdErrorComponent)
  | ({
      attr: 'name';
    } & PricingPricingSchemeConflictsCreateNameErrorComponent)
  | ({
      attr: 'start_date';
    } & PricingPricingSchemeConflictsCreateStartDateErrorComponent)
  | ({
      attr: 'end_date';
    } & PricingPricingSchemeConflictsCreateEndDateErrorComponent)
  | ({
      attr: 'space_types';
    } & PricingPricingSchemeConflictsCreateSpaceTypesErrorComponent)
  | ({
      attr: 'space_types.INDEX';
    } & PricingPricingSchemeConflictsCreateSpaceTypesIndexErrorComponent)
  | ({
      attr: 'service_types';
    } & PricingPricingSchemeConflictsCreateServiceTypesErrorComponent)
  | ({
      attr: 'service_types.INDEX';
    } & PricingPricingSchemeConflictsCreateServiceTypesIndexErrorComponent)
  | ({
      attr: 'payer_ids';
    } & PricingPricingSchemeConflictsCreatePayerIdsErrorComponent)
  | ({
      attr: 'payer_ids.INDEX';
    } & PricingPricingSchemeConflictsCreatePayerIdsIndexErrorComponent)
  | ({
      attr: 'mileage_range_hundredths_lower';
    } & PricingPricingSchemeConflictsCreateMileageRangeHundredthsLowerErrorComponent)
  | ({
      attr: 'mileage_range_hundredths_upper';
    } & PricingPricingSchemeConflictsCreateMileageRangeHundredthsUpperErrorComponent);
export type PricingPricingSchemeConflictsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PricingPricingSchemeConflictsCreateError[];
};
export type PricingPricingSchemeConflictsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PricingPricingSchemeConflictsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PriceSchemeConflict = {};
export type PriceSchemeConflictWrite = {
  id?: string;
  name: string;
  start_date: string;
  end_date: string;
  space_types: string[];
  service_types?: ServiceTypeEnum[];
  payer_ids: string[];
  mileage_range_hundredths_lower?: number | null;
  mileage_range_hundredths_upper?: number | null;
};
export type RoundingEnum = 'none' | 'up' | 'down' | 'nearest';
export type PriceRoundingIntervalEnum = 1 | 5 | 10;
export type StairFeeTypeEnum = 'Flat' | 'Rate';
export type ObservedHolidaysEnum =
  | "New Year's Day"
  | 'Martin Luther King Jr. Day'
  | "Washington's Birthday"
  | 'Memorial Day'
  | 'Juneteenth'
  | 'Independence Day'
  | 'Labor Day'
  | 'Columbus Day'
  | 'Veterans Day'
  | 'Thanksgiving'
  | 'Christmas';
export type PricingScheme = {
  /** Name of the pricing scheme, this should be unique */
  name: string;
  /** Description of the pricing scheme */
  description?: string;
  /** Date the pricing scheme goes into effect */
  start_date: string;
  /** Date the pricing scheme is no longer in effect */
  end_date: string;
  /** Space types that this pricing scheme applies to */
  space_types?: SpaceTypeEnum[];
  service_types?: ServiceTypeEnum[];
  /** Base fee in cents */
  base_fee_cents?: number | null;
  /** How the mileage is rounded */
  mileage_rounding?: RoundingEnum;
  price_rounding?: RoundingEnum;
  price_rounding_interval?: (PriceRoundingIntervalEnum | NullEnum) | null;
  /** Rate in cents per loaded mile */
  loaded_mileage_rate_cents?: number | null;
  /** Rate in cents per mile for long distance trips */
  long_distance_mileage_rate_cents?: number | null;
  /** Minimum distance in miles for long distance trips */
  long_distance_mileage_start?: number | null;
  /** Number of free loaded miles */
  free_loaded_miles?: number | null;
  /** Rate in cents per unloaded mile */
  unloaded_mileage_rate_cents?: number | null;
  /** Number of free unloaded miles */
  free_unloaded_miles?: number | null;
  /** Rate in cents per unloaded return mile */
  unloaded_return_mileage_rate_cents?: number | null;
  /** Number of free unloaded return miles */
  free_unloaded_return_miles?: number | null;
  /** Rate in cents per wait time period */
  wait_time_rate_cents?: number | null;
  /** Wait time period in minutes */
  wait_time_period_minutes?: number | null;
  /** Number of free wait time minutes */
  wait_time_free_minutes?: number | null;
  /** Fee in cents for late cancellations */
  late_cancellation_fee_cents?: number | null;
  /** Minutes before scheduled pickup time for late cancellations */
  late_cancellation_period_minutes?: number | null;
  /** Fee in cents for no shows */
  no_show_fee_cents?: number | null;
  /** Fee in cents for stairs */
  stair_fee_cents?: number | null;
  /** Minimum number of steps for the stair fee to be applied */
  minimum_steps?: number | null;
  /** Type of stair fee, flat fee or per step fee */
  stair_fee_type?: StairFeeTypeEnum | BlankEnum;
  /** Fee in cents for each additional attendant */
  additional_attendant_rate_cents?: number | null;
  /** Fee in cents for each additional passenger */
  additional_passenger_rate_cents?: number | null;
  /** Fee in cents for bariatric passengers */
  bariatric_passenger_fee_cents?: number | null;
  /** Fee in cents for wheelchair rentals */
  wheelchair_rental_fee_cents?: number | null;
  /** Fee in cents for oxygen */
  oxygen_fee_cents?: number | null;
  /** Fee in cents for weekend trips */
  weekend_fee_cents?: number | null;
  /** Fee in cents for after hours trips */
  after_hours_fee_cents?: number | null;
  /** Time before which trips are considered after hours */
  business_hours_start_time?: string | null;
  /** Time after which trips are considered after hours */
  business_hours_end_time?: string | null;
  /** Fee in cents for holiday trips */
  holiday_fee_cents?: number | null;
  /** Holidays that this pricing scheme applies to */
  observed_holidays?: ObservedHolidaysEnum[] | null;
  /** Minimum price in cents for this pricing scheme */
  minimum_price_cents?: number | null;
  /** Type of cancellation fee, flat fee or as a percentage of the trip cost */
  late_cancellation_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  /** Type of no show fee, flat fee or as a percentage of the trip cost */
  no_show_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  /** Fee in cents for passenger with infectious disease */
  infectious_disease_fee_cents?: number | null;
  /** Fee in cents for for same day booking */
  same_day_booking_fee_cents?: number | null;
  /** Fee in cents for car seat */
  car_seat_fee_cents?: number | null;
  /** Fee in cents for booster seat */
  booster_seat_fee_cents?: number | null;
  /** Fee in cents for ride alone */
  ride_alone_fee_cents?: number | null;
  mileage_range_hundredths_lower?: number | null;
  mileage_range_hundredths_upper?: number | null;
};
export type PricingSchemePayer = {
  pricing_scheme: string;
  payer: string;
};
export type PricingSchemePayerRead = {
  id: string;
  pricing_scheme: string;
  payer: string;
  display_name: string;
};
export type PricingSchemeRead = {
  id: string;
  /** Name of the pricing scheme, this should be unique */
  name: string;
  /** Description of the pricing scheme */
  description?: string;
  /** Date the pricing scheme goes into effect */
  start_date: string;
  /** Date the pricing scheme is no longer in effect */
  end_date: string;
  /** Space types that this pricing scheme applies to */
  space_types?: SpaceTypeEnum[];
  service_types?: ServiceTypeEnum[];
  /** Base fee in cents */
  base_fee_cents?: number | null;
  /** How the mileage is rounded */
  mileage_rounding?: RoundingEnum;
  price_rounding?: RoundingEnum;
  price_rounding_interval?: (PriceRoundingIntervalEnum | NullEnum) | null;
  /** Rate in cents per loaded mile */
  loaded_mileage_rate_cents?: number | null;
  /** Rate in cents per mile for long distance trips */
  long_distance_mileage_rate_cents?: number | null;
  /** Minimum distance in miles for long distance trips */
  long_distance_mileage_start?: number | null;
  /** Number of free loaded miles */
  free_loaded_miles?: number | null;
  /** Rate in cents per unloaded mile */
  unloaded_mileage_rate_cents?: number | null;
  /** Number of free unloaded miles */
  free_unloaded_miles?: number | null;
  /** Rate in cents per unloaded return mile */
  unloaded_return_mileage_rate_cents?: number | null;
  /** Number of free unloaded return miles */
  free_unloaded_return_miles?: number | null;
  /** Rate in cents per wait time period */
  wait_time_rate_cents?: number | null;
  /** Wait time period in minutes */
  wait_time_period_minutes?: number | null;
  /** Number of free wait time minutes */
  wait_time_free_minutes?: number | null;
  /** Fee in cents for late cancellations */
  late_cancellation_fee_cents?: number | null;
  /** Minutes before scheduled pickup time for late cancellations */
  late_cancellation_period_minutes?: number | null;
  /** Fee in cents for no shows */
  no_show_fee_cents?: number | null;
  /** Fee in cents for stairs */
  stair_fee_cents?: number | null;
  /** Minimum number of steps for the stair fee to be applied */
  minimum_steps?: number | null;
  /** Type of stair fee, flat fee or per step fee */
  stair_fee_type?: StairFeeTypeEnum | BlankEnum;
  /** Fee in cents for each additional attendant */
  additional_attendant_rate_cents?: number | null;
  /** Fee in cents for each additional passenger */
  additional_passenger_rate_cents?: number | null;
  /** Fee in cents for bariatric passengers */
  bariatric_passenger_fee_cents?: number | null;
  /** Fee in cents for wheelchair rentals */
  wheelchair_rental_fee_cents?: number | null;
  /** Fee in cents for oxygen */
  oxygen_fee_cents?: number | null;
  /** Fee in cents for weekend trips */
  weekend_fee_cents?: number | null;
  /** Fee in cents for after hours trips */
  after_hours_fee_cents?: number | null;
  /** Time before which trips are considered after hours */
  business_hours_start_time?: string | null;
  /** Time after which trips are considered after hours */
  business_hours_end_time?: string | null;
  /** Fee in cents for holiday trips */
  holiday_fee_cents?: number | null;
  /** Holidays that this pricing scheme applies to */
  observed_holidays?: ObservedHolidaysEnum[] | null;
  /** Minimum price in cents for this pricing scheme */
  minimum_price_cents?: number | null;
  /** Type of cancellation fee, flat fee or as a percentage of the trip cost */
  late_cancellation_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  /** Type of no show fee, flat fee or as a percentage of the trip cost */
  no_show_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  payers: PricingSchemePayerRead[];
  /** Fee in cents for passenger with infectious disease */
  infectious_disease_fee_cents?: number | null;
  /** Fee in cents for for same day booking */
  same_day_booking_fee_cents?: number | null;
  /** Fee in cents for car seat */
  car_seat_fee_cents?: number | null;
  /** Fee in cents for booster seat */
  booster_seat_fee_cents?: number | null;
  /** Fee in cents for ride alone */
  ride_alone_fee_cents?: number | null;
  mileage_range_hundredths_lower?: number | null;
  mileage_range_hundredths_upper?: number | null;
};
export type PricingSchemeWrite = {
  /** Name of the pricing scheme, this should be unique */
  name: string;
  /** Description of the pricing scheme */
  description?: string;
  /** Date the pricing scheme goes into effect */
  start_date: string;
  /** Date the pricing scheme is no longer in effect */
  end_date: string;
  /** Space types that this pricing scheme applies to */
  space_types?: SpaceTypeEnum[];
  service_types?: ServiceTypeEnum[];
  /** Base fee in cents */
  base_fee_cents?: number | null;
  /** How the mileage is rounded */
  mileage_rounding?: RoundingEnum;
  price_rounding?: RoundingEnum;
  price_rounding_interval?: (PriceRoundingIntervalEnum | NullEnum) | null;
  /** Rate in cents per loaded mile */
  loaded_mileage_rate_cents?: number | null;
  /** Rate in cents per mile for long distance trips */
  long_distance_mileage_rate_cents?: number | null;
  /** Minimum distance in miles for long distance trips */
  long_distance_mileage_start?: number | null;
  /** Number of free loaded miles */
  free_loaded_miles?: number | null;
  /** Rate in cents per unloaded mile */
  unloaded_mileage_rate_cents?: number | null;
  /** Number of free unloaded miles */
  free_unloaded_miles?: number | null;
  /** Rate in cents per unloaded return mile */
  unloaded_return_mileage_rate_cents?: number | null;
  /** Number of free unloaded return miles */
  free_unloaded_return_miles?: number | null;
  /** Rate in cents per wait time period */
  wait_time_rate_cents?: number | null;
  /** Wait time period in minutes */
  wait_time_period_minutes?: number | null;
  /** Number of free wait time minutes */
  wait_time_free_minutes?: number | null;
  /** Fee in cents for late cancellations */
  late_cancellation_fee_cents?: number | null;
  /** Minutes before scheduled pickup time for late cancellations */
  late_cancellation_period_minutes?: number | null;
  /** Fee in cents for no shows */
  no_show_fee_cents?: number | null;
  /** Fee in cents for stairs */
  stair_fee_cents?: number | null;
  /** Minimum number of steps for the stair fee to be applied */
  minimum_steps?: number | null;
  /** Type of stair fee, flat fee or per step fee */
  stair_fee_type?: StairFeeTypeEnum | BlankEnum;
  /** Fee in cents for each additional attendant */
  additional_attendant_rate_cents?: number | null;
  /** Fee in cents for each additional passenger */
  additional_passenger_rate_cents?: number | null;
  /** Fee in cents for bariatric passengers */
  bariatric_passenger_fee_cents?: number | null;
  /** Fee in cents for wheelchair rentals */
  wheelchair_rental_fee_cents?: number | null;
  /** Fee in cents for oxygen */
  oxygen_fee_cents?: number | null;
  /** Fee in cents for weekend trips */
  weekend_fee_cents?: number | null;
  /** Fee in cents for after hours trips */
  after_hours_fee_cents?: number | null;
  /** Time before which trips are considered after hours */
  business_hours_start_time?: string | null;
  /** Time after which trips are considered after hours */
  business_hours_end_time?: string | null;
  /** Fee in cents for holiday trips */
  holiday_fee_cents?: number | null;
  /** Holidays that this pricing scheme applies to */
  observed_holidays?: ObservedHolidaysEnum[] | null;
  /** Minimum price in cents for this pricing scheme */
  minimum_price_cents?: number | null;
  /** Type of cancellation fee, flat fee or as a percentage of the trip cost */
  late_cancellation_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  /** Type of no show fee, flat fee or as a percentage of the trip cost */
  no_show_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  payer_ids: string[];
  /** Fee in cents for passenger with infectious disease */
  infectious_disease_fee_cents?: number | null;
  /** Fee in cents for for same day booking */
  same_day_booking_fee_cents?: number | null;
  /** Fee in cents for car seat */
  car_seat_fee_cents?: number | null;
  /** Fee in cents for booster seat */
  booster_seat_fee_cents?: number | null;
  /** Fee in cents for ride alone */
  ride_alone_fee_cents?: number | null;
  mileage_range_hundredths_lower?: number | null;
  mileage_range_hundredths_upper?: number | null;
};
export type PaginatedPricingSchemeList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PricingScheme[];
};
export type PaginatedPricingSchemeListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PricingSchemeRead[];
};
export type PaginatedPricingSchemeListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: PricingSchemeWrite[];
};
export type PricingPricingSchemesListPricingSchemePayersPayerIdErrorComponent =
  {
    attr: 'pricing_scheme_payers__payer_id';
    code: 'invalid_choice';
    detail: string;
  };
export type PricingPricingSchemesListError = {
  attr: 'pricing_scheme_payers__payer_id';
} & PricingPricingSchemesListPricingSchemePayersPayerIdErrorComponent;
export type PricingPricingSchemesListValidationError = {
  type: ValidationErrorEnum;
  errors: PricingPricingSchemesListError[];
};
export type PricingPricingSchemesListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PricingPricingSchemesListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PricingPricingSchemesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PricingPricingSchemesCreateNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PricingPricingSchemesCreateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PricingPricingSchemesCreateStartDateErrorComponent = {
  attr: 'start_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesCreateEndDateErrorComponent = {
  attr: 'end_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesCreateSpaceTypesErrorComponent = {
  attr: 'space_types';
  code: 'empty' | 'not_a_list' | 'null';
  detail: string;
};
export type PricingPricingSchemesCreateSpaceTypesIndexErrorComponent = {
  attr: 'space_types.INDEX';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesCreateServiceTypesErrorComponent = {
  attr: 'service_types';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type PricingPricingSchemesCreateServiceTypesIndexErrorComponent = {
  attr: 'service_types.INDEX';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesCreateBaseFeeCentsErrorComponent = {
  attr: 'base_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateMileageRoundingErrorComponent = {
  attr: 'mileage_rounding';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PricingPricingSchemesCreatePriceRoundingErrorComponent = {
  attr: 'price_rounding';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PricingPricingSchemesCreatePriceRoundingIntervalErrorComponent = {
  attr: 'price_rounding_interval';
  code: 'invalid_choice';
  detail: string;
};
export type PricingPricingSchemesCreateLoadedMileageRateCentsErrorComponent = {
  attr: 'loaded_mileage_rate_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateLongDistanceMileageRateCentsErrorComponent =
  {
    attr: 'long_distance_mileage_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateLongDistanceMileageStartErrorComponent =
  {
    attr: 'long_distance_mileage_start';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateFreeLoadedMilesErrorComponent = {
  attr: 'free_loaded_miles';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateUnloadedMileageRateCentsErrorComponent =
  {
    attr: 'unloaded_mileage_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateFreeUnloadedMilesErrorComponent = {
  attr: 'free_unloaded_miles';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateUnloadedReturnMileageRateCentsErrorComponent =
  {
    attr: 'unloaded_return_mileage_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateFreeUnloadedReturnMilesErrorComponent = {
  attr: 'free_unloaded_return_miles';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateWaitTimeRateCentsErrorComponent = {
  attr: 'wait_time_rate_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateWaitTimePeriodMinutesErrorComponent = {
  attr: 'wait_time_period_minutes';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateWaitTimeFreeMinutesErrorComponent = {
  attr: 'wait_time_free_minutes';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateLateCancellationFeeCentsErrorComponent =
  {
    attr: 'late_cancellation_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateLateCancellationPeriodMinutesErrorComponent =
  {
    attr: 'late_cancellation_period_minutes';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateNoShowFeeCentsErrorComponent = {
  attr: 'no_show_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateStairFeeCentsErrorComponent = {
  attr: 'stair_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateMinimumStepsErrorComponent = {
  attr: 'minimum_steps';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateStairFeeTypeErrorComponent = {
  attr: 'stair_fee_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PricingPricingSchemesCreateAdditionalAttendantRateCentsErrorComponent =
  {
    attr: 'additional_attendant_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateAdditionalPassengerRateCentsErrorComponent =
  {
    attr: 'additional_passenger_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateBariatricPassengerFeeCentsErrorComponent =
  {
    attr: 'bariatric_passenger_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateWheelchairRentalFeeCentsErrorComponent =
  {
    attr: 'wheelchair_rental_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateOxygenFeeCentsErrorComponent = {
  attr: 'oxygen_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateWeekendFeeCentsErrorComponent = {
  attr: 'weekend_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateAfterHoursFeeCentsErrorComponent = {
  attr: 'after_hours_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateBusinessHoursStartTimeErrorComponent = {
  attr: 'business_hours_start_time';
  code: 'invalid';
  detail: string;
};
export type PricingPricingSchemesCreateBusinessHoursEndTimeErrorComponent = {
  attr: 'business_hours_end_time';
  code: 'invalid';
  detail: string;
};
export type PricingPricingSchemesCreateHolidayFeeCentsErrorComponent = {
  attr: 'holiday_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateObservedHolidaysErrorComponent = {
  attr: 'observed_holidays';
  code: 'not_a_list';
  detail: string;
};
export type PricingPricingSchemesCreateObservedHolidaysIndexErrorComponent = {
  attr: 'observed_holidays.INDEX';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesCreateMinimumPriceCentsErrorComponent = {
  attr: 'minimum_price_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateLateCancellationFeeTypeErrorComponent = {
  attr: 'late_cancellation_fee_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PricingPricingSchemesCreateNoShowFeeTypeErrorComponent = {
  attr: 'no_show_fee_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PricingPricingSchemesCreatePayersIndexPricingSchemeErrorComponent =
  {
    attr: 'payers.INDEX.pricing_scheme';
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
  };
export type PricingPricingSchemesCreatePayersIndexPayerErrorComponent = {
  attr: 'payers.INDEX.payer';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesCreatePayerIdsErrorComponent = {
  attr: 'payer_ids';
  code: 'empty' | 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesCreatePayerIdsIndexErrorComponent = {
  attr: 'payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesCreateInfectiousDiseaseFeeCentsErrorComponent =
  {
    attr: 'infectious_disease_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesCreateSameDayBookingFeeCentsErrorComponent = {
  attr: 'same_day_booking_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateCarSeatFeeCentsErrorComponent = {
  attr: 'car_seat_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateBoosterSeatFeeCentsErrorComponent = {
  attr: 'booster_seat_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateRideAloneFeeCentsErrorComponent = {
  attr: 'ride_alone_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesCreateMileageRangeHundredthsLowerErrorComponent =
  {
    attr: 'mileage_range_hundredths_lower';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type PricingPricingSchemesCreateMileageRangeHundredthsUpperErrorComponent =
  {
    attr: 'mileage_range_hundredths_upper';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type PricingPricingSchemesCreateError =
  | ({
      attr: 'non_field_errors';
    } & PricingPricingSchemesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & PricingPricingSchemesCreateNameErrorComponent)
  | ({
      attr: 'description';
    } & PricingPricingSchemesCreateDescriptionErrorComponent)
  | ({
      attr: 'start_date';
    } & PricingPricingSchemesCreateStartDateErrorComponent)
  | ({
      attr: 'end_date';
    } & PricingPricingSchemesCreateEndDateErrorComponent)
  | ({
      attr: 'space_types';
    } & PricingPricingSchemesCreateSpaceTypesErrorComponent)
  | ({
      attr: 'space_types.INDEX';
    } & PricingPricingSchemesCreateSpaceTypesIndexErrorComponent)
  | ({
      attr: 'service_types';
    } & PricingPricingSchemesCreateServiceTypesErrorComponent)
  | ({
      attr: 'service_types.INDEX';
    } & PricingPricingSchemesCreateServiceTypesIndexErrorComponent)
  | ({
      attr: 'base_fee_cents';
    } & PricingPricingSchemesCreateBaseFeeCentsErrorComponent)
  | ({
      attr: 'mileage_rounding';
    } & PricingPricingSchemesCreateMileageRoundingErrorComponent)
  | ({
      attr: 'price_rounding';
    } & PricingPricingSchemesCreatePriceRoundingErrorComponent)
  | ({
      attr: 'price_rounding_interval';
    } & PricingPricingSchemesCreatePriceRoundingIntervalErrorComponent)
  | ({
      attr: 'loaded_mileage_rate_cents';
    } & PricingPricingSchemesCreateLoadedMileageRateCentsErrorComponent)
  | ({
      attr: 'long_distance_mileage_rate_cents';
    } & PricingPricingSchemesCreateLongDistanceMileageRateCentsErrorComponent)
  | ({
      attr: 'long_distance_mileage_start';
    } & PricingPricingSchemesCreateLongDistanceMileageStartErrorComponent)
  | ({
      attr: 'free_loaded_miles';
    } & PricingPricingSchemesCreateFreeLoadedMilesErrorComponent)
  | ({
      attr: 'unloaded_mileage_rate_cents';
    } & PricingPricingSchemesCreateUnloadedMileageRateCentsErrorComponent)
  | ({
      attr: 'free_unloaded_miles';
    } & PricingPricingSchemesCreateFreeUnloadedMilesErrorComponent)
  | ({
      attr: 'unloaded_return_mileage_rate_cents';
    } & PricingPricingSchemesCreateUnloadedReturnMileageRateCentsErrorComponent)
  | ({
      attr: 'free_unloaded_return_miles';
    } & PricingPricingSchemesCreateFreeUnloadedReturnMilesErrorComponent)
  | ({
      attr: 'wait_time_rate_cents';
    } & PricingPricingSchemesCreateWaitTimeRateCentsErrorComponent)
  | ({
      attr: 'wait_time_period_minutes';
    } & PricingPricingSchemesCreateWaitTimePeriodMinutesErrorComponent)
  | ({
      attr: 'wait_time_free_minutes';
    } & PricingPricingSchemesCreateWaitTimeFreeMinutesErrorComponent)
  | ({
      attr: 'late_cancellation_fee_cents';
    } & PricingPricingSchemesCreateLateCancellationFeeCentsErrorComponent)
  | ({
      attr: 'late_cancellation_period_minutes';
    } & PricingPricingSchemesCreateLateCancellationPeriodMinutesErrorComponent)
  | ({
      attr: 'no_show_fee_cents';
    } & PricingPricingSchemesCreateNoShowFeeCentsErrorComponent)
  | ({
      attr: 'stair_fee_cents';
    } & PricingPricingSchemesCreateStairFeeCentsErrorComponent)
  | ({
      attr: 'minimum_steps';
    } & PricingPricingSchemesCreateMinimumStepsErrorComponent)
  | ({
      attr: 'stair_fee_type';
    } & PricingPricingSchemesCreateStairFeeTypeErrorComponent)
  | ({
      attr: 'additional_attendant_rate_cents';
    } & PricingPricingSchemesCreateAdditionalAttendantRateCentsErrorComponent)
  | ({
      attr: 'additional_passenger_rate_cents';
    } & PricingPricingSchemesCreateAdditionalPassengerRateCentsErrorComponent)
  | ({
      attr: 'bariatric_passenger_fee_cents';
    } & PricingPricingSchemesCreateBariatricPassengerFeeCentsErrorComponent)
  | ({
      attr: 'wheelchair_rental_fee_cents';
    } & PricingPricingSchemesCreateWheelchairRentalFeeCentsErrorComponent)
  | ({
      attr: 'oxygen_fee_cents';
    } & PricingPricingSchemesCreateOxygenFeeCentsErrorComponent)
  | ({
      attr: 'weekend_fee_cents';
    } & PricingPricingSchemesCreateWeekendFeeCentsErrorComponent)
  | ({
      attr: 'after_hours_fee_cents';
    } & PricingPricingSchemesCreateAfterHoursFeeCentsErrorComponent)
  | ({
      attr: 'business_hours_start_time';
    } & PricingPricingSchemesCreateBusinessHoursStartTimeErrorComponent)
  | ({
      attr: 'business_hours_end_time';
    } & PricingPricingSchemesCreateBusinessHoursEndTimeErrorComponent)
  | ({
      attr: 'holiday_fee_cents';
    } & PricingPricingSchemesCreateHolidayFeeCentsErrorComponent)
  | ({
      attr: 'observed_holidays';
    } & PricingPricingSchemesCreateObservedHolidaysErrorComponent)
  | ({
      attr: 'observed_holidays.INDEX';
    } & PricingPricingSchemesCreateObservedHolidaysIndexErrorComponent)
  | ({
      attr: 'minimum_price_cents';
    } & PricingPricingSchemesCreateMinimumPriceCentsErrorComponent)
  | ({
      attr: 'late_cancellation_fee_type';
    } & PricingPricingSchemesCreateLateCancellationFeeTypeErrorComponent)
  | ({
      attr: 'no_show_fee_type';
    } & PricingPricingSchemesCreateNoShowFeeTypeErrorComponent)
  | ({
      attr: 'payers.INDEX.pricing_scheme';
    } & PricingPricingSchemesCreatePayersIndexPricingSchemeErrorComponent)
  | ({
      attr: 'payers.INDEX.payer';
    } & PricingPricingSchemesCreatePayersIndexPayerErrorComponent)
  | ({
      attr: 'payer_ids';
    } & PricingPricingSchemesCreatePayerIdsErrorComponent)
  | ({
      attr: 'payer_ids.INDEX';
    } & PricingPricingSchemesCreatePayerIdsIndexErrorComponent)
  | ({
      attr: 'infectious_disease_fee_cents';
    } & PricingPricingSchemesCreateInfectiousDiseaseFeeCentsErrorComponent)
  | ({
      attr: 'same_day_booking_fee_cents';
    } & PricingPricingSchemesCreateSameDayBookingFeeCentsErrorComponent)
  | ({
      attr: 'car_seat_fee_cents';
    } & PricingPricingSchemesCreateCarSeatFeeCentsErrorComponent)
  | ({
      attr: 'booster_seat_fee_cents';
    } & PricingPricingSchemesCreateBoosterSeatFeeCentsErrorComponent)
  | ({
      attr: 'ride_alone_fee_cents';
    } & PricingPricingSchemesCreateRideAloneFeeCentsErrorComponent)
  | ({
      attr: 'mileage_range_hundredths_lower';
    } & PricingPricingSchemesCreateMileageRangeHundredthsLowerErrorComponent)
  | ({
      attr: 'mileage_range_hundredths_upper';
    } & PricingPricingSchemesCreateMileageRangeHundredthsUpperErrorComponent);
export type PricingPricingSchemesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: PricingPricingSchemesCreateError[];
};
export type PricingPricingSchemesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PricingPricingSchemesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PricingPricingSchemesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PricingPricingSchemesPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateStartDateErrorComponent = {
  attr: 'start_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateEndDateErrorComponent = {
  attr: 'end_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateSpaceTypesErrorComponent = {
  attr: 'space_types';
  code: 'empty' | 'not_a_list' | 'null';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateSpaceTypesIndexErrorComponent = {
  attr: 'space_types.INDEX';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateServiceTypesErrorComponent = {
  attr: 'service_types';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateServiceTypesIndexErrorComponent =
  {
    attr: 'service_types.INDEX';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateBaseFeeCentsErrorComponent = {
  attr: 'base_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateMileageRoundingErrorComponent = {
  attr: 'mileage_rounding';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PricingPricingSchemesPartialUpdatePriceRoundingErrorComponent = {
  attr: 'price_rounding';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PricingPricingSchemesPartialUpdatePriceRoundingIntervalErrorComponent =
  {
    attr: 'price_rounding_interval';
    code: 'invalid_choice';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateLoadedMileageRateCentsErrorComponent =
  {
    attr: 'loaded_mileage_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateLongDistanceMileageRateCentsErrorComponent =
  {
    attr: 'long_distance_mileage_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateLongDistanceMileageStartErrorComponent =
  {
    attr: 'long_distance_mileage_start';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateFreeLoadedMilesErrorComponent = {
  attr: 'free_loaded_miles';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateUnloadedMileageRateCentsErrorComponent =
  {
    attr: 'unloaded_mileage_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateFreeUnloadedMilesErrorComponent =
  {
    attr: 'free_unloaded_miles';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateUnloadedReturnMileageRateCentsErrorComponent =
  {
    attr: 'unloaded_return_mileage_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateFreeUnloadedReturnMilesErrorComponent =
  {
    attr: 'free_unloaded_return_miles';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateWaitTimeRateCentsErrorComponent =
  {
    attr: 'wait_time_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateWaitTimePeriodMinutesErrorComponent =
  {
    attr: 'wait_time_period_minutes';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateWaitTimeFreeMinutesErrorComponent =
  {
    attr: 'wait_time_free_minutes';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateLateCancellationFeeCentsErrorComponent =
  {
    attr: 'late_cancellation_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateLateCancellationPeriodMinutesErrorComponent =
  {
    attr: 'late_cancellation_period_minutes';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateNoShowFeeCentsErrorComponent = {
  attr: 'no_show_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateStairFeeCentsErrorComponent = {
  attr: 'stair_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateMinimumStepsErrorComponent = {
  attr: 'minimum_steps';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateStairFeeTypeErrorComponent = {
  attr: 'stair_fee_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateAdditionalAttendantRateCentsErrorComponent =
  {
    attr: 'additional_attendant_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateAdditionalPassengerRateCentsErrorComponent =
  {
    attr: 'additional_passenger_rate_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateBariatricPassengerFeeCentsErrorComponent =
  {
    attr: 'bariatric_passenger_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateWheelchairRentalFeeCentsErrorComponent =
  {
    attr: 'wheelchair_rental_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateOxygenFeeCentsErrorComponent = {
  attr: 'oxygen_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateWeekendFeeCentsErrorComponent = {
  attr: 'weekend_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateAfterHoursFeeCentsErrorComponent =
  {
    attr: 'after_hours_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateBusinessHoursStartTimeErrorComponent =
  {
    attr: 'business_hours_start_time';
    code: 'invalid';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateBusinessHoursEndTimeErrorComponent =
  {
    attr: 'business_hours_end_time';
    code: 'invalid';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateHolidayFeeCentsErrorComponent = {
  attr: 'holiday_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateObservedHolidaysErrorComponent = {
  attr: 'observed_holidays';
  code: 'not_a_list';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateObservedHolidaysIndexErrorComponent =
  {
    attr: 'observed_holidays.INDEX';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateMinimumPriceCentsErrorComponent =
  {
    attr: 'minimum_price_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateLateCancellationFeeTypeErrorComponent =
  {
    attr: 'late_cancellation_fee_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateNoShowFeeTypeErrorComponent = {
  attr: 'no_show_fee_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type PricingPricingSchemesPartialUpdatePayersIndexPricingSchemeErrorComponent =
  {
    attr: 'payers.INDEX.pricing_scheme';
    code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdatePayersIndexPayerErrorComponent = {
  attr: 'payers.INDEX.payer';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesPartialUpdatePayerIdsErrorComponent = {
  attr: 'payer_ids';
  code: 'empty' | 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesPartialUpdatePayerIdsIndexErrorComponent = {
  attr: 'payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateInfectiousDiseaseFeeCentsErrorComponent =
  {
    attr: 'infectious_disease_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateSameDayBookingFeeCentsErrorComponent =
  {
    attr: 'same_day_booking_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateCarSeatFeeCentsErrorComponent = {
  attr: 'car_seat_fee_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type PricingPricingSchemesPartialUpdateBoosterSeatFeeCentsErrorComponent =
  {
    attr: 'booster_seat_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateRideAloneFeeCentsErrorComponent =
  {
    attr: 'ride_alone_fee_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateMileageRangeHundredthsLowerErrorComponent =
  {
    attr: 'mileage_range_hundredths_lower';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateMileageRangeHundredthsUpperErrorComponent =
  {
    attr: 'mileage_range_hundredths_upper';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type PricingPricingSchemesPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & PricingPricingSchemesPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & PricingPricingSchemesPartialUpdateNameErrorComponent)
  | ({
      attr: 'description';
    } & PricingPricingSchemesPartialUpdateDescriptionErrorComponent)
  | ({
      attr: 'start_date';
    } & PricingPricingSchemesPartialUpdateStartDateErrorComponent)
  | ({
      attr: 'end_date';
    } & PricingPricingSchemesPartialUpdateEndDateErrorComponent)
  | ({
      attr: 'space_types';
    } & PricingPricingSchemesPartialUpdateSpaceTypesErrorComponent)
  | ({
      attr: 'space_types.INDEX';
    } & PricingPricingSchemesPartialUpdateSpaceTypesIndexErrorComponent)
  | ({
      attr: 'service_types';
    } & PricingPricingSchemesPartialUpdateServiceTypesErrorComponent)
  | ({
      attr: 'service_types.INDEX';
    } & PricingPricingSchemesPartialUpdateServiceTypesIndexErrorComponent)
  | ({
      attr: 'base_fee_cents';
    } & PricingPricingSchemesPartialUpdateBaseFeeCentsErrorComponent)
  | ({
      attr: 'mileage_rounding';
    } & PricingPricingSchemesPartialUpdateMileageRoundingErrorComponent)
  | ({
      attr: 'price_rounding';
    } & PricingPricingSchemesPartialUpdatePriceRoundingErrorComponent)
  | ({
      attr: 'price_rounding_interval';
    } & PricingPricingSchemesPartialUpdatePriceRoundingIntervalErrorComponent)
  | ({
      attr: 'loaded_mileage_rate_cents';
    } & PricingPricingSchemesPartialUpdateLoadedMileageRateCentsErrorComponent)
  | ({
      attr: 'long_distance_mileage_rate_cents';
    } & PricingPricingSchemesPartialUpdateLongDistanceMileageRateCentsErrorComponent)
  | ({
      attr: 'long_distance_mileage_start';
    } & PricingPricingSchemesPartialUpdateLongDistanceMileageStartErrorComponent)
  | ({
      attr: 'free_loaded_miles';
    } & PricingPricingSchemesPartialUpdateFreeLoadedMilesErrorComponent)
  | ({
      attr: 'unloaded_mileage_rate_cents';
    } & PricingPricingSchemesPartialUpdateUnloadedMileageRateCentsErrorComponent)
  | ({
      attr: 'free_unloaded_miles';
    } & PricingPricingSchemesPartialUpdateFreeUnloadedMilesErrorComponent)
  | ({
      attr: 'unloaded_return_mileage_rate_cents';
    } & PricingPricingSchemesPartialUpdateUnloadedReturnMileageRateCentsErrorComponent)
  | ({
      attr: 'free_unloaded_return_miles';
    } & PricingPricingSchemesPartialUpdateFreeUnloadedReturnMilesErrorComponent)
  | ({
      attr: 'wait_time_rate_cents';
    } & PricingPricingSchemesPartialUpdateWaitTimeRateCentsErrorComponent)
  | ({
      attr: 'wait_time_period_minutes';
    } & PricingPricingSchemesPartialUpdateWaitTimePeriodMinutesErrorComponent)
  | ({
      attr: 'wait_time_free_minutes';
    } & PricingPricingSchemesPartialUpdateWaitTimeFreeMinutesErrorComponent)
  | ({
      attr: 'late_cancellation_fee_cents';
    } & PricingPricingSchemesPartialUpdateLateCancellationFeeCentsErrorComponent)
  | ({
      attr: 'late_cancellation_period_minutes';
    } & PricingPricingSchemesPartialUpdateLateCancellationPeriodMinutesErrorComponent)
  | ({
      attr: 'no_show_fee_cents';
    } & PricingPricingSchemesPartialUpdateNoShowFeeCentsErrorComponent)
  | ({
      attr: 'stair_fee_cents';
    } & PricingPricingSchemesPartialUpdateStairFeeCentsErrorComponent)
  | ({
      attr: 'minimum_steps';
    } & PricingPricingSchemesPartialUpdateMinimumStepsErrorComponent)
  | ({
      attr: 'stair_fee_type';
    } & PricingPricingSchemesPartialUpdateStairFeeTypeErrorComponent)
  | ({
      attr: 'additional_attendant_rate_cents';
    } & PricingPricingSchemesPartialUpdateAdditionalAttendantRateCentsErrorComponent)
  | ({
      attr: 'additional_passenger_rate_cents';
    } & PricingPricingSchemesPartialUpdateAdditionalPassengerRateCentsErrorComponent)
  | ({
      attr: 'bariatric_passenger_fee_cents';
    } & PricingPricingSchemesPartialUpdateBariatricPassengerFeeCentsErrorComponent)
  | ({
      attr: 'wheelchair_rental_fee_cents';
    } & PricingPricingSchemesPartialUpdateWheelchairRentalFeeCentsErrorComponent)
  | ({
      attr: 'oxygen_fee_cents';
    } & PricingPricingSchemesPartialUpdateOxygenFeeCentsErrorComponent)
  | ({
      attr: 'weekend_fee_cents';
    } & PricingPricingSchemesPartialUpdateWeekendFeeCentsErrorComponent)
  | ({
      attr: 'after_hours_fee_cents';
    } & PricingPricingSchemesPartialUpdateAfterHoursFeeCentsErrorComponent)
  | ({
      attr: 'business_hours_start_time';
    } & PricingPricingSchemesPartialUpdateBusinessHoursStartTimeErrorComponent)
  | ({
      attr: 'business_hours_end_time';
    } & PricingPricingSchemesPartialUpdateBusinessHoursEndTimeErrorComponent)
  | ({
      attr: 'holiday_fee_cents';
    } & PricingPricingSchemesPartialUpdateHolidayFeeCentsErrorComponent)
  | ({
      attr: 'observed_holidays';
    } & PricingPricingSchemesPartialUpdateObservedHolidaysErrorComponent)
  | ({
      attr: 'observed_holidays.INDEX';
    } & PricingPricingSchemesPartialUpdateObservedHolidaysIndexErrorComponent)
  | ({
      attr: 'minimum_price_cents';
    } & PricingPricingSchemesPartialUpdateMinimumPriceCentsErrorComponent)
  | ({
      attr: 'late_cancellation_fee_type';
    } & PricingPricingSchemesPartialUpdateLateCancellationFeeTypeErrorComponent)
  | ({
      attr: 'no_show_fee_type';
    } & PricingPricingSchemesPartialUpdateNoShowFeeTypeErrorComponent)
  | ({
      attr: 'payers.INDEX.pricing_scheme';
    } & PricingPricingSchemesPartialUpdatePayersIndexPricingSchemeErrorComponent)
  | ({
      attr: 'payers.INDEX.payer';
    } & PricingPricingSchemesPartialUpdatePayersIndexPayerErrorComponent)
  | ({
      attr: 'payer_ids';
    } & PricingPricingSchemesPartialUpdatePayerIdsErrorComponent)
  | ({
      attr: 'payer_ids.INDEX';
    } & PricingPricingSchemesPartialUpdatePayerIdsIndexErrorComponent)
  | ({
      attr: 'infectious_disease_fee_cents';
    } & PricingPricingSchemesPartialUpdateInfectiousDiseaseFeeCentsErrorComponent)
  | ({
      attr: 'same_day_booking_fee_cents';
    } & PricingPricingSchemesPartialUpdateSameDayBookingFeeCentsErrorComponent)
  | ({
      attr: 'car_seat_fee_cents';
    } & PricingPricingSchemesPartialUpdateCarSeatFeeCentsErrorComponent)
  | ({
      attr: 'booster_seat_fee_cents';
    } & PricingPricingSchemesPartialUpdateBoosterSeatFeeCentsErrorComponent)
  | ({
      attr: 'ride_alone_fee_cents';
    } & PricingPricingSchemesPartialUpdateRideAloneFeeCentsErrorComponent)
  | ({
      attr: 'mileage_range_hundredths_lower';
    } & PricingPricingSchemesPartialUpdateMileageRangeHundredthsLowerErrorComponent)
  | ({
      attr: 'mileage_range_hundredths_upper';
    } & PricingPricingSchemesPartialUpdateMileageRangeHundredthsUpperErrorComponent);
export type PricingPricingSchemesPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: PricingPricingSchemesPartialUpdateError[];
};
export type PricingPricingSchemesPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PricingPricingSchemesPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedPricingScheme = {
  /** Name of the pricing scheme, this should be unique */
  name?: string;
  /** Description of the pricing scheme */
  description?: string;
  /** Date the pricing scheme goes into effect */
  start_date?: string;
  /** Date the pricing scheme is no longer in effect */
  end_date?: string;
  /** Space types that this pricing scheme applies to */
  space_types?: SpaceTypeEnum[];
  service_types?: ServiceTypeEnum[];
  /** Base fee in cents */
  base_fee_cents?: number | null;
  /** How the mileage is rounded */
  mileage_rounding?: RoundingEnum;
  price_rounding?: RoundingEnum;
  price_rounding_interval?: (PriceRoundingIntervalEnum | NullEnum) | null;
  /** Rate in cents per loaded mile */
  loaded_mileage_rate_cents?: number | null;
  /** Rate in cents per mile for long distance trips */
  long_distance_mileage_rate_cents?: number | null;
  /** Minimum distance in miles for long distance trips */
  long_distance_mileage_start?: number | null;
  /** Number of free loaded miles */
  free_loaded_miles?: number | null;
  /** Rate in cents per unloaded mile */
  unloaded_mileage_rate_cents?: number | null;
  /** Number of free unloaded miles */
  free_unloaded_miles?: number | null;
  /** Rate in cents per unloaded return mile */
  unloaded_return_mileage_rate_cents?: number | null;
  /** Number of free unloaded return miles */
  free_unloaded_return_miles?: number | null;
  /** Rate in cents per wait time period */
  wait_time_rate_cents?: number | null;
  /** Wait time period in minutes */
  wait_time_period_minutes?: number | null;
  /** Number of free wait time minutes */
  wait_time_free_minutes?: number | null;
  /** Fee in cents for late cancellations */
  late_cancellation_fee_cents?: number | null;
  /** Minutes before scheduled pickup time for late cancellations */
  late_cancellation_period_minutes?: number | null;
  /** Fee in cents for no shows */
  no_show_fee_cents?: number | null;
  /** Fee in cents for stairs */
  stair_fee_cents?: number | null;
  /** Minimum number of steps for the stair fee to be applied */
  minimum_steps?: number | null;
  /** Type of stair fee, flat fee or per step fee */
  stair_fee_type?: StairFeeTypeEnum | BlankEnum;
  /** Fee in cents for each additional attendant */
  additional_attendant_rate_cents?: number | null;
  /** Fee in cents for each additional passenger */
  additional_passenger_rate_cents?: number | null;
  /** Fee in cents for bariatric passengers */
  bariatric_passenger_fee_cents?: number | null;
  /** Fee in cents for wheelchair rentals */
  wheelchair_rental_fee_cents?: number | null;
  /** Fee in cents for oxygen */
  oxygen_fee_cents?: number | null;
  /** Fee in cents for weekend trips */
  weekend_fee_cents?: number | null;
  /** Fee in cents for after hours trips */
  after_hours_fee_cents?: number | null;
  /** Time before which trips are considered after hours */
  business_hours_start_time?: string | null;
  /** Time after which trips are considered after hours */
  business_hours_end_time?: string | null;
  /** Fee in cents for holiday trips */
  holiday_fee_cents?: number | null;
  /** Holidays that this pricing scheme applies to */
  observed_holidays?: ObservedHolidaysEnum[] | null;
  /** Minimum price in cents for this pricing scheme */
  minimum_price_cents?: number | null;
  /** Type of cancellation fee, flat fee or as a percentage of the trip cost */
  late_cancellation_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  /** Type of no show fee, flat fee or as a percentage of the trip cost */
  no_show_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  /** Fee in cents for passenger with infectious disease */
  infectious_disease_fee_cents?: number | null;
  /** Fee in cents for for same day booking */
  same_day_booking_fee_cents?: number | null;
  /** Fee in cents for car seat */
  car_seat_fee_cents?: number | null;
  /** Fee in cents for booster seat */
  booster_seat_fee_cents?: number | null;
  /** Fee in cents for ride alone */
  ride_alone_fee_cents?: number | null;
  mileage_range_hundredths_lower?: number | null;
  mileage_range_hundredths_upper?: number | null;
};
export type PatchedPricingSchemeRead = {
  id?: string;
  /** Name of the pricing scheme, this should be unique */
  name?: string;
  /** Description of the pricing scheme */
  description?: string;
  /** Date the pricing scheme goes into effect */
  start_date?: string;
  /** Date the pricing scheme is no longer in effect */
  end_date?: string;
  /** Space types that this pricing scheme applies to */
  space_types?: SpaceTypeEnum[];
  service_types?: ServiceTypeEnum[];
  /** Base fee in cents */
  base_fee_cents?: number | null;
  /** How the mileage is rounded */
  mileage_rounding?: RoundingEnum;
  price_rounding?: RoundingEnum;
  price_rounding_interval?: (PriceRoundingIntervalEnum | NullEnum) | null;
  /** Rate in cents per loaded mile */
  loaded_mileage_rate_cents?: number | null;
  /** Rate in cents per mile for long distance trips */
  long_distance_mileage_rate_cents?: number | null;
  /** Minimum distance in miles for long distance trips */
  long_distance_mileage_start?: number | null;
  /** Number of free loaded miles */
  free_loaded_miles?: number | null;
  /** Rate in cents per unloaded mile */
  unloaded_mileage_rate_cents?: number | null;
  /** Number of free unloaded miles */
  free_unloaded_miles?: number | null;
  /** Rate in cents per unloaded return mile */
  unloaded_return_mileage_rate_cents?: number | null;
  /** Number of free unloaded return miles */
  free_unloaded_return_miles?: number | null;
  /** Rate in cents per wait time period */
  wait_time_rate_cents?: number | null;
  /** Wait time period in minutes */
  wait_time_period_minutes?: number | null;
  /** Number of free wait time minutes */
  wait_time_free_minutes?: number | null;
  /** Fee in cents for late cancellations */
  late_cancellation_fee_cents?: number | null;
  /** Minutes before scheduled pickup time for late cancellations */
  late_cancellation_period_minutes?: number | null;
  /** Fee in cents for no shows */
  no_show_fee_cents?: number | null;
  /** Fee in cents for stairs */
  stair_fee_cents?: number | null;
  /** Minimum number of steps for the stair fee to be applied */
  minimum_steps?: number | null;
  /** Type of stair fee, flat fee or per step fee */
  stair_fee_type?: StairFeeTypeEnum | BlankEnum;
  /** Fee in cents for each additional attendant */
  additional_attendant_rate_cents?: number | null;
  /** Fee in cents for each additional passenger */
  additional_passenger_rate_cents?: number | null;
  /** Fee in cents for bariatric passengers */
  bariatric_passenger_fee_cents?: number | null;
  /** Fee in cents for wheelchair rentals */
  wheelchair_rental_fee_cents?: number | null;
  /** Fee in cents for oxygen */
  oxygen_fee_cents?: number | null;
  /** Fee in cents for weekend trips */
  weekend_fee_cents?: number | null;
  /** Fee in cents for after hours trips */
  after_hours_fee_cents?: number | null;
  /** Time before which trips are considered after hours */
  business_hours_start_time?: string | null;
  /** Time after which trips are considered after hours */
  business_hours_end_time?: string | null;
  /** Fee in cents for holiday trips */
  holiday_fee_cents?: number | null;
  /** Holidays that this pricing scheme applies to */
  observed_holidays?: ObservedHolidaysEnum[] | null;
  /** Minimum price in cents for this pricing scheme */
  minimum_price_cents?: number | null;
  /** Type of cancellation fee, flat fee or as a percentage of the trip cost */
  late_cancellation_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  /** Type of no show fee, flat fee or as a percentage of the trip cost */
  no_show_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  payers?: PricingSchemePayerRead[];
  /** Fee in cents for passenger with infectious disease */
  infectious_disease_fee_cents?: number | null;
  /** Fee in cents for for same day booking */
  same_day_booking_fee_cents?: number | null;
  /** Fee in cents for car seat */
  car_seat_fee_cents?: number | null;
  /** Fee in cents for booster seat */
  booster_seat_fee_cents?: number | null;
  /** Fee in cents for ride alone */
  ride_alone_fee_cents?: number | null;
  mileage_range_hundredths_lower?: number | null;
  mileage_range_hundredths_upper?: number | null;
};
export type PatchedPricingSchemeWrite = {
  /** Name of the pricing scheme, this should be unique */
  name?: string;
  /** Description of the pricing scheme */
  description?: string;
  /** Date the pricing scheme goes into effect */
  start_date?: string;
  /** Date the pricing scheme is no longer in effect */
  end_date?: string;
  /** Space types that this pricing scheme applies to */
  space_types?: SpaceTypeEnum[];
  service_types?: ServiceTypeEnum[];
  /** Base fee in cents */
  base_fee_cents?: number | null;
  /** How the mileage is rounded */
  mileage_rounding?: RoundingEnum;
  price_rounding?: RoundingEnum;
  price_rounding_interval?: (PriceRoundingIntervalEnum | NullEnum) | null;
  /** Rate in cents per loaded mile */
  loaded_mileage_rate_cents?: number | null;
  /** Rate in cents per mile for long distance trips */
  long_distance_mileage_rate_cents?: number | null;
  /** Minimum distance in miles for long distance trips */
  long_distance_mileage_start?: number | null;
  /** Number of free loaded miles */
  free_loaded_miles?: number | null;
  /** Rate in cents per unloaded mile */
  unloaded_mileage_rate_cents?: number | null;
  /** Number of free unloaded miles */
  free_unloaded_miles?: number | null;
  /** Rate in cents per unloaded return mile */
  unloaded_return_mileage_rate_cents?: number | null;
  /** Number of free unloaded return miles */
  free_unloaded_return_miles?: number | null;
  /** Rate in cents per wait time period */
  wait_time_rate_cents?: number | null;
  /** Wait time period in minutes */
  wait_time_period_minutes?: number | null;
  /** Number of free wait time minutes */
  wait_time_free_minutes?: number | null;
  /** Fee in cents for late cancellations */
  late_cancellation_fee_cents?: number | null;
  /** Minutes before scheduled pickup time for late cancellations */
  late_cancellation_period_minutes?: number | null;
  /** Fee in cents for no shows */
  no_show_fee_cents?: number | null;
  /** Fee in cents for stairs */
  stair_fee_cents?: number | null;
  /** Minimum number of steps for the stair fee to be applied */
  minimum_steps?: number | null;
  /** Type of stair fee, flat fee or per step fee */
  stair_fee_type?: StairFeeTypeEnum | BlankEnum;
  /** Fee in cents for each additional attendant */
  additional_attendant_rate_cents?: number | null;
  /** Fee in cents for each additional passenger */
  additional_passenger_rate_cents?: number | null;
  /** Fee in cents for bariatric passengers */
  bariatric_passenger_fee_cents?: number | null;
  /** Fee in cents for wheelchair rentals */
  wheelchair_rental_fee_cents?: number | null;
  /** Fee in cents for oxygen */
  oxygen_fee_cents?: number | null;
  /** Fee in cents for weekend trips */
  weekend_fee_cents?: number | null;
  /** Fee in cents for after hours trips */
  after_hours_fee_cents?: number | null;
  /** Time before which trips are considered after hours */
  business_hours_start_time?: string | null;
  /** Time after which trips are considered after hours */
  business_hours_end_time?: string | null;
  /** Fee in cents for holiday trips */
  holiday_fee_cents?: number | null;
  /** Holidays that this pricing scheme applies to */
  observed_holidays?: ObservedHolidaysEnum[] | null;
  /** Minimum price in cents for this pricing scheme */
  minimum_price_cents?: number | null;
  /** Type of cancellation fee, flat fee or as a percentage of the trip cost */
  late_cancellation_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  /** Type of no show fee, flat fee or as a percentage of the trip cost */
  no_show_fee_type?: NoShowFeeTypeEnum | BlankEnum;
  payer_ids?: string[];
  /** Fee in cents for passenger with infectious disease */
  infectious_disease_fee_cents?: number | null;
  /** Fee in cents for for same day booking */
  same_day_booking_fee_cents?: number | null;
  /** Fee in cents for car seat */
  car_seat_fee_cents?: number | null;
  /** Fee in cents for booster seat */
  booster_seat_fee_cents?: number | null;
  /** Fee in cents for ride alone */
  ride_alone_fee_cents?: number | null;
  mileage_range_hundredths_lower?: number | null;
  mileage_range_hundredths_upper?: number | null;
};
export type PricingPricingSchemesDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type UserProfileDriver = {
  id?: string;
  can_be_scheduled?: boolean;
};
export type UserProfileAttendant = {
  id?: string;
  can_be_scheduled?: boolean;
};
export type UserProfileMembership = {
  id?: string;
  role?: RoleEnum;
  driver?: UserProfileDriver;
  attendant?: UserProfileAttendant;
  deleted_at?: string | null;
};
export type UserProfileOrganization = {
  name: string;
  id?: string;
  dispatch_phone_number?: string | null;
  dispatch_text_number?: string | null;
  /** The chat application id for this org. Probably Sendbird */
  chat_application_id?: string | null;
};
export type UserProfileOrganizationRead = {
  name: string;
  id?: string;
  dispatch_phone_number?: string | null;
  dispatch_text_number?: string | null;
  settings: OrganizationSettingsRead;
  /** The chat application id for this org. Probably Sendbird */
  chat_application_id?: string | null;
};
export type UserProfileMembershipRead = {
  id?: string;
  organization: UserProfileOrganizationRead;
  created_at: string;
  role?: RoleEnum;
  driver?: UserProfileDriver;
  attendant?: UserProfileAttendant;
  deleted_at?: string | null;
};
export type UserProfile = {
  first_name?: string;
  last_name?: string;
  email: string;
  /** Contact phone number */
  phone_number?: string | null;
  date_joined?: string;
  memberships: UserProfileMembership[];
};
export type UserProfileRead = {
  id: number;
  first_name?: string;
  last_name?: string;
  email: string;
  /** Contact phone number */
  phone_number?: string | null;
  date_joined?: string;
  memberships: UserProfileMembershipRead[];
};
export type ProfileRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type CustomReportTypeEnum = 'all_trip_details';
export type CustomReport = {
  name: string;
  description?: string;
  type?: CustomReportTypeEnum;
  fields: string;
};
export type CustomReportRead = {
  id: string;
  name: string;
  description?: string;
  type?: CustomReportTypeEnum;
  fields: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedCustomReportList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: CustomReport[];
};
export type PaginatedCustomReportListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: CustomReportRead[];
};
export type ReportsCustomReportsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type ReportsCustomReportsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type ReportsCustomReportsCreateNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type ReportsCustomReportsCreateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type ReportsCustomReportsCreateTypeErrorComponent = {
  attr: 'type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type ReportsCustomReportsCreateFieldsErrorComponent = {
  attr: 'fields';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type ReportsCustomReportsCreateError =
  | ({
      attr: 'non_field_errors';
    } & ReportsCustomReportsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & ReportsCustomReportsCreateNameErrorComponent)
  | ({
      attr: 'description';
    } & ReportsCustomReportsCreateDescriptionErrorComponent)
  | ({
      attr: 'type';
    } & ReportsCustomReportsCreateTypeErrorComponent)
  | ({
      attr: 'fields';
    } & ReportsCustomReportsCreateFieldsErrorComponent);
export type ReportsCustomReportsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ReportsCustomReportsCreateError[];
};
export type ReportsCustomReportsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & ReportsCustomReportsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type ReportsCustomReportsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type ReportsCustomReportsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type ReportsCustomReportsPartialUpdateNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type ReportsCustomReportsPartialUpdateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type ReportsCustomReportsPartialUpdateTypeErrorComponent = {
  attr: 'type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type ReportsCustomReportsPartialUpdateFieldsErrorComponent = {
  attr: 'fields';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type ReportsCustomReportsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & ReportsCustomReportsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & ReportsCustomReportsPartialUpdateNameErrorComponent)
  | ({
      attr: 'description';
    } & ReportsCustomReportsPartialUpdateDescriptionErrorComponent)
  | ({
      attr: 'type';
    } & ReportsCustomReportsPartialUpdateTypeErrorComponent)
  | ({
      attr: 'fields';
    } & ReportsCustomReportsPartialUpdateFieldsErrorComponent);
export type ReportsCustomReportsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: ReportsCustomReportsPartialUpdateError[];
};
export type ReportsCustomReportsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & ReportsCustomReportsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedCustomReport = {
  name?: string;
  description?: string;
  type?: CustomReportTypeEnum;
  fields?: string;
};
export type PatchedCustomReportRead = {
  id?: string;
  name?: string;
  description?: string;
  type?: CustomReportTypeEnum;
  fields?: string;
  created_at?: string;
  updated_at?: string;
};
export type ReportsCustomReportsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripLoadedMileageResults = {};
export type TripLoadedMileageResultsRead = {
  estimated_distance_miles: number;
  payer_id: string;
  driver_id: string;
  attendant_id: string;
};
export type ReportsTripsLoadedMileageCountCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type ReportsTripsLoadedMileageCountCreateRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type ReportsTripsLoadedMileageCountCreateRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type ReportsTripsLoadedMileageCountCreatePayerIdInErrorComponent = {
  attr: 'payer_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsLoadedMileageCountCreatePayerIdInIndexErrorComponent = {
  attr: 'payer_id__in.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type ReportsTripsLoadedMileageCountCreatePayerBucketErrorComponent = {
  attr: 'payer_bucket';
  code: 'invalid' | 'null';
  detail: string;
};
export type ReportsTripsLoadedMileageCountCreateDriverIdInErrorComponent = {
  attr: 'driver_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsLoadedMileageCountCreateDriverIdInIndexErrorComponent =
  {
    attr: 'driver_id__in.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type ReportsTripsLoadedMileageCountCreateDriverBucketErrorComponent = {
  attr: 'driver_bucket';
  code: 'invalid' | 'null';
  detail: string;
};
export type ReportsTripsLoadedMileageCountCreateAttendantIdInErrorComponent = {
  attr: 'attendant_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsLoadedMileageCountCreateAttendantIdInIndexErrorComponent =
  {
    attr: 'attendant_id__in.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type ReportsTripsLoadedMileageCountCreateAttendantBucketErrorComponent =
  {
    attr: 'attendant_bucket';
    code: 'invalid' | 'null';
    detail: string;
  };
export type ReportsTripsLoadedMileageCountCreateError =
  | ({
      attr: 'non_field_errors';
    } & ReportsTripsLoadedMileageCountCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'range_start';
    } & ReportsTripsLoadedMileageCountCreateRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & ReportsTripsLoadedMileageCountCreateRangeEndErrorComponent)
  | ({
      attr: 'payer_id__in';
    } & ReportsTripsLoadedMileageCountCreatePayerIdInErrorComponent)
  | ({
      attr: 'payer_id__in.INDEX';
    } & ReportsTripsLoadedMileageCountCreatePayerIdInIndexErrorComponent)
  | ({
      attr: 'payer_bucket';
    } & ReportsTripsLoadedMileageCountCreatePayerBucketErrorComponent)
  | ({
      attr: 'driver_id__in';
    } & ReportsTripsLoadedMileageCountCreateDriverIdInErrorComponent)
  | ({
      attr: 'driver_id__in.INDEX';
    } & ReportsTripsLoadedMileageCountCreateDriverIdInIndexErrorComponent)
  | ({
      attr: 'driver_bucket';
    } & ReportsTripsLoadedMileageCountCreateDriverBucketErrorComponent)
  | ({
      attr: 'attendant_id__in';
    } & ReportsTripsLoadedMileageCountCreateAttendantIdInErrorComponent)
  | ({
      attr: 'attendant_id__in.INDEX';
    } & ReportsTripsLoadedMileageCountCreateAttendantIdInIndexErrorComponent)
  | ({
      attr: 'attendant_bucket';
    } & ReportsTripsLoadedMileageCountCreateAttendantBucketErrorComponent);
export type ReportsTripsLoadedMileageCountCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ReportsTripsLoadedMileageCountCreateError[];
};
export type ReportsTripsLoadedMileageCountCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & ReportsTripsLoadedMileageCountCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripLoadedMileageRequest = {
  range_start?: string;
  range_end?: string;
  payer_id__in?: string[];
  payer_bucket?: boolean;
  driver_id__in?: string[];
  driver_bucket?: boolean;
  attendant_id__in?: string[];
  attendant_bucket?: boolean;
};
export type TripOnTimeResults = {};
export type TripOnTimeResultsRead = {
  total_count: number;
  on_time_count: number;
  late_count: number;
  payer_id: string;
  driver_id: string;
  attendant_id: string;
};
export type ReportsTripsOnTimeCountCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type ReportsTripsOnTimeCountCreateRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type ReportsTripsOnTimeCountCreateRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type ReportsTripsOnTimeCountCreatePayerIdInErrorComponent = {
  attr: 'payer_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsOnTimeCountCreatePayerIdInIndexErrorComponent = {
  attr: 'payer_id__in.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type ReportsTripsOnTimeCountCreatePayerBucketErrorComponent = {
  attr: 'payer_bucket';
  code: 'invalid' | 'null';
  detail: string;
};
export type ReportsTripsOnTimeCountCreateDriverIdInErrorComponent = {
  attr: 'driver_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsOnTimeCountCreateDriverIdInIndexErrorComponent = {
  attr: 'driver_id__in.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type ReportsTripsOnTimeCountCreateDriverBucketErrorComponent = {
  attr: 'driver_bucket';
  code: 'invalid' | 'null';
  detail: string;
};
export type ReportsTripsOnTimeCountCreateAttendantIdInErrorComponent = {
  attr: 'attendant_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsOnTimeCountCreateAttendantIdInIndexErrorComponent = {
  attr: 'attendant_id__in.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type ReportsTripsOnTimeCountCreateError =
  | ({
      attr: 'non_field_errors';
    } & ReportsTripsOnTimeCountCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'range_start';
    } & ReportsTripsOnTimeCountCreateRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & ReportsTripsOnTimeCountCreateRangeEndErrorComponent)
  | ({
      attr: 'payer_id__in';
    } & ReportsTripsOnTimeCountCreatePayerIdInErrorComponent)
  | ({
      attr: 'payer_id__in.INDEX';
    } & ReportsTripsOnTimeCountCreatePayerIdInIndexErrorComponent)
  | ({
      attr: 'payer_bucket';
    } & ReportsTripsOnTimeCountCreatePayerBucketErrorComponent)
  | ({
      attr: 'driver_id__in';
    } & ReportsTripsOnTimeCountCreateDriverIdInErrorComponent)
  | ({
      attr: 'driver_id__in.INDEX';
    } & ReportsTripsOnTimeCountCreateDriverIdInIndexErrorComponent)
  | ({
      attr: 'driver_bucket';
    } & ReportsTripsOnTimeCountCreateDriverBucketErrorComponent)
  | ({
      attr: 'attendant_id__in';
    } & ReportsTripsOnTimeCountCreateAttendantIdInErrorComponent)
  | ({
      attr: 'attendant_id__in.INDEX';
    } & ReportsTripsOnTimeCountCreateAttendantIdInIndexErrorComponent);
export type ReportsTripsOnTimeCountCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ReportsTripsOnTimeCountCreateError[];
};
export type ReportsTripsOnTimeCountCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & ReportsTripsOnTimeCountCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripOnTimeRequest = {
  range_start?: string;
  range_end?: string;
  payer_id__in?: string[];
  payer_bucket?: boolean;
  driver_id__in?: string[];
  driver_bucket?: boolean;
  attendant_id__in?: string[];
};
export type TripRevenueResults = {};
export type TripRevenueResultsRead = {
  revenue_cents: number;
  payer_id: string;
  driver_id: string;
  attendant_id: string;
};
export type ReportsTripsRevenueCountCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type ReportsTripsRevenueCountCreateRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type ReportsTripsRevenueCountCreateRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type ReportsTripsRevenueCountCreatePayerIdInErrorComponent = {
  attr: 'payer_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsRevenueCountCreatePayerIdInIndexErrorComponent = {
  attr: 'payer_id__in.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type ReportsTripsRevenueCountCreatePayerBucketErrorComponent = {
  attr: 'payer_bucket';
  code: 'invalid' | 'null';
  detail: string;
};
export type ReportsTripsRevenueCountCreateDriverIdInErrorComponent = {
  attr: 'driver_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsRevenueCountCreateDriverIdInIndexErrorComponent = {
  attr: 'driver_id__in.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type ReportsTripsRevenueCountCreateDriverBucketErrorComponent = {
  attr: 'driver_bucket';
  code: 'invalid' | 'null';
  detail: string;
};
export type ReportsTripsRevenueCountCreateAttendantIdInErrorComponent = {
  attr: 'attendant_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsRevenueCountCreateAttendantIdInIndexErrorComponent = {
  attr: 'attendant_id__in.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type ReportsTripsRevenueCountCreateAttendantBucketErrorComponent = {
  attr: 'attendant_bucket';
  code: 'invalid' | 'null';
  detail: string;
};
export type ReportsTripsRevenueCountCreateError =
  | ({
      attr: 'non_field_errors';
    } & ReportsTripsRevenueCountCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'range_start';
    } & ReportsTripsRevenueCountCreateRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & ReportsTripsRevenueCountCreateRangeEndErrorComponent)
  | ({
      attr: 'payer_id__in';
    } & ReportsTripsRevenueCountCreatePayerIdInErrorComponent)
  | ({
      attr: 'payer_id__in.INDEX';
    } & ReportsTripsRevenueCountCreatePayerIdInIndexErrorComponent)
  | ({
      attr: 'payer_bucket';
    } & ReportsTripsRevenueCountCreatePayerBucketErrorComponent)
  | ({
      attr: 'driver_id__in';
    } & ReportsTripsRevenueCountCreateDriverIdInErrorComponent)
  | ({
      attr: 'driver_id__in.INDEX';
    } & ReportsTripsRevenueCountCreateDriverIdInIndexErrorComponent)
  | ({
      attr: 'driver_bucket';
    } & ReportsTripsRevenueCountCreateDriverBucketErrorComponent)
  | ({
      attr: 'attendant_id__in';
    } & ReportsTripsRevenueCountCreateAttendantIdInErrorComponent)
  | ({
      attr: 'attendant_id__in.INDEX';
    } & ReportsTripsRevenueCountCreateAttendantIdInIndexErrorComponent)
  | ({
      attr: 'attendant_bucket';
    } & ReportsTripsRevenueCountCreateAttendantBucketErrorComponent);
export type ReportsTripsRevenueCountCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ReportsTripsRevenueCountCreateError[];
};
export type ReportsTripsRevenueCountCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & ReportsTripsRevenueCountCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripRevenueRequest = {
  range_start?: string;
  range_end?: string;
  payer_id__in?: string[];
  payer_bucket?: boolean;
  driver_id__in?: string[];
  driver_bucket?: boolean;
  attendant_id__in?: string[];
  attendant_bucket?: boolean;
};
export type TripStatusCountResults = {};
export type TimeBucketEnum = 'day' | 'week' | 'month' | 'year' | 'total';
export type TripStatusCountResultsRead = {
  status: OverrideStatusEnum;
  count: number;
  time_bucket: TimeBucketEnum;
  payer_id: string;
  driver_id: string;
  attendant_id: string;
};
export type ReportsTripsStatusCountCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type ReportsTripsStatusCountCreateRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type ReportsTripsStatusCountCreateRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow';
  detail: string;
};
export type ReportsTripsStatusCountCreateTimeBucketErrorComponent = {
  attr: 'time_bucket';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type ReportsTripsStatusCountCreatePayerIdInErrorComponent = {
  attr: 'payer_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsStatusCountCreatePayerIdInIndexErrorComponent = {
  attr: 'payer_id__in.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type ReportsTripsStatusCountCreatePayerBucketErrorComponent = {
  attr: 'payer_bucket';
  code: 'invalid' | 'null';
  detail: string;
};
export type ReportsTripsStatusCountCreateDriverIdInErrorComponent = {
  attr: 'driver_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsStatusCountCreateDriverIdInIndexErrorComponent = {
  attr: 'driver_id__in.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type ReportsTripsStatusCountCreateDriverBucketErrorComponent = {
  attr: 'driver_bucket';
  code: 'invalid' | 'null';
  detail: string;
};
export type ReportsTripsStatusCountCreateAttendantIdInErrorComponent = {
  attr: 'attendant_id__in';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type ReportsTripsStatusCountCreateAttendantIdInIndexErrorComponent = {
  attr: 'attendant_id__in.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type ReportsTripsStatusCountCreateAttendantBucketErrorComponent = {
  attr: 'attendant_bucket';
  code: 'invalid' | 'null';
  detail: string;
};
export type ReportsTripsStatusCountCreateError =
  | ({
      attr: 'non_field_errors';
    } & ReportsTripsStatusCountCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'range_start';
    } & ReportsTripsStatusCountCreateRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & ReportsTripsStatusCountCreateRangeEndErrorComponent)
  | ({
      attr: 'time_bucket';
    } & ReportsTripsStatusCountCreateTimeBucketErrorComponent)
  | ({
      attr: 'payer_id__in';
    } & ReportsTripsStatusCountCreatePayerIdInErrorComponent)
  | ({
      attr: 'payer_id__in.INDEX';
    } & ReportsTripsStatusCountCreatePayerIdInIndexErrorComponent)
  | ({
      attr: 'payer_bucket';
    } & ReportsTripsStatusCountCreatePayerBucketErrorComponent)
  | ({
      attr: 'driver_id__in';
    } & ReportsTripsStatusCountCreateDriverIdInErrorComponent)
  | ({
      attr: 'driver_id__in.INDEX';
    } & ReportsTripsStatusCountCreateDriverIdInIndexErrorComponent)
  | ({
      attr: 'driver_bucket';
    } & ReportsTripsStatusCountCreateDriverBucketErrorComponent)
  | ({
      attr: 'attendant_id__in';
    } & ReportsTripsStatusCountCreateAttendantIdInErrorComponent)
  | ({
      attr: 'attendant_id__in.INDEX';
    } & ReportsTripsStatusCountCreateAttendantIdInIndexErrorComponent)
  | ({
      attr: 'attendant_bucket';
    } & ReportsTripsStatusCountCreateAttendantBucketErrorComponent);
export type ReportsTripsStatusCountCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ReportsTripsStatusCountCreateError[];
};
export type ReportsTripsStatusCountCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & ReportsTripsStatusCountCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripStatusCountRequest = {
  range_start?: string;
  range_end?: string;
  time_bucket?: TimeBucketEnum;
  payer_id__in?: string[];
  payer_bucket?: boolean;
  driver_id__in?: string[];
  driver_bucket?: boolean;
  attendant_id__in?: string[];
  attendant_bucket?: boolean;
};
export type RunBambiRun = {};
export type RunBambiRunRead = {
  id: string;
};
export type ModeEnum = 'optimal' | 'non-optimal';
export type RunBambiRunWrite = {
  range_start: string;
  range_end: string;
  trips: string[];
  assignments: string[];
  should_multiload?: boolean | null;
  mode?: ModeEnum;
};
export type RunBambiRunCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type RunBambiRunCreateRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type RunBambiRunCreateRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type RunBambiRunCreateTripsErrorComponent = {
  attr: 'trips';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type RunBambiRunCreateTripsIndexErrorComponent = {
  attr: 'trips.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RunBambiRunCreateAssignmentsErrorComponent = {
  attr: 'assignments';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type RunBambiRunCreateAssignmentsIndexErrorComponent = {
  attr: 'assignments.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RunBambiRunCreateShouldMultiloadErrorComponent = {
  attr: 'should_multiload';
  code: 'invalid';
  detail: string;
};
export type RunBambiRunCreateModeErrorComponent = {
  attr: 'mode';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type RunBambiRunCreateError =
  | ({
      attr: 'non_field_errors';
    } & RunBambiRunCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'range_start';
    } & RunBambiRunCreateRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & RunBambiRunCreateRangeEndErrorComponent)
  | ({
      attr: 'trips';
    } & RunBambiRunCreateTripsErrorComponent)
  | ({
      attr: 'trips.INDEX';
    } & RunBambiRunCreateTripsIndexErrorComponent)
  | ({
      attr: 'assignments';
    } & RunBambiRunCreateAssignmentsErrorComponent)
  | ({
      attr: 'assignments.INDEX';
    } & RunBambiRunCreateAssignmentsIndexErrorComponent)
  | ({
      attr: 'should_multiload';
    } & RunBambiRunCreateShouldMultiloadErrorComponent)
  | ({
      attr: 'mode';
    } & RunBambiRunCreateModeErrorComponent);
export type RunBambiRunCreateValidationError = {
  type: ValidationErrorEnum;
  errors: RunBambiRunCreateError[];
};
export type RunBambiRunCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RunBambiRunCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type RunBambiRunTask = {};
export type StateEnum =
  | 'PENDING'
  | 'RECEIVED'
  | 'STARTED'
  | 'SUCCESS'
  | 'FAILURE'
  | 'REVOKED'
  | 'REJECTED'
  | 'RETRY'
  | 'IGNORED';
export type RunBambiRunResult = {};
export type RunBambiRunAssignment = {};
export type RunBambiRunAssignedVehicle = {};
export type RunBambiRunAssignedVehicleRead = {
  id: string;
  nickname: string;
  category: string;
};
export type RunBambiRunAssignedDriver = {};
export type RunBambiRunAssignedDriverRead = {
  id: string;
  first_name: string;
  last_name: string;
};
export type RunBambiRunAssignmentRead = {
  id: string;
  start: string;
  end: string;
  vehicle: RunBambiRunAssignedVehicleRead;
  driver: RunBambiRunAssignedDriverRead;
};
export type RunBambiRunTrip = {};
export type RunBambiRunTripPassenger = {};
export type RunBambiRunTripPassengerRead = {
  full_name: string;
  id: string;
};
export type RunBambiRunTripRead = {
  id: string;
  pickup_address: string;
  pickup_latitude: number;
  pickup_longitude: number;
  dropoff_address: string;
  dropoff_latitude: number;
  dropoff_longitude: number;
  passenger: RunBambiRunTripPassengerRead;
  assignment: RunBambiRunAssignmentRead;
  scheduled_pickup_at: string;
  scheduled_dropoff_at: string;
  suggested_pickup_time: string;
  appointment_at: string;
  status: OverrideStatusEnum;
  space_type: SpaceTypeEnum;
  service_type: ServiceTypeEnum;
  estimated_duration_sec: number;
  is_locked: boolean;
  is_non_activated_will_call: boolean;
  wait_time_start: string | null;
  wait_time_end: string | null;
  correlation_id: string;
  multiload_id: string | null;
  should_avoid_multiload: boolean;
  arrival_time: string | null;
  completion_time: string | null;
  travel_time_minutes: number | null;
};
export type RunBambiRunReassignedTrip = {};
export type RunBambiRunReassignedTripRead = {
  id: string;
  pickup_address: string;
  pickup_latitude: number;
  pickup_longitude: number;
  dropoff_address: string;
  dropoff_latitude: number;
  dropoff_longitude: number;
  passenger: RunBambiRunTripPassengerRead;
  assignment: RunBambiRunAssignmentRead;
  scheduled_pickup_at: string;
  scheduled_dropoff_at: string;
  suggested_pickup_time: string;
  appointment_at: string;
  status: OverrideStatusEnum;
  space_type: SpaceTypeEnum;
  service_type: ServiceTypeEnum;
  estimated_duration_sec: number;
  is_locked: boolean;
  is_non_activated_will_call: boolean;
  wait_time_start: string | null;
  wait_time_end: string | null;
  correlation_id: string;
  multiload_id: string | null;
  should_avoid_multiload: boolean;
  arrival_time: string | null;
  completion_time: string | null;
  travel_time_minutes: number | null;
  old_assignment: RunBambiRunAssignmentRead;
  new_scheduled_pickup_at: string;
  new_scheduled_dropoff_at: string;
};
export type RunBambiRunResultRead = {
  assignments: RunBambiRunAssignmentRead[];
  new_trip_assignments: RunBambiRunTripRead[];
  trip_reassignments: RunBambiRunReassignedTripRead[];
  trips_not_assigned: RunBambiRunTripRead[];
  existing_trip_assignments: RunBambiRunTripRead[];
};
export type RunBambiRunTaskRead = {
  id: string;
  state: StateEnum;
  result: RunBambiRunResultRead;
  message: string;
};
export type RunBambiRunRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type RunBambiRunApply = {};
export type RunBambiRunApplyWrite = {
  excluded_trips: string[];
};
export type RunBambiRunApplyCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type RunBambiRunApplyCreateExcludedTripsErrorComponent = {
  attr: 'excluded_trips';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type RunBambiRunApplyCreateExcludedTripsIndexErrorComponent = {
  attr: 'excluded_trips.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type RunBambiRunApplyCreateError =
  | ({
      attr: 'non_field_errors';
    } & RunBambiRunApplyCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'excluded_trips';
    } & RunBambiRunApplyCreateExcludedTripsErrorComponent)
  | ({
      attr: 'excluded_trips.INDEX';
    } & RunBambiRunApplyCreateExcludedTripsIndexErrorComponent);
export type RunBambiRunApplyCreateValidationError = {
  type: ValidationErrorEnum;
  errors: RunBambiRunApplyCreateError[];
};
export type RunBambiRunApplyCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & RunBambiRunApplyCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type SignatureTypeEnum =
  | 'membership'
  | 'passenger'
  | 'guardian'
  | 'facility'
  | 'unable';
export type ContentTypeEnum = 'vehicleinspectionreport' | 'triplocationdetail';
export type SignedItem = {
  content_type: ContentTypeEnum;
  object_id: string;
};
export type Signature = {
  image: string;
  /** type of signature */
  signature_type?: SignatureTypeEnum | BlankEnum;
  signed_items: SignedItem[];
};
export type SignatureRead = {
  id: string;
  organization_id: string;
  membership: string;
  first_name: string;
  last_name: string;
  longitude: number;
  latitude: number;
  location_queried_at: string | null;
  device_requested_at: string | null;
  image: string;
  /** type of signature */
  signature_type?: SignatureTypeEnum | BlankEnum;
  signed_items: SignedItem[];
  created_at: string;
  updated_at: string;
};
export type PaginatedSignatureList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Signature[];
};
export type PaginatedSignatureListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: SignatureRead[];
};
export type SignaturesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type SignaturesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type SignaturesCreateImageErrorComponent = {
  attr: 'image';
  code:
    | 'empty'
    | 'invalid'
    | 'invalid_image'
    | 'max_length'
    | 'no_name'
    | 'null'
    | 'required';
  detail: string;
};
export type SignaturesCreateSignatureTypeErrorComponent = {
  attr: 'signature_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type SignaturesCreateSignedItemsNonFieldErrorsErrorComponent = {
  attr: 'signed_items.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type SignaturesCreateSignedItemsIndexNonFieldErrorsErrorComponent = {
  attr: 'signed_items.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type SignaturesCreateSignedItemsIndexContentTypeErrorComponent = {
  attr: 'signed_items.INDEX.content_type';
  code: 'does_not_exist' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type SignaturesCreateSignedItemsIndexObjectIdErrorComponent = {
  attr: 'signed_items.INDEX.object_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type SignaturesCreateError =
  | ({
      attr: 'non_field_errors';
    } & SignaturesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'image';
    } & SignaturesCreateImageErrorComponent)
  | ({
      attr: 'signature_type';
    } & SignaturesCreateSignatureTypeErrorComponent)
  | ({
      attr: 'signed_items.non_field_errors';
    } & SignaturesCreateSignedItemsNonFieldErrorsErrorComponent)
  | ({
      attr: 'signed_items.INDEX.non_field_errors';
    } & SignaturesCreateSignedItemsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'signed_items.INDEX.content_type';
    } & SignaturesCreateSignedItemsIndexContentTypeErrorComponent)
  | ({
      attr: 'signed_items.INDEX.object_id';
    } & SignaturesCreateSignedItemsIndexObjectIdErrorComponent);
export type SignaturesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: SignaturesCreateError[];
};
export type SignaturesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & SignaturesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type SignaturesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type SignaturesDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type Tag = {
  tag_name: string;
  color_hex?: string;
  /** Optional description of the tag */
  description?: string;
};
export type InternalUseEnum =
  | 'address interpolation warning'
  | 'multistop trip'
  | 'pricing confirmed'
  | 'billing complete'
  | 'pickup address interpolation warning'
  | 'dropoff address interpolation warning'
  | 'source, pickup, dropoff timezone mismatch'
  | 'no pickup time provided';
export type TagRead = {
  id: string;
  tag_name: string;
  color_hex?: string;
  internal_use: (InternalUseEnum | BlankEnum | NullEnum) | null;
  /** Optional description of the tag */
  description?: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedTagList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Tag[];
};
export type PaginatedTagListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TagRead[];
};
export type TagsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TagsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TagsCreateTagNameErrorComponent = {
  attr: 'tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TagsCreateColorHexErrorComponent = {
  attr: 'color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TagsCreateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TagsCreateError =
  | ({
      attr: 'non_field_errors';
    } & TagsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'tag_name';
    } & TagsCreateTagNameErrorComponent)
  | ({
      attr: 'color_hex';
    } & TagsCreateColorHexErrorComponent)
  | ({
      attr: 'description';
    } & TagsCreateDescriptionErrorComponent);
export type TagsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TagsCreateError[];
};
export type TagsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TagsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TagsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TagsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TagsPartialUpdateTagNameErrorComponent = {
  attr: 'tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TagsPartialUpdateColorHexErrorComponent = {
  attr: 'color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TagsPartialUpdateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TagsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TagsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'tag_name';
    } & TagsPartialUpdateTagNameErrorComponent)
  | ({
      attr: 'color_hex';
    } & TagsPartialUpdateColorHexErrorComponent)
  | ({
      attr: 'description';
    } & TagsPartialUpdateDescriptionErrorComponent);
export type TagsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TagsPartialUpdateError[];
};
export type TagsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TagsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTag = {
  tag_name?: string;
  color_hex?: string;
  /** Optional description of the tag */
  description?: string;
};
export type PatchedTagRead = {
  id?: string;
  tag_name?: string;
  color_hex?: string;
  internal_use?: (InternalUseEnum | BlankEnum | NullEnum) | null;
  /** Optional description of the tag */
  description?: string;
  created_at?: string;
  updated_at?: string;
};
export type TagsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type BambiPayerTypeEnum = 'passenger' | 'payer_organization';
export type TilledCustomerMetaData = {
  bambi_payer_id: string;
  bambi_payer_type: BambiPayerTypeEnum;
};
export type TilledPaymentMethodBillingDetailsAddress = {
  city?: string | null;
  country?: string | null;
  street?: string | null;
  street2?: string | null;
  zip: string;
  state?: string | null;
};
export type TilledBillingDetails = {
  address?: TilledPaymentMethodBillingDetailsAddress;
  email?: string;
  name: string;
  phone?: string;
};
export type TilledCard = {
  brand: string;
  exp_month: number;
  exp_year: number;
  holder_name: string;
  last4: string;
};
export type TilledPaymentMethodResponse = {
  id: string;
  metadata: TilledCustomerMetaData | null;
  billing_details?: TilledBillingDetails | null;
  card: TilledCard;
  chargeable: boolean;
  created_at: string;
  customer_id: string;
  expires_at: string | null;
};
export type TilledListPaymentMethodsTilledResponse = {
  has_more: boolean;
  limit: number;
  offset: number;
  total: number;
  items: TilledPaymentMethodResponse[];
};
export type TilledPaymentMethodRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TilledCustomer = {
  tilled_customer_id: string;
};
export type TilledPaymentMethodCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TilledPaymentMethodCreatePayerIdErrorComponent = {
  attr: 'payer_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TilledPaymentMethodCreatePayerTypeErrorComponent = {
  attr: 'payer_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TilledPaymentMethodCreatePaymentMethodIdErrorComponent = {
  attr: 'payment_method_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledPaymentMethodCreatePaymentAccountIdErrorComponent = {
  attr: 'payment_account_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledPaymentMethodCreateOrganizationIdErrorComponent = {
  attr: 'organization_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TilledPaymentMethodCreateError =
  | ({
      attr: 'non_field_errors';
    } & TilledPaymentMethodCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_id';
    } & TilledPaymentMethodCreatePayerIdErrorComponent)
  | ({
      attr: 'payer_type';
    } & TilledPaymentMethodCreatePayerTypeErrorComponent)
  | ({
      attr: 'payment_method_id';
    } & TilledPaymentMethodCreatePaymentMethodIdErrorComponent)
  | ({
      attr: 'payment_account_id';
    } & TilledPaymentMethodCreatePaymentAccountIdErrorComponent)
  | ({
      attr: 'organization_id';
    } & TilledPaymentMethodCreateOrganizationIdErrorComponent);
export type TilledPaymentMethodCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TilledPaymentMethodCreateError[];
};
export type TilledPaymentMethodCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TilledPaymentMethodCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TilledPaymentMethodInput = {
  payer_id: string;
  payer_type: BambiPayerTypeEnum;
  payment_method_id: string;
};
export type TilledPaymentMethodDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TilledPaymentMethodPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TilledPaymentMethodPartialUpdateAddressNonFieldErrorsErrorComponent =
  {
    attr: 'address.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TilledPaymentMethodPartialUpdateAddressCityErrorComponent = {
  attr: 'address.city';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledPaymentMethodPartialUpdateAddressCountryErrorComponent = {
  attr: 'address.country';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledPaymentMethodPartialUpdateAddressStreetErrorComponent = {
  attr: 'address.street';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledPaymentMethodPartialUpdateAddressStreet2ErrorComponent = {
  attr: 'address.street2';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledPaymentMethodPartialUpdateAddressZipErrorComponent = {
  attr: 'address.zip';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledPaymentMethodPartialUpdateAddressStateErrorComponent = {
  attr: 'address.state';
  code:
    | 'invalid'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledPaymentMethodPartialUpdateNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledPaymentMethodPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TilledPaymentMethodPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'address.non_field_errors';
    } & TilledPaymentMethodPartialUpdateAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'address.city';
    } & TilledPaymentMethodPartialUpdateAddressCityErrorComponent)
  | ({
      attr: 'address.country';
    } & TilledPaymentMethodPartialUpdateAddressCountryErrorComponent)
  | ({
      attr: 'address.street';
    } & TilledPaymentMethodPartialUpdateAddressStreetErrorComponent)
  | ({
      attr: 'address.street2';
    } & TilledPaymentMethodPartialUpdateAddressStreet2ErrorComponent)
  | ({
      attr: 'address.zip';
    } & TilledPaymentMethodPartialUpdateAddressZipErrorComponent)
  | ({
      attr: 'address.state';
    } & TilledPaymentMethodPartialUpdateAddressStateErrorComponent)
  | ({
      attr: 'name';
    } & TilledPaymentMethodPartialUpdateNameErrorComponent);
export type TilledPaymentMethodPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TilledPaymentMethodPartialUpdateError[];
};
export type TilledPaymentMethodPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TilledPaymentMethodPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTilledPaymentMethodBillingDetails = {
  address?: TilledPaymentMethodBillingDetailsAddress;
  name?: string;
};
export type TilledPaymentMethodVerifyResponse = {};
export type TilledPaymentMethodVerifyResponseStatusEnum =
  | 'pending'
  | 'succeeded'
  | 'failed';
export type TilledPaymentMethodVerifyResponseRead = {
  id: string;
  amount_cents: number;
  status: TilledPaymentMethodVerifyResponseStatusEnum;
  failure_message: string;
  next_steps: string;
  created_at: string;
  updated_at: string;
};
export type TilledPaymentMethodVerifyRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TilledPaymentMethodVerifyRequest = {
  fuzz_amount: number;
};
export type TilledPaymentMethodVerifyCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TilledPaymentMethodVerifyCreateFuzzAmountErrorComponent = {
  attr: 'fuzz_amount';
  code: 'invalid' | 'max_string_length' | 'null' | 'required';
  detail: string;
};
export type TilledPaymentMethodVerifyCreateError =
  | ({
      attr: 'non_field_errors';
    } & TilledPaymentMethodVerifyCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'fuzz_amount';
    } & TilledPaymentMethodVerifyCreateFuzzAmountErrorComponent);
export type TilledPaymentMethodVerifyCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TilledPaymentMethodVerifyCreateError[];
};
export type TilledPaymentMethodVerifyCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TilledPaymentMethodVerifyCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TilledPayoutReadOnly = {};
export type TilledPayoutReadOnlyStatusEnum =
  | 'canceled'
  | 'failed'
  | 'in_transit'
  | 'paid'
  | 'pending';
export type TilledPayoutInvoice = {};
export type TilledPayoutInvoiceRead = {
  id: string;
  number: string;
  date_issued: string;
};
export type TilledPayoutReadOnlyRead = {
  id: string;
  payout_id: string;
  amount: number;
  currency: string;
  paid_at: string | null;
  status: TilledPayoutReadOnlyStatusEnum;
  description: string;
  failure_code: string;
  created_at: string;
  updated_at: string;
  invoices: TilledPayoutInvoiceRead[];
};
export type PaginatedTilledPayoutReadOnlyList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TilledPayoutReadOnly[];
};
export type PaginatedTilledPayoutReadOnlyListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TilledPayoutReadOnlyRead[];
};
export type TilledPayoutsListInvoiceNumberErrorComponent = {
  attr: 'invoice_number';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TilledPayoutsListPaidAtAfterErrorComponent = {
  attr: 'paid_at_after';
  code: 'invalid';
  detail: string;
};
export type TilledPayoutsListPaidAtBeforeErrorComponent = {
  attr: 'paid_at_before';
  code: 'invalid';
  detail: string;
};
export type TilledPayoutsListSelectedInvoicesErrorComponent = {
  attr: 'selected_invoices';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TilledPayoutsListError =
  | ({
      attr: 'invoice_number';
    } & TilledPayoutsListInvoiceNumberErrorComponent)
  | ({
      attr: 'paid_at_after';
    } & TilledPayoutsListPaidAtAfterErrorComponent)
  | ({
      attr: 'paid_at_before';
    } & TilledPayoutsListPaidAtBeforeErrorComponent)
  | ({
      attr: 'selected_invoices';
    } & TilledPayoutsListSelectedInvoicesErrorComponent);
export type TilledPayoutsListValidationError = {
  type: ValidationErrorEnum;
  errors: TilledPayoutsListError[];
};
export type TilledPayoutsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TilledPayoutsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TilledPayoutExport = {
  PayoutID: string;
  Amount: number;
  Currency: string;
  PaidAt: string;
  Status: string;
  Description: string;
  FailureCode: string;
};
export type TilledPayoutExportRead = {
  PayoutID: string;
  Amount: number;
  Currency: string;
  PaidAt: string;
  Status: string;
  Description: string;
  FailureCode: string;
  InvoiceNumbers: string;
};
export type TilledAuthLink = {
  id?: string;
  account_id: string;
  url: string;
  user_id: string;
  expires_at: string;
  redeemed: boolean;
  redirect_url: string;
  metadata: {
    [key: string]: any;
  } | null;
  updated_at: string;
  created_at: string;
};
export type TilledResourceLinkCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TilledResourceLinkCreateTypeErrorComponent = {
  attr: 'type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TilledResourceLinkCreateIdErrorComponent = {
  attr: 'id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledResourceLinkCreateError =
  | ({
      attr: 'non_field_errors';
    } & TilledResourceLinkCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'type';
    } & TilledResourceLinkCreateTypeErrorComponent)
  | ({
      attr: 'id';
    } & TilledResourceLinkCreateIdErrorComponent);
export type TilledResourceLinkCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TilledResourceLinkCreateError[];
};
export type TilledResourceLinkCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TilledResourceLinkCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TilledResourceLinkTypeEnum = 'payments' | 'refunds' | 'payouts';
export type TilledResourceLink = {
  type: TilledResourceLinkTypeEnum;
  id: string;
};
export type TilledWebHookEnvelope = {
  id: string;
  account_id: string;
  type: string;
  internal_data: {
    [key: string]: any;
  };
};
export type TilledWebhookCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TilledWebhookCreateIdErrorComponent = {
  attr: 'id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledWebhookCreateAccountIdErrorComponent = {
  attr: 'account_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledWebhookCreateTypeErrorComponent = {
  attr: 'type';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TilledWebhookCreateInternalDataErrorComponent = {
  attr: 'internal_data';
  code: 'not_a_dict' | 'null' | 'required';
  detail: string;
};
export type TilledWebhookCreateInternalDataKeyErrorComponent = {
  attr: 'internal_data.KEY';
  code: 'required';
  detail: string;
};
export type TilledWebhookCreateError =
  | ({
      attr: 'non_field_errors';
    } & TilledWebhookCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'id';
    } & TilledWebhookCreateIdErrorComponent)
  | ({
      attr: 'account_id';
    } & TilledWebhookCreateAccountIdErrorComponent)
  | ({
      attr: 'type';
    } & TilledWebhookCreateTypeErrorComponent)
  | ({
      attr: 'internal_data';
    } & TilledWebhookCreateInternalDataErrorComponent)
  | ({
      attr: 'internal_data.KEY';
    } & TilledWebhookCreateInternalDataKeyErrorComponent);
export type TilledWebhookCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TilledWebhookCreateError[];
};
export type TilledWebhookCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TilledWebhookCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type ChatTokens = {
  token: string;
  /** Unix timestamp in seconds */
  expiration: number;
};
export type TokensChatIssueRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type PushTokens = {
  token: string;
};
export type PushTokensRead = {
  token: string;
  token_type: string | null;
};
export type TokensPushRegisterCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TokensPushRegisterCreateTokenErrorComponent = {
  attr: 'token';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TokensPushRegisterCreateError =
  | ({
      attr: 'non_field_errors';
    } & TokensPushRegisterCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'token';
    } & TokensPushRegisterCreateTokenErrorComponent);
export type TokensPushRegisterCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TokensPushRegisterCreateError[];
};
export type TokensPushRegisterCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TokensPushRegisterCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TokensPushRevokeCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TokensPushRevokeCreateTokenErrorComponent = {
  attr: 'token';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TokensPushRevokeCreateError =
  | ({
      attr: 'non_field_errors';
    } & TokensPushRevokeCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'token';
    } & TokensPushRevokeCreateTokenErrorComponent);
export type TokensPushRevokeCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TokensPushRevokeCreateError[];
};
export type TokensPushRevokeCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TokensPushRevokeCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripImportAsync = {};
export type TripImportAsyncRead = {
  id: string;
};
export type TripImportAsyncWrite = {
  payer_id?: string | null;
  template_key: string;
  trips_from_csv: {
    [key: string]: any;
  };
  import_batch_id?: number | null;
};
export type TripImportCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripImportCreatePayerIdErrorComponent = {
  attr: 'payer_id';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripImportCreateTemplateKeyErrorComponent = {
  attr: 'template_key';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripImportCreateTripsFromCsvNonFieldErrorsErrorComponent = {
  attr: 'trips_from_csv.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsNonFieldErrorsErrorComponent = {
  attr: 'trips_from_csv.records.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexAssignmentStartErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.assignment.start';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexAssignmentEndErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.assignment.end';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerFirstNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.first_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerLastNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.last_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerPreferredNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.preferred_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerPronounErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.pronoun';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerGenderErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.gender';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerDobErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.dob';
    code: 'datetime' | 'invalid';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerWeightErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.weight';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerNeedsBariatricTransportErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.needs_bariatric_transport';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.phone_number';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerEmailErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.email';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerDispatcherNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPassengerAllowSmsMessageErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.allow_sms_message';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerPayerErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.payer.payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsIndexPayerDisplayNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.display_name';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerAlternateNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.alternate_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerTypeErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.payer.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsIndexPayerIsActiveErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.is_active';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerIsSelfPayErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.is_self_pay';
    code: 'invalid';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerCanMultiloadErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.can_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerExternalIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.external_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerWebsiteErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.website';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerEinErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.payer.ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsIndexPayerEmailErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.payer.email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsIndexPayerPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerBillingNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerBillingPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerBillingEmailErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_email';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerDispatcherNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerAdminNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.admin_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerDeletedAtErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.deleted_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLocationPlaceIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLabelErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLabel2ErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressAddressNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressAddressTypeErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLabelErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLabel2ErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressAddressNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressAddressTypeErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerMultiloadingPartnersIndexErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.multiloading_partners.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPayerIdErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.payer_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsIndexPayerPassengerExternalIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer_passenger_external_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexExternalTripIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.external_trip_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexInputPriceCentsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.input_price_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPaymentMethodErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payment_method';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexScheduledPickupAtErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.scheduled_pickup_at';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPickupNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPickupAddressDetailsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPickupNumStairsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPickupStairEquipmentErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPickupContactNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPickupContactPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPickupDriverNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPickupPlaceIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexDropoffNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexDropoffAddressDetailsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexDropoffNumStairsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexDropoffStairEquipmentErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexDropoffContactNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexDropoffContactPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexDropoffDriverNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexDropoffPlaceIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexAppointmentAtErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.appointment_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexIsWillCallErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.is_will_call';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsIndexSpaceTypeErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsIndexMustProvideWheelchairErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.must_provide_wheelchair';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexServiceTypeErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.service_type';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexDispatcherNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexBillingNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.billing_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexDriverEnteredNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.driver_entered_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexIsOxygenRequiredErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.is_oxygen_required';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexOxygenLitersPerMinErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.oxygen_liters_per_min';
    code:
      | 'invalid'
      | 'max_decimal_places'
      | 'max_digits'
      | 'max_string_length'
      | 'max_whole_digits'
      | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexNumAttendantsNeededErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.num_attendants_needed';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexNumAccompanyingPassengersErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.num_accompanying_passengers';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexOneSchemaTemplateIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.one_schema_template_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexOneSchemaTemplateMultiIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.one_schema_template_multi_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexCorrelationIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.correlation_id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexBookedByNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.booked_by_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexBookedByPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.booked_by_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexBookedByPhoneExtensionErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.booked_by_phone_extension';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexLoadTimeSecondsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.load_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexUnloadTimeSecondsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.unload_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexPickupWaitTimeSecondsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup_wait_time_seconds';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexTagIdsErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsIndexTagIdsIndexErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.tag_ids.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexTagsIndexTagNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.tags.INDEX.tag_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexTagsIndexColorHexErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.tags.INDEX.color_hex';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexAddedTagsErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.added_tags';
  code: 'not_a_list';
  detail: string;
};
export type TripImportCreateTripsFromCsvRecordsIndexAddedTagsIndexErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.added_tags.INDEX';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexIsWaitAndReturnOutboundErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.is_wait_and_return_outbound';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexIsWaitAndReturnInboundErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.is_wait_and_return_inbound';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexAuthorizationIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.authorization_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexInsurancePolicyIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.insurance_policy_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexIsPriceLockedErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.is_price_locked';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexLinkToPayerErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.link_to_payer';
    code: 'invalid_choice';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexConfirmationCodeErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.confirmation_code';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexIntermediaryErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.intermediary';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexHasInfectiousDiseaseErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.has_infectious_disease';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexSeatEquipmentErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.seat_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexShouldAvoidMultiloadErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.should_avoid_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripImportCreateTripsFromCsvRecordsIndexImportBatchIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.import_batch_id';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type TripImportCreateImportBatchIdErrorComponent = {
  attr: 'import_batch_id';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type TripImportCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripImportCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_id';
    } & TripImportCreatePayerIdErrorComponent)
  | ({
      attr: 'template_key';
    } & TripImportCreateTemplateKeyErrorComponent)
  | ({
      attr: 'trips_from_csv.non_field_errors';
    } & TripImportCreateTripsFromCsvNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.non_field_errors';
    } & TripImportCreateTripsFromCsvRecordsNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.non_field_errors';
    } & TripImportCreateTripsFromCsvRecordsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.assignment.start';
    } & TripImportCreateTripsFromCsvRecordsIndexAssignmentStartErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.assignment.end';
    } & TripImportCreateTripsFromCsvRecordsIndexAssignmentEndErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.non_field_errors';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.id';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.first_name';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerFirstNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.last_name';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerLastNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.preferred_name';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerPreferredNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.pronoun';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerPronounErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.gender';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerGenderErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.dob';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerDobErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.weight';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerWeightErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.needs_bariatric_transport';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.phone_number';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.email';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerEmailErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.notes';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.dispatcher_notes';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerDispatcherNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.allow_sms_message';
    } & TripImportCreateTripsFromCsvRecordsIndexPassengerAllowSmsMessageErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.payer';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerPayerErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.display_name';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerDisplayNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.alternate_name';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerAlternateNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.type';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerTypeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.is_active';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerIsActiveErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.is_self_pay';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerIsSelfPayErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.can_multiload';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerCanMultiloadErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.external_id';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerExternalIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.website';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerWebsiteErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.ein';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerEinErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.email';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerEmailErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.phone_number';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_name';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerBillingNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_phone_number';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerBillingPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_email';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerBillingEmailErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.dispatcher_notes';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerDispatcherNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.admin_notes';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerAdminNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.deleted_at';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerDeletedAtErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.non_field_errors';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.location.non_field_errors';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.location.place_id';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.label';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLabelErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.label2';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.address_notes';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.address_type';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.non_field_errors';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.location.non_field_errors';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.location.place_id';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.label';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.label2';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.address_notes';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.address_type';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.multiloading_partners.non_field_errors';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.multiloading_partners.INDEX';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerMultiloadingPartnersIndexErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer_id';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer_passenger_external_id';
    } & TripImportCreateTripsFromCsvRecordsIndexPayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.external_trip_id';
    } & TripImportCreateTripsFromCsvRecordsIndexExternalTripIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.input_price_cents';
    } & TripImportCreateTripsFromCsvRecordsIndexInputPriceCentsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payment_method';
    } & TripImportCreateTripsFromCsvRecordsIndexPaymentMethodErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.scheduled_pickup_at';
    } & TripImportCreateTripsFromCsvRecordsIndexScheduledPickupAtErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.non_field_errors';
    } & TripImportCreateTripsFromCsvRecordsIndexPickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.address_details';
    } & TripImportCreateTripsFromCsvRecordsIndexPickupAddressDetailsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.num_stairs';
    } & TripImportCreateTripsFromCsvRecordsIndexPickupNumStairsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.stair_equipment';
    } & TripImportCreateTripsFromCsvRecordsIndexPickupStairEquipmentErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.contact_name';
    } & TripImportCreateTripsFromCsvRecordsIndexPickupContactNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.contact_phone_number';
    } & TripImportCreateTripsFromCsvRecordsIndexPickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.driver_notes';
    } & TripImportCreateTripsFromCsvRecordsIndexPickupDriverNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.place_id';
    } & TripImportCreateTripsFromCsvRecordsIndexPickupPlaceIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.non_field_errors';
    } & TripImportCreateTripsFromCsvRecordsIndexDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.address_details';
    } & TripImportCreateTripsFromCsvRecordsIndexDropoffAddressDetailsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.num_stairs';
    } & TripImportCreateTripsFromCsvRecordsIndexDropoffNumStairsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.stair_equipment';
    } & TripImportCreateTripsFromCsvRecordsIndexDropoffStairEquipmentErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.contact_name';
    } & TripImportCreateTripsFromCsvRecordsIndexDropoffContactNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.contact_phone_number';
    } & TripImportCreateTripsFromCsvRecordsIndexDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.driver_notes';
    } & TripImportCreateTripsFromCsvRecordsIndexDropoffDriverNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.place_id';
    } & TripImportCreateTripsFromCsvRecordsIndexDropoffPlaceIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.appointment_at';
    } & TripImportCreateTripsFromCsvRecordsIndexAppointmentAtErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.is_will_call';
    } & TripImportCreateTripsFromCsvRecordsIndexIsWillCallErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.space_type';
    } & TripImportCreateTripsFromCsvRecordsIndexSpaceTypeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.must_provide_wheelchair';
    } & TripImportCreateTripsFromCsvRecordsIndexMustProvideWheelchairErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.service_type';
    } & TripImportCreateTripsFromCsvRecordsIndexServiceTypeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dispatcher_notes';
    } & TripImportCreateTripsFromCsvRecordsIndexDispatcherNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.billing_notes';
    } & TripImportCreateTripsFromCsvRecordsIndexBillingNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.driver_entered_notes';
    } & TripImportCreateTripsFromCsvRecordsIndexDriverEnteredNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.is_oxygen_required';
    } & TripImportCreateTripsFromCsvRecordsIndexIsOxygenRequiredErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.oxygen_liters_per_min';
    } & TripImportCreateTripsFromCsvRecordsIndexOxygenLitersPerMinErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.num_attendants_needed';
    } & TripImportCreateTripsFromCsvRecordsIndexNumAttendantsNeededErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.num_accompanying_passengers';
    } & TripImportCreateTripsFromCsvRecordsIndexNumAccompanyingPassengersErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.one_schema_template_id';
    } & TripImportCreateTripsFromCsvRecordsIndexOneSchemaTemplateIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.one_schema_template_multi_id';
    } & TripImportCreateTripsFromCsvRecordsIndexOneSchemaTemplateMultiIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.correlation_id';
    } & TripImportCreateTripsFromCsvRecordsIndexCorrelationIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.booked_by_name';
    } & TripImportCreateTripsFromCsvRecordsIndexBookedByNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.booked_by_phone_number';
    } & TripImportCreateTripsFromCsvRecordsIndexBookedByPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.booked_by_phone_extension';
    } & TripImportCreateTripsFromCsvRecordsIndexBookedByPhoneExtensionErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.load_time_seconds';
    } & TripImportCreateTripsFromCsvRecordsIndexLoadTimeSecondsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.unload_time_seconds';
    } & TripImportCreateTripsFromCsvRecordsIndexUnloadTimeSecondsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup_wait_time_seconds';
    } & TripImportCreateTripsFromCsvRecordsIndexPickupWaitTimeSecondsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.tag_ids';
    } & TripImportCreateTripsFromCsvRecordsIndexTagIdsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.tag_ids.INDEX';
    } & TripImportCreateTripsFromCsvRecordsIndexTagIdsIndexErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.tags.INDEX.tag_name';
    } & TripImportCreateTripsFromCsvRecordsIndexTagsIndexTagNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.tags.INDEX.color_hex';
    } & TripImportCreateTripsFromCsvRecordsIndexTagsIndexColorHexErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.added_tags';
    } & TripImportCreateTripsFromCsvRecordsIndexAddedTagsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.added_tags.INDEX';
    } & TripImportCreateTripsFromCsvRecordsIndexAddedTagsIndexErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.is_wait_and_return_outbound';
    } & TripImportCreateTripsFromCsvRecordsIndexIsWaitAndReturnOutboundErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.is_wait_and_return_inbound';
    } & TripImportCreateTripsFromCsvRecordsIndexIsWaitAndReturnInboundErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.authorization_id';
    } & TripImportCreateTripsFromCsvRecordsIndexAuthorizationIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.insurance_policy_id';
    } & TripImportCreateTripsFromCsvRecordsIndexInsurancePolicyIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.is_price_locked';
    } & TripImportCreateTripsFromCsvRecordsIndexIsPriceLockedErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.link_to_payer';
    } & TripImportCreateTripsFromCsvRecordsIndexLinkToPayerErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.confirmation_code';
    } & TripImportCreateTripsFromCsvRecordsIndexConfirmationCodeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.intermediary';
    } & TripImportCreateTripsFromCsvRecordsIndexIntermediaryErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.has_infectious_disease';
    } & TripImportCreateTripsFromCsvRecordsIndexHasInfectiousDiseaseErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.seat_equipment';
    } & TripImportCreateTripsFromCsvRecordsIndexSeatEquipmentErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.should_avoid_multiload';
    } & TripImportCreateTripsFromCsvRecordsIndexShouldAvoidMultiloadErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.import_batch_id';
    } & TripImportCreateTripsFromCsvRecordsIndexImportBatchIdErrorComponent)
  | ({
      attr: 'import_batch_id';
    } & TripImportCreateImportBatchIdErrorComponent);
export type TripImportCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripImportCreateError[];
};
export type TripImportCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripImportCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type LinkToPayerEnum = 'always' | 'never' | 'only_with_id';
export type Trip = {
  passenger: PatchedTripPassenger;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  scheduled_pickup_at: string;
  pickup: TripLocationDetail;
  dropoff: TripLocationDetail;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min?: string;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound?: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound?: boolean;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** Whether this trips pricing is locked (non-editable) */
  is_price_locked?: boolean;
  link_to_payer?: (LinkToPayerEnum | NullEnum) | null;
  confirmation_code?: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
  import_batch_id?: number | null;
};
export type AssignmentMini = {
  start: string;
  end: string;
};
export type AssignmentMiniRead = {
  id: string;
  start: string;
  end: string;
};
export type TripTiming = {};
export type TripTimingRead = {
  /** Estimated arrival at pickup location per vehicle's last location log */
  estimated_pickup_arrival_time: string | null;
  is_on_time: boolean | null;
  delayed_by_seconds: number | null;
  /** Last time this timing was calculated */
  last_calculated_at: string | null;
};
export type TripSourceEnum = 'public_form';
export type TripRead = {
  id: string;
  assignment: AssignmentMiniRead | null;
  /** Current status of this trip */
  status: OverrideStatusEnum;
  /** Locked assignment cannot be changed */
  is_locked: boolean | null;
  passenger: PatchedTripPassengerRead;
  payer: PayerOrganizationRead;
  payer_passenger: TripPayerPassengerRead | null;
  early_pickup_at: string;
  late_pickup_at: string;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The initial price of the trip calculated using a pricing model */
  initial_calculated_price_cents: number | null;
  /** The final price of the trip calculated using a pricing model */
  final_calculated_price_cents: number | null;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  scheduled_pickup_at: string;
  current_task: PurposeEnum;
  current_task_at: string;
  pickup: TripLocationDetailRead;
  dropoff: TripLocationDetailRead;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** Whether the passenger has called in that they are ready to be picked up */
  is_will_call_activated: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min?: string;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  estimated_distance_miles: number | null;
  /** The time the trip was canceled */
  canceled_at: string | null;
  /** The main reason a trip was canceled */
  canceled_reason: CanceledReasonEnum;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  timing: TripTimingRead | null;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  tags: TripTripTagRead[] | null;
  /** The suggested pickup time based off of run_bambi_run results */
  suggested_pickup_time: string | null;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound?: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound?: boolean;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** Whether this trips pricing is locked (non-editable) */
  is_price_locked?: boolean;
  link_to_payer?: (LinkToPayerEnum | NullEnum) | null;
  confirmation_code?: string;
  driver_name: string;
  invoice_numbers: string | null;
  invoice_id: string | null;
  rejection_reason: string | null;
  /** The trip ID used by an intermediary/broker, may or may not be the originator */
  intermediary_id: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** How this trip was created */
  source: TripSourceEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  completion_time: string | null;
  vehicle_nickname: string | null;
  /** Membership that caused a model creation */
  created_by: string | null;
  created_at: string;
  is_cancellation_requested: boolean;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
  import_batch_id?: number | null;
};
export type TripWrite = {
  passenger: PatchedTripPassenger;
  payer_id: string;
  payer_passenger_external_id?: string;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  scheduled_pickup_at: string;
  pickup: TripLocationDetail;
  dropoff: TripLocationDetail;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min?: string;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  tag_ids?: string[] | null;
  added_tags?: string[] | null;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound?: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound?: boolean;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** Whether this trips pricing is locked (non-editable) */
  is_price_locked?: boolean;
  link_to_payer?: (LinkToPayerEnum | NullEnum) | null;
  confirmation_code?: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
  import_batch_id?: number | null;
};
export type OneSchemaDataAsync = {
  records: Trip[];
};
export type OneSchemaDataAsyncRead = {
  records: TripRead[];
};
export type OneSchemaDataAsyncWrite = {
  records: TripWrite[];
};
export type TripImportAsyncRequest = {
  payer_id?: string;
  template_key: string;
  trips_from_csv: OneSchemaDataAsync;
  import_batch_id?: number;
};
export type TripImportAsyncRequestRead = {
  payer_id?: string;
  template_key: string;
  trips_from_csv: OneSchemaDataAsyncRead;
  import_batch_id?: number;
};
export type TripImportAsyncRequestWrite = {
  payer_id?: string;
  template_key: string;
  trips_from_csv: OneSchemaDataAsyncWrite;
  import_batch_id?: number;
};
export type TripImportTask = {};
export type TripImportResult = {};
export type TripImportParserError = {};
export type TripImportParserErrorRead = {
  trip: string;
  error: string;
};
export type TripImportUploadError = {};
export type TripImportUploadErrorRead = {
  trip: string;
  errors: {
    [key: string]: string[];
  };
};
export type TripImportResultRead = {
  trip_ids: string[];
  number_parsed: number;
  number_uploaded: number;
  parser_errors: TripImportParserErrorRead[];
  upload_errors: TripImportUploadErrorRead[];
};
export type TripImportTaskRead = {
  id: string;
  state: StateEnum;
  result: TripImportResultRead;
};
export type TripImportRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type HostingProviderEnum = 'other' | 'wix';
export type TripRequestEmbed = {
  /** TP's name for this source */
  label: string;
  /** The domain where this form will be embedded (e.g. 'www.example.com') */
  domain: string;
  /** The hosting provider for the embedded domain */
  hosting_provider?: HostingProviderEnum;
  /** Wix site ID (UUID) from the Wix dashboard URL */
  wix_site_id?: string;
  /** The payer to use for trips submitted through this embed */
  payer?: string | null;
  description?: string;
  /** If false, requests from this source are rejected */
  is_active?: boolean;
};
export type TripRequestEmbedRead = {
  id: string;
  /** TP's name for this source */
  label: string;
  /** The domain where this form will be embedded (e.g. 'www.example.com') */
  domain: string;
  /** The hosting provider for the embedded domain */
  hosting_provider?: HostingProviderEnum;
  /** Wix site ID (UUID) from the Wix dashboard URL */
  wix_site_id?: string;
  /** The payer to use for trips submitted through this embed */
  payer?: string | null;
  payer_display_name: string;
  description?: string;
  /** Generated by the model */
  public_token: string;
  /** If false, requests from this source are rejected */
  is_active?: boolean;
  created_at: string;
  updated_at: string;
};
export type PaginatedTripRequestEmbedList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripRequestEmbed[];
};
export type PaginatedTripRequestEmbedListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripRequestEmbedRead[];
};
export type TripRequestEmbedCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripRequestEmbedCreateLabelErrorComponent = {
  attr: 'label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripRequestEmbedCreateDomainErrorComponent = {
  attr: 'domain';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripRequestEmbedCreateHostingProviderErrorComponent = {
  attr: 'hosting_provider';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripRequestEmbedCreateWixSiteIdErrorComponent = {
  attr: 'wix_site_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripRequestEmbedCreatePayerErrorComponent = {
  attr: 'payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type TripRequestEmbedCreateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripRequestEmbedCreateIsActiveErrorComponent = {
  attr: 'is_active';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripRequestEmbedCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripRequestEmbedCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'label';
    } & TripRequestEmbedCreateLabelErrorComponent)
  | ({
      attr: 'domain';
    } & TripRequestEmbedCreateDomainErrorComponent)
  | ({
      attr: 'hosting_provider';
    } & TripRequestEmbedCreateHostingProviderErrorComponent)
  | ({
      attr: 'wix_site_id';
    } & TripRequestEmbedCreateWixSiteIdErrorComponent)
  | ({
      attr: 'payer';
    } & TripRequestEmbedCreatePayerErrorComponent)
  | ({
      attr: 'description';
    } & TripRequestEmbedCreateDescriptionErrorComponent)
  | ({
      attr: 'is_active';
    } & TripRequestEmbedCreateIsActiveErrorComponent);
export type TripRequestEmbedCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripRequestEmbedCreateError[];
};
export type TripRequestEmbedCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripRequestEmbedCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripRequestEmbedRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripRequestEmbedPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripRequestEmbedPartialUpdateLabelErrorComponent = {
  attr: 'label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripRequestEmbedPartialUpdateDomainErrorComponent = {
  attr: 'domain';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripRequestEmbedPartialUpdateHostingProviderErrorComponent = {
  attr: 'hosting_provider';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripRequestEmbedPartialUpdateWixSiteIdErrorComponent = {
  attr: 'wix_site_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripRequestEmbedPartialUpdatePayerErrorComponent = {
  attr: 'payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type TripRequestEmbedPartialUpdateDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripRequestEmbedPartialUpdateIsActiveErrorComponent = {
  attr: 'is_active';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripRequestEmbedPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripRequestEmbedPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'label';
    } & TripRequestEmbedPartialUpdateLabelErrorComponent)
  | ({
      attr: 'domain';
    } & TripRequestEmbedPartialUpdateDomainErrorComponent)
  | ({
      attr: 'hosting_provider';
    } & TripRequestEmbedPartialUpdateHostingProviderErrorComponent)
  | ({
      attr: 'wix_site_id';
    } & TripRequestEmbedPartialUpdateWixSiteIdErrorComponent)
  | ({
      attr: 'payer';
    } & TripRequestEmbedPartialUpdatePayerErrorComponent)
  | ({
      attr: 'description';
    } & TripRequestEmbedPartialUpdateDescriptionErrorComponent)
  | ({
      attr: 'is_active';
    } & TripRequestEmbedPartialUpdateIsActiveErrorComponent);
export type TripRequestEmbedPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripRequestEmbedPartialUpdateError[];
};
export type TripRequestEmbedPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripRequestEmbedPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripRequestEmbed = {
  /** TP's name for this source */
  label?: string;
  /** The domain where this form will be embedded (e.g. 'www.example.com') */
  domain?: string;
  /** The hosting provider for the embedded domain */
  hosting_provider?: HostingProviderEnum;
  /** Wix site ID (UUID) from the Wix dashboard URL */
  wix_site_id?: string;
  /** The payer to use for trips submitted through this embed */
  payer?: string | null;
  description?: string;
  /** If false, requests from this source are rejected */
  is_active?: boolean;
};
export type PatchedTripRequestEmbedRead = {
  id?: string;
  /** TP's name for this source */
  label?: string;
  /** The domain where this form will be embedded (e.g. 'www.example.com') */
  domain?: string;
  /** The hosting provider for the embedded domain */
  hosting_provider?: HostingProviderEnum;
  /** Wix site ID (UUID) from the Wix dashboard URL */
  wix_site_id?: string;
  /** The payer to use for trips submitted through this embed */
  payer?: string | null;
  payer_display_name?: string;
  description?: string;
  /** Generated by the model */
  public_token?: string;
  /** If false, requests from this source are rejected */
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
};
export type TripRequestEmbedDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripTag = {
  trip: string;
  tag: string;
};
export type TripTagRead = {
  id: string;
  tag_name: string;
  color_hex: string;
  trip: string;
  tag: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedTripTagList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripTag[];
};
export type PaginatedTripTagListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripTagRead[];
};
export type TripTagsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripTagBulkCreate = {
  tags: TripTag[];
};
export type TripTagBulkCreateRead = {
  tags: TripTagRead[];
};
export type TripTagsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripTagsCreateTagsNonFieldErrorsErrorComponent = {
  attr: 'tags.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripTagsCreateTagsIndexNonFieldErrorsErrorComponent = {
  attr: 'tags.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required' | 'unique';
  detail: string;
};
export type TripTagsCreateTagsIndexTripErrorComponent = {
  attr: 'tags.INDEX.trip';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type TripTagsCreateTagsIndexTagErrorComponent = {
  attr: 'tags.INDEX.tag';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type TripTagsCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripTagsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.non_field_errors';
    } & TripTagsCreateTagsNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.INDEX.non_field_errors';
    } & TripTagsCreateTagsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.INDEX.trip';
    } & TripTagsCreateTagsIndexTripErrorComponent)
  | ({
      attr: 'tags.INDEX.tag';
    } & TripTagsCreateTagsIndexTagErrorComponent);
export type TripTagsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripTagsCreateError[];
};
export type TripTagsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripTagsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripTagsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripTagsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type VehicleTag = {
  vehicle: string;
  tag: string;
};
export type VehicleTagRead = {
  id: string;
  tag_name: string;
  color_hex: string;
  vehicle: string;
  tag: string;
  created_at: string;
  updated_at: string;
};
export type PaginatedVehicleTagList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: VehicleTag[];
};
export type PaginatedVehicleTagListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: VehicleTagRead[];
};
export type VehicleTagsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type VehicleTagBulkCreate = {
  tags: VehicleTag[];
};
export type VehicleTagBulkCreateRead = {
  tags: VehicleTagRead[];
};
export type VehicleTagsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type VehicleTagsCreateTagsNonFieldErrorsErrorComponent = {
  attr: 'tags.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type VehicleTagsCreateTagsIndexNonFieldErrorsErrorComponent = {
  attr: 'tags.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required' | 'unique';
  detail: string;
};
export type VehicleTagsCreateTagsIndexVehicleErrorComponent = {
  attr: 'tags.INDEX.vehicle';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type VehicleTagsCreateTagsIndexTagErrorComponent = {
  attr: 'tags.INDEX.tag';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type VehicleTagsCreateError =
  | ({
      attr: 'non_field_errors';
    } & VehicleTagsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.non_field_errors';
    } & VehicleTagsCreateTagsNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.INDEX.non_field_errors';
    } & VehicleTagsCreateTagsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'tags.INDEX.vehicle';
    } & VehicleTagsCreateTagsIndexVehicleErrorComponent)
  | ({
      attr: 'tags.INDEX.tag';
    } & VehicleTagsCreateTagsIndexTagErrorComponent);
export type VehicleTagsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: VehicleTagsCreateError[];
};
export type VehicleTagsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & VehicleTagsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type VehicleTagsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type VehicleTagsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type VehicleStorageLocation = {
  place_id: string;
};
export type VehicleStorageLocationRead = {
  /** full address */
  label: string;
  place_id: string;
  latitude: number;
  longitude: number;
};
export type VehicleCapacityConfiguration = {
  wheelchair_capacity?: number;
  wheelchair_xl_capacity?: number;
  broda_chair_capacity?: number;
  geri_chair_capacity?: number;
  stretcher_capacity?: number;
  stretcher_xl_capacity?: number;
  ambulatory_capacity?: number;
  /** how many wheelchairs without passengers the vehicle can safely transport */
  equipment_wheelchair_capacity?: number;
  is_delivery_capable?: boolean;
};
export type Vehicle = {
  nickname?: string;
  vin?: string;
  make?: string;
  model?: string;
  color?: string;
  year?: number | null;
  can_be_scheduled?: boolean;
  license_plate?: string;
  license_plate_state?: (LicensePlateStateEnum | BlankEnum | NullEnum) | null;
  category: VehicleCategoryEnum;
  notes?: string;
  storage_location: VehicleStorageLocation;
  capacity_configurations: VehicleCapacityConfiguration[];
  deleted_at?: string | null;
  allowed_payer_ids?: string[] | null;
};
export type VehicleVehicleTag = {
  tag_name: string;
  color_hex: string;
};
export type VehicleVehicleTagRead = {
  id: string;
  tag: string;
  tag_name: string;
  color_hex: string;
  created_at: string;
  updated_at: string;
};
export type VehicleRead = {
  id: string;
  nickname?: string;
  vin?: string;
  organization_id: string;
  make?: string;
  model?: string;
  color?: string;
  year?: number | null;
  can_be_scheduled?: boolean;
  license_plate?: string;
  license_plate_state?: (LicensePlateStateEnum | BlankEnum | NullEnum) | null;
  category: VehicleCategoryEnum;
  notes?: string;
  storage_location: VehicleStorageLocationRead;
  capacity_configurations: VehicleCapacityConfiguration[];
  updated_at: string;
  created_at: string;
  deleted_at?: string | null;
  tags: VehicleVehicleTagRead[] | null;
  allowed_payer_ids?: string[] | null;
};
export type VehicleWrite = {
  nickname?: string;
  vin?: string;
  make?: string;
  model?: string;
  color?: string;
  year?: number | null;
  can_be_scheduled?: boolean;
  license_plate?: string;
  license_plate_state?: (LicensePlateStateEnum | BlankEnum | NullEnum) | null;
  category: VehicleCategoryEnum;
  notes?: string;
  storage_location: VehicleStorageLocation;
  capacity_configurations: VehicleCapacityConfiguration[];
  deleted_at?: string | null;
  tag_ids?: string[] | null;
  allowed_payer_ids?: string[] | null;
};
export type PaginatedVehicleList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Vehicle[];
};
export type PaginatedVehicleListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: VehicleRead[];
};
export type PaginatedVehicleListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: VehicleWrite[];
};
export type VehiclesListTagsErrorComponent = {
  attr: 'tags';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type VehiclesListError = {
  attr: 'tags';
} & VehiclesListTagsErrorComponent;
export type VehiclesListValidationError = {
  type: ValidationErrorEnum;
  errors: VehiclesListError[];
};
export type VehiclesListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & VehiclesListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type VehiclesCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type VehiclesCreateNicknameErrorComponent = {
  attr: 'nickname';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesCreateVinErrorComponent = {
  attr: 'vin';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesCreateMakeErrorComponent = {
  attr: 'make';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesCreateModelErrorComponent = {
  attr: 'model';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesCreateColorErrorComponent = {
  attr: 'color';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesCreateYearErrorComponent = {
  attr: 'year';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type VehiclesCreateCanBeScheduledErrorComponent = {
  attr: 'can_be_scheduled';
  code: 'invalid' | 'null';
  detail: string;
};
export type VehiclesCreateLicensePlateErrorComponent = {
  attr: 'license_plate';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesCreateLicensePlateStateErrorComponent = {
  attr: 'license_plate_state';
  code: 'invalid_choice';
  detail: string;
};
export type VehiclesCreateCategoryErrorComponent = {
  attr: 'category';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type VehiclesCreateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesCreateStorageLocationNonFieldErrorsErrorComponent = {
  attr: 'storage_location.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type VehiclesCreateStorageLocationPlaceIdErrorComponent = {
  attr: 'storage_location.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesCreateCapacityConfigurationsNonFieldErrorsErrorComponent = {
  attr: 'capacity_configurations.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type VehiclesCreateCapacityConfigurationsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type VehiclesCreateCapacityConfigurationsIndexWheelchairCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.wheelchair_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesCreateCapacityConfigurationsIndexWheelchairXlCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.wheelchair_xl_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesCreateCapacityConfigurationsIndexBrodaChairCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.broda_chair_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesCreateCapacityConfigurationsIndexGeriChairCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.geri_chair_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesCreateCapacityConfigurationsIndexStretcherCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.stretcher_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesCreateCapacityConfigurationsIndexStretcherXlCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.stretcher_xl_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesCreateCapacityConfigurationsIndexAmbulatoryCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.ambulatory_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesCreateCapacityConfigurationsIndexEquipmentWheelchairCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.equipment_wheelchair_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesCreateCapacityConfigurationsIndexIsDeliveryCapableErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.is_delivery_capable';
    code: 'invalid' | 'null';
    detail: string;
  };
export type VehiclesCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type VehiclesCreateTagsIndexTagNameErrorComponent = {
  attr: 'tags.INDEX.tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesCreateTagsIndexColorHexErrorComponent = {
  attr: 'tags.INDEX.color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesCreateTagIdsErrorComponent = {
  attr: 'tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type VehiclesCreateTagIdsIndexErrorComponent = {
  attr: 'tag_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type VehiclesCreateAllowedPayerIdsErrorComponent = {
  attr: 'allowed_payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type VehiclesCreateAllowedPayerIdsIndexErrorComponent = {
  attr: 'allowed_payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type VehiclesCreateError =
  | ({
      attr: 'non_field_errors';
    } & VehiclesCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'nickname';
    } & VehiclesCreateNicknameErrorComponent)
  | ({
      attr: 'vin';
    } & VehiclesCreateVinErrorComponent)
  | ({
      attr: 'make';
    } & VehiclesCreateMakeErrorComponent)
  | ({
      attr: 'model';
    } & VehiclesCreateModelErrorComponent)
  | ({
      attr: 'color';
    } & VehiclesCreateColorErrorComponent)
  | ({
      attr: 'year';
    } & VehiclesCreateYearErrorComponent)
  | ({
      attr: 'can_be_scheduled';
    } & VehiclesCreateCanBeScheduledErrorComponent)
  | ({
      attr: 'license_plate';
    } & VehiclesCreateLicensePlateErrorComponent)
  | ({
      attr: 'license_plate_state';
    } & VehiclesCreateLicensePlateStateErrorComponent)
  | ({
      attr: 'category';
    } & VehiclesCreateCategoryErrorComponent)
  | ({
      attr: 'notes';
    } & VehiclesCreateNotesErrorComponent)
  | ({
      attr: 'storage_location.non_field_errors';
    } & VehiclesCreateStorageLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'storage_location.place_id';
    } & VehiclesCreateStorageLocationPlaceIdErrorComponent)
  | ({
      attr: 'capacity_configurations.non_field_errors';
    } & VehiclesCreateCapacityConfigurationsNonFieldErrorsErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.non_field_errors';
    } & VehiclesCreateCapacityConfigurationsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.wheelchair_capacity';
    } & VehiclesCreateCapacityConfigurationsIndexWheelchairCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.wheelchair_xl_capacity';
    } & VehiclesCreateCapacityConfigurationsIndexWheelchairXlCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.broda_chair_capacity';
    } & VehiclesCreateCapacityConfigurationsIndexBrodaChairCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.geri_chair_capacity';
    } & VehiclesCreateCapacityConfigurationsIndexGeriChairCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.stretcher_capacity';
    } & VehiclesCreateCapacityConfigurationsIndexStretcherCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.stretcher_xl_capacity';
    } & VehiclesCreateCapacityConfigurationsIndexStretcherXlCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.ambulatory_capacity';
    } & VehiclesCreateCapacityConfigurationsIndexAmbulatoryCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.equipment_wheelchair_capacity';
    } & VehiclesCreateCapacityConfigurationsIndexEquipmentWheelchairCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.is_delivery_capable';
    } & VehiclesCreateCapacityConfigurationsIndexIsDeliveryCapableErrorComponent)
  | ({
      attr: 'deleted_at';
    } & VehiclesCreateDeletedAtErrorComponent)
  | ({
      attr: 'tags.INDEX.tag_name';
    } & VehiclesCreateTagsIndexTagNameErrorComponent)
  | ({
      attr: 'tags.INDEX.color_hex';
    } & VehiclesCreateTagsIndexColorHexErrorComponent)
  | ({
      attr: 'tag_ids';
    } & VehiclesCreateTagIdsErrorComponent)
  | ({
      attr: 'tag_ids.INDEX';
    } & VehiclesCreateTagIdsIndexErrorComponent)
  | ({
      attr: 'allowed_payer_ids';
    } & VehiclesCreateAllowedPayerIdsErrorComponent)
  | ({
      attr: 'allowed_payer_ids.INDEX';
    } & VehiclesCreateAllowedPayerIdsIndexErrorComponent);
export type VehiclesCreateValidationError = {
  type: ValidationErrorEnum;
  errors: VehiclesCreateError[];
};
export type VehiclesCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & VehiclesCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type VehiclesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type VehiclesPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type VehiclesPartialUpdateNicknameErrorComponent = {
  attr: 'nickname';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesPartialUpdateVinErrorComponent = {
  attr: 'vin';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesPartialUpdateMakeErrorComponent = {
  attr: 'make';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesPartialUpdateModelErrorComponent = {
  attr: 'model';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesPartialUpdateColorErrorComponent = {
  attr: 'color';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesPartialUpdateYearErrorComponent = {
  attr: 'year';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type VehiclesPartialUpdateCanBeScheduledErrorComponent = {
  attr: 'can_be_scheduled';
  code: 'invalid' | 'null';
  detail: string;
};
export type VehiclesPartialUpdateLicensePlateErrorComponent = {
  attr: 'license_plate';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesPartialUpdateLicensePlateStateErrorComponent = {
  attr: 'license_plate_state';
  code: 'invalid_choice';
  detail: string;
};
export type VehiclesPartialUpdateCategoryErrorComponent = {
  attr: 'category';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type VehiclesPartialUpdateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesPartialUpdateStorageLocationNonFieldErrorsErrorComponent = {
  attr: 'storage_location.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type VehiclesPartialUpdateStorageLocationPlaceIdErrorComponent = {
  attr: 'storage_location.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesPartialUpdateCapacityConfigurationsNonFieldErrorsErrorComponent =
  {
    attr: 'capacity_configurations.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type VehiclesPartialUpdateCapacityConfigurationsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type VehiclesPartialUpdateCapacityConfigurationsIndexWheelchairCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.wheelchair_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesPartialUpdateCapacityConfigurationsIndexWheelchairXlCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.wheelchair_xl_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesPartialUpdateCapacityConfigurationsIndexBrodaChairCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.broda_chair_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesPartialUpdateCapacityConfigurationsIndexGeriChairCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.geri_chair_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesPartialUpdateCapacityConfigurationsIndexStretcherCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.stretcher_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesPartialUpdateCapacityConfigurationsIndexStretcherXlCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.stretcher_xl_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesPartialUpdateCapacityConfigurationsIndexAmbulatoryCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.ambulatory_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesPartialUpdateCapacityConfigurationsIndexEquipmentWheelchairCapacityErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.equipment_wheelchair_capacity';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type VehiclesPartialUpdateCapacityConfigurationsIndexIsDeliveryCapableErrorComponent =
  {
    attr: 'capacity_configurations.INDEX.is_delivery_capable';
    code: 'invalid' | 'null';
    detail: string;
  };
export type VehiclesPartialUpdateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type VehiclesPartialUpdateTagsIndexTagNameErrorComponent = {
  attr: 'tags.INDEX.tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesPartialUpdateTagsIndexColorHexErrorComponent = {
  attr: 'tags.INDEX.color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesPartialUpdateTagIdsErrorComponent = {
  attr: 'tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type VehiclesPartialUpdateTagIdsIndexErrorComponent = {
  attr: 'tag_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type VehiclesPartialUpdateAllowedPayerIdsErrorComponent = {
  attr: 'allowed_payer_ids';
  code: 'not_a_list';
  detail: string;
};
export type VehiclesPartialUpdateAllowedPayerIdsIndexErrorComponent = {
  attr: 'allowed_payer_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type VehiclesPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & VehiclesPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'nickname';
    } & VehiclesPartialUpdateNicknameErrorComponent)
  | ({
      attr: 'vin';
    } & VehiclesPartialUpdateVinErrorComponent)
  | ({
      attr: 'make';
    } & VehiclesPartialUpdateMakeErrorComponent)
  | ({
      attr: 'model';
    } & VehiclesPartialUpdateModelErrorComponent)
  | ({
      attr: 'color';
    } & VehiclesPartialUpdateColorErrorComponent)
  | ({
      attr: 'year';
    } & VehiclesPartialUpdateYearErrorComponent)
  | ({
      attr: 'can_be_scheduled';
    } & VehiclesPartialUpdateCanBeScheduledErrorComponent)
  | ({
      attr: 'license_plate';
    } & VehiclesPartialUpdateLicensePlateErrorComponent)
  | ({
      attr: 'license_plate_state';
    } & VehiclesPartialUpdateLicensePlateStateErrorComponent)
  | ({
      attr: 'category';
    } & VehiclesPartialUpdateCategoryErrorComponent)
  | ({
      attr: 'notes';
    } & VehiclesPartialUpdateNotesErrorComponent)
  | ({
      attr: 'storage_location.non_field_errors';
    } & VehiclesPartialUpdateStorageLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'storage_location.place_id';
    } & VehiclesPartialUpdateStorageLocationPlaceIdErrorComponent)
  | ({
      attr: 'capacity_configurations.non_field_errors';
    } & VehiclesPartialUpdateCapacityConfigurationsNonFieldErrorsErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.non_field_errors';
    } & VehiclesPartialUpdateCapacityConfigurationsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.wheelchair_capacity';
    } & VehiclesPartialUpdateCapacityConfigurationsIndexWheelchairCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.wheelchair_xl_capacity';
    } & VehiclesPartialUpdateCapacityConfigurationsIndexWheelchairXlCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.broda_chair_capacity';
    } & VehiclesPartialUpdateCapacityConfigurationsIndexBrodaChairCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.geri_chair_capacity';
    } & VehiclesPartialUpdateCapacityConfigurationsIndexGeriChairCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.stretcher_capacity';
    } & VehiclesPartialUpdateCapacityConfigurationsIndexStretcherCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.stretcher_xl_capacity';
    } & VehiclesPartialUpdateCapacityConfigurationsIndexStretcherXlCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.ambulatory_capacity';
    } & VehiclesPartialUpdateCapacityConfigurationsIndexAmbulatoryCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.equipment_wheelchair_capacity';
    } & VehiclesPartialUpdateCapacityConfigurationsIndexEquipmentWheelchairCapacityErrorComponent)
  | ({
      attr: 'capacity_configurations.INDEX.is_delivery_capable';
    } & VehiclesPartialUpdateCapacityConfigurationsIndexIsDeliveryCapableErrorComponent)
  | ({
      attr: 'deleted_at';
    } & VehiclesPartialUpdateDeletedAtErrorComponent)
  | ({
      attr: 'tags.INDEX.tag_name';
    } & VehiclesPartialUpdateTagsIndexTagNameErrorComponent)
  | ({
      attr: 'tags.INDEX.color_hex';
    } & VehiclesPartialUpdateTagsIndexColorHexErrorComponent)
  | ({
      attr: 'tag_ids';
    } & VehiclesPartialUpdateTagIdsErrorComponent)
  | ({
      attr: 'tag_ids.INDEX';
    } & VehiclesPartialUpdateTagIdsIndexErrorComponent)
  | ({
      attr: 'allowed_payer_ids';
    } & VehiclesPartialUpdateAllowedPayerIdsErrorComponent)
  | ({
      attr: 'allowed_payer_ids.INDEX';
    } & VehiclesPartialUpdateAllowedPayerIdsIndexErrorComponent);
export type VehiclesPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: VehiclesPartialUpdateError[];
};
export type VehiclesPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & VehiclesPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedVehicle = {
  nickname?: string;
  vin?: string;
  make?: string;
  model?: string;
  color?: string;
  year?: number | null;
  can_be_scheduled?: boolean;
  license_plate?: string;
  license_plate_state?: (LicensePlateStateEnum | BlankEnum | NullEnum) | null;
  category?: VehicleCategoryEnum;
  notes?: string;
  storage_location?: VehicleStorageLocation;
  capacity_configurations?: VehicleCapacityConfiguration[];
  deleted_at?: string | null;
  allowed_payer_ids?: string[] | null;
};
export type PatchedVehicleRead = {
  id?: string;
  nickname?: string;
  vin?: string;
  organization_id?: string;
  make?: string;
  model?: string;
  color?: string;
  year?: number | null;
  can_be_scheduled?: boolean;
  license_plate?: string;
  license_plate_state?: (LicensePlateStateEnum | BlankEnum | NullEnum) | null;
  category?: VehicleCategoryEnum;
  notes?: string;
  storage_location?: VehicleStorageLocationRead;
  capacity_configurations?: VehicleCapacityConfiguration[];
  updated_at?: string;
  created_at?: string;
  deleted_at?: string | null;
  tags?: VehicleVehicleTagRead[] | null;
  allowed_payer_ids?: string[] | null;
};
export type PatchedVehicleWrite = {
  nickname?: string;
  vin?: string;
  make?: string;
  model?: string;
  color?: string;
  year?: number | null;
  can_be_scheduled?: boolean;
  license_plate?: string;
  license_plate_state?: (LicensePlateStateEnum | BlankEnum | NullEnum) | null;
  category?: VehicleCategoryEnum;
  notes?: string;
  storage_location?: VehicleStorageLocation;
  capacity_configurations?: VehicleCapacityConfiguration[];
  deleted_at?: string | null;
  tag_ids?: string[] | null;
  allowed_payer_ids?: string[] | null;
};
export type VehiclesDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type VehiclePayerOrganization = {};
export type VehiclePayerOrganizationRead = {
  id: string;
  organization_id: string;
  vehicle_id: string;
  payer_organization_id: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
};
export type VehiclePayerOrganizationWrite = {
  payer_organization_ids: string[];
};
export type PaginatedVehiclePayerOrganizationList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: VehiclePayerOrganization[];
};
export type PaginatedVehiclePayerOrganizationListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: VehiclePayerOrganizationRead[];
};
export type PaginatedVehiclePayerOrganizationListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: VehiclePayerOrganizationWrite[];
};
export type VehiclesPayersListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type VehiclesPayersCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type VehiclesPayersCreatePayerOrganizationIdsErrorComponent = {
  attr: 'payer_organization_ids';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type VehiclesPayersCreatePayerOrganizationIdsIndexErrorComponent = {
  attr: 'payer_organization_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type VehiclesPayersCreateError =
  | ({
      attr: 'non_field_errors';
    } & VehiclesPayersCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_organization_ids';
    } & VehiclesPayersCreatePayerOrganizationIdsErrorComponent)
  | ({
      attr: 'payer_organization_ids.INDEX';
    } & VehiclesPayersCreatePayerOrganizationIdsIndexErrorComponent);
export type VehiclesPayersCreateValidationError = {
  type: ValidationErrorEnum;
  errors: VehiclesPayersCreateError[];
};
export type VehiclesPayersCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & VehiclesPayersCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type VehicleInspectionReport = {
  membership: string;
  vehicle: string;
  assignment?: string | null;
};
export type VehicleInspectionReportRead = {
  id: string;
  membership: string;
  vehicle: string;
  assignment?: string | null;
  created_at: string;
  updated_at: string;
};
export type VehicleInspectionFieldSubmit = {
  title: string;
  value: string;
  comment?: string;
};
export type VehicleInspectionReportWrite = {
  membership: string;
  vehicle: string;
  assignment?: string | null;
  report: VehicleInspectionFieldSubmit[];
};
export type VehiclesInspectionCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type VehiclesInspectionCreateMembershipErrorComponent = {
  attr: 'membership';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type VehiclesInspectionCreateVehicleErrorComponent = {
  attr: 'vehicle';
  code: 'does_not_exist' | 'incorrect_type' | 'null' | 'required';
  detail: string;
};
export type VehiclesInspectionCreateAssignmentErrorComponent = {
  attr: 'assignment';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type VehiclesInspectionCreateReportNonFieldErrorsErrorComponent = {
  attr: 'report.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type VehiclesInspectionCreateReportIndexNonFieldErrorsErrorComponent = {
  attr: 'report.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type VehiclesInspectionCreateReportIndexTitleErrorComponent = {
  attr: 'report.INDEX.title';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesInspectionCreateReportIndexValueErrorComponent = {
  attr: 'report.INDEX.value';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesInspectionCreateReportIndexCommentErrorComponent = {
  attr: 'report.INDEX.comment';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type VehiclesInspectionCreateError =
  | ({
      attr: 'non_field_errors';
    } & VehiclesInspectionCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'membership';
    } & VehiclesInspectionCreateMembershipErrorComponent)
  | ({
      attr: 'vehicle';
    } & VehiclesInspectionCreateVehicleErrorComponent)
  | ({
      attr: 'assignment';
    } & VehiclesInspectionCreateAssignmentErrorComponent)
  | ({
      attr: 'report.non_field_errors';
    } & VehiclesInspectionCreateReportNonFieldErrorsErrorComponent)
  | ({
      attr: 'report.INDEX.non_field_errors';
    } & VehiclesInspectionCreateReportIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'report.INDEX.title';
    } & VehiclesInspectionCreateReportIndexTitleErrorComponent)
  | ({
      attr: 'report.INDEX.value';
    } & VehiclesInspectionCreateReportIndexValueErrorComponent)
  | ({
      attr: 'report.INDEX.comment';
    } & VehiclesInspectionCreateReportIndexCommentErrorComponent);
export type VehiclesInspectionCreateValidationError = {
  type: ValidationErrorEnum;
  errors: VehiclesInspectionCreateError[];
};
export type VehiclesInspectionCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & VehiclesInspectionCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type VehicleInspectionField = {
  title: string;
  description: string;
  field_type: string;
  required?: boolean;
};
export type PaginatedVehicleInspectionFieldList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: VehicleInspectionField[];
};
export type VehiclesInspectionFieldsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type VehicleInspectionReportDetails = {};
export type ReportMembership = {
  id?: string;
  first_name: string;
  last_name: string;
  deleted_at?: string | null;
};
export type ReportVehicle = {
  id?: string;
  nickname: string;
};
export type ReportAssignment = {
  id?: string;
  start: string;
  end: string;
};
export type VehicleInspectionReportDetailsRead = {
  id: string;
  membership: ReportMembership;
  vehicle: ReportVehicle;
  assignment: ReportAssignment;
  report_json: {
    title?: string;
    value?: string;
    comment?: string;
  }[];
  signatures_as_base64: string[];
  created_at: string;
  updated_at: string;
};
export type PaginatedVehicleInspectionReportDetailsList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: VehicleInspectionReportDetails[];
};
export type PaginatedVehicleInspectionReportDetailsListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: VehicleInspectionReportDetailsRead[];
};
export type VehiclesInspectionsListVehicleErrorComponent = {
  attr: 'vehicle';
  code: 'invalid_choice';
  detail: string;
};
export type VehiclesInspectionsListAssignmentErrorComponent = {
  attr: 'assignment';
  code: 'invalid_choice';
  detail: string;
};
export type VehiclesInspectionsListMembershipErrorComponent = {
  attr: 'membership';
  code: 'invalid_choice';
  detail: string;
};
export type VehiclesInspectionsListCreatedAtErrorComponent = {
  attr: 'created_at';
  code: 'invalid';
  detail: string;
};
export type VehiclesInspectionsListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type VehiclesInspectionsListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type VehiclesInspectionsListError =
  | ({
      attr: 'vehicle';
    } & VehiclesInspectionsListVehicleErrorComponent)
  | ({
      attr: 'assignment';
    } & VehiclesInspectionsListAssignmentErrorComponent)
  | ({
      attr: 'membership';
    } & VehiclesInspectionsListMembershipErrorComponent)
  | ({
      attr: 'created_at';
    } & VehiclesInspectionsListCreatedAtErrorComponent)
  | ({
      attr: 'range_start';
    } & VehiclesInspectionsListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & VehiclesInspectionsListRangeEndErrorComponent);
export type VehiclesInspectionsListValidationError = {
  type: ValidationErrorEnum;
  errors: VehiclesInspectionsListError[];
};
export type VehiclesInspectionsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & VehiclesInspectionsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type VehicleInspectionReportExtraDetails = {};
export type ReportMembershipExtraDetails = {
  id?: string;
  first_name: string;
  last_name: string;
};
export type ReportMembershipExtraDetailsRead = {
  id?: string;
  first_name: string;
  last_name: string;
  license_number: string | null;
  license_state: string | null;
};
export type ReportVehicleExtraDetails = {
  id?: string;
  category: string;
  nickname: string;
  vin: string;
  make: string;
  model: string;
  color: string;
  year: number;
  license_plate: string;
  license_plate_state: string;
};
export type VehicleInspectionReportExtraDetailsRead = {
  id: string;
  membership: ReportMembershipExtraDetailsRead;
  vehicle: ReportVehicleExtraDetails;
  assignment: ReportAssignment;
  report_json: {
    title?: string;
    value?: string;
    comment?: string;
  }[];
  signatures_as_base64: string[];
  created_at: string;
  updated_at: string;
};
export type VehiclesInspectionsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type VehiclesListSelectedNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type VehiclesListSelectedSelectedVehiclesErrorComponent = {
  attr: 'selected_vehicles';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type VehiclesListSelectedSelectedVehiclesIndexErrorComponent = {
  attr: 'selected_vehicles.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type VehiclesListSelectedError =
  | ({
      attr: 'non_field_errors';
    } & VehiclesListSelectedNonFieldErrorsErrorComponent)
  | ({
      attr: 'selected_vehicles';
    } & VehiclesListSelectedSelectedVehiclesErrorComponent)
  | ({
      attr: 'selected_vehicles.INDEX';
    } & VehiclesListSelectedSelectedVehiclesIndexErrorComponent);
export type VehiclesListSelectedValidationError = {
  type: ValidationErrorEnum;
  errors: VehiclesListSelectedError[];
};
export type VehiclesListSelectedErrorResponse400 =
  | ({
      type: 'validation_error';
    } & VehiclesListSelectedValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type VehicleFilters = {
  /** List of IDs of the vehicles to include in response. */
  selected_vehicles?: string[];
};
export const {
  useAttendantsListQuery,
  useLazyAttendantsListQuery,
  useAttendantsCreateMutation,
  useAttendantsRetrieveQuery,
  useLazyAttendantsRetrieveQuery,
  useAttendantsPartialUpdateMutation,
  useAttendantsDestroyMutation,
  useAttendantsSkillsCreateMutation,
  useAttendantsSkillsRetrieveQuery,
  useLazyAttendantsSkillsRetrieveQuery,
  useAttendantsSkillsUpdateMutation,
  useAttendantsSkillsPartialUpdateMutation,
  useAttendantsSkillsDestroyMutation,
  useBillingBillingSettingsRetrieveQuery,
  useLazyBillingBillingSettingsRetrieveQuery,
  useBillingBillingSettingsPartialUpdateMutation,
  useBillingBillingSettingsNextInvoiceNumberRetrieveQuery,
  useLazyBillingBillingSettingsNextInvoiceNumberRetrieveQuery,
  useBillingTripsBillingListQuery,
  useLazyBillingTripsBillingListQuery,
  useBrokersAliviOauth2TokenCreateMutation,
  useBrokersAliviRideActivateWillcallCreateMutation,
  useBrokersAliviRideCancelCreateMutation,
  useBrokersAliviRideCancelWillcallActivationCreateMutation,
  useBrokersAliviRideGetStatusCreateMutation,
  useBrokersAliviRideOfferCreateMutation,
  useBrokersAliviRideUpdateCreateMutation,
  useBrokersClearviewOauth2TokenCreateMutation,
  useBrokersClearviewTripsListQuery,
  useLazyBrokersClearviewTripsListQuery,
  useBrokersClearviewTripsCreateMutation,
  useBrokersClearviewTripsRetrieveQuery,
  useLazyBrokersClearviewTripsRetrieveQuery,
  useBrokersClearviewTripsPartialUpdateMutation,
  useBrokersClearviewTripsCancelCreateMutation,
  useBrokersCtcOauth2TokenCreateMutation,
  useBrokersCtcTripCreateMutation,
  useBrokersCtcTripActivationCreateMutation,
  useBrokersCtcTripCancelCreateMutation,
  useBrokersExampleHelloWorldRetrieveQuery,
  useLazyBrokersExampleHelloWorldRetrieveQuery,
  useBrokersKinetikOauth2TokenCreateMutation,
  useBrokersKinetikV1CancelRideCreateMutation,
  useBrokersKinetikV1CreateRidesCreateMutation,
  useBrokersKinetikV1GetDriverCreateMutation,
  useBrokersKinetikV1GetRideCreateMutation,
  useBrokersKinetikV1GetVehicleCreateMutation,
  useBrokersKinetikV1UpdateRidesUpdateMutation,
  useBrokersMedidriveOauth2TokenCreateMutation,
  useBrokersMomentmBrokerAuthListQuery,
  useLazyBrokersMomentmBrokerAuthListQuery,
  useBrokersMomentmBrokerAuthCreateMutation,
  useBrokersMomentmBrokerAuthRetrieveQuery,
  useLazyBrokersMomentmBrokerAuthRetrieveQuery,
  useBrokersMomentmBrokerAuthUpdateMutation,
  useBrokersMomentmBrokerAuthPartialUpdateMutation,
  useBrokersMomentmBrokerAuthDestroyMutation,
  useBrokersMomentmBrokerAuthSetSecretCreateMutation,
  useBrokersMomentmSetSecretCreateMutation,
  useBrokersMtmInitCreateMutation,
  useBrokersMtmOauth2TokenCreateMutation,
  useBrokersMtmSetSecretCreateMutation,
  useBrokersMtmTransportationProvidersListQuery,
  useLazyBrokersMtmTransportationProvidersListQuery,
  useBrokersMtmTransportationProvidersCreateMutation,
  useBrokersMtmTransportationProvidersRetrieveQuery,
  useLazyBrokersMtmTransportationProvidersRetrieveQuery,
  useBrokersMtmTransportationProvidersUpdateMutation,
  useBrokersMtmTransportationProvidersPartialUpdateMutation,
  useBrokersMtmTransportationProvidersDestroyMutation,
  useBrokersMtmTransportationProvidersBackfillTripsCreateMutation,
  useBrokersMtmTransportationProvidersGetEmailRetrieveQuery,
  useLazyBrokersMtmTransportationProvidersGetEmailRetrieveQuery,
  useBrokersMtmTransportationProvidersTurnbackReasonsRetrieveQuery,
  useLazyBrokersMtmTransportationProvidersTurnbackReasonsRetrieveQuery,
  useBrokersMtmTransportationProvidersGetEmailTextRetrieveQuery,
  useLazyBrokersMtmTransportationProvidersGetEmailTextRetrieveQuery,
  useBrokersMtmTransportationProvidersInitCreateMutation,
  useBrokersMtmTransportationProvidersSetSecretCreateMutation,
  useBrokersMtmWebhookCreateMutation,
  useBrokersProvideARideOauth2TokenCreateMutation,
  useBrokersProvideARideTripsCreateMutation,
  useBrokersProvideARideTripsRetrieveQuery,
  useLazyBrokersProvideARideTripsRetrieveQuery,
  useBrokersProvideARideTripsCancelCreateMutation,
  useBrokersVectorcareWebhookCreateMutation,
  useCredentialsListQuery,
  useLazyCredentialsListQuery,
  useCredentialsCreateMutation,
  useCredentialsRetrieveQuery,
  useLazyCredentialsRetrieveQuery,
  useCredentialsPartialUpdateMutation,
  useCredentialsDestroyMutation,
  useCredentialsExpiringSoonCountRetrieveQuery,
  useLazyCredentialsExpiringSoonCountRetrieveQuery,
  useCredentialsTypesListQuery,
  useLazyCredentialsTypesListQuery,
  useCredentialsTypesCreateMutation,
  useCredentialsTypesRetrieveQuery,
  useLazyCredentialsTypesRetrieveQuery,
  useCredentialsTypesPartialUpdateMutation,
  useCredentialsTypesDestroyMutation,
  useDailyDigestCreateMutation,
  useDieCreateMutation,
  useDispatchRetrieveQuery,
  useLazyDispatchRetrieveQuery,
  useDispatchSummaryRetrieveQuery,
  useLazyDispatchSummaryRetrieveQuery,
  useDriverTagsListQuery,
  useLazyDriverTagsListQuery,
  useDriverTagsCreateMutation,
  useDriverTagsRetrieveQuery,
  useLazyDriverTagsRetrieveQuery,
  useDriverTagsDestroyMutation,
  useDriversListQuery,
  useLazyDriversListQuery,
  useDriversCreateMutation,
  useDriversPayersListQuery,
  useLazyDriversPayersListQuery,
  useDriversPayersCreateMutation,
  useDriversRetrieveQuery,
  useLazyDriversRetrieveQuery,
  useDriversPartialUpdateMutation,
  useDriversDestroyMutation,
  useDriversUndeleteCreateMutation,
  useDriversListSelectedQuery,
  useLazyDriversListSelectedQuery,
  useFilterGroupsListQuery,
  useLazyFilterGroupsListQuery,
  useFilterGroupsCreateMutation,
  useFilterGroupsRetrieveQuery,
  useLazyFilterGroupsRetrieveQuery,
  useFilterGroupsPartialUpdateMutation,
  useFilterGroupsDestroyMutation,
  useFilterGroupsCreateExamplesCreateMutation,
  useFlagsFeatureValuesListQuery,
  useLazyFlagsFeatureValuesListQuery,
  useFlagsFeatureValuesMobileListQuery,
  useLazyFlagsFeatureValuesMobileListQuery,
  useFlagsFeatureValuesWebListQuery,
  useLazyFlagsFeatureValuesWebListQuery,
  useFlagsFeaturesListQuery,
  useLazyFlagsFeaturesListQuery,
  useInvoicesPayersListQuery,
  useLazyInvoicesPayersListQuery,
  useInvoicesTripsListQuery,
  useLazyInvoicesTripsListQuery,
  useInvoicesExportRetrieveQuery,
  useLazyInvoicesExportRetrieveQuery,
  useInvoicesExportPaymentsRetrieveQuery,
  useLazyInvoicesExportPaymentsRetrieveQuery,
  useInvoicePaymentsListSelectedQuery,
  useLazyInvoicePaymentsListSelectedQuery,
  useInvoicesExportRefundsRetrieveQuery,
  useLazyInvoicesExportRefundsRetrieveQuery,
  useInvoiceRefundsListSelectedQuery,
  useLazyInvoiceRefundsListSelectedQuery,
  useInvoiceLineItemsListSelectedQuery,
  useLazyInvoiceLineItemsListSelectedQuery,
  useInvoicesInvoiceEmailCreateMutation,
  useInvoicesInvoicesListQuery,
  useLazyInvoicesInvoicesListQuery,
  useInvoicesInvoicesCreateMutation,
  useInvoicesInvoicesRetrieveQuery,
  useLazyInvoicesInvoicesRetrieveQuery,
  useInvoicesInvoicesPartialUpdateMutation,
  useInvoicesInvoicesDestroyMutation,
  useInvoicesLineItemsListQuery,
  useLazyInvoicesLineItemsListQuery,
  useInvoicesLineItemsCreateMutation,
  useInvoicesLineItemsRetrieveQuery,
  useLazyInvoicesLineItemsRetrieveQuery,
  useInvoicesLineItemsPartialUpdateMutation,
  useInvoicesLineItemsDestroyMutation,
  useInvoicesPaymentLinkListQuery,
  useLazyInvoicesPaymentLinkListQuery,
  useInvoicesPaymentLinkCreateMutation,
  useInvoicesPaymentLinkEmailCreateMutation,
  useInvoicesPaymentLinkRetrieveQuery,
  useLazyInvoicesPaymentLinkRetrieveQuery,
  useInvoicesPaymentLinkPartialUpdateMutation,
  useInvoicesPaymentsListQuery,
  useLazyInvoicesPaymentsListQuery,
  useInvoicesPaymentsCreateMutation,
  useInvoicesPaymentsRetrieveQuery,
  useLazyInvoicesPaymentsRetrieveQuery,
  useInvoicesRefundsListQuery,
  useLazyInvoicesRefundsListQuery,
  useInvoicesRefundsCreateMutation,
  useInvoicesRefundsRetrieveQuery,
  useLazyInvoicesRefundsRetrieveQuery,
  useInvoicesTripFinderListQuery,
  useLazyInvoicesTripFinderListQuery,
  useInvoicesTripFinderRetrieveQuery,
  useLazyInvoicesTripFinderRetrieveQuery,
  useLocationsAddressesListQuery,
  useLazyLocationsAddressesListQuery,
  useLocationsAddressesRetrieveQuery,
  useLazyLocationsAddressesRetrieveQuery,
  useLocationsCountiesListQuery,
  useLazyLocationsCountiesListQuery,
  useLocationsGeolocationsListQuery,
  useLazyLocationsGeolocationsListQuery,
  useLocationsGeolocationsCreateMutation,
  useLocationsGeolocationsRetrieveQuery,
  useLazyLocationsGeolocationsRetrieveQuery,
  useLocationsGeolocationsPartialUpdateMutation,
  useLocationsGeolocationsDestroyMutation,
  useLocationsGeolocationsUndeleteCreateMutation,
  useLocationsLocationLogEntryTripsListQuery,
  useLazyLocationsLocationLogEntryTripsListQuery,
  useLocationsLogCreateMutation,
  useLocationsMunicipalitiesRetrieveQuery,
  useLazyLocationsMunicipalitiesRetrieveQuery,
  useLocationsPassengerAddressesListQuery,
  useLazyLocationsPassengerAddressesListQuery,
  useLocationsPassengerAddressesCreateMutation,
  useLocationsPassengerAddressesRetrieveQuery,
  useLazyLocationsPassengerAddressesRetrieveQuery,
  useLocationsPassengerAddressesUpdateMutation,
  useLocationsPassengerAddressesPartialUpdateMutation,
  useLocationsPassengerAddressesDestroyMutation,
  useLocationsZipcodesListQuery,
  useLazyLocationsZipcodesListQuery,
  useMembersListQuery,
  useLazyMembersListQuery,
  useMembersCreateMutation,
  useMembersRetrieveQuery,
  useLazyMembersRetrieveQuery,
  useMembersPartialUpdateMutation,
  useMembersDestroyMutation,
  useMembersUndeleteCreateMutation,
  useMembersUpdateEmailCreateMutation,
  useMessagesListQuery,
  useLazyMessagesListQuery,
  useMessagesCreateMutation,
  useMessagesRetrieveQuery,
  useLazyMessagesRetrieveQuery,
  useMessagesTripMessagesListQuery,
  useLazyMessagesTripMessagesListQuery,
  useMessagesTripMessagesCreateMutation,
  useMessagesTripMessagesRetrieveQuery,
  useLazyMessagesTripMessagesRetrieveQuery,
  useMessagesWebHookMessageUpdateCreateMutation,
  useMobileAppSettingsRetrieveQuery,
  useLazyMobileAppSettingsRetrieveQuery,
  useMobileAppSettingsPartialUpdateMutation,
  useOrganizationBillingStatusRetrieveQuery,
  useLazyOrganizationBillingStatusRetrieveQuery,
  useOrganizationSettingsRetrieveQuery,
  useLazyOrganizationSettingsRetrieveQuery,
  useOrganizationSettingsPartialUpdateMutation,
  useOrganizationSettingsConnectMerchantAccountCreateMutation,
  useOrganizationSettingsLogoRetrieveQuery,
  useLazyOrganizationSettingsLogoRetrieveQuery,
  usePartnersOauth2TokenCreateMutation,
  usePartnersOrganizationsListQuery,
  useLazyPartnersOrganizationsListQuery,
  usePartnersOrganizationsPayersListQuery,
  useLazyPartnersOrganizationsPayersListQuery,
  usePartnersOrganizationsTripsListQuery,
  useLazyPartnersOrganizationsTripsListQuery,
  usePartnersOrganizationsTripsCreateMutation,
  usePartnersOrganizationsTripsRetrieveQuery,
  useLazyPartnersOrganizationsTripsRetrieveQuery,
  usePartnersOrganizationsTripsActivateWillCallCreateMutation,
  usePartnersOrganizationsTripsCancelCreateMutation,
  usePassengerTagsListQuery,
  useLazyPassengerTagsListQuery,
  usePassengerTagsCreateMutation,
  usePassengerTagsRetrieveQuery,
  useLazyPassengerTagsRetrieveQuery,
  usePassengerTagsDestroyMutation,
  usePassengersListQuery,
  useLazyPassengersListQuery,
  usePassengersCreateMutation,
  usePassengersAlternateIdentifiersListQuery,
  useLazyPassengersAlternateIdentifiersListQuery,
  usePassengersAlternateIdentifiersCreateMutation,
  usePassengersAlternateIdentifiersRetrieveQuery,
  useLazyPassengersAlternateIdentifiersRetrieveQuery,
  usePassengersAlternateIdentifiersPartialUpdateMutation,
  usePassengersAlternateIdentifiersDestroyMutation,
  usePassengersPreferredDriversListQuery,
  useLazyPassengersPreferredDriversListQuery,
  usePassengersPreferredDriversCreateMutation,
  usePassengersPreferredDriversRetrieveQuery,
  useLazyPassengersPreferredDriversRetrieveQuery,
  usePassengersPreferredDriversPartialUpdateMutation,
  usePassengersPreferredDriversDestroyMutation,
  usePassengersRetrieveQuery,
  useLazyPassengersRetrieveQuery,
  usePassengersPartialUpdateMutation,
  usePassengersDestroyMutation,
  usePassengersRecentAddressesListQuery,
  useLazyPassengersRecentAddressesListQuery,
  usePassengersRecentPayersListQuery,
  useLazyPassengersRecentPayersListQuery,
  usePassengersUndeleteCreateMutation,
  usePassengersDuplicatesListQuery,
  useLazyPassengersDuplicatesListQuery,
  usePassengersExportRetrieveQuery,
  useLazyPassengersExportRetrieveQuery,
  usePassengersMergeCreateMutation,
  usePayerSettingsListQuery,
  useLazyPayerSettingsListQuery,
  usePayerSettingsRetrieveQuery,
  useLazyPayerSettingsRetrieveQuery,
  usePayerSettingsPartialUpdateMutation,
  usePayerinfoListQuery,
  useLazyPayerinfoListQuery,
  usePayerinfoRetrieveQuery,
  useLazyPayerinfoRetrieveQuery,
  usePayerinfooneschematemplateListQuery,
  useLazyPayerinfooneschematemplateListQuery,
  usePayersListQuery,
  useLazyPayersListQuery,
  usePayersCreateMutation,
  usePayersDriversListQuery,
  useLazyPayersDriversListQuery,
  usePayersDriversCreateMutation,
  usePayersPassengersRetrieveQuery,
  useLazyPayersPassengersRetrieveQuery,
  usePayersPassengersCreateMutation,
  usePayersPassengersPartialUpdateMutation,
  usePayersPassengersDestroyMutation,
  usePayersSettingsRetrieveQuery,
  useLazyPayersSettingsRetrieveQuery,
  usePayersSettingsPartialUpdateMutation,
  usePayersVehiclesListQuery,
  useLazyPayersVehiclesListQuery,
  usePayersVehiclesCreateMutation,
  usePayersRetrieveQuery,
  useLazyPayersRetrieveQuery,
  usePayersPartialUpdateMutation,
  usePayersDestroyMutation,
  usePayersMultiloadingPartnersRetrieveQuery,
  useLazyPayersMultiloadingPartnersRetrieveQuery,
  usePayersListSelectedQuery,
  useLazyPayersListSelectedQuery,
  usePayersandtemplatesRetrieveQuery,
  useLazyPayersandtemplatesRetrieveQuery,
  usePayerstemplatesListQuery,
  useLazyPayerstemplatesListQuery,
  usePayerstemplatesRetrieveQuery,
  useLazyPayerstemplatesRetrieveQuery,
  usePricingPriceQuoteCreateMutation,
  usePricingPricingSchemeConflictsCreateMutation,
  usePricingPricingSchemesListQuery,
  useLazyPricingPricingSchemesListQuery,
  usePricingPricingSchemesCreateMutation,
  usePricingPricingSchemesRetrieveQuery,
  useLazyPricingPricingSchemesRetrieveQuery,
  usePricingPricingSchemesPartialUpdateMutation,
  usePricingPricingSchemesDestroyMutation,
  useProfileRetrieveQuery,
  useLazyProfileRetrieveQuery,
  useReportsCustomReportsListQuery,
  useLazyReportsCustomReportsListQuery,
  useReportsCustomReportsCreateMutation,
  useReportsCustomReportsRetrieveQuery,
  useLazyReportsCustomReportsRetrieveQuery,
  useReportsCustomReportsPartialUpdateMutation,
  useReportsCustomReportsDestroyMutation,
  useReportsTripsLoadedMileageCountCreateQuery,
  useLazyReportsTripsLoadedMileageCountCreateQuery,
  useReportsTripsOnTimeCountCreateQuery,
  useLazyReportsTripsOnTimeCountCreateQuery,
  useReportsTripsRevenueCountCreateQuery,
  useLazyReportsTripsRevenueCountCreateQuery,
  useReportsTripsStatusCountCreateQuery,
  useLazyReportsTripsStatusCountCreateQuery,
  useRunBambiRunCreateMutation,
  useRunBambiRunRetrieveQuery,
  useLazyRunBambiRunRetrieveQuery,
  useRunBambiRunApplyCreateMutation,
  useSignaturesListQuery,
  useLazySignaturesListQuery,
  useSignaturesCreateMutation,
  useSignaturesRetrieveQuery,
  useLazySignaturesRetrieveQuery,
  useSignaturesDestroyMutation,
  useTagsListQuery,
  useLazyTagsListQuery,
  useTagsCreateMutation,
  useTagsRetrieveQuery,
  useLazyTagsRetrieveQuery,
  useTagsPartialUpdateMutation,
  useTagsDestroyMutation,
  useTilledPaymentMethodRetrieveQuery,
  useLazyTilledPaymentMethodRetrieveQuery,
  useTilledPaymentMethodCreateMutation,
  useTilledPaymentMethodDestroyMutation,
  useTilledPaymentMethodPartialUpdateMutation,
  useTilledPaymentMethodVerifyRetrieveQuery,
  useLazyTilledPaymentMethodVerifyRetrieveQuery,
  useTilledPaymentMethodVerifyCreateMutation,
  useTilledPayoutsListQuery,
  useLazyTilledPayoutsListQuery,
  useTilledPayoutsExportCreateMutation,
  useTilledResourceLinkCreateMutation,
  useTilledWebhookCreateMutation,
  useTokensChatIssueRetrieveQuery,
  useLazyTokensChatIssueRetrieveQuery,
  useTokensPushRegisterCreateMutation,
  useTokensPushRevokeCreateMutation,
  useTripImportCreateMutation,
  useTripImportRetrieveQuery,
  useLazyTripImportRetrieveQuery,
  useTripRequestEmbedListQuery,
  useLazyTripRequestEmbedListQuery,
  useTripRequestEmbedCreateMutation,
  useTripRequestEmbedRetrieveQuery,
  useLazyTripRequestEmbedRetrieveQuery,
  useTripRequestEmbedPartialUpdateMutation,
  useTripRequestEmbedDestroyMutation,
  useTripTagsListQuery,
  useLazyTripTagsListQuery,
  useTripTagsCreateMutation,
  useTripTagsRetrieveQuery,
  useLazyTripTagsRetrieveQuery,
  useTripTagsDestroyMutation,
  useVehicleTagsListQuery,
  useLazyVehicleTagsListQuery,
  useVehicleTagsCreateMutation,
  useVehicleTagsRetrieveQuery,
  useLazyVehicleTagsRetrieveQuery,
  useVehicleTagsDestroyMutation,
  useVehiclesListQuery,
  useLazyVehiclesListQuery,
  useVehiclesCreateMutation,
  useVehiclesRetrieveQuery,
  useLazyVehiclesRetrieveQuery,
  useVehiclesPartialUpdateMutation,
  useVehiclesDestroyMutation,
  useVehiclesPayersListQuery,
  useLazyVehiclesPayersListQuery,
  useVehiclesPayersCreateMutation,
  useVehiclesInspectionCreateMutation,
  useVehiclesInspectionFieldsListQuery,
  useLazyVehiclesInspectionFieldsListQuery,
  useVehiclesInspectionsListQuery,
  useLazyVehiclesInspectionsListQuery,
  useVehiclesInspectionsRetrieveQuery,
  useLazyVehiclesInspectionsRetrieveQuery,
  useVehiclesInspectionsExportRetrieveQuery,
  useLazyVehiclesInspectionsExportRetrieveQuery,
  useVehiclesListSelectedQuery,
  useLazyVehiclesListSelectedQuery,
} = injectedRtkApi;
